export const wayfinderData = {
  "36530074": {
    "id": "item_22564",
    "Last Name": "Lyons",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530111": {
    "id": "item_11164",
    "Last Name": "Jia",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530127": {
    "id": "item_22055",
    "Last Name": "Duff",
    "First Name": "Juliette",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530134": {
    "id": "item_22104",
    "Last Name": "Culling",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530138": {
    "id": "item_23867",
    "Last Name": "Yardley",
    "First Name": "Evnike",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530141": {
    "id": "item_9244",
    "Last Name": "MORRISON",
    "First Name": "ROSS",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530149": {
    "id": "item_9377",
    "Last Name": "Donaldson",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530159": {
    "id": "item_9355",
    "Last Name": "Foley",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530165": {
    "id": "item_9359",
    "Last Name": "Topfer",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530166": {
    "id": "item_11192",
    "Last Name": "Ryland",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530179": {
    "id": "item_24045",
    "Last Name": "Dean",
    "First Name": "Amber",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530180": {
    "id": "item_22290",
    "Last Name": "Hunter",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530181": {
    "id": "item_11326",
    "Last Name": "Todd",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530183": {
    "id": "item_22258",
    "Last Name": "Hopwood",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530184": {
    "id": "item_9412",
    "Last Name": "Boxshall",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530194": {
    "id": "item_24072",
    "Last Name": "Mendoza",
    "First Name": "Maricris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530195": {
    "id": "item_22453",
    "Last Name": "Bollard",
    "First Name": "Emmet",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530197": {
    "id": "item_9742",
    "Last Name": "Yong",
    "First Name": "Kai Seng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530201": {
    "id": "item_24064",
    "Last Name": "THOMAS",
    "First Name": "BRECK",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530210": {
    "id": "item_11370",
    "Last Name": "Nally",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530211": {
    "id": "item_36777",
    "Last Name": "Natividad",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530236": {
    "id": "item_34773",
    "Last Name": "OÕConnor",
    "First Name": "Alan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530237": {
    "id": "item_24108",
    "Last Name": "Philips",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530240": {
    "id": "item_22026",
    "Last Name": "Green",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530241": {
    "id": "item_22505",
    "Last Name": "Allan",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530244": {
    "id": "item_24112",
    "Last Name": "Harnett",
    "First Name": "Seamus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530246": {
    "id": "item_34826",
    "Last Name": "Lau",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530248": {
    "id": "item_11112",
    "Last Name": "You",
    "First Name": "Haowei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530252": {
    "id": "item_22030",
    "Last Name": "Octaviano",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530256": {
    "id": "item_37047",
    "Last Name": "Ong",
    "First Name": "Tommy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530258": {
    "id": "item_22555",
    "Last Name": "Telchid",
    "First Name": "Mathieu Henri",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530262": {
    "id": "item_22368",
    "Last Name": "Ferrell",
    "First Name": "Myles",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530263": {
    "id": "item_9683",
    "Last Name": "Carleton",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530270": {
    "id": "item_11021",
    "Last Name": "Pearson",
    "First Name": "Kirby",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530274": {
    "id": "item_11442",
    "Last Name": "Klimt",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530278": {
    "id": "item_9695",
    "Last Name": "McKenna",
    "First Name": "Jared",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530292": {
    "id": "item_23876",
    "Last Name": "Hill",
    "First Name": "Monique",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530309": {
    "id": "item_9218",
    "Last Name": "Sheppard",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530310": {
    "id": "item_11448",
    "Last Name": "Sun",
    "First Name": "Nickk",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530315": {
    "id": "item_22122",
    "Last Name": "Starley",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530333": {
    "id": "item_9334",
    "Last Name": "Kawashima",
    "First Name": "Jun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530335": {
    "id": "item_11352",
    "Last Name": "Berger",
    "First Name": "Bernhard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530336": {
    "id": "item_9382",
    "Last Name": "Friedland",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530340": {
    "id": "item_11502",
    "Last Name": "Georgeson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530342": {
    "id": "item_23915",
    "Last Name": "ZHENG",
    "First Name": "SIYUAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530357": {
    "id": "item_22617",
    "Last Name": "Hickman",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530362": {
    "id": "item_9580",
    "Last Name": "Dunstan",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530367": {
    "id": "item_9676",
    "Last Name": "Hartley",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530368": {
    "id": "item_36692",
    "Last Name": "Brennan",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530369": {
    "id": "item_34732",
    "Last Name": "James",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530371": {
    "id": "item_9386",
    "Last Name": "Pettit",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530377": {
    "id": "item_22254",
    "Last Name": "Collins",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530381": {
    "id": "item_36705",
    "Last Name": "Anderson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530382": {
    "id": "item_11334",
    "Last Name": "Butler",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530384": {
    "id": "item_22348",
    "Last Name": "Vlotman",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530385": {
    "id": "item_22330",
    "Last Name": "Sweeting",
    "First Name": "Sandie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530387": {
    "id": "item_22300",
    "Last Name": "Silicato",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530388": {
    "id": "item_36772",
    "Last Name": "REDDY",
    "First Name": "Radhika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530389": {
    "id": "item_24136",
    "Last Name": "Ziogas",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530394": {
    "id": "item_9560",
    "Last Name": "BRUN",
    "First Name": "EMILIO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530395": {
    "id": "item_11223",
    "Last Name": "Luck",
    "First Name": "Kai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530397": {
    "id": "item_22642",
    "Last Name": "GATTO",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530409": {
    "id": "item_37086",
    "Last Name": "Gehrels",
    "First Name": "Paige",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530411": {
    "id": "item_9620",
    "Last Name": "Gibson",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530420": {
    "id": "item_24139",
    "Last Name": "Tate",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530424": {
    "id": "item_36793",
    "Last Name": "Aarts",
    "First Name": "Josh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530430": {
    "id": "item_36967",
    "Last Name": "Curwood",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530432": {
    "id": "item_22552",
    "Last Name": "Le",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530435": {
    "id": "item_9667",
    "Last Name": "Wasylkowski",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530439": {
    "id": "item_11310",
    "Last Name": "Scott",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530441": {
    "id": "item_9593",
    "Last Name": "Fraga",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530442": {
    "id": "item_34856",
    "Last Name": "Hamilton",
    "First Name": "Karyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530443": {
    "id": "item_11426",
    "Last Name": "Nelson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530469": {
    "id": "item_11424",
    "Last Name": "Mort",
    "First Name": "Ander",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530473": {
    "id": "item_9671",
    "Last Name": "McInnes",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530475": {
    "id": "item_11427",
    "Last Name": "Proutt",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530476": {
    "id": "item_34841",
    "Last Name": "Kou",
    "First Name": "Yingxin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530484": {
    "id": "item_22524",
    "Last Name": "Donnolley",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530500": {
    "id": "item_9660",
    "Last Name": "Chen",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530501": {
    "id": "item_9685",
    "Last Name": "Whitehead",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530504": {
    "id": "item_9672",
    "Last Name": "Murace",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530512": {
    "id": "item_9669",
    "Last Name": "Stevens",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530515": {
    "id": "item_34834",
    "Last Name": "Baraket",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530516": {
    "id": "item_11447",
    "Last Name": "Hsieh",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530517": {
    "id": "item_9668",
    "Last Name": "Pettit",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530522": {
    "id": "item_34831",
    "Last Name": "Luu",
    "First Name": "Kimuly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530525": {
    "id": "item_37003",
    "Last Name": "Brooks",
    "First Name": "Nisha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530528": {
    "id": "item_37002",
    "Last Name": "Zou",
    "First Name": "Yang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530535": {
    "id": "item_34830",
    "Last Name": "Uncle",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530539": {
    "id": "item_9682",
    "Last Name": "Goulart",
    "First Name": "Willian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530544": {
    "id": "item_9665",
    "Last Name": "fitzpatrick",
    "First Name": "Ronan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530550": {
    "id": "item_36999",
    "Last Name": "Huang",
    "First Name": "Echo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530557": {
    "id": "item_9353",
    "Last Name": "McDonald",
    "First Name": "Nik",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530560": {
    "id": "item_22522",
    "Last Name": "Loasby",
    "First Name": "Mayako",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530561": {
    "id": "item_22544",
    "Last Name": "Wong",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530569": {
    "id": "item_34829",
    "Last Name": "McCormick",
    "First Name": "Conor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530574": {
    "id": "item_11444",
    "Last Name": "Ferris",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530577": {
    "id": "item_36996",
    "Last Name": "Trilaksono",
    "First Name": "Yudhi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530581": {
    "id": "item_22518",
    "Last Name": "Jennings",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530585": {
    "id": "item_36988",
    "Last Name": "Stainer",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530591": {
    "id": "item_36997",
    "Last Name": "Frost",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530592": {
    "id": "item_22519",
    "Last Name": "Grindley",
    "First Name": "Phil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530595": {
    "id": "item_37095",
    "Last Name": "Palmer",
    "First Name": "Tennaya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530606": {
    "id": "item_22632",
    "Last Name": "McIntyre",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530609": {
    "id": "item_22508",
    "Last Name": "Smith",
    "First Name": "Gita",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530613": {
    "id": "item_11419",
    "Last Name": "Skinner",
    "First Name": "Ted",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530616": {
    "id": "item_24133",
    "Last Name": "Garrett",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530617": {
    "id": "item_34840",
    "Last Name": "Howell",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530629": {
    "id": "item_9681",
    "Last Name": "Tran",
    "First Name": "Long",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530630": {
    "id": "item_36993",
    "Last Name": "Palffy",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530631": {
    "id": "item_24134",
    "Last Name": "Johns",
    "First Name": "Theo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530638": {
    "id": "item_9654",
    "Last Name": "Naughton",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530641": {
    "id": "item_11410",
    "Last Name": "Swinton",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530642": {
    "id": "item_36984",
    "Last Name": "Thomas",
    "First Name": "Miles",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530644": {
    "id": "item_11416",
    "Last Name": "Daley",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530647": {
    "id": "item_36990",
    "Last Name": "Jarvis",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530648": {
    "id": "item_36985",
    "Last Name": "Mitchell",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530654": {
    "id": "item_36989",
    "Last Name": "Keers",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530655": {
    "id": "item_24131",
    "Last Name": "Wibowo",
    "First Name": "Emil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530656": {
    "id": "item_22504",
    "Last Name": "McKenzie",
    "First Name": "Shea",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530658": {
    "id": "item_9652",
    "Last Name": "McMinn",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530660": {
    "id": "item_11414",
    "Last Name": "Cruz",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530664": {
    "id": "item_22514",
    "Last Name": "Dreyfus",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530670": {
    "id": "item_9651",
    "Last Name": "Irving",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530677": {
    "id": "item_36987",
    "Last Name": "Zhang",
    "First Name": "Jessie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530681": {
    "id": "item_22540",
    "Last Name": "Lee",
    "First Name": "Chun Hin Angus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530682": {
    "id": "item_11405",
    "Last Name": "Chen",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530684": {
    "id": "item_22512",
    "Last Name": "Melvin",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530685": {
    "id": "item_24127",
    "Last Name": "Morrisey",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530689": {
    "id": "item_36979",
    "Last Name": "Tsai",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530697": {
    "id": "item_36982",
    "Last Name": "Fairall",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530698": {
    "id": "item_11397",
    "Last Name": "Consunji",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530701": {
    "id": "item_37018",
    "Last Name": "NYGREN",
    "First Name": "ABBY",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530702": {
    "id": "item_22510",
    "Last Name": "Iloski",
    "First Name": "Ivana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530710": {
    "id": "item_11403",
    "Last Name": "Rahman",
    "First Name": "Sid",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530712": {
    "id": "item_11401",
    "Last Name": "Jia",
    "First Name": "Yingjie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530716": {
    "id": "item_9623",
    "Last Name": "Hawkes",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530720": {
    "id": "item_11507",
    "Last Name": "Sharpe",
    "First Name": "Mannie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530725": {
    "id": "item_34823",
    "Last Name": "Cirillo",
    "First Name": "Giovanni",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530728": {
    "id": "item_11394",
    "Last Name": "Robertson",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530729": {
    "id": "item_24146",
    "Last Name": "Salazar",
    "First Name": "Russell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530730": {
    "id": "item_36977",
    "Last Name": "Ong",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530734": {
    "id": "item_36976",
    "Last Name": "Liang",
    "First Name": "Sally",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530740": {
    "id": "item_36974",
    "Last Name": "Hurn",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530750": {
    "id": "item_9619",
    "Last Name": "OSullivan",
    "First Name": "Eoin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530760": {
    "id": "item_22502",
    "Last Name": "Bower",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530765": {
    "id": "item_37094",
    "Last Name": "Chen",
    "First Name": "Jim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530767": {
    "id": "item_9677",
    "Last Name": "Godkin",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530769": {
    "id": "item_9352",
    "Last Name": "Tan",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530778": {
    "id": "item_22501",
    "Last Name": "Brnabic",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530781": {
    "id": "item_22539",
    "Last Name": "Clements",
    "First Name": "Flynn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530782": {
    "id": "item_24145",
    "Last Name": "Cox",
    "First Name": "Richelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530784": {
    "id": "item_9642",
    "Last Name": "Brooks",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530788": {
    "id": "item_34855",
    "Last Name": "Tandog",
    "First Name": "Elvera",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530789": {
    "id": "item_11391",
    "Last Name": "Spanner",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530790": {
    "id": "item_22499",
    "Last Name": "McGrath",
    "First Name": "Fionna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530797": {
    "id": "item_22497",
    "Last Name": "Smart",
    "First Name": "Zuzana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530802": {
    "id": "item_9641",
    "Last Name": "Tonel",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530804": {
    "id": "item_22532",
    "Last Name": "Ho",
    "First Name": "Shing Fu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530806": {
    "id": "item_24122",
    "Last Name": "Hu",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530808": {
    "id": "item_24143",
    "Last Name": "Malarkey",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530810": {
    "id": "item_11393",
    "Last Name": "Jackson",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530821": {
    "id": "item_9637",
    "Last Name": "Silver",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530825": {
    "id": "item_9639",
    "Last Name": "McPherson",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530826": {
    "id": "item_11437",
    "Last Name": "van Uden",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530829": {
    "id": "item_9638",
    "Last Name": "Maxwell",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530835": {
    "id": "item_22495",
    "Last Name": "Sharpe",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530838": {
    "id": "item_22631",
    "Last Name": "Lee",
    "First Name": "Keeane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530839": {
    "id": "item_11505",
    "Last Name": "Manley",
    "First Name": "Zach",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530844": {
    "id": "item_9674",
    "Last Name": "Rogers",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530848": {
    "id": "item_24142",
    "Last Name": "Cox",
    "First Name": "Jamila",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530851": {
    "id": "item_34818",
    "Last Name": "Irvine",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530856": {
    "id": "item_9636",
    "Last Name": "Cashman",
    "First Name": "Eoin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530857": {
    "id": "item_9635",
    "Last Name": "Begbie",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530869": {
    "id": "item_11390",
    "Last Name": "O'Neill",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530874": {
    "id": "item_34810",
    "Last Name": "Morrison",
    "First Name": "Drew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530889": {
    "id": "item_11389",
    "Last Name": "Wong",
    "First Name": "Desmond",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530901": {
    "id": "item_11431",
    "Last Name": "Le Rossignol",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530902": {
    "id": "item_22534",
    "Last Name": "Spohr",
    "First Name": "Bree",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530906": {
    "id": "item_22210",
    "Last Name": "Berezner",
    "First Name": "Ana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530909": {
    "id": "item_11388",
    "Last Name": "Smith",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530912": {
    "id": "item_9629",
    "Last Name": "Truong",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530913": {
    "id": "item_11385",
    "Last Name": "Roy-Webb",
    "First Name": "Alfie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530915": {
    "id": "item_34837",
    "Last Name": "Cajes",
    "First Name": "Conrado",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530919": {
    "id": "item_9631",
    "Last Name": "Knox",
    "First Name": "Trent",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530920": {
    "id": "item_36966",
    "Last Name": "Shen",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530922": {
    "id": "item_11506",
    "Last Name": "Beasley",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530925": {
    "id": "item_22488",
    "Last Name": "Le",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530929": {
    "id": "item_22490",
    "Last Name": "Kishore",
    "First Name": "Vishal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530937": {
    "id": "item_37091",
    "Last Name": "Morillas",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530945": {
    "id": "item_22207",
    "Last Name": "De Jong",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530953": {
    "id": "item_22486",
    "Last Name": "Dhital",
    "First Name": "Mahendra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530954": {
    "id": "item_22630",
    "Last Name": "Clifford",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530957": {
    "id": "item_37093",
    "Last Name": "Woods-Jack",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530958": {
    "id": "item_11346",
    "Last Name": "OÕBrien",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530965": {
    "id": "item_22531",
    "Last Name": "Haydon",
    "First Name": "Blair",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530979": {
    "id": "item_36965",
    "Last Name": "Chang",
    "First Name": "Ken",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530981": {
    "id": "item_11541",
    "Last Name": "Kim",
    "First Name": "Steven-Ju",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530990": {
    "id": "item_36964",
    "Last Name": "Yogesh",
    "First Name": "Priyam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530995": {
    "id": "item_22209",
    "Last Name": "Hay",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530996": {
    "id": "item_11379",
    "Last Name": "Francis",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36530999": {
    "id": "item_37013",
    "Last Name": "Stevenson",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531000": {
    "id": "item_37012",
    "Last Name": "Nyama",
    "First Name": "Martha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531005": {
    "id": "item_22208",
    "Last Name": "De Jong",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531009": {
    "id": "item_36962",
    "Last Name": "Welch",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531011": {
    "id": "item_24109",
    "Last Name": "Vassiliou",
    "First Name": "Adriana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531013": {
    "id": "item_22530",
    "Last Name": "Mulheron",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531015": {
    "id": "item_9617",
    "Last Name": "Lane",
    "First Name": "Seb",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531022": {
    "id": "item_34814",
    "Last Name": "Yun",
    "First Name": "Vivian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531023": {
    "id": "item_22521",
    "Last Name": "MA",
    "First Name": "GAVIN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531029": {
    "id": "item_11377",
    "Last Name": "Chin",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531031": {
    "id": "item_11376",
    "Last Name": "Richtor",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531037": {
    "id": "item_22476",
    "Last Name": "Atanacio",
    "First Name": "Jayson",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531043": {
    "id": "item_9609",
    "Last Name": "Georgiadis",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531044": {
    "id": "item_22483",
    "Last Name": "Yao",
    "First Name": "Priscilla",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531045": {
    "id": "item_24100",
    "Last Name": "Chang",
    "First Name": "Barom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531046": {
    "id": "item_9606",
    "Last Name": "Djukanovic",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531048": {
    "id": "item_9348",
    "Last Name": "Dalto",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531051": {
    "id": "item_22528",
    "Last Name": "Upton",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531053": {
    "id": "item_24105",
    "Last Name": "Flannery",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531056": {
    "id": "item_36960",
    "Last Name": "Dy",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531057": {
    "id": "item_36954",
    "Last Name": "Che",
    "First Name": "Kristy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531063": {
    "id": "item_36958",
    "Last Name": "Button",
    "First Name": "Josh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531064": {
    "id": "item_36655",
    "Last Name": "Kan",
    "First Name": "Wing Fai Terry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531068": {
    "id": "item_34836",
    "Last Name": "Thomas",
    "First Name": "Megghann",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531072": {
    "id": "item_22527",
    "Last Name": "Switala",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531073": {
    "id": "item_37007",
    "Last Name": "Scott",
    "First Name": "Kathy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531074": {
    "id": "item_11373",
    "Last Name": "Watterson",
    "First Name": "Anna",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531076": {
    "id": "item_36957",
    "Last Name": "Talukder",
    "First Name": "Ahmed Shoeb",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531077": {
    "id": "item_24107",
    "Last Name": "van de Werve",
    "First Name": "Tessa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531082": {
    "id": "item_36953",
    "Last Name": "Rachapet",
    "First Name": "Nattawut",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531102": {
    "id": "item_22629",
    "Last Name": "Salerno",
    "First Name": "Teresa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531108": {
    "id": "item_22477",
    "Last Name": "Hurney",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531130": {
    "id": "item_9603",
    "Last Name": "Fletcher",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531136": {
    "id": "item_9604",
    "Last Name": "Perkins",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531141": {
    "id": "item_37005",
    "Last Name": "HOR",
    "First Name": "WING KIT",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531142": {
    "id": "item_34835",
    "Last Name": "Stead",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531147": {
    "id": "item_22473",
    "Last Name": "mcdonald",
    "First Name": "shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531157": {
    "id": "item_9670",
    "Last Name": "Rancie",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531161": {
    "id": "item_22474",
    "Last Name": "Chen",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531164": {
    "id": "item_9592",
    "Last Name": "LEVCHENKO",
    "First Name": "ILYA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531175": {
    "id": "item_22525",
    "Last Name": "Thorburn",
    "First Name": "Karin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531177": {
    "id": "item_22472",
    "Last Name": "Canning",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531178": {
    "id": "item_11366",
    "Last Name": "Dorn",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531198": {
    "id": "item_36947",
    "Last Name": "Sridarani",
    "First Name": "Made",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531199": {
    "id": "item_9598",
    "Last Name": "Darmadi",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531201": {
    "id": "item_22465",
    "Last Name": "Mills",
    "First Name": "Jon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531202": {
    "id": "item_24101",
    "Last Name": "Pigrome",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531206": {
    "id": "item_11363",
    "Last Name": "Perrott",
    "First Name": "Braeden",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531213": {
    "id": "item_9594",
    "Last Name": "Dunlea",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531219": {
    "id": "item_34805",
    "Last Name": "Knight",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531225": {
    "id": "item_11422",
    "Last Name": "Luong",
    "First Name": "Hai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531234": {
    "id": "item_37001",
    "Last Name": "Calderon",
    "First Name": "Ana Lucia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531241": {
    "id": "item_9666",
    "Last Name": "holt",
    "First Name": "jarrod",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531243": {
    "id": "item_9591",
    "Last Name": "McCabe",
    "First Name": "Tammy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531244": {
    "id": "item_24099",
    "Last Name": "Chen",
    "First Name": "Gordon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531259": {
    "id": "item_23909",
    "Last Name": "Berkahn",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531261": {
    "id": "item_22467",
    "Last Name": "Cester",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531264": {
    "id": "item_24082",
    "Last Name": "Pundir",
    "First Name": "Ashwani",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531267": {
    "id": "item_37000",
    "Last Name": "Smith",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531279": {
    "id": "item_24091",
    "Last Name": "Syjuco",
    "First Name": "Jose Mari",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531289": {
    "id": "item_34833",
    "Last Name": "Mullen",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531292": {
    "id": "item_22461",
    "Last Name": "Srikhut",
    "First Name": "Nirandorn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531293": {
    "id": "item_22459",
    "Last Name": "Kalal",
    "First Name": "Faysal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531297": {
    "id": "item_24095",
    "Last Name": "Douglas",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531300": {
    "id": "item_9664",
    "Last Name": "Brown",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531301": {
    "id": "item_37092",
    "Last Name": "Young",
    "First Name": "Carl",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531303": {
    "id": "item_24137",
    "Last Name": "Bennett",
    "First Name": "Cass",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531312": {
    "id": "item_11156",
    "Last Name": "Kim",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531326": {
    "id": "item_11421",
    "Last Name": "Evans",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531328": {
    "id": "item_11357",
    "Last Name": "Cavanna",
    "First Name": "Jersey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531338": {
    "id": "item_36942",
    "Last Name": "Hajduk",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531347": {
    "id": "item_22460",
    "Last Name": "Stephenson",
    "First Name": "Evan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531353": {
    "id": "item_24090",
    "Last Name": "Humphries",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531357": {
    "id": "item_11353",
    "Last Name": "Coombs",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531361": {
    "id": "item_22457",
    "Last Name": "Beck",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531363": {
    "id": "item_11354",
    "Last Name": "Evans",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531375": {
    "id": "item_22520",
    "Last Name": "Lambert",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531387": {
    "id": "item_24083",
    "Last Name": "Cresswell",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531390": {
    "id": "item_22455",
    "Last Name": "Byrnes",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531391": {
    "id": "item_24085",
    "Last Name": "Zhang",
    "First Name": "Yandong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531396": {
    "id": "item_24084",
    "Last Name": "Hone",
    "First Name": "Asjadi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531405": {
    "id": "item_36938",
    "Last Name": "Wirawan",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531411": {
    "id": "item_22628",
    "Last Name": "Scully",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531415": {
    "id": "item_36937",
    "Last Name": "Shrewsbury",
    "First Name": "Kamie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531416": {
    "id": "item_34828",
    "Last Name": "Baidwaan",
    "First Name": "Preet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531432": {
    "id": "item_34799",
    "Last Name": "An",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531436": {
    "id": "item_36936",
    "Last Name": "Bingul",
    "First Name": "Sinan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531438": {
    "id": "item_36935",
    "Last Name": "Marano",
    "First Name": "Lex Anton",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531452": {
    "id": "item_9552",
    "Last Name": "Scorr",
    "First Name": "Niall",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531457": {
    "id": "item_9581",
    "Last Name": "Sparks",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531464": {
    "id": "item_24135",
    "Last Name": "Li",
    "First Name": "Collin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531470": {
    "id": "item_9575",
    "Last Name": "Turner",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531474": {
    "id": "item_9578",
    "Last Name": "Gibson",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531475": {
    "id": "item_9663",
    "Last Name": "Hall",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531479": {
    "id": "item_9740",
    "Last Name": "Leslie",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531481": {
    "id": "item_24080",
    "Last Name": "Whelan",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531488": {
    "id": "item_36934",
    "Last Name": "Mysore",
    "First Name": "Sandeep",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531491": {
    "id": "item_34827",
    "Last Name": "Dong",
    "First Name": "Juling",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531497": {
    "id": "item_22641",
    "Last Name": "Buckley",
    "First Name": "Damien",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531500": {
    "id": "item_34797",
    "Last Name": "Sun",
    "First Name": "Chenxi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531512": {
    "id": "item_9571",
    "Last Name": "Dawson",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531518": {
    "id": "item_9659",
    "Last Name": "Di Masi",
    "First Name": "Rochelle",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531523": {
    "id": "item_11347",
    "Last Name": "Pan",
    "First Name": "Shuncheng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531524": {
    "id": "item_36930",
    "Last Name": "Subramaniam",
    "First Name": "Piranavan-Sivathasan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531527": {
    "id": "item_11345",
    "Last Name": "Lotero Castro",
    "First Name": "Juan Camilo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531530": {
    "id": "item_22627",
    "Last Name": "Corocher",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531532": {
    "id": "item_11418",
    "Last Name": "Hamann",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531547": {
    "id": "item_36923",
    "Last Name": "Tran",
    "First Name": "Dinh Chi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531551": {
    "id": "item_22205",
    "Last Name": "Wong",
    "First Name": "Cecilia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531557": {
    "id": "item_36924",
    "Last Name": "Dumaguing",
    "First Name": "xavier yzrael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531558": {
    "id": "item_9569",
    "Last Name": "Blundell",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531568": {
    "id": "item_9566",
    "Last Name": "Brent",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531573": {
    "id": "item_9658",
    "Last Name": "Pilipchuk",
    "First Name": "Artem",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531575": {
    "id": "item_11343",
    "Last Name": "Richards",
    "First Name": "Kieren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531580": {
    "id": "item_9561",
    "Last Name": "TAYLOR",
    "First Name": "Colman",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531589": {
    "id": "item_22442",
    "Last Name": "Ngatiron",
    "First Name": "Nur Syazwani Binti",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531590": {
    "id": "item_11411",
    "Last Name": "Wong",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531592": {
    "id": "item_36916",
    "Last Name": "MA",
    "First Name": "YU",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531613": {
    "id": "item_22626",
    "Last Name": "Hamlet",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531625": {
    "id": "item_9657",
    "Last Name": "Morton",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531629": {
    "id": "item_24075",
    "Last Name": "Young",
    "First Name": "Hayden Hyejin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531631": {
    "id": "item_34795",
    "Last Name": "Almeida",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531635": {
    "id": "item_9562",
    "Last Name": "Spenceley",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531642": {
    "id": "item_9739",
    "Last Name": "Jones",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531649": {
    "id": "item_34793",
    "Last Name": "McSharry",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531666": {
    "id": "item_11153",
    "Last Name": "Brady",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531672": {
    "id": "item_36912",
    "Last Name": "Vickers",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531688": {
    "id": "item_22432",
    "Last Name": "Whittaker",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531690": {
    "id": "item_24071",
    "Last Name": "Meskin",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531693": {
    "id": "item_36904",
    "Last Name": "Trumper",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531699": {
    "id": "item_22203",
    "Last Name": "Ruby",
    "First Name": "Candice",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531700": {
    "id": "item_9556",
    "Last Name": "Ye",
    "First Name": "Leo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531708": {
    "id": "item_22429",
    "Last Name": "Cheung",
    "First Name": "Kin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531718": {
    "id": "item_9559",
    "Last Name": "Fitzsimmons",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531719": {
    "id": "item_11342",
    "Last Name": "OÕDonoghue",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531720": {
    "id": "item_36994",
    "Last Name": "Volkman",
    "First Name": "Madonna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531721": {
    "id": "item_11337",
    "Last Name": "Elturk",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531722": {
    "id": "item_36910",
    "Last Name": "COOPER",
    "First Name": "ANDREW",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531729": {
    "id": "item_11415",
    "Last Name": "Khan",
    "First Name": "Muhtaseem",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531731": {
    "id": "item_22428",
    "Last Name": "Foo",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531749": {
    "id": "item_36653",
    "Last Name": "Jovovic",
    "First Name": "Dusan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531752": {
    "id": "item_9551",
    "Last Name": "Mullen",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531753": {
    "id": "item_37107",
    "Last Name": "Yeou",
    "First Name": "Frederick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531754": {
    "id": "item_24069",
    "Last Name": "Kamar Affendi",
    "First Name": "Muhammad Arief",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531760": {
    "id": "item_22425",
    "Last Name": "Lemus",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531764": {
    "id": "item_36900",
    "Last Name": "Zou",
    "First Name": "Xiaohui Sherry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531765": {
    "id": "item_9555",
    "Last Name": "Qureshi",
    "First Name": "Zarak",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531773": {
    "id": "item_9653",
    "Last Name": "Bodey",
    "First Name": "Cam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531784": {
    "id": "item_11504",
    "Last Name": "Fittler",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531797": {
    "id": "item_37090",
    "Last Name": "Feenan",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531807": {
    "id": "item_11331",
    "Last Name": "Valenciano",
    "First Name": "Levi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531842": {
    "id": "item_24132",
    "Last Name": "Lam",
    "First Name": "Willis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531843": {
    "id": "item_11413",
    "Last Name": "Thorn",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531870": {
    "id": "item_9738",
    "Last Name": "Byrne",
    "First Name": "Riley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531875": {
    "id": "item_11503",
    "Last Name": "Smyth",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531877": {
    "id": "item_9736",
    "Last Name": "Dietrich",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531891": {
    "id": "item_9346",
    "Last Name": "Teologio",
    "First Name": "Eizar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531894": {
    "id": "item_36896",
    "Last Name": "Mackinlay",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531903": {
    "id": "item_24063",
    "Last Name": "Smith",
    "First Name": "Nadina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531904": {
    "id": "item_36991",
    "Last Name": "Chuc",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531909": {
    "id": "item_9737",
    "Last Name": "Daintith",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531919": {
    "id": "item_9735",
    "Last Name": "Bergmeier",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531921": {
    "id": "item_34789",
    "Last Name": "Pettersen",
    "First Name": "Kobe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531922": {
    "id": "item_24061",
    "Last Name": "Huang",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531933": {
    "id": "item_24060",
    "Last Name": "Montaos",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531938": {
    "id": "item_34785",
    "Last Name": "Crispin",
    "First Name": "Bob",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531942": {
    "id": "item_34786",
    "Last Name": "Sharma",
    "First Name": "Sumit",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531943": {
    "id": "item_22412",
    "Last Name": "Madilao",
    "First Name": "Muljadi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531944": {
    "id": "item_9546",
    "Last Name": "Camilleri",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531949": {
    "id": "item_9537",
    "Last Name": "Hooper",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531961": {
    "id": "item_11324",
    "Last Name": "Patel",
    "First Name": "Ruchir",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531967": {
    "id": "item_11322",
    "Last Name": "Flanagan",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531968": {
    "id": "item_9544",
    "Last Name": "Wong",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531969": {
    "id": "item_22414",
    "Last Name": "Breva",
    "First Name": "Jhovey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531984": {
    "id": "item_11171",
    "Last Name": "Li",
    "First Name": "Ning",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36531987": {
    "id": "item_36886",
    "Last Name": "CIBULKOVA",
    "First Name": "Katarina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532015": {
    "id": "item_37089",
    "Last Name": "Stone",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532019": {
    "id": "item_24055",
    "Last Name": "Song",
    "First Name": "Chunmei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532021": {
    "id": "item_22407",
    "Last Name": "Yan",
    "First Name": "Shu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532022": {
    "id": "item_24053",
    "Last Name": "Alam",
    "First Name": "Atik",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532024": {
    "id": "item_11408",
    "Last Name": "Cummins",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532027": {
    "id": "item_11407",
    "Last Name": "Sullivan",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532029": {
    "id": "item_22200",
    "Last Name": "ANGGRIAWAN",
    "First Name": "WIDHINATA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532039": {
    "id": "item_36885",
    "Last Name": "Nguyen",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532047": {
    "id": "item_22402",
    "Last Name": "Fernandes",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532048": {
    "id": "item_9345",
    "Last Name": "Eggleston",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532063": {
    "id": "item_36882",
    "Last Name": "Kokubo",
    "First Name": "Yukie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532071": {
    "id": "item_22404",
    "Last Name": "Orlando",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532079": {
    "id": "item_36875",
    "Last Name": "Chongchalermpaiboon",
    "First Name": "Norrason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532080": {
    "id": "item_24049",
    "Last Name": "Aban",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532087": {
    "id": "item_34825",
    "Last Name": "Beattie",
    "First Name": "Beck",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532089": {
    "id": "item_24047",
    "Last Name": "Anders",
    "First Name": "Mel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532100": {
    "id": "item_22403",
    "Last Name": "Gibbons",
    "First Name": "Suzannah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532104": {
    "id": "item_11317",
    "Last Name": "Tobin",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532108": {
    "id": "item_11318",
    "Last Name": "Davies",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532109": {
    "id": "item_22401",
    "Last Name": "Gunasekera",
    "First Name": "Shalindra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532112": {
    "id": "item_22198",
    "Last Name": "Baluch",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532138": {
    "id": "item_9536",
    "Last Name": "Goesmann",
    "First Name": "Erik",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532146": {
    "id": "item_37088",
    "Last Name": "Wheeler",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532151": {
    "id": "item_22399",
    "Last Name": "Kelly",
    "First Name": "Elise",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532164": {
    "id": "item_37087",
    "Last Name": "Jaques",
    "First Name": "Marianne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532166": {
    "id": "item_22396",
    "Last Name": "Peralta",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532167": {
    "id": "item_22397",
    "Last Name": "Cheung",
    "First Name": "Warren",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532173": {
    "id": "item_37106",
    "Last Name": "Catalano",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532184": {
    "id": "item_11312",
    "Last Name": "Khurelbaatar",
    "First Name": "Ariunbold",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532187": {
    "id": "item_36878",
    "Last Name": "Widmer",
    "First Name": "Damien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532188": {
    "id": "item_22395",
    "Last Name": "Wainer",
    "First Name": "Delon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532197": {
    "id": "item_11404",
    "Last Name": "LIN",
    "First Name": "BO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532199": {
    "id": "item_36874",
    "Last Name": "Walker",
    "First Name": "Kel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532211": {
    "id": "item_36981",
    "Last Name": "Dbouk",
    "First Name": "Ali",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532213": {
    "id": "item_36983",
    "Last Name": "Sanjurjo",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532217": {
    "id": "item_9534",
    "Last Name": "Gellen",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532246": {
    "id": "item_11308",
    "Last Name": "McIntosh",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532248": {
    "id": "item_9529",
    "Last Name": "Creagh",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532279": {
    "id": "item_22391",
    "Last Name": "Wood",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532291": {
    "id": "item_36980",
    "Last Name": "Stewart",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532303": {
    "id": "item_36978",
    "Last Name": "Stewart",
    "First Name": "Kayla",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532344": {
    "id": "item_37085",
    "Last Name": "Barwick",
    "First Name": "Debbie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532349": {
    "id": "item_11399",
    "Last Name": "Reid",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532350": {
    "id": "item_11398",
    "Last Name": "Lam",
    "First Name": "Ulysses",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532357": {
    "id": "item_9343",
    "Last Name": "Chan",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532371": {
    "id": "item_11305",
    "Last Name": "Wennerstrom",
    "First Name": "Henrik",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532380": {
    "id": "item_9528",
    "Last Name": "Barry",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532388": {
    "id": "item_22640",
    "Last Name": "Morris",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532390": {
    "id": "item_36870",
    "Last Name": "Yeung",
    "First Name": "Annie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532408": {
    "id": "item_22387",
    "Last Name": "Thompson",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532414": {
    "id": "item_11149",
    "Last Name": "PARK",
    "First Name": "INSU",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532422": {
    "id": "item_36869",
    "Last Name": "Christensen",
    "First Name": "Rhaisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532427": {
    "id": "item_34822",
    "Last Name": "Caguioa",
    "First Name": "Ada",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532448": {
    "id": "item_37084",
    "Last Name": "Clements",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532454": {
    "id": "item_36648",
    "Last Name": "Suryatmoko",
    "First Name": "Ignatius",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532465": {
    "id": "item_9522",
    "Last Name": "THOM",
    "First Name": "MATTHEW",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532466": {
    "id": "item_9517",
    "Last Name": "Shin",
    "First Name": "Soonchul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532468": {
    "id": "item_9520",
    "Last Name": "Bahri",
    "First Name": "Karim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532476": {
    "id": "item_36862",
    "Last Name": "Watermann",
    "First Name": "Finn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532484": {
    "id": "item_22625",
    "Last Name": "Alcorn",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532490": {
    "id": "item_22383",
    "Last Name": "Hilton",
    "First Name": "Greg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532492": {
    "id": "item_9644",
    "Last Name": "Mchugh",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532498": {
    "id": "item_24177",
    "Last Name": "Ward",
    "First Name": "Linda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532504": {
    "id": "item_9515",
    "Last Name": "Scarce",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532507": {
    "id": "item_34821",
    "Last Name": "Kelly",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532509": {
    "id": "item_11501",
    "Last Name": "Lewis",
    "First Name": "Braden",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532512": {
    "id": "item_22197",
    "Last Name": "Drelick",
    "First Name": "Ailsa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532521": {
    "id": "item_9512",
    "Last Name": "Tang",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532531": {
    "id": "item_36859",
    "Last Name": "Bouteille",
    "First Name": "Adrien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532538": {
    "id": "item_9514",
    "Last Name": "Smith",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532543": {
    "id": "item_22196",
    "Last Name": "Westren",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532544": {
    "id": "item_36973",
    "Last Name": "Hu",
    "First Name": "Carrie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532546": {
    "id": "item_11395",
    "Last Name": "Taylor",
    "First Name": "Riley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532551": {
    "id": "item_22195",
    "Last Name": "Johansson",
    "First Name": "Karla",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532562": {
    "id": "item_22639",
    "Last Name": "Lynch",
    "First Name": "Sally",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532568": {
    "id": "item_36858",
    "Last Name": "Surmon",
    "First Name": "Diarmait",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532571": {
    "id": "item_37083",
    "Last Name": "GUO",
    "First Name": "XIAOYU",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532588": {
    "id": "item_37080",
    "Last Name": "Taylor-Smith",
    "First Name": "Zizi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532591": {
    "id": "item_24026",
    "Last Name": "Lockley",
    "First Name": "Amelia-Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532596": {
    "id": "item_34775",
    "Last Name": "Pike",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532607": {
    "id": "item_22380",
    "Last Name": "Geraghty",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532626": {
    "id": "item_36647",
    "Last Name": "Torres",
    "First Name": "Doel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532627": {
    "id": "item_22378",
    "Last Name": "Salcedo",
    "First Name": "Dani Ray",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532641": {
    "id": "item_24174",
    "Last Name": "McKillop",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532648": {
    "id": "item_24121",
    "Last Name": "Petrowski",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532667": {
    "id": "item_11295",
    "Last Name": "Cruz",
    "First Name": "Jan Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532674": {
    "id": "item_11299",
    "Last Name": "fuller",
    "First Name": "tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532675": {
    "id": "item_9506",
    "Last Name": "Gibson",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532684": {
    "id": "item_22376",
    "Last Name": "Forbes",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532688": {
    "id": "item_9734",
    "Last Name": "Hurrell",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532693": {
    "id": "item_11294",
    "Last Name": "Alam",
    "First Name": "Md Nasirul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532696": {
    "id": "item_9505",
    "Last Name": "Pienaar",
    "First Name": "Blaine",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532704": {
    "id": "item_22194",
    "Last Name": "Koh",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532715": {
    "id": "item_9640",
    "Last Name": "Hilson",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532731": {
    "id": "item_36844",
    "Last Name": "Hobbs",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532732": {
    "id": "item_22192",
    "Last Name": "Anggriawan",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532743": {
    "id": "item_24119",
    "Last Name": "Ng",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532766": {
    "id": "item_34854",
    "Last Name": "Naylor",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532771": {
    "id": "item_24025",
    "Last Name": "van Asperen",
    "First Name": "Donna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532782": {
    "id": "item_24118",
    "Last Name": "Lambert",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532794": {
    "id": "item_37082",
    "Last Name": "Go",
    "First Name": "Adriane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532820": {
    "id": "item_9733",
    "Last Name": "OSullivan",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532828": {
    "id": "item_22624",
    "Last Name": "OConnor",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532834": {
    "id": "item_9500",
    "Last Name": "Machielsen",
    "First Name": "Matthijs",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532847": {
    "id": "item_36838",
    "Last Name": "Lareza",
    "First Name": "Luigi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532850": {
    "id": "item_24022",
    "Last Name": "Suplico",
    "First Name": "Aries",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532853": {
    "id": "item_22367",
    "Last Name": "Kang",
    "First Name": "Tae Bong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532854": {
    "id": "item_22496",
    "Last Name": "Ingrey",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532858": {
    "id": "item_24116",
    "Last Name": "Clunes",
    "First Name": "Brad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532869": {
    "id": "item_36837",
    "Last Name": "Vo",
    "First Name": "Tiet Huy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532884": {
    "id": "item_37081",
    "Last Name": "Sharp",
    "First Name": "matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532889": {
    "id": "item_24020",
    "Last Name": "Senior",
    "First Name": "Janeen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532890": {
    "id": "item_24021",
    "Last Name": "Hosseini",
    "First Name": "Seyedehmina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532902": {
    "id": "item_11500",
    "Last Name": "Mudge",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532906": {
    "id": "item_9495",
    "Last Name": "Stemmer",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532910": {
    "id": "item_36833",
    "Last Name": "Gopela",
    "First Name": "Urace Raoul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532914": {
    "id": "item_24019",
    "Last Name": "O Brien",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532916": {
    "id": "item_36834",
    "Last Name": "Johnston",
    "First Name": "Penny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532917": {
    "id": "item_9340",
    "Last Name": "VERE",
    "First Name": "RORY",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532922": {
    "id": "item_11288",
    "Last Name": "Pullin",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532929": {
    "id": "item_36971",
    "Last Name": "Collaga",
    "First Name": "Zos",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532934": {
    "id": "item_24017",
    "Last Name": "Tao",
    "First Name": "Johnny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532940": {
    "id": "item_22358",
    "Last Name": "Muir",
    "First Name": "Gregg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532948": {
    "id": "item_11287",
    "Last Name": "O Halloran",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532950": {
    "id": "item_9492",
    "Last Name": "Wade",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532958": {
    "id": "item_9490",
    "Last Name": "Marks",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532961": {
    "id": "item_37105",
    "Last Name": "Mok",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36532971": {
    "id": "item_24173",
    "Last Name": "Watts",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533007": {
    "id": "item_22356",
    "Last Name": "Kibble",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533026": {
    "id": "item_11283",
    "Last Name": "brock",
    "First Name": "matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533028": {
    "id": "item_9485",
    "Last Name": "Shankar",
    "First Name": "Shesha",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533031": {
    "id": "item_11282",
    "Last Name": "MacGregor",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533048": {
    "id": "item_36831",
    "Last Name": "Thor",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533049": {
    "id": "item_9484",
    "Last Name": "Awramenko",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533061": {
    "id": "item_36830",
    "Last Name": "Utegenova",
    "First Name": "Aigul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533068": {
    "id": "item_36827",
    "Last Name": "Sibly",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533083": {
    "id": "item_36828",
    "Last Name": "SINGH",
    "First Name": "Harpreet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533084": {
    "id": "item_22354",
    "Last Name": "Wilson",
    "First Name": "Rob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533085": {
    "id": "item_24172",
    "Last Name": "ZHENG",
    "First Name": "GANG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533088": {
    "id": "item_36823",
    "Last Name": "O Reilly",
    "First Name": "Declan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533089": {
    "id": "item_24011",
    "Last Name": "Alves",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533091": {
    "id": "item_9483",
    "Last Name": "XU",
    "First Name": "GAOXIANG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533098": {
    "id": "item_34766",
    "Last Name": "Khera",
    "First Name": "Ranjit Singh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533107": {
    "id": "item_9633",
    "Last Name": "Shallcross",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533110": {
    "id": "item_34767",
    "Last Name": "Porto Kalaf",
    "First Name": "Victor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533114": {
    "id": "item_9339",
    "Last Name": "LI",
    "First Name": "ZIXING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533116": {
    "id": "item_22353",
    "Last Name": "Bentley",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533122": {
    "id": "item_36825",
    "Last Name": "Li",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533124": {
    "id": "item_34853",
    "Last Name": "Iles",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533128": {
    "id": "item_24009",
    "Last Name": "Devine",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533348": {
    "id": "item_24115",
    "Last Name": "Maciver",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533559": {
    "id": "item_11498",
    "Last Name": "Barnett",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533883": {
    "id": "item_22352",
    "Last Name": "Calamos",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533900": {
    "id": "item_37079",
    "Last Name": "Reddy",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36533989": {
    "id": "item_11499",
    "Last Name": "Cleeland",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36534403": {
    "id": "item_11275",
    "Last Name": "Loughnane",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36534763": {
    "id": "item_11387",
    "Last Name": "Boarotto",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36534841": {
    "id": "item_22493",
    "Last Name": "Riordan",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36534969": {
    "id": "item_22346",
    "Last Name": "Ozsonmez",
    "First Name": "Cemil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36535090": {
    "id": "item_9627",
    "Last Name": "Nash",
    "First Name": "Clint",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36535395": {
    "id": "item_36817",
    "Last Name": "Burt",
    "First Name": "Lydia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36535461": {
    "id": "item_24000",
    "Last Name": "Nicholson",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36535714": {
    "id": "item_22188",
    "Last Name": "Sulaiman",
    "First Name": "Mohd Hishamuddin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36536004": {
    "id": "item_9478",
    "Last Name": "Driscoll",
    "First Name": "Arawa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36536175": {
    "id": "item_22345",
    "Last Name": "Brighton",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36536327": {
    "id": "item_36968",
    "Last Name": "Fleming",
    "First Name": "Jay",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36536428": {
    "id": "item_9477",
    "Last Name": "Chen",
    "First Name": "Lincoln",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36536545": {
    "id": "item_37104",
    "Last Name": "Xu",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36536952": {
    "id": "item_9625",
    "Last Name": "Phan",
    "First Name": "Hung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537061": {
    "id": "item_37078",
    "Last Name": "Wells",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537095": {
    "id": "item_34852",
    "Last Name": "Kiama",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537102": {
    "id": "item_34762",
    "Last Name": "Gomez",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537126": {
    "id": "item_9476",
    "Last Name": "Callister",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537200": {
    "id": "item_24113",
    "Last Name": "Davis",
    "First Name": "Jaysine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537300": {
    "id": "item_36642",
    "Last Name": "Bathan",
    "First Name": "Mae Elaine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537531": {
    "id": "item_11267",
    "Last Name": "Ilagan",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537781": {
    "id": "item_36640",
    "Last Name": "Dassa",
    "First Name": "Rizky",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36537932": {
    "id": "item_22342",
    "Last Name": "Fanner",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538074": {
    "id": "item_11497",
    "Last Name": "Roberts-Thomson",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538087": {
    "id": "item_24171",
    "Last Name": "Duncan",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538101": {
    "id": "item_23999",
    "Last Name": "Pirotta",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538135": {
    "id": "item_22340",
    "Last Name": "Bolus",
    "First Name": "Melvyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538177": {
    "id": "item_11266",
    "Last Name": "Baker",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538182": {
    "id": "item_36639",
    "Last Name": "MANAF",
    "First Name": "AZIZUL",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538185": {
    "id": "item_22339",
    "Last Name": "Barker",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538191": {
    "id": "item_11264",
    "Last Name": "Mazziero",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538193": {
    "id": "item_22187",
    "Last Name": "Rubiana",
    "First Name": "Dina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538194": {
    "id": "item_23998",
    "Last Name": "Mizzi",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538231": {
    "id": "item_22623",
    "Last Name": "Logan",
    "First Name": "Lilly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538250": {
    "id": "item_36637",
    "Last Name": "cartwright",
    "First Name": "david",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538266": {
    "id": "item_23996",
    "Last Name": "Singh",
    "First Name": "Kulwinder",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538280": {
    "id": "item_11262",
    "Last Name": "evans",
    "First Name": "ean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538281": {
    "id": "item_23997",
    "Last Name": "Hashimura",
    "First Name": "Seiji",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538295": {
    "id": "item_36803",
    "Last Name": "Briggs",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538297": {
    "id": "item_34759",
    "Last Name": "Bradhurst",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538299": {
    "id": "item_22489",
    "Last Name": "QI",
    "First Name": "JIRONG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538300": {
    "id": "item_22336",
    "Last Name": "Beck",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538305": {
    "id": "item_34758",
    "Last Name": "Spasevski",
    "First Name": "Nick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538310": {
    "id": "item_9624",
    "Last Name": "Pham",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538312": {
    "id": "item_22487",
    "Last Name": "Heilbronn",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538313": {
    "id": "item_11382",
    "Last Name": "Hicks",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538318": {
    "id": "item_22335",
    "Last Name": "Kochergin",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538345": {
    "id": "item_9472",
    "Last Name": "McDonagh",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538353": {
    "id": "item_23904",
    "Last Name": "Huang",
    "First Name": "Jerry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538358": {
    "id": "item_11260",
    "Last Name": "Furey",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538360": {
    "id": "item_36797",
    "Last Name": "Burchett",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538371": {
    "id": "item_36634",
    "Last Name": "Loberanis",
    "First Name": "Arvin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538384": {
    "id": "item_11381",
    "Last Name": "Sekhar",
    "First Name": "Sandeep",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538394": {
    "id": "item_11259",
    "Last Name": "Smolnik",
    "First Name": "Daria",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538404": {
    "id": "item_22334",
    "Last Name": "Tian",
    "First Name": "Xin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538414": {
    "id": "item_36796",
    "Last Name": "Middleton",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538424": {
    "id": "item_23994",
    "Last Name": "Zhou",
    "First Name": "Yi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538426": {
    "id": "item_11257",
    "Last Name": "TOLMAN",
    "First Name": "Cae",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538434": {
    "id": "item_22332",
    "Last Name": "Skilling",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538442": {
    "id": "item_9470",
    "Last Name": "Anderson",
    "First Name": "Collin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538456": {
    "id": "item_11380",
    "Last Name": "Cramer",
    "First Name": "Xavier",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538465": {
    "id": "item_9622",
    "Last Name": "Poulos",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538466": {
    "id": "item_22622",
    "Last Name": "Copeland",
    "First Name": "Summer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538472": {
    "id": "item_9467",
    "Last Name": "Nicholson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538488": {
    "id": "item_22638",
    "Last Name": "Rodgers",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36538737": {
    "id": "item_9465",
    "Last Name": "Kirk",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36539739": {
    "id": "item_23991",
    "Last Name": "Smith",
    "First Name": "Hayley-Ann",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36539867": {
    "id": "item_37077",
    "Last Name": "Cook",
    "First Name": "Kirilee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36539975": {
    "id": "item_9335",
    "Last Name": "Baltaev",
    "First Name": "Azat",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540024": {
    "id": "item_36792",
    "Last Name": "Delgado",
    "First Name": "Mhelfred",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540026": {
    "id": "item_9621",
    "Last Name": "Tran",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540043": {
    "id": "item_22325",
    "Last Name": "Chinalha Loureiro",
    "First Name": "Bruno",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540055": {
    "id": "item_36794",
    "Last Name": "Vo",
    "First Name": "Joyce",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540073": {
    "id": "item_22323",
    "Last Name": "Zemuner",
    "First Name": "Priscila",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540074": {
    "id": "item_36791",
    "Last Name": "Nanthiyath Sinkaran",
    "First Name": "Anoop",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540083": {
    "id": "item_9456",
    "Last Name": "Alehossein",
    "First Name": "Salar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540089": {
    "id": "item_36787",
    "Last Name": "Fryer",
    "First Name": "Sally",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540103": {
    "id": "item_9453",
    "Last Name": "Montagna",
    "First Name": "Dalmir",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540107": {
    "id": "item_11247",
    "Last Name": "Garcia",
    "First Name": "Esteban",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540118": {
    "id": "item_22319",
    "Last Name": "Edge",
    "First Name": "Renee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540183": {
    "id": "item_22320",
    "Last Name": "Buckley",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540356": {
    "id": "item_9732",
    "Last Name": "Pendleton",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540413": {
    "id": "item_36785",
    "Last Name": "McMahon",
    "First Name": "Bettina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540414": {
    "id": "item_22318",
    "Last Name": "FITZPATRICK",
    "First Name": "STEPHEN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540623": {
    "id": "item_37103",
    "Last Name": "Pollard",
    "First Name": "Tessa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36540680": {
    "id": "item_24111",
    "Last Name": "Edwards",
    "First Name": "Fay",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36541020": {
    "id": "item_11144",
    "Last Name": "Chio",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36541792": {
    "id": "item_37076",
    "Last Name": "Steele",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36541811": {
    "id": "item_9451",
    "Last Name": "Reed",
    "First Name": "Damo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36542215": {
    "id": "item_11378",
    "Last Name": "Bates",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36542845": {
    "id": "item_9450",
    "Last Name": "King",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36543156": {
    "id": "item_36780",
    "Last Name": "Delgado",
    "First Name": "Ma Simolyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36543493": {
    "id": "item_34752",
    "Last Name": "Mathieu",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36543696": {
    "id": "item_22621",
    "Last Name": "Maguire",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36543853": {
    "id": "item_9731",
    "Last Name": "Robinson",
    "First Name": "Griffin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36543991": {
    "id": "item_37102",
    "Last Name": "Tang",
    "First Name": "Ken Zee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544828": {
    "id": "item_36631",
    "Last Name": "Purwatmoko",
    "First Name": "Hariadi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36544874": {
    "id": "item_23987",
    "Last Name": "Lee",
    "First Name": "Lik hang",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545198": {
    "id": "item_36779",
    "Last Name": "Roberts",
    "First Name": "Katriona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545219": {
    "id": "item_36774",
    "Last Name": "Kenna",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545238": {
    "id": "item_36775",
    "Last Name": "Strong",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545339": {
    "id": "item_23981",
    "Last Name": "Andrade",
    "First Name": "Marcelo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545364": {
    "id": "item_23985",
    "Last Name": "Baez",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545512": {
    "id": "item_36776",
    "Last Name": "Horton King",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545525": {
    "id": "item_24110",
    "Last Name": "Barber",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545532": {
    "id": "item_36778",
    "Last Name": "Tanti",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545538": {
    "id": "item_23986",
    "Last Name": "Norris",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36545865": {
    "id": "item_9614",
    "Last Name": "Hartley",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36546063": {
    "id": "item_9613",
    "Last Name": "Suter",
    "First Name": "Bradon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36546067": {
    "id": "item_22312",
    "Last Name": "Semenova",
    "First Name": "Elizaveta",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36546199": {
    "id": "item_23979",
    "Last Name": "Wood",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36546311": {
    "id": "item_9333",
    "Last Name": "WANG",
    "First Name": "HAO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36546587": {
    "id": "item_37075",
    "Last Name": "Paterson",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36546666": {
    "id": "item_34750",
    "Last Name": "Trinh",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547163": {
    "id": "item_22310",
    "Last Name": "Gilmore",
    "First Name": "Kieren",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547181": {
    "id": "item_36771",
    "Last Name": "Guo",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547190": {
    "id": "item_22309",
    "Last Name": "Ahn",
    "First Name": "Lenny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547206": {
    "id": "item_9611",
    "Last Name": "Brady",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547242": {
    "id": "item_36961",
    "Last Name": "Tsien",
    "First Name": "Jai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547250": {
    "id": "item_22306",
    "Last Name": "YANG",
    "First Name": "YI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547271": {
    "id": "item_36766",
    "Last Name": "Butel",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547274": {
    "id": "item_11375",
    "Last Name": "Ellison",
    "First Name": "Jade",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547279": {
    "id": "item_34749",
    "Last Name": "Yamamoto",
    "First Name": "Chiharu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547292": {
    "id": "item_9610",
    "Last Name": "Barry",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547295": {
    "id": "item_22482",
    "Last Name": "Landucci",
    "First Name": "Angelo Giovanni",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547308": {
    "id": "item_34812",
    "Last Name": "Vella",
    "First Name": "Doris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547424": {
    "id": "item_9443",
    "Last Name": "Dillon",
    "First Name": "Owen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547770": {
    "id": "item_9442",
    "Last Name": "Dortkamp",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36547919": {
    "id": "item_9331",
    "Last Name": "Barker",
    "First Name": "Red",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549087": {
    "id": "item_9438",
    "Last Name": "McEwan",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549099": {
    "id": "item_9437",
    "Last Name": "Cregan",
    "First Name": "Ed",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549116": {
    "id": "item_23973",
    "Last Name": "Rochfort",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549123": {
    "id": "item_11231",
    "Last Name": "Thamin",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549127": {
    "id": "item_36627",
    "Last Name": "Velasco Sarmiento",
    "First Name": "Daniel Alejandro",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549131": {
    "id": "item_24104",
    "Last Name": "Rendall",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549137": {
    "id": "item_23971",
    "Last Name": "Jalil",
    "First Name": "Federico",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549143": {
    "id": "item_34745",
    "Last Name": "Napper",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549160": {
    "id": "item_23966",
    "Last Name": "Thornton",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549262": {
    "id": "item_36626",
    "Last Name": "Harimurti",
    "First Name": "Ganjar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549264": {
    "id": "item_23969",
    "Last Name": "Llorador",
    "First Name": "Jonah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36549586": {
    "id": "item_11372",
    "Last Name": "Brockman",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36550315": {
    "id": "item_9432",
    "Last Name": "Hogg",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36550628": {
    "id": "item_22481",
    "Last Name": "Palmer",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36550783": {
    "id": "item_9429",
    "Last Name": "Gray",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36550866": {
    "id": "item_34743",
    "Last Name": "Wayman",
    "First Name": "Kristi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36551129": {
    "id": "item_34809",
    "Last Name": "Boiko",
    "First Name": "Artur",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36551885": {
    "id": "item_9608",
    "Last Name": "Chan",
    "First Name": "Siu Fai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36552104": {
    "id": "item_36752",
    "Last Name": "Barsch",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36552626": {
    "id": "item_36751",
    "Last Name": "Egan",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36552667": {
    "id": "item_11371",
    "Last Name": "Bryant",
    "First Name": "Briony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36553282": {
    "id": "item_36750",
    "Last Name": "Kidman",
    "First Name": "Trent",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36553302": {
    "id": "item_11496",
    "Last Name": "Skewes",
    "First Name": "Dakota",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36553831": {
    "id": "item_36749",
    "Last Name": "Wallace",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36554544": {
    "id": "item_36747",
    "Last Name": "Roldan",
    "First Name": "Prince Jubert III",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36554656": {
    "id": "item_36748",
    "Last Name": "Brandham",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555019": {
    "id": "item_11224",
    "Last Name": "Barnicle",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555076": {
    "id": "item_22295",
    "Last Name": "Bortz",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555769": {
    "id": "item_23901",
    "Last Name": "Filler",
    "First Name": "Donnie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555770": {
    "id": "item_36624",
    "Last Name": "Go",
    "First Name": "Mary Abigael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555772": {
    "id": "item_24176",
    "Last Name": "Kirkland",
    "First Name": "Christie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555789": {
    "id": "item_11218",
    "Last Name": "Evans",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555810": {
    "id": "item_36737",
    "Last Name": "Davis",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555817": {
    "id": "item_9326",
    "Last Name": "Villasin",
    "First Name": "Adriel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555826": {
    "id": "item_9730",
    "Last Name": "Bell",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555831": {
    "id": "item_9427",
    "Last Name": "Harding",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555832": {
    "id": "item_22292",
    "Last Name": "Kwan",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555848": {
    "id": "item_11217",
    "Last Name": "Pethybridge",
    "First Name": "Kieren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555877": {
    "id": "item_23960",
    "Last Name": "Baseley",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555878": {
    "id": "item_9425",
    "Last Name": "Love",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555883": {
    "id": "item_22620",
    "Last Name": "Ham",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555900": {
    "id": "item_22619",
    "Last Name": "Howlett",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555943": {
    "id": "item_11215",
    "Last Name": "Liang",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555987": {
    "id": "item_9423",
    "Last Name": "Wang",
    "First Name": "Huanong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36555988": {
    "id": "item_22288",
    "Last Name": "Baudzus",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36556004": {
    "id": "item_9325",
    "Last Name": "Seymour",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36556074": {
    "id": "item_9605",
    "Last Name": "Pan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36556130": {
    "id": "item_23957",
    "Last Name": "Vale",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36556652": {
    "id": "item_9420",
    "Last Name": "Tang",
    "First Name": "Ka Wai Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36557317": {
    "id": "item_24170",
    "Last Name": "Saunderson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36557347": {
    "id": "item_22285",
    "Last Name": "Phillips",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36558239": {
    "id": "item_36621",
    "Last Name": "CHEN",
    "First Name": "KAI-WEN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36558530": {
    "id": "item_36733",
    "Last Name": "chow",
    "First Name": "kenny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36558642": {
    "id": "item_36732",
    "Last Name": "Borg",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36558817": {
    "id": "item_36951",
    "Last Name": "Ashley",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36559306": {
    "id": "item_23955",
    "Last Name": "Leong",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36559479": {
    "id": "item_34739",
    "Last Name": "Hunt",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36559650": {
    "id": "item_34808",
    "Last Name": "Mackenzie",
    "First Name": "Noeleen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560196": {
    "id": "item_9411",
    "Last Name": "Kopke",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560573": {
    "id": "item_36731",
    "Last Name": "Manshadi",
    "First Name": "Nasrin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560644": {
    "id": "item_22475",
    "Last Name": "Shaw",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560657": {
    "id": "item_9415",
    "Last Name": "Marshall",
    "First Name": "Hew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560718": {
    "id": "item_34738",
    "Last Name": "isaacs",
    "First Name": "lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36560787": {
    "id": "item_9416",
    "Last Name": "Anderson",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561196": {
    "id": "item_11367",
    "Last Name": "Lewis",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561242": {
    "id": "item_9601",
    "Last Name": "Burns",
    "First Name": "Shanan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561255": {
    "id": "item_9414",
    "Last Name": "Glew",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561263": {
    "id": "item_36728",
    "Last Name": "Yu",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36561946": {
    "id": "item_36726",
    "Last Name": "Harrison",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562276": {
    "id": "item_9404",
    "Last Name": "Hong",
    "First Name": "Keith",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562293": {
    "id": "item_22281",
    "Last Name": "Fowler",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562457": {
    "id": "item_11495",
    "Last Name": "McCallum",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562477": {
    "id": "item_22280",
    "Last Name": "King",
    "First Name": "Debbie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562611": {
    "id": "item_22278",
    "Last Name": "XIE",
    "First Name": "Ricky Jian Yu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562630": {
    "id": "item_9729",
    "Last Name": "Sharpe",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562631": {
    "id": "item_22277",
    "Last Name": "Rasaratnam",
    "First Name": "Daven",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562641": {
    "id": "item_36950",
    "Last Name": "Davis",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562654": {
    "id": "item_9406",
    "Last Name": "Wholley",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562672": {
    "id": "item_23952",
    "Last Name": "Jackson",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562673": {
    "id": "item_11207",
    "Last Name": "TINDAL",
    "First Name": "SCOTT",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562737": {
    "id": "item_22178",
    "Last Name": "Wong",
    "First Name": "Chung Man Rebecca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562764": {
    "id": "item_36718",
    "Last Name": "Garrett",
    "First Name": "Ian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562798": {
    "id": "item_22273",
    "Last Name": "Hamajima",
    "First Name": "Masato",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36562877": {
    "id": "item_36617",
    "Last Name": "Chen",
    "First Name": "Ting-Sheng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36563449": {
    "id": "item_9402",
    "Last Name": "Hosking",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36563737": {
    "id": "item_22270",
    "Last Name": "Gibson",
    "First Name": "Claude",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36563838": {
    "id": "item_22269",
    "Last Name": "Macapinlac",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36564783": {
    "id": "item_22471",
    "Last Name": "Benson",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36564822": {
    "id": "item_36721",
    "Last Name": "Ubas",
    "First Name": "Beck",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36564906": {
    "id": "item_22266",
    "Last Name": "Parkinson",
    "First Name": "Dervan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36564916": {
    "id": "item_22177",
    "Last Name": "Dino",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36565027": {
    "id": "item_11540",
    "Last Name": "Dalhuisen",
    "First Name": "Sander",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36565122": {
    "id": "item_9398",
    "Last Name": "OÕMeara",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36565486": {
    "id": "item_36946",
    "Last Name": "O'Connor",
    "First Name": "Theresa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36566046": {
    "id": "item_23948",
    "Last Name": "Brown",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36566466": {
    "id": "item_22265",
    "Last Name": "Solomon",
    "First Name": "Che",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36567244": {
    "id": "item_9597",
    "Last Name": "Ito",
    "First Name": "Daichi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36567977": {
    "id": "item_36945",
    "Last Name": "Carlson",
    "First Name": "Paige",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568023": {
    "id": "item_22262",
    "Last Name": "Tomlinson",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568026": {
    "id": "item_22263",
    "Last Name": "Jin",
    "First Name": "Terry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568639": {
    "id": "item_22469",
    "Last Name": "Le Lievre",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568643": {
    "id": "item_36714",
    "Last Name": "Feurtado",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568645": {
    "id": "item_22259",
    "Last Name": "Simpson",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568658": {
    "id": "item_11200",
    "Last Name": "Kennedy",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568661": {
    "id": "item_22260",
    "Last Name": "Churchill",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568665": {
    "id": "item_34704",
    "Last Name": "Ismail",
    "First Name": "Zulkifli",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568834": {
    "id": "item_34729",
    "Last Name": "Sendall",
    "First Name": "Stewart",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568846": {
    "id": "item_36616",
    "Last Name": "Leung",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36568934": {
    "id": "item_22255",
    "Last Name": "McKinney",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569131": {
    "id": "item_23946",
    "Last Name": "Wrightson",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569261": {
    "id": "item_24169",
    "Last Name": "Pateman",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569305": {
    "id": "item_11362",
    "Last Name": "Li",
    "First Name": "Zheren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569314": {
    "id": "item_22256",
    "Last Name": "Roure",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569319": {
    "id": "item_9596",
    "Last Name": "Manks",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569350": {
    "id": "item_23945",
    "Last Name": "Murphy",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569367": {
    "id": "item_36615",
    "Last Name": "Claridad",
    "First Name": "Roland Allan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569379": {
    "id": "item_11198",
    "Last Name": "Calleija",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569394": {
    "id": "item_9394",
    "Last Name": "Xia",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569404": {
    "id": "item_11135",
    "Last Name": "Skygebjerg",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569432": {
    "id": "item_34728",
    "Last Name": "Tanaka",
    "First Name": "Naoko",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569435": {
    "id": "item_22252",
    "Last Name": "Krogh",
    "First Name": "Jesper Wisborg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569446": {
    "id": "item_24097",
    "Last Name": "Singh",
    "First Name": "Gagandeep",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36569450": {
    "id": "item_34727",
    "Last Name": "Hough",
    "First Name": "Imogen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36570157": {
    "id": "item_23897",
    "Last Name": "Lee",
    "First Name": "Ka chi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36570167": {
    "id": "item_36708",
    "Last Name": "Prescott",
    "First Name": "Ramona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36570219": {
    "id": "item_22618",
    "Last Name": "Carter",
    "First Name": "Kira",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36570836": {
    "id": "item_36706",
    "Last Name": "Kang",
    "First Name": "Alan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36571103": {
    "id": "item_34726",
    "Last Name": "Crowley",
    "First Name": "Eimear",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36571471": {
    "id": "item_11194",
    "Last Name": "Haikerwal",
    "First Name": "Jeevan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36571886": {
    "id": "item_22250",
    "Last Name": "Doyle",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36572199": {
    "id": "item_22637",
    "Last Name": "Dave",
    "First Name": "Jay",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36572587": {
    "id": "item_9321",
    "Last Name": "Vaysset",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36573467": {
    "id": "item_11360",
    "Last Name": "NGUYEN",
    "First Name": "KHOA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36573645": {
    "id": "item_36703",
    "Last Name": "Swift",
    "First Name": "Roger",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36573677": {
    "id": "item_23942",
    "Last Name": "Dickson",
    "First Name": "Clare",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36573688": {
    "id": "item_34725",
    "Last Name": "Xiao",
    "First Name": "Ying",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36573708": {
    "id": "item_36699",
    "Last Name": "Mailer",
    "First Name": "Krystyna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36574091": {
    "id": "item_11189",
    "Last Name": "Abbey",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36574682": {
    "id": "item_11134",
    "Last Name": "LAW",
    "First Name": "POK MAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36574686": {
    "id": "item_22248",
    "Last Name": "Rangan",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36574961": {
    "id": "item_22247",
    "Last Name": "Brankovic",
    "First Name": "Stevan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575410": {
    "id": "item_36698",
    "Last Name": "santos",
    "First Name": "marc dominique",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575611": {
    "id": "item_11494",
    "Last Name": "Walker",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575623": {
    "id": "item_37101",
    "Last Name": "Holmes",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575631": {
    "id": "item_37143",
    "Last Name": "ZHU",
    "First Name": "WEIHONG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575770": {
    "id": "item_22464",
    "Last Name": "Furniss",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575820": {
    "id": "item_24168",
    "Last Name": "Jackson",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575957": {
    "id": "item_23940",
    "Last Name": "Yu",
    "First Name": "Jingyi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575985": {
    "id": "item_11132",
    "Last Name": "Koyama",
    "First Name": "Makoto",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36575988": {
    "id": "item_11187",
    "Last Name": "Nikolov",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576002": {
    "id": "item_11186",
    "Last Name": "QIAN",
    "First Name": "XINWEI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576014": {
    "id": "item_36697",
    "Last Name": "Murray",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576017": {
    "id": "item_9589",
    "Last Name": "Ingham",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576089": {
    "id": "item_11358",
    "Last Name": "Mash",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576103": {
    "id": "item_22243",
    "Last Name": "Corcoran",
    "First Name": "Chanice",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576143": {
    "id": "item_22462",
    "Last Name": "Sestak",
    "First Name": "Antonia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576159": {
    "id": "item_9728",
    "Last Name": "Giffin",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576170": {
    "id": "item_24093",
    "Last Name": "walters",
    "First Name": "steven",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576187": {
    "id": "item_34722",
    "Last Name": "Roberts",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576195": {
    "id": "item_24092",
    "Last Name": "Vegliante",
    "First Name": "Santina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576232": {
    "id": "item_37100",
    "Last Name": "Lopez",
    "First Name": "Benito",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576251": {
    "id": "item_37074",
    "Last Name": "Cowan",
    "First Name": "Malcolm",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576288": {
    "id": "item_9588",
    "Last Name": "Hilgers",
    "First Name": "Sascha",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576289": {
    "id": "item_22173",
    "Last Name": "Yue",
    "First Name": "Rong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576352": {
    "id": "item_24089",
    "Last Name": "Christian",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576368": {
    "id": "item_22458",
    "Last Name": "Odlum",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576371": {
    "id": "item_11177",
    "Last Name": "Shrestha",
    "First Name": "Bikash",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576372": {
    "id": "item_36690",
    "Last Name": "Li",
    "First Name": "Ye",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576387": {
    "id": "item_22238",
    "Last Name": "Bajwa",
    "First Name": "Satnam Singh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576401": {
    "id": "item_9380",
    "Last Name": "Riggs",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576402": {
    "id": "item_36691",
    "Last Name": "Casement",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576422": {
    "id": "item_9379",
    "Last Name": "Oakes",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576427": {
    "id": "item_36688",
    "Last Name": "May",
    "First Name": "Jacinta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576501": {
    "id": "item_24088",
    "Last Name": "Cheng",
    "First Name": "Solomon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576509": {
    "id": "item_36941",
    "Last Name": "Lin",
    "First Name": "Yao-Hung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576515": {
    "id": "item_9378",
    "Last Name": "Morgan",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576552": {
    "id": "item_24087",
    "Last Name": "Pell",
    "First Name": "Narelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576559": {
    "id": "item_37099",
    "Last Name": "Fortu",
    "First Name": "Schandel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576588": {
    "id": "item_9376",
    "Last Name": "Latta",
    "First Name": "Troy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576589": {
    "id": "item_9587",
    "Last Name": "Bordignon",
    "First Name": "Marty",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576592": {
    "id": "item_23934",
    "Last Name": "Duggan",
    "First Name": "Brad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576629": {
    "id": "item_11493",
    "Last Name": "Nguyen",
    "First Name": "Tam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576630": {
    "id": "item_22237",
    "Last Name": "Woods",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576648": {
    "id": "item_11175",
    "Last Name": "Rutherford",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576652": {
    "id": "item_11174",
    "Last Name": "Kim",
    "First Name": "Sung Chan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576663": {
    "id": "item_36684",
    "Last Name": "Nivelleau",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576699": {
    "id": "item_11173",
    "Last Name": "Wright",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576723": {
    "id": "item_22236",
    "Last Name": "Bourchdan",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576753": {
    "id": "item_36683",
    "Last Name": "Kelly",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576787": {
    "id": "item_23933",
    "Last Name": "Tang",
    "First Name": "Bao",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576792": {
    "id": "item_11351",
    "Last Name": "Mendoza",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576809": {
    "id": "item_34802",
    "Last Name": "Liu",
    "First Name": "Dingrong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576821": {
    "id": "item_36681",
    "Last Name": "Rawson",
    "First Name": "Jill",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576823": {
    "id": "item_22456",
    "Last Name": "Fazakerley",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576840": {
    "id": "item_11172",
    "Last Name": "DUNN",
    "First Name": "BRYCE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576887": {
    "id": "item_24086",
    "Last Name": "Spooner",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576893": {
    "id": "item_23932",
    "Last Name": "Raeburn",
    "First Name": "Toby",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576923": {
    "id": "item_23929",
    "Last Name": "Smith",
    "First Name": "Leona",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576936": {
    "id": "item_36680",
    "Last Name": "Mitchelmore",
    "First Name": "Suallyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576939": {
    "id": "item_34800",
    "Last Name": "Smith",
    "First Name": "Karin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36576998": {
    "id": "item_22232",
    "Last Name": "Illingworth",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577011": {
    "id": "item_22230",
    "Last Name": "Astono",
    "First Name": "Hendi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577076": {
    "id": "item_11350",
    "Last Name": "Salerno",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577097": {
    "id": "item_9582",
    "Last Name": "Lewis",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577115": {
    "id": "item_9366",
    "Last Name": "Hewat",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577137": {
    "id": "item_22228",
    "Last Name": "Leung",
    "First Name": "Annabel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577140": {
    "id": "item_22454",
    "Last Name": "Campos",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577168": {
    "id": "item_11168",
    "Last Name": "Bobbett",
    "First Name": "Ollie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577175": {
    "id": "item_23925",
    "Last Name": "Bertram",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577195": {
    "id": "item_36604",
    "Last Name": "Sandika",
    "First Name": "Afriandini Putri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577237": {
    "id": "item_22616",
    "Last Name": "Shearman",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577243": {
    "id": "item_9365",
    "Last Name": "Tran",
    "First Name": "Johnson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577252": {
    "id": "item_23896",
    "Last Name": "Saraboot",
    "First Name": "Theparporn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577261": {
    "id": "item_34860",
    "Last Name": "Kelly",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577281": {
    "id": "item_23895",
    "Last Name": "wang",
    "First Name": "liwei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577295": {
    "id": "item_36676",
    "Last Name": "Murray",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577325": {
    "id": "item_36603",
    "Last Name": "PONGKANKHAM",
    "First Name": "WARIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577367": {
    "id": "item_23922",
    "Last Name": "Hidalgo",
    "First Name": "Blanca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577383": {
    "id": "item_11167",
    "Last Name": "Masternak",
    "First Name": "Karl",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577404": {
    "id": "item_36674",
    "Last Name": "Mathur",
    "First Name": "Sandeep",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577406": {
    "id": "item_34859",
    "Last Name": "Kline",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577436": {
    "id": "item_23920",
    "Last Name": "Gibson",
    "First Name": "Liz",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577479": {
    "id": "item_9576",
    "Last Name": "Ho",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577490": {
    "id": "item_37073",
    "Last Name": "Janos",
    "First Name": "Annika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577519": {
    "id": "item_22164",
    "Last Name": "WANG",
    "First Name": "JIYI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577527": {
    "id": "item_36673",
    "Last Name": "Wilkins",
    "First Name": "Shane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577559": {
    "id": "item_9577",
    "Last Name": "Van Arkel",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577569": {
    "id": "item_22162",
    "Last Name": "Vogler",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577582": {
    "id": "item_11128",
    "Last Name": "LIN",
    "First Name": "CHAO-YU",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577628": {
    "id": "item_22161",
    "Last Name": "Kong",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577636": {
    "id": "item_36600",
    "Last Name": "Mo",
    "First Name": "Kristal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577669": {
    "id": "item_36668",
    "Last Name": "Lok",
    "First Name": "Sing To",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577670": {
    "id": "item_22450",
    "Last Name": "Brose",
    "First Name": "Kyla",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577674": {
    "id": "item_22449",
    "Last Name": "Phipps",
    "First Name": "Leighton",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577675": {
    "id": "item_36932",
    "Last Name": "Stolk",
    "First Name": "Boudewijn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577699": {
    "id": "item_11163",
    "Last Name": "Yu",
    "First Name": "Yang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577707": {
    "id": "item_34715",
    "Last Name": "David",
    "First Name": "Dwane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577739": {
    "id": "item_37098",
    "Last Name": "fang",
    "First Name": "hang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577746": {
    "id": "item_23917",
    "Last Name": "Bradish",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577752": {
    "id": "item_34798",
    "Last Name": "Haliczer",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577764": {
    "id": "item_36599",
    "Last Name": "Wong",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577769": {
    "id": "item_22615",
    "Last Name": "Kearin",
    "First Name": "Manette",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577771": {
    "id": "item_36665",
    "Last Name": "Unsworth",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577798": {
    "id": "item_9310",
    "Last Name": "BIN ALIAS",
    "First Name": "MOHD SYAHIDAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577835": {
    "id": "item_36661",
    "Last Name": "Banuzaki",
    "First Name": "Adniwan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577856": {
    "id": "item_23914",
    "Last Name": "Tynan",
    "First Name": "Deana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577865": {
    "id": "item_23913",
    "Last Name": "Tse",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577895": {
    "id": "item_22218",
    "Last Name": "Darwin",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577914": {
    "id": "item_24079",
    "Last Name": "Scott-Wild",
    "First Name": "Denise",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577933": {
    "id": "item_22216",
    "Last Name": "Corbisiero",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36577962": {
    "id": "item_22214",
    "Last Name": "Sappey",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578001": {
    "id": "item_36658",
    "Last Name": "Malla",
    "First Name": "Dinesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578011": {
    "id": "item_9351",
    "Last Name": "Li",
    "First Name": "Zheng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578035": {
    "id": "item_11161",
    "Last Name": "Lum",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578063": {
    "id": "item_22212",
    "Last Name": "Vuillermet",
    "First Name": "Malou",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578069": {
    "id": "item_24077",
    "Last Name": "LU",
    "First Name": "YUE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578094": {
    "id": "item_36931",
    "Last Name": "Ittarattana",
    "First Name": "Kittichai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578111": {
    "id": "item_22211",
    "Last Name": "Robson",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578162": {
    "id": "item_22444",
    "Last Name": "Brogan",
    "First Name": "Neredah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578226": {
    "id": "item_36929",
    "Last Name": "Millikan",
    "First Name": "Abbie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578233": {
    "id": "item_36656",
    "Last Name": "Gray",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578289": {
    "id": "item_9350",
    "Last Name": "Powell",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578295": {
    "id": "item_11160",
    "Last Name": "Finegan",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578319": {
    "id": "item_22159",
    "Last Name": "nursidah",
    "First Name": "errin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578391": {
    "id": "item_9568",
    "Last Name": "Do",
    "First Name": "Huy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578396": {
    "id": "item_23911",
    "Last Name": "Sharkey",
    "First Name": "Aisling",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578421": {
    "id": "item_34712",
    "Last Name": "Zvezdakoski",
    "First Name": "Tony",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578422": {
    "id": "item_23910",
    "Last Name": "Wall",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578423": {
    "id": "item_11157",
    "Last Name": "Elizondo",
    "First Name": "Luis Diego",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578476": {
    "id": "item_22201",
    "Last Name": "Thomas",
    "First Name": "Tayla",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578487": {
    "id": "item_9347",
    "Last Name": "Cooley",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578495": {
    "id": "item_11122",
    "Last Name": "Niki",
    "First Name": "Tatsuzo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578526": {
    "id": "item_36651",
    "Last Name": "Cochrane",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578528": {
    "id": "item_11154",
    "Last Name": "Wen",
    "First Name": "Fang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578542": {
    "id": "item_36928",
    "Last Name": "Pitsaris",
    "First Name": "Anastacia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578569": {
    "id": "item_34710",
    "Last Name": "Segal",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578618": {
    "id": "item_22202",
    "Last Name": "Gilleland",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578646": {
    "id": "item_36927",
    "Last Name": "Pitsaris",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578650": {
    "id": "item_23908",
    "Last Name": "Jackson",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578669": {
    "id": "item_36926",
    "Last Name": "Forster",
    "First Name": "Kent",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578692": {
    "id": "item_22199",
    "Last Name": "Thompson",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578724": {
    "id": "item_9567",
    "Last Name": "Vincenc",
    "First Name": "Milan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578732": {
    "id": "item_24175",
    "Last Name": "Christensen",
    "First Name": "Chad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578755": {
    "id": "item_23894",
    "Last Name": "Chan",
    "First Name": "Anthony Chee Wee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578795": {
    "id": "item_11151",
    "Last Name": "Fay",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578835": {
    "id": "item_9344",
    "Last Name": "Kim",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578843": {
    "id": "item_36922",
    "Last Name": "Sekulic",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578869": {
    "id": "item_34698",
    "Last Name": "Jacobs",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578891": {
    "id": "item_22440",
    "Last Name": "Browne",
    "First Name": "Kimberley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578894": {
    "id": "item_36649",
    "Last Name": "Hulley",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578895": {
    "id": "item_23906",
    "Last Name": "Chockii",
    "First Name": "Hot",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578947": {
    "id": "item_9341",
    "Last Name": "Carbone",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578959": {
    "id": "item_22193",
    "Last Name": "Singh",
    "First Name": "Guriqbal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36578993": {
    "id": "item_34707",
    "Last Name": "Caraballo",
    "First Name": "Clarence",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579002": {
    "id": "item_22439",
    "Last Name": "Scandlyn",
    "First Name": "Viv",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579015": {
    "id": "item_22190",
    "Last Name": "Katsikogianis",
    "First Name": "Nickolas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579033": {
    "id": "item_36645",
    "Last Name": "Chen",
    "First Name": "Daisy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579065": {
    "id": "item_36644",
    "Last Name": "rao",
    "First Name": "Archana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579090": {
    "id": "item_9338",
    "Last Name": "Doohan",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579111": {
    "id": "item_9564",
    "Last Name": "Lei",
    "First Name": "Justo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579155": {
    "id": "item_22437",
    "Last Name": "Fu",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579167": {
    "id": "item_36641",
    "Last Name": "Cox",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579178": {
    "id": "item_9337",
    "Last Name": "Mineo",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579192": {
    "id": "item_22636",
    "Last Name": "Wang",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579217": {
    "id": "item_22436",
    "Last Name": "Santoso",
    "First Name": "Andry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579224": {
    "id": "item_36919",
    "Last Name": "Cron",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579235": {
    "id": "item_23893",
    "Last Name": "Rickerby",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579237": {
    "id": "item_36638",
    "Last Name": "Wilson",
    "First Name": "Cori",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579272": {
    "id": "item_11146",
    "Last Name": "Sathananthan",
    "First Name": "Sankarsana",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579295": {
    "id": "item_9727",
    "Last Name": "Hudson",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579309": {
    "id": "item_9336",
    "Last Name": "Simmonds",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579330": {
    "id": "item_36633",
    "Last Name": "Tan",
    "First Name": "Andy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579351": {
    "id": "item_22185",
    "Last Name": "Tavares",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579368": {
    "id": "item_24073",
    "Last Name": "Mkwananzi",
    "First Name": "Zibusiso",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579373": {
    "id": "item_34794",
    "Last Name": "Ross",
    "First Name": "Holly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579399": {
    "id": "item_22184",
    "Last Name": "Harvey",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579425": {
    "id": "item_23903",
    "Last Name": "Peacock",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579522": {
    "id": "item_23902",
    "Last Name": "Grech",
    "First Name": "Damian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579533": {
    "id": "item_9332",
    "Last Name": "Mehta",
    "First Name": "Manthan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579534": {
    "id": "item_22183",
    "Last Name": "Moradian",
    "First Name": "Afsaneh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579556": {
    "id": "item_34705",
    "Last Name": "McCarthy",
    "First Name": "Sonja",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579589": {
    "id": "item_11117",
    "Last Name": "Files",
    "First Name": "Caleb-Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579620": {
    "id": "item_36630",
    "Last Name": "Larsen",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579628": {
    "id": "item_11141",
    "Last Name": "Ripper",
    "First Name": "Megan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579638": {
    "id": "item_36628",
    "Last Name": "Gonzalez",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579703": {
    "id": "item_36594",
    "Last Name": "Leung",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579708": {
    "id": "item_22433",
    "Last Name": "Poole",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579713": {
    "id": "item_22182",
    "Last Name": "So",
    "First Name": "Gloria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579725": {
    "id": "item_9328",
    "Last Name": "Jollow",
    "First Name": "Ash",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579749": {
    "id": "item_36917",
    "Last Name": "Keeve",
    "First Name": "Thinus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579769": {
    "id": "item_9299",
    "Last Name": "Liu",
    "First Name": "Yingwei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579780": {
    "id": "item_9323",
    "Last Name": "Woodhall",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579828": {
    "id": "item_9298",
    "Last Name": "Chin",
    "First Name": "Keegan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579831": {
    "id": "item_9324",
    "Last Name": "YAN",
    "First Name": "KUAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579838": {
    "id": "item_23899",
    "Last Name": "Prehananto",
    "First Name": "Endra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579852": {
    "id": "item_11344",
    "Last Name": "Dall",
    "First Name": "Katie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579875": {
    "id": "item_11138",
    "Last Name": "Thompson",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579937": {
    "id": "item_11137",
    "Last Name": "Mason",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36579998": {
    "id": "item_9741",
    "Last Name": "Dodd",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580031": {
    "id": "item_11136",
    "Last Name": "Butler",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580047": {
    "id": "item_36611",
    "Last Name": "Anstee",
    "First Name": "Will",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580059": {
    "id": "item_34696",
    "Last Name": "Wang",
    "First Name": "Dan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580075": {
    "id": "item_36610",
    "Last Name": "Kim",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580128": {
    "id": "item_36608",
    "Last Name": "Kiss",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580138": {
    "id": "item_9320",
    "Last Name": "Handley",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580164": {
    "id": "item_36606",
    "Last Name": "Boubbov",
    "First Name": "Janine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580169": {
    "id": "item_9318",
    "Last Name": "Pidgeon",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580199": {
    "id": "item_22172",
    "Last Name": "Berki",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580249": {
    "id": "item_9316",
    "Last Name": "Miller",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580262": {
    "id": "item_36605",
    "Last Name": "Shing",
    "First Name": "Lindsey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580264": {
    "id": "item_9315",
    "Last Name": "Fox",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580271": {
    "id": "item_9558",
    "Last Name": "Batty",
    "First Name": "Carl",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580304": {
    "id": "item_24070",
    "Last Name": "Goodwin",
    "First Name": "Russ",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580315": {
    "id": "item_11130",
    "Last Name": "Quilter",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580318": {
    "id": "item_22171",
    "Last Name": "Lum",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580369": {
    "id": "item_37072",
    "Last Name": "Langdon",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580376": {
    "id": "item_9295",
    "Last Name": "Ly",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580422": {
    "id": "item_11336",
    "Last Name": "Rivera Gallego",
    "First Name": "Juan David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580430": {
    "id": "item_9557",
    "Last Name": "Miller",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580439": {
    "id": "item_11129",
    "Last Name": "Geoghegan",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580465": {
    "id": "item_36911",
    "Last Name": "Hams",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580497": {
    "id": "item_36601",
    "Last Name": "Jenkinson",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580501": {
    "id": "item_22165",
    "Last Name": "Gomes do Nascimento",
    "First Name": "Vinicius",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580505": {
    "id": "item_11492",
    "Last Name": "Stevens",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580520": {
    "id": "item_22163",
    "Last Name": "Ymana",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580539": {
    "id": "item_11339",
    "Last Name": "Braham",
    "First Name": "Elliot",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580591": {
    "id": "item_11127",
    "Last Name": "Sweeney",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580597": {
    "id": "item_9293",
    "Last Name": "Nan",
    "First Name": "Wang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580620": {
    "id": "item_36598",
    "Last Name": "Burnet-Smith",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580628": {
    "id": "item_34791",
    "Last Name": "Cockrum",
    "First Name": "Elise",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580651": {
    "id": "item_9309",
    "Last Name": "Malate",
    "First Name": "Miles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580688": {
    "id": "item_11126",
    "Last Name": "Webster",
    "First Name": "Johnny",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580692": {
    "id": "item_34700",
    "Last Name": "Duguid",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580697": {
    "id": "item_11335",
    "Last Name": "Jaffrey",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580711": {
    "id": "item_22160",
    "Last Name": "Lacanlale",
    "First Name": "Denzel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580718": {
    "id": "item_9554",
    "Last Name": "Owen",
    "First Name": "Ricky",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580722": {
    "id": "item_11124",
    "Last Name": "Barham",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580724": {
    "id": "item_22158",
    "Last Name": "Herbert",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580733": {
    "id": "item_11125",
    "Last Name": "O Mahony",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580740": {
    "id": "item_22614",
    "Last Name": "Murphy",
    "First Name": "Morakot",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580752": {
    "id": "item_9553",
    "Last Name": "Fitzgerald",
    "First Name": "Wade",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580759": {
    "id": "item_37071",
    "Last Name": "Cole",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580768": {
    "id": "item_11491",
    "Last Name": "Barham",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580778": {
    "id": "item_34699",
    "Last Name": "Patrick",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580820": {
    "id": "item_11121",
    "Last Name": "Temmo",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580835": {
    "id": "item_22157",
    "Last Name": "Williamson",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580847": {
    "id": "item_36909",
    "Last Name": "Casana",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580858": {
    "id": "item_22156",
    "Last Name": "Peiris",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580865": {
    "id": "item_11490",
    "Last Name": "Korotkich",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580887": {
    "id": "item_36908",
    "Last Name": "Ng",
    "First Name": "Sherene",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580890": {
    "id": "item_9305",
    "Last Name": "Fraser",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580908": {
    "id": "item_36906",
    "Last Name": "Wheaton",
    "First Name": "Tania",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580928": {
    "id": "item_23892",
    "Last Name": "Oboyle",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580931": {
    "id": "item_9302",
    "Last Name": "Delahunty",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580964": {
    "id": "item_11116",
    "Last Name": "Baigent",
    "First Name": "Derek",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36580970": {
    "id": "item_11118",
    "Last Name": "Neylan",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581008": {
    "id": "item_22155",
    "Last Name": "Byrne",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581036": {
    "id": "item_36593",
    "Last Name": "MacCallum",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581046": {
    "id": "item_24068",
    "Last Name": "Narwani",
    "First Name": "Himanshu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581089": {
    "id": "item_9297",
    "Last Name": "Lee",
    "First Name": "Jeongyun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581111": {
    "id": "item_36592",
    "Last Name": "Rigby",
    "First Name": "Annette",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581119": {
    "id": "item_24067",
    "Last Name": "Li",
    "First Name": "Chen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581127": {
    "id": "item_22153",
    "Last Name": "Yates",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581139": {
    "id": "item_11113",
    "Last Name": "HU",
    "First Name": "XIUYING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581143": {
    "id": "item_36589",
    "Last Name": "Hernanta",
    "First Name": "Malvin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581146": {
    "id": "item_11114",
    "Last Name": "Andrews",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581148": {
    "id": "item_36590",
    "Last Name": "Chua",
    "First Name": "Selena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581189": {
    "id": "item_36591",
    "Last Name": "yu",
    "First Name": "Branko",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581206": {
    "id": "item_9292",
    "Last Name": "Xu",
    "First Name": "Zhangyu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581208": {
    "id": "item_22152",
    "Last Name": "Denton",
    "First Name": "Milly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581233": {
    "id": "item_9291",
    "Last Name": "Tran",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581259": {
    "id": "item_36587",
    "Last Name": "Ngo",
    "First Name": "Liem",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581296": {
    "id": "item_22149",
    "Last Name": "Yu",
    "First Name": "Wei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581300": {
    "id": "item_37070",
    "Last Name": "Baker",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581341": {
    "id": "item_36903",
    "Last Name": "Warwick",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581342": {
    "id": "item_36586",
    "Last Name": "MENGPING",
    "First Name": "XIAO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581368": {
    "id": "item_36583",
    "Last Name": "Jaura",
    "First Name": "Kuldip Singh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581376": {
    "id": "item_36584",
    "Last Name": "Joshi",
    "First Name": "Shree Ram",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581400": {
    "id": "item_9288",
    "Last Name": "Chapman",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581409": {
    "id": "item_11332",
    "Last Name": "Allen",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581448": {
    "id": "item_36579",
    "Last Name": "Singh",
    "First Name": "Sukhwant",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581479": {
    "id": "item_11111",
    "Last Name": "Chai Jun Hoe",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581504": {
    "id": "item_36578",
    "Last Name": "Longden",
    "First Name": "Jean",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581513": {
    "id": "item_11106",
    "Last Name": "Zhao",
    "First Name": "Peng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581519": {
    "id": "item_34790",
    "Last Name": "Roberts",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581545": {
    "id": "item_23890",
    "Last Name": "Ng",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581583": {
    "id": "item_23888",
    "Last Name": "Chesterman",
    "First Name": "Miya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581600": {
    "id": "item_22613",
    "Last Name": "Friend",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581613": {
    "id": "item_22144",
    "Last Name": "Galvin",
    "First Name": "Conor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581637": {
    "id": "item_36575",
    "Last Name": "Lissenden",
    "First Name": "Max",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581641": {
    "id": "item_9285",
    "Last Name": "Mitchell",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581650": {
    "id": "item_23887",
    "Last Name": "Lloyd",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581659": {
    "id": "item_34851",
    "Last Name": "Araujo",
    "First Name": "Lili",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581670": {
    "id": "item_11105",
    "Last Name": "Barton",
    "First Name": "Isabel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581680": {
    "id": "item_23886",
    "Last Name": "Marks",
    "First Name": "Y",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581688": {
    "id": "item_36573",
    "Last Name": "McPherson",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581706": {
    "id": "item_11329",
    "Last Name": "Martini",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581735": {
    "id": "item_11110",
    "Last Name": "A Pimp",
    "First Name": "I am",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581739": {
    "id": "item_22417",
    "Last Name": "Villa",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581760": {
    "id": "item_11103",
    "Last Name": "XU",
    "First Name": "Gang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581765": {
    "id": "item_36570",
    "Last Name": "CHI",
    "First Name": "YANHUI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581799": {
    "id": "item_24065",
    "Last Name": "O'Brien",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581831": {
    "id": "item_22138",
    "Last Name": "Suraweera",
    "First Name": "Navod",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581836": {
    "id": "item_11109",
    "Last Name": "Chou",
    "First Name": "Han-Chung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581846": {
    "id": "item_9282",
    "Last Name": "O'brien",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581848": {
    "id": "item_22148",
    "Last Name": "Baerlocher",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581858": {
    "id": "item_9281",
    "Last Name": "Zhu",
    "First Name": "Levi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581865": {
    "id": "item_36898",
    "Last Name": "Bryan",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581879": {
    "id": "item_11327",
    "Last Name": "Martin",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581881": {
    "id": "item_9549",
    "Last Name": "Wegener",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581944": {
    "id": "item_37069",
    "Last Name": "Francis",
    "First Name": "Alissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581960": {
    "id": "item_11101",
    "Last Name": "Vuong",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581962": {
    "id": "item_24062",
    "Last Name": "Tritton",
    "First Name": "Brent",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581977": {
    "id": "item_34690",
    "Last Name": "Trevallion",
    "First Name": "Cate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581978": {
    "id": "item_36895",
    "Last Name": "Fowles",
    "First Name": "Shane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581981": {
    "id": "item_22612",
    "Last Name": "Lambert",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581987": {
    "id": "item_9547",
    "Last Name": "Woods",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581989": {
    "id": "item_34787",
    "Last Name": "Impellizzeri",
    "First Name": "Patrice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581994": {
    "id": "item_34858",
    "Last Name": "White",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581996": {
    "id": "item_22135",
    "Last Name": "Hayes",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36581998": {
    "id": "item_36892",
    "Last Name": "Duffin",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582001": {
    "id": "item_22132",
    "Last Name": "Lam",
    "First Name": "Andre",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582002": {
    "id": "item_36894",
    "Last Name": "Duffin",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582008": {
    "id": "item_22635",
    "Last Name": "Flemming",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582011": {
    "id": "item_22133",
    "Last Name": "Teh",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582024": {
    "id": "item_36581",
    "Last Name": "Missen",
    "First Name": "Valentina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582062": {
    "id": "item_36565",
    "Last Name": "Calejesan",
    "First Name": "Maria Rissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582079": {
    "id": "item_36564",
    "Last Name": "Ip",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582091": {
    "id": "item_36580",
    "Last Name": "Tyrrell",
    "First Name": "Grant",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582098": {
    "id": "item_9279",
    "Last Name": "Rafagnin",
    "First Name": "Matheus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582105": {
    "id": "item_11100",
    "Last Name": "Bumstead",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582108": {
    "id": "item_9545",
    "Last Name": "Walsh",
    "First Name": "Zane",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582110": {
    "id": "item_36563",
    "Last Name": "Rose",
    "First Name": "Mia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582113": {
    "id": "item_36891",
    "Last Name": "Andrea",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582118": {
    "id": "item_22128",
    "Last Name": "Dahal",
    "First Name": "Sudarshan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582134": {
    "id": "item_11108",
    "Last Name": "Zhang",
    "First Name": "Xiang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582143": {
    "id": "item_36562",
    "Last Name": "McDonald",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582150": {
    "id": "item_22611",
    "Last Name": "Ratcliffe",
    "First Name": "Joey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582185": {
    "id": "item_36890",
    "Last Name": "Impellizzeri",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582200": {
    "id": "item_36558",
    "Last Name": "Bisset",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582213": {
    "id": "item_36556",
    "Last Name": "McGuire",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582238": {
    "id": "item_24058",
    "Last Name": "Sion",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582246": {
    "id": "item_9275",
    "Last Name": "Silva",
    "First Name": "Luis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582260": {
    "id": "item_37068",
    "Last Name": "Workman",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582261": {
    "id": "item_22610",
    "Last Name": "Fitzsimmons",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582267": {
    "id": "item_11325",
    "Last Name": "Smitheram",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582286": {
    "id": "item_36888",
    "Last Name": "Smith",
    "First Name": "Bec",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582306": {
    "id": "item_9273",
    "Last Name": "Burnett",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582314": {
    "id": "item_9272",
    "Last Name": "McCullough",
    "First Name": "Kris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582325": {
    "id": "item_34686",
    "Last Name": "Guo",
    "First Name": "Youqing",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582344": {
    "id": "item_22120",
    "Last Name": "Shum",
    "First Name": "Gordon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582353": {
    "id": "item_24057",
    "Last Name": "Robertson",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582354": {
    "id": "item_11095",
    "Last Name": "Spurr",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582364": {
    "id": "item_22119",
    "Last Name": "Ormes",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582390": {
    "id": "item_22116",
    "Last Name": "Wong",
    "First Name": "Freeman",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582391": {
    "id": "item_22145",
    "Last Name": "Adhiguna",
    "First Name": "Angga",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582399": {
    "id": "item_36549",
    "Last Name": "Goodwin",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582419": {
    "id": "item_23889",
    "Last Name": "Wongtangman",
    "First Name": "Thiti",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582441": {
    "id": "item_36548",
    "Last Name": "Koelmeyer",
    "First Name": "Kirk",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582446": {
    "id": "item_11321",
    "Last Name": "Roberts",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582474": {
    "id": "item_11093",
    "Last Name": "Wang",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582483": {
    "id": "item_37067",
    "Last Name": "Crowe",
    "First Name": "Abbie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582488": {
    "id": "item_23879",
    "Last Name": "Hing",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582494": {
    "id": "item_22609",
    "Last Name": "Stewart",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582498": {
    "id": "item_23877",
    "Last Name": "Guerriero",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582504": {
    "id": "item_9267",
    "Last Name": "Topak",
    "First Name": "Vedat",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582510": {
    "id": "item_22634",
    "Last Name": "SMYTH",
    "First Name": "CHARMAINE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582511": {
    "id": "item_36544",
    "Last Name": "Lambino",
    "First Name": "Jun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582517": {
    "id": "item_36543",
    "Last Name": "Data",
    "First Name": "Earll Justin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582519": {
    "id": "item_23874",
    "Last Name": "Khoury",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582525": {
    "id": "item_9264",
    "Last Name": "Howard",
    "First Name": "Lew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582535": {
    "id": "item_22112",
    "Last Name": "Peters",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582538": {
    "id": "item_11489",
    "Last Name": "Shibble",
    "First Name": "Elton",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582550": {
    "id": "item_36542",
    "Last Name": "Bird",
    "First Name": "Maya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582564": {
    "id": "item_23873",
    "Last Name": "Butler",
    "First Name": "Wray",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582570": {
    "id": "item_9263",
    "Last Name": "Watkins",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582576": {
    "id": "item_24054",
    "Last Name": "Vilsten",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582595": {
    "id": "item_22409",
    "Last Name": "Wishart",
    "First Name": "Phil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582605": {
    "id": "item_36538",
    "Last Name": "Wolf",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582607": {
    "id": "item_23871",
    "Last Name": "Slater",
    "First Name": "Bernadette",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582626": {
    "id": "item_24052",
    "Last Name": "Drummond",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582648": {
    "id": "item_22110",
    "Last Name": "Hodges",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582655": {
    "id": "item_22108",
    "Last Name": "Haselroither",
    "First Name": "Helmut",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582664": {
    "id": "item_11320",
    "Last Name": "Roughton",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582670": {
    "id": "item_22107",
    "Last Name": "Organ",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582674": {
    "id": "item_34682",
    "Last Name": "Cruz",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582700": {
    "id": "item_9256",
    "Last Name": "Campbell",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582715": {
    "id": "item_36884",
    "Last Name": "CHAN",
    "First Name": "RAYMOND",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582725": {
    "id": "item_24167",
    "Last Name": "Phillips",
    "First Name": "Aiden",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582735": {
    "id": "item_22143",
    "Last Name": "Hidalgo",
    "First Name": "Antonino",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582739": {
    "id": "item_37066",
    "Last Name": "Salas",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582754": {
    "id": "item_11090",
    "Last Name": "Arraiza",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582761": {
    "id": "item_34694",
    "Last Name": "Lee",
    "First Name": "Mildred",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582770": {
    "id": "item_36883",
    "Last Name": "Bowman-derrick",
    "First Name": "Felix",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582772": {
    "id": "item_22405",
    "Last Name": "Tran",
    "First Name": "Anh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582800": {
    "id": "item_24166",
    "Last Name": "Christodoulou",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582804": {
    "id": "item_9255",
    "Last Name": "Muncey",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582806": {
    "id": "item_36574",
    "Last Name": "Dela Serna",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582816": {
    "id": "item_9254",
    "Last Name": "Plohl",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582831": {
    "id": "item_24050",
    "Last Name": "Langley",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582832": {
    "id": "item_9252",
    "Last Name": "Tiller",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582842": {
    "id": "item_36529",
    "Last Name": "Arena",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582852": {
    "id": "item_36528",
    "Last Name": "Cameron",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582856": {
    "id": "item_34681",
    "Last Name": "Lim",
    "First Name": "Tommy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582857": {
    "id": "item_22098",
    "Last Name": "Hird",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582860": {
    "id": "item_9251",
    "Last Name": "Mulally",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582861": {
    "id": "item_9250",
    "Last Name": "Fotopoulos",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582867": {
    "id": "item_11104",
    "Last Name": "Skeivoll",
    "First Name": "Kjell Tore",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582875": {
    "id": "item_11319",
    "Last Name": "Karsten",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582884": {
    "id": "item_22094",
    "Last Name": "Abignano",
    "First Name": "Antoni",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582887": {
    "id": "item_23865",
    "Last Name": "Dadic",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582922": {
    "id": "item_11082",
    "Last Name": "Wilkins",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582924": {
    "id": "item_9538",
    "Last Name": "Ludhwani",
    "First Name": "Tarun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582925": {
    "id": "item_24048",
    "Last Name": "Gleich",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582928": {
    "id": "item_9539",
    "Last Name": "Vogelzang",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582936": {
    "id": "item_9248",
    "Last Name": "Jones",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582940": {
    "id": "item_22092",
    "Last Name": "Shaw",
    "First Name": "Leighton",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582956": {
    "id": "item_36572",
    "Last Name": "Leng",
    "First Name": "Chyi Bin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582986": {
    "id": "item_11080",
    "Last Name": "Graham",
    "First Name": "Ken",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582991": {
    "id": "item_11079",
    "Last Name": "Chen",
    "First Name": "Yongliang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36582995": {
    "id": "item_22400",
    "Last Name": "Goodacre",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583006": {
    "id": "item_22090",
    "Last Name": "Gillet",
    "First Name": "Enguerran",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583012": {
    "id": "item_34679",
    "Last Name": "Harrington",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583030": {
    "id": "item_37065",
    "Last Name": "Riordan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583036": {
    "id": "item_11488",
    "Last Name": "Cooke",
    "First Name": "Alastair",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583037": {
    "id": "item_22398",
    "Last Name": "Karajian",
    "First Name": "Suzi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583039": {
    "id": "item_24043",
    "Last Name": "Harcombe",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583041": {
    "id": "item_11316",
    "Last Name": "Tang",
    "First Name": "Yu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583042": {
    "id": "item_22086",
    "Last Name": "Middleton",
    "First Name": "Jarrad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583043": {
    "id": "item_22087",
    "Last Name": "Westhuizen",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583056": {
    "id": "item_36523",
    "Last Name": "Johnston",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583086": {
    "id": "item_9245",
    "Last Name": "McGarry",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583098": {
    "id": "item_23858",
    "Last Name": "Lychagin",
    "First Name": "Alexey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583101": {
    "id": "item_34783",
    "Last Name": "Piasco",
    "First Name": "Fabrizio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583109": {
    "id": "item_37064",
    "Last Name": "Riordan",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583113": {
    "id": "item_36569",
    "Last Name": "Park",
    "First Name": "Sung Jin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583115": {
    "id": "item_22084",
    "Last Name": "Wynn",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583117": {
    "id": "item_36518",
    "Last Name": "LLADO",
    "First Name": "ANTONIO REAL",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583119": {
    "id": "item_11314",
    "Last Name": "Tran",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583120": {
    "id": "item_34782",
    "Last Name": "French",
    "First Name": "Leonie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583122": {
    "id": "item_9535",
    "Last Name": "Roqica",
    "First Name": "Emerson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583123": {
    "id": "item_36879",
    "Last Name": "Russ",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583128": {
    "id": "item_11074",
    "Last Name": "Donohue",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583131": {
    "id": "item_11311",
    "Last Name": "Williams",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583135": {
    "id": "item_11313",
    "Last Name": "Gimbert",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583136": {
    "id": "item_22083",
    "Last Name": "ISHIKAWA",
    "First Name": "HIDENORI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583144": {
    "id": "item_9242",
    "Last Name": "Murray",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583147": {
    "id": "item_22394",
    "Last Name": "Stanford",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583148": {
    "id": "item_36516",
    "Last Name": "Mutowembwa",
    "First Name": "TAMBURAI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583156": {
    "id": "item_9726",
    "Last Name": "Woolley",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583165": {
    "id": "item_22082",
    "Last Name": "Cheng",
    "First Name": "Wing Kai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583170": {
    "id": "item_36514",
    "Last Name": "Fawcett Palma",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583176": {
    "id": "item_36877",
    "Last Name": "Li",
    "First Name": "Dongmei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583179": {
    "id": "item_22081",
    "Last Name": "Evans",
    "First Name": "Bron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583182": {
    "id": "item_36876",
    "Last Name": "NEIMANIS",
    "First Name": "KATHLEEN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583193": {
    "id": "item_23857",
    "Last Name": "Ghosh",
    "First Name": "Anirban",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583209": {
    "id": "item_22079",
    "Last Name": "Kelly",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583211": {
    "id": "item_22393",
    "Last Name": "Player",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583223": {
    "id": "item_9533",
    "Last Name": "Payne",
    "First Name": "Quan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583238": {
    "id": "item_9283",
    "Last Name": "ruan",
    "First Name": "zheng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583244": {
    "id": "item_36513",
    "Last Name": "Tarau",
    "First Name": "Tori",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583247": {
    "id": "item_11067",
    "Last Name": "Lees",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583262": {
    "id": "item_34781",
    "Last Name": "Moloney",
    "First Name": "Suzie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583264": {
    "id": "item_9237",
    "Last Name": "Beaton",
    "First Name": "Acacia",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583266": {
    "id": "item_36873",
    "Last Name": "Kok",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583273": {
    "id": "item_22078",
    "Last Name": "Berriman",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583281": {
    "id": "item_36872",
    "Last Name": "Topham",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583282": {
    "id": "item_34780",
    "Last Name": "Klomp",
    "First Name": "Nick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583287": {
    "id": "item_24039",
    "Last Name": "Brock",
    "First Name": "Kane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583290": {
    "id": "item_9236",
    "Last Name": "Kam",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583291": {
    "id": "item_22608",
    "Last Name": "Robertson",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583293": {
    "id": "item_22077",
    "Last Name": "Cabacungan",
    "First Name": "Jomar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583298": {
    "id": "item_36508",
    "Last Name": "Dyszel",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583313": {
    "id": "item_11062",
    "Last Name": "Stewart",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583331": {
    "id": "item_11487",
    "Last Name": "Reedy",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583332": {
    "id": "item_9234",
    "Last Name": "Tran",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583338": {
    "id": "item_9531",
    "Last Name": "Cooke",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583351": {
    "id": "item_22140",
    "Last Name": "Aggus",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583369": {
    "id": "item_11486",
    "Last Name": "Jarman",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583371": {
    "id": "item_9530",
    "Last Name": "HONG",
    "First Name": "SEUNGGIL",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583374": {
    "id": "item_11061",
    "Last Name": "Dang",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583383": {
    "id": "item_11307",
    "Last Name": "Kelly",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583399": {
    "id": "item_9231",
    "Last Name": "Legget",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583401": {
    "id": "item_22073",
    "Last Name": "Morse",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583402": {
    "id": "item_23885",
    "Last Name": "Parardya",
    "First Name": "Aga",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583406": {
    "id": "item_37063",
    "Last Name": "Tipler",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583409": {
    "id": "item_36505",
    "Last Name": "Moore",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583418": {
    "id": "item_34675",
    "Last Name": "Betts",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583438": {
    "id": "item_34779",
    "Last Name": "McDougall",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583442": {
    "id": "item_24037",
    "Last Name": "Kidon",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583459": {
    "id": "item_22071",
    "Last Name": "Chung",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583468": {
    "id": "item_22068",
    "Last Name": "Wolff",
    "First Name": "Rubert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583476": {
    "id": "item_11057",
    "Last Name": "Liu",
    "First Name": "Xingzhong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583482": {
    "id": "item_36503",
    "Last Name": "Clark",
    "First Name": "Steve",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583486": {
    "id": "item_11055",
    "Last Name": "Trieu",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583503": {
    "id": "item_36501",
    "Last Name": "Reilly",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583508": {
    "id": "item_9228",
    "Last Name": "Davis",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583514": {
    "id": "item_11054",
    "Last Name": "Williams",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583544": {
    "id": "item_11485",
    "Last Name": "Gillis",
    "First Name": "Jane",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583551": {
    "id": "item_22607",
    "Last Name": "Lindsay",
    "First Name": "Cam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583564": {
    "id": "item_22388",
    "Last Name": "Aynsley",
    "First Name": "Deane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583566": {
    "id": "item_11304",
    "Last Name": "Dinh",
    "First Name": "Quan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583575": {
    "id": "item_9227",
    "Last Name": "Orr",
    "First Name": "Toby",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583577": {
    "id": "item_9525",
    "Last Name": "Nihei",
    "First Name": "Kotaro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583579": {
    "id": "item_37062",
    "Last Name": "Wood",
    "First Name": "Murray",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583590": {
    "id": "item_36496",
    "Last Name": "Tani",
    "First Name": "HIROMICHI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583591": {
    "id": "item_9725",
    "Last Name": "Downs",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583636": {
    "id": "item_23846",
    "Last Name": "Musumeci",
    "First Name": "Silvestro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583641": {
    "id": "item_22606",
    "Last Name": "Roberts-Thomson",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583648": {
    "id": "item_22059",
    "Last Name": "Sach",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583650": {
    "id": "item_36493",
    "Last Name": "Hu",
    "First Name": "Zeke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583652": {
    "id": "item_36867",
    "Last Name": "Mikusek",
    "First Name": "Jiri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583655": {
    "id": "item_22058",
    "Last Name": "Yan",
    "First Name": "Norman",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583658": {
    "id": "item_11049",
    "Last Name": "XU",
    "First Name": "Hua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583663": {
    "id": "item_36866",
    "Last Name": "Chuc",
    "First Name": "Chau",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583686": {
    "id": "item_24036",
    "Last Name": "Lindenmayer",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583688": {
    "id": "item_36491",
    "Last Name": "Barnsley",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583696": {
    "id": "item_9724",
    "Last Name": "Page",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583697": {
    "id": "item_11048",
    "Last Name": "Sheppard",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583710": {
    "id": "item_36863",
    "Last Name": "Onny",
    "First Name": "Gems",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583714": {
    "id": "item_11046",
    "Last Name": "Skalski Bilek",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583724": {
    "id": "item_24035",
    "Last Name": "Sibanda",
    "First Name": "Shillar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583761": {
    "id": "item_36567",
    "Last Name": "Jarmin",
    "First Name": "Martin Jeremiah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583765": {
    "id": "item_9521",
    "Last Name": "Stone",
    "First Name": "Cory",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583768": {
    "id": "item_36489",
    "Last Name": "Attard",
    "First Name": "Julian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583769": {
    "id": "item_11045",
    "Last Name": "ROUAUD",
    "First Name": "Marc-Alexandre",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583776": {
    "id": "item_36488",
    "Last Name": "Xu",
    "First Name": "Sheng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583777": {
    "id": "item_11043",
    "Last Name": "Rosenbaum",
    "First Name": "Neil",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583778": {
    "id": "item_24034",
    "Last Name": "Lau",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583788": {
    "id": "item_36861",
    "Last Name": "Leung",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583796": {
    "id": "item_22054",
    "Last Name": "So",
    "First Name": "Ho Pan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583816": {
    "id": "item_37061",
    "Last Name": "Lee",
    "First Name": "Lok Heng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583850": {
    "id": "item_23884",
    "Last Name": "CHUA",
    "First Name": "PUI YU",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583851": {
    "id": "item_34670",
    "Last Name": "Williams",
    "First Name": "Dianne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583855": {
    "id": "item_22385",
    "Last Name": "Nguyen",
    "First Name": "Quan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583864": {
    "id": "item_22384",
    "Last Name": "Koh",
    "First Name": "Joo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583865": {
    "id": "item_23844",
    "Last Name": "Keetels",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583886": {
    "id": "item_11039",
    "Last Name": "Tamura",
    "First Name": "Yuki",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583896": {
    "id": "item_11038",
    "Last Name": "Garibay Lara",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583944": {
    "id": "item_36566",
    "Last Name": "Shadwell",
    "First Name": "Pui-See",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583957": {
    "id": "item_24033",
    "Last Name": "Wong",
    "First Name": "Chun Keung",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583960": {
    "id": "item_23840",
    "Last Name": "Galvis Martinez",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36583995": {
    "id": "item_34778",
    "Last Name": "Potts",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584007": {
    "id": "item_24032",
    "Last Name": "Nichol",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584014": {
    "id": "item_36483",
    "Last Name": "Hands",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584033": {
    "id": "item_34668",
    "Last Name": "Lui",
    "First Name": "Lily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584037": {
    "id": "item_11032",
    "Last Name": "Zhou",
    "First Name": "Kangrui",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584048": {
    "id": "item_22382",
    "Last Name": "Phillips",
    "First Name": "Sue",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584056": {
    "id": "item_9513",
    "Last Name": "Carter",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584096": {
    "id": "item_22381",
    "Last Name": "Schwarz",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584113": {
    "id": "item_11303",
    "Last Name": "Stephens",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584157": {
    "id": "item_36857",
    "Last Name": "Young",
    "First Name": "Liz",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584159": {
    "id": "item_22045",
    "Last Name": "Breytenbach",
    "First Name": "Charlene",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584165": {
    "id": "item_23839",
    "Last Name": "Chung",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584172": {
    "id": "item_22044",
    "Last Name": "Reza",
    "First Name": "Abid",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584245": {
    "id": "item_11029",
    "Last Name": "Strutt",
    "First Name": "Anneli",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584269": {
    "id": "item_9219",
    "Last Name": "Heavey",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584288": {
    "id": "item_22136",
    "Last Name": "Chavez Rojas",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584316": {
    "id": "item_11028",
    "Last Name": "Wu",
    "First Name": "Haoming",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584342": {
    "id": "item_9511",
    "Last Name": "LI",
    "First Name": "JINGJING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584351": {
    "id": "item_36476",
    "Last Name": "Jatukannyaprateep",
    "First Name": "Pariyawit",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584384": {
    "id": "item_23881",
    "Last Name": "arnold",
    "First Name": "febry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584421": {
    "id": "item_23837",
    "Last Name": "Chan",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584442": {
    "id": "item_36856",
    "Last Name": "Ward",
    "First Name": "Naaman",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584514": {
    "id": "item_34689",
    "Last Name": "Whitaker",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584530": {
    "id": "item_22042",
    "Last Name": "PARK",
    "First Name": "JINWOO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584588": {
    "id": "item_24029",
    "Last Name": "Skeen",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584590": {
    "id": "item_36854",
    "Last Name": "Deschamps",
    "First Name": "Renee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584642": {
    "id": "item_22379",
    "Last Name": "Tam",
    "First Name": "Yin Hong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584666": {
    "id": "item_36473",
    "Last Name": "Charoenwacharavit",
    "First Name": "Louis",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36584984": {
    "id": "item_34774",
    "Last Name": "Streim",
    "First Name": "Brigitte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585198": {
    "id": "item_22131",
    "Last Name": "Chiang",
    "First Name": "Chee Keong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585228": {
    "id": "item_36853",
    "Last Name": "Bartlett",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585236": {
    "id": "item_22130",
    "Last Name": "Ongkowijoyo",
    "First Name": "Ronny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585301": {
    "id": "item_9278",
    "Last Name": "WEI SHENG",
    "First Name": "ONG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585566": {
    "id": "item_36470",
    "Last Name": "Chen",
    "First Name": "Denghui",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585651": {
    "id": "item_36561",
    "Last Name": "Nugraha",
    "First Name": "Johan Adi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36585693": {
    "id": "item_22127",
    "Last Name": "Muhammad",
    "First Name": "Razali",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586032": {
    "id": "item_36560",
    "Last Name": "Katsuno Hayashikawa",
    "First Name": "Maki",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586288": {
    "id": "item_36559",
    "Last Name": "Liang",
    "First Name": "Ming-Hsin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586394": {
    "id": "item_36557",
    "Last Name": "Tseng",
    "First Name": "Yu-Wei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586748": {
    "id": "item_36851",
    "Last Name": "Chiu",
    "First Name": "Cheuk Fung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36586825": {
    "id": "item_36555",
    "Last Name": "RONG",
    "First Name": "YUEYING",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36587439": {
    "id": "item_22125",
    "Last Name": "Kwok",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36587469": {
    "id": "item_34857",
    "Last Name": "Wetters",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36587568": {
    "id": "item_34688",
    "Last Name": "Haffey",
    "First Name": "Bill",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36588202": {
    "id": "item_11025",
    "Last Name": "Meyer",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36588492": {
    "id": "item_36553",
    "Last Name": "Siino",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36588788": {
    "id": "item_11024",
    "Last Name": "Raiman",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36590881": {
    "id": "item_22633",
    "Last Name": "Cunningham",
    "First Name": "Carol",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36591265": {
    "id": "item_22377",
    "Last Name": "Charlton",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36591666": {
    "id": "item_9274",
    "Last Name": "Ross",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36591906": {
    "id": "item_36850",
    "Last Name": "Berglund",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36591978": {
    "id": "item_22123",
    "Last Name": "Murphy",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592042": {
    "id": "item_34665",
    "Last Name": "Keur",
    "First Name": "Antal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592147": {
    "id": "item_11298",
    "Last Name": "Mcgrath",
    "First Name": "Trent",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592181": {
    "id": "item_36468",
    "Last Name": "bootle",
    "First Name": "brian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592229": {
    "id": "item_22605",
    "Last Name": "Strachan",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592477": {
    "id": "item_9216",
    "Last Name": "Moore",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592632": {
    "id": "item_36467",
    "Last Name": "Nguyen",
    "First Name": "Ngoc Anh Duy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592857": {
    "id": "item_9215",
    "Last Name": "Roff",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592874": {
    "id": "item_36848",
    "Last Name": "Beecher",
    "First Name": "Mia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36592963": {
    "id": "item_36463",
    "Last Name": "Mohd Radzuan",
    "First Name": "Amirul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593311": {
    "id": "item_22375",
    "Last Name": "Guppy",
    "First Name": "Rob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593588": {
    "id": "item_11018",
    "Last Name": "Watney",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593693": {
    "id": "item_34664",
    "Last Name": "Burton",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593707": {
    "id": "item_22031",
    "Last Name": "Wang",
    "First Name": "Di",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593779": {
    "id": "item_22604",
    "Last Name": "Parry",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593803": {
    "id": "item_11484",
    "Last Name": "Richardson",
    "First Name": "Leon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36593871": {
    "id": "item_22603",
    "Last Name": "Joubert",
    "First Name": "Imke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594006": {
    "id": "item_22374",
    "Last Name": "MacGregor",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594033": {
    "id": "item_9214",
    "Last Name": "Emery",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594044": {
    "id": "item_22029",
    "Last Name": "Heymann",
    "First Name": "Anton",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594202": {
    "id": "item_22602",
    "Last Name": "Reed",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594306": {
    "id": "item_36457",
    "Last Name": "Tomasella",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594465": {
    "id": "item_36456",
    "Last Name": "Redwood",
    "First Name": "Graham",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594478": {
    "id": "item_36455",
    "Last Name": "Das",
    "First Name": "Niloy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594557": {
    "id": "item_36845",
    "Last Name": "Ng",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594558": {
    "id": "item_34772",
    "Last Name": "McKechnie",
    "First Name": "Prudence",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594559": {
    "id": "item_11010",
    "Last Name": "Cigana",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594585": {
    "id": "item_22028",
    "Last Name": "Lee",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594650": {
    "id": "item_11483",
    "Last Name": "Cato",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594688": {
    "id": "item_36453",
    "Last Name": "Li",
    "First Name": "Shen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594719": {
    "id": "item_9209",
    "Last Name": "Longman",
    "First Name": "Huw",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594796": {
    "id": "item_36452",
    "Last Name": "Nguyen",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36594895": {
    "id": "item_22121",
    "Last Name": "Shahim",
    "First Name": "Iman",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595055": {
    "id": "item_36843",
    "Last Name": "MASAUD",
    "First Name": "MUHAMMAD",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595091": {
    "id": "item_9208",
    "Last Name": "Williams",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595150": {
    "id": "item_34659",
    "Last Name": "Wong",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595175": {
    "id": "item_11008",
    "Last Name": "Filizzola",
    "First Name": "Juan Pablo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595236": {
    "id": "item_37060",
    "Last Name": "Shawcross",
    "First Name": "Brad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595280": {
    "id": "item_22371",
    "Last Name": "Leong",
    "First Name": "Yong Jin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595303": {
    "id": "item_34685",
    "Last Name": "Kuhlman",
    "First Name": "Stig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595315": {
    "id": "item_34684",
    "Last Name": "Kuhlman",
    "First Name": "Ella Lissner",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595327": {
    "id": "item_11007",
    "Last Name": "Wang",
    "First Name": "Yu-Yun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595478": {
    "id": "item_34657",
    "Last Name": "Nisbet",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595539": {
    "id": "item_23828",
    "Last Name": "Brickett",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595541": {
    "id": "item_22024",
    "Last Name": "Huynh",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595550": {
    "id": "item_37059",
    "Last Name": "Armstrong",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595588": {
    "id": "item_22601",
    "Last Name": "Fowler",
    "First Name": "Oli",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595589": {
    "id": "item_22023",
    "Last Name": "Hughes",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595676": {
    "id": "item_36840",
    "Last Name": "Mahendran",
    "First Name": "Karti",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595710": {
    "id": "item_34654",
    "Last Name": "Solomon",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595766": {
    "id": "item_9504",
    "Last Name": "Miles",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595790": {
    "id": "item_9205",
    "Last Name": "Derrick",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595894": {
    "id": "item_11005",
    "Last Name": "Gonzalo",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595907": {
    "id": "item_22020",
    "Last Name": "Chan",
    "First Name": "Kev",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595934": {
    "id": "item_9202",
    "Last Name": "Kelter",
    "First Name": "Maurice",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595946": {
    "id": "item_22019",
    "Last Name": "Petrie",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36595984": {
    "id": "item_9502",
    "Last Name": "Ferris",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596093": {
    "id": "item_22018",
    "Last Name": "Colton",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596119": {
    "id": "item_22370",
    "Last Name": "Sim",
    "First Name": "Ji Hoong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596146": {
    "id": "item_36839",
    "Last Name": "Atkins",
    "First Name": "Faith",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596151": {
    "id": "item_9501",
    "Last Name": "Davey",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596177": {
    "id": "item_9271",
    "Last Name": "Galindo",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596180": {
    "id": "item_23827",
    "Last Name": "Cohen",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596247": {
    "id": "item_9499",
    "Last Name": "Braver",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596316": {
    "id": "item_22118",
    "Last Name": "Fitzpatrick",
    "First Name": "Damien",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596358": {
    "id": "item_24024",
    "Last Name": "Ranasinghe",
    "First Name": "Duminda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596374": {
    "id": "item_22016",
    "Last Name": "Tomal",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596416": {
    "id": "item_34646",
    "Last Name": "Noble",
    "First Name": "Agnete",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596436": {
    "id": "item_34647",
    "Last Name": "Xie",
    "First Name": "Zhiyong (Jason)",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596465": {
    "id": "item_22369",
    "Last Name": "Gaylor",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596520": {
    "id": "item_11004",
    "Last Name": "Hogg",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596699": {
    "id": "item_22586",
    "Last Name": "Fear",
    "First Name": "Phoebe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596872": {
    "id": "item_24165",
    "Last Name": "Sunderland",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596877": {
    "id": "item_11471",
    "Last Name": "cheng",
    "First Name": "Yijie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36596927": {
    "id": "item_22585",
    "Last Name": "Gutierrez",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597253": {
    "id": "item_22363",
    "Last Name": "Shi",
    "First Name": "Minhao",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597363": {
    "id": "item_34846",
    "Last Name": "Seeto",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597450": {
    "id": "item_9714",
    "Last Name": "Cohen",
    "First Name": "Gary",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597469": {
    "id": "item_9713",
    "Last Name": "Jackson",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597646": {
    "id": "item_9494",
    "Last Name": "Stacey",
    "First Name": "Dainah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597678": {
    "id": "item_37051",
    "Last Name": "Fitzpatrick",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597757": {
    "id": "item_24018",
    "Last Name": "Kahlberg",
    "First Name": "Hilton",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597915": {
    "id": "item_37050",
    "Last Name": "Manibo",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597941": {
    "id": "item_37049",
    "Last Name": "Aung",
    "First Name": "Sandy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597962": {
    "id": "item_22600",
    "Last Name": "Howell",
    "First Name": "Dawson",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36597994": {
    "id": "item_24016",
    "Last Name": "Luu",
    "First Name": "Kit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598140": {
    "id": "item_24015",
    "Last Name": "Xie",
    "First Name": "Zhemin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598215": {
    "id": "item_11286",
    "Last Name": "Cooper",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598278": {
    "id": "item_22582",
    "Last Name": "Parkar",
    "First Name": "Kazim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598300": {
    "id": "item_37046",
    "Last Name": "Nguyen",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598338": {
    "id": "item_11470",
    "Last Name": "LEE",
    "First Name": "PETER",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598343": {
    "id": "item_9723",
    "Last Name": "Black",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598450": {
    "id": "item_22578",
    "Last Name": "Maughan",
    "First Name": "Leon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598479": {
    "id": "item_22577",
    "Last Name": "Elliott",
    "First Name": "Lily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598518": {
    "id": "item_11467",
    "Last Name": "Dowling",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598527": {
    "id": "item_34769",
    "Last Name": "Aung",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598604": {
    "id": "item_22576",
    "Last Name": "Chor",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598677": {
    "id": "item_9708",
    "Last Name": "Deloso",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598703": {
    "id": "item_37043",
    "Last Name": "Taylor",
    "First Name": "Diana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598759": {
    "id": "item_9722",
    "Last Name": "Browne",
    "First Name": "Giles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598791": {
    "id": "item_37042",
    "Last Name": "Guo",
    "First Name": "Alex Xuxi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598858": {
    "id": "item_11465",
    "Last Name": "Djemal",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598954": {
    "id": "item_22574",
    "Last Name": "Mahto",
    "First Name": "Amit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36598957": {
    "id": "item_9491",
    "Last Name": "Harris",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599215": {
    "id": "item_22359",
    "Last Name": "Montgomery",
    "First Name": "Lyndon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599254": {
    "id": "item_24164",
    "Last Name": "Blackwell",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599319": {
    "id": "item_22115",
    "Last Name": "Teo",
    "First Name": "Jay",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599433": {
    "id": "item_24154",
    "Last Name": "Cousens",
    "First Name": "Marigold",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599640": {
    "id": "item_34845",
    "Last Name": "Guo",
    "First Name": "Sunny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599671": {
    "id": "item_11482",
    "Last Name": "Smits",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599767": {
    "id": "item_9702",
    "Last Name": "Bowkett",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599820": {
    "id": "item_22572",
    "Last Name": "Li",
    "First Name": "Ran",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36599866": {
    "id": "item_22571",
    "Last Name": "Vanneste",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600036": {
    "id": "item_24012",
    "Last Name": "Sant",
    "First Name": "Leon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600105": {
    "id": "item_9698",
    "Last Name": "McInnes",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600131": {
    "id": "item_22599",
    "Last Name": "Napper",
    "First Name": "Melinda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600195": {
    "id": "item_22598",
    "Last Name": "Kolasinski",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600315": {
    "id": "item_9697",
    "Last Name": "Brown",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600323": {
    "id": "item_9488",
    "Last Name": "Erasmus",
    "First Name": "Jaco",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600386": {
    "id": "item_9268",
    "Last Name": "Green",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600396": {
    "id": "item_22357",
    "Last Name": "Blore",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600464": {
    "id": "item_11094",
    "Last Name": "Ozburn",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600465": {
    "id": "item_24151",
    "Last Name": "Martin",
    "First Name": "Toby",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600485": {
    "id": "item_37037",
    "Last Name": "Hoang",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600580": {
    "id": "item_11458",
    "Last Name": "Jackson",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600601": {
    "id": "item_37036",
    "Last Name": "Tan",
    "First Name": "Inna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600609": {
    "id": "item_36547",
    "Last Name": "Nickels",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600642": {
    "id": "item_9696",
    "Last Name": "Selvage",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600692": {
    "id": "item_36832",
    "Last Name": "Brady",
    "First Name": "Sasha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600702": {
    "id": "item_37033",
    "Last Name": "Flores",
    "First Name": "Frederick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600755": {
    "id": "item_37032",
    "Last Name": "Wagstaffe",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36600992": {
    "id": "item_22562",
    "Last Name": "Ansley",
    "First Name": "Eleanor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601009": {
    "id": "item_11457",
    "Last Name": "Estoque",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601012": {
    "id": "item_9694",
    "Last Name": "Tucker",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601068": {
    "id": "item_9693",
    "Last Name": "Gilbertson",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601097": {
    "id": "item_36546",
    "Last Name": "Lu",
    "First Name": "Ally",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601184": {
    "id": "item_24163",
    "Last Name": "Kercher",
    "First Name": "Jemima",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601232": {
    "id": "item_36545",
    "Last Name": "Ho",
    "First Name": "Yan Kit Patrick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601277": {
    "id": "item_22560",
    "Last Name": "Khanal",
    "First Name": "Mukunda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601383": {
    "id": "item_11456",
    "Last Name": "Chapman",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601429": {
    "id": "item_9482",
    "Last Name": "Shakespeare",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601692": {
    "id": "item_11455",
    "Last Name": "Weeks",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601877": {
    "id": "item_36826",
    "Last Name": "Taylor",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601909": {
    "id": "item_11481",
    "Last Name": "Miller",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36601965": {
    "id": "item_11280",
    "Last Name": "Li",
    "First Name": "Jie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36602069": {
    "id": "item_11454",
    "Last Name": "Yuen",
    "First Name": "Wai Yat",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36602769": {
    "id": "item_37027",
    "Last Name": "Simcoe",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36602800": {
    "id": "item_22558",
    "Last Name": "Nicholson",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36602803": {
    "id": "item_9689",
    "Last Name": "Magro",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36603378": {
    "id": "item_9481",
    "Last Name": "Van",
    "First Name": "Antony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36603585": {
    "id": "item_37025",
    "Last Name": "Pingsumpant",
    "First Name": "Sittichai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604385": {
    "id": "item_22556",
    "Last Name": "Joo",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604475": {
    "id": "item_11279",
    "Last Name": "da Silva Junior",
    "First Name": "Edson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604513": {
    "id": "item_24010",
    "Last Name": "Bannatyne",
    "First Name": "Kirsty",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604578": {
    "id": "item_37024",
    "Last Name": "Joseph",
    "First Name": "Abbey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604627": {
    "id": "item_37023",
    "Last Name": "Wan",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604664": {
    "id": "item_9687",
    "Last Name": "Salisbury",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604682": {
    "id": "item_11450",
    "Last Name": "Lainson",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604710": {
    "id": "item_22554",
    "Last Name": "Sund",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604764": {
    "id": "item_11449",
    "Last Name": "Hammond",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604784": {
    "id": "item_23875",
    "Last Name": "Fornieles Navarro",
    "First Name": "Jose Maria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604833": {
    "id": "item_22551",
    "Last Name": "Abbott",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604840": {
    "id": "item_37022",
    "Last Name": "Fragias",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604880": {
    "id": "item_37021",
    "Last Name": "Mojica",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36604886": {
    "id": "item_24008",
    "Last Name": "Swan",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605037": {
    "id": "item_24007",
    "Last Name": "Swan",
    "First Name": "Greg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605057": {
    "id": "item_37020",
    "Last Name": "tunbridge",
    "First Name": "mel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605096": {
    "id": "item_37019",
    "Last Name": "Joseph",
    "First Name": "Danny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605109": {
    "id": "item_9265",
    "Last Name": "Preater",
    "First Name": "Elliott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605168": {
    "id": "item_22546",
    "Last Name": "Shao",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605284": {
    "id": "item_22545",
    "Last Name": "Paul",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605294": {
    "id": "item_22113",
    "Last Name": "HENPITAK",
    "First Name": "THANADECH",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605631": {
    "id": "item_11278",
    "Last Name": "Tsang",
    "First Name": "Walter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605706": {
    "id": "item_11277",
    "Last Name": "Cantos",
    "First Name": "Ramil Joseph",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605713": {
    "id": "item_11446",
    "Last Name": "Mullins",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605740": {
    "id": "item_11445",
    "Last Name": "Wang",
    "First Name": "Dingze",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605768": {
    "id": "item_11092",
    "Last Name": "TRAN DUC",
    "First Name": "VIET",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605827": {
    "id": "item_34842",
    "Last Name": "DOWER",
    "First Name": "ANGE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36605990": {
    "id": "item_22543",
    "Last Name": "Zancanaro",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606144": {
    "id": "item_11443",
    "Last Name": "Railz",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606226": {
    "id": "item_22541",
    "Last Name": "Teeling",
    "First Name": "Ann-Maree",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606230": {
    "id": "item_22542",
    "Last Name": "Howard",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606275": {
    "id": "item_24147",
    "Last Name": "Raychaudhuri",
    "First Name": "Ronny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606279": {
    "id": "item_24006",
    "Last Name": "Pham",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606410": {
    "id": "item_34765",
    "Last Name": "McDonnell",
    "First Name": "Sarah Jane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606656": {
    "id": "item_9679",
    "Last Name": "Ainsworth",
    "First Name": "Russ",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606813": {
    "id": "item_22538",
    "Last Name": "Lindsay",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606825": {
    "id": "item_37058",
    "Last Name": "Smith",
    "First Name": "Gordon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606881": {
    "id": "item_9675",
    "Last Name": "Suzuki",
    "First Name": "Akira",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36606904": {
    "id": "item_34764",
    "Last Name": "Li",
    "First Name": "Bin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607052": {
    "id": "item_34839",
    "Last Name": "Horan",
    "First Name": "Cathal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607088": {
    "id": "item_34850",
    "Last Name": "Bridle",
    "First Name": "Billy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607092": {
    "id": "item_9262",
    "Last Name": "YING",
    "First Name": "CHUN SZE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607139": {
    "id": "item_11438",
    "Last Name": "Lansdown",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607222": {
    "id": "item_11436",
    "Last Name": "Goette",
    "First Name": "Bjoern",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607261": {
    "id": "item_23872",
    "Last Name": "Lee",
    "First Name": "Seungho",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607478": {
    "id": "item_22535",
    "Last Name": "Choi",
    "First Name": "Yong Ho",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607525": {
    "id": "item_22350",
    "Last Name": "grant Johnston",
    "First Name": "grant Johnston",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607661": {
    "id": "item_34849",
    "Last Name": "Thornton",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607921": {
    "id": "item_11433",
    "Last Name": "Chow",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36607976": {
    "id": "item_11432",
    "Last Name": "McGuire",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608164": {
    "id": "item_36816",
    "Last Name": "Peng",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608310": {
    "id": "item_24002",
    "Last Name": "Rayos",
    "First Name": "Kat",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608315": {
    "id": "item_9260",
    "Last Name": "YOKOYAMA",
    "First Name": "TOSHIO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608327": {
    "id": "item_11271",
    "Last Name": "Isobel",
    "First Name": "Marion",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608367": {
    "id": "item_34763",
    "Last Name": "Palmer-Cannon",
    "First Name": "Liam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608370": {
    "id": "item_24141",
    "Last Name": "Madero",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608544": {
    "id": "item_37016",
    "Last Name": "Parthong",
    "First Name": "Sittisak",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608636": {
    "id": "item_37015",
    "Last Name": "Smith",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608645": {
    "id": "item_11429",
    "Last Name": "Kim",
    "First Name": "Jaeyeon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608654": {
    "id": "item_37014",
    "Last Name": "Park",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608748": {
    "id": "item_9765",
    "Last Name": "O'Brien",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608760": {
    "id": "item_11270",
    "Last Name": "Zeng",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608769": {
    "id": "item_24140",
    "Last Name": "Kitay",
    "First Name": "Greg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608848": {
    "id": "item_24162",
    "Last Name": "Dang",
    "First Name": "Viet",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608874": {
    "id": "item_11428",
    "Last Name": "Kim",
    "First Name": "Gun Woo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608924": {
    "id": "item_36814",
    "Last Name": "Noy",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608953": {
    "id": "item_11091",
    "Last Name": "Thomas Mukalumpurathu",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608989": {
    "id": "item_11269",
    "Last Name": "Udodov",
    "First Name": "Valerii",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36608996": {
    "id": "item_37010",
    "Last Name": "Zhong",
    "First Name": "Hua",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609035": {
    "id": "item_23870",
    "Last Name": "Tran Huy Thanh",
    "First Name": "Tung",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609038": {
    "id": "item_37011",
    "Last Name": "Lazell",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609211": {
    "id": "item_37009",
    "Last Name": "Cox",
    "First Name": "Cassian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609219": {
    "id": "item_22343",
    "Last Name": "Richardson",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609236": {
    "id": "item_24161",
    "Last Name": "Sutcliffe",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609266": {
    "id": "item_11425",
    "Last Name": "Fanning",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609270": {
    "id": "item_9721",
    "Last Name": "Wilkie",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609272": {
    "id": "item_37008",
    "Last Name": "GUNTI",
    "First Name": "BHASKAR",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609276": {
    "id": "item_36812",
    "Last Name": "Tiyyagura",
    "First Name": "Vamsi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609285": {
    "id": "item_36811",
    "Last Name": "Stiebel",
    "First Name": "Harley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609316": {
    "id": "item_22526",
    "Last Name": "Advincula",
    "First Name": "Gary",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609319": {
    "id": "item_37006",
    "Last Name": "Varouhakis",
    "First Name": "Jayne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609322": {
    "id": "item_37004",
    "Last Name": "Varouhakis",
    "First Name": "Heather",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609396": {
    "id": "item_22109",
    "Last Name": "Gardner",
    "First Name": "Meghan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609422": {
    "id": "item_22597",
    "Last Name": "Zieja",
    "First Name": "Rafal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609520": {
    "id": "item_24138",
    "Last Name": "Sue",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609704": {
    "id": "item_11423",
    "Last Name": "Ryan",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609741": {
    "id": "item_22338",
    "Last Name": "Davies",
    "First Name": "Bonnie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609830": {
    "id": "item_22523",
    "Last Name": "Noyce",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609881": {
    "id": "item_34832",
    "Last Name": "Ojha",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36609928": {
    "id": "item_11480",
    "Last Name": "Gerber",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610039": {
    "id": "item_24160",
    "Last Name": "Basman",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610137": {
    "id": "item_9662",
    "Last Name": "Liang",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610145": {
    "id": "item_36536",
    "Last Name": "Shaw",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610169": {
    "id": "item_11420",
    "Last Name": "korkmann",
    "First Name": "benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610289": {
    "id": "item_9475",
    "Last Name": "Tierney",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610306": {
    "id": "item_22596",
    "Last Name": "Grainger",
    "First Name": "Jon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610316": {
    "id": "item_36998",
    "Last Name": "Adiv",
    "First Name": "Adiv",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610330": {
    "id": "item_9661",
    "Last Name": "Williams",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610339": {
    "id": "item_11417",
    "Last Name": "Chen",
    "First Name": "Arthur",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610380": {
    "id": "item_22517",
    "Last Name": "Yadav",
    "First Name": "Nirvikar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610397": {
    "id": "item_22516",
    "Last Name": "Wunderlich",
    "First Name": "Charina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610489": {
    "id": "item_36995",
    "Last Name": "Finance",
    "First Name": "Philippe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610545": {
    "id": "item_9656",
    "Last Name": "Swain",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610548": {
    "id": "item_34760",
    "Last Name": "Younes",
    "First Name": "Therese",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610591": {
    "id": "item_9655",
    "Last Name": "Vijayaratnam",
    "First Name": "Suthan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610627": {
    "id": "item_23869",
    "Last Name": "SINDANE",
    "First Name": "PETROS",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610672": {
    "id": "item_37097",
    "Last Name": "Yang",
    "First Name": "Yuk Fan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610693": {
    "id": "item_22515",
    "Last Name": "Ferris",
    "First Name": "LenŽ",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610696": {
    "id": "item_36806",
    "Last Name": "Broderick",
    "First Name": "Jen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610735": {
    "id": "item_9257",
    "Last Name": "Chen",
    "First Name": "Chenghao",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610744": {
    "id": "item_24130",
    "Last Name": "Middleton",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610749": {
    "id": "item_36992",
    "Last Name": "Ashfield-Smith",
    "First Name": "Vicki",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610781": {
    "id": "item_11412",
    "Last Name": "Parkin",
    "First Name": "Heath",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610818": {
    "id": "item_9650",
    "Last Name": "Waddington",
    "First Name": "Greg",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610839": {
    "id": "item_24129",
    "Last Name": "Bennett",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610873": {
    "id": "item_9473",
    "Last Name": "Burnell",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610901": {
    "id": "item_22595",
    "Last Name": "Gordon",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610910": {
    "id": "item_22513",
    "Last Name": "Tomov",
    "First Name": "Millen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610917": {
    "id": "item_24128",
    "Last Name": "Lee",
    "First Name": "Jong hwan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610925": {
    "id": "item_9649",
    "Last Name": "Huang",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610935": {
    "id": "item_22511",
    "Last Name": "Phillips",
    "First Name": "Manu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610937": {
    "id": "item_11409",
    "Last Name": "Ren",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36610993": {
    "id": "item_22509",
    "Last Name": "Drydale-Cech",
    "First Name": "Nikolaj",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611072": {
    "id": "item_34848",
    "Last Name": "Lucas",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611080": {
    "id": "item_36986",
    "Last Name": "Williams",
    "First Name": "Deidre",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611104": {
    "id": "item_36802",
    "Last Name": "Pham",
    "First Name": "Thanh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611147": {
    "id": "item_11406",
    "Last Name": "Jowett",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611162": {
    "id": "item_36800",
    "Last Name": "Butler",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611175": {
    "id": "item_9471",
    "Last Name": "Read",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611184": {
    "id": "item_22507",
    "Last Name": "Hanger",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611229": {
    "id": "item_24126",
    "Last Name": "Cox",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611268": {
    "id": "item_34824",
    "Last Name": "Lines",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611276": {
    "id": "item_22106",
    "Last Name": "ZAKARIA",
    "First Name": "MOHD TAJUDIN BIN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611283": {
    "id": "item_22105",
    "Last Name": "SAAD",
    "First Name": "ZURAIDI BIN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611286": {
    "id": "item_9648",
    "Last Name": "Huynh",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611316": {
    "id": "item_24125",
    "Last Name": "Oxby",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611362": {
    "id": "item_11402",
    "Last Name": "Muir",
    "First Name": "Jasper",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611374": {
    "id": "item_22506",
    "Last Name": "Trivedi",
    "First Name": "Prathmesh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611380": {
    "id": "item_37057",
    "Last Name": "Powell",
    "First Name": "Reece",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611397": {
    "id": "item_11400",
    "Last Name": "Lee",
    "First Name": "Han-Oh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611446": {
    "id": "item_36533",
    "Last Name": "Karwejna",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611467": {
    "id": "item_24124",
    "Last Name": "Pham",
    "First Name": "Van",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611485": {
    "id": "item_23868",
    "Last Name": "Fuchsgruber",
    "First Name": "Monika",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611515": {
    "id": "item_36975",
    "Last Name": "Waddell",
    "First Name": "Ian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611518": {
    "id": "item_9647",
    "Last Name": "Costello",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611531": {
    "id": "item_9646",
    "Last Name": "Pickett",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611546": {
    "id": "item_22503",
    "Last Name": "Whight",
    "First Name": "Bob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611562": {
    "id": "item_22102",
    "Last Name": "Malinowska-Szacon",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611583": {
    "id": "item_37056",
    "Last Name": "McLaughlin",
    "First Name": "Jillian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611584": {
    "id": "item_36531",
    "Last Name": "HSIA",
    "First Name": "LI-MING",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611610": {
    "id": "item_11396",
    "Last Name": "Moon",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611640": {
    "id": "item_11261",
    "Last Name": "Radovan",
    "First Name": "Zaldy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611641": {
    "id": "item_9643",
    "Last Name": "Zenos",
    "First Name": "Martti",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611646": {
    "id": "item_9645",
    "Last Name": "Eisenhuth",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611663": {
    "id": "item_22594",
    "Last Name": "Farley",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611683": {
    "id": "item_34820",
    "Last Name": "Langley",
    "First Name": "Chantelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611694": {
    "id": "item_24123",
    "Last Name": "Manas",
    "First Name": "Tad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611712": {
    "id": "item_11088",
    "Last Name": "Jones",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611717": {
    "id": "item_36972",
    "Last Name": "Luo",
    "First Name": "Jiawen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611726": {
    "id": "item_22333",
    "Last Name": "Stevens",
    "First Name": "Jerry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611734": {
    "id": "item_9253",
    "Last Name": "ZHU",
    "First Name": "TAO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611777": {
    "id": "item_22500",
    "Last Name": "Mort",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611794": {
    "id": "item_34819",
    "Last Name": "Higgs",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611814": {
    "id": "item_24120",
    "Last Name": "Dunne",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611842": {
    "id": "item_11392",
    "Last Name": "Seki",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611851": {
    "id": "item_9720",
    "Last Name": "Roach",
    "First Name": "Jaidyn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611881": {
    "id": "item_22498",
    "Last Name": "Campbell",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611903": {
    "id": "item_34756",
    "Last Name": "Lin",
    "First Name": "Julie Yuxuan Zheng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611909": {
    "id": "item_37055",
    "Last Name": "Pappas",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611948": {
    "id": "item_24117",
    "Last Name": "Kaps",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611979": {
    "id": "item_9469",
    "Last Name": "Bennett",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36611997": {
    "id": "item_11256",
    "Last Name": "Ryan",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612014": {
    "id": "item_23995",
    "Last Name": "Paynter",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612027": {
    "id": "item_22494",
    "Last Name": "Krejci",
    "First Name": "Lara",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612056": {
    "id": "item_9634",
    "Last Name": "Andrews",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612089": {
    "id": "item_9632",
    "Last Name": "Stokes",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612099": {
    "id": "item_36970",
    "Last Name": "Foo",
    "First Name": "Justine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612110": {
    "id": "item_22099",
    "Last Name": "Mclean",
    "First Name": "Georgie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612130": {
    "id": "item_11479",
    "Last Name": "Horne",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612156": {
    "id": "item_23866",
    "Last Name": "Hsieh",
    "First Name": "Cheng Hsien",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612205": {
    "id": "item_9466",
    "Last Name": "Behling",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612212": {
    "id": "item_9630",
    "Last Name": "Lambert",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612218": {
    "id": "item_24114",
    "Last Name": "Owen",
    "First Name": "Dion",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612230": {
    "id": "item_9628",
    "Last Name": "Edinburg",
    "First Name": "Gidon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612246": {
    "id": "item_9626",
    "Last Name": "Colless",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612263": {
    "id": "item_11478",
    "Last Name": "HARVEY",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612295": {
    "id": "item_36969",
    "Last Name": "Dela Cruz",
    "First Name": "Jaren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612302": {
    "id": "item_22492",
    "Last Name": "Mishra",
    "First Name": "Hansraj",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612308": {
    "id": "item_9719",
    "Last Name": "Engel",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612309": {
    "id": "item_11386",
    "Last Name": "XU",
    "First Name": "YIZHEN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612323": {
    "id": "item_22592",
    "Last Name": "Phillips",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612329": {
    "id": "item_37054",
    "Last Name": "Secombe",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612331": {
    "id": "item_22491",
    "Last Name": "MATEMATICO",
    "First Name": "JOESAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612340": {
    "id": "item_11384",
    "Last Name": "Ghilks",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612348": {
    "id": "item_11383",
    "Last Name": "Hagiwara",
    "First Name": "Yoshihito",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612364": {
    "id": "item_22593",
    "Last Name": "Hancock",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612395": {
    "id": "item_9464",
    "Last Name": "Kelly",
    "First Name": "Marty",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612415": {
    "id": "item_22329",
    "Last Name": "Beaudry",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612418": {
    "id": "item_9463",
    "Last Name": "Gao",
    "First Name": "Peng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612421": {
    "id": "item_34817",
    "Last Name": "Hii",
    "First Name": "Johnson",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612428": {
    "id": "item_23992",
    "Last Name": "Evans",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612442": {
    "id": "item_34816",
    "Last Name": "Parker",
    "First Name": "Karie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612449": {
    "id": "item_9462",
    "Last Name": "Fenton",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612468": {
    "id": "item_9461",
    "Last Name": "Winnel",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612494": {
    "id": "item_9460",
    "Last Name": "Bedford",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612503": {
    "id": "item_11254",
    "Last Name": "Lee",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612506": {
    "id": "item_34815",
    "Last Name": "Holland",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612524": {
    "id": "item_22485",
    "Last Name": "Almeida",
    "First Name": "Gilson Eduardo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612546": {
    "id": "item_22484",
    "Last Name": "Costales",
    "First Name": "John-Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612558": {
    "id": "item_22328",
    "Last Name": "Sollesta",
    "First Name": "Rod",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612570": {
    "id": "item_22327",
    "Last Name": "Faulkner",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612690": {
    "id": "item_9618",
    "Last Name": "Churchward",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612754": {
    "id": "item_9616",
    "Last Name": "Trewin",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612782": {
    "id": "item_9249",
    "Last Name": "KIM",
    "First Name": "KEONWOO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612835": {
    "id": "item_36963",
    "Last Name": "Foster",
    "First Name": "Steph",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612837": {
    "id": "item_34813",
    "Last Name": "Sendall",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612839": {
    "id": "item_11250",
    "Last Name": "Jones",
    "First Name": "Trent",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612849": {
    "id": "item_9615",
    "Last Name": "Laurie",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612933": {
    "id": "item_34754",
    "Last Name": "Banerjee",
    "First Name": "Susmita",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612938": {
    "id": "item_9612",
    "Last Name": "Evans",
    "First Name": "Alastair",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36612978": {
    "id": "item_34753",
    "Last Name": "Absolon",
    "First Name": "Meg",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613371": {
    "id": "item_36959",
    "Last Name": "Lie",
    "First Name": "Lionel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613592": {
    "id": "item_11374",
    "Last Name": "Lo",
    "First Name": "Ming Keung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613679": {
    "id": "item_36789",
    "Last Name": "Kassim",
    "First Name": "Jaris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613799": {
    "id": "item_24106",
    "Last Name": "Forster",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613892": {
    "id": "item_11081",
    "Last Name": "LIAO",
    "First Name": "XINTING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613948": {
    "id": "item_36956",
    "Last Name": "LI",
    "First Name": "YAT-SING",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36613980": {
    "id": "item_36527",
    "Last Name": "TAN",
    "First Name": "IRIS",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614011": {
    "id": "item_34680",
    "Last Name": "ZHAO",
    "First Name": "GANG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614058": {
    "id": "item_36526",
    "Last Name": "Tacsiat",
    "First Name": "Cristine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614103": {
    "id": "item_36955",
    "Last Name": "Christianto",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614139": {
    "id": "item_22091",
    "Last Name": "DING",
    "First Name": "JIJUN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614283": {
    "id": "item_23860",
    "Last Name": "Espeleta",
    "First Name": "Erick Lawrenz",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614439": {
    "id": "item_11078",
    "Last Name": "ZHOU QIAN",
    "First Name": "Zi Yang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614466": {
    "id": "item_36525",
    "Last Name": "ZHANG",
    "First Name": "JIE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614488": {
    "id": "item_24103",
    "Last Name": "Chen",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614751": {
    "id": "item_23990",
    "Last Name": "PLOWMAN",
    "First Name": "JONATHAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614829": {
    "id": "item_36788",
    "Last Name": "Rabena",
    "First Name": "Timothy Joseph",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36614839": {
    "id": "item_22089",
    "Last Name": "McLay",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36615023": {
    "id": "item_22085",
    "Last Name": "LIN",
    "First Name": "TING HAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36615247": {
    "id": "item_36522",
    "Last Name": "Chan",
    "First Name": "Kang Jun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36615384": {
    "id": "item_22480",
    "Last Name": "Kerry",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36615682": {
    "id": "item_22479",
    "Last Name": "Wiseman",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36616212": {
    "id": "item_36521",
    "Last Name": "Tan",
    "First Name": "Juay Khoon David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36616370": {
    "id": "item_36520",
    "Last Name": "Loh",
    "First Name": "Sow Fun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36616527": {
    "id": "item_36519",
    "Last Name": "Ong",
    "First Name": "Hwee Li",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36616629": {
    "id": "item_34678",
    "Last Name": "Gardner",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36616828": {
    "id": "item_9607",
    "Last Name": "GAO",
    "First Name": "YANLI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36618255": {
    "id": "item_22478",
    "Last Name": "Cronan",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36620233": {
    "id": "item_11369",
    "Last Name": "Vose",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36620548": {
    "id": "item_9243",
    "Last Name": "CHEN",
    "First Name": "JIE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36621009": {
    "id": "item_24102",
    "Last Name": "Chaubey",
    "First Name": "Saurabh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36621310": {
    "id": "item_11249",
    "Last Name": "GUO",
    "First Name": "MINGLIANG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36622480": {
    "id": "item_11368",
    "Last Name": "Hynes",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36622559": {
    "id": "item_11477",
    "Last Name": "Wade",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36624068": {
    "id": "item_9718",
    "Last Name": "Cullen",
    "First Name": "Jolie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36624158": {
    "id": "item_9717",
    "Last Name": "Jansen van Rensburg",
    "First Name": "Charl",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36624186": {
    "id": "item_36952",
    "Last Name": "D'Imperio",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36624635": {
    "id": "item_36786",
    "Last Name": "Zhao",
    "First Name": "Hao",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36624867": {
    "id": "item_9602",
    "Last Name": "Campbell",
    "First Name": "Daragh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36625459": {
    "id": "item_22321",
    "Last Name": "Volk",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36625497": {
    "id": "item_11073",
    "Last Name": "de Souza",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36626270": {
    "id": "item_37096",
    "Last Name": "Whittle",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36626334": {
    "id": "item_22591",
    "Last Name": "Thomson",
    "First Name": "Katja",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36626367": {
    "id": "item_9600",
    "Last Name": "MacDonald",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36626606": {
    "id": "item_11476",
    "Last Name": "Meyers",
    "First Name": "Clint",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36626684": {
    "id": "item_9599",
    "Last Name": "Wood",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36626810": {
    "id": "item_34807",
    "Last Name": "Lax",
    "First Name": "Wilfred",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627131": {
    "id": "item_11365",
    "Last Name": "Fraser",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627257": {
    "id": "item_11364",
    "Last Name": "Stroud",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627374": {
    "id": "item_36949",
    "Last Name": "Nguyen",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627384": {
    "id": "item_36948",
    "Last Name": "Ho",
    "First Name": "Hailey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627545": {
    "id": "item_22470",
    "Last Name": "La",
    "First Name": "Tinh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627719": {
    "id": "item_34806",
    "Last Name": "MOJARRAD",
    "First Name": "Pedram",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627794": {
    "id": "item_36944",
    "Last Name": "Hamnett",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627871": {
    "id": "item_22468",
    "Last Name": "Liu",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627884": {
    "id": "item_36784",
    "Last Name": "Kenny",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36627954": {
    "id": "item_9595",
    "Last Name": "Lee",
    "First Name": "Tomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628340": {
    "id": "item_11361",
    "Last Name": "Lopreiato",
    "First Name": "Onofrio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628458": {
    "id": "item_24098",
    "Last Name": "Datos",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628646": {
    "id": "item_22466",
    "Last Name": "Stoneham",
    "First Name": "Rob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628754": {
    "id": "item_22317",
    "Last Name": "Ellis",
    "First Name": "Marissa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36628772": {
    "id": "item_9590",
    "Last Name": "Thomson",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629011": {
    "id": "item_11359",
    "Last Name": "Peters",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629043": {
    "id": "item_36515",
    "Last Name": "LUNG",
    "First Name": "SAI WAH",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629162": {
    "id": "item_24096",
    "Last Name": "Chivers",
    "First Name": "Stina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629241": {
    "id": "item_34638",
    "Last Name": "Khan",
    "First Name": "Atiqur",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629290": {
    "id": "item_9452",
    "Last Name": "Burton",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629366": {
    "id": "item_9241",
    "Last Name": "KARASU",
    "First Name": "YASUHIRO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629463": {
    "id": "item_24094",
    "Last Name": "Jang",
    "First Name": "Shao-Jye Jeffrey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629473": {
    "id": "item_22463",
    "Last Name": "Hall",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629617": {
    "id": "item_22316",
    "Last Name": "Fukunaga",
    "First Name": "Aya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629694": {
    "id": "item_34677",
    "Last Name": "Barreda",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629859": {
    "id": "item_34804",
    "Last Name": "Hoare",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36629994": {
    "id": "item_36783",
    "Last Name": "McConville",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630070": {
    "id": "item_36782",
    "Last Name": "Davies",
    "First Name": "Alyce",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630409": {
    "id": "item_34803",
    "Last Name": "Carrapetta",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630502": {
    "id": "item_36781",
    "Last Name": "Staff",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630546": {
    "id": "item_36943",
    "Last Name": "Busby",
    "First Name": "Cherie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630610": {
    "id": "item_11356",
    "Last Name": "Mazziotta",
    "First Name": "Rocco",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36630697": {
    "id": "item_11355",
    "Last Name": "O'Neil",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36631849": {
    "id": "item_9448",
    "Last Name": "Jiang",
    "First Name": "Yuxuan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36631936": {
    "id": "item_36940",
    "Last Name": "Lee",
    "First Name": "Dominique",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36632050": {
    "id": "item_9586",
    "Last Name": "Northey",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36632423": {
    "id": "item_23988",
    "Last Name": "Coffey",
    "First Name": "Zena",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36632510": {
    "id": "item_9585",
    "Last Name": "Stevens",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36632649": {
    "id": "item_36939",
    "Last Name": "Gregg",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36632684": {
    "id": "item_34801",
    "Last Name": "Deloso",
    "First Name": "Alexandria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36632759": {
    "id": "item_9584",
    "Last Name": "Leaf",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633092": {
    "id": "item_22314",
    "Last Name": "Sullivan",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633517": {
    "id": "item_24081",
    "Last Name": "Bennet",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633527": {
    "id": "item_11071",
    "Last Name": "DONG",
    "First Name": "YIHANG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633589": {
    "id": "item_11244",
    "Last Name": "yaqub",
    "First Name": "yoosof",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633718": {
    "id": "item_9583",
    "Last Name": "Ziegler",
    "First Name": "Jared",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633783": {
    "id": "item_11070",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36633861": {
    "id": "item_11243",
    "Last Name": "Anderson",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634226": {
    "id": "item_34811",
    "Last Name": "Bannink",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634504": {
    "id": "item_9579",
    "Last Name": "Skopek",
    "First Name": "Jakub",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634829": {
    "id": "item_9447",
    "Last Name": "Lynch",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634852": {
    "id": "item_11242",
    "Last Name": "Dawes",
    "First Name": "Dave",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36634871": {
    "id": "item_22452",
    "Last Name": "Wetherill",
    "First Name": "Evan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635007": {
    "id": "item_11349",
    "Last Name": "Ang",
    "First Name": "Somphors",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635124": {
    "id": "item_22451",
    "Last Name": "Wynne",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635162": {
    "id": "item_36933",
    "Last Name": "Hilton",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635218": {
    "id": "item_9574",
    "Last Name": "Pilu",
    "First Name": "Martino",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635332": {
    "id": "item_9573",
    "Last Name": "Dunne",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635530": {
    "id": "item_22448",
    "Last Name": "Volpato",
    "First Name": "Andre",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635705": {
    "id": "item_9572",
    "Last Name": "Jeffree",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635723": {
    "id": "item_22447",
    "Last Name": "Cole",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635851": {
    "id": "item_22446",
    "Last Name": "Naidu",
    "First Name": "Rohini",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36635960": {
    "id": "item_9570",
    "Last Name": "Bromfield",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636039": {
    "id": "item_22445",
    "Last Name": "Brown",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636200": {
    "id": "item_24078",
    "Last Name": "Caesar",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636354": {
    "id": "item_23982",
    "Last Name": "Regalo",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636431": {
    "id": "item_11348",
    "Last Name": "Gardner",
    "First Name": "Kieren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636532": {
    "id": "item_23980",
    "Last Name": "Kamp",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36636698": {
    "id": "item_34796",
    "Last Name": "Davenport",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36637789": {
    "id": "item_34751",
    "Last Name": "Hunter",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36637901": {
    "id": "item_9239",
    "Last Name": "Wang",
    "First Name": "Zhixiang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36637925": {
    "id": "item_22443",
    "Last Name": "Lu",
    "First Name": "yufei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638063": {
    "id": "item_36925",
    "Last Name": "Chu",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638103": {
    "id": "item_22590",
    "Last Name": "Gillan",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638173": {
    "id": "item_22080",
    "Last Name": "Fernandez Garita",
    "First Name": "Maria Lucia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638311": {
    "id": "item_36773",
    "Last Name": "Chong",
    "First Name": "Kei Fung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638314": {
    "id": "item_9565",
    "Last Name": "Palhares",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638560": {
    "id": "item_22441",
    "Last Name": "Owens",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638631": {
    "id": "item_11068",
    "Last Name": "Otnieliem",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638658": {
    "id": "item_22438",
    "Last Name": "Lay",
    "First Name": "Roger",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638661": {
    "id": "item_36921",
    "Last Name": "Fairgrieve",
    "First Name": "Herlianty",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638838": {
    "id": "item_9563",
    "Last Name": "Han",
    "First Name": "Jacky",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36638961": {
    "id": "item_22311",
    "Last Name": "Hoggan",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639100": {
    "id": "item_24076",
    "Last Name": "Israel",
    "First Name": "AurŽlia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639188": {
    "id": "item_36920",
    "Last Name": "Ngo",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639387": {
    "id": "item_24074",
    "Last Name": "Thomas",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639565": {
    "id": "item_22435",
    "Last Name": "McFarlane",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639614": {
    "id": "item_36918",
    "Last Name": "Ostos Rios",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639664": {
    "id": "item_23978",
    "Last Name": "Oxlade",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639675": {
    "id": "item_36770",
    "Last Name": "Husman",
    "First Name": "Jeffry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639700": {
    "id": "item_36512",
    "Last Name": "WU",
    "First Name": "QIAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639703": {
    "id": "item_34792",
    "Last Name": "Woodman",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639711": {
    "id": "item_22434",
    "Last Name": "Mallett",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639745": {
    "id": "item_22589",
    "Last Name": "Sandstrom",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639853": {
    "id": "item_9446",
    "Last Name": "Brady",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639945": {
    "id": "item_36511",
    "Last Name": "Feng",
    "First Name": "Zhe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639963": {
    "id": "item_36510",
    "Last Name": "WANG",
    "First Name": "BEILI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36639977": {
    "id": "item_36915",
    "Last Name": "Hang",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640029": {
    "id": "item_36769",
    "Last Name": "Adams",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640031": {
    "id": "item_22588",
    "Last Name": "Brown",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640071": {
    "id": "item_36509",
    "Last Name": "Bin Rohaizad",
    "First Name": "Muhammad Ilham Rizqullah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640093": {
    "id": "item_22431",
    "Last Name": "Zhang",
    "First Name": "Cindy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640307": {
    "id": "item_11065",
    "Last Name": "NG",
    "First Name": "HOI MING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640313": {
    "id": "item_36914",
    "Last Name": "gannon",
    "First Name": "Phil",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640376": {
    "id": "item_9716",
    "Last Name": "Tiwari",
    "First Name": "Abhishek",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640436": {
    "id": "item_11341",
    "Last Name": "Pintabona",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640503": {
    "id": "item_24159",
    "Last Name": "Quinlan",
    "First Name": "Heather",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640519": {
    "id": "item_36913",
    "Last Name": "Maass",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640530": {
    "id": "item_22305",
    "Last Name": "Hong",
    "First Name": "ZhiQiang",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640533": {
    "id": "item_11340",
    "Last Name": "Hubble",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640596": {
    "id": "item_23976",
    "Last Name": "Wu",
    "First Name": "Zhinan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640640": {
    "id": "item_11338",
    "Last Name": "Thavalingam",
    "First Name": "Sriganesh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640804": {
    "id": "item_11063",
    "Last Name": "JIN",
    "First Name": "YUQING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640863": {
    "id": "item_22430",
    "Last Name": "Fujikawa",
    "First Name": "Noritaka",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640893": {
    "id": "item_36765",
    "Last Name": "Dai",
    "First Name": "Min Jian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640997": {
    "id": "item_22426",
    "Last Name": "Jenkins",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36640998": {
    "id": "item_22427",
    "Last Name": "Chandna",
    "First Name": "Amit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641085": {
    "id": "item_11475",
    "Last Name": "Kean",
    "First Name": "Wesley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641090": {
    "id": "item_22424",
    "Last Name": "March",
    "First Name": "Stewart",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641091": {
    "id": "item_22587",
    "Last Name": "Bradley",
    "First Name": "Wilaiporn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641092": {
    "id": "item_11240",
    "Last Name": "Crossley",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641096": {
    "id": "item_22423",
    "Last Name": "Tyler",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641140": {
    "id": "item_22422",
    "Last Name": "Reichling",
    "First Name": "Christoph",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641144": {
    "id": "item_9445",
    "Last Name": "Minto",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641160": {
    "id": "item_36907",
    "Last Name": "Follent",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641203": {
    "id": "item_9233",
    "Last Name": "zhou",
    "First Name": "li",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641217": {
    "id": "item_11239",
    "Last Name": "DENNING",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641269": {
    "id": "item_9444",
    "Last Name": "Beyers",
    "First Name": "Leo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641328": {
    "id": "item_36905",
    "Last Name": "Ochiai",
    "First Name": "Kanji",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641338": {
    "id": "item_22421",
    "Last Name": "Novak",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641418": {
    "id": "item_11238",
    "Last Name": "Male",
    "First Name": "Keaton",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641425": {
    "id": "item_11236",
    "Last Name": "Alley",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641480": {
    "id": "item_22420",
    "Last Name": "McConnell-Whalan",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641733": {
    "id": "item_24066",
    "Last Name": "Fulton",
    "First Name": "Randall",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641758": {
    "id": "item_11333",
    "Last Name": "Banh",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641778": {
    "id": "item_22419",
    "Last Name": "Browne",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641805": {
    "id": "item_23975",
    "Last Name": "Nelson",
    "First Name": "Bill",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641807": {
    "id": "item_36762",
    "Last Name": "Milne",
    "First Name": "Tash",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641848": {
    "id": "item_36902",
    "Last Name": "Malik",
    "First Name": "Priyanka",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641856": {
    "id": "item_9441",
    "Last Name": "Graham",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641890": {
    "id": "item_9440",
    "Last Name": "Bui",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641932": {
    "id": "item_22418",
    "Last Name": "Simmonds",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641937": {
    "id": "item_11234",
    "Last Name": "Smith",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641971": {
    "id": "item_11330",
    "Last Name": "Biviano",
    "First Name": "Jarryd",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641973": {
    "id": "item_36901",
    "Last Name": "P",
    "First Name": "Praveen Kumar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36641990": {
    "id": "item_22303",
    "Last Name": "Westmore",
    "First Name": "Beth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642003": {
    "id": "item_9550",
    "Last Name": "Vaziri",
    "First Name": "Saleh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642050": {
    "id": "item_36899",
    "Last Name": "Chen",
    "First Name": "Yixuan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642053": {
    "id": "item_34747",
    "Last Name": "LaMicela",
    "First Name": "Racquel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642065": {
    "id": "item_22416",
    "Last Name": "Adinata",
    "First Name": "Glen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642098": {
    "id": "item_11328",
    "Last Name": "Hu",
    "First Name": "shanqian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642125": {
    "id": "item_22301",
    "Last Name": "Dai",
    "First Name": "Xufeng",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642214": {
    "id": "item_36760",
    "Last Name": "Li",
    "First Name": "Yuet Man",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642220": {
    "id": "item_36759",
    "Last Name": "Kumsing",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642246": {
    "id": "item_36897",
    "Last Name": "Bartlett",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642397": {
    "id": "item_22076",
    "Last Name": "Simanjuntak",
    "First Name": "Partogi Binsar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642415": {
    "id": "item_9548",
    "Last Name": "Bailey",
    "First Name": "Nic",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642472": {
    "id": "item_11232",
    "Last Name": "Grolimund",
    "First Name": "Liz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642516": {
    "id": "item_34788",
    "Last Name": "Beeston",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36642566": {
    "id": "item_36893",
    "Last Name": "Herceg",
    "First Name": "Dagan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36643169": {
    "id": "item_24059",
    "Last Name": "Fok",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36643455": {
    "id": "item_22075",
    "Last Name": "Winfield",
    "First Name": "Russell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36643563": {
    "id": "item_11060",
    "Last Name": "Yoesoef",
    "First Name": "Paulus Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36643638": {
    "id": "item_22415",
    "Last Name": "Ahmad",
    "First Name": "Afiq Hakimi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36643685": {
    "id": "item_34746",
    "Last Name": "Sunaba",
    "First Name": "Keiko",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36644026": {
    "id": "item_9230",
    "Last Name": "Matsumoto",
    "First Name": "Reima",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36644378": {
    "id": "item_9434",
    "Last Name": "Pham",
    "First Name": "Anh Tung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36644637": {
    "id": "item_11059",
    "Last Name": "Gumkowski",
    "First Name": "Michal",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36645246": {
    "id": "item_36889",
    "Last Name": "Yang",
    "First Name": "Aixia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36645270": {
    "id": "item_36506",
    "Last Name": "Lin",
    "First Name": "Yu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36646572": {
    "id": "item_34674",
    "Last Name": "Cheang",
    "First Name": "In Leng Kitty",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36647271": {
    "id": "item_11058",
    "Last Name": "Grofils",
    "First Name": "Denis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36648642": {
    "id": "item_11323",
    "Last Name": "Gao",
    "First Name": "Hui",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36648837": {
    "id": "item_22413",
    "Last Name": "Smith",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36648982": {
    "id": "item_22411",
    "Last Name": "Plzak",
    "First Name": "Loraine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649133": {
    "id": "item_9543",
    "Last Name": "Gibson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649176": {
    "id": "item_34847",
    "Last Name": "Hulbert",
    "First Name": "Shane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649262": {
    "id": "item_24056",
    "Last Name": "Manici",
    "First Name": "Arno",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649561": {
    "id": "item_36887",
    "Last Name": "Senior",
    "First Name": "Brock",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649575": {
    "id": "item_9542",
    "Last Name": "Franklin",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649688": {
    "id": "item_22410",
    "Last Name": "WANG",
    "First Name": "XIANCHAO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649698": {
    "id": "item_9541",
    "Last Name": "McFadden",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36649935": {
    "id": "item_9433",
    "Last Name": "Moritz",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650031": {
    "id": "item_9540",
    "Last Name": "Lau",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650062": {
    "id": "item_24158",
    "Last Name": "Murton",
    "First Name": "Adelaide",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650067": {
    "id": "item_22408",
    "Last Name": "Gemmell",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650112": {
    "id": "item_24051",
    "Last Name": "Lin",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650287": {
    "id": "item_22406",
    "Last Name": "Lachele",
    "First Name": "Markus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650515": {
    "id": "item_11229",
    "Last Name": "Leigh",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650601": {
    "id": "item_37053",
    "Last Name": "Pasechnik",
    "First Name": "Alina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650667": {
    "id": "item_36504",
    "Last Name": "Lo",
    "First Name": "Chung Keung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36650902": {
    "id": "item_34784",
    "Last Name": "Elimin",
    "First Name": "Ronny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651212": {
    "id": "item_11228",
    "Last Name": "Brady",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651293": {
    "id": "item_23853",
    "Last Name": "Lilja",
    "First Name": "Robert Carl",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651392": {
    "id": "item_36881",
    "Last Name": "Fernandez",
    "First Name": "Aly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651562": {
    "id": "item_24046",
    "Last Name": "Cahill",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651593": {
    "id": "item_23967",
    "Last Name": "Drake",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651712": {
    "id": "item_34742",
    "Last Name": "Weber",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651716": {
    "id": "item_11474",
    "Last Name": "Crowl",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651847": {
    "id": "item_24044",
    "Last Name": "Sheahan",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36651964": {
    "id": "item_23965",
    "Last Name": "Ratnayake",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652122": {
    "id": "item_11315",
    "Last Name": "CHEN",
    "First Name": "CLIFF",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652199": {
    "id": "item_36880",
    "Last Name": "Marshall",
    "First Name": "Robbie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652407": {
    "id": "item_24157",
    "Last Name": "Henderson",
    "First Name": "Leyden",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652481": {
    "id": "item_24042",
    "Last Name": "Kumar",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652786": {
    "id": "item_24041",
    "Last Name": "Abraham",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36652953": {
    "id": "item_11309",
    "Last Name": "Archie",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653296": {
    "id": "item_24040",
    "Last Name": "Corcoran",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653601": {
    "id": "item_9532",
    "Last Name": "Lam",
    "First Name": "Saweng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653673": {
    "id": "item_11056",
    "Last Name": "Gaede",
    "First Name": "Florian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653898": {
    "id": "item_22392",
    "Last Name": "Tanaka",
    "First Name": "Hidetaka",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36653931": {
    "id": "item_24038",
    "Last Name": "sugiatno",
    "First Name": "whitney",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654025": {
    "id": "item_36871",
    "Last Name": "Skoric",
    "First Name": "Suzana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654109": {
    "id": "item_22390",
    "Last Name": "Camrass",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654326": {
    "id": "item_11306",
    "Last Name": "Mao",
    "First Name": "Yafang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654453": {
    "id": "item_22389",
    "Last Name": "Peadon",
    "First Name": "Denis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654485": {
    "id": "item_9527",
    "Last Name": "Waser",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654613": {
    "id": "item_22386",
    "Last Name": "Myles",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654691": {
    "id": "item_9526",
    "Last Name": "Fenn",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654965": {
    "id": "item_36868",
    "Last Name": "Meyer",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654970": {
    "id": "item_9524",
    "Last Name": "David",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654971": {
    "id": "item_9523",
    "Last Name": "Daley",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654973": {
    "id": "item_36865",
    "Last Name": "Dunphy",
    "First Name": "Suzie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36654978": {
    "id": "item_36864",
    "Last Name": "Venhuizen",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655022": {
    "id": "item_9519",
    "Last Name": "Branley",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655049": {
    "id": "item_36860",
    "Last Name": "Rawnsley",
    "First Name": "Liz",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655052": {
    "id": "item_9518",
    "Last Name": "Vu",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655053": {
    "id": "item_36746",
    "Last Name": "O'Brien",
    "First Name": "Adair",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655056": {
    "id": "item_11473",
    "Last Name": "Wilson",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655069": {
    "id": "item_24030",
    "Last Name": "Felizardo",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655080": {
    "id": "item_9516",
    "Last Name": "Pham",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655094": {
    "id": "item_34777",
    "Last Name": "Smith",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655105": {
    "id": "item_11302",
    "Last Name": "Liu",
    "First Name": "Sidong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655118": {
    "id": "item_24031",
    "Last Name": "Scott",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655126": {
    "id": "item_23963",
    "Last Name": "Hodge",
    "First Name": "Dianne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655137": {
    "id": "item_11301",
    "Last Name": "Monk",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655142": {
    "id": "item_9509",
    "Last Name": "Curran",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655143": {
    "id": "item_9510",
    "Last Name": "Irons",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655146": {
    "id": "item_9507",
    "Last Name": "Silver",
    "First Name": "Owen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655148": {
    "id": "item_37052",
    "Last Name": "Cullen",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655151": {
    "id": "item_34776",
    "Last Name": "Guest",
    "First Name": "Holly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655154": {
    "id": "item_36855",
    "Last Name": "Zhang",
    "First Name": "Bin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655155": {
    "id": "item_9508",
    "Last Name": "Blair",
    "First Name": "Rebekah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655159": {
    "id": "item_11222",
    "Last Name": "Barry",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655163": {
    "id": "item_24028",
    "Last Name": "McGregor",
    "First Name": "Allan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655170": {
    "id": "item_9715",
    "Last Name": "Carr",
    "First Name": "Colm",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655175": {
    "id": "item_11300",
    "Last Name": "Lambourne",
    "First Name": "Todd",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655177": {
    "id": "item_36852",
    "Last Name": "Pan",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655180": {
    "id": "item_22373",
    "Last Name": "Milne",
    "First Name": "Margie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655181": {
    "id": "item_24027",
    "Last Name": "Pike",
    "First Name": "Annalise",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655187": {
    "id": "item_36502",
    "Last Name": "Langford",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655209": {
    "id": "item_36849",
    "Last Name": "SOLRAJU DURAISAMY",
    "First Name": "HEMANTH",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655218": {
    "id": "item_11297",
    "Last Name": "Santander Ju‡rez",
    "First Name": "Damian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655254": {
    "id": "item_11296",
    "Last Name": "Kwan",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655261": {
    "id": "item_11221",
    "Last Name": "Wolfenson",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655263": {
    "id": "item_11472",
    "Last Name": "Goncalves",
    "First Name": "Nuno",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655270": {
    "id": "item_36847",
    "Last Name": "Benzaquen",
    "First Name": "Ali",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655290": {
    "id": "item_36846",
    "Last Name": "Guo",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655295": {
    "id": "item_34771",
    "Last Name": "Davies",
    "First Name": "James Frazer",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655296": {
    "id": "item_36842",
    "Last Name": "Mealing",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655301": {
    "id": "item_9428",
    "Last Name": "Stevens",
    "First Name": "Elliot",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655315": {
    "id": "item_11219",
    "Last Name": "Shand",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655319": {
    "id": "item_22372",
    "Last Name": "Cross",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655330": {
    "id": "item_22293",
    "Last Name": "Caggauauan",
    "First Name": "Wayne Ria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655340": {
    "id": "item_36841",
    "Last Name": "Kirkegard",
    "First Name": "Felicity",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655345": {
    "id": "item_9503",
    "Last Name": "Mort",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655366": {
    "id": "item_22065",
    "Last Name": "Ang",
    "First Name": "Kwok Ann",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655373": {
    "id": "item_36500",
    "Last Name": "Duran-Moy",
    "First Name": "Vivian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655385": {
    "id": "item_22291",
    "Last Name": "Chau",
    "First Name": "Khai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655390": {
    "id": "item_9498",
    "Last Name": "Dachakoon",
    "First Name": "Nattakarn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655392": {
    "id": "item_11293",
    "Last Name": "Havlicek",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655406": {
    "id": "item_24023",
    "Last Name": "Mitchell",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655408": {
    "id": "item_22366",
    "Last Name": "Close",
    "First Name": "Lee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655419": {
    "id": "item_22364",
    "Last Name": "Amado Mesa",
    "First Name": "Andres Felipe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655423": {
    "id": "item_36836",
    "Last Name": "Hoogesteger",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655430": {
    "id": "item_22365",
    "Last Name": "Jaksch",
    "First Name": "Stefan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655453": {
    "id": "item_9497",
    "Last Name": "Mackwell",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655480": {
    "id": "item_9496",
    "Last Name": "Truscott",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655482": {
    "id": "item_11292",
    "Last Name": "Croke",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655483": {
    "id": "item_22064",
    "Last Name": "Bian",
    "First Name": "Dawei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655488": {
    "id": "item_11216",
    "Last Name": "Edward",
    "First Name": "Yvette",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655496": {
    "id": "item_11291",
    "Last Name": "Haluza",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655497": {
    "id": "item_36835",
    "Last Name": "McCann",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655503": {
    "id": "item_11289",
    "Last Name": "Dimery",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655507": {
    "id": "item_11290",
    "Last Name": "Luker",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655512": {
    "id": "item_22362",
    "Last Name": "Bahety",
    "First Name": "Lokesh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655514": {
    "id": "item_34770",
    "Last Name": "Wong",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655529": {
    "id": "item_23961",
    "Last Name": "Purdie",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655532": {
    "id": "item_22361",
    "Last Name": "Graham",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655552": {
    "id": "item_24014",
    "Last Name": "Trodoux",
    "First Name": "Mickael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655566": {
    "id": "item_36742",
    "Last Name": "Yong",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655587": {
    "id": "item_9493",
    "Last Name": "Schimpl",
    "First Name": "Florian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655588": {
    "id": "item_34768",
    "Last Name": "Wilson",
    "First Name": "Lexy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655599": {
    "id": "item_11284",
    "Last Name": "CRESPO",
    "First Name": "ALVARO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655625": {
    "id": "item_11285",
    "Last Name": "Dwyer",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655630": {
    "id": "item_22360",
    "Last Name": "Schweikert",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655636": {
    "id": "item_24013",
    "Last Name": "Nguyen",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655664": {
    "id": "item_9489",
    "Last Name": "Johnson",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655687": {
    "id": "item_9487",
    "Last Name": "Chandrasekaran",
    "First Name": "Gokul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655701": {
    "id": "item_9486",
    "Last Name": "Duckworth",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655721": {
    "id": "item_22355",
    "Last Name": "Collins",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655728": {
    "id": "item_11281",
    "Last Name": "Ferrara",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655753": {
    "id": "item_36829",
    "Last Name": "Bugeja",
    "First Name": "Jodie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655766": {
    "id": "item_34673",
    "Last Name": "Redmann",
    "First Name": "Gerhard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655791": {
    "id": "item_9480",
    "Last Name": "Janu",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655811": {
    "id": "item_36824",
    "Last Name": "Slatter",
    "First Name": "Jade",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655815": {
    "id": "item_23850",
    "Last Name": "LIOW",
    "First Name": "LEONG SAN ROBIN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655821": {
    "id": "item_36498",
    "Last Name": "Voss",
    "First Name": "Kathy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655844": {
    "id": "item_36822",
    "Last Name": "Griffin",
    "First Name": "Layota",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655866": {
    "id": "item_36820",
    "Last Name": "Carroli",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655869": {
    "id": "item_36821",
    "Last Name": "Robertson",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655896": {
    "id": "item_9422",
    "Last Name": "Jones",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655944": {
    "id": "item_36740",
    "Last Name": "Whelan",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655945": {
    "id": "item_24004",
    "Last Name": "Cao",
    "First Name": "Gena",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655947": {
    "id": "item_36819",
    "Last Name": "Zhou",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655958": {
    "id": "item_24005",
    "Last Name": "Nakamura",
    "First Name": "Chihoko",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655968": {
    "id": "item_11276",
    "Last Name": "Schlosser",
    "First Name": "Martine",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655977": {
    "id": "item_34672",
    "Last Name": "Huet",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36655987": {
    "id": "item_36739",
    "Last Name": "Chen",
    "First Name": "Lok Seng Marvin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656032": {
    "id": "item_36818",
    "Last Name": "Nel",
    "First Name": "Christo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656033": {
    "id": "item_34740",
    "Last Name": "Frew",
    "First Name": "Terence",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656054": {
    "id": "item_24003",
    "Last Name": "Davis",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656059": {
    "id": "item_11274",
    "Last Name": "Palumbo",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656065": {
    "id": "item_11273",
    "Last Name": "Hilliard",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656071": {
    "id": "item_11272",
    "Last Name": "ZHANG",
    "First Name": "AIQIANG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656087": {
    "id": "item_22351",
    "Last Name": "Kinsella",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656120": {
    "id": "item_36738",
    "Last Name": "Leung",
    "First Name": "Siu Fung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656137": {
    "id": "item_22349",
    "Last Name": "Peatman",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656144": {
    "id": "item_22347",
    "Last Name": "Glastonbury",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656164": {
    "id": "item_9479",
    "Last Name": "Musgrove",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656170": {
    "id": "item_24001",
    "Last Name": "Hutchings",
    "First Name": "Ellie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656178": {
    "id": "item_36815",
    "Last Name": "Aynsley",
    "First Name": "Kirrily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656183": {
    "id": "item_23849",
    "Last Name": "Clement",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656184": {
    "id": "item_23958",
    "Last Name": "Santos",
    "First Name": "Ana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656223": {
    "id": "item_36736",
    "Last Name": "Bruce",
    "First Name": "Murray",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656267": {
    "id": "item_34761",
    "Last Name": "Briscoe",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656276": {
    "id": "item_22344",
    "Last Name": "Jorna",
    "First Name": "Freek",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656303": {
    "id": "item_36813",
    "Last Name": "Pedram",
    "First Name": "Shiva",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656313": {
    "id": "item_22341",
    "Last Name": "Rossen",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656319": {
    "id": "item_11268",
    "Last Name": "Newsom",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656350": {
    "id": "item_36810",
    "Last Name": "Ryan",
    "First Name": "Colin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656355": {
    "id": "item_11265",
    "Last Name": "Panetta",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656368": {
    "id": "item_36809",
    "Last Name": "Treanor",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656372": {
    "id": "item_36808",
    "Last Name": "Power",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656400": {
    "id": "item_36807",
    "Last Name": "Nash",
    "First Name": "Tonielle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656411": {
    "id": "item_22286",
    "Last Name": "Karlov",
    "First Name": "Katriona",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656425": {
    "id": "item_23848",
    "Last Name": "chan",
    "First Name": "mokwan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656461": {
    "id": "item_36735",
    "Last Name": "Steedman",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656467": {
    "id": "item_11053",
    "Last Name": "Delauzun",
    "First Name": "Luc",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656487": {
    "id": "item_36805",
    "Last Name": "XU",
    "First Name": "JIA HONG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656493": {
    "id": "item_11263",
    "Last Name": "Scarfone",
    "First Name": "Reid",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656509": {
    "id": "item_23847",
    "Last Name": "Hamilton",
    "First Name": "Robyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656510": {
    "id": "item_9474",
    "Last Name": "Spicer",
    "First Name": "Toby",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656524": {
    "id": "item_36804",
    "Last Name": "Keller",
    "First Name": "Candice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656543": {
    "id": "item_23845",
    "Last Name": "Truter",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656550": {
    "id": "item_22062",
    "Last Name": "Kaware",
    "First Name": "Roy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656572": {
    "id": "item_36799",
    "Last Name": "Yau",
    "First Name": "Yuen Wai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656576": {
    "id": "item_22337",
    "Last Name": "Damm",
    "First Name": "Bevan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656590": {
    "id": "item_36801",
    "Last Name": "Morrison",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656599": {
    "id": "item_36798",
    "Last Name": "Djajakusli",
    "First Name": "Danny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656671": {
    "id": "item_9712",
    "Last Name": "Mainey",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656742": {
    "id": "item_22583",
    "Last Name": "Schnelle",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656747": {
    "id": "item_11258",
    "Last Name": "Kelly",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656961": {
    "id": "item_9419",
    "Last Name": "Slaney",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36656967": {
    "id": "item_34757",
    "Last Name": "Mc Carron",
    "First Name": "Shauna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657005": {
    "id": "item_22060",
    "Last Name": "Chuang",
    "First Name": "Shu-Ching",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657086": {
    "id": "item_22331",
    "Last Name": "Le",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657090": {
    "id": "item_9711",
    "Last Name": "Prince",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657127": {
    "id": "item_9468",
    "Last Name": "Skinner",
    "First Name": "Neil",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657190": {
    "id": "item_34755",
    "Last Name": "De Silva",
    "First Name": "Sumitha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657256": {
    "id": "item_22283",
    "Last Name": "FONG",
    "First Name": "Chun Sing",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657262": {
    "id": "item_23993",
    "Last Name": "Nuttall-Smith",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657292": {
    "id": "item_9710",
    "Last Name": "Ashton",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657323": {
    "id": "item_11051",
    "Last Name": "Sopi",
    "First Name": "Maurice",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657357": {
    "id": "item_36494",
    "Last Name": "Santos",
    "First Name": "Jennifer Joy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657399": {
    "id": "item_36795",
    "Last Name": "MAKWANA",
    "First Name": "Puneet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657403": {
    "id": "item_11255",
    "Last Name": "Peile",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657404": {
    "id": "item_11253",
    "Last Name": "Baird",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657411": {
    "id": "item_9459",
    "Last Name": "Carruthers",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657427": {
    "id": "item_11050",
    "Last Name": "Mulholland",
    "First Name": "Gus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657461": {
    "id": "item_11252",
    "Last Name": "Smith",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657493": {
    "id": "item_9418",
    "Last Name": "Bache",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657494": {
    "id": "item_11251",
    "Last Name": "Gilliatt",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657517": {
    "id": "item_22326",
    "Last Name": "Winsbury",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657586": {
    "id": "item_9458",
    "Last Name": "Vette-Welsh",
    "First Name": "Dayne",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657635": {
    "id": "item_9457",
    "Last Name": "Eadie",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657651": {
    "id": "item_36492",
    "Last Name": "SCHERP",
    "First Name": "REBECCA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657673": {
    "id": "item_22324",
    "Last Name": "Timms",
    "First Name": "Ollie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36657799": {
    "id": "item_36790",
    "Last Name": "De Vega",
    "First Name": "Grant",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658053": {
    "id": "item_22057",
    "Last Name": "Scully",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658229": {
    "id": "item_11248",
    "Last Name": "Yang",
    "First Name": "Leena",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658267": {
    "id": "item_9417",
    "Last Name": "Yates",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658319": {
    "id": "item_22322",
    "Last Name": "Fung",
    "First Name": "Danny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658383": {
    "id": "item_9455",
    "Last Name": "Gillett",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658408": {
    "id": "item_9454",
    "Last Name": "Molloy",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658612": {
    "id": "item_11468",
    "Last Name": "Payten",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658615": {
    "id": "item_11246",
    "Last Name": "Krha",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658629": {
    "id": "item_37045",
    "Last Name": "Campbell",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658658": {
    "id": "item_11047",
    "Last Name": "WANG",
    "First Name": "KAI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658905": {
    "id": "item_36490",
    "Last Name": "Wisuttiyan",
    "First Name": "Werapat",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658920": {
    "id": "item_23989",
    "Last Name": "Raikes",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36658959": {
    "id": "item_11245",
    "Last Name": "Gibbons",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659164": {
    "id": "item_9449",
    "Last Name": "Ross",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659445": {
    "id": "item_37044",
    "Last Name": "Mackenzie",
    "First Name": "Taelor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659536": {
    "id": "item_22315",
    "Last Name": "Gawidan",
    "First Name": "Aurelio Jr",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659540": {
    "id": "item_36729",
    "Last Name": "Clements",
    "First Name": "Kiara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659544": {
    "id": "item_36730",
    "Last Name": "Clements",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659654": {
    "id": "item_23984",
    "Last Name": "Aspell",
    "First Name": "Michaela",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659687": {
    "id": "item_22313",
    "Last Name": "Near",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659715": {
    "id": "item_23983",
    "Last Name": "Essex",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659893": {
    "id": "item_11044",
    "Last Name": "LIU",
    "First Name": "DONGYUE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36659945": {
    "id": "item_11241",
    "Last Name": "Foley",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660126": {
    "id": "item_36487",
    "Last Name": "Danford",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660202": {
    "id": "item_36727",
    "Last Name": "Lai",
    "First Name": "Kai cheung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660236": {
    "id": "item_22308",
    "Last Name": "Cooper",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660353": {
    "id": "item_37108",
    "Last Name": "Bisht",
    "First Name": "Shriruj",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660377": {
    "id": "item_22307",
    "Last Name": "Ellis",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660425": {
    "id": "item_36768",
    "Last Name": "Surapaneni",
    "First Name": "Vardhan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660440": {
    "id": "item_23977",
    "Last Name": "Gelonesi",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660545": {
    "id": "item_36767",
    "Last Name": "Franklin",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660618": {
    "id": "item_9409",
    "Last Name": "Drown",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660718": {
    "id": "item_22279",
    "Last Name": "Murphy",
    "First Name": "Irulan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660763": {
    "id": "item_9407",
    "Last Name": "O'Connell",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660834": {
    "id": "item_22304",
    "Last Name": "Chan",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660883": {
    "id": "item_9707",
    "Last Name": "Langley",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36660903": {
    "id": "item_23954",
    "Last Name": "Huang",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661000": {
    "id": "item_36764",
    "Last Name": "Forrest",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661004": {
    "id": "item_11237",
    "Last Name": "Dowling",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661104": {
    "id": "item_36763",
    "Last Name": "Clayton",
    "First Name": "Evangeline",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661316": {
    "id": "item_11235",
    "Last Name": "Anson",
    "First Name": "Ned",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661344": {
    "id": "item_37041",
    "Last Name": "McCarthy",
    "First Name": "Jake",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661400": {
    "id": "item_11233",
    "Last Name": "Kirk",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661446": {
    "id": "item_34748",
    "Last Name": "Takahashi",
    "First Name": "Camila",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661459": {
    "id": "item_22302",
    "Last Name": "Wisely",
    "First Name": "Shanan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661464": {
    "id": "item_9439",
    "Last Name": "Huang",
    "First Name": "Rui Zhu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661465": {
    "id": "item_36761",
    "Last Name": "Coram",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661479": {
    "id": "item_9436",
    "Last Name": "Brien",
    "First Name": "Gary",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661487": {
    "id": "item_23974",
    "Last Name": "Maguire",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661495": {
    "id": "item_9435",
    "Last Name": "Nienaber",
    "First Name": "Charl",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661502": {
    "id": "item_36758",
    "Last Name": "Hu",
    "First Name": "Wenfeng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661574": {
    "id": "item_23972",
    "Last Name": "Turnbull",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661656": {
    "id": "item_11230",
    "Last Name": "Giroul",
    "First Name": "Jules",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661663": {
    "id": "item_24156",
    "Last Name": "Badenhorst",
    "First Name": "Casper",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661670": {
    "id": "item_34744",
    "Last Name": "Gouliotis",
    "First Name": "Eleni",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661707": {
    "id": "item_23970",
    "Last Name": "Moon",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661714": {
    "id": "item_36757",
    "Last Name": "Wrightson",
    "First Name": "Suzie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661718": {
    "id": "item_36756",
    "Last Name": "Hazzard",
    "First Name": "Elaine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661840": {
    "id": "item_23953",
    "Last Name": "Yang",
    "First Name": "Shengyao",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661842": {
    "id": "item_11227",
    "Last Name": "Miles",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661865": {
    "id": "item_23968",
    "Last Name": "King",
    "First Name": "Aisling",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661918": {
    "id": "item_11464",
    "Last Name": "Carey",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661940": {
    "id": "item_9431",
    "Last Name": "Raper",
    "First Name": "Damian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661969": {
    "id": "item_36755",
    "Last Name": "Hobden",
    "First Name": "Josh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36661979": {
    "id": "item_9430",
    "Last Name": "Coleman",
    "First Name": "Rhett",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662002": {
    "id": "item_11226",
    "Last Name": "McCormack",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662036": {
    "id": "item_11463",
    "Last Name": "Denton",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662042": {
    "id": "item_22276",
    "Last Name": "Williams",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662111": {
    "id": "item_36754",
    "Last Name": "Kourtesis",
    "First Name": "Simona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662122": {
    "id": "item_9705",
    "Last Name": "Myors",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662164": {
    "id": "item_22274",
    "Last Name": "Anderson",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662170": {
    "id": "item_36753",
    "Last Name": "Garcia",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662199": {
    "id": "item_11225",
    "Last Name": "Massey",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662238": {
    "id": "item_22299",
    "Last Name": "Tedjakusuma",
    "First Name": "Abraham",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662263": {
    "id": "item_9403",
    "Last Name": "Ranger",
    "First Name": "Guy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662314": {
    "id": "item_36723",
    "Last Name": "Nguyen",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662315": {
    "id": "item_23964",
    "Last Name": "Baddock",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662324": {
    "id": "item_22298",
    "Last Name": "Mann",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662330": {
    "id": "item_22297",
    "Last Name": "Nandlal",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662331": {
    "id": "item_22296",
    "Last Name": "Beven",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662407": {
    "id": "item_11462",
    "Last Name": "Clough",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662492": {
    "id": "item_22294",
    "Last Name": "Hidajat",
    "First Name": "Cecilia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662658": {
    "id": "item_23962",
    "Last Name": "Schnelle",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662703": {
    "id": "item_11206",
    "Last Name": "Gunsser",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662724": {
    "id": "item_36745",
    "Last Name": "YAN",
    "First Name": "YUN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662726": {
    "id": "item_11220",
    "Last Name": "Warren",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662773": {
    "id": "item_36744",
    "Last Name": "WEI",
    "First Name": "MIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662806": {
    "id": "item_36743",
    "Last Name": "Ko",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662839": {
    "id": "item_34736",
    "Last Name": "Arthur",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662847": {
    "id": "item_34741",
    "Last Name": "Zinn",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662952": {
    "id": "item_36722",
    "Last Name": "Quimosing",
    "First Name": "Sheryll",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662963": {
    "id": "item_9426",
    "Last Name": "Chan",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662980": {
    "id": "item_23959",
    "Last Name": "Wu",
    "First Name": "Luisa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36662998": {
    "id": "item_9424",
    "Last Name": "Furka",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663002": {
    "id": "item_22053",
    "Last Name": "Ross",
    "First Name": "Magalie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663057": {
    "id": "item_22289",
    "Last Name": "Liaw",
    "First Name": "Fabian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663073": {
    "id": "item_36741",
    "Last Name": "Tolardo",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663090": {
    "id": "item_22272",
    "Last Name": "Liang",
    "First Name": "Qiao",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663119": {
    "id": "item_23843",
    "Last Name": "Loh",
    "First Name": "Gary",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663152": {
    "id": "item_9421",
    "Last Name": "Tellidis",
    "First Name": "Chrys",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663218": {
    "id": "item_23956",
    "Last Name": "Tibbles",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663254": {
    "id": "item_22287",
    "Last Name": "BUTTIGIEG",
    "First Name": "MICHAEL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663385": {
    "id": "item_9401",
    "Last Name": "Yaxley",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663391": {
    "id": "item_9400",
    "Last Name": "Ye",
    "First Name": "Wei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663437": {
    "id": "item_9399",
    "Last Name": "Corbett",
    "First Name": "Raphael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663489": {
    "id": "item_11214",
    "Last Name": "ONeil",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663499": {
    "id": "item_37040",
    "Last Name": "Valdez",
    "First Name": "Norman",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663540": {
    "id": "item_34734",
    "Last Name": "Swaby",
    "First Name": "Margeritha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663645": {
    "id": "item_22052",
    "Last Name": "Val Souto",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663651": {
    "id": "item_36734",
    "Last Name": "Ding",
    "First Name": "Jie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663722": {
    "id": "item_22284",
    "Last Name": "Tong",
    "First Name": "Thien",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663734": {
    "id": "item_11213",
    "Last Name": "RAID",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663775": {
    "id": "item_34733",
    "Last Name": "Wiederkehr",
    "First Name": "Myriame",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663826": {
    "id": "item_36720",
    "Last Name": "Mani",
    "First Name": "Dev",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36663831": {
    "id": "item_23842",
    "Last Name": "chen",
    "First Name": "yong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36664046": {
    "id": "item_23841",
    "Last Name": "Kim",
    "First Name": "Mujin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36664051": {
    "id": "item_9224",
    "Last Name": "WANG",
    "First Name": "HAORAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36664150": {
    "id": "item_11212",
    "Last Name": "Gock",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36665648": {
    "id": "item_9413",
    "Last Name": "Carpenter",
    "First Name": "Neil",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36665819": {
    "id": "item_22050",
    "Last Name": "Ni",
    "First Name": "shengyou",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36666362": {
    "id": "item_36486",
    "Last Name": "Lopez",
    "First Name": "Mario Ernesto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36666440": {
    "id": "item_11035",
    "Last Name": "JUNG",
    "First Name": "HUNKYO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36666533": {
    "id": "item_11211",
    "Last Name": "zhou",
    "First Name": "jieren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36666592": {
    "id": "item_22282",
    "Last Name": "Cunliffe",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36667838": {
    "id": "item_11210",
    "Last Name": "Adamou",
    "First Name": "Theo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36668311": {
    "id": "item_36484",
    "Last Name": "KRYCKI",
    "First Name": "GRZEGORZ",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36669276": {
    "id": "item_36482",
    "Last Name": "Li",
    "First Name": "Jia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36670040": {
    "id": "item_11209",
    "Last Name": "Weaver",
    "First Name": "Trey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36670515": {
    "id": "item_9410",
    "Last Name": "Cook",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36670836": {
    "id": "item_9408",
    "Last Name": "Wright",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36671557": {
    "id": "item_11208",
    "Last Name": "Richardson",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36672505": {
    "id": "item_36725",
    "Last Name": "DZENIS",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36672510": {
    "id": "item_9405",
    "Last Name": "Johnson",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36672582": {
    "id": "item_22267",
    "Last Name": "Switala",
    "First Name": "Greg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36672693": {
    "id": "item_36724",
    "Last Name": "Eyaru",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36673070": {
    "id": "item_11204",
    "Last Name": "Hodder",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36673903": {
    "id": "item_22275",
    "Last Name": "Jariani",
    "First Name": "Ali",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36673947": {
    "id": "item_11203",
    "Last Name": "Blythe",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36674452": {
    "id": "item_34737",
    "Last Name": "Cerioli",
    "First Name": "Irene",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675033": {
    "id": "item_36481",
    "Last Name": "LIN",
    "First Name": "LlCHING",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675189": {
    "id": "item_11031",
    "Last Name": "Marfell",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675349": {
    "id": "item_22047",
    "Last Name": "Tappa",
    "First Name": "Ian Angelo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675397": {
    "id": "item_11205",
    "Last Name": "Feng",
    "First Name": "Minghe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675652": {
    "id": "item_22271",
    "Last Name": "Reid",
    "First Name": "Robbie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675780": {
    "id": "item_34735",
    "Last Name": "Kidman",
    "First Name": "Bella",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36675979": {
    "id": "item_11202",
    "Last Name": "Engel",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676070": {
    "id": "item_23951",
    "Last Name": "Geering",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676173": {
    "id": "item_22268",
    "Last Name": "Hayes",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676271": {
    "id": "item_9397",
    "Last Name": "McAdam",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676304": {
    "id": "item_36719",
    "Last Name": "Russell",
    "First Name": "Kye",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676327": {
    "id": "item_23950",
    "Last Name": "Al-Habr",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676378": {
    "id": "item_22573",
    "Last Name": "Hibbit",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676441": {
    "id": "item_23949",
    "Last Name": "Nordien",
    "First Name": "Ray",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36676565": {
    "id": "item_9396",
    "Last Name": "Slaven",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677028": {
    "id": "item_36717",
    "Last Name": "Fauchon",
    "First Name": "Todd",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677157": {
    "id": "item_34731",
    "Last Name": "LI",
    "First Name": "HONG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677406": {
    "id": "item_36715",
    "Last Name": "Corry",
    "First Name": "Jack",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677470": {
    "id": "item_22261",
    "Last Name": "Shan",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677527": {
    "id": "item_23947",
    "Last Name": "Steer",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677649": {
    "id": "item_22264",
    "Last Name": "Bisignano",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677759": {
    "id": "item_9700",
    "Last Name": "Roffey",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677785": {
    "id": "item_36716",
    "Last Name": "Hart",
    "First Name": "Isobel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36677985": {
    "id": "item_22257",
    "Last Name": "Zengoski",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678082": {
    "id": "item_36713",
    "Last Name": "Mai",
    "First Name": "Haiyan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678206": {
    "id": "item_36712",
    "Last Name": "Bootle",
    "First Name": "Glen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678327": {
    "id": "item_36710",
    "Last Name": "Debast",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678407": {
    "id": "item_22046",
    "Last Name": "Lim",
    "First Name": "Joohan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678444": {
    "id": "item_11197",
    "Last Name": "Newhouse",
    "First Name": "Gabe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678473": {
    "id": "item_9395",
    "Last Name": "Cullen",
    "First Name": "Diarmuid",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678950": {
    "id": "item_22251",
    "Last Name": "Bolleteau",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36678964": {
    "id": "item_9392",
    "Last Name": "Nguyen",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679207": {
    "id": "item_11201",
    "Last Name": "Kelly",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679346": {
    "id": "item_36707",
    "Last Name": "Chambers",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679383": {
    "id": "item_11461",
    "Last Name": "McCrossin",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679517": {
    "id": "item_23944",
    "Last Name": "Lumley",
    "First Name": "Harry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679654": {
    "id": "item_23943",
    "Last Name": "Ostavich",
    "First Name": "Kellie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36679988": {
    "id": "item_34730",
    "Last Name": "Pupic",
    "First Name": "Frank",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680063": {
    "id": "item_9391",
    "Last Name": "Bannigan",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36680193": {
    "id": "item_22570",
    "Last Name": "Evans",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681276": {
    "id": "item_11190",
    "Last Name": "Dwan",
    "First Name": "Mary Rose",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681341": {
    "id": "item_9389",
    "Last Name": "Coghlan",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681486": {
    "id": "item_23941",
    "Last Name": "Haris",
    "First Name": "Abdul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681862": {
    "id": "item_37038",
    "Last Name": "Parfrey",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36681984": {
    "id": "item_11188",
    "Last Name": "Blanc",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682466": {
    "id": "item_34724",
    "Last Name": "Chapple",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682554": {
    "id": "item_22043",
    "Last Name": "Sanchez",
    "First Name": "Carlos J",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682577": {
    "id": "item_22245",
    "Last Name": "Vasiliou",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36682783": {
    "id": "item_34723",
    "Last Name": "Steuerwald",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683035": {
    "id": "item_11199",
    "Last Name": "Moyle",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683081": {
    "id": "item_22244",
    "Last Name": "Gifford",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683190": {
    "id": "item_22567",
    "Last Name": "Cox",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683492": {
    "id": "item_9385",
    "Last Name": "Lee",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683816": {
    "id": "item_9221",
    "Last Name": "SHEN",
    "First Name": "HAOZE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683819": {
    "id": "item_9384",
    "Last Name": "Scott",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36683835": {
    "id": "item_36695",
    "Last Name": "Tata",
    "First Name": "Ravi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36684268": {
    "id": "item_22242",
    "Last Name": "Hunt",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36684723": {
    "id": "item_36711",
    "Last Name": "Johnson",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36684837": {
    "id": "item_37035",
    "Last Name": "Ward",
    "First Name": "Audrey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36685495": {
    "id": "item_9383",
    "Last Name": "Baroudi",
    "First Name": "Khaldun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36685867": {
    "id": "item_11182",
    "Last Name": "Donald",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36686292": {
    "id": "item_36694",
    "Last Name": "Wang",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36686341": {
    "id": "item_37034",
    "Last Name": "Young",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36686881": {
    "id": "item_23938",
    "Last Name": "Dumlao",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687186": {
    "id": "item_36478",
    "Last Name": "TUMANDAY",
    "First Name": "JULITO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687330": {
    "id": "item_11179",
    "Last Name": "Gao",
    "First Name": "Lan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687409": {
    "id": "item_22239",
    "Last Name": "Stockburger",
    "First Name": "Brianna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687730": {
    "id": "item_11459",
    "Last Name": "Ward",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687900": {
    "id": "item_22253",
    "Last Name": "Reis",
    "First Name": "C. A.",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36687980": {
    "id": "item_11027",
    "Last Name": "Taylor",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688014": {
    "id": "item_23936",
    "Last Name": "Barber",
    "First Name": "Aine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688172": {
    "id": "item_23935",
    "Last Name": "Trimboli",
    "First Name": "Nina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688296": {
    "id": "item_22682",
    "Last Name": "SHENGJIAO",
    "First Name": "LU",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688408": {
    "id": "item_36686",
    "Last Name": "Xiang",
    "First Name": "Joyce",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36688587": {
    "id": "item_9393",
    "Last Name": "hu",
    "First Name": "xinyan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689502": {
    "id": "item_22565",
    "Last Name": "Hogan",
    "First Name": "Terrence",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689537": {
    "id": "item_22234",
    "Last Name": "Todd",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689715": {
    "id": "item_34717",
    "Last Name": "Jambur",
    "First Name": "Abhishek",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689876": {
    "id": "item_9373",
    "Last Name": "Yip",
    "First Name": "Leo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36689925": {
    "id": "item_34844",
    "Last Name": "Sibanda",
    "First Name": "Webson",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36690915": {
    "id": "item_22563",
    "Last Name": "Kehoe",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36690992": {
    "id": "item_23930",
    "Last Name": "Ahmed",
    "First Name": "Farhan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691126": {
    "id": "item_36679",
    "Last Name": "Wiseman",
    "First Name": "Tammy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691201": {
    "id": "item_11196",
    "Last Name": "Hulin",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691291": {
    "id": "item_11170",
    "Last Name": "Bowles",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691304": {
    "id": "item_23928",
    "Last Name": "Hay",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691338": {
    "id": "item_9367",
    "Last Name": "ZHOU",
    "First Name": "CHUNFENG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691353": {
    "id": "item_11169",
    "Last Name": "Bhutra",
    "First Name": "Shrey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691373": {
    "id": "item_23927",
    "Last Name": "Seery",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691419": {
    "id": "item_23926",
    "Last Name": "Galbraith",
    "First Name": "Sally",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691550": {
    "id": "item_36709",
    "Last Name": "Parsons",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691632": {
    "id": "item_22227",
    "Last Name": "Schmaman",
    "First Name": "Romy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691638": {
    "id": "item_22226",
    "Last Name": "Stadnik",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691705": {
    "id": "item_22225",
    "Last Name": "Li",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691962": {
    "id": "item_22223",
    "Last Name": "Aravamudhan",
    "First Name": "Sriram",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36691970": {
    "id": "item_36675",
    "Last Name": "Wilson",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692011": {
    "id": "item_9363",
    "Last Name": "Yang",
    "First Name": "Haijun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692101": {
    "id": "item_36475",
    "Last Name": "bin Sulaiman",
    "First Name": "Mohd Asrul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692149": {
    "id": "item_36474",
    "Last Name": "Bhattarai",
    "First Name": "Hari",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692277": {
    "id": "item_36672",
    "Last Name": "Daw",
    "First Name": "Debra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36692334": {
    "id": "item_22041",
    "Last Name": "Jiang",
    "First Name": "Juncai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36694497": {
    "id": "item_9361",
    "Last Name": "Chan",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36694634": {
    "id": "item_11195",
    "Last Name": "Croker",
    "First Name": "Brittney",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36694644": {
    "id": "item_22040",
    "Last Name": "ZHOU",
    "First Name": "ZIQIANG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36694934": {
    "id": "item_36671",
    "Last Name": "Tang",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36694999": {
    "id": "item_36670",
    "Last Name": "Yang",
    "First Name": "Jinmei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36696739": {
    "id": "item_23835",
    "Last Name": "Lao",
    "First Name": "Val rianne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36699882": {
    "id": "item_36667",
    "Last Name": "Pankaew",
    "First Name": "Paisan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36700093": {
    "id": "item_9358",
    "Last Name": "Zhang",
    "First Name": "Nero (weizhen)",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36701323": {
    "id": "item_34667",
    "Last Name": "Fang",
    "First Name": "Min",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36705107": {
    "id": "item_36469",
    "Last Name": "Koh",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36706059": {
    "id": "item_11162",
    "Last Name": "Roskov",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36711744": {
    "id": "item_34666",
    "Last Name": "LIN",
    "First Name": "WEICHIEH",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36711843": {
    "id": "item_9692",
    "Last Name": "Naseby",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36712111": {
    "id": "item_34714",
    "Last Name": "Lee",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36712231": {
    "id": "item_34713",
    "Last Name": "Sugita",
    "First Name": "Odilia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36712237": {
    "id": "item_36664",
    "Last Name": "Wilson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36712351": {
    "id": "item_22035",
    "Last Name": "VIZCAINO ZAMORA",
    "First Name": "CARLOS",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36712443": {
    "id": "item_22034",
    "Last Name": "GALLARDO AVILA",
    "First Name": "JOCELYN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36712448": {
    "id": "item_36662",
    "Last Name": "Empson",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36713827": {
    "id": "item_22217",
    "Last Name": "Southern",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714137": {
    "id": "item_11193",
    "Last Name": "Jin",
    "First Name": "He",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714684": {
    "id": "item_22215",
    "Last Name": "Fysh",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714883": {
    "id": "item_36659",
    "Last Name": "Turgut",
    "First Name": "Adem",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36714991": {
    "id": "item_22213",
    "Last Name": "Kodali",
    "First Name": "Chandu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715159": {
    "id": "item_23912",
    "Last Name": "Bhatia",
    "First Name": "Sardai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715163": {
    "id": "item_37030",
    "Last Name": "Strudwick",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715336": {
    "id": "item_36704",
    "Last Name": "Murphy",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715415": {
    "id": "item_36657",
    "Last Name": "Gooshan",
    "First Name": "Nadia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715515": {
    "id": "item_9390",
    "Last Name": "Davies",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715523": {
    "id": "item_22249",
    "Last Name": "DellÕAnno",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715636": {
    "id": "item_11159",
    "Last Name": "Patel",
    "First Name": "Raj",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36715969": {
    "id": "item_9349",
    "Last Name": "Conroy",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716041": {
    "id": "item_22206",
    "Last Name": "Cowie",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716057": {
    "id": "item_11158",
    "Last Name": "Doro",
    "First Name": "Vitor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716615": {
    "id": "item_9690",
    "Last Name": "Taylor",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716655": {
    "id": "item_11155",
    "Last Name": "SLEIGHT",
    "First Name": "DAVID",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716704": {
    "id": "item_36654",
    "Last Name": "REYLLO",
    "First Name": "FERDINAND URSABIA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716811": {
    "id": "item_11191",
    "Last Name": "McKay",
    "First Name": "Corey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36716878": {
    "id": "item_22204",
    "Last Name": "Opitz-Kosuta",
    "First Name": "Jan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717076": {
    "id": "item_34711",
    "Last Name": "Malicka",
    "First Name": "Marcela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717097": {
    "id": "item_36652",
    "Last Name": "Gunawan",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717144": {
    "id": "item_34709",
    "Last Name": "MCGOVERN",
    "First Name": "ADRIENNE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717277": {
    "id": "item_36650",
    "Last Name": "Mejia",
    "First Name": "Jaime Immanuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717460": {
    "id": "item_11152",
    "Last Name": "Burford",
    "First Name": "Rusty",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717481": {
    "id": "item_22557",
    "Last Name": "Schipp",
    "First Name": "Greg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717631": {
    "id": "item_36702",
    "Last Name": "O'Reilly",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717634": {
    "id": "item_36466",
    "Last Name": "Ripley",
    "First Name": "Morrie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717818": {
    "id": "item_23907",
    "Last Name": "Grech",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36717916": {
    "id": "item_11150",
    "Last Name": "Rapeli",
    "First Name": "Hanna",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718125": {
    "id": "item_9342",
    "Last Name": "Ciuffetelli",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718365": {
    "id": "item_36701",
    "Last Name": "OÕBrien",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718393": {
    "id": "item_36700",
    "Last Name": "O'Brien",
    "First Name": "Sue",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718517": {
    "id": "item_34708",
    "Last Name": "Young",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718769": {
    "id": "item_36464",
    "Last Name": "Maul",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718815": {
    "id": "item_11148",
    "Last Name": "Lee",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718848": {
    "id": "item_36646",
    "Last Name": "Juanitez",
    "First Name": "Carlito",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36718965": {
    "id": "item_22191",
    "Last Name": "Jordan",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719606": {
    "id": "item_22189",
    "Last Name": "Dahal",
    "First Name": "Zubin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719639": {
    "id": "item_36643",
    "Last Name": "Evans",
    "First Name": "Jeannetta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36719738": {
    "id": "item_11147",
    "Last Name": "Teicher",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720007": {
    "id": "item_36636",
    "Last Name": "Liu",
    "First Name": "Yanhuan Luke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720030": {
    "id": "item_23905",
    "Last Name": "Kuchin",
    "First Name": "Max",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720103": {
    "id": "item_11022",
    "Last Name": "Fairweather",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720161": {
    "id": "item_36462",
    "Last Name": "Ho",
    "First Name": "Mee Yoke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720178": {
    "id": "item_36635",
    "Last Name": "Chang",
    "First Name": "Anne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720465": {
    "id": "item_22246",
    "Last Name": "Kurashima",
    "First Name": "Mayuko",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720585": {
    "id": "item_22186",
    "Last Name": "Kirk",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720836": {
    "id": "item_36460",
    "Last Name": "Lompot",
    "First Name": "Kim Adrian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720862": {
    "id": "item_36632",
    "Last Name": "MANUCAN",
    "First Name": "MARVIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36720963": {
    "id": "item_11145",
    "Last Name": "Rojas",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721065": {
    "id": "item_34706",
    "Last Name": "Dawe",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721173": {
    "id": "item_11143",
    "Last Name": "Vom",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721220": {
    "id": "item_11142",
    "Last Name": "Molesworth",
    "First Name": "Lilian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721454": {
    "id": "item_9330",
    "Last Name": "Johnstone",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721874": {
    "id": "item_36629",
    "Last Name": "Kioufi",
    "First Name": "Jade",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721933": {
    "id": "item_9329",
    "Last Name": "Kelly",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36721949": {
    "id": "item_11140",
    "Last Name": "Tran",
    "First Name": "Calvin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722109": {
    "id": "item_9688",
    "Last Name": "Fish",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722123": {
    "id": "item_36625",
    "Last Name": "Gutierrez",
    "First Name": "Andre Chev Orosa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722183": {
    "id": "item_22181",
    "Last Name": "Kelleher",
    "First Name": "Clare",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722186": {
    "id": "item_11139",
    "Last Name": "Donegan",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722251": {
    "id": "item_9327",
    "Last Name": "Graham",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722387": {
    "id": "item_11451",
    "Last Name": "Bourke",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722505": {
    "id": "item_23900",
    "Last Name": "Davis",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722517": {
    "id": "item_36623",
    "Last Name": "Artup",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722812": {
    "id": "item_36622",
    "Last Name": "Lockwood",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722875": {
    "id": "item_36620",
    "Last Name": "Goldin",
    "First Name": "Robyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722887": {
    "id": "item_22180",
    "Last Name": "Amiri",
    "First Name": "Farhad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722922": {
    "id": "item_22179",
    "Last Name": "Cannon-O'Brien",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722928": {
    "id": "item_36619",
    "Last Name": "Bueno",
    "First Name": "Agerico",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722954": {
    "id": "item_23898",
    "Last Name": "Roles",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36722994": {
    "id": "item_36618",
    "Last Name": "Fletcher",
    "First Name": "Jack",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723178": {
    "id": "item_22176",
    "Last Name": "Hough",
    "First Name": "Max",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723392": {
    "id": "item_36614",
    "Last Name": "Ho",
    "First Name": "Kai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723408": {
    "id": "item_36613",
    "Last Name": "Carmady",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723439": {
    "id": "item_36612",
    "Last Name": "de los Santos",
    "First Name": "Carlo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723519": {
    "id": "item_9322",
    "Last Name": "Wiradharma",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723580": {
    "id": "item_34663",
    "Last Name": "Chuu",
    "First Name": "Wenmin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723634": {
    "id": "item_36609",
    "Last Name": "Moskvita",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723703": {
    "id": "item_11133",
    "Last Name": "Corlis",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723707": {
    "id": "item_22175",
    "Last Name": "Hayes",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723783": {
    "id": "item_22174",
    "Last Name": "Godfrey",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723809": {
    "id": "item_23833",
    "Last Name": "Cheung",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723903": {
    "id": "item_9388",
    "Last Name": "Laviolette",
    "First Name": "Braydon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36723960": {
    "id": "item_9319",
    "Last Name": "Aoki",
    "First Name": "Hiroyuki",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724087": {
    "id": "item_36607",
    "Last Name": "Horobin",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724222": {
    "id": "item_11131",
    "Last Name": "Seljanovski",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724228": {
    "id": "item_9317",
    "Last Name": "Coleman",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724349": {
    "id": "item_34703",
    "Last Name": "Rathi",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724566": {
    "id": "item_22170",
    "Last Name": "Feeney",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724660": {
    "id": "item_22169",
    "Last Name": "Reyes",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724698": {
    "id": "item_9314",
    "Last Name": "Woodward",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724710": {
    "id": "item_22167",
    "Last Name": "Mc Gill",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724711": {
    "id": "item_22168",
    "Last Name": "Chan",
    "First Name": "Joyce",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724729": {
    "id": "item_9313",
    "Last Name": "Pereira",
    "First Name": "Warren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724784": {
    "id": "item_36458",
    "Last Name": "Binti Saroni",
    "First Name": "Azianty",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724789": {
    "id": "item_22166",
    "Last Name": "Mason",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724821": {
    "id": "item_11015",
    "Last Name": "LEE",
    "First Name": "SANGHYEOP",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724849": {
    "id": "item_9686",
    "Last Name": "Davidson",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724902": {
    "id": "item_9312",
    "Last Name": "Slaven",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36724938": {
    "id": "item_34702",
    "Last Name": "Markey-Towler",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725024": {
    "id": "item_36602",
    "Last Name": "Nguyen",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725090": {
    "id": "item_9311",
    "Last Name": "Dufourq",
    "First Name": "Rick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725139": {
    "id": "item_11014",
    "Last Name": "Marfell",
    "First Name": "Stu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725305": {
    "id": "item_9387",
    "Last Name": "Weston",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725424": {
    "id": "item_11185",
    "Last Name": "Szach",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725482": {
    "id": "item_22553",
    "Last Name": "Bland",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725573": {
    "id": "item_11012",
    "Last Name": "Hillan",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725614": {
    "id": "item_34701",
    "Last Name": "Easterbrook",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725780": {
    "id": "item_34662",
    "Last Name": "LEE",
    "First Name": "YISHAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725841": {
    "id": "item_36696",
    "Last Name": "Rainbird",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725858": {
    "id": "item_11123",
    "Last Name": "Blackband",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725870": {
    "id": "item_36597",
    "Last Name": "Wavikar",
    "First Name": "Sameer",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725942": {
    "id": "item_9308",
    "Last Name": "Lynn",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725958": {
    "id": "item_9307",
    "Last Name": "Gillespie",
    "First Name": "Shane Bernard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36725980": {
    "id": "item_36596",
    "Last Name": "Bye",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726004": {
    "id": "item_9306",
    "Last Name": "Wiradharma",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726016": {
    "id": "item_11120",
    "Last Name": "Nicolaou",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726021": {
    "id": "item_9304",
    "Last Name": "Hunt",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726023": {
    "id": "item_22550",
    "Last Name": "hayes",
    "First Name": "darrin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726053": {
    "id": "item_36595",
    "Last Name": "XU",
    "First Name": "KAI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726060": {
    "id": "item_9303",
    "Last Name": "qian",
    "First Name": "Liangliang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726068": {
    "id": "item_22549",
    "Last Name": "Byrne",
    "First Name": "Mariana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726095": {
    "id": "item_34697",
    "Last Name": "McKinnon",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726114": {
    "id": "item_11119",
    "Last Name": "Liddle",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726118": {
    "id": "item_9301",
    "Last Name": "Huang",
    "First Name": "Alick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726125": {
    "id": "item_11184",
    "Last Name": "Foster",
    "First Name": "Jock",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726138": {
    "id": "item_9300",
    "Last Name": "Scarce",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726216": {
    "id": "item_22548",
    "Last Name": "James",
    "First Name": "Sharleen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726244": {
    "id": "item_22154",
    "Last Name": "Fitzgerald",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726258": {
    "id": "item_11183",
    "Last Name": "Chia",
    "First Name": "Jun Yong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726298": {
    "id": "item_36454",
    "Last Name": "Ciu",
    "First Name": "Vera Andayani",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726367": {
    "id": "item_34721",
    "Last Name": "Yeung",
    "First Name": "Janette",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726408": {
    "id": "item_22027",
    "Last Name": "Chan",
    "First Name": "Ka Chung",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726504": {
    "id": "item_9296",
    "Last Name": "Giltinan",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726556": {
    "id": "item_34695",
    "Last Name": "Warner",
    "First Name": "Guy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726567": {
    "id": "item_11115",
    "Last Name": "Hasebe",
    "First Name": "Nao",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726611": {
    "id": "item_9294",
    "Last Name": "Tang chai hock",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726647": {
    "id": "item_9684",
    "Last Name": "Pereira",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726686": {
    "id": "item_34720",
    "Last Name": "O'Brien",
    "First Name": "Ali",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726702": {
    "id": "item_9212",
    "Last Name": "Hruska",
    "First Name": "Jakub",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726716": {
    "id": "item_36588",
    "Last Name": "Parker",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726757": {
    "id": "item_22151",
    "Last Name": "Gerlich",
    "First Name": "Ladislav",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726758": {
    "id": "item_9290",
    "Last Name": "Nogales Pastrana",
    "First Name": "Mario",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726777": {
    "id": "item_23939",
    "Last Name": "Spotswood",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726788": {
    "id": "item_22150",
    "Last Name": "Mezger",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726802": {
    "id": "item_36693",
    "Last Name": "Smids",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726841": {
    "id": "item_36585",
    "Last Name": "Yin",
    "First Name": "Yifan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726845": {
    "id": "item_23891",
    "Last Name": "Brien",
    "First Name": "Ciara",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726847": {
    "id": "item_9289",
    "Last Name": "Hurst",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726857": {
    "id": "item_11181",
    "Last Name": "Clarke",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726887": {
    "id": "item_36582",
    "Last Name": "Williams",
    "First Name": "Garry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726900": {
    "id": "item_9287",
    "Last Name": "Kirrane",
    "First Name": "Keith",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726913": {
    "id": "item_22547",
    "Last Name": "Evans",
    "First Name": "Maisie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726919": {
    "id": "item_11180",
    "Last Name": "Black",
    "First Name": "Corrina",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726965": {
    "id": "item_22147",
    "Last Name": "Housein",
    "First Name": "Clare",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726974": {
    "id": "item_23937",
    "Last Name": "Peiris",
    "First Name": "Randy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36726981": {
    "id": "item_11107",
    "Last Name": "kitagawa",
    "First Name": "shinroku",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727014": {
    "id": "item_36577",
    "Last Name": "Nievergelt",
    "First Name": "Juliet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727017": {
    "id": "item_9381",
    "Last Name": "Edmonds",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727020": {
    "id": "item_22146",
    "Last Name": "Keevers",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727021": {
    "id": "item_22241",
    "Last Name": "Edyvane",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727027": {
    "id": "item_22240",
    "Last Name": "Cooney",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727055": {
    "id": "item_36576",
    "Last Name": "Tomlin",
    "First Name": "Billy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727069": {
    "id": "item_9286",
    "Last Name": "Xenos",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727114": {
    "id": "item_9284",
    "Last Name": "Monteleone",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727138": {
    "id": "item_22142",
    "Last Name": "Lucas",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727145": {
    "id": "item_34693",
    "Last Name": "Stallinger",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727169": {
    "id": "item_36571",
    "Last Name": "Wang",
    "First Name": "Jing",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727220": {
    "id": "item_22141",
    "Last Name": "Majoor",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727289": {
    "id": "item_11178",
    "Last Name": "Pham",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727301": {
    "id": "item_22139",
    "Last Name": "Burgin",
    "First Name": "Bec",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727350": {
    "id": "item_36568",
    "Last Name": "Wong",
    "First Name": "ChiewKhuen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727360": {
    "id": "item_34692",
    "Last Name": "Uy",
    "First Name": "Tara Kenisha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727361": {
    "id": "item_36689",
    "Last Name": "McShane",
    "First Name": "Annette",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727429": {
    "id": "item_22137",
    "Last Name": "Pollak",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727436": {
    "id": "item_34691",
    "Last Name": "Kelly",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727460": {
    "id": "item_23883",
    "Last Name": "Upton",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727629": {
    "id": "item_11102",
    "Last Name": "Hahn-Hill",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36727758": {
    "id": "item_23882",
    "Last Name": "Son",
    "First Name": "Sekwang",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728018": {
    "id": "item_9280",
    "Last Name": "McKelvey",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728060": {
    "id": "item_22134",
    "Last Name": "O'Farrell",
    "First Name": "Ellery",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728130": {
    "id": "item_36687",
    "Last Name": "Nguyen",
    "First Name": "Khoa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728492": {
    "id": "item_22129",
    "Last Name": "Montaos",
    "First Name": "Arvin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728509": {
    "id": "item_11009",
    "Last Name": "Shi",
    "First Name": "Sha",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728607": {
    "id": "item_11176",
    "Last Name": "Moore",
    "First Name": "Ollie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36728690": {
    "id": "item_9277",
    "Last Name": "Hawtrey",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729243": {
    "id": "item_11099",
    "Last Name": "Hamley",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36729691": {
    "id": "item_22126",
    "Last Name": "Almasri",
    "First Name": "Nedal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36730224": {
    "id": "item_36685",
    "Last Name": "Ferreira Sie Yong",
    "First Name": "Francine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36730252": {
    "id": "item_23832",
    "Last Name": "Stasiuk",
    "First Name": "Leah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36731419": {
    "id": "item_22124",
    "Last Name": "Behan",
    "First Name": "Aoife",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36731511": {
    "id": "item_36451",
    "Last Name": "PAN",
    "First Name": "HSING JUI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36731528": {
    "id": "item_34661",
    "Last Name": "Takenaka",
    "First Name": "Osamu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36731543": {
    "id": "item_34660",
    "Last Name": "Takenaka",
    "First Name": "Sayuri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36731797": {
    "id": "item_9276",
    "Last Name": "Savage",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36732684": {
    "id": "item_11098",
    "Last Name": "Ouyang",
    "First Name": "Zi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36732801": {
    "id": "item_9375",
    "Last Name": "Kwong",
    "First Name": "Colby",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36733255": {
    "id": "item_36554",
    "Last Name": "Jung",
    "First Name": "Alisha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36733944": {
    "id": "item_11097",
    "Last Name": "Quach",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36734245": {
    "id": "item_36552",
    "Last Name": "Chung",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36735320": {
    "id": "item_22025",
    "Last Name": "Jariyathitipong",
    "First Name": "Wilawan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36735686": {
    "id": "item_34687",
    "Last Name": "Mathieu",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36736545": {
    "id": "item_23830",
    "Last Name": "JIANG",
    "First Name": "ZE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36738788": {
    "id": "item_23829",
    "Last Name": "MIURA",
    "First Name": "TOMOYUKI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36739400": {
    "id": "item_36551",
    "Last Name": "Holten",
    "First Name": "Briona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36739669": {
    "id": "item_11096",
    "Last Name": "Heller",
    "First Name": "Marshall",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36742935": {
    "id": "item_34656",
    "Last Name": "Tang",
    "First Name": "Dai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36747859": {
    "id": "item_34655",
    "Last Name": "Tan",
    "First Name": "Marilyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36749213": {
    "id": "item_34719",
    "Last Name": "Sobania",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36750819": {
    "id": "item_36550",
    "Last Name": "Chia",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36751067": {
    "id": "item_22117",
    "Last Name": "Lacey",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36751105": {
    "id": "item_34652",
    "Last Name": "YANG",
    "First Name": "Fan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36751236": {
    "id": "item_9204",
    "Last Name": "Dela Cruz",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36752138": {
    "id": "item_23880",
    "Last Name": "Louw",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36752445": {
    "id": "item_9269",
    "Last Name": "Boros",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36752464": {
    "id": "item_9270",
    "Last Name": "Fotheringham",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36752927": {
    "id": "item_23878",
    "Last Name": "Johnson",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753235": {
    "id": "item_34718",
    "Last Name": "Roberts",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753252": {
    "id": "item_9266",
    "Last Name": "Kane",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753275": {
    "id": "item_22022",
    "Last Name": "Craik",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36753485": {
    "id": "item_22114",
    "Last Name": "Wong",
    "First Name": "Curtis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754042": {
    "id": "item_24149",
    "Last Name": "Kretchmer",
    "First Name": "Jai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754092": {
    "id": "item_36541",
    "Last Name": "Deng",
    "First Name": "Wilson",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754285": {
    "id": "item_36682",
    "Last Name": "Langley",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754287": {
    "id": "item_22235",
    "Last Name": "Muhlen-Schulte",
    "First Name": "Tjuntu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754365": {
    "id": "item_36540",
    "Last Name": "Clayton",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754590": {
    "id": "item_9261",
    "Last Name": "Schork",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754662": {
    "id": "item_36539",
    "Last Name": "Ho",
    "First Name": "Kris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36754672": {
    "id": "item_9259",
    "Last Name": "Willand",
    "First Name": "Statler",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755145": {
    "id": "item_22111",
    "Last Name": "Murray",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755495": {
    "id": "item_34683",
    "Last Name": "Do",
    "First Name": "Mai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755559": {
    "id": "item_9258",
    "Last Name": "Bullivant",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755688": {
    "id": "item_22233",
    "Last Name": "Camargo",
    "First Name": "Ivonne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755704": {
    "id": "item_36537",
    "Last Name": "Francisco",
    "First Name": "Enzo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36755889": {
    "id": "item_36535",
    "Last Name": "Francey",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756200": {
    "id": "item_9680",
    "Last Name": "Ferrif",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756358": {
    "id": "item_36534",
    "Last Name": "Woodward",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756388": {
    "id": "item_37142",
    "Last Name": "Nguyen",
    "First Name": "Phuong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756421": {
    "id": "item_24148",
    "Last Name": "Macauley",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756430": {
    "id": "item_22103",
    "Last Name": "Maddern",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756474": {
    "id": "item_9374",
    "Last Name": "Beasley",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756495": {
    "id": "item_36532",
    "Last Name": "Qin",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36756883": {
    "id": "item_11089",
    "Last Name": "Cacciatori",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757019": {
    "id": "item_22101",
    "Last Name": "Burn",
    "First Name": "Morenna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757312": {
    "id": "item_36530",
    "Last Name": "Louden",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757385": {
    "id": "item_23931",
    "Last Name": "Ku",
    "First Name": "Siu Fai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757406": {
    "id": "item_9372",
    "Last Name": "Mckenzie",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757532": {
    "id": "item_22100",
    "Last Name": "Kovacevic",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757652": {
    "id": "item_9371",
    "Last Name": "Mataira",
    "First Name": "Logan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757676": {
    "id": "item_9370",
    "Last Name": "Li",
    "First Name": "Jie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757737": {
    "id": "item_11087",
    "Last Name": "Sier",
    "First Name": "Jai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757773": {
    "id": "item_11086",
    "Last Name": "Zaidi",
    "First Name": "Ali",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36757983": {
    "id": "item_22096",
    "Last Name": "Sun",
    "First Name": "Ioulia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758003": {
    "id": "item_22097",
    "Last Name": "Sun",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758025": {
    "id": "item_11085",
    "Last Name": "Hoft",
    "First Name": "Rainer",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758032": {
    "id": "item_22095",
    "Last Name": "Derrick",
    "First Name": "Graham",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758108": {
    "id": "item_11084",
    "Last Name": "Heddles",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758325": {
    "id": "item_11083",
    "Last Name": "shen",
    "First Name": "teng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758352": {
    "id": "item_23864",
    "Last Name": "Zammit",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758567": {
    "id": "item_9203",
    "Last Name": "Gaffney",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758708": {
    "id": "item_23863",
    "Last Name": "Callaghan",
    "First Name": "Bronte",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36758833": {
    "id": "item_9369",
    "Last Name": "Hammond",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759005": {
    "id": "item_22093",
    "Last Name": "wadsworth",
    "First Name": "zacariah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759061": {
    "id": "item_22231",
    "Last Name": "Dobson",
    "First Name": "Marshall",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759137": {
    "id": "item_22229",
    "Last Name": "Davis",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759254": {
    "id": "item_34650",
    "Last Name": "Joveres",
    "First Name": "Kristina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759264": {
    "id": "item_23862",
    "Last Name": "Molen-Grigull",
    "First Name": "Katia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759315": {
    "id": "item_23861",
    "Last Name": "Mupariwa",
    "First Name": "Felix",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759403": {
    "id": "item_23859",
    "Last Name": "Koyama",
    "First Name": "Masayuki",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759602": {
    "id": "item_9247",
    "Last Name": "Andrews",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759713": {
    "id": "item_37017",
    "Last Name": "Williams",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759820": {
    "id": "item_34649",
    "Last Name": "Shiba",
    "First Name": "Makoto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759864": {
    "id": "item_22088",
    "Last Name": "Kemeys",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36759963": {
    "id": "item_36524",
    "Last Name": "Shah",
    "First Name": "Abhi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760033": {
    "id": "item_11077",
    "Last Name": "Mukai",
    "First Name": "Kae",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760222": {
    "id": "item_9246",
    "Last Name": "Yu",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760224": {
    "id": "item_22669",
    "Last Name": "Bruce",
    "First Name": "Debbie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760334": {
    "id": "item_9201",
    "Last Name": "Centeno",
    "First Name": "Tomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760419": {
    "id": "item_11076",
    "Last Name": "Wang",
    "First Name": "Wilson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760734": {
    "id": "item_9368",
    "Last Name": "Shaw",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36760840": {
    "id": "item_11075",
    "Last Name": "carpentieri",
    "First Name": "Iacopo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761089": {
    "id": "item_9200",
    "Last Name": "Moulonguet",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761232": {
    "id": "item_36517",
    "Last Name": "Nguyen",
    "First Name": "Paige",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761474": {
    "id": "item_11072",
    "Last Name": "Angelopoulos",
    "First Name": "Theo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761788": {
    "id": "item_9240",
    "Last Name": "Reapy",
    "First Name": "Gary",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36761971": {
    "id": "item_9678",
    "Last Name": "Hardie",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762077": {
    "id": "item_11069",
    "Last Name": "Shi",
    "First Name": "Tao",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762193": {
    "id": "item_9238",
    "Last Name": "Tanabe",
    "First Name": "Yoshikata",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762202": {
    "id": "item_23826",
    "Last Name": "Maclean",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762304": {
    "id": "item_36678",
    "Last Name": "Da Costa Bianchi",
    "First Name": "Denis",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762556": {
    "id": "item_34676",
    "Last Name": "Lakin",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762594": {
    "id": "item_23856",
    "Last Name": "Liang",
    "First Name": "Parker",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36762683": {
    "id": "item_11066",
    "Last Name": "Murray",
    "First Name": "Julian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763204": {
    "id": "item_11064",
    "Last Name": "Larance",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763235": {
    "id": "item_23855",
    "Last Name": "Costa",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763417": {
    "id": "item_9235",
    "Last Name": "Fletcher",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763766": {
    "id": "item_22074",
    "Last Name": "Nee",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763772": {
    "id": "item_11441",
    "Last Name": "Marchioro",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763775": {
    "id": "item_9232",
    "Last Name": "Meinertzhagen",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763889": {
    "id": "item_36507",
    "Last Name": "Flood",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36763955": {
    "id": "item_23854",
    "Last Name": "Kwok",
    "First Name": "Ka Ho",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764089": {
    "id": "item_9199",
    "Last Name": "KIM",
    "First Name": "INKI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764438": {
    "id": "item_34648",
    "Last Name": "MURAYAMA",
    "First Name": "MAMORU",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764651": {
    "id": "item_22072",
    "Last Name": "Cole",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764795": {
    "id": "item_22070",
    "Last Name": "Kao",
    "First Name": "Tina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764796": {
    "id": "item_22017",
    "Last Name": "Kumaraguru-Ng",
    "First Name": "Jairaj",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764844": {
    "id": "item_11440",
    "Last Name": "Postnikov",
    "First Name": "Dima",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36764873": {
    "id": "item_22069",
    "Last Name": "Gates",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36765411": {
    "id": "item_9229",
    "Last Name": "Sandrasegaran",
    "First Name": "Aran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36765453": {
    "id": "item_23852",
    "Last Name": "Wijeratne",
    "First Name": "Sachin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36765802": {
    "id": "item_22067",
    "Last Name": "Katafono",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36765888": {
    "id": "item_22066",
    "Last Name": "Kelly",
    "First Name": "Paula",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36766140": {
    "id": "item_36677",
    "Last Name": "simmons",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36767144": {
    "id": "item_36499",
    "Last Name": "Clarke",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36767444": {
    "id": "item_23924",
    "Last Name": "Moscript",
    "First Name": "Tegan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36767543": {
    "id": "item_24144",
    "Last Name": "Harrison",
    "First Name": "Neil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36767899": {
    "id": "item_36497",
    "Last Name": "Machimbidza",
    "First Name": "Auten",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36767937": {
    "id": "item_23851",
    "Last Name": "Murphy",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768007": {
    "id": "item_11439",
    "Last Name": "Flack",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768068": {
    "id": "item_22537",
    "Last Name": "NuÕu",
    "First Name": "Bob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768103": {
    "id": "item_11539",
    "Last Name": "Calvetti",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768290": {
    "id": "item_36495",
    "Last Name": "Lactao",
    "First Name": "Ranee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768515": {
    "id": "item_22063",
    "Last Name": "Gee",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768520": {
    "id": "item_22061",
    "Last Name": "Jenkins",
    "First Name": "Simonie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36768542": {
    "id": "item_11052",
    "Last Name": "Cherubino",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769211": {
    "id": "item_23923",
    "Last Name": "Williamson",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769234": {
    "id": "item_34716",
    "Last Name": "Broughton-Wright",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769426": {
    "id": "item_9226",
    "Last Name": "deng",
    "First Name": "yangwen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769513": {
    "id": "item_22224",
    "Last Name": "Reckord",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769574": {
    "id": "item_9198",
    "Last Name": "Wang",
    "First Name": "Han",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769738": {
    "id": "item_34645",
    "Last Name": "SETIAWAN",
    "First Name": "ISWAHYUGO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769846": {
    "id": "item_34644",
    "Last Name": "Lai",
    "First Name": "Yun Choi Eddie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769883": {
    "id": "item_22056",
    "Last Name": "Pham",
    "First Name": "Tuyen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36769928": {
    "id": "item_9364",
    "Last Name": "McMullen",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36770432": {
    "id": "item_34671",
    "Last Name": "Neelisetti",
    "First Name": "Hareesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36770600": {
    "id": "item_23921",
    "Last Name": "Smedley",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36770973": {
    "id": "item_22015",
    "Last Name": "de Keersmaeker",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771074": {
    "id": "item_11042",
    "Last Name": "Coghlan",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771352": {
    "id": "item_9225",
    "Last Name": "Pappas",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771360": {
    "id": "item_22222",
    "Last Name": "Mccarthy",
    "First Name": "Jarryd",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771515": {
    "id": "item_9197",
    "Last Name": "Limon-Monroy",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771532": {
    "id": "item_11041",
    "Last Name": "wilde",
    "First Name": "bryce",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771625": {
    "id": "item_11040",
    "Last Name": "Karam",
    "First Name": "Hunter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771633": {
    "id": "item_22014",
    "Last Name": "Schumacher",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771840": {
    "id": "item_34669",
    "Last Name": "Lai",
    "First Name": "Francis",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771844": {
    "id": "item_11166",
    "Last Name": "Ridgard",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36771932": {
    "id": "item_11165",
    "Last Name": "Angove",
    "First Name": "Edwina",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772102": {
    "id": "item_11003",
    "Last Name": "Hong",
    "First Name": "Li Wee",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772116": {
    "id": "item_22051",
    "Last Name": "Villadolid",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772120": {
    "id": "item_22049",
    "Last Name": "Macmillan",
    "First Name": "Alisdair",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772132": {
    "id": "item_11036",
    "Last Name": "Wring",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772138": {
    "id": "item_11037",
    "Last Name": "Herbelot",
    "First Name": "Matteo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772151": {
    "id": "item_22048",
    "Last Name": "Glendinning",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772156": {
    "id": "item_36485",
    "Last Name": "Kim",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772195": {
    "id": "item_11034",
    "Last Name": "Rayner",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772287": {
    "id": "item_9223",
    "Last Name": "Argall",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772314": {
    "id": "item_9222",
    "Last Name": "Abel",
    "First Name": "Matty",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36772373": {
    "id": "item_11033",
    "Last Name": "Boers",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774622": {
    "id": "item_22536",
    "Last Name": "Russell",
    "First Name": "Dane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774701": {
    "id": "item_36480",
    "Last Name": "Drew",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774716": {
    "id": "item_11030",
    "Last Name": "Meade",
    "First Name": "Barry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774741": {
    "id": "item_36479",
    "Last Name": "Pham",
    "First Name": "Thang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774845": {
    "id": "item_9220",
    "Last Name": "Smollerup",
    "First Name": "Frederik",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774887": {
    "id": "item_23838",
    "Last Name": "Cai",
    "First Name": "Lillian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36774891": {
    "id": "item_36477",
    "Last Name": "Makarewicz",
    "First Name": "Logan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36775140": {
    "id": "item_23836",
    "Last Name": "TONG",
    "First Name": "YIMING",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36779282": {
    "id": "item_11026",
    "Last Name": "Coleman",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36779469": {
    "id": "item_22221",
    "Last Name": "Espejo",
    "First Name": "Florencio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36780453": {
    "id": "item_9196",
    "Last Name": "Mawer",
    "First Name": "Shamiso",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784017": {
    "id": "item_36472",
    "Last Name": "Box",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784034": {
    "id": "item_36471",
    "Last Name": "Vizuete",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784056": {
    "id": "item_22038",
    "Last Name": "Kirwan",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784065": {
    "id": "item_22039",
    "Last Name": "Hammerton",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784095": {
    "id": "item_22037",
    "Last Name": "Summersgill",
    "First Name": "Ciara",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784211": {
    "id": "item_9217",
    "Last Name": "Cormack",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784225": {
    "id": "item_22036",
    "Last Name": "Pettit",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784231": {
    "id": "item_34643",
    "Last Name": "apinanthanapat",
    "First Name": "panupakorn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784288": {
    "id": "item_9362",
    "Last Name": "Helmot",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784349": {
    "id": "item_23919",
    "Last Name": "Shirer",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784351": {
    "id": "item_11023",
    "Last Name": "Wong",
    "First Name": "Elijah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36784371": {
    "id": "item_22033",
    "Last Name": "BONALUME",
    "First Name": "MICHEL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785336": {
    "id": "item_36465",
    "Last Name": "Cody",
    "First Name": "Lara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785350": {
    "id": "item_23918",
    "Last Name": "Gill",
    "First Name": "WIlliam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785354": {
    "id": "item_11435",
    "Last Name": "Glennan",
    "First Name": "Troy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785362": {
    "id": "item_34642",
    "Last Name": "Dosado",
    "First Name": "Wira",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785409": {
    "id": "item_22533",
    "Last Name": "Pearson",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785416": {
    "id": "item_22032",
    "Last Name": "Parra",
    "First Name": "Carla",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785422": {
    "id": "item_23834",
    "Last Name": "Harley",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785441": {
    "id": "item_36461",
    "Last Name": "Pearson",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785446": {
    "id": "item_11020",
    "Last Name": "Harding",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785456": {
    "id": "item_36459",
    "Last Name": "Ly Kui",
    "First Name": "Andy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785469": {
    "id": "item_9360",
    "Last Name": "Bound",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785470": {
    "id": "item_11019",
    "Last Name": "Cornell",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785472": {
    "id": "item_11016",
    "Last Name": "Smith",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785482": {
    "id": "item_11017",
    "Last Name": "Gordon",
    "First Name": "Owen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785493": {
    "id": "item_11013",
    "Last Name": "Sananikone",
    "First Name": "Gibson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785512": {
    "id": "item_9213",
    "Last Name": "Allegrini",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785553": {
    "id": "item_11011",
    "Last Name": "Raisbeck",
    "First Name": "Troy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785630": {
    "id": "item_9211",
    "Last Name": "Flannery",
    "First Name": "Donal",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785638": {
    "id": "item_36669",
    "Last Name": "Harris",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785663": {
    "id": "item_9210",
    "Last Name": "Brown",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785705": {
    "id": "item_22220",
    "Last Name": "Derrick",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785798": {
    "id": "item_34658",
    "Last Name": "Jones",
    "First Name": "Alastair",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785801": {
    "id": "item_23831",
    "Last Name": "Hennings",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785804": {
    "id": "item_9207",
    "Last Name": "Mullan",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785838": {
    "id": "item_9206",
    "Last Name": "Donohoe",
    "First Name": "Cillian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785857": {
    "id": "item_11002",
    "Last Name": "Rubin",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785874": {
    "id": "item_11434",
    "Last Name": "Taylor",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785877": {
    "id": "item_34653",
    "Last Name": "Dedinja",
    "First Name": "Ilir",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785902": {
    "id": "item_22021",
    "Last Name": "Castle",
    "First Name": "Brad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785915": {
    "id": "item_34651",
    "Last Name": "Tran",
    "First Name": "Tri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785916": {
    "id": "item_11001",
    "Last Name": "Ong",
    "First Name": "Yong Kiat",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785925": {
    "id": "item_11006",
    "Last Name": "Povey",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785984": {
    "id": "item_36666",
    "Last Name": "Coleman",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36785991": {
    "id": "item_34641",
    "Last Name": "Aromas",
    "First Name": "Camille",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786000": {
    "id": "item_22584",
    "Last Name": "Chan",
    "First Name": "Poling",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786026": {
    "id": "item_37048",
    "Last Name": "Waygood",
    "First Name": "Eden",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786043": {
    "id": "item_9195",
    "Last Name": "Harre",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786049": {
    "id": "item_22219",
    "Last Name": "Castro",
    "First Name": "Ranizel Lambert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786067": {
    "id": "item_22581",
    "Last Name": "Kipp",
    "First Name": "Di",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786077": {
    "id": "item_22580",
    "Last Name": "Dugdale",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786099": {
    "id": "item_9673",
    "Last Name": "Chung",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786100": {
    "id": "item_22579",
    "Last Name": "Jurd",
    "First Name": "Robyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786114": {
    "id": "item_11469",
    "Last Name": "Yeomans",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786133": {
    "id": "item_11000",
    "Last Name": "Nugent",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786140": {
    "id": "item_9709",
    "Last Name": "Langridge",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786191": {
    "id": "item_11466",
    "Last Name": "Davies",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786197": {
    "id": "item_9706",
    "Last Name": "Peng",
    "First Name": "Chenghai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786232": {
    "id": "item_22575",
    "Last Name": "Torville",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786272": {
    "id": "item_23916",
    "Last Name": "Silleto",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786339": {
    "id": "item_24155",
    "Last Name": "Sheridan",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786343": {
    "id": "item_36663",
    "Last Name": "Low",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786367": {
    "id": "item_9704",
    "Last Name": "Brown",
    "First Name": "Alasdair",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786368": {
    "id": "item_24153",
    "Last Name": "Neill",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786373": {
    "id": "item_24152",
    "Last Name": "Geyer",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786423": {
    "id": "item_9703",
    "Last Name": "Shi",
    "First Name": "Xiaolei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786439": {
    "id": "item_9357",
    "Last Name": "Goddard",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786486": {
    "id": "item_34640",
    "Last Name": "han",
    "First Name": "lili",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786500": {
    "id": "item_9356",
    "Last Name": "Franklin",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786502": {
    "id": "item_9701",
    "Last Name": "Alder",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786506": {
    "id": "item_37039",
    "Last Name": "Moreira",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786547": {
    "id": "item_34838",
    "Last Name": "Bolton",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786552": {
    "id": "item_10999",
    "Last Name": "Ohara",
    "First Name": "Yoshihiko",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786553": {
    "id": "item_9699",
    "Last Name": "Farrenkothen",
    "First Name": "Kristafor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786573": {
    "id": "item_22569",
    "Last Name": "Lynch",
    "First Name": "Bertie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786582": {
    "id": "item_22568",
    "Last Name": "Doublet",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786636": {
    "id": "item_11430",
    "Last Name": "Clifton",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786645": {
    "id": "item_11460",
    "Last Name": "Hagan",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786789": {
    "id": "item_22566",
    "Last Name": "Pinhorn",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786866": {
    "id": "item_37031",
    "Last Name": "Brugo",
    "First Name": "Graham",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786881": {
    "id": "item_36660",
    "Last Name": "Guo",
    "First Name": "Nianen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786889": {
    "id": "item_34843",
    "Last Name": "Darcey",
    "First Name": "Paige",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786934": {
    "id": "item_22561",
    "Last Name": "Lange",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786952": {
    "id": "item_9691",
    "Last Name": "Kotlar",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36786977": {
    "id": "item_22559",
    "Last Name": "Conway",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787056": {
    "id": "item_37029",
    "Last Name": "Marshall",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787148": {
    "id": "item_34639",
    "Last Name": "Usman",
    "First Name": "Mila Maulidina Mardhani",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787216": {
    "id": "item_37028",
    "Last Name": "Eddings",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787279": {
    "id": "item_11453",
    "Last Name": "Truong",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787308": {
    "id": "item_37026",
    "Last Name": "Hussain",
    "First Name": "Syed Dawer",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787349": {
    "id": "item_11452",
    "Last Name": "Hoskins",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787482": {
    "id": "item_24150",
    "Last Name": "Louey",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787520": {
    "id": "item_9194",
    "Last Name": "SUZUKI",
    "First Name": "JOJI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787609": {
    "id": "item_9354",
    "Last Name": "Kellerman",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36787632": {
    "id": "item_22529",
    "Last Name": "Griffiths",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36904793": {
    "id": "item_37109",
    "Last Name": "Nizam",
    "First Name": "Khairul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36906088": {
    "id": "item_37110",
    "Last Name": "Bin Rashid",
    "First Name": "Muhammad Hasbullah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928250": {
    "id": "item_24178",
    "Last Name": "Vercoe",
    "First Name": "Finn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928255": {
    "id": "item_22643",
    "Last Name": "Collins",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928279": {
    "id": "item_11508",
    "Last Name": "Fraser",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928285": {
    "id": "item_9743",
    "Last Name": "Swain",
    "First Name": "Reuben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928308": {
    "id": "item_22644",
    "Last Name": "Millard",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928318": {
    "id": "item_11509",
    "Last Name": "Ochoa Rivera",
    "First Name": "Nestor Alejandro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928320": {
    "id": "item_9744",
    "Last Name": "Lilu",
    "First Name": "Dion",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928356": {
    "id": "item_22645",
    "Last Name": "Fahad",
    "First Name": "Georgie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928360": {
    "id": "item_9745",
    "Last Name": "Macdougall",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928368": {
    "id": "item_22646",
    "Last Name": "Guntamadugu",
    "First Name": "Dileep",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928371": {
    "id": "item_11510",
    "Last Name": "Cardone",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928387": {
    "id": "item_37111",
    "Last Name": "Day",
    "First Name": "Molly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928390": {
    "id": "item_11511",
    "Last Name": "Nash",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928392": {
    "id": "item_24179",
    "Last Name": "White",
    "First Name": "Kath",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928397": {
    "id": "item_22647",
    "Last Name": "Cheung",
    "First Name": "Mike",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928398": {
    "id": "item_37112",
    "Last Name": "Molander",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928401": {
    "id": "item_22648",
    "Last Name": "Yuthawongsuk",
    "First Name": "Supakorn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928411": {
    "id": "item_34862",
    "Last Name": "Natoli",
    "First Name": "Gianfranco",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928423": {
    "id": "item_34861",
    "Last Name": "Ring",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928433": {
    "id": "item_37113",
    "Last Name": "Perriotte",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928465": {
    "id": "item_22649",
    "Last Name": "Treloar",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928467": {
    "id": "item_22650",
    "Last Name": "Hackett",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928471": {
    "id": "item_9746",
    "Last Name": "Briones",
    "First Name": "Andres",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928472": {
    "id": "item_22652",
    "Last Name": "Dinh",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928476": {
    "id": "item_9747",
    "Last Name": "Thieu",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928483": {
    "id": "item_24180",
    "Last Name": "FARQUHAR",
    "First Name": "HUGH",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928485": {
    "id": "item_37114",
    "Last Name": "Spadaccini",
    "First Name": "Zorica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928487": {
    "id": "item_22651",
    "Last Name": "Naghoni-Bakhtiari",
    "First Name": "Poulad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928506": {
    "id": "item_11512",
    "Last Name": "Park",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928514": {
    "id": "item_22653",
    "Last Name": "McCulloch",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928519": {
    "id": "item_34863",
    "Last Name": "Dickson",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928537": {
    "id": "item_9748",
    "Last Name": "Ward",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928544": {
    "id": "item_11513",
    "Last Name": "Cooke",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928551": {
    "id": "item_22654",
    "Last Name": "Foodey",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928556": {
    "id": "item_24181",
    "Last Name": "Henry",
    "First Name": "Roxanne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928564": {
    "id": "item_9749",
    "Last Name": "Liebelt",
    "First Name": "Grace",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928582": {
    "id": "item_11514",
    "Last Name": "Gonzalez",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928589": {
    "id": "item_22655",
    "Last Name": "Lau",
    "First Name": "Siu Tung",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928638": {
    "id": "item_9750",
    "Last Name": "Mckenzie",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928656": {
    "id": "item_22656",
    "Last Name": "Peduru-Arachchige",
    "First Name": "Kristina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928657": {
    "id": "item_34864",
    "Last Name": "Stark",
    "First Name": "Aimee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928659": {
    "id": "item_37115",
    "Last Name": "Flannagan",
    "First Name": "Lilly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928666": {
    "id": "item_11515",
    "Last Name": "doyle",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928674": {
    "id": "item_9751",
    "Last Name": "Jenkins",
    "First Name": "Grayson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928727": {
    "id": "item_37116",
    "Last Name": "Wang",
    "First Name": "Fei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928728": {
    "id": "item_24182",
    "Last Name": "Abad",
    "First Name": "Arnel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928736": {
    "id": "item_37117",
    "Last Name": "Barton",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928739": {
    "id": "item_9753",
    "Last Name": "Elliman",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928746": {
    "id": "item_9752",
    "Last Name": "Fantom",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928753": {
    "id": "item_11516",
    "Last Name": "WANG",
    "First Name": "YI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928779": {
    "id": "item_34865",
    "Last Name": "Verbeek",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928783": {
    "id": "item_37119",
    "Last Name": "Schaeffer",
    "First Name": "Curtis",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928800": {
    "id": "item_37118",
    "Last Name": "Ellis",
    "First Name": "Chase",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928856": {
    "id": "item_22657",
    "Last Name": "Obst",
    "First Name": "Florian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928872": {
    "id": "item_24183",
    "Last Name": "Ardila",
    "First Name": "Diego",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928884": {
    "id": "item_24184",
    "Last Name": "FISHER",
    "First Name": "MARK",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928896": {
    "id": "item_9754",
    "Last Name": "MacDonald",
    "First Name": "Rien",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928935": {
    "id": "item_11517",
    "Last Name": "Foo",
    "First Name": "Kar Kin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928937": {
    "id": "item_9755",
    "Last Name": "Irwin",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36928964": {
    "id": "item_22658",
    "Last Name": "Maseka",
    "First Name": "Esanju",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929010": {
    "id": "item_22659",
    "Last Name": "Stevenson",
    "First Name": "Savannah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929017": {
    "id": "item_22660",
    "Last Name": "Parker",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929082": {
    "id": "item_9756",
    "Last Name": "Wilson",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929086": {
    "id": "item_37121",
    "Last Name": "Palogan",
    "First Name": "Imee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929091": {
    "id": "item_37120",
    "Last Name": "Marasigan",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929097": {
    "id": "item_24185",
    "Last Name": "Chok",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929130": {
    "id": "item_22661",
    "Last Name": "Hettasch",
    "First Name": "Werner",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929216": {
    "id": "item_22662",
    "Last Name": "Woods",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929217": {
    "id": "item_9757",
    "Last Name": "Jeffree",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929218": {
    "id": "item_11518",
    "Last Name": "Fittler",
    "First Name": "Alistair",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929497": {
    "id": "item_22663",
    "Last Name": "Sheehan",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929514": {
    "id": "item_37122",
    "Last Name": "lin",
    "First Name": "jialiang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929544": {
    "id": "item_22664",
    "Last Name": "Brown",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929589": {
    "id": "item_22665",
    "Last Name": "Ackland",
    "First Name": "Corrie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929696": {
    "id": "item_9758",
    "Last Name": "Ma",
    "First Name": "Haoting",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929712": {
    "id": "item_24186",
    "Last Name": "Crane",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929733": {
    "id": "item_11519",
    "Last Name": "McMorrow",
    "First Name": "Julia",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36929828": {
    "id": "item_11520",
    "Last Name": "Duncan",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930020": {
    "id": "item_11521",
    "Last Name": "Behrmann",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930075": {
    "id": "item_24187",
    "Last Name": "Rogers",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930127": {
    "id": "item_37123",
    "Last Name": "Dye",
    "First Name": "Emilie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930307": {
    "id": "item_34866",
    "Last Name": "Tulloch",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930408": {
    "id": "item_37124",
    "Last Name": "LUO",
    "First Name": "CHIN CHIU",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930450": {
    "id": "item_37125",
    "Last Name": "Nugroho",
    "First Name": "Setiawan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930515": {
    "id": "item_11522",
    "Last Name": "Breytenbach",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930591": {
    "id": "item_22666",
    "Last Name": "Wilson",
    "First Name": "Huei Chen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930606": {
    "id": "item_11523",
    "Last Name": "Liu",
    "First Name": "Siu Fung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930723": {
    "id": "item_24188",
    "Last Name": "Knaus",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930768": {
    "id": "item_9760",
    "Last Name": "Azzopardi",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930780": {
    "id": "item_9759",
    "Last Name": "Zakimi",
    "First Name": "Taichi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36930852": {
    "id": "item_11524",
    "Last Name": "Staunton",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931199": {
    "id": "item_11526",
    "Last Name": "Xu",
    "First Name": "Jianda",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931213": {
    "id": "item_11525",
    "Last Name": "Mc Kernan",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931217": {
    "id": "item_22667",
    "Last Name": "GUO",
    "First Name": "CAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931306": {
    "id": "item_9761",
    "Last Name": "Fraser",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931486": {
    "id": "item_11527",
    "Last Name": "Polimeni",
    "First Name": "Vicente",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931516": {
    "id": "item_9762",
    "Last Name": "Abraham",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931559": {
    "id": "item_37126",
    "Last Name": "Karina",
    "First Name": "Dellanea Cinta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931562": {
    "id": "item_9763",
    "Last Name": "Zhao",
    "First Name": "Weilun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931615": {
    "id": "item_24189",
    "Last Name": "McCormack",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931678": {
    "id": "item_37127",
    "Last Name": "Mpahlwa",
    "First Name": "Siyatakazela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931737": {
    "id": "item_37128",
    "Last Name": "Taylor",
    "First Name": "Aireen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931764": {
    "id": "item_24190",
    "Last Name": "Guinan",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931901": {
    "id": "item_11528",
    "Last Name": "DUAN",
    "First Name": "JING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931937": {
    "id": "item_11529",
    "Last Name": "Cho",
    "First Name": "Sehoon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36931941": {
    "id": "item_34867",
    "Last Name": "Li",
    "First Name": "Cathy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932003": {
    "id": "item_24191",
    "Last Name": "O Connor",
    "First Name": "Ailis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932049": {
    "id": "item_24192",
    "Last Name": "LANG",
    "First Name": "HONGHUA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932302": {
    "id": "item_37129",
    "Last Name": "Coleman",
    "First Name": "Marg",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932356": {
    "id": "item_9764",
    "Last Name": "Liu",
    "First Name": "Ning",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36932406": {
    "id": "item_37130",
    "Last Name": "WANG",
    "First Name": "NIANYONG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36936037": {
    "id": "item_22668",
    "Last Name": "Cunliffe",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36939828": {
    "id": "item_11530",
    "Last Name": "Kavanagh",
    "First Name": "Alice",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940098": {
    "id": "item_22670",
    "Last Name": "ZHU",
    "First Name": "HAOXIANG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940420": {
    "id": "item_22671",
    "Last Name": "Beavis",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940499": {
    "id": "item_34868",
    "Last Name": "Matiwaza",
    "First Name": "Tshakalisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940787": {
    "id": "item_9766",
    "Last Name": "Taylor",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940953": {
    "id": "item_24193",
    "Last Name": "Gibson",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36940983": {
    "id": "item_24194",
    "Last Name": "Hayes",
    "First Name": "julie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941170": {
    "id": "item_9767",
    "Last Name": "Tacugue",
    "First Name": "Marlou",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941345": {
    "id": "item_11531",
    "Last Name": "Mackintosh",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941601": {
    "id": "item_22672",
    "Last Name": "Akinaga",
    "First Name": "Kenji",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941655": {
    "id": "item_22673",
    "Last Name": "Ochoa Hernandez",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941930": {
    "id": "item_11532",
    "Last Name": "MacKenzie",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36941961": {
    "id": "item_22674",
    "Last Name": "Sequeira",
    "First Name": "Samson",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942074": {
    "id": "item_11533",
    "Last Name": "Parker",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942225": {
    "id": "item_34869",
    "Last Name": "McDonald",
    "First Name": "Brody",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942509": {
    "id": "item_9768",
    "Last Name": "Fang",
    "First Name": "Qian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942541": {
    "id": "item_22675",
    "Last Name": "Ingleton",
    "First Name": "Noah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36942577": {
    "id": "item_24195",
    "Last Name": "Tapp",
    "First Name": "Nash",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36943367": {
    "id": "item_34870",
    "Last Name": "SONG",
    "First Name": "YUAN MING",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "36944419": {
    "id": "item_11534",
    "Last Name": "Sharma",
    "First Name": "Sunil",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37053418": {
    "id": "item_9769",
    "Last Name": "Ord",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37092204": {
    "id": "item_22676",
    "Last Name": "Watson",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37092732": {
    "id": "item_24196",
    "Last Name": "JAVELLANA",
    "First Name": "DOMIVIC",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37093884": {
    "id": "item_37131",
    "Last Name": "Tueansakul",
    "First Name": "Apisada",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37094032": {
    "id": "item_37132",
    "Last Name": "Liu",
    "First Name": "Hui",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37094471": {
    "id": "item_22677",
    "Last Name": "Pereira",
    "First Name": "Adriana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37094994": {
    "id": "item_34871",
    "Last Name": "Medina",
    "First Name": "Joseph Mari",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37097361": {
    "id": "item_24197",
    "Last Name": "Rosenbrock",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37097569": {
    "id": "item_22678",
    "Last Name": "Sidhu",
    "First Name": "Abdul Wahab",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37099236": {
    "id": "item_11535",
    "Last Name": "Chao",
    "First Name": "Yin Loong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37099272": {
    "id": "item_37133",
    "Last Name": "Chailark",
    "First Name": "Sarotin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37099378": {
    "id": "item_37134",
    "Last Name": "Fountain",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37108976": {
    "id": "item_11536",
    "Last Name": "Ly",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37112726": {
    "id": "item_22679",
    "Last Name": "Brazell",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37113137": {
    "id": "item_24198",
    "Last Name": "Wu",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37113499": {
    "id": "item_24199",
    "Last Name": "Ji",
    "First Name": "Sully",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37114319": {
    "id": "item_9770",
    "Last Name": "Pichler",
    "First Name": "Reuben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37115807": {
    "id": "item_11537",
    "Last Name": "Bowler",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37116259": {
    "id": "item_9771",
    "Last Name": "Higgins",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37116594": {
    "id": "item_37135",
    "Last Name": "Espanola",
    "First Name": "Bianca Jane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144152": {
    "id": "item_9772",
    "Last Name": "Brown",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144627": {
    "id": "item_35636",
    "Last Name": "Nicolaou",
    "First Name": "Julian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144707": {
    "id": "item_10431",
    "Last Name": "Home",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144768": {
    "id": "item_24713",
    "Last Name": "Solis Resendiz",
    "First Name": "Isai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144786": {
    "id": "item_23487",
    "Last Name": "Tay",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144876": {
    "id": "item_24712",
    "Last Name": "Cain",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144900": {
    "id": "item_35635",
    "Last Name": "Rajan",
    "First Name": "Nadia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144907": {
    "id": "item_24711",
    "Last Name": "Lau",
    "First Name": "Jonnie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144910": {
    "id": "item_35634",
    "Last Name": "Johnstone",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144916": {
    "id": "item_24710",
    "Last Name": "Wang",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144953": {
    "id": "item_24709",
    "Last Name": "Smart",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144973": {
    "id": "item_24708",
    "Last Name": "Warner",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144979": {
    "id": "item_10429",
    "Last Name": "Coad",
    "First Name": "Louis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37144998": {
    "id": "item_23486",
    "Last Name": "Maher",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145000": {
    "id": "item_24706",
    "Last Name": "Liu",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145024": {
    "id": "item_24707",
    "Last Name": "Feiner",
    "First Name": "Beck",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145025": {
    "id": "item_24705",
    "Last Name": "MAHER",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145028": {
    "id": "item_35633",
    "Last Name": "Livings",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145038": {
    "id": "item_35628",
    "Last Name": "Schofield",
    "First Name": "Jenni",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145039": {
    "id": "item_35632",
    "Last Name": "Tabley-Gallagher",
    "First Name": "Yasmin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145040": {
    "id": "item_10430",
    "Last Name": "Mitchell",
    "First Name": "Keith",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145052": {
    "id": "item_10425",
    "Last Name": "Tohara",
    "First Name": "Brodie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145087": {
    "id": "item_10428",
    "Last Name": "Morris",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145101": {
    "id": "item_10427",
    "Last Name": "Rebbechi",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145117": {
    "id": "item_35627",
    "Last Name": "Wixcey",
    "First Name": "Eleanor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145143": {
    "id": "item_23485",
    "Last Name": "Burney",
    "First Name": "Max",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145151": {
    "id": "item_24703",
    "Last Name": "Sinclair",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145152": {
    "id": "item_35625",
    "Last Name": "George",
    "First Name": "Millie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145156": {
    "id": "item_10407",
    "Last Name": "Marsh",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145177": {
    "id": "item_35626",
    "Last Name": "Wang",
    "First Name": "Amber",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145183": {
    "id": "item_12214",
    "Last Name": "St John",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145199": {
    "id": "item_24692",
    "Last Name": "Jackson",
    "First Name": "Heath",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145223": {
    "id": "item_24695",
    "Last Name": "Maguire",
    "First Name": "Siobhan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145227": {
    "id": "item_10424",
    "Last Name": "Tenaglia",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145228": {
    "id": "item_12213",
    "Last Name": "Young",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145254": {
    "id": "item_24700",
    "Last Name": "Blane",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145275": {
    "id": "item_24699",
    "Last Name": "Jansen",
    "First Name": "Rose",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145328": {
    "id": "item_10422",
    "Last Name": "Kennedy",
    "First Name": "Mack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145329": {
    "id": "item_10414",
    "Last Name": "Rodrigues",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145333": {
    "id": "item_10418",
    "Last Name": "Arnold",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145337": {
    "id": "item_35612",
    "Last Name": "Molamphy",
    "First Name": "Aisling",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145347": {
    "id": "item_12207",
    "Last Name": "Beacock",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145375": {
    "id": "item_24676",
    "Last Name": "Morris",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145389": {
    "id": "item_12205",
    "Last Name": "Roex",
    "First Name": "Juliette",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145392": {
    "id": "item_24688",
    "Last Name": "Achary",
    "First Name": "Shiv",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145398": {
    "id": "item_35617",
    "Last Name": "Miller",
    "First Name": "Rebekah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145409": {
    "id": "item_24686",
    "Last Name": "Colli",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145413": {
    "id": "item_10411",
    "Last Name": "Bridges",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145424": {
    "id": "item_35614",
    "Last Name": "Astill",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145433": {
    "id": "item_24684",
    "Last Name": "Yu",
    "First Name": "Jing",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145436": {
    "id": "item_35599",
    "Last Name": "Burgos",
    "First Name": "E.J.",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145460": {
    "id": "item_24687",
    "Last Name": "Cox",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145471": {
    "id": "item_35609",
    "Last Name": "Maughan",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145483": {
    "id": "item_35608",
    "Last Name": "Leonardo Jr.",
    "First Name": "Conrado",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145494": {
    "id": "item_24677",
    "Last Name": "Deans",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145502": {
    "id": "item_35605",
    "Last Name": "Cooling",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145526": {
    "id": "item_35598",
    "Last Name": "Rowley",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145528": {
    "id": "item_24683",
    "Last Name": "Chau",
    "First Name": "Danny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145542": {
    "id": "item_35603",
    "Last Name": "Ramalingam",
    "First Name": "Mithun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145543": {
    "id": "item_12203",
    "Last Name": "Hallett",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145544": {
    "id": "item_24680",
    "Last Name": "Rawson",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145563": {
    "id": "item_10397",
    "Last Name": "Love",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145578": {
    "id": "item_35593",
    "Last Name": "Bush",
    "First Name": "Rod",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145603": {
    "id": "item_24678",
    "Last Name": "Lund",
    "First Name": "Jules",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145623": {
    "id": "item_12198",
    "Last Name": "Cannon",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145654": {
    "id": "item_24632",
    "Last Name": "McLean",
    "First Name": "Harriet",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145657": {
    "id": "item_24919",
    "Last Name": "Tan",
    "First Name": "Andre",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145689": {
    "id": "item_12187",
    "Last Name": "Chaney",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145690": {
    "id": "item_24670",
    "Last Name": "Lawrence",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145691": {
    "id": "item_24647",
    "Last Name": "Low",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145693": {
    "id": "item_12169",
    "Last Name": "Nghiem",
    "First Name": "Tri Duc",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145698": {
    "id": "item_12192",
    "Last Name": "Brunton",
    "First Name": "Jerym",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145703": {
    "id": "item_12194",
    "Last Name": "Smith",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145747": {
    "id": "item_12191",
    "Last Name": "Farrar",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145751": {
    "id": "item_35591",
    "Last Name": "Burke-Shyne",
    "First Name": "Suailce",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145762": {
    "id": "item_10403",
    "Last Name": "Bonney",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145764": {
    "id": "item_12189",
    "Last Name": "Paterson",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145783": {
    "id": "item_12190",
    "Last Name": "Steen",
    "First Name": "Cooper",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145788": {
    "id": "item_35590",
    "Last Name": "Laveau",
    "First Name": "Laurence",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145806": {
    "id": "item_38263",
    "Last Name": "Clark",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145812": {
    "id": "item_35582",
    "Last Name": "Beckwith",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145823": {
    "id": "item_35589",
    "Last Name": "Roberts",
    "First Name": "Kellie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145830": {
    "id": "item_24663",
    "Last Name": "Hua",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145835": {
    "id": "item_10401",
    "Last Name": "Mckenzie",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145844": {
    "id": "item_24655",
    "Last Name": "Moss",
    "First Name": "Rohan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145872": {
    "id": "item_12182",
    "Last Name": "Fabb",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145881": {
    "id": "item_10400",
    "Last Name": "Valentini",
    "First Name": "Matteo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145892": {
    "id": "item_24656",
    "Last Name": "haugen",
    "First Name": "peder",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145895": {
    "id": "item_24657",
    "Last Name": "Cott",
    "First Name": "Raphael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145899": {
    "id": "item_35578",
    "Last Name": "Conroy",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145900": {
    "id": "item_35584",
    "Last Name": "Chong",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145916": {
    "id": "item_24661",
    "Last Name": "Dabb",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145917": {
    "id": "item_24659",
    "Last Name": "Dobson",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145932": {
    "id": "item_10398",
    "Last Name": "Pearce",
    "First Name": "Kadell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145965": {
    "id": "item_10384",
    "Last Name": "Quinn",
    "First Name": "Declan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37145991": {
    "id": "item_35580",
    "Last Name": "Koehl",
    "First Name": "Gisela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146000": {
    "id": "item_24652",
    "Last Name": "Cullen",
    "First Name": "Eimear",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146005": {
    "id": "item_24643",
    "Last Name": "Tsiligiannis",
    "First Name": "Ingrid",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146006": {
    "id": "item_12178",
    "Last Name": "Gibson",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146010": {
    "id": "item_24649",
    "Last Name": "Reed",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146045": {
    "id": "item_24642",
    "Last Name": "Villicana",
    "First Name": "Diego",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146065": {
    "id": "item_24644",
    "Last Name": "Sexton",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146087": {
    "id": "item_12156",
    "Last Name": "Semikop",
    "First Name": "Sergii",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146112": {
    "id": "item_10379",
    "Last Name": "White",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146114": {
    "id": "item_10385",
    "Last Name": "Simyoni",
    "First Name": "Ido",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146117": {
    "id": "item_12166",
    "Last Name": "Rehbein",
    "First Name": "Russell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146130": {
    "id": "item_24634",
    "Last Name": "Schipano",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146139": {
    "id": "item_24640",
    "Last Name": "Lau",
    "First Name": "Josiah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146152": {
    "id": "item_12163",
    "Last Name": "Tan",
    "First Name": "YanFen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146172": {
    "id": "item_24637",
    "Last Name": "Carpenter",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146174": {
    "id": "item_35559",
    "Last Name": "Kim",
    "First Name": "Taiyoung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146224": {
    "id": "item_24635",
    "Last Name": "Cheevers",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146289": {
    "id": "item_35563",
    "Last Name": "Eyers",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146290": {
    "id": "item_24630",
    "Last Name": "Chen",
    "First Name": "Shang",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146302": {
    "id": "item_35561",
    "Last Name": "Peng",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146315": {
    "id": "item_24617",
    "Last Name": "Deaker",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146379": {
    "id": "item_35541",
    "Last Name": "Bennetto",
    "First Name": "Lara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146400": {
    "id": "item_35554",
    "Last Name": "Vanstone",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146406": {
    "id": "item_12160",
    "Last Name": "Forrest",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146437": {
    "id": "item_10366",
    "Last Name": "Stephanou",
    "First Name": "Nina",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146442": {
    "id": "item_35552",
    "Last Name": "Pearce",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146444": {
    "id": "item_10371",
    "Last Name": "Abey",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146469": {
    "id": "item_24618",
    "Last Name": "Fenton",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146494": {
    "id": "item_35548",
    "Last Name": "Weare",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146558": {
    "id": "item_35542",
    "Last Name": "Forde",
    "First Name": "Marina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146566": {
    "id": "item_24612",
    "Last Name": "Carr",
    "First Name": "Macaulay",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146575": {
    "id": "item_10362",
    "Last Name": "Koirala",
    "First Name": "Milan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146579": {
    "id": "item_12148",
    "Last Name": "Moy",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146584": {
    "id": "item_24598",
    "Last Name": "Ng",
    "First Name": "Kai Sheng",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146591": {
    "id": "item_24608",
    "Last Name": "De Barros Marques dos Santos",
    "First Name": "Romulo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146614": {
    "id": "item_10301",
    "Last Name": "O'HALLORAN",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146617": {
    "id": "item_12152",
    "Last Name": "Cole",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146627": {
    "id": "item_12150",
    "Last Name": "Marsh",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146665": {
    "id": "item_24602",
    "Last Name": "Sissian",
    "First Name": "Bryar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146681": {
    "id": "item_24591",
    "Last Name": "Shilton",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146686": {
    "id": "item_35536",
    "Last Name": "Singh",
    "First Name": "Jiwan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146695": {
    "id": "item_12118",
    "Last Name": "Baillon",
    "First Name": "Carlton",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146700": {
    "id": "item_10357",
    "Last Name": "Howden",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146714": {
    "id": "item_24600",
    "Last Name": "Simmons",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146715": {
    "id": "item_12137",
    "Last Name": "Harnischfeger",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146719": {
    "id": "item_24603",
    "Last Name": "O'Brien",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146737": {
    "id": "item_10360",
    "Last Name": "Johnson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146764": {
    "id": "item_23474",
    "Last Name": "Lopez Robles",
    "First Name": "Paola Michelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146767": {
    "id": "item_24590",
    "Last Name": "Graham",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146768": {
    "id": "item_24573",
    "Last Name": "Creasey",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146776": {
    "id": "item_24582",
    "Last Name": "Murphy",
    "First Name": "Marlou",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146781": {
    "id": "item_24596",
    "Last Name": "Sarris",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146785": {
    "id": "item_35534",
    "Last Name": "Tarleton",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146790": {
    "id": "item_10355",
    "Last Name": "Thai",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146804": {
    "id": "item_24593",
    "Last Name": "Tenaglia",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146819": {
    "id": "item_24584",
    "Last Name": "Villadelgado",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146831": {
    "id": "item_24587",
    "Last Name": "Burke",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146898": {
    "id": "item_12133",
    "Last Name": "Weribone",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146908": {
    "id": "item_10353",
    "Last Name": "Maher",
    "First Name": "Alastair",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146923": {
    "id": "item_24577",
    "Last Name": "Mumbray",
    "First Name": "Phoebe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146931": {
    "id": "item_35527",
    "Last Name": "Smedsrud",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146974": {
    "id": "item_12136",
    "Last Name": "O Doherty",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146981": {
    "id": "item_10352",
    "Last Name": "Macesic",
    "First Name": "Nenad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37146997": {
    "id": "item_35528",
    "Last Name": "MACNISH",
    "First Name": "SARAH",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147011": {
    "id": "item_35520",
    "Last Name": "Andrews",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147054": {
    "id": "item_24578",
    "Last Name": "Ngo",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147060": {
    "id": "item_35521",
    "Last Name": "Senanayake",
    "First Name": "Malinga",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147065": {
    "id": "item_24562",
    "Last Name": "Meredith",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147072": {
    "id": "item_12135",
    "Last Name": "Simpson",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147076": {
    "id": "item_24570",
    "Last Name": "Moyse",
    "First Name": "Kris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147116": {
    "id": "item_35518",
    "Last Name": "Wong",
    "First Name": "May",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147127": {
    "id": "item_12126",
    "Last Name": "Furnari",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147133": {
    "id": "item_10343",
    "Last Name": "Hulbert",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147170": {
    "id": "item_24568",
    "Last Name": "Kortright",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147188": {
    "id": "item_35463",
    "Last Name": "Pearce",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147209": {
    "id": "item_35516",
    "Last Name": "Yoganayagam",
    "First Name": "Niran",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147220": {
    "id": "item_24550",
    "Last Name": "Russell",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147237": {
    "id": "item_35512",
    "Last Name": "Castelletti",
    "First Name": "Elise",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147249": {
    "id": "item_24565",
    "Last Name": "Grey",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147258": {
    "id": "item_23470",
    "Last Name": "McCarthy",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147323": {
    "id": "item_35509",
    "Last Name": "McKinlay",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147332": {
    "id": "item_10332",
    "Last Name": "Barlow",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147339": {
    "id": "item_10342",
    "Last Name": "Humphrey",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147352": {
    "id": "item_10339",
    "Last Name": "Scott",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147360": {
    "id": "item_35507",
    "Last Name": "Chen",
    "First Name": "Lena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147388": {
    "id": "item_24545",
    "Last Name": "Black",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147431": {
    "id": "item_35504",
    "Last Name": "Dengate",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147456": {
    "id": "item_35498",
    "Last Name": "LONG",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147460": {
    "id": "item_35505",
    "Last Name": "Barbara",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147485": {
    "id": "item_24537",
    "Last Name": "Sadeghian",
    "First Name": "Damoon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147495": {
    "id": "item_10330",
    "Last Name": "Steyn",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147524": {
    "id": "item_24535",
    "Last Name": "Watters",
    "First Name": "R—n‡n",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147583": {
    "id": "item_12106",
    "Last Name": "Cousins",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147587": {
    "id": "item_35493",
    "Last Name": "Thomas",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147616": {
    "id": "item_12105",
    "Last Name": "Kellerman",
    "First Name": "Travis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147629": {
    "id": "item_24532",
    "Last Name": "Tan",
    "First Name": "Bevan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147647": {
    "id": "item_12100",
    "Last Name": "McHugh",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147654": {
    "id": "item_35480",
    "Last Name": "Nepomuceno",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147676": {
    "id": "item_10305",
    "Last Name": "Verbeek",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147678": {
    "id": "item_12095",
    "Last Name": "Espinosa Betancourt",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147702": {
    "id": "item_24531",
    "Last Name": "Stevens",
    "First Name": "Beitris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147721": {
    "id": "item_24528",
    "Last Name": "Li",
    "First Name": "Yuchong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147732": {
    "id": "item_24526",
    "Last Name": "CONSIDINE",
    "First Name": "LEIGH",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147748": {
    "id": "item_24522",
    "Last Name": "Porter",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147763": {
    "id": "item_24499",
    "Last Name": "McComisky",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147808": {
    "id": "item_24519",
    "Last Name": "Gallagher",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147820": {
    "id": "item_12092",
    "Last Name": "Quick",
    "First Name": "Conrad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147845": {
    "id": "item_23463",
    "Last Name": "Ramirez Vargas",
    "First Name": "Idaris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147847": {
    "id": "item_35474",
    "Last Name": "Pang",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147862": {
    "id": "item_24516",
    "Last Name": "Ruiz",
    "First Name": "Johanna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147875": {
    "id": "item_24502",
    "Last Name": "Greathead",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147910": {
    "id": "item_24518",
    "Last Name": "Atkins",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147919": {
    "id": "item_12044",
    "Last Name": "Bruty",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147927": {
    "id": "item_24513",
    "Last Name": "Hinds",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147934": {
    "id": "item_23464",
    "Last Name": "Smith",
    "First Name": "Jodi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147939": {
    "id": "item_10317",
    "Last Name": "Todd",
    "First Name": "Owen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147949": {
    "id": "item_24512",
    "Last Name": "Twyford",
    "First Name": "Drew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147970": {
    "id": "item_24486",
    "Last Name": "Humphries",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37147994": {
    "id": "item_24495",
    "Last Name": "Richter",
    "First Name": "Carola",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148000": {
    "id": "item_24505",
    "Last Name": "Thakkar",
    "First Name": "Harsh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148031": {
    "id": "item_12080",
    "Last Name": "Byrne",
    "First Name": "Bernard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148067": {
    "id": "item_12073",
    "Last Name": "Edwards",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148070": {
    "id": "item_24500",
    "Last Name": "de Bruyn",
    "First Name": "Davyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148096": {
    "id": "item_10302",
    "Last Name": "Maud",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148097": {
    "id": "item_12074",
    "Last Name": "Fuller",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148107": {
    "id": "item_12033",
    "Last Name": "Bhalla",
    "First Name": "Aman",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148116": {
    "id": "item_10303",
    "Last Name": "Anderson",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148117": {
    "id": "item_10307",
    "Last Name": "Rogers",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148156": {
    "id": "item_23460",
    "Last Name": "Byrne",
    "First Name": "prada",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148161": {
    "id": "item_24498",
    "Last Name": "Peters",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148201": {
    "id": "item_23442",
    "Last Name": "Fahmi",
    "First Name": "Ibrahim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148215": {
    "id": "item_35450",
    "Last Name": "Percival",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148230": {
    "id": "item_12076",
    "Last Name": "Demera",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148291": {
    "id": "item_23462",
    "Last Name": "Zhang",
    "First Name": "Zilin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148315": {
    "id": "item_35447",
    "Last Name": "Cavalot",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148343": {
    "id": "item_10298",
    "Last Name": "Eiszele",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148346": {
    "id": "item_23434",
    "Last Name": "BEALE",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148369": {
    "id": "item_12064",
    "Last Name": "Stubbs",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148372": {
    "id": "item_10293",
    "Last Name": "Bowyer",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148381": {
    "id": "item_23445",
    "Last Name": "Fegan",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148382": {
    "id": "item_11912",
    "Last Name": "Lester",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148407": {
    "id": "item_35443",
    "Last Name": "Greaves",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148437": {
    "id": "item_12061",
    "Last Name": "Demarco",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148438": {
    "id": "item_35444",
    "Last Name": "Plaksin",
    "First Name": "Vitalii",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148448": {
    "id": "item_23446",
    "Last Name": "Campbell",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148456": {
    "id": "item_23439",
    "Last Name": "Mostyn",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148476": {
    "id": "item_10288",
    "Last Name": "Parada PŽrez",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148482": {
    "id": "item_23444",
    "Last Name": "Kelly",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148484": {
    "id": "item_11962",
    "Last Name": "Nissen",
    "First Name": "Zac",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148486": {
    "id": "item_10292",
    "Last Name": "Sheehy",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148502": {
    "id": "item_12049",
    "Last Name": "G—mez Blanco",
    "First Name": "Ignacio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148504": {
    "id": "item_12054",
    "Last Name": "Singleton",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148514": {
    "id": "item_10289",
    "Last Name": "Chiu",
    "First Name": "kwan chun Eric",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148590": {
    "id": "item_23438",
    "Last Name": "Constable",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148599": {
    "id": "item_23430",
    "Last Name": "Shiel",
    "First Name": "Kynan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148605": {
    "id": "item_10282",
    "Last Name": "Moreland",
    "First Name": "Darcy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148614": {
    "id": "item_12050",
    "Last Name": "Mccormack",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148650": {
    "id": "item_35434",
    "Last Name": "Gopalakrishnan",
    "First Name": "Neelakantan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148673": {
    "id": "item_23427",
    "Last Name": "Simpson",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148688": {
    "id": "item_10283",
    "Last Name": "Cutrer",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148690": {
    "id": "item_35427",
    "Last Name": "Atter",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148705": {
    "id": "item_10277",
    "Last Name": "Hutchins",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148725": {
    "id": "item_35426",
    "Last Name": "Goudeau",
    "First Name": "Marie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148728": {
    "id": "item_10274",
    "Last Name": "Andrews",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148746": {
    "id": "item_35429",
    "Last Name": "Bakalik",
    "First Name": "Judith",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148762": {
    "id": "item_10278",
    "Last Name": "Wade",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148773": {
    "id": "item_23431",
    "Last Name": "Sun",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148813": {
    "id": "item_23403",
    "Last Name": "Stephens",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148820": {
    "id": "item_12036",
    "Last Name": "inserra",
    "First Name": "silvano",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148822": {
    "id": "item_10260",
    "Last Name": "Brown",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148829": {
    "id": "item_12038",
    "Last Name": "BLANC DE LA COUR",
    "First Name": "Clement",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148836": {
    "id": "item_24482",
    "Last Name": "Tester",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148843": {
    "id": "item_23417",
    "Last Name": "Chan",
    "First Name": "Lung Shun",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148855": {
    "id": "item_12030",
    "Last Name": "Osmand",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148859": {
    "id": "item_10240",
    "Last Name": "Bardon",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148874": {
    "id": "item_12040",
    "Last Name": "Gaitan",
    "First Name": "Russell Jan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148879": {
    "id": "item_23401",
    "Last Name": "Hourigan",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148881": {
    "id": "item_10271",
    "Last Name": "McClung",
    "First Name": "Riley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148884": {
    "id": "item_10263",
    "Last Name": "Grant",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148906": {
    "id": "item_35417",
    "Last Name": "Bennett",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148920": {
    "id": "item_35326",
    "Last Name": "Roberts",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148940": {
    "id": "item_23416",
    "Last Name": "Nicholson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148943": {
    "id": "item_23405",
    "Last Name": "Archer",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148958": {
    "id": "item_12029",
    "Last Name": "Liu",
    "First Name": "Zezhong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148963": {
    "id": "item_11991",
    "Last Name": "Nally",
    "First Name": "Seanie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148972": {
    "id": "item_23408",
    "Last Name": "Fegan",
    "First Name": "Warwick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148990": {
    "id": "item_35421",
    "Last Name": "Price",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148996": {
    "id": "item_23392",
    "Last Name": "Laird",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37148997": {
    "id": "item_35412",
    "Last Name": "Parker",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149005": {
    "id": "item_35411",
    "Last Name": "Davis",
    "First Name": "Graham",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149014": {
    "id": "item_12031",
    "Last Name": "Love",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149025": {
    "id": "item_23391",
    "Last Name": "Fill",
    "First Name": "Kade",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149032": {
    "id": "item_23402",
    "Last Name": "McGovern",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149069": {
    "id": "item_10229",
    "Last Name": "Bramich",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149074": {
    "id": "item_23398",
    "Last Name": "Gibson",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149109": {
    "id": "item_35397",
    "Last Name": "Dissanayake",
    "First Name": "Dhanuka",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149111": {
    "id": "item_35413",
    "Last Name": "Maxime",
    "First Name": "Applanat",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149115": {
    "id": "item_12019",
    "Last Name": "Chen",
    "First Name": "Chuan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149129": {
    "id": "item_10250",
    "Last Name": "Hore",
    "First Name": "Toby",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149132": {
    "id": "item_23373",
    "Last Name": "Franey",
    "First Name": "Leona",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149133": {
    "id": "item_23396",
    "Last Name": "Grace",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149135": {
    "id": "item_10254",
    "Last Name": "Ku",
    "First Name": "Chun-Kai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149136": {
    "id": "item_10253",
    "Last Name": "Butcher",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149143": {
    "id": "item_23382",
    "Last Name": "Laufer",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149146": {
    "id": "item_10235",
    "Last Name": "Howe",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149177": {
    "id": "item_12020",
    "Last Name": "Schultz",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149183": {
    "id": "item_38251",
    "Last Name": "Cao",
    "First Name": "Nam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149201": {
    "id": "item_12380",
    "Last Name": "Wheatley",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149207": {
    "id": "item_23381",
    "Last Name": "Daffy",
    "First Name": "Troy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149224": {
    "id": "item_23371",
    "Last Name": "Yoannidis",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149232": {
    "id": "item_12014",
    "Last Name": "Akers",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149234": {
    "id": "item_35402",
    "Last Name": "Perry",
    "First Name": "Jahna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149266": {
    "id": "item_12016",
    "Last Name": "Ryan",
    "First Name": "Davin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149277": {
    "id": "item_12006",
    "Last Name": "Zhyruk",
    "First Name": "Mykhaylo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149285": {
    "id": "item_10237",
    "Last Name": "Deller",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149294": {
    "id": "item_12013",
    "Last Name": "Castro",
    "First Name": "Enrique",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149306": {
    "id": "item_24481",
    "Last Name": "Forward",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149309": {
    "id": "item_23374",
    "Last Name": "Winton",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149333": {
    "id": "item_35387",
    "Last Name": "Silva",
    "First Name": "Sir. Leo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149338": {
    "id": "item_10242",
    "Last Name": "Mountney",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149371": {
    "id": "item_10232",
    "Last Name": "Albrecht",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149384": {
    "id": "item_12009",
    "Last Name": "Miller",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149392": {
    "id": "item_12011",
    "Last Name": "Polatkesen",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149406": {
    "id": "item_10244",
    "Last Name": "Finlayson",
    "First Name": "Iain",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149439": {
    "id": "item_12004",
    "Last Name": "Morales Hernandez",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149466": {
    "id": "item_24478",
    "Last Name": "Kelly",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149479": {
    "id": "item_35747",
    "Last Name": "Nolan",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149511": {
    "id": "item_23341",
    "Last Name": "Tiney",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149519": {
    "id": "item_35368",
    "Last Name": "Sutton",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149590": {
    "id": "item_11972",
    "Last Name": "Robertson",
    "First Name": "Ewan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149603": {
    "id": "item_23347",
    "Last Name": "Perdriau",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149620": {
    "id": "item_35378",
    "Last Name": "Maxwell",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149659": {
    "id": "item_10234",
    "Last Name": "Davies",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149668": {
    "id": "item_35381",
    "Last Name": "Mitchell",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149679": {
    "id": "item_24473",
    "Last Name": "Chisenga",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149688": {
    "id": "item_11987",
    "Last Name": "Ramos Perin",
    "First Name": "Hugo Leonardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149692": {
    "id": "item_24475",
    "Last Name": "Gu",
    "First Name": "yu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149696": {
    "id": "item_24833",
    "Last Name": "Lancaster",
    "First Name": "Grady",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149698": {
    "id": "item_23340",
    "Last Name": "Jenkins",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149702": {
    "id": "item_35349",
    "Last Name": "Denny",
    "First Name": "Denny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149728": {
    "id": "item_35798",
    "Last Name": "Rowles",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149731": {
    "id": "item_10227",
    "Last Name": "Burgess",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149737": {
    "id": "item_24477",
    "Last Name": "Kellinghaus",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149738": {
    "id": "item_35363",
    "Last Name": "bin Ahmad Sharmy",
    "First Name": "Muhammad Adam Shaqir",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149758": {
    "id": "item_10231",
    "Last Name": "Biggar",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149777": {
    "id": "item_11979",
    "Last Name": "Henry",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149786": {
    "id": "item_35351",
    "Last Name": "Angarita Pico",
    "First Name": "Oscar Gabriel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149810": {
    "id": "item_10521",
    "Last Name": "Corgel",
    "First Name": "Stefanie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149826": {
    "id": "item_35347",
    "Last Name": "Chapple",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149842": {
    "id": "item_35332",
    "Last Name": "Wigsten",
    "First Name": "Robin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149863": {
    "id": "item_35355",
    "Last Name": "Aguila",
    "First Name": "Jerome",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149867": {
    "id": "item_35360",
    "Last Name": "Sharman",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149870": {
    "id": "item_10221",
    "Last Name": "Johnson",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149874": {
    "id": "item_23338",
    "Last Name": "Neville",
    "First Name": "Cam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149890": {
    "id": "item_10225",
    "Last Name": "Hyde",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149893": {
    "id": "item_35312",
    "Last Name": "Kang",
    "First Name": "Jung In",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149897": {
    "id": "item_23339",
    "Last Name": "Burn",
    "First Name": "HAMISH",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149907": {
    "id": "item_23332",
    "Last Name": "Walker",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149924": {
    "id": "item_24472",
    "Last Name": "Nguyen",
    "First Name": "Bao",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149925": {
    "id": "item_11978",
    "Last Name": "Grant",
    "First Name": "Ruarc",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149932": {
    "id": "item_11982",
    "Last Name": "Laws",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149953": {
    "id": "item_10202",
    "Last Name": "Camilleri",
    "First Name": "Andre",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149973": {
    "id": "item_23333",
    "Last Name": "Stroulger",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149980": {
    "id": "item_23326",
    "Last Name": "Davies",
    "First Name": "Glen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37149983": {
    "id": "item_23336",
    "Last Name": "Zaina",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150025": {
    "id": "item_35329",
    "Last Name": "Workmaster",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150053": {
    "id": "item_23324",
    "Last Name": "Mc Carthy",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150060": {
    "id": "item_38258",
    "Last Name": "Kok",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150063": {
    "id": "item_23329",
    "Last Name": "Grafitti",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150074": {
    "id": "item_38192",
    "Last Name": "Jobli",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150090": {
    "id": "item_23327",
    "Last Name": "Fuller",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150091": {
    "id": "item_23325",
    "Last Name": "Todd",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150098": {
    "id": "item_38246",
    "Last Name": "Clack",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150110": {
    "id": "item_10214",
    "Last Name": "Mavrofridis",
    "First Name": "Sav",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150116": {
    "id": "item_35324",
    "Last Name": "Rich",
    "First Name": "Cheyne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150118": {
    "id": "item_10217",
    "Last Name": "Day",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150131": {
    "id": "item_11961",
    "Last Name": "encarnacion barriga",
    "First Name": "luis alberto",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150138": {
    "id": "item_11964",
    "Last Name": "O'Reilly",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150157": {
    "id": "item_35334",
    "Last Name": "Wunsch",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150160": {
    "id": "item_38248",
    "Last Name": "Oswin",
    "First Name": "Pru",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150172": {
    "id": "item_10211",
    "Last Name": "Mathew",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150190": {
    "id": "item_11937",
    "Last Name": "Cross",
    "First Name": "Halliday",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150217": {
    "id": "item_38220",
    "Last Name": "Morris",
    "First Name": "Natalya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150236": {
    "id": "item_11965",
    "Last Name": "Gouker",
    "First Name": "Fred",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150254": {
    "id": "item_24464",
    "Last Name": "Dorn",
    "First Name": "Janine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150259": {
    "id": "item_35323",
    "Last Name": "Nobles",
    "First Name": "Abegail",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150260": {
    "id": "item_38223",
    "Last Name": "Abella",
    "First Name": "Rod",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150275": {
    "id": "item_24467",
    "Last Name": "Amedu",
    "First Name": "Ugbede",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150280": {
    "id": "item_11959",
    "Last Name": "Mathwin",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150283": {
    "id": "item_38234",
    "Last Name": "Paglia",
    "First Name": "Theresa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150285": {
    "id": "item_11925",
    "Last Name": "Lip",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150290": {
    "id": "item_38233",
    "Last Name": "Smith",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150307": {
    "id": "item_10198",
    "Last Name": "Mcmanus",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150323": {
    "id": "item_38175",
    "Last Name": "Hussain",
    "First Name": "Sahdia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150340": {
    "id": "item_38193",
    "Last Name": "Aung",
    "First Name": "Wai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150392": {
    "id": "item_11957",
    "Last Name": "Doyle",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150398": {
    "id": "item_38229",
    "Last Name": "Fine",
    "First Name": "Bart",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150410": {
    "id": "item_24468",
    "Last Name": "Scherer",
    "First Name": "Wilfrid",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150430": {
    "id": "item_35317",
    "Last Name": "Brody",
    "First Name": "Max",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150439": {
    "id": "item_38188",
    "Last Name": "Canolas",
    "First Name": "Jerzon Amor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150461": {
    "id": "item_38211",
    "Last Name": "Doan",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150463": {
    "id": "item_23310",
    "Last Name": "Cuecha",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150483": {
    "id": "item_38212",
    "Last Name": "Borrello",
    "First Name": "Trinidad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150485": {
    "id": "item_11949",
    "Last Name": "Gibson",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150504": {
    "id": "item_23314",
    "Last Name": "Bourke",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150505": {
    "id": "item_24466",
    "Last Name": "McCarthy",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150509": {
    "id": "item_11942",
    "Last Name": "Ozturk",
    "First Name": "Ediz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150519": {
    "id": "item_23299",
    "Last Name": "Mears",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150531": {
    "id": "item_23306",
    "Last Name": "Aspden",
    "First Name": "Jarrad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150560": {
    "id": "item_38200",
    "Last Name": "Marques Silveira",
    "First Name": "Ana Laura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150569": {
    "id": "item_38216",
    "Last Name": "Efremova",
    "First Name": "Varvara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150571": {
    "id": "item_38184",
    "Last Name": "Griffin",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150583": {
    "id": "item_10569",
    "Last Name": "Chin",
    "First Name": "San kin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150591": {
    "id": "item_35308",
    "Last Name": "Rodrigues",
    "First Name": "Leonor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150606": {
    "id": "item_23302",
    "Last Name": "Stallwood-Hall",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150625": {
    "id": "item_11943",
    "Last Name": "Carter",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150643": {
    "id": "item_38156",
    "Last Name": "Kam",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150659": {
    "id": "item_38190",
    "Last Name": "Durrant",
    "First Name": "Ruth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150688": {
    "id": "item_11924",
    "Last Name": "Beckman",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150701": {
    "id": "item_38163",
    "Last Name": "Thomas",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150702": {
    "id": "item_35301",
    "Last Name": "Wilson",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150714": {
    "id": "item_35300",
    "Last Name": "Jiang",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150724": {
    "id": "item_38165",
    "Last Name": "Thode",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150746": {
    "id": "item_38173",
    "Last Name": "Hancock",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150747": {
    "id": "item_10194",
    "Last Name": "Morris",
    "First Name": "Judah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150756": {
    "id": "item_10197",
    "Last Name": "McClary",
    "First Name": "Cody",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150758": {
    "id": "item_24465",
    "Last Name": "Desai",
    "First Name": "Daksh Udaykumar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150760": {
    "id": "item_38166",
    "Last Name": "Cheng",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150765": {
    "id": "item_35296",
    "Last Name": "Bahfen",
    "First Name": "Nasya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150771": {
    "id": "item_38162",
    "Last Name": "Lim",
    "First Name": "Yong Zhen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150773": {
    "id": "item_23287",
    "Last Name": "Pickard",
    "First Name": "Kye",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150785": {
    "id": "item_38168",
    "Last Name": "Jayakumar",
    "First Name": "Mahesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150804": {
    "id": "item_38169",
    "Last Name": "Van Gent",
    "First Name": "Leana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150807": {
    "id": "item_23289",
    "Last Name": "Champion",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150860": {
    "id": "item_23277",
    "Last Name": "Murphy",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150862": {
    "id": "item_35279",
    "Last Name": "Dillon",
    "First Name": "Emanuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150869": {
    "id": "item_38155",
    "Last Name": "Muir",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150921": {
    "id": "item_23278",
    "Last Name": "Wood",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150934": {
    "id": "item_11917",
    "Last Name": "Parsons",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150939": {
    "id": "item_23264",
    "Last Name": "Dalfsen",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150984": {
    "id": "item_38136",
    "Last Name": "Herman",
    "First Name": "Anton",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37150985": {
    "id": "item_23270",
    "Last Name": "Huynh",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151013": {
    "id": "item_38146",
    "Last Name": "Newnham",
    "First Name": "Rob",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151021": {
    "id": "item_38158",
    "Last Name": "Espinosa",
    "First Name": "Janstan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151022": {
    "id": "item_38123",
    "Last Name": "Contreras",
    "First Name": "Alvaro",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151060": {
    "id": "item_38115",
    "Last Name": "Semb",
    "First Name": "Shae",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151065": {
    "id": "item_38128",
    "Last Name": "Karumuri",
    "First Name": "Srikanth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151106": {
    "id": "item_10179",
    "Last Name": "Bradford",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151121": {
    "id": "item_35268",
    "Last Name": "Rech",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151133": {
    "id": "item_35271",
    "Last Name": "Kovacs",
    "First Name": "Atareta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151141": {
    "id": "item_38129",
    "Last Name": "Lugo",
    "First Name": "Cristhian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151147": {
    "id": "item_35278",
    "Last Name": "Incaprero",
    "First Name": "Suzanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151148": {
    "id": "item_10174",
    "Last Name": "Hill",
    "First Name": "Louis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151175": {
    "id": "item_23237",
    "Last Name": "Neill",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151177": {
    "id": "item_38100",
    "Last Name": "Ozseyhan",
    "First Name": "Hasan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151198": {
    "id": "item_23261",
    "Last Name": "Collin",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151200": {
    "id": "item_23269",
    "Last Name": "Jarvie",
    "First Name": "Guy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151211": {
    "id": "item_38109",
    "Last Name": "Smith",
    "First Name": "Damien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151224": {
    "id": "item_23257",
    "Last Name": "Silva",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151245": {
    "id": "item_35264",
    "Last Name": "Prestianni",
    "First Name": "Salvatore",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151259": {
    "id": "item_10171",
    "Last Name": "Kilpatrick",
    "First Name": "Riley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151302": {
    "id": "item_10169",
    "Last Name": "Stevens",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151316": {
    "id": "item_38111",
    "Last Name": "Saliba",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151325": {
    "id": "item_38092",
    "Last Name": "Oo",
    "First Name": "Myo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151336": {
    "id": "item_38098",
    "Last Name": "Carwana",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151340": {
    "id": "item_23248",
    "Last Name": "Mackenzie",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151350": {
    "id": "item_23243",
    "Last Name": "Gibson",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151355": {
    "id": "item_35262",
    "Last Name": "O'Donnell",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151364": {
    "id": "item_23249",
    "Last Name": "Sambell",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151369": {
    "id": "item_10153",
    "Last Name": "Kirkland",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151381": {
    "id": "item_23251",
    "Last Name": "Marks",
    "First Name": "Jared",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151389": {
    "id": "item_11909",
    "Last Name": "Logan",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151407": {
    "id": "item_11906",
    "Last Name": "White",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151422": {
    "id": "item_35249",
    "Last Name": "Polas",
    "First Name": "Suraj",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151447": {
    "id": "item_23236",
    "Last Name": "Dromgoole",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151449": {
    "id": "item_23246",
    "Last Name": "Hurley",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151451": {
    "id": "item_23238",
    "Last Name": "Lodge",
    "First Name": "Connor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151464": {
    "id": "item_23230",
    "Last Name": "Conroy",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151475": {
    "id": "item_23229",
    "Last Name": "Rathi",
    "First Name": "Yashwant",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151489": {
    "id": "item_38061",
    "Last Name": "Arphaadul",
    "First Name": "Bunjerd",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151507": {
    "id": "item_11885",
    "Last Name": "tazza",
    "First Name": "cristina",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151509": {
    "id": "item_23188",
    "Last Name": "McCabe",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151510": {
    "id": "item_11896",
    "Last Name": "O'Shaughnessy",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151533": {
    "id": "item_35207",
    "Last Name": "Cordova",
    "First Name": "Aleanna Denice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151549": {
    "id": "item_11905",
    "Last Name": "Greentree",
    "First Name": "Jarrad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151551": {
    "id": "item_23223",
    "Last Name": "Greber",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151556": {
    "id": "item_35254",
    "Last Name": "Evans",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151585": {
    "id": "item_38066",
    "Last Name": "Exler",
    "First Name": "Carmen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151603": {
    "id": "item_23224",
    "Last Name": "Allan",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151604": {
    "id": "item_38070",
    "Last Name": "Garcia",
    "First Name": "Bronte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151613": {
    "id": "item_38073",
    "Last Name": "OÕNeill",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151617": {
    "id": "item_23228",
    "Last Name": "Cucaita",
    "First Name": "German",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151635": {
    "id": "item_38078",
    "Last Name": "Bayliss",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151649": {
    "id": "item_11901",
    "Last Name": "Anstice",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151657": {
    "id": "item_38045",
    "Last Name": "Craig",
    "First Name": "Stewart",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151662": {
    "id": "item_38053",
    "Last Name": "Hernandez",
    "First Name": "Dante",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151680": {
    "id": "item_35238",
    "Last Name": "Varricchio",
    "First Name": "Alanah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151702": {
    "id": "item_23217",
    "Last Name": "Topp",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151703": {
    "id": "item_38056",
    "Last Name": "Georgakopoulos",
    "First Name": "Anastasios",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151730": {
    "id": "item_38052",
    "Last Name": "Bommaghatta Venkatesh",
    "First Name": "Akash",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151742": {
    "id": "item_10149",
    "Last Name": "Davies",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151754": {
    "id": "item_10152",
    "Last Name": "van Jole",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151755": {
    "id": "item_11895",
    "Last Name": "FERNANDEZ",
    "First Name": "FEDERICO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151774": {
    "id": "item_23211",
    "Last Name": "Jasper",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151790": {
    "id": "item_38041",
    "Last Name": "Du",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151794": {
    "id": "item_10131",
    "Last Name": "Sproson",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151797": {
    "id": "item_10137",
    "Last Name": "Green",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151813": {
    "id": "item_23210",
    "Last Name": "Donnelly",
    "First Name": "Mia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151814": {
    "id": "item_10141",
    "Last Name": "Alvarez",
    "First Name": "Recio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151818": {
    "id": "item_10145",
    "Last Name": "Lemmens",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151822": {
    "id": "item_35226",
    "Last Name": "Bowes",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151827": {
    "id": "item_23205",
    "Last Name": "Wood",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151831": {
    "id": "item_38055",
    "Last Name": "Semb",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151844": {
    "id": "item_37804",
    "Last Name": "McDougall",
    "First Name": "Annaliese",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151857": {
    "id": "item_10140",
    "Last Name": "Blanc",
    "First Name": "Boris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151879": {
    "id": "item_23208",
    "Last Name": "Chung",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151891": {
    "id": "item_24455",
    "Last Name": "hernandez",
    "First Name": "ruthy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151898": {
    "id": "item_35219",
    "Last Name": "Wathen",
    "First Name": "Kurtis",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151901": {
    "id": "item_38011",
    "Last Name": "Nolan",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151904": {
    "id": "item_35797",
    "Last Name": "Park",
    "First Name": "EUN YOUNG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151908": {
    "id": "item_23190",
    "Last Name": "Ahmed",
    "First Name": "Zain",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151915": {
    "id": "item_35214",
    "Last Name": "Karagiozis",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151916": {
    "id": "item_35211",
    "Last Name": "Phillips",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151928": {
    "id": "item_35221",
    "Last Name": "Illindala",
    "First Name": "Vamsi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151934": {
    "id": "item_38035",
    "Last Name": "Hogan",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151936": {
    "id": "item_38003",
    "Last Name": "Polido de Souza",
    "First Name": "Luis Henrique",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151946": {
    "id": "item_38038",
    "Last Name": "Jeon",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151952": {
    "id": "item_38034",
    "Last Name": "Martens",
    "First Name": "Harry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151956": {
    "id": "item_38023",
    "Last Name": "Otieno",
    "First Name": "Robin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151973": {
    "id": "item_37988",
    "Last Name": "Buencamino",
    "First Name": "Frederick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151980": {
    "id": "item_23195",
    "Last Name": "Rathi",
    "First Name": "Sangeeta",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151984": {
    "id": "item_23203",
    "Last Name": "Hargreaves",
    "First Name": "Roderick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151990": {
    "id": "item_38021",
    "Last Name": "Benstead",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151996": {
    "id": "item_38017",
    "Last Name": "Yu",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37151999": {
    "id": "item_35217",
    "Last Name": "Wolff",
    "First Name": "Karin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152014": {
    "id": "item_23187",
    "Last Name": "Jenkinson",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152018": {
    "id": "item_38031",
    "Last Name": "Simonovic",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152038": {
    "id": "item_10133",
    "Last Name": "Powell-Morse",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152057": {
    "id": "item_24457",
    "Last Name": "Adams",
    "First Name": "Sally",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152079": {
    "id": "item_35191",
    "Last Name": "Baxter",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152110": {
    "id": "item_11875",
    "Last Name": "Gallagher",
    "First Name": "Aran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152113": {
    "id": "item_38001",
    "Last Name": "Ma",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152123": {
    "id": "item_35796",
    "Last Name": "Bracken",
    "First Name": "Killian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152150": {
    "id": "item_37843",
    "Last Name": "Mulrosha",
    "First Name": "Andika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152160": {
    "id": "item_23181",
    "Last Name": "Barnes",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152179": {
    "id": "item_11877",
    "Last Name": "Spielmann",
    "First Name": "Chad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152183": {
    "id": "item_37996",
    "Last Name": "Gollan",
    "First Name": "Alfred",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152189": {
    "id": "item_11881",
    "Last Name": "Bate",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152204": {
    "id": "item_23166",
    "Last Name": "Leembruggen",
    "First Name": "Pauline",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152213": {
    "id": "item_23182",
    "Last Name": "Adams",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152226": {
    "id": "item_23177",
    "Last Name": "Young",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152230": {
    "id": "item_10123",
    "Last Name": "Fonseca",
    "First Name": "Jo‹o Paulo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152238": {
    "id": "item_35198",
    "Last Name": "Hawken",
    "First Name": "Kendal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152239": {
    "id": "item_11871",
    "Last Name": "Man",
    "First Name": "Wan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152248": {
    "id": "item_37948",
    "Last Name": "Luis",
    "First Name": "Sheela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152251": {
    "id": "item_35199",
    "Last Name": "Bremner",
    "First Name": "Seth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152290": {
    "id": "item_37933",
    "Last Name": "Becerril",
    "First Name": "Juan Pablo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152294": {
    "id": "item_11870",
    "Last Name": "Chen",
    "First Name": "Yixiong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152330": {
    "id": "item_35178",
    "Last Name": "Parkes",
    "First Name": "Lizzie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152346": {
    "id": "item_35187",
    "Last Name": "Glover",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152361": {
    "id": "item_35184",
    "Last Name": "Man",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152380": {
    "id": "item_37977",
    "Last Name": "Howard",
    "First Name": "Daisy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152402": {
    "id": "item_37986",
    "Last Name": "Tsui",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152403": {
    "id": "item_37899",
    "Last Name": "Price",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152407": {
    "id": "item_10110",
    "Last Name": "Acevedo",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152410": {
    "id": "item_11867",
    "Last Name": "Cieza",
    "First Name": "Geronimo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152417": {
    "id": "item_10122",
    "Last Name": "McLaren",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152425": {
    "id": "item_10120",
    "Last Name": "Croston",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152440": {
    "id": "item_37980",
    "Last Name": "CHOWDHURI",
    "First Name": "SANDIPAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152484": {
    "id": "item_23153",
    "Last Name": "Zosa",
    "First Name": "Joselito",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152486": {
    "id": "item_10115",
    "Last Name": "Burnett",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152489": {
    "id": "item_37953",
    "Last Name": "Fillios",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152507": {
    "id": "item_35181",
    "Last Name": "Hill",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152508": {
    "id": "item_37962",
    "Last Name": "Choi",
    "First Name": "Sin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152523": {
    "id": "item_37969",
    "Last Name": "LI",
    "First Name": "JIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152549": {
    "id": "item_11841",
    "Last Name": "Somerville",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152560": {
    "id": "item_23160",
    "Last Name": "Davis",
    "First Name": "Benny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152577": {
    "id": "item_37918",
    "Last Name": "Evans",
    "First Name": "Mick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152584": {
    "id": "item_23155",
    "Last Name": "Forsyth",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152598": {
    "id": "item_37957",
    "Last Name": "Tallent",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152601": {
    "id": "item_11855",
    "Last Name": "Gooden",
    "First Name": "Keelan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152622": {
    "id": "item_37947",
    "Last Name": "Koch",
    "First Name": "Mel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152644": {
    "id": "item_10109",
    "Last Name": "Fallon",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152660": {
    "id": "item_37873",
    "Last Name": "Jones",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152661": {
    "id": "item_35175",
    "Last Name": "Williams",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152669": {
    "id": "item_35172",
    "Last Name": "Dakalbab",
    "First Name": "Osama",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152696": {
    "id": "item_23129",
    "Last Name": "Funnell",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152701": {
    "id": "item_35157",
    "Last Name": "O Sullivan",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152718": {
    "id": "item_37936",
    "Last Name": "Bovill",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152724": {
    "id": "item_24453",
    "Last Name": "Orellana",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152731": {
    "id": "item_23139",
    "Last Name": "Xia",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152737": {
    "id": "item_35168",
    "Last Name": "Gibson",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152750": {
    "id": "item_37931",
    "Last Name": "Dade",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152751": {
    "id": "item_10097",
    "Last Name": "Parke",
    "First Name": "Taz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152762": {
    "id": "item_23144",
    "Last Name": "Dunstan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152764": {
    "id": "item_11847",
    "Last Name": "Britnell",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152774": {
    "id": "item_37927",
    "Last Name": "Garms",
    "First Name": "Bruna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152781": {
    "id": "item_23133",
    "Last Name": "Lee",
    "First Name": "Hang Yip",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152782": {
    "id": "item_37924",
    "Last Name": "Parker",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152807": {
    "id": "item_37919",
    "Last Name": "Van Der Westhuizen",
    "First Name": "Tjaart",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152826": {
    "id": "item_35150",
    "Last Name": "Khor",
    "First Name": "Jacyline",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152833": {
    "id": "item_35149",
    "Last Name": "Diallo",
    "First Name": "Amadou",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152841": {
    "id": "item_11831",
    "Last Name": "Kelliher",
    "First Name": "Tadhg",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152851": {
    "id": "item_35154",
    "Last Name": "Jiao",
    "First Name": "Xingwei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152865": {
    "id": "item_35137",
    "Last Name": "Baingan",
    "First Name": "Janine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152886": {
    "id": "item_11828",
    "Last Name": "Cogan",
    "First Name": "Xanthe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152887": {
    "id": "item_37914",
    "Last Name": "Lee",
    "First Name": "Keegan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152907": {
    "id": "item_10088",
    "Last Name": "Loane",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152908": {
    "id": "item_35145",
    "Last Name": "Seditas",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152916": {
    "id": "item_23137",
    "Last Name": "Peng",
    "First Name": "Jacky",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152918": {
    "id": "item_35148",
    "Last Name": "Barreto Barbosa",
    "First Name": "Oscar Eli",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152933": {
    "id": "item_11838",
    "Last Name": "Walsh",
    "First Name": "Adelene",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152935": {
    "id": "item_11834",
    "Last Name": "Ensor",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152939": {
    "id": "item_10568",
    "Last Name": "enriques",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152941": {
    "id": "item_37881",
    "Last Name": "Tolentino",
    "First Name": "Raven Joshua",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152943": {
    "id": "item_37912",
    "Last Name": "Baadarani",
    "First Name": "Sami",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152953": {
    "id": "item_35147",
    "Last Name": "O'Connor",
    "First Name": "Enya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152956": {
    "id": "item_35152",
    "Last Name": "QI",
    "First Name": "ANNA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37152983": {
    "id": "item_35141",
    "Last Name": "Huang",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153001": {
    "id": "item_35118",
    "Last Name": "Abaya",
    "First Name": "Khristine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153007": {
    "id": "item_37867",
    "Last Name": "Schmitzer",
    "First Name": "Jodie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153008": {
    "id": "item_35097",
    "Last Name": "Bosio",
    "First Name": "Maddison",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153010": {
    "id": "item_23128",
    "Last Name": "Lander",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153020": {
    "id": "item_11836",
    "Last Name": "Cusack",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153022": {
    "id": "item_11835",
    "Last Name": "Hall",
    "First Name": "Ammon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153046": {
    "id": "item_10084",
    "Last Name": "Mendoza",
    "First Name": "Patricia Rose",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153048": {
    "id": "item_37855",
    "Last Name": "Wallace",
    "First Name": "Heath",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153058": {
    "id": "item_37898",
    "Last Name": "Nadaraju",
    "First Name": "Francis",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153074": {
    "id": "item_10083",
    "Last Name": "Mandikiza",
    "First Name": "Lenon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153086": {
    "id": "item_11827",
    "Last Name": "Crellin",
    "First Name": "Kenya",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153107": {
    "id": "item_35138",
    "Last Name": "Novilla",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153108": {
    "id": "item_23120",
    "Last Name": "Bouwmeester",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153135": {
    "id": "item_37836",
    "Last Name": "Teo Yii Wen",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153139": {
    "id": "item_10079",
    "Last Name": "Wardell",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153142": {
    "id": "item_37833",
    "Last Name": "Genet",
    "First Name": "Shane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153151": {
    "id": "item_12379",
    "Last Name": "Ellis",
    "First Name": "Barry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153152": {
    "id": "item_23117",
    "Last Name": "Chan",
    "First Name": "Ting Bun",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153185": {
    "id": "item_10081",
    "Last Name": "Moore",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153188": {
    "id": "item_10077",
    "Last Name": "Luscombe",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153198": {
    "id": "item_23121",
    "Last Name": "Mead",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153207": {
    "id": "item_37865",
    "Last Name": "Ngoma",
    "First Name": "Nyasha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153208": {
    "id": "item_23092",
    "Last Name": "Butler",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153225": {
    "id": "item_10078",
    "Last Name": "Sheard",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153235": {
    "id": "item_35090",
    "Last Name": "Farlee",
    "First Name": "Ann",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153255": {
    "id": "item_11824",
    "Last Name": "Costi",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153262": {
    "id": "item_24450",
    "Last Name": "Song",
    "First Name": "Marco",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153265": {
    "id": "item_11825",
    "Last Name": "Govier",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153268": {
    "id": "item_10072",
    "Last Name": "Honan",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153271": {
    "id": "item_23105",
    "Last Name": "Koelmeyer",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153293": {
    "id": "item_23108",
    "Last Name": "Williams",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153298": {
    "id": "item_37847",
    "Last Name": "Ndlovu",
    "First Name": "Thandeka",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153302": {
    "id": "item_10070",
    "Last Name": "COTA GARCêA",
    "First Name": "JOSƒ CARLOS",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153306": {
    "id": "item_37840",
    "Last Name": "zhang",
    "First Name": "yanzhe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153318": {
    "id": "item_10567",
    "Last Name": "Horwitz",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153329": {
    "id": "item_24446",
    "Last Name": "Sherpa",
    "First Name": "Sonam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153383": {
    "id": "item_35116",
    "Last Name": "Scott",
    "First Name": "Ross",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153384": {
    "id": "item_23097",
    "Last Name": "Huy",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153408": {
    "id": "item_35102",
    "Last Name": "Gwynn-Jones",
    "First Name": "Kirsty",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153417": {
    "id": "item_35113",
    "Last Name": "Ryan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153423": {
    "id": "item_35022",
    "Last Name": "Hoey",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153436": {
    "id": "item_23065",
    "Last Name": "dalgliesh",
    "First Name": "miles",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153454": {
    "id": "item_11811",
    "Last Name": "Tia",
    "First Name": "Aik Teong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153467": {
    "id": "item_10049",
    "Last Name": "Brennan-Coulthard",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153477": {
    "id": "item_23093",
    "Last Name": "Griffiths",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153495": {
    "id": "item_37853",
    "Last Name": "Connor",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153499": {
    "id": "item_24449",
    "Last Name": "Bavester",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153504": {
    "id": "item_35103",
    "Last Name": "McInerney",
    "First Name": "Tania",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153560": {
    "id": "item_23078",
    "Last Name": "McNamara",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153575": {
    "id": "item_23085",
    "Last Name": "Ortiz",
    "First Name": "Susana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153581": {
    "id": "item_10062",
    "Last Name": "Don",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153613": {
    "id": "item_23089",
    "Last Name": "Turner",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153629": {
    "id": "item_23070",
    "Last Name": "Culpeper",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153631": {
    "id": "item_23090",
    "Last Name": "Rizvanov",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153633": {
    "id": "item_10061",
    "Last Name": "Ferguson",
    "First Name": "Marissa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153637": {
    "id": "item_37822",
    "Last Name": "Merigan",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153649": {
    "id": "item_10059",
    "Last Name": "Male",
    "First Name": "Lucien",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153696": {
    "id": "item_35100",
    "Last Name": "Adedapo",
    "First Name": "Babatunde",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153712": {
    "id": "item_37791",
    "Last Name": "McClelland",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153718": {
    "id": "item_24438",
    "Last Name": "Chan",
    "First Name": "Wing Kin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153722": {
    "id": "item_37826",
    "Last Name": "Crinion",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153725": {
    "id": "item_37827",
    "Last Name": "Dsouza",
    "First Name": "Anali",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153731": {
    "id": "item_23076",
    "Last Name": "Ray",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153741": {
    "id": "item_35095",
    "Last Name": "Tan",
    "First Name": "Kristine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153749": {
    "id": "item_11803",
    "Last Name": "Reid",
    "First Name": "Denzel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153773": {
    "id": "item_11802",
    "Last Name": "Danks",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153784": {
    "id": "item_11805",
    "Last Name": "Stockwell",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153802": {
    "id": "item_37820",
    "Last Name": "Ho",
    "First Name": "Allan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153814": {
    "id": "item_37813",
    "Last Name": "WOO",
    "First Name": "SIU MING",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153815": {
    "id": "item_10045",
    "Last Name": "Agwalama",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153832": {
    "id": "item_37816",
    "Last Name": "Feierbach-Christian",
    "First Name": "Mara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153845": {
    "id": "item_23056",
    "Last Name": "Solomon",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153851": {
    "id": "item_10031",
    "Last Name": "Connery",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153856": {
    "id": "item_23066",
    "Last Name": "Pollock",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153882": {
    "id": "item_11799",
    "Last Name": "Fallon",
    "First Name": "Mick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153892": {
    "id": "item_35083",
    "Last Name": "Visser",
    "First Name": "Michiel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153916": {
    "id": "item_10041",
    "Last Name": "Welsh",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153925": {
    "id": "item_10040",
    "Last Name": "Kunz",
    "First Name": "Madeline",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153945": {
    "id": "item_35081",
    "Last Name": "Alder",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153949": {
    "id": "item_37807",
    "Last Name": "Buencamino",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153974": {
    "id": "item_23051",
    "Last Name": "Cornish",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153981": {
    "id": "item_10037",
    "Last Name": "Wang",
    "First Name": "Kai Hsiang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37153983": {
    "id": "item_37805",
    "Last Name": "Rozo Hernandez",
    "First Name": "Jorge Alberto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154006": {
    "id": "item_35073",
    "Last Name": "Boonstra",
    "First Name": "Abbey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154012": {
    "id": "item_23045",
    "Last Name": "Moore",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154025": {
    "id": "item_12378",
    "Last Name": "Soria",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154037": {
    "id": "item_35064",
    "Last Name": "Erana",
    "First Name": "Ricia Ann",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154068": {
    "id": "item_10036",
    "Last Name": "Kourim",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154071": {
    "id": "item_23039",
    "Last Name": "Masel",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154096": {
    "id": "item_23043",
    "Last Name": "Campbell",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154098": {
    "id": "item_37786",
    "Last Name": "S V SOUNDAPPAN",
    "First Name": "SOUNDAPPAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154124": {
    "id": "item_11782",
    "Last Name": "Noujoum",
    "First Name": "Khadija",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154152": {
    "id": "item_37789",
    "Last Name": "Latimer",
    "First Name": "Shay",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154186": {
    "id": "item_35066",
    "Last Name": "Casey",
    "First Name": "Shelly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154202": {
    "id": "item_10033",
    "Last Name": "Gomes",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154206": {
    "id": "item_35058",
    "Last Name": "Heron",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154237": {
    "id": "item_37779",
    "Last Name": "Alder",
    "First Name": "Caprice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154260": {
    "id": "item_37773",
    "Last Name": "Zhou",
    "First Name": "Bo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154277": {
    "id": "item_35052",
    "Last Name": "Cuenco",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154282": {
    "id": "item_10027",
    "Last Name": "Blackburn",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154298": {
    "id": "item_24436",
    "Last Name": "Mendoza",
    "First Name": "Karla",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154303": {
    "id": "item_35053",
    "Last Name": "Hardie",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154350": {
    "id": "item_23019",
    "Last Name": "Pham",
    "First Name": "Kenny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154356": {
    "id": "item_35044",
    "Last Name": "Silcock",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154360": {
    "id": "item_37741",
    "Last Name": "shaw",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154383": {
    "id": "item_35036",
    "Last Name": "Nanda",
    "First Name": "Ericho",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154401": {
    "id": "item_37768",
    "Last Name": "Effendi",
    "First Name": "Yenny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154413": {
    "id": "item_35043",
    "Last Name": "Kanowski",
    "First Name": "Steve",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154418": {
    "id": "item_35047",
    "Last Name": "Chien",
    "First Name": "Wei-An",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154422": {
    "id": "item_37759",
    "Last Name": "Hernandez rios",
    "First Name": "Edgar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154429": {
    "id": "item_23017",
    "Last Name": "Condon",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154437": {
    "id": "item_23016",
    "Last Name": "Willeston",
    "First Name": "Ged",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154456": {
    "id": "item_23011",
    "Last Name": "YANG",
    "First Name": "ZHENYU",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154459": {
    "id": "item_37766",
    "Last Name": "Bisignano",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154482": {
    "id": "item_37763",
    "Last Name": "Watson",
    "First Name": "Clare",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154483": {
    "id": "item_37745",
    "Last Name": "OBrien",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154484": {
    "id": "item_35032",
    "Last Name": "Priest",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154499": {
    "id": "item_11753",
    "Last Name": "Liu",
    "First Name": "Yuanao",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154559": {
    "id": "item_23009",
    "Last Name": "Thomas",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154573": {
    "id": "item_10011",
    "Last Name": "Kennedy-Adams",
    "First Name": "Leon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154577": {
    "id": "item_35015",
    "Last Name": "Collins",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154616": {
    "id": "item_35034",
    "Last Name": "Bohan",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154654": {
    "id": "item_24396",
    "Last Name": "Xia",
    "First Name": "Fei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154673": {
    "id": "item_10015",
    "Last Name": "Hanlon",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154688": {
    "id": "item_23006",
    "Last Name": "Moreno",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154689": {
    "id": "item_37734",
    "Last Name": "Hamment",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154702": {
    "id": "item_24433",
    "Last Name": "Longstaff",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154705": {
    "id": "item_24383",
    "Last Name": "Ma",
    "First Name": "Shanen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154709": {
    "id": "item_37738",
    "Last Name": "Reveley",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154728": {
    "id": "item_35028",
    "Last Name": "Jawando-Williams",
    "First Name": "Philippa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154740": {
    "id": "item_11765",
    "Last Name": "Donaldson",
    "First Name": "Bill",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154764": {
    "id": "item_37731",
    "Last Name": "Stratford",
    "First Name": "Deanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154771": {
    "id": "item_35016",
    "Last Name": "Fischer",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154776": {
    "id": "item_37725",
    "Last Name": "Sherman",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154873": {
    "id": "item_11760",
    "Last Name": "Shoesmith",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154891": {
    "id": "item_11755",
    "Last Name": "Choi",
    "First Name": "Minho",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154897": {
    "id": "item_37718",
    "Last Name": "Angud",
    "First Name": "Johannes",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154900": {
    "id": "item_37708",
    "Last Name": "White",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154907": {
    "id": "item_37714",
    "Last Name": "Beavis",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154926": {
    "id": "item_10002",
    "Last Name": "Taylor",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154930": {
    "id": "item_37711",
    "Last Name": "mesic",
    "First Name": "sophie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154951": {
    "id": "item_22998",
    "Last Name": "Eka Nugyasa",
    "First Name": "Yahya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154958": {
    "id": "item_11751",
    "Last Name": "Nauta",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154977": {
    "id": "item_23001",
    "Last Name": "Rogerson",
    "First Name": "Grant",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154987": {
    "id": "item_35007",
    "Last Name": "McGrath",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154991": {
    "id": "item_37664",
    "Last Name": "Rhodes",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37154993": {
    "id": "item_37678",
    "Last Name": "Leonard",
    "First Name": "Julian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155017": {
    "id": "item_22978",
    "Last Name": "Stugard",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155027": {
    "id": "item_22995",
    "Last Name": "Vazquez",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155029": {
    "id": "item_37685",
    "Last Name": "Steyn",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155030": {
    "id": "item_37693",
    "Last Name": "Singh",
    "First Name": "Trisha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155031": {
    "id": "item_22996",
    "Last Name": "JOHNSON",
    "First Name": "MARK",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155038": {
    "id": "item_24387",
    "Last Name": "Abdul",
    "First Name": "Wahid",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155043": {
    "id": "item_11749",
    "Last Name": "Buckley",
    "First Name": "kenneth",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155053": {
    "id": "item_35002",
    "Last Name": "Mulhearn",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155073": {
    "id": "item_37681",
    "Last Name": "Wang",
    "First Name": "Yutong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155079": {
    "id": "item_37699",
    "Last Name": "Croton",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155091": {
    "id": "item_22993",
    "Last Name": "Smith",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155096": {
    "id": "item_24427",
    "Last Name": "Collado Such",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155103": {
    "id": "item_22986",
    "Last Name": "enno",
    "First Name": "SAMANTHA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155118": {
    "id": "item_37674",
    "Last Name": "Rees",
    "First Name": "Jaimie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155127": {
    "id": "item_37677",
    "Last Name": "Macdonald",
    "First Name": "Katalina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155148": {
    "id": "item_24423",
    "Last Name": "Cormican",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155158": {
    "id": "item_22984",
    "Last Name": "Bhebhe",
    "First Name": "Harris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155193": {
    "id": "item_24418",
    "Last Name": "Smith",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155200": {
    "id": "item_37606",
    "Last Name": "Hassall",
    "First Name": "Vicky",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155207": {
    "id": "item_24416",
    "Last Name": "Richards",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155214": {
    "id": "item_24422",
    "Last Name": "McPhee",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155228": {
    "id": "item_24411",
    "Last Name": "Campbell",
    "First Name": "Tommy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155231": {
    "id": "item_9992",
    "Last Name": "Sanders",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155237": {
    "id": "item_24413",
    "Last Name": "Micallef",
    "First Name": "Noel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155241": {
    "id": "item_37657",
    "Last Name": "OConnor",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155272": {
    "id": "item_22982",
    "Last Name": "Wytkin",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155283": {
    "id": "item_9990",
    "Last Name": "Fitzgerald",
    "First Name": "Gatsby",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155301": {
    "id": "item_37654",
    "Last Name": "Yang",
    "First Name": "Sheng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155311": {
    "id": "item_11745",
    "Last Name": "Piiroinen",
    "First Name": "Bryn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155320": {
    "id": "item_37620",
    "Last Name": "Magtoto",
    "First Name": "Jude Kevin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155338": {
    "id": "item_24410",
    "Last Name": "White",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155353": {
    "id": "item_37635",
    "Last Name": "Tang",
    "First Name": "Zhi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155355": {
    "id": "item_9988",
    "Last Name": "Sherry",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155367": {
    "id": "item_37644",
    "Last Name": "Bouziri",
    "First Name": "Nesrine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155370": {
    "id": "item_37659",
    "Last Name": "Yap",
    "First Name": "Sim Chin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155380": {
    "id": "item_11747",
    "Last Name": "Crilly",
    "First Name": "Ray",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155381": {
    "id": "item_11722",
    "Last Name": "Boey",
    "First Name": "Montien",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155386": {
    "id": "item_37652",
    "Last Name": "McKendrick",
    "First Name": "Lita",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155387": {
    "id": "item_37645",
    "Last Name": "Lockhart",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155395": {
    "id": "item_22972",
    "Last Name": "Pate",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155397": {
    "id": "item_22974",
    "Last Name": "way",
    "First Name": "kane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155407": {
    "id": "item_24404",
    "Last Name": "Cullinane",
    "First Name": "Martina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155412": {
    "id": "item_37630",
    "Last Name": "Dimaandal",
    "First Name": "Roman",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155419": {
    "id": "item_22976",
    "Last Name": "Winterbourne",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155421": {
    "id": "item_24403",
    "Last Name": "Dundas",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155432": {
    "id": "item_11741",
    "Last Name": "Gambier Ross",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155433": {
    "id": "item_37632",
    "Last Name": "Scarborough",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155434": {
    "id": "item_34987",
    "Last Name": "Arkle",
    "First Name": "Pete",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155439": {
    "id": "item_24406",
    "Last Name": "Featonby",
    "First Name": "Deane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155459": {
    "id": "item_37631",
    "Last Name": "Naughton",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155462": {
    "id": "item_37636",
    "Last Name": "Atkinson",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155488": {
    "id": "item_37626",
    "Last Name": "Chen",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155497": {
    "id": "item_11738",
    "Last Name": "Skillman",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155504": {
    "id": "item_22968",
    "Last Name": "Chua",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155527": {
    "id": "item_22969",
    "Last Name": "Smith",
    "First Name": "Rob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155567": {
    "id": "item_22959",
    "Last Name": "Morton",
    "First Name": "Ryley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155594": {
    "id": "item_22963",
    "Last Name": "HERRERA LARENAS",
    "First Name": "LEONARDO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155609": {
    "id": "item_37623",
    "Last Name": "Lam",
    "First Name": "Kau Wang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155623": {
    "id": "item_24395",
    "Last Name": "Crouch",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155628": {
    "id": "item_37619",
    "Last Name": "Davis",
    "First Name": "Georgie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155691": {
    "id": "item_9976",
    "Last Name": "Whelan",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155702": {
    "id": "item_22957",
    "Last Name": "Ling",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155710": {
    "id": "item_11729",
    "Last Name": "de Bricassart",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155718": {
    "id": "item_37605",
    "Last Name": "Robson",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155737": {
    "id": "item_9977",
    "Last Name": "Welch",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155743": {
    "id": "item_37602",
    "Last Name": "Claro",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155752": {
    "id": "item_34974",
    "Last Name": "Mallon",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155782": {
    "id": "item_24390",
    "Last Name": "Garkawe",
    "First Name": "Zack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155783": {
    "id": "item_9974",
    "Last Name": "Brownhill",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155803": {
    "id": "item_37601",
    "Last Name": "Harcourt",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155808": {
    "id": "item_22951",
    "Last Name": "Lim",
    "First Name": "Aik Fan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155834": {
    "id": "item_22946",
    "Last Name": "Carmichael",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155881": {
    "id": "item_11719",
    "Last Name": "Lindsay",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155905": {
    "id": "item_37580",
    "Last Name": "Black",
    "First Name": "Damien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155908": {
    "id": "item_9971",
    "Last Name": "Maxwell",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155928": {
    "id": "item_11716",
    "Last Name": "Mackle",
    "First Name": "Keelan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155950": {
    "id": "item_37571",
    "Last Name": "Ganasen",
    "First Name": "Suhan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37155970": {
    "id": "item_22938",
    "Last Name": "Renaldi",
    "First Name": "Dimas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156000": {
    "id": "item_11711",
    "Last Name": "Goh",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156028": {
    "id": "item_9953",
    "Last Name": "Fung",
    "First Name": "Tin Yiu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156029": {
    "id": "item_9954",
    "Last Name": "Hamann",
    "First Name": "Ralf",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156031": {
    "id": "item_9966",
    "Last Name": "Dixon",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156035": {
    "id": "item_11708",
    "Last Name": "BARNES",
    "First Name": "MANDELA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156041": {
    "id": "item_22936",
    "Last Name": "Urquhart",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156053": {
    "id": "item_24379",
    "Last Name": "eng",
    "First Name": "kevin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156055": {
    "id": "item_24377",
    "Last Name": "Dillard",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156063": {
    "id": "item_37576",
    "Last Name": "Radons",
    "First Name": "Nele",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156120": {
    "id": "item_9956",
    "Last Name": "Pienaar",
    "First Name": "Andre",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156127": {
    "id": "item_22931",
    "Last Name": "Munjodzi",
    "First Name": "Ignatius",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156128": {
    "id": "item_11701",
    "Last Name": "Bradley",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156139": {
    "id": "item_24337",
    "Last Name": "Pallares Zabaleta",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156143": {
    "id": "item_11710",
    "Last Name": "Nguyen",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156153": {
    "id": "item_9946",
    "Last Name": "Foley",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156162": {
    "id": "item_9957",
    "Last Name": "Wood",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156195": {
    "id": "item_37567",
    "Last Name": "Gascoigne",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156198": {
    "id": "item_22932",
    "Last Name": "Woodman",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156220": {
    "id": "item_9949",
    "Last Name": "Marten",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156238": {
    "id": "item_22920",
    "Last Name": "Farrington",
    "First Name": "Zack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156239": {
    "id": "item_9955",
    "Last Name": "Young",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156248": {
    "id": "item_11704",
    "Last Name": "Lim",
    "First Name": "Graham",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156250": {
    "id": "item_12377",
    "Last Name": "Hao",
    "First Name": "Yahui",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156255": {
    "id": "item_37563",
    "Last Name": "Fitzgerald",
    "First Name": "Owen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156269": {
    "id": "item_24371",
    "Last Name": "Cieslik",
    "First Name": "Zachary Alexander",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156273": {
    "id": "item_9950",
    "Last Name": "Hasell",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156298": {
    "id": "item_24918",
    "Last Name": "Stergos",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156324": {
    "id": "item_37560",
    "Last Name": "Lilley",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156351": {
    "id": "item_24370",
    "Last Name": "Johnson",
    "First Name": "Zhanna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156423": {
    "id": "item_24364",
    "Last Name": "Kopp",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156424": {
    "id": "item_9943",
    "Last Name": "Krizman",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156434": {
    "id": "item_37524",
    "Last Name": "Butsri",
    "First Name": "Juree",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156444": {
    "id": "item_24361",
    "Last Name": "Macdonald",
    "First Name": "Lily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156462": {
    "id": "item_24339",
    "Last Name": "Musni",
    "First Name": "Marvin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156487": {
    "id": "item_37516",
    "Last Name": "AHMED",
    "First Name": "KABEER",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156489": {
    "id": "item_22922",
    "Last Name": "Tamblyn",
    "First Name": "Jodi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156514": {
    "id": "item_22907",
    "Last Name": "Min",
    "First Name": "Xiaoping",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156534": {
    "id": "item_37535",
    "Last Name": "Brier",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156537": {
    "id": "item_9938",
    "Last Name": "Sacal",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156543": {
    "id": "item_22911",
    "Last Name": "Kullen",
    "First Name": "Salversan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156550": {
    "id": "item_9939",
    "Last Name": "Jensen",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156555": {
    "id": "item_37527",
    "Last Name": "Mercadante",
    "First Name": "Marco",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156598": {
    "id": "item_37530",
    "Last Name": "Murphy",
    "First Name": "Ella",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156612": {
    "id": "item_11693",
    "Last Name": "VALENZUELA",
    "First Name": "JOSE MIGUEL",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156619": {
    "id": "item_12376",
    "Last Name": "ROH",
    "First Name": "DAJI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156620": {
    "id": "item_24356",
    "Last Name": "Jugovac",
    "First Name": "Taylah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156638": {
    "id": "item_37509",
    "Last Name": "McDonnell",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156639": {
    "id": "item_37499",
    "Last Name": "Harber",
    "First Name": "Jazzmin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156684": {
    "id": "item_37482",
    "Last Name": "Wijaya",
    "First Name": "Franky",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156685": {
    "id": "item_37514",
    "Last Name": "Farrell",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156697": {
    "id": "item_9933",
    "Last Name": "Fahrer",
    "First Name": "Nik",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156699": {
    "id": "item_9934",
    "Last Name": "Kay",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156716": {
    "id": "item_34958",
    "Last Name": "Ling",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156732": {
    "id": "item_37500",
    "Last Name": "Yahya",
    "First Name": "Ezreena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156742": {
    "id": "item_11688",
    "Last Name": "Baskin",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156751": {
    "id": "item_37501",
    "Last Name": "Jack",
    "First Name": "Eleanor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156783": {
    "id": "item_34956",
    "Last Name": "Watty",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156797": {
    "id": "item_22893",
    "Last Name": "Thomas",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156800": {
    "id": "item_37505",
    "Last Name": "Falzon",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156824": {
    "id": "item_24344",
    "Last Name": "Wood",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156832": {
    "id": "item_37496",
    "Last Name": "Noll",
    "First Name": "Stella",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156834": {
    "id": "item_22890",
    "Last Name": "Raab",
    "First Name": "Connor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156843": {
    "id": "item_9920",
    "Last Name": "Gao",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156854": {
    "id": "item_22887",
    "Last Name": "Collingwood-Boots",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156863": {
    "id": "item_24346",
    "Last Name": "Sztar",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156866": {
    "id": "item_37498",
    "Last Name": "Vellin",
    "First Name": "Kane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156870": {
    "id": "item_9914",
    "Last Name": "McNeilly",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156890": {
    "id": "item_37483",
    "Last Name": "Khoo",
    "First Name": "Caleb",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156894": {
    "id": "item_24341",
    "Last Name": "Quach",
    "First Name": "Newton",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156910": {
    "id": "item_37488",
    "Last Name": "Urquhart",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156927": {
    "id": "item_22891",
    "Last Name": "Lowe",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156932": {
    "id": "item_9921",
    "Last Name": "Connelly",
    "First Name": "Levi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156938": {
    "id": "item_11680",
    "Last Name": "Castles",
    "First Name": "Conan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156957": {
    "id": "item_37487",
    "Last Name": "Scally",
    "First Name": "Adelyne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156966": {
    "id": "item_35746",
    "Last Name": "Chiu",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156979": {
    "id": "item_9918",
    "Last Name": "Stout",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37156993": {
    "id": "item_34952",
    "Last Name": "Mirzoian",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157000": {
    "id": "item_24334",
    "Last Name": "Vargas",
    "First Name": "Jesus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157022": {
    "id": "item_24331",
    "Last Name": "Porter",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157038": {
    "id": "item_22873",
    "Last Name": "Lee",
    "First Name": "King Yiu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157053": {
    "id": "item_37476",
    "Last Name": "Pridgeon",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157062": {
    "id": "item_22882",
    "Last Name": "Leske",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157065": {
    "id": "item_22881",
    "Last Name": "Vo",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157068": {
    "id": "item_11675",
    "Last Name": "Borschmann",
    "First Name": "Mollie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157084": {
    "id": "item_11677",
    "Last Name": "Archie",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157096": {
    "id": "item_22884",
    "Last Name": "Sheehan",
    "First Name": "Cushla",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157097": {
    "id": "item_37470",
    "Last Name": "ASILO",
    "First Name": "HILARIO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157128": {
    "id": "item_37469",
    "Last Name": "Johnstone",
    "First Name": "Gavan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157141": {
    "id": "item_22866",
    "Last Name": "Setthapinun",
    "First Name": "Ampol",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157143": {
    "id": "item_9908",
    "Last Name": "CHIU",
    "First Name": "JUI JUNG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157152": {
    "id": "item_37471",
    "Last Name": "Miedema",
    "First Name": "Mirjam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157154": {
    "id": "item_22857",
    "Last Name": "Evans",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157155": {
    "id": "item_24306",
    "Last Name": "Bushell",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157190": {
    "id": "item_24324",
    "Last Name": "Ngan",
    "First Name": "Yat Long",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157194": {
    "id": "item_11672",
    "Last Name": "Ong",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157197": {
    "id": "item_9906",
    "Last Name": "Goncalves",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157253": {
    "id": "item_11670",
    "Last Name": "Hsu",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157264": {
    "id": "item_37458",
    "Last Name": "Gopalakrishnan",
    "First Name": "Anup",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157273": {
    "id": "item_37462",
    "Last Name": "Carter",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157302": {
    "id": "item_24319",
    "Last Name": "Andrews",
    "First Name": "Dayna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157308": {
    "id": "item_34946",
    "Last Name": "Dukino",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157314": {
    "id": "item_9902",
    "Last Name": "Yeo",
    "First Name": "Tyson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157345": {
    "id": "item_22865",
    "Last Name": "Moorthy",
    "First Name": "Chirag",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157348": {
    "id": "item_24311",
    "Last Name": "Edwards",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157360": {
    "id": "item_37448",
    "Last Name": "Elkins",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157372": {
    "id": "item_9900",
    "Last Name": "Dubar",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157383": {
    "id": "item_37434",
    "Last Name": "Jochinke",
    "First Name": "Elise",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157385": {
    "id": "item_9898",
    "Last Name": "Collin",
    "First Name": "Clair",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157436": {
    "id": "item_24310",
    "Last Name": "Koh",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157441": {
    "id": "item_11667",
    "Last Name": "Chang",
    "First Name": "Kochang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157443": {
    "id": "item_37442",
    "Last Name": "Nguyen",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157486": {
    "id": "item_34943",
    "Last Name": "Davie",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157494": {
    "id": "item_37429",
    "Last Name": "Pryor",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157499": {
    "id": "item_37432",
    "Last Name": "cho",
    "First Name": "Yongho",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157521": {
    "id": "item_22843",
    "Last Name": "Chuang",
    "First Name": "Kyle (Yu-Sheng)",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157527": {
    "id": "item_22848",
    "Last Name": "McLachlan",
    "First Name": "Olive",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157528": {
    "id": "item_22852",
    "Last Name": "Murphy",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157539": {
    "id": "item_9889",
    "Last Name": "Jacobo Kaim",
    "First Name": "Juan Pablo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157555": {
    "id": "item_11664",
    "Last Name": "Potter",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157558": {
    "id": "item_22851",
    "Last Name": "Moloughney",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157585": {
    "id": "item_24305",
    "Last Name": "Woodhouse",
    "First Name": "Jen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157591": {
    "id": "item_37426",
    "Last Name": "Anderson",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157593": {
    "id": "item_34937",
    "Last Name": "chen",
    "First Name": "chiaying",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157595": {
    "id": "item_37419",
    "Last Name": "Paice",
    "First Name": "Vanesa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157603": {
    "id": "item_37423",
    "Last Name": "Byrne",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157605": {
    "id": "item_22847",
    "Last Name": "McMahon",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157675": {
    "id": "item_11647",
    "Last Name": "Kramer",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157689": {
    "id": "item_37416",
    "Last Name": "Rehman",
    "First Name": "Osama",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157697": {
    "id": "item_37397",
    "Last Name": "Pham",
    "First Name": "Liem",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157705": {
    "id": "item_9881",
    "Last Name": "Gordon",
    "First Name": "Dale",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157710": {
    "id": "item_9886",
    "Last Name": "cain",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157711": {
    "id": "item_34935",
    "Last Name": "Peddie",
    "First Name": "Kirsty",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157722": {
    "id": "item_37388",
    "Last Name": "Limansyah",
    "First Name": "Emil",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157725": {
    "id": "item_37403",
    "Last Name": "Cheng",
    "First Name": "Ya-Feng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157736": {
    "id": "item_37411",
    "Last Name": "Xue",
    "First Name": "Feier",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157753": {
    "id": "item_24292",
    "Last Name": "Angdika",
    "First Name": "Suwanto",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157774": {
    "id": "item_9884",
    "Last Name": "King",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157794": {
    "id": "item_24298",
    "Last Name": "Suryantoro",
    "First Name": "Suryantoro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157800": {
    "id": "item_10566",
    "Last Name": "Moyle",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157806": {
    "id": "item_37402",
    "Last Name": "Gould",
    "First Name": "Corey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157809": {
    "id": "item_37386",
    "Last Name": "Boko",
    "First Name": "Troy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157834": {
    "id": "item_24297",
    "Last Name": "Maddock",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157853": {
    "id": "item_22826",
    "Last Name": "Sreenivasan",
    "First Name": "Sreejith",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157861": {
    "id": "item_22825",
    "Last Name": "MCNAUGHTON",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157868": {
    "id": "item_37392",
    "Last Name": "Mitchell",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157902": {
    "id": "item_24293",
    "Last Name": "Rowe",
    "First Name": "Amber",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157935": {
    "id": "item_37385",
    "Last Name": "Mori",
    "First Name": "Sena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157959": {
    "id": "item_22821",
    "Last Name": "Omandam",
    "First Name": "Jonas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157977": {
    "id": "item_37378",
    "Last Name": "Hopwood",
    "First Name": "Dayna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157978": {
    "id": "item_34928",
    "Last Name": "Sinnott",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157982": {
    "id": "item_11641",
    "Last Name": "Ye",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157984": {
    "id": "item_11644",
    "Last Name": "McNamara",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37157991": {
    "id": "item_9868",
    "Last Name": "REDO",
    "First Name": "Franck",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158013": {
    "id": "item_37366",
    "Last Name": "Quah",
    "First Name": "Boon-Siew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158029": {
    "id": "item_37377",
    "Last Name": "Sherburn",
    "First Name": "Dane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158060": {
    "id": "item_37374",
    "Last Name": "Gundry",
    "First Name": "Alyson",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158061": {
    "id": "item_11639",
    "Last Name": "Badger",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158081": {
    "id": "item_37371",
    "Last Name": "Huynh",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158092": {
    "id": "item_22814",
    "Last Name": "Ryan",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158100": {
    "id": "item_24917",
    "Last Name": "Cheery",
    "First Name": "Youhan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158123": {
    "id": "item_37373",
    "Last Name": "Black",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158150": {
    "id": "item_22807",
    "Last Name": "Wahab",
    "First Name": "Aswadi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158155": {
    "id": "item_22809",
    "Last Name": "Dodson",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158176": {
    "id": "item_22810",
    "Last Name": "Ryan",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158183": {
    "id": "item_9862",
    "Last Name": "Lake",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158187": {
    "id": "item_37367",
    "Last Name": "Banner",
    "First Name": "Alesha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158217": {
    "id": "item_22789",
    "Last Name": "Peacock",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158219": {
    "id": "item_37306",
    "Last Name": "France",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158243": {
    "id": "item_24287",
    "Last Name": "Ieong",
    "First Name": "Chi Tong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158251": {
    "id": "item_37349",
    "Last Name": "Njoroge",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158260": {
    "id": "item_9858",
    "Last Name": "Ashikhmin",
    "First Name": "Matvei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158261": {
    "id": "item_11631",
    "Last Name": "Unsworth",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158269": {
    "id": "item_11626",
    "Last Name": "Dinh",
    "First Name": "Mackinley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158292": {
    "id": "item_37344",
    "Last Name": "Quan",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158300": {
    "id": "item_11625",
    "Last Name": "Chanrai",
    "First Name": "Ambika",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158312": {
    "id": "item_11607",
    "Last Name": "KIM",
    "First Name": "YOUNGTAE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158324": {
    "id": "item_22786",
    "Last Name": "De Aguiar Bellesia",
    "First Name": "Nathalia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158327": {
    "id": "item_34920",
    "Last Name": "Nalen",
    "First Name": "Tate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158328": {
    "id": "item_37356",
    "Last Name": "Perez",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158347": {
    "id": "item_37354",
    "Last Name": "Coombs",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158375": {
    "id": "item_24916",
    "Last Name": "Tenorio",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158384": {
    "id": "item_37347",
    "Last Name": "van Pinxteren",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158398": {
    "id": "item_22800",
    "Last Name": "Hopper",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158411": {
    "id": "item_34917",
    "Last Name": "Magtagnob",
    "First Name": "Jerrold",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158416": {
    "id": "item_11619",
    "Last Name": "Hazlewood",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158417": {
    "id": "item_9848",
    "Last Name": "Lorant",
    "First Name": "Orangel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158418": {
    "id": "item_37350",
    "Last Name": "Pace",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158434": {
    "id": "item_22797",
    "Last Name": "Dodds",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158436": {
    "id": "item_35795",
    "Last Name": "Middleton",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158464": {
    "id": "item_11617",
    "Last Name": "Pulvirenti",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158476": {
    "id": "item_11618",
    "Last Name": "Brophy",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158498": {
    "id": "item_37340",
    "Last Name": "Harding",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158515": {
    "id": "item_11613",
    "Last Name": "Crosby",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158538": {
    "id": "item_11611",
    "Last Name": "Khatis",
    "First Name": "Emilio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158539": {
    "id": "item_37318",
    "Last Name": "Punwatthanasing",
    "First Name": "Thak",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158550": {
    "id": "item_37334",
    "Last Name": "Wedd",
    "First Name": "Kellie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158552": {
    "id": "item_22793",
    "Last Name": "Salisbury",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158564": {
    "id": "item_11609",
    "Last Name": "Hynam",
    "First Name": "Brodie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158584": {
    "id": "item_37336",
    "Last Name": "Smith",
    "First Name": "Maike",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158586": {
    "id": "item_37332",
    "Last Name": "McGill",
    "First Name": "Eamonn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158591": {
    "id": "item_22791",
    "Last Name": "Anderson",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158600": {
    "id": "item_22790",
    "Last Name": "Ensink",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158606": {
    "id": "item_34913",
    "Last Name": "Gleeson",
    "First Name": "Juliana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158638": {
    "id": "item_37326",
    "Last Name": "Leon gomez",
    "First Name": "Paola andrea",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158676": {
    "id": "item_37317",
    "Last Name": "Conway",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158702": {
    "id": "item_22783",
    "Last Name": "Collera",
    "First Name": "Mikel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158705": {
    "id": "item_22780",
    "Last Name": "Khan",
    "First Name": "Munad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158714": {
    "id": "item_11605",
    "Last Name": "Massey",
    "First Name": "Mariah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158720": {
    "id": "item_34909",
    "Last Name": "Scott",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158734": {
    "id": "item_22774",
    "Last Name": "Laird",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158736": {
    "id": "item_37299",
    "Last Name": "Linton",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158740": {
    "id": "item_37313",
    "Last Name": "Tsai",
    "First Name": "Ching Yi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158749": {
    "id": "item_37308",
    "Last Name": "Mills",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158762": {
    "id": "item_24266",
    "Last Name": "Bara",
    "First Name": "Mauricio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158772": {
    "id": "item_22777",
    "Last Name": "Human",
    "First Name": "Karien",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158787": {
    "id": "item_22771",
    "Last Name": "Watts",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158805": {
    "id": "item_37309",
    "Last Name": "Wu-Quach",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158825": {
    "id": "item_22760",
    "Last Name": "Cole",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158838": {
    "id": "item_24263",
    "Last Name": "Chu",
    "First Name": "Amber",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158848": {
    "id": "item_37304",
    "Last Name": "Brown",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158857": {
    "id": "item_9835",
    "Last Name": "Cain",
    "First Name": "Francis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158917": {
    "id": "item_24243",
    "Last Name": "CANIZALES",
    "First Name": "Rogelio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158930": {
    "id": "item_37290",
    "Last Name": "Bhandari",
    "First Name": "Ritesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158932": {
    "id": "item_34902",
    "Last Name": "Murfin",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158951": {
    "id": "item_37296",
    "Last Name": "Li",
    "First Name": "Shiyao",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158965": {
    "id": "item_37286",
    "Last Name": "Rose",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158971": {
    "id": "item_22739",
    "Last Name": "Walkom",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37158984": {
    "id": "item_37291",
    "Last Name": "Thagunna",
    "First Name": "Aashish",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159002": {
    "id": "item_24257",
    "Last Name": "Roberts",
    "First Name": "Miyuki",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159007": {
    "id": "item_22764",
    "Last Name": "Gee",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159018": {
    "id": "item_11598",
    "Last Name": "Van Schaik",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159031": {
    "id": "item_24248",
    "Last Name": "Sasim",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159037": {
    "id": "item_37285",
    "Last Name": "Fu",
    "First Name": "Hao",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159066": {
    "id": "item_22759",
    "Last Name": "Marsh",
    "First Name": "Mel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159072": {
    "id": "item_22755",
    "Last Name": "Hayes",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159091": {
    "id": "item_37282",
    "Last Name": "Luu",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159095": {
    "id": "item_22754",
    "Last Name": "REYES TRUJILLO",
    "First Name": "FREDY DANIEL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159105": {
    "id": "item_34893",
    "Last Name": "Srour",
    "First Name": "Bass",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159109": {
    "id": "item_37284",
    "Last Name": "Hamilton",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159114": {
    "id": "item_37287",
    "Last Name": "felkai",
    "First Name": "csaba",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159117": {
    "id": "item_22757",
    "Last Name": "Ogden",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159120": {
    "id": "item_37278",
    "Last Name": "Juanto",
    "First Name": "Nico",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159130": {
    "id": "item_11591",
    "Last Name": "Gonzalez",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159133": {
    "id": "item_22750",
    "Last Name": "Mason",
    "First Name": "Bridget",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159183": {
    "id": "item_22749",
    "Last Name": "Worme",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159184": {
    "id": "item_34892",
    "Last Name": "Taylor",
    "First Name": "Tammy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159216": {
    "id": "item_37276",
    "Last Name": "KEYS",
    "First Name": "MELISSA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159220": {
    "id": "item_37270",
    "Last Name": "Marshall",
    "First Name": "Polly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159224": {
    "id": "item_37272",
    "Last Name": "McCarthy",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159251": {
    "id": "item_9825",
    "Last Name": "Sidebottom",
    "First Name": "Vaughan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159285": {
    "id": "item_34894",
    "Last Name": "Eungblut",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159309": {
    "id": "item_22734",
    "Last Name": "Di Losa",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159312": {
    "id": "item_37136",
    "Last Name": "Tiwari",
    "First Name": "Shaivy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159319": {
    "id": "item_24246",
    "Last Name": "Prunonosa",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159336": {
    "id": "item_24251",
    "Last Name": "Ly",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159342": {
    "id": "item_24252",
    "Last Name": "Hunter",
    "First Name": "Tahlia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159369": {
    "id": "item_24250",
    "Last Name": "Laurel",
    "First Name": "Nathaniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159378": {
    "id": "item_11586",
    "Last Name": "Miyazawa",
    "First Name": "Kosaku",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159417": {
    "id": "item_22730",
    "Last Name": "Jelfs",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159437": {
    "id": "item_37261",
    "Last Name": "Ng",
    "First Name": "Tze Way",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159456": {
    "id": "item_24245",
    "Last Name": "Skirrow",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159501": {
    "id": "item_9796",
    "Last Name": "Prunty",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159509": {
    "id": "item_24241",
    "Last Name": "Campbell",
    "First Name": "Harriet",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159540": {
    "id": "item_22718",
    "Last Name": "Kitschke",
    "First Name": "Tori",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159553": {
    "id": "item_9801",
    "Last Name": "Rached Jorge",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159572": {
    "id": "item_22722",
    "Last Name": "Heathcote",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159589": {
    "id": "item_12375",
    "Last Name": "Hsu",
    "First Name": "ChengChieh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159594": {
    "id": "item_34887",
    "Last Name": "Situ",
    "First Name": "Xingci",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159597": {
    "id": "item_37251",
    "Last Name": "Cluet",
    "First Name": "Elsa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159603": {
    "id": "item_11578",
    "Last Name": "Battulga",
    "First Name": "Idertulga",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159625": {
    "id": "item_37245",
    "Last Name": "Ramsey",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159639": {
    "id": "item_22680",
    "Last Name": "Tiwari",
    "First Name": "Sohil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159658": {
    "id": "item_11576",
    "Last Name": "Keane",
    "First Name": "Cillian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159669": {
    "id": "item_37242",
    "Last Name": "Reed",
    "First Name": "Allison",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159679": {
    "id": "item_9810",
    "Last Name": "Doak",
    "First Name": "Lachie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159694": {
    "id": "item_37234",
    "Last Name": "Ihsan",
    "First Name": "Febrian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159709": {
    "id": "item_22720",
    "Last Name": "Tan",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159716": {
    "id": "item_37188",
    "Last Name": "ELIZABETH",
    "First Name": "LAETITIA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159723": {
    "id": "item_11572",
    "Last Name": "Chang",
    "First Name": "Wei Sheng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159731": {
    "id": "item_35497",
    "Last Name": "Olden",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159738": {
    "id": "item_37237",
    "Last Name": "Dy",
    "First Name": "Jaimie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159745": {
    "id": "item_22717",
    "Last Name": "Frye",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159785": {
    "id": "item_11568",
    "Last Name": "Yin",
    "First Name": "Andy(Zhaoguo)",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159801": {
    "id": "item_22708",
    "Last Name": "Finn",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159839": {
    "id": "item_9803",
    "Last Name": "Castillo",
    "First Name": "Mario",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159844": {
    "id": "item_11549",
    "Last Name": "liu",
    "First Name": "jinglong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159882": {
    "id": "item_24225",
    "Last Name": "Dobler",
    "First Name": "Allison",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159892": {
    "id": "item_37207",
    "Last Name": "Worth",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159923": {
    "id": "item_24915",
    "Last Name": "Stannard",
    "First Name": "Marleigh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159924": {
    "id": "item_24221",
    "Last Name": "Vanderzalm",
    "First Name": "Sidney",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159930": {
    "id": "item_24219",
    "Last Name": "Donegan",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159949": {
    "id": "item_24214",
    "Last Name": "Durant",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159986": {
    "id": "item_37206",
    "Last Name": "Tang",
    "First Name": "Allan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37159992": {
    "id": "item_37217",
    "Last Name": "Tai",
    "First Name": "On Ting",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160039": {
    "id": "item_24216",
    "Last Name": "SEPULVEDA",
    "First Name": "JORGE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160059": {
    "id": "item_9783",
    "Last Name": "Lade",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160077": {
    "id": "item_37202",
    "Last Name": "Lee",
    "First Name": "Chia wei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160081": {
    "id": "item_24218",
    "Last Name": "Slocombe",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160082": {
    "id": "item_37204",
    "Last Name": "Lane",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160098": {
    "id": "item_37198",
    "Last Name": "Cheng",
    "First Name": "Wai ping",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160105": {
    "id": "item_11565",
    "Last Name": "Smith",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160107": {
    "id": "item_37196",
    "Last Name": "Cooper-Watts",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160111": {
    "id": "item_37197",
    "Last Name": "Aoki",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160158": {
    "id": "item_34877",
    "Last Name": "Smith",
    "First Name": "Brett",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160166": {
    "id": "item_9790",
    "Last Name": "Newton",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160177": {
    "id": "item_35491",
    "Last Name": "XU",
    "First Name": "TONY",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160180": {
    "id": "item_24213",
    "Last Name": "Moghimi Kandelousi",
    "First Name": "Arshia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160209": {
    "id": "item_24212",
    "Last Name": "Howell",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160226": {
    "id": "item_24210",
    "Last Name": "King",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160237": {
    "id": "item_9785",
    "Last Name": "Lane",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160241": {
    "id": "item_37185",
    "Last Name": "Brazier",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160253": {
    "id": "item_34876",
    "Last Name": "Fuller",
    "First Name": "Shona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160258": {
    "id": "item_37183",
    "Last Name": "Dick",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160262": {
    "id": "item_11554",
    "Last Name": "Rogers",
    "First Name": "Ciall",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160275": {
    "id": "item_37178",
    "Last Name": "Ryan",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160278": {
    "id": "item_12108",
    "Last Name": "Kanuma",
    "First Name": "Haruki",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160288": {
    "id": "item_11553",
    "Last Name": "Wong",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160297": {
    "id": "item_11558",
    "Last Name": "Armstrong",
    "First Name": "Rohan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160330": {
    "id": "item_37182",
    "Last Name": "Wang",
    "First Name": "Selina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160343": {
    "id": "item_11547",
    "Last Name": "Catong",
    "First Name": "Bill",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160353": {
    "id": "item_12082",
    "Last Name": "SHEK",
    "First Name": "CHI WING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160354": {
    "id": "item_34875",
    "Last Name": "Moonlight",
    "First Name": "Pamela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160358": {
    "id": "item_11552",
    "Last Name": "Pham",
    "First Name": "Huan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160360": {
    "id": "item_23506",
    "Last Name": "Hedianto",
    "First Name": "HEDIANTO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160384": {
    "id": "item_24541",
    "Last Name": "Chan",
    "First Name": "Ming Hong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160393": {
    "id": "item_37175",
    "Last Name": "Briggs",
    "First Name": "Allison",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160405": {
    "id": "item_22691",
    "Last Name": "Stevens-Bullmore",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160415": {
    "id": "item_22693",
    "Last Name": "Van Unen",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160423": {
    "id": "item_22690",
    "Last Name": "Boyd",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160432": {
    "id": "item_24206",
    "Last Name": "Murza",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160442": {
    "id": "item_22688",
    "Last Name": "Cowie",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160452": {
    "id": "item_24203",
    "Last Name": "Lehmann",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160468": {
    "id": "item_9782",
    "Last Name": "Smith",
    "First Name": "Kurtis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160483": {
    "id": "item_37157",
    "Last Name": "Harbour",
    "First Name": "Danah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160489": {
    "id": "item_37161",
    "Last Name": "Kaju",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160495": {
    "id": "item_9781",
    "Last Name": "NI",
    "First Name": "YUSHENG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160504": {
    "id": "item_22684",
    "Last Name": "Lam",
    "First Name": "Walden Hoi Ming",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160517": {
    "id": "item_37151",
    "Last Name": "TANAYA",
    "First Name": "GILBERT CHRISTOPHER",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160538": {
    "id": "item_22687",
    "Last Name": "Kennedy",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160549": {
    "id": "item_22683",
    "Last Name": "Whalley",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160574": {
    "id": "item_37153",
    "Last Name": "Gerrard",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160615": {
    "id": "item_24539",
    "Last Name": "Nardi",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160618": {
    "id": "item_12101",
    "Last Name": "Love",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160640": {
    "id": "item_24536",
    "Last Name": "von Sanden",
    "First Name": "Karl",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160647": {
    "id": "item_35503",
    "Last Name": "Phung",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160675": {
    "id": "item_35500",
    "Last Name": "Rutter",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160727": {
    "id": "item_12107",
    "Last Name": "Robertson",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160744": {
    "id": "item_24534",
    "Last Name": "Hemingway",
    "First Name": "Lennox",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160753": {
    "id": "item_35492",
    "Last Name": "Donaldson",
    "First Name": "Skylar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160811": {
    "id": "item_24533",
    "Last Name": "Tynan-Davey",
    "First Name": "Prudence",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160839": {
    "id": "item_10326",
    "Last Name": "Schulte",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160894": {
    "id": "item_24527",
    "Last Name": "Quinn",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160909": {
    "id": "item_35482",
    "Last Name": "Vernon",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160915": {
    "id": "item_12097",
    "Last Name": "Bennett",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160930": {
    "id": "item_24529",
    "Last Name": "White",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160945": {
    "id": "item_10322",
    "Last Name": "Siripaiboon",
    "First Name": "Nattapon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160984": {
    "id": "item_10320",
    "Last Name": "Wright",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37160995": {
    "id": "item_10323",
    "Last Name": "Quirk",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161057": {
    "id": "item_12094",
    "Last Name": "TSOI",
    "First Name": "TSZ CHUN JASON",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161069": {
    "id": "item_35477",
    "Last Name": "Corr",
    "First Name": "Estelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161071": {
    "id": "item_35476",
    "Last Name": "McGlone",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161100": {
    "id": "item_10319",
    "Last Name": "Dermoudy",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161126": {
    "id": "item_12090",
    "Last Name": "Parkes",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161264": {
    "id": "item_10313",
    "Last Name": "Li",
    "First Name": "Chenle",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161329": {
    "id": "item_10315",
    "Last Name": "Fritzlar",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161331": {
    "id": "item_12084",
    "Last Name": "Staples",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161337": {
    "id": "item_35470",
    "Last Name": "Hinc",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161378": {
    "id": "item_24506",
    "Last Name": "Neo",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161395": {
    "id": "item_10309",
    "Last Name": "Beard",
    "First Name": "Hunter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161433": {
    "id": "item_12081",
    "Last Name": "Fox",
    "First Name": "Kelsey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161513": {
    "id": "item_35464",
    "Last Name": "Crowe",
    "First Name": "Marisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161531": {
    "id": "item_24501",
    "Last Name": "Danckert",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161578": {
    "id": "item_10306",
    "Last Name": "Hennig",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161583": {
    "id": "item_24493",
    "Last Name": "Williamson",
    "First Name": "Braiden",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161707": {
    "id": "item_35794",
    "Last Name": "Holden",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161713": {
    "id": "item_12077",
    "Last Name": "Pilkington",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161742": {
    "id": "item_35456",
    "Last Name": "Korff",
    "First Name": "Dan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161771": {
    "id": "item_24491",
    "Last Name": "Zgoznik",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161785": {
    "id": "item_24490",
    "Last Name": "Cosgrave",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161859": {
    "id": "item_24488",
    "Last Name": "Shortis",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161886": {
    "id": "item_24489",
    "Last Name": "Lee",
    "First Name": "Chi Wa Eric",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161974": {
    "id": "item_12067",
    "Last Name": "Rolandus Hagedoorn",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161978": {
    "id": "item_23461",
    "Last Name": "Thomson",
    "First Name": "Nathanial",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37161986": {
    "id": "item_35449",
    "Last Name": "Cox",
    "First Name": "Lance",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162004": {
    "id": "item_12048",
    "Last Name": "Rafferty",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162011": {
    "id": "item_23458",
    "Last Name": "Garg",
    "First Name": "Vipul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162079": {
    "id": "item_23456",
    "Last Name": "Pennell",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162083": {
    "id": "item_24483",
    "Last Name": "O Leary",
    "First Name": "Meadhbh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162088": {
    "id": "item_12063",
    "Last Name": "Lynch",
    "First Name": "Ken",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162115": {
    "id": "item_35445",
    "Last Name": "Reetov",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162121": {
    "id": "item_35441",
    "Last Name": "Vaughan",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162152": {
    "id": "item_35435",
    "Last Name": "Jarurat",
    "First Name": "Boonyarit",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162200": {
    "id": "item_23449",
    "Last Name": "Kream",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162205": {
    "id": "item_23448",
    "Last Name": "Wong",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162239": {
    "id": "item_10291",
    "Last Name": "Li",
    "First Name": "Tsz Leung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162243": {
    "id": "item_12059",
    "Last Name": "Dedels",
    "First Name": "Stanislavs",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162253": {
    "id": "item_35745",
    "Last Name": "Soon",
    "First Name": "Keefe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162328": {
    "id": "item_12047",
    "Last Name": "Shaw",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162336": {
    "id": "item_23441",
    "Last Name": "Brewer",
    "First Name": "Lynton",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162425": {
    "id": "item_35428",
    "Last Name": "Andrews",
    "First Name": "Talia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162441": {
    "id": "item_12046",
    "Last Name": "Rabone",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162471": {
    "id": "item_12045",
    "Last Name": "Williams",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162529": {
    "id": "item_35431",
    "Last Name": "Oakeshott",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162532": {
    "id": "item_35432",
    "Last Name": "Buchholtz",
    "First Name": "Grant",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162535": {
    "id": "item_12043",
    "Last Name": "Painton",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162586": {
    "id": "item_23421",
    "Last Name": "Bowmar",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162597": {
    "id": "item_23428",
    "Last Name": "Burger",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162619": {
    "id": "item_23426",
    "Last Name": "Brereton",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162652": {
    "id": "item_23424",
    "Last Name": "Milambo",
    "First Name": "Tina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162681": {
    "id": "item_12039",
    "Last Name": "Broadbridge",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162748": {
    "id": "item_10273",
    "Last Name": "Nankervis",
    "First Name": "Brady",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162755": {
    "id": "item_23418",
    "Last Name": "Lee",
    "First Name": "Chieh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162767": {
    "id": "item_23414",
    "Last Name": "Hao",
    "First Name": "Site",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162784": {
    "id": "item_23388",
    "Last Name": "ZOU",
    "First Name": "Yijie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162832": {
    "id": "item_10268",
    "Last Name": "Alnatour",
    "First Name": "Abdelrahim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162841": {
    "id": "item_35420",
    "Last Name": "Scott",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162871": {
    "id": "item_23409",
    "Last Name": "Jamieson",
    "First Name": "Pip",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162884": {
    "id": "item_10267",
    "Last Name": "Bryce",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162902": {
    "id": "item_23412",
    "Last Name": "METRAUX",
    "First Name": "CELINE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162976": {
    "id": "item_23413",
    "Last Name": "Jackson",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37162989": {
    "id": "item_35415",
    "Last Name": "Vinning",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163038": {
    "id": "item_35416",
    "Last Name": "Utami",
    "First Name": "Eka ayu wira",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163056": {
    "id": "item_10258",
    "Last Name": "Aycinena",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163075": {
    "id": "item_12028",
    "Last Name": "Sutherland",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163117": {
    "id": "item_23397",
    "Last Name": "Bromley",
    "First Name": "Lou",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163130": {
    "id": "item_10257",
    "Last Name": "McEwen",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163136": {
    "id": "item_12021",
    "Last Name": "Jays",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163137": {
    "id": "item_10256",
    "Last Name": "Miller",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163151": {
    "id": "item_12022",
    "Last Name": "Young",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163179": {
    "id": "item_35410",
    "Last Name": "Campbell",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163210": {
    "id": "item_23378",
    "Last Name": "Querubin",
    "First Name": "Lorenz",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163257": {
    "id": "item_12018",
    "Last Name": "Silverwood",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163356": {
    "id": "item_10238",
    "Last Name": "KIM",
    "First Name": "WOOJUNG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163359": {
    "id": "item_12017",
    "Last Name": "Walsh",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163374": {
    "id": "item_23379",
    "Last Name": "Morris",
    "First Name": "Neil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163384": {
    "id": "item_35403",
    "Last Name": "Ariesta",
    "First Name": "Ratih",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163431": {
    "id": "item_35399",
    "Last Name": "Fung",
    "First Name": "Jade",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163473": {
    "id": "item_12015",
    "Last Name": "Earl",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163501": {
    "id": "item_10247",
    "Last Name": "Wood",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163589": {
    "id": "item_35395",
    "Last Name": "Badia",
    "First Name": "Clarisse",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163626": {
    "id": "item_23366",
    "Last Name": "LOZANO CASTELLANOS",
    "First Name": "NICOLAS",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163675": {
    "id": "item_23365",
    "Last Name": "Patten",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163703": {
    "id": "item_12008",
    "Last Name": "nicholson",
    "First Name": "jesse",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163705": {
    "id": "item_23368",
    "Last Name": "Adams",
    "First Name": "Rod",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163741": {
    "id": "item_23364",
    "Last Name": "Ogilvie",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163772": {
    "id": "item_35390",
    "Last Name": "Green",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163773": {
    "id": "item_10239",
    "Last Name": "Hechfe",
    "First Name": "Edgar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163789": {
    "id": "item_12003",
    "Last Name": "CATALANO",
    "First Name": "FRANCESCO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163804": {
    "id": "item_23361",
    "Last Name": "Dortmans",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163805": {
    "id": "item_23359",
    "Last Name": "Wang",
    "First Name": "Shu-Wei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163811": {
    "id": "item_35389",
    "Last Name": "Dadis",
    "First Name": "Ann",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163843": {
    "id": "item_12005",
    "Last Name": "Jones",
    "First Name": "Lincoln",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163851": {
    "id": "item_12374",
    "Last Name": "Gallardo",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163864": {
    "id": "item_12002",
    "Last Name": "Rowbotham",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163880": {
    "id": "item_11999",
    "Last Name": "Huang",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163897": {
    "id": "item_23354",
    "Last Name": "Pendo",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163901": {
    "id": "item_35386",
    "Last Name": "Mackemer",
    "First Name": "Marissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163907": {
    "id": "item_23356",
    "Last Name": "Yosiffidis",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163917": {
    "id": "item_11998",
    "Last Name": "Ashmore",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163929": {
    "id": "item_35384",
    "Last Name": "Erickson",
    "First Name": "Theresa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163977": {
    "id": "item_35379",
    "Last Name": "Tippayasoontorn",
    "First Name": "Songsak",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37163983": {
    "id": "item_35382",
    "Last Name": "Adams",
    "First Name": "Zanaida",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164020": {
    "id": "item_11995",
    "Last Name": "Leith",
    "First Name": "Neill",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164055": {
    "id": "item_35371",
    "Last Name": "Thampy",
    "First Name": "Nidhin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164066": {
    "id": "item_23351",
    "Last Name": "Weir",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164071": {
    "id": "item_23350",
    "Last Name": "Toa",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164164": {
    "id": "item_35370",
    "Last Name": "Jeffery",
    "First Name": "Keely",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164182": {
    "id": "item_35356",
    "Last Name": "Ng",
    "First Name": "Kin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164238": {
    "id": "item_11990",
    "Last Name": "sullivan",
    "First Name": "luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164250": {
    "id": "item_35359",
    "Last Name": "Rosales",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164274": {
    "id": "item_35361",
    "Last Name": "Worldon-Miller",
    "First Name": "Keet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164299": {
    "id": "item_35348",
    "Last Name": "Dias Leoni",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164300": {
    "id": "item_23342",
    "Last Name": "Fellows",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164327": {
    "id": "item_11988",
    "Last Name": "whitcombe",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164348": {
    "id": "item_10224",
    "Last Name": "Adler",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164356": {
    "id": "item_10226",
    "Last Name": "Grindrod",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164489": {
    "id": "item_11980",
    "Last Name": "Wang",
    "First Name": "Yi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164528": {
    "id": "item_38242",
    "Last Name": "CHEN",
    "First Name": "XI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164548": {
    "id": "item_10223",
    "Last Name": "Anchor",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164551": {
    "id": "item_10222",
    "Last Name": "Parkinson",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164576": {
    "id": "item_11983",
    "Last Name": "De Clifford",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164614": {
    "id": "item_11977",
    "Last Name": "Russell",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164676": {
    "id": "item_23334",
    "Last Name": "McCombe",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164693": {
    "id": "item_35346",
    "Last Name": "Su",
    "First Name": "Jing",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164744": {
    "id": "item_38253",
    "Last Name": "Jay",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164761": {
    "id": "item_35342",
    "Last Name": "MA",
    "First Name": "JONGHYUN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164766": {
    "id": "item_38222",
    "Last Name": "Odowd",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164782": {
    "id": "item_38254",
    "Last Name": "Whittaker",
    "First Name": "Trent",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164801": {
    "id": "item_35343",
    "Last Name": "Emmanuel",
    "First Name": "Jerome",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164815": {
    "id": "item_35344",
    "Last Name": "Davis",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164861": {
    "id": "item_38252",
    "Last Name": "Llewellyn",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164887": {
    "id": "item_35339",
    "Last Name": "Rangaswamy",
    "First Name": "Arun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37164888": {
    "id": "item_35337",
    "Last Name": "Horsburgh",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165030": {
    "id": "item_35335",
    "Last Name": "Chamberlain",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165050": {
    "id": "item_35330",
    "Last Name": "Chan",
    "First Name": "Sze Ching Margaret",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165084": {
    "id": "item_24832",
    "Last Name": "Alvarez Gomez",
    "First Name": "Daniel Leonardo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165086": {
    "id": "item_11968",
    "Last Name": "Ciavarella",
    "First Name": "carmine",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165146": {
    "id": "item_11967",
    "Last Name": "Whelan",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165149": {
    "id": "item_38240",
    "Last Name": "Morgan",
    "First Name": "Lance",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165156": {
    "id": "item_38244",
    "Last Name": "Chayadi",
    "First Name": "Abigail",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165188": {
    "id": "item_23321",
    "Last Name": "Mallinder",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165219": {
    "id": "item_11966",
    "Last Name": "Thomson",
    "First Name": "Fletcher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165277": {
    "id": "item_35327",
    "Last Name": "Miguel",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165293": {
    "id": "item_23322",
    "Last Name": "Jeong",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165359": {
    "id": "item_38230",
    "Last Name": "Uzunov",
    "First Name": "Yordan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165492": {
    "id": "item_10209",
    "Last Name": "Patch",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165499": {
    "id": "item_23309",
    "Last Name": "Dimitrakopoulos",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165500": {
    "id": "item_38231",
    "Last Name": "Barry",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165532": {
    "id": "item_38228",
    "Last Name": "Cain",
    "First Name": "Charles",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165559": {
    "id": "item_35320",
    "Last Name": "Woolf",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165584": {
    "id": "item_35319",
    "Last Name": "Birbeck",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165601": {
    "id": "item_11960",
    "Last Name": "Wicks",
    "First Name": "Rowan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165603": {
    "id": "item_38225",
    "Last Name": "Maron",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165625": {
    "id": "item_35321",
    "Last Name": "Thornley",
    "First Name": "Matty",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165636": {
    "id": "item_38224",
    "Last Name": "Parcero",
    "First Name": "Augusto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165649": {
    "id": "item_23315",
    "Last Name": "Putnam",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165658": {
    "id": "item_11955",
    "Last Name": "Carroll",
    "First Name": "Tyrone",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165703": {
    "id": "item_11953",
    "Last Name": "McPhillips",
    "First Name": "Rory",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165741": {
    "id": "item_35316",
    "Last Name": "Rutkowski",
    "First Name": "Jaroslaw",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165783": {
    "id": "item_10204",
    "Last Name": "Russell",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165798": {
    "id": "item_35315",
    "Last Name": "Hughes",
    "First Name": "Cillian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165801": {
    "id": "item_10205",
    "Last Name": "Pitchford",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165804": {
    "id": "item_38217",
    "Last Name": "Smith",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165808": {
    "id": "item_23312",
    "Last Name": "Sun",
    "First Name": "Yipeng",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165831": {
    "id": "item_38208",
    "Last Name": "Si",
    "First Name": "Cheng Chong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165843": {
    "id": "item_38213",
    "Last Name": "Hall",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165891": {
    "id": "item_23308",
    "Last Name": "Hart",
    "First Name": "Dominique",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165894": {
    "id": "item_38210",
    "Last Name": "Peplow",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165919": {
    "id": "item_23305",
    "Last Name": "Flegler",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165940": {
    "id": "item_35310",
    "Last Name": "Sida",
    "First Name": "Abigail",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165959": {
    "id": "item_11948",
    "Last Name": "Flanagan",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37165998": {
    "id": "item_38204",
    "Last Name": "Chen",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166001": {
    "id": "item_38203",
    "Last Name": "Hall",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166009": {
    "id": "item_38199",
    "Last Name": "Ly",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166024": {
    "id": "item_38202",
    "Last Name": "Canlas",
    "First Name": "Peter John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166039": {
    "id": "item_23301",
    "Last Name": "Moore",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166119": {
    "id": "item_24914",
    "Last Name": "Thorson Jr.",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166125": {
    "id": "item_38196",
    "Last Name": "Mortimer",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166146": {
    "id": "item_35291",
    "Last Name": "Princen",
    "First Name": "Bram",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166162": {
    "id": "item_35302",
    "Last Name": "Childs",
    "First Name": "Mary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166166": {
    "id": "item_35304",
    "Last Name": "Belic",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166214": {
    "id": "item_23296",
    "Last Name": "Knowles",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166239": {
    "id": "item_38191",
    "Last Name": "Park",
    "First Name": "Soojin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166311": {
    "id": "item_35295",
    "Last Name": "Ramdlani",
    "First Name": "Muhammad Ilham",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166317": {
    "id": "item_23295",
    "Last Name": "Moctezuma",
    "First Name": "Alfredo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166325": {
    "id": "item_38186",
    "Last Name": "Ricardel",
    "First Name": "Therese",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166333": {
    "id": "item_35299",
    "Last Name": "O'Brien",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166362": {
    "id": "item_11935",
    "Last Name": "Karagounis",
    "First Name": "Leonidas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166368": {
    "id": "item_11936",
    "Last Name": "Celic",
    "First Name": "Sinisa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166450": {
    "id": "item_38183",
    "Last Name": "Suganthan",
    "First Name": "Thalaiyasingam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166472": {
    "id": "item_38178",
    "Last Name": "Park",
    "First Name": "Huemin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166479": {
    "id": "item_10192",
    "Last Name": "Milden",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166495": {
    "id": "item_38181",
    "Last Name": "Choi",
    "First Name": "Kayoung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166516": {
    "id": "item_35293",
    "Last Name": "Sousa",
    "First Name": "Marco",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166532": {
    "id": "item_38174",
    "Last Name": "Donegan",
    "First Name": "Finn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166544": {
    "id": "item_23290",
    "Last Name": "CHEN",
    "First Name": "WEI CHEIN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166570": {
    "id": "item_38159",
    "Last Name": "Hsi",
    "First Name": "Yung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166578": {
    "id": "item_10565",
    "Last Name": "Ansara",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166585": {
    "id": "item_11929",
    "Last Name": "Overs",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166588": {
    "id": "item_11931",
    "Last Name": "Kyungchul",
    "First Name": "Lee",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166593": {
    "id": "item_23291",
    "Last Name": "Grammer",
    "First Name": "Anne Claire",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166613": {
    "id": "item_38167",
    "Last Name": "Fang",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166627": {
    "id": "item_35285",
    "Last Name": "NGUYEN",
    "First Name": "VAN DUNG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166657": {
    "id": "item_38096",
    "Last Name": "Ragg",
    "First Name": "Amber",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166689": {
    "id": "item_11928",
    "Last Name": "Brealey",
    "First Name": "Cooper",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166715": {
    "id": "item_23288",
    "Last Name": "Goode",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166720": {
    "id": "item_23286",
    "Last Name": "Cheong",
    "First Name": "Fook Seng Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166723": {
    "id": "item_38161",
    "Last Name": "Wald",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166743": {
    "id": "item_11927",
    "Last Name": "Gauchan",
    "First Name": "Ash",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166748": {
    "id": "item_38153",
    "Last Name": "Bajumi",
    "First Name": "Ibadallah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166769": {
    "id": "item_10186",
    "Last Name": "Lin",
    "First Name": "Yang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166781": {
    "id": "item_38157",
    "Last Name": "Tomas",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166791": {
    "id": "item_23283",
    "Last Name": "Pula",
    "First Name": "Sateesh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166810": {
    "id": "item_11926",
    "Last Name": "Schulz",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166819": {
    "id": "item_35286",
    "Last Name": "Kirchner",
    "First Name": "Molly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166828": {
    "id": "item_38149",
    "Last Name": "Matthews",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166849": {
    "id": "item_23281",
    "Last Name": "MATTHEWS",
    "First Name": "LUKE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166853": {
    "id": "item_10183",
    "Last Name": "Sostaric",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166854": {
    "id": "item_23275",
    "Last Name": "Squires",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166884": {
    "id": "item_35284",
    "Last Name": "Lawrence",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166891": {
    "id": "item_35282",
    "Last Name": "Smyth",
    "First Name": "Liam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166973": {
    "id": "item_10180",
    "Last Name": "Turner",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166990": {
    "id": "item_11918",
    "Last Name": "Ligero Garcia",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37166999": {
    "id": "item_35272",
    "Last Name": "Guo",
    "First Name": "Jinchi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167038": {
    "id": "item_38142",
    "Last Name": "Woods",
    "First Name": "Brent",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167064": {
    "id": "item_11916",
    "Last Name": "Tobin",
    "First Name": "Chad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167065": {
    "id": "item_38141",
    "Last Name": "Clough",
    "First Name": "Isabel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167069": {
    "id": "item_10177",
    "Last Name": "Down",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167089": {
    "id": "item_38137",
    "Last Name": "Mancia",
    "First Name": "Reginald",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167090": {
    "id": "item_38134",
    "Last Name": "chau",
    "First Name": "hoi yan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167127": {
    "id": "item_23267",
    "Last Name": "Wong",
    "First Name": "Ming Ho Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167167": {
    "id": "item_23265",
    "Last Name": "Wray",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167178": {
    "id": "item_38132",
    "Last Name": "Maruta",
    "First Name": "Mio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167207": {
    "id": "item_38130",
    "Last Name": "Russell",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167223": {
    "id": "item_24913",
    "Last Name": "Dashdulam",
    "First Name": "Altantuya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167226": {
    "id": "item_38119",
    "Last Name": "Gyn Cheng",
    "First Name": "Tai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167232": {
    "id": "item_38126",
    "Last Name": "Solis Ruiz",
    "First Name": "Lorena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167238": {
    "id": "item_23263",
    "Last Name": "NGU",
    "First Name": "JOHNSON",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167279": {
    "id": "item_38120",
    "Last Name": "Smith",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167348": {
    "id": "item_38114",
    "Last Name": "WU",
    "First Name": "CHI EN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167349": {
    "id": "item_11910",
    "Last Name": "McCann",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167364": {
    "id": "item_38112",
    "Last Name": "Ying",
    "First Name": "Jie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167392": {
    "id": "item_23255",
    "Last Name": "Kunnalok",
    "First Name": "Chittrawat",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167402": {
    "id": "item_38105",
    "Last Name": "O'Connor",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167410": {
    "id": "item_24912",
    "Last Name": "Olson",
    "First Name": "Mira",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167413": {
    "id": "item_23258",
    "Last Name": "chang",
    "First Name": "roger",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167416": {
    "id": "item_38108",
    "Last Name": "Huang",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167440": {
    "id": "item_38102",
    "Last Name": "Van Der Peet",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167444": {
    "id": "item_24463",
    "Last Name": "Duffy",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167449": {
    "id": "item_11908",
    "Last Name": "Cadden",
    "First Name": "Austin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167472": {
    "id": "item_35250",
    "Last Name": "Mullen",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167478": {
    "id": "item_23252",
    "Last Name": "Messenger",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167506": {
    "id": "item_35261",
    "Last Name": "Takacs",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167519": {
    "id": "item_23250",
    "Last Name": "Blackford",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167583": {
    "id": "item_38097",
    "Last Name": "Vergara",
    "First Name": "Kristine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167589": {
    "id": "item_35257",
    "Last Name": "SETIONO",
    "First Name": "IVAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167611": {
    "id": "item_23244",
    "Last Name": "Avent",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167672": {
    "id": "item_38090",
    "Last Name": "Wang",
    "First Name": "Su Fen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167799": {
    "id": "item_35251",
    "Last Name": "Cooper",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167801": {
    "id": "item_10164",
    "Last Name": "Trala",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167892": {
    "id": "item_35231",
    "Last Name": "Cheng",
    "First Name": "Yik Hoong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167914": {
    "id": "item_11898",
    "Last Name": "Feng",
    "First Name": "xiaoyu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167922": {
    "id": "item_38074",
    "Last Name": "Hillier",
    "First Name": "Stefanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167938": {
    "id": "item_11902",
    "Last Name": "Lee",
    "First Name": "Yeung chi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167973": {
    "id": "item_10159",
    "Last Name": "Beaton",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37167976": {
    "id": "item_38075",
    "Last Name": "Burgos",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168002": {
    "id": "item_23231",
    "Last Name": "Campbell",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168013": {
    "id": "item_11903",
    "Last Name": "Richardson",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168021": {
    "id": "item_11900",
    "Last Name": "Poulton",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168028": {
    "id": "item_35239",
    "Last Name": "Reynolds",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168076": {
    "id": "item_38077",
    "Last Name": "Rogers",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168086": {
    "id": "item_11899",
    "Last Name": "Nakkan",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168113": {
    "id": "item_35236",
    "Last Name": "Chan",
    "First Name": "Anastasia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168123": {
    "id": "item_10148",
    "Last Name": "Leach",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168128": {
    "id": "item_38069",
    "Last Name": "MORRISON",
    "First Name": "REBECCA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168132": {
    "id": "item_35233",
    "Last Name": "Finkelstein",
    "First Name": "Clive",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168180": {
    "id": "item_38065",
    "Last Name": "Edwards",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168253": {
    "id": "item_38060",
    "Last Name": "Calimpon",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168258": {
    "id": "item_24911",
    "Last Name": "Antolini",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168272": {
    "id": "item_23214",
    "Last Name": "Ornelas",
    "First Name": "Brenda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168280": {
    "id": "item_23220",
    "Last Name": "Brown",
    "First Name": "Jeri",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168284": {
    "id": "item_23213",
    "Last Name": "Singh",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168300": {
    "id": "item_23216",
    "Last Name": "Tan",
    "First Name": "Chew Choon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168301": {
    "id": "item_23218",
    "Last Name": "Long",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168317": {
    "id": "item_38059",
    "Last Name": "Widiandhana",
    "First Name": "Deri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168337": {
    "id": "item_35229",
    "Last Name": "Choice",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168347": {
    "id": "item_23212",
    "Last Name": "Haskard",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168350": {
    "id": "item_38057",
    "Last Name": "Roche",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168379": {
    "id": "item_24458",
    "Last Name": "Chan",
    "First Name": "Pik Yu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168383": {
    "id": "item_38049",
    "Last Name": "Priest",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168410": {
    "id": "item_35228",
    "Last Name": "Stratford",
    "First Name": "Cherie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168425": {
    "id": "item_11893",
    "Last Name": "Hopkins",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168470": {
    "id": "item_11884",
    "Last Name": "Fang",
    "First Name": "Hongsheng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168487": {
    "id": "item_11891",
    "Last Name": "Sovitslis",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168502": {
    "id": "item_38043",
    "Last Name": "Stott",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168557": {
    "id": "item_10134",
    "Last Name": "Davey",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168603": {
    "id": "item_38039",
    "Last Name": "YATES",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168609": {
    "id": "item_35220",
    "Last Name": "sinclair",
    "First Name": "Tiana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168647": {
    "id": "item_23201",
    "Last Name": "Seitz",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168659": {
    "id": "item_38033",
    "Last Name": "Syarif A",
    "First Name": "Abdurahman",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168668": {
    "id": "item_35218",
    "Last Name": "Del Moral",
    "First Name": "Erika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168672": {
    "id": "item_23202",
    "Last Name": "Ma",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168715": {
    "id": "item_11887",
    "Last Name": "kosim",
    "First Name": "chaidir akbar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168765": {
    "id": "item_11872",
    "Last Name": "yang",
    "First Name": "haobing",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168772": {
    "id": "item_23197",
    "Last Name": "Ji",
    "First Name": "Ruili",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168806": {
    "id": "item_10135",
    "Last Name": "Strus",
    "First Name": "Tomasz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168821": {
    "id": "item_23196",
    "Last Name": "Cordero",
    "First Name": "Linda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168822": {
    "id": "item_38026",
    "Last Name": "Wright",
    "First Name": "Michaela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168825": {
    "id": "item_35216",
    "Last Name": "Gleeson",
    "First Name": "Siobhan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168852": {
    "id": "item_10130",
    "Last Name": "WANG",
    "First Name": "JINJIA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168859": {
    "id": "item_35213",
    "Last Name": "Evans",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168863": {
    "id": "item_38018",
    "Last Name": "Hood",
    "First Name": "Will",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168912": {
    "id": "item_23189",
    "Last Name": "Chan",
    "First Name": "Gianluca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168937": {
    "id": "item_23186",
    "Last Name": "Marshall",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37168992": {
    "id": "item_10121",
    "Last Name": "Johansson",
    "First Name": "Lukas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169012": {
    "id": "item_38007",
    "Last Name": "Chua",
    "First Name": "Phey Yee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169044": {
    "id": "item_11879",
    "Last Name": "Hammonds",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169080": {
    "id": "item_11878",
    "Last Name": "Sung",
    "First Name": "MingEn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169092": {
    "id": "item_35203",
    "Last Name": "Telford",
    "First Name": "Jess",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169132": {
    "id": "item_35202",
    "Last Name": "McAleer",
    "First Name": "Juliette",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169485": {
    "id": "item_38002",
    "Last Name": "Pratiwi",
    "First Name": "Yohanes Isa Ananto Tri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169859": {
    "id": "item_10129",
    "Last Name": "Clowes",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37169965": {
    "id": "item_35193",
    "Last Name": "Wong",
    "First Name": "Karem Wing Chi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170422": {
    "id": "item_37998",
    "Last Name": "Donohoe",
    "First Name": "Bernadette",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170437": {
    "id": "item_12373",
    "Last Name": "OISTAD",
    "First Name": "CHAD",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170649": {
    "id": "item_23178",
    "Last Name": "Johnson",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37170877": {
    "id": "item_11874",
    "Last Name": "Herklots",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37171222": {
    "id": "item_37995",
    "Last Name": "Vong",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37171268": {
    "id": "item_37987",
    "Last Name": "Evans",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37171454": {
    "id": "item_37991",
    "Last Name": "Elcheikh",
    "First Name": "Sanaa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37171686": {
    "id": "item_23176",
    "Last Name": "Daly",
    "First Name": "Trent",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37171850": {
    "id": "item_37990",
    "Last Name": "Nguyen",
    "First Name": "Thanh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172110": {
    "id": "item_23175",
    "Last Name": "Parisi",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172245": {
    "id": "item_35197",
    "Last Name": "Nienaber",
    "First Name": "Shayne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172443": {
    "id": "item_23174",
    "Last Name": "Devitt",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172454": {
    "id": "item_11873",
    "Last Name": "Drury",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172483": {
    "id": "item_23172",
    "Last Name": "Poon",
    "First Name": "Brayden",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172485": {
    "id": "item_35744",
    "Last Name": "Garcia",
    "First Name": "John Romer",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172491": {
    "id": "item_10564",
    "Last Name": "Burt",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172497": {
    "id": "item_37984",
    "Last Name": "Betton",
    "First Name": "Pierre",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172501": {
    "id": "item_37985",
    "Last Name": "Breekveldt",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172522": {
    "id": "item_35195",
    "Last Name": "Huang",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172529": {
    "id": "item_23169",
    "Last Name": "Licona",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172541": {
    "id": "item_23170",
    "Last Name": "Angsanant",
    "First Name": "Pakorn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172550": {
    "id": "item_11866",
    "Last Name": "Botov",
    "First Name": "Evgenii",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172558": {
    "id": "item_35190",
    "Last Name": "Gabayoyo",
    "First Name": "Giro",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172569": {
    "id": "item_23171",
    "Last Name": "Olds",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172580": {
    "id": "item_23159",
    "Last Name": "FUNG",
    "First Name": "WAI HO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172587": {
    "id": "item_23167",
    "Last Name": "Chan",
    "First Name": "Jameson",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172623": {
    "id": "item_37976",
    "Last Name": "Lee",
    "First Name": "Donghwan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172646": {
    "id": "item_37973",
    "Last Name": "Roe",
    "First Name": "Kelsey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172651": {
    "id": "item_35186",
    "Last Name": "Barrulanda",
    "First Name": "Veda Almira",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172653": {
    "id": "item_37970",
    "Last Name": "STEVENSON",
    "First Name": "RICHARD",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172665": {
    "id": "item_35183",
    "Last Name": "youn",
    "First Name": "junghwan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172674": {
    "id": "item_37971",
    "Last Name": "Patel",
    "First Name": "Baiju",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172686": {
    "id": "item_9773",
    "Last Name": "Lui",
    "First Name": "Wai Keung Dennis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172692": {
    "id": "item_24454",
    "Last Name": "Lee",
    "First Name": "Shangjung",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172710": {
    "id": "item_37967",
    "Last Name": "Coady",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172712": {
    "id": "item_37954",
    "Last Name": "Artomo",
    "First Name": "Rindi Irsan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172737": {
    "id": "item_10117",
    "Last Name": "Greig",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172767": {
    "id": "item_37966",
    "Last Name": "Shimek",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172812": {
    "id": "item_35180",
    "Last Name": "Rogacion",
    "First Name": "Jose Antonio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172816": {
    "id": "item_10116",
    "Last Name": "Norman",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172828": {
    "id": "item_37955",
    "Last Name": "Soediro",
    "First Name": "Herfiyani",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172835": {
    "id": "item_10113",
    "Last Name": "Beare",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172842": {
    "id": "item_12372",
    "Last Name": "Allott",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172886": {
    "id": "item_37960",
    "Last Name": "Harries",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172930": {
    "id": "item_11854",
    "Last Name": "LEACH",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172932": {
    "id": "item_23156",
    "Last Name": "Wong",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172934": {
    "id": "item_37958",
    "Last Name": "Thompson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172966": {
    "id": "item_37952",
    "Last Name": "LIN",
    "First Name": "FENG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37172996": {
    "id": "item_35176",
    "Last Name": "Robertson",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173036": {
    "id": "item_10107",
    "Last Name": "Lane",
    "First Name": "Damian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173067": {
    "id": "item_11853",
    "Last Name": "BOUZOUBAA",
    "First Name": "Mohamed",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173113": {
    "id": "item_23150",
    "Last Name": "Pilapil",
    "First Name": "Reggie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173115": {
    "id": "item_35173",
    "Last Name": "Tan",
    "First Name": "Hui Lyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173116": {
    "id": "item_37937",
    "Last Name": "Oberinger",
    "First Name": "Manuela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173173": {
    "id": "item_10101",
    "Last Name": "Brittain",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173178": {
    "id": "item_10103",
    "Last Name": "OH",
    "First Name": "HyunJun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173183": {
    "id": "item_11851",
    "Last Name": "Ha",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173184": {
    "id": "item_37935",
    "Last Name": "Masala",
    "First Name": "Maria Francesca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173276": {
    "id": "item_11850",
    "Last Name": "Dermentzoglou",
    "First Name": "Helena",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173332": {
    "id": "item_37938",
    "Last Name": "Chin Kato",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173336": {
    "id": "item_11849",
    "Last Name": "Chow",
    "First Name": "Kin Lap",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173373": {
    "id": "item_35169",
    "Last Name": "Robertson",
    "First Name": "Eireann",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173607": {
    "id": "item_10098",
    "Last Name": "Potter",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37173730": {
    "id": "item_11848",
    "Last Name": "THABETHE",
    "First Name": "Freedom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37174384": {
    "id": "item_37934",
    "Last Name": "de Laine",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37174426": {
    "id": "item_23146",
    "Last Name": "DARMO",
    "First Name": "RIANTO ADHA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37174757": {
    "id": "item_24451",
    "Last Name": "Burnham",
    "First Name": "Wade",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37175619": {
    "id": "item_35163",
    "Last Name": "Aleman",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176143": {
    "id": "item_10092",
    "Last Name": "Uren",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176169": {
    "id": "item_35160",
    "Last Name": "Trotter",
    "First Name": "Nevan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176170": {
    "id": "item_35158",
    "Last Name": "SANTOS",
    "First Name": "KATRINA EICA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176211": {
    "id": "item_37926",
    "Last Name": "Cade",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176567": {
    "id": "item_23140",
    "Last Name": "Edwards",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37176908": {
    "id": "item_35153",
    "Last Name": "Darshani",
    "First Name": "shika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37177996": {
    "id": "item_37917",
    "Last Name": "Amdani",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178209": {
    "id": "item_37915",
    "Last Name": "Kwan",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178224": {
    "id": "item_35151",
    "Last Name": "Stanton-Sellers",
    "First Name": "Teresa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178449": {
    "id": "item_23135",
    "Last Name": "McDermott",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178557": {
    "id": "item_37910",
    "Last Name": "Matuto",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178627": {
    "id": "item_10087",
    "Last Name": "Mussin",
    "First Name": "Yerzhan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178671": {
    "id": "item_37908",
    "Last Name": "Christianto",
    "First Name": "Wibie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178750": {
    "id": "item_23131",
    "Last Name": "Sheridan",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178794": {
    "id": "item_37906",
    "Last Name": "Song",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178887": {
    "id": "item_10563",
    "Last Name": "XIANPENG",
    "First Name": "HU",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37178889": {
    "id": "item_23127",
    "Last Name": "YEO",
    "First Name": "CHIAT WEI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179151": {
    "id": "item_11833",
    "Last Name": "Finney",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179295": {
    "id": "item_37902",
    "Last Name": "Mitchell",
    "First Name": "Maxine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179298": {
    "id": "item_23126",
    "Last Name": "Hodalova",
    "First Name": "Sofia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179537": {
    "id": "item_23125",
    "Last Name": "Moore",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179550": {
    "id": "item_35139",
    "Last Name": "Phan",
    "First Name": "Linh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37179943": {
    "id": "item_10082",
    "Last Name": "Vermeulen",
    "First Name": "Pieter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180025": {
    "id": "item_37888",
    "Last Name": "Nieves",
    "First Name": "Nathalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180304": {
    "id": "item_23122",
    "Last Name": "Koo",
    "First Name": "Youngmo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37180657": {
    "id": "item_37886",
    "Last Name": "Prica",
    "First Name": "Mirjana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181591": {
    "id": "item_37884",
    "Last Name": "feblu",
    "First Name": "denny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181594": {
    "id": "item_11829",
    "Last Name": "Perillo",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181597": {
    "id": "item_37893",
    "Last Name": "WONG",
    "First Name": "SIU WAI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181630": {
    "id": "item_12327",
    "Last Name": "MENDEZ",
    "First Name": "John ALLEN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181651": {
    "id": "item_37883",
    "Last Name": "Cabrera",
    "First Name": "Vilma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181654": {
    "id": "item_35131",
    "Last Name": "Cameron",
    "First Name": "Jan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181678": {
    "id": "item_37892",
    "Last Name": "Antoine",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181689": {
    "id": "item_23118",
    "Last Name": "Horan",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181692": {
    "id": "item_10076",
    "Last Name": "Silsby",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181757": {
    "id": "item_10075",
    "Last Name": "Scott",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181779": {
    "id": "item_23113",
    "Last Name": "Hwang",
    "First Name": "Chunyeh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181822": {
    "id": "item_23109",
    "Last Name": "TEW",
    "First Name": "KHOON YAW",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37181829": {
    "id": "item_10073",
    "Last Name": "Redpath",
    "First Name": "Drew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37182171": {
    "id": "item_11819",
    "Last Name": "Lau",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37182185": {
    "id": "item_23103",
    "Last Name": "Rainbow",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37182510": {
    "id": "item_23106",
    "Last Name": "Andiko",
    "First Name": "Nico",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37182700": {
    "id": "item_35126",
    "Last Name": "Cheah",
    "First Name": "Tricia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37182715": {
    "id": "item_11821",
    "Last Name": "Dang",
    "First Name": "Fanchao",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37183094": {
    "id": "item_37874",
    "Last Name": "Gilbert",
    "First Name": "McKenzie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184348": {
    "id": "item_10069",
    "Last Name": "Bracken",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184641": {
    "id": "item_35120",
    "Last Name": "Benson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184708": {
    "id": "item_11817",
    "Last Name": "Corbett",
    "First Name": "Escher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184715": {
    "id": "item_11818",
    "Last Name": "Taylor",
    "First Name": "Kye",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184721": {
    "id": "item_23100",
    "Last Name": "Jansse",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184749": {
    "id": "item_11815",
    "Last Name": "Smith",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184757": {
    "id": "item_35114",
    "Last Name": "Pan",
    "First Name": "Ling",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184806": {
    "id": "item_37859",
    "Last Name": "Arguido",
    "First Name": "Gerald",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184813": {
    "id": "item_35112",
    "Last Name": "McPherson",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184826": {
    "id": "item_37857",
    "Last Name": "Rose",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184836": {
    "id": "item_37858",
    "Last Name": "Liu",
    "First Name": "Joe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184848": {
    "id": "item_10064",
    "Last Name": "Ceballos",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184855": {
    "id": "item_35110",
    "Last Name": "Lakshmana perumal",
    "First Name": "Mahesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184857": {
    "id": "item_35111",
    "Last Name": "Martin",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37184927": {
    "id": "item_10066",
    "Last Name": "Sippl",
    "First Name": "Andreas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37185074": {
    "id": "item_37852",
    "Last Name": "Yong",
    "First Name": "Winston",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186154": {
    "id": "item_35107",
    "Last Name": "Clark",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186710": {
    "id": "item_37846",
    "Last Name": "CHANAPAN",
    "First Name": "TEERAPAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186724": {
    "id": "item_35106",
    "Last Name": "Frediani",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186727": {
    "id": "item_37841",
    "Last Name": "Sichone",
    "First Name": "Sali",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37186767": {
    "id": "item_24910",
    "Last Name": "Cheung",
    "First Name": "Shuk Man Mona",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187027": {
    "id": "item_23091",
    "Last Name": "Bowler",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187480": {
    "id": "item_10063",
    "Last Name": "Blore",
    "First Name": "Dwayne",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187494": {
    "id": "item_35104",
    "Last Name": "Wong Shu Juan",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187529": {
    "id": "item_10057",
    "Last Name": "Purnell",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187577": {
    "id": "item_35101",
    "Last Name": "Chalermrungroj",
    "First Name": "Nontakorn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187615": {
    "id": "item_10055",
    "Last Name": "Hurley",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187666": {
    "id": "item_23080",
    "Last Name": "HAN",
    "First Name": "CHAO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37187676": {
    "id": "item_37834",
    "Last Name": "LIU",
    "First Name": "Yang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37188251": {
    "id": "item_23082",
    "Last Name": "Mittapalli",
    "First Name": "Sai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37188381": {
    "id": "item_37835",
    "Last Name": "Ofiana",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37188704": {
    "id": "item_10051",
    "Last Name": "Ahearn",
    "First Name": "jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189426": {
    "id": "item_23048",
    "Last Name": "SHAO",
    "First Name": "JUNZHEN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189554": {
    "id": "item_37831",
    "Last Name": "BELL",
    "First Name": "JAMES",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189805": {
    "id": "item_23077",
    "Last Name": "McNamara",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189823": {
    "id": "item_23079",
    "Last Name": "Allport",
    "First Name": "Boden",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189917": {
    "id": "item_11538",
    "Last Name": "Moorfield",
    "First Name": "Monica",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189929": {
    "id": "item_10050",
    "Last Name": "Cameron",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37189932": {
    "id": "item_35096",
    "Last Name": "Doyle",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37190036": {
    "id": "item_11785",
    "Last Name": "Cross",
    "First Name": "Brinsley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37190555": {
    "id": "item_35094",
    "Last Name": "Cooke",
    "First Name": "Becky",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37191240": {
    "id": "item_23069",
    "Last Name": "King",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37191292": {
    "id": "item_11796",
    "Last Name": "De Berry",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37191391": {
    "id": "item_35091",
    "Last Name": "Clements",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37191831": {
    "id": "item_10043",
    "Last Name": "Roylance",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192236": {
    "id": "item_23063",
    "Last Name": "Murphy",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192258": {
    "id": "item_35084",
    "Last Name": "Phelan",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192265": {
    "id": "item_23060",
    "Last Name": "YEN",
    "First Name": "TIEN WEI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192302": {
    "id": "item_37818",
    "Last Name": "Mitchell",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192336": {
    "id": "item_23055",
    "Last Name": "Rashou",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192343": {
    "id": "item_37815",
    "Last Name": "Lehrer",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192357": {
    "id": "item_11793",
    "Last Name": "Ryan",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192360": {
    "id": "item_35075",
    "Last Name": "Han",
    "First Name": "Lei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192384": {
    "id": "item_23053",
    "Last Name": "Parkinson",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192412": {
    "id": "item_35077",
    "Last Name": "Galo",
    "First Name": "Marcos",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192420": {
    "id": "item_11790",
    "Last Name": "Saldanha",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192421": {
    "id": "item_11791",
    "Last Name": "Kron",
    "First Name": "Edmund",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192429": {
    "id": "item_35078",
    "Last Name": "Qu",
    "First Name": "Xue",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192440": {
    "id": "item_35079",
    "Last Name": "Sneddon",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192484": {
    "id": "item_37806",
    "Last Name": "Milner",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192507": {
    "id": "item_35076",
    "Last Name": "Tham",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192526": {
    "id": "item_37803",
    "Last Name": "Milla",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192534": {
    "id": "item_37800",
    "Last Name": "Trinh",
    "First Name": "Terry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192550": {
    "id": "item_11780",
    "Last Name": "Pun",
    "First Name": "Ho Wang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192563": {
    "id": "item_11787",
    "Last Name": "Wilkinson",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192564": {
    "id": "item_35074",
    "Last Name": "JU",
    "First Name": "SUMIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192649": {
    "id": "item_11783",
    "Last Name": "Hunter",
    "First Name": "Zac",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192657": {
    "id": "item_37796",
    "Last Name": "Ward",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192665": {
    "id": "item_10035",
    "Last Name": "Cheung",
    "First Name": "Chi Hang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192678": {
    "id": "item_23042",
    "Last Name": "Wadsworth",
    "First Name": "Connor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192797": {
    "id": "item_35062",
    "Last Name": "Yu",
    "First Name": "Wai Sun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192829": {
    "id": "item_24909",
    "Last Name": "Fung",
    "First Name": "Chi Kin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192872": {
    "id": "item_37788",
    "Last Name": "WU",
    "First Name": "HO CHUO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192909": {
    "id": "item_37784",
    "Last Name": "Albarracin",
    "First Name": "Yamir",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192931": {
    "id": "item_24439",
    "Last Name": "Oxley",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37192940": {
    "id": "item_35060",
    "Last Name": "Xiao",
    "First Name": "Guangyu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193008": {
    "id": "item_23033",
    "Last Name": "McLain",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193043": {
    "id": "item_10029",
    "Last Name": "Jagger",
    "First Name": "Jim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193067": {
    "id": "item_23032",
    "Last Name": "Wawrzyk",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193075": {
    "id": "item_10028",
    "Last Name": "Lockrey",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193122": {
    "id": "item_37777",
    "Last Name": "Elliott",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193138": {
    "id": "item_37772",
    "Last Name": "Tong",
    "First Name": "Tam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193144": {
    "id": "item_35055",
    "Last Name": "Stoddard",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193158": {
    "id": "item_10025",
    "Last Name": "Hobson",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193189": {
    "id": "item_37775",
    "Last Name": "Schofield",
    "First Name": "Tianna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193190": {
    "id": "item_37774",
    "Last Name": "Scott",
    "First Name": "Lana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193208": {
    "id": "item_23022",
    "Last Name": "Bong",
    "First Name": "Evelyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193261": {
    "id": "item_35048",
    "Last Name": "Kim",
    "First Name": "SunWook",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193266": {
    "id": "item_37770",
    "Last Name": "Connelly",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193297": {
    "id": "item_12371",
    "Last Name": "Lopez",
    "First Name": "Osborne",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193323": {
    "id": "item_10019",
    "Last Name": "George",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193331": {
    "id": "item_35046",
    "Last Name": "Mangeya",
    "First Name": "Pride",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193368": {
    "id": "item_35045",
    "Last Name": "Morales",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193374": {
    "id": "item_23015",
    "Last Name": "Dahal",
    "First Name": "Mahesh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193390": {
    "id": "item_23014",
    "Last Name": "Freitas",
    "First Name": "Catarina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193402": {
    "id": "item_35743",
    "Last Name": "Tangsunawan",
    "First Name": "Phirush",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193410": {
    "id": "item_37762",
    "Last Name": "Howat",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193430": {
    "id": "item_10020",
    "Last Name": "Boyle",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193449": {
    "id": "item_10018",
    "Last Name": "Young",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193450": {
    "id": "item_37755",
    "Last Name": "Gerlach",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193454": {
    "id": "item_37754",
    "Last Name": "Tang",
    "First Name": "Caleb",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193479": {
    "id": "item_11773",
    "Last Name": "Johnstone",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193488": {
    "id": "item_23013",
    "Last Name": "Bevan",
    "First Name": "Bevo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193489": {
    "id": "item_23012",
    "Last Name": "Holland",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193566": {
    "id": "item_23008",
    "Last Name": "KIMURA",
    "First Name": "YURIKO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193569": {
    "id": "item_23010",
    "Last Name": "McClusky",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193626": {
    "id": "item_24434",
    "Last Name": "SUMALINOG",
    "First Name": "JUNMAR",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193683": {
    "id": "item_11772",
    "Last Name": "Octaviano",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193785": {
    "id": "item_23007",
    "Last Name": "Boswell",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193822": {
    "id": "item_35027",
    "Last Name": "Kantharia",
    "First Name": "Priyank",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193850": {
    "id": "item_37732",
    "Last Name": "Edwards",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193943": {
    "id": "item_10008",
    "Last Name": "Duffy",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193955": {
    "id": "item_10562",
    "Last Name": "Tritsch",
    "First Name": "Matthias",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193958": {
    "id": "item_35024",
    "Last Name": "Baque",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193963": {
    "id": "item_37729",
    "Last Name": "McArdle",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37193998": {
    "id": "item_23005",
    "Last Name": "Ranger",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194293": {
    "id": "item_23004",
    "Last Name": "Rose",
    "First Name": "Mikayla",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194371": {
    "id": "item_35018",
    "Last Name": "Van Dongen",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194378": {
    "id": "item_35010",
    "Last Name": "Lobarbio",
    "First Name": "Bernadette",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194384": {
    "id": "item_23002",
    "Last Name": "Leahy",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194464": {
    "id": "item_35013",
    "Last Name": "Jackson",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194485": {
    "id": "item_11762",
    "Last Name": "Brooks",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194504": {
    "id": "item_35012",
    "Last Name": "Zhang",
    "First Name": "Xintan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194909": {
    "id": "item_11759",
    "Last Name": "Ball",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194918": {
    "id": "item_11756",
    "Last Name": "Sawyer",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194923": {
    "id": "item_22999",
    "Last Name": "Ho",
    "First Name": "Rayann",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194952": {
    "id": "item_24432",
    "Last Name": "Ellis",
    "First Name": "Diane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194956": {
    "id": "item_37694",
    "Last Name": "Oshlack",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37194958": {
    "id": "item_37705",
    "Last Name": "Chukwudi",
    "First Name": "Derby",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195001": {
    "id": "item_35009",
    "Last Name": "Lynch",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195029": {
    "id": "item_35008",
    "Last Name": "Janjua",
    "First Name": "Adrian Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195064": {
    "id": "item_35005",
    "Last Name": "Fisher",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195090": {
    "id": "item_37698",
    "Last Name": "Le",
    "First Name": "Suong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195439": {
    "id": "item_10001",
    "Last Name": "Halewood",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195461": {
    "id": "item_37690",
    "Last Name": "Taylor",
    "First Name": "Annika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195462": {
    "id": "item_37695",
    "Last Name": "Davies",
    "First Name": "Bryony",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195468": {
    "id": "item_24429",
    "Last Name": "Younes",
    "First Name": "Laith",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195542": {
    "id": "item_37686",
    "Last Name": "Grech",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195545": {
    "id": "item_37684",
    "Last Name": "LIU",
    "First Name": "HUI CHUN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195558": {
    "id": "item_35000",
    "Last Name": "Mowett",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195568": {
    "id": "item_37682",
    "Last Name": "Swain",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195571": {
    "id": "item_37675",
    "Last Name": "Kwok",
    "First Name": "Wai Lung Dragon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195587": {
    "id": "item_34999",
    "Last Name": "Blyton",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195616": {
    "id": "item_37676",
    "Last Name": "Guerin",
    "First Name": "Max",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195673": {
    "id": "item_9997",
    "Last Name": "Wolff",
    "First Name": "Riley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195691": {
    "id": "item_37668",
    "Last Name": "Hoey",
    "First Name": "Bernard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195696": {
    "id": "item_24420",
    "Last Name": "Duffy",
    "First Name": "Russell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195701": {
    "id": "item_11748",
    "Last Name": "Prendergast",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195712": {
    "id": "item_24417",
    "Last Name": "Matsuda",
    "First Name": "Vivian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195720": {
    "id": "item_22988",
    "Last Name": "Bernstein",
    "First Name": "Noa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195730": {
    "id": "item_22985",
    "Last Name": "Avila",
    "First Name": "PHANEXIS Analyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195737": {
    "id": "item_37665",
    "Last Name": "Pritchard",
    "First Name": "Joann",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195742": {
    "id": "item_22987",
    "Last Name": "Loucas",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195797": {
    "id": "item_22983",
    "Last Name": "Douch",
    "First Name": "Elliot",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195848": {
    "id": "item_37661",
    "Last Name": "Sison",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195868": {
    "id": "item_37658",
    "Last Name": "Gates",
    "First Name": "Jaimee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195870": {
    "id": "item_11746",
    "Last Name": "Sandry",
    "First Name": "Sandry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195896": {
    "id": "item_37655",
    "Last Name": "JU",
    "First Name": "Kwok Fai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195914": {
    "id": "item_24408",
    "Last Name": "Tugei",
    "First Name": "Gana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195933": {
    "id": "item_9986",
    "Last Name": "Peill",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195971": {
    "id": "item_11742",
    "Last Name": "Zawadski",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195972": {
    "id": "item_37649",
    "Last Name": "Wibowo",
    "First Name": "Agus Untung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195979": {
    "id": "item_11744",
    "Last Name": "Jones",
    "First Name": "Arthur",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37195982": {
    "id": "item_37653",
    "Last Name": "CHEN",
    "First Name": "ICHUNG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196054": {
    "id": "item_37646",
    "Last Name": "McKeith",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196064": {
    "id": "item_34986",
    "Last Name": "bruggemann",
    "First Name": "stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196073": {
    "id": "item_37638",
    "Last Name": "Kingsland",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196084": {
    "id": "item_35793",
    "Last Name": "Guley",
    "First Name": "Jed",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196085": {
    "id": "item_12370",
    "Last Name": "ELLIS",
    "First Name": "CHRISTIAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196087": {
    "id": "item_24402",
    "Last Name": "Vitelli",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196102": {
    "id": "item_37641",
    "Last Name": "Murugan",
    "First Name": "Rakesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196106": {
    "id": "item_24399",
    "Last Name": "Kanesarajah",
    "First Name": "Lagu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196142": {
    "id": "item_22971",
    "Last Name": "Mead",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196151": {
    "id": "item_34985",
    "Last Name": "Penney",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196183": {
    "id": "item_11735",
    "Last Name": "Scrivens",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196202": {
    "id": "item_11736",
    "Last Name": "XIAO",
    "First Name": "LIN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196213": {
    "id": "item_37628",
    "Last Name": "Bauer",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196214": {
    "id": "item_24400",
    "Last Name": "Paterson",
    "First Name": "Tahnee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196237": {
    "id": "item_22964",
    "Last Name": "Frommenwiler",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196286": {
    "id": "item_9983",
    "Last Name": "Bianco",
    "First Name": "Simone",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196305": {
    "id": "item_37625",
    "Last Name": "Noll",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196344": {
    "id": "item_22961",
    "Last Name": "Lee",
    "First Name": "Eujeane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196345": {
    "id": "item_11732",
    "Last Name": "Hong",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196358": {
    "id": "item_37614",
    "Last Name": "Molloy",
    "First Name": "Ian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196362": {
    "id": "item_22958",
    "Last Name": "PAN",
    "First Name": "WEI-HSUN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196369": {
    "id": "item_34981",
    "Last Name": "Singh",
    "First Name": "Virendra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196373": {
    "id": "item_37615",
    "Last Name": "Leong",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196374": {
    "id": "item_37618",
    "Last Name": "McArthur",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196397": {
    "id": "item_34982",
    "Last Name": "Hooi",
    "First Name": "Wai Foong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196441": {
    "id": "item_9979",
    "Last Name": "Charter",
    "First Name": "Hall",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196461": {
    "id": "item_9978",
    "Last Name": "Ma",
    "First Name": "Tian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196469": {
    "id": "item_24392",
    "Last Name": "Buda",
    "First Name": "Vivian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196505": {
    "id": "item_22954",
    "Last Name": "Lo",
    "First Name": "Man Ho",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196555": {
    "id": "item_9975",
    "Last Name": "Zafiris",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196575": {
    "id": "item_22955",
    "Last Name": "Chea",
    "First Name": "Sokhean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196622": {
    "id": "item_37600",
    "Last Name": "Kim",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196626": {
    "id": "item_37599",
    "Last Name": "Byrne",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196629": {
    "id": "item_22948",
    "Last Name": "WANG",
    "First Name": "Lingfei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196674": {
    "id": "item_37597",
    "Last Name": "Tan",
    "First Name": "Danny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196749": {
    "id": "item_22949",
    "Last Name": "Ritchie",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196780": {
    "id": "item_24386",
    "Last Name": "Smith",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196842": {
    "id": "item_37589",
    "Last Name": "Makrami",
    "First Name": "Raja Bariq Fakhri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196866": {
    "id": "item_11720",
    "Last Name": "Feng",
    "First Name": "Kun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196906": {
    "id": "item_37591",
    "Last Name": "Yunus",
    "First Name": "Anwar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196950": {
    "id": "item_22941",
    "Last Name": "Carr",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196965": {
    "id": "item_11724",
    "Last Name": "Knight",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196975": {
    "id": "item_34975",
    "Last Name": "French",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37196998": {
    "id": "item_22942",
    "Last Name": "Portbury",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197008": {
    "id": "item_11723",
    "Last Name": "Davies",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197052": {
    "id": "item_37585",
    "Last Name": "Cruz Dela",
    "First Name": "Juvanni",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197068": {
    "id": "item_24382",
    "Last Name": "Im",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197128": {
    "id": "item_22937",
    "Last Name": "Geraghty",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197206": {
    "id": "item_9964",
    "Last Name": "Creighton",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197209": {
    "id": "item_37579",
    "Last Name": "Lim",
    "First Name": "Teddy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197239": {
    "id": "item_24378",
    "Last Name": "Yoon",
    "First Name": "Young",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197247": {
    "id": "item_11715",
    "Last Name": "Pasaribu",
    "First Name": "Bonar Cornellius",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197272": {
    "id": "item_9962",
    "Last Name": "Eagling",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197283": {
    "id": "item_11713",
    "Last Name": "Quirke",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197306": {
    "id": "item_37574",
    "Last Name": "North",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197327": {
    "id": "item_9959",
    "Last Name": "Paine",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197355": {
    "id": "item_37569",
    "Last Name": "LAI",
    "First Name": "Shuk Han",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197396": {
    "id": "item_37568",
    "Last Name": "Mohd Yasin",
    "First Name": "Mohd Zailan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197408": {
    "id": "item_37566",
    "Last Name": "Sheppard",
    "First Name": "Diane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197418": {
    "id": "item_35792",
    "Last Name": "Soriano",
    "First Name": "Jake",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197427": {
    "id": "item_22929",
    "Last Name": "ARKLESS",
    "First Name": "BENJAMIN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197496": {
    "id": "item_34970",
    "Last Name": "Byers",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197500": {
    "id": "item_9951",
    "Last Name": "Renner",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197547": {
    "id": "item_24375",
    "Last Name": "Nicholas",
    "First Name": "Nicholas, ho chuen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197551": {
    "id": "item_24373",
    "Last Name": "Hood",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197565": {
    "id": "item_9944",
    "Last Name": "Lamerton",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197587": {
    "id": "item_37550",
    "Last Name": "Thomson",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197609": {
    "id": "item_9945",
    "Last Name": "Chun Tak",
    "First Name": "Chan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197638": {
    "id": "item_11705",
    "Last Name": "Gadsby",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197656": {
    "id": "item_24368",
    "Last Name": "McPhee",
    "First Name": "Alisdair",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197663": {
    "id": "item_37554",
    "Last Name": "GU",
    "First Name": "HUISONG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197690": {
    "id": "item_37557",
    "Last Name": "Hughes",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197733": {
    "id": "item_37552",
    "Last Name": "Westworth",
    "First Name": "Renee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197753": {
    "id": "item_24367",
    "Last Name": "Arias",
    "First Name": "Julio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197763": {
    "id": "item_37548",
    "Last Name": "Ashad",
    "First Name": "Azlan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197789": {
    "id": "item_37547",
    "Last Name": "Wilkins",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197843": {
    "id": "item_11698",
    "Last Name": "Petersen",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197853": {
    "id": "item_11699",
    "Last Name": "Jamieson",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197889": {
    "id": "item_34965",
    "Last Name": "Butler",
    "First Name": "Lennie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197898": {
    "id": "item_37541",
    "Last Name": "Chiong",
    "First Name": "Mary Jane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197943": {
    "id": "item_37526",
    "Last Name": "Harmon",
    "First Name": "Fenny Meiyanthi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197956": {
    "id": "item_34964",
    "Last Name": "CHEN",
    "First Name": "YUPING",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197976": {
    "id": "item_11695",
    "Last Name": "Lloyd",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37197998": {
    "id": "item_22919",
    "Last Name": "Martin",
    "First Name": "Travis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198002": {
    "id": "item_22918",
    "Last Name": "Smith",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198030": {
    "id": "item_22913",
    "Last Name": "Liaw",
    "First Name": "Voon Tatt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198031": {
    "id": "item_24360",
    "Last Name": "Goronfolah",
    "First Name": "Loie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198041": {
    "id": "item_24359",
    "Last Name": "Cullen",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198048": {
    "id": "item_37531",
    "Last Name": "Capper",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198070": {
    "id": "item_22914",
    "Last Name": "van 't Hof",
    "First Name": "Heleen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198154": {
    "id": "item_35791",
    "Last Name": "Chan",
    "First Name": "Kwok Ming Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198167": {
    "id": "item_37522",
    "Last Name": "Choo",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198175": {
    "id": "item_22912",
    "Last Name": "Alstowe",
    "First Name": "Niall",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198228": {
    "id": "item_11692",
    "Last Name": "Farrell",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198247": {
    "id": "item_24355",
    "Last Name": "Yeh",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198271": {
    "id": "item_22905",
    "Last Name": "Watkins",
    "First Name": "Dionne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198283": {
    "id": "item_34961",
    "Last Name": "XU",
    "First Name": "WENJIA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198285": {
    "id": "item_9935",
    "Last Name": "Copey",
    "First Name": "Jared",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198352": {
    "id": "item_37507",
    "Last Name": "Tognoni",
    "First Name": "Lorenzo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198353": {
    "id": "item_11690",
    "Last Name": "Duran",
    "First Name": "Aslan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198357": {
    "id": "item_24354",
    "Last Name": "delignieres",
    "First Name": "lionel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198362": {
    "id": "item_9932",
    "Last Name": "Tyack",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198375": {
    "id": "item_37512",
    "Last Name": "Trevena",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198386": {
    "id": "item_9929",
    "Last Name": "Hayes",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198400": {
    "id": "item_22903",
    "Last Name": "van der Merwe",
    "First Name": "Rachelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198432": {
    "id": "item_9930",
    "Last Name": "Fishlock",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198439": {
    "id": "item_34959",
    "Last Name": "Buitrago",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198441": {
    "id": "item_37506",
    "Last Name": "Bryant",
    "First Name": "Garreth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198461": {
    "id": "item_9927",
    "Last Name": "Flanagan",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198467": {
    "id": "item_24348",
    "Last Name": "Clarke",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198487": {
    "id": "item_9926",
    "Last Name": "Murdock",
    "First Name": "Tahlia",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198506": {
    "id": "item_24347",
    "Last Name": "Oliver",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198560": {
    "id": "item_9925",
    "Last Name": "Evans",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198598": {
    "id": "item_34955",
    "Last Name": "Thorne",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198611": {
    "id": "item_37494",
    "Last Name": "Scott",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198626": {
    "id": "item_11683",
    "Last Name": "Grace",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198629": {
    "id": "item_24342",
    "Last Name": "Philippi",
    "First Name": "Michel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198630": {
    "id": "item_37492",
    "Last Name": "Sulit",
    "First Name": "Lourdes",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198654": {
    "id": "item_34954",
    "Last Name": "Ryan",
    "First Name": "Trent",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198660": {
    "id": "item_24345",
    "Last Name": "Mulhearn",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198663": {
    "id": "item_22895",
    "Last Name": "Tomlinson",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198666": {
    "id": "item_37490",
    "Last Name": "Tai",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198696": {
    "id": "item_37489",
    "Last Name": "Beccia",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198715": {
    "id": "item_22892",
    "Last Name": "Groenheide",
    "First Name": "Jethro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198743": {
    "id": "item_22889",
    "Last Name": "REVENGA GIERTYCH",
    "First Name": "CARLOS",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198765": {
    "id": "item_11682",
    "Last Name": "Clarke",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198840": {
    "id": "item_11681",
    "Last Name": "Sinclair",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198859": {
    "id": "item_11679",
    "Last Name": "KAo",
    "First Name": "CHINGFENG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198883": {
    "id": "item_24335",
    "Last Name": "Barnard",
    "First Name": "Phil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198926": {
    "id": "item_37479",
    "Last Name": "BAI",
    "First Name": "LIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198943": {
    "id": "item_37481",
    "Last Name": "Pun",
    "First Name": "Wing Hong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198978": {
    "id": "item_22886",
    "Last Name": "Day",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37198993": {
    "id": "item_37480",
    "Last Name": "Dolphin",
    "First Name": "Robyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199034": {
    "id": "item_37478",
    "Last Name": "CUNLIFFE",
    "First Name": "LEE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199047": {
    "id": "item_24329",
    "Last Name": "Damodaran",
    "First Name": "Nikhil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199066": {
    "id": "item_11676",
    "Last Name": "Lee",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199095": {
    "id": "item_11674",
    "Last Name": "xinyu",
    "First Name": "xia",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199149": {
    "id": "item_24328",
    "Last Name": "Purcell",
    "First Name": "Chrissy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199170": {
    "id": "item_24327",
    "Last Name": "Jones",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199227": {
    "id": "item_37472",
    "Last Name": "Dass",
    "First Name": "Shailesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199235": {
    "id": "item_34949",
    "Last Name": "McKay",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199248": {
    "id": "item_35790",
    "Last Name": "Cook",
    "First Name": "Stefanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199253": {
    "id": "item_9912",
    "Last Name": "Russell",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199261": {
    "id": "item_37467",
    "Last Name": "Elputra",
    "First Name": "Gayus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199300": {
    "id": "item_10561",
    "Last Name": "Shum",
    "First Name": "Hei-chun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199368": {
    "id": "item_37463",
    "Last Name": "Jiang",
    "First Name": "Zhenyu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199408": {
    "id": "item_37460",
    "Last Name": "Heit",
    "First Name": "Ros",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199440": {
    "id": "item_9904",
    "Last Name": "Chalkley",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199449": {
    "id": "item_22864",
    "Last Name": "Leiva",
    "First Name": "AndrŽ",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199548": {
    "id": "item_22861",
    "Last Name": "La Sala",
    "First Name": "Giovanni",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199549": {
    "id": "item_37454",
    "Last Name": "fuangfoo",
    "First Name": "supanya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199592": {
    "id": "item_37452",
    "Last Name": "Muhammad",
    "First Name": "Syazrin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199596": {
    "id": "item_24831",
    "Last Name": "Xu",
    "First Name": "Bo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199623": {
    "id": "item_22858",
    "Last Name": "Collins",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199634": {
    "id": "item_9899",
    "Last Name": "Beckers",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199641": {
    "id": "item_24316",
    "Last Name": "Gherardi",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199644": {
    "id": "item_24315",
    "Last Name": "Campbell",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199680": {
    "id": "item_34941",
    "Last Name": "Jia",
    "First Name": "Yuanyuan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199706": {
    "id": "item_9895",
    "Last Name": "Oliver",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199722": {
    "id": "item_37438",
    "Last Name": "Park",
    "First Name": "Sueun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199733": {
    "id": "item_34936",
    "Last Name": "OU",
    "First Name": "Dingying",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199739": {
    "id": "item_9897",
    "Last Name": "de la Porte",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199741": {
    "id": "item_11668",
    "Last Name": "Bejgier",
    "First Name": "Edmund",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199772": {
    "id": "item_24908",
    "Last Name": "Moore",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199782": {
    "id": "item_35742",
    "Last Name": "Patel",
    "First Name": "Dinesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199837": {
    "id": "item_22855",
    "Last Name": "Kenny",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199858": {
    "id": "item_37433",
    "Last Name": "Young",
    "First Name": "Charlee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199859": {
    "id": "item_22854",
    "Last Name": "McIvor",
    "First Name": "Ross",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199863": {
    "id": "item_11665",
    "Last Name": "Morgan",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199907": {
    "id": "item_37431",
    "Last Name": "Landrito",
    "First Name": "John Bernard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199932": {
    "id": "item_22850",
    "Last Name": "Wing Fu Kenneth",
    "First Name": "Wong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199948": {
    "id": "item_22844",
    "Last Name": "Davis",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199966": {
    "id": "item_34940",
    "Last Name": "Fitzpatrick",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199984": {
    "id": "item_9894",
    "Last Name": "Wight",
    "First Name": "Rohan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199989": {
    "id": "item_22841",
    "Last Name": "Upton",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37199996": {
    "id": "item_34938",
    "Last Name": "Tucker",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200001": {
    "id": "item_9893",
    "Last Name": "Zgraggen",
    "First Name": "Eugen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200019": {
    "id": "item_9892",
    "Last Name": "Harris",
    "First Name": "Danny",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200050": {
    "id": "item_9890",
    "Last Name": "Morandi",
    "First Name": "Davide",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200060": {
    "id": "item_22840",
    "Last Name": "Dunn",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200099": {
    "id": "item_22838",
    "Last Name": "Higgins",
    "First Name": "Toby",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200107": {
    "id": "item_11654",
    "Last Name": "Parkes",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200150": {
    "id": "item_34872",
    "Last Name": "Manfr�",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200164": {
    "id": "item_11660",
    "Last Name": "McDermott",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200181": {
    "id": "item_24907",
    "Last Name": "Makins",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200197": {
    "id": "item_11658",
    "Last Name": "Taillandier",
    "First Name": "Yvan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200229": {
    "id": "item_37405",
    "Last Name": "Mangaser",
    "First Name": "Joey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200230": {
    "id": "item_11656",
    "Last Name": "Davis",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200233": {
    "id": "item_34934",
    "Last Name": "Rodrigues Moreno Junior",
    "First Name": "Alvaro",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200237": {
    "id": "item_22833",
    "Last Name": "Fraser",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200245": {
    "id": "item_22830",
    "Last Name": "Dobbs",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200250": {
    "id": "item_11653",
    "Last Name": "Barry",
    "First Name": "Bill",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200261": {
    "id": "item_24300",
    "Last Name": "TREMBLAY",
    "First Name": "Marc",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200271": {
    "id": "item_37406",
    "Last Name": "Fallins",
    "First Name": "Xanthe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200284": {
    "id": "item_34933",
    "Last Name": "Laschko",
    "First Name": "Nadine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200289": {
    "id": "item_37407",
    "Last Name": "Heaver",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200332": {
    "id": "item_11652",
    "Last Name": "Xia",
    "First Name": "Mingwei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200356": {
    "id": "item_37399",
    "Last Name": "Moeliana",
    "First Name": "Martinus Arief Dharma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200358": {
    "id": "item_9883",
    "Last Name": "Hearn",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200387": {
    "id": "item_34932",
    "Last Name": "Carson",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200399": {
    "id": "item_37396",
    "Last Name": "Try",
    "First Name": "Khengthong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200453": {
    "id": "item_37394",
    "Last Name": "Pickard",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200457": {
    "id": "item_9879",
    "Last Name": "Sherwin",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200476": {
    "id": "item_11650",
    "Last Name": "De Lorme",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200489": {
    "id": "item_37393",
    "Last Name": "See",
    "First Name": "Peta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200511": {
    "id": "item_37391",
    "Last Name": "Tariq",
    "First Name": "Adeel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200532": {
    "id": "item_22816",
    "Last Name": "Kadowaki",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200535": {
    "id": "item_37387",
    "Last Name": "Devlin",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200548": {
    "id": "item_22824",
    "Last Name": "Lieng",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200557": {
    "id": "item_22822",
    "Last Name": "Saloma Saloma",
    "First Name": "Jose Guillermo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200573": {
    "id": "item_9875",
    "Last Name": "Lacey",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200584": {
    "id": "item_9874",
    "Last Name": "Barton",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200587": {
    "id": "item_37379",
    "Last Name": "Tang",
    "First Name": "Heng Hui",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200591": {
    "id": "item_22823",
    "Last Name": "McIntosh",
    "First Name": "Kelsey Louise",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200605": {
    "id": "item_9873",
    "Last Name": "Hana",
    "First Name": "Rune",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200614": {
    "id": "item_11645",
    "Last Name": "Fesenko",
    "First Name": "Aleksejs",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200615": {
    "id": "item_34929",
    "Last Name": "Chang",
    "First Name": "Warren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200638": {
    "id": "item_9872",
    "Last Name": "Lee",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200666": {
    "id": "item_22819",
    "Last Name": "Barros",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200684": {
    "id": "item_24291",
    "Last Name": "Bergersen",
    "First Name": "Cole",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200686": {
    "id": "item_12326",
    "Last Name": "AIHARA",
    "First Name": "TAKAAKI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200692": {
    "id": "item_9870",
    "Last Name": "Solar",
    "First Name": "Tomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200700": {
    "id": "item_11643",
    "Last Name": "Pegg",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200711": {
    "id": "item_11638",
    "Last Name": "Delgado Rodr’guez",
    "First Name": "Roberto Jaime",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200745": {
    "id": "item_11637",
    "Last Name": "Cop",
    "First Name": "Riccardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200758": {
    "id": "item_34925",
    "Last Name": "Bryant",
    "First Name": "Keiron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200783": {
    "id": "item_9867",
    "Last Name": "Norris",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200824": {
    "id": "item_34924",
    "Last Name": "Roland",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200897": {
    "id": "item_22811",
    "Last Name": "Cockroft",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200910": {
    "id": "item_24289",
    "Last Name": "Burge",
    "First Name": "Alix",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200929": {
    "id": "item_9861",
    "Last Name": "Ho",
    "First Name": "Chun Ting Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200949": {
    "id": "item_11633",
    "Last Name": "Hodges",
    "First Name": "Nic",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200953": {
    "id": "item_37362",
    "Last Name": "Sammon",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37200976": {
    "id": "item_37363",
    "Last Name": "Keen",
    "First Name": "Garry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201067": {
    "id": "item_34921",
    "Last Name": "Wilson",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201122": {
    "id": "item_11628",
    "Last Name": "Gottlieb",
    "First Name": "Yehuda",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201124": {
    "id": "item_11627",
    "Last Name": "Bennie",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201190": {
    "id": "item_22804",
    "Last Name": "Wassertheil",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201207": {
    "id": "item_37358",
    "Last Name": "Kuo",
    "First Name": "Liying",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201222": {
    "id": "item_37353",
    "Last Name": "Bambury",
    "First Name": "Simone",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201247": {
    "id": "item_24906",
    "Last Name": "Gorski",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201275": {
    "id": "item_37352",
    "Last Name": "Stjepic",
    "First Name": "Trisha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201277": {
    "id": "item_37345",
    "Last Name": "Lekploy",
    "First Name": "Piriya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201285": {
    "id": "item_37346",
    "Last Name": "MAGSALIN",
    "First Name": "JOSE MARI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201287": {
    "id": "item_9855",
    "Last Name": "Bell",
    "First Name": "Elliott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201300": {
    "id": "item_37351",
    "Last Name": "Han Chen",
    "First Name": "Leon Gan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201301": {
    "id": "item_24280",
    "Last Name": "Yaseen",
    "First Name": "Idrees",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201323": {
    "id": "item_9854",
    "Last Name": "Richards",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201324": {
    "id": "item_24279",
    "Last Name": "Andrews",
    "First Name": "Michael James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201374": {
    "id": "item_37342",
    "Last Name": "Ruangpanyapot",
    "First Name": "Nattapol",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201389": {
    "id": "item_9853",
    "Last Name": "Crameri",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201417": {
    "id": "item_22794",
    "Last Name": "Russell",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201458": {
    "id": "item_22796",
    "Last Name": "Williams",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201469": {
    "id": "item_37337",
    "Last Name": "Horton",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201528": {
    "id": "item_9852",
    "Last Name": "Rice",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201537": {
    "id": "item_34915",
    "Last Name": "Sandford",
    "First Name": "Philippa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201556": {
    "id": "item_12369",
    "Last Name": "Martinez-Gonzalez",
    "First Name": "Borja",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201561": {
    "id": "item_37335",
    "Last Name": "Perry",
    "First Name": "Chrissia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201576": {
    "id": "item_9850",
    "Last Name": "Smith",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201587": {
    "id": "item_22681",
    "Last Name": "XU",
    "First Name": "MING",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201596": {
    "id": "item_37331",
    "Last Name": "Mayhill",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201602": {
    "id": "item_11603",
    "Last Name": "Okubo",
    "First Name": "Akihito",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201618": {
    "id": "item_9846",
    "Last Name": "NGUYEN",
    "First Name": "Sinh Chung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201663": {
    "id": "item_37324",
    "Last Name": "vongasvathepchai",
    "First Name": "nives",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201681": {
    "id": "item_37323",
    "Last Name": "McKinley",
    "First Name": "Cliff",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201696": {
    "id": "item_24270",
    "Last Name": "Hogg",
    "First Name": "Elliot",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201711": {
    "id": "item_9844",
    "Last Name": "Onlaor",
    "First Name": "Wichai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201716": {
    "id": "item_22785",
    "Last Name": "Buchanan",
    "First Name": "Callum",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201750": {
    "id": "item_34907",
    "Last Name": "FENG",
    "First Name": "LI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201776": {
    "id": "item_22782",
    "Last Name": "Middleton",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201780": {
    "id": "item_22781",
    "Last Name": "van der Linden",
    "First Name": "Johannes",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201784": {
    "id": "item_34908",
    "Last Name": "Carnell",
    "First Name": "Amber",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201788": {
    "id": "item_22779",
    "Last Name": "Daniels",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201804": {
    "id": "item_37315",
    "Last Name": "Gaffney",
    "First Name": "Tre",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201805": {
    "id": "item_10560",
    "Last Name": "SORDELLO",
    "First Name": "JEROME",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201816": {
    "id": "item_22776",
    "Last Name": "Capitein",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201818": {
    "id": "item_37314",
    "Last Name": "Turner",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201821": {
    "id": "item_9843",
    "Last Name": "Phillips",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201822": {
    "id": "item_24267",
    "Last Name": "Weckert",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201845": {
    "id": "item_24265",
    "Last Name": "Grosmann",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201881": {
    "id": "item_37311",
    "Last Name": "Pope",
    "First Name": "Ilsa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201905": {
    "id": "item_9841",
    "Last Name": "Timmermann",
    "First Name": "Jonas Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201948": {
    "id": "item_34903",
    "Last Name": "ALLO",
    "First Name": "Maximilien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201950": {
    "id": "item_11602",
    "Last Name": "Woollard",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201989": {
    "id": "item_22772",
    "Last Name": "Bertuzzo",
    "First Name": "Bruno",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37201999": {
    "id": "item_34905",
    "Last Name": "Martens",
    "First Name": "Lode",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202001": {
    "id": "item_9839",
    "Last Name": "Phipps",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202024": {
    "id": "item_34904",
    "Last Name": "Mudri",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202048": {
    "id": "item_24264",
    "Last Name": "Billington",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202050": {
    "id": "item_9837",
    "Last Name": "Lawrence",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202052": {
    "id": "item_22770",
    "Last Name": "Ballerini",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202055": {
    "id": "item_9836",
    "Last Name": "Thompson",
    "First Name": "Curtis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202062": {
    "id": "item_37298",
    "Last Name": "Robinson",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202083": {
    "id": "item_37297",
    "Last Name": "Johnston",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202087": {
    "id": "item_24262",
    "Last Name": "Crilly",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202122": {
    "id": "item_9833",
    "Last Name": "Vogrig",
    "First Name": "Xavier",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202123": {
    "id": "item_11600",
    "Last Name": "Davies",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202130": {
    "id": "item_37293",
    "Last Name": "Darrington",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202156": {
    "id": "item_34897",
    "Last Name": "Shah",
    "First Name": "Saj",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202203": {
    "id": "item_9830",
    "Last Name": "Chan",
    "First Name": "Chi Kit",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202213": {
    "id": "item_9832",
    "Last Name": "Hall",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202218": {
    "id": "item_9831",
    "Last Name": "Stanlake",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202244": {
    "id": "item_22761",
    "Last Name": "Hill",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202247": {
    "id": "item_37289",
    "Last Name": "Ellwood",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202268": {
    "id": "item_37288",
    "Last Name": "Lirio",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202275": {
    "id": "item_34899",
    "Last Name": "Lianto",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202303": {
    "id": "item_24254",
    "Last Name": "O'Sullivan",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202313": {
    "id": "item_24905",
    "Last Name": "Hall",
    "First Name": "Kayla",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202350": {
    "id": "item_11592",
    "Last Name": "baddeley",
    "First Name": "lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202353": {
    "id": "item_22752",
    "Last Name": "McLean",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202359": {
    "id": "item_24255",
    "Last Name": "Sulit",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202368": {
    "id": "item_37279",
    "Last Name": "Wangman",
    "First Name": "Brodie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202372": {
    "id": "item_11596",
    "Last Name": "Brosolo",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202379": {
    "id": "item_34896",
    "Last Name": "Stepanov",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202401": {
    "id": "item_11590",
    "Last Name": "Mackay",
    "First Name": "Quinn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202422": {
    "id": "item_22747",
    "Last Name": "Cullen",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202437": {
    "id": "item_37275",
    "Last Name": "Tao",
    "First Name": "Xiaoke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202444": {
    "id": "item_34895",
    "Last Name": "Swann",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202479": {
    "id": "item_9816",
    "Last Name": "Peres",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202480": {
    "id": "item_37274",
    "Last Name": "Fior",
    "First Name": "Zoey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202497": {
    "id": "item_22744",
    "Last Name": "Magorian",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202505": {
    "id": "item_9822",
    "Last Name": "Taylor",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202506": {
    "id": "item_22743",
    "Last Name": "Krichmara",
    "First Name": "Grigorii",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202563": {
    "id": "item_24247",
    "Last Name": "Alberio",
    "First Name": "salvatore",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202587": {
    "id": "item_37268",
    "Last Name": "Sklavakis",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202595": {
    "id": "item_22741",
    "Last Name": "Rodriguez",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202621": {
    "id": "item_22738",
    "Last Name": "Mazzarolo",
    "First Name": "Louisa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202651": {
    "id": "item_24249",
    "Last Name": "Chadburn",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202691": {
    "id": "item_22733",
    "Last Name": "Harding",
    "First Name": "Teresa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202703": {
    "id": "item_11583",
    "Last Name": "Lopes",
    "First Name": "Vitor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202704": {
    "id": "item_22736",
    "Last Name": "Xie",
    "First Name": "Fachun",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202736": {
    "id": "item_11584",
    "Last Name": "Caballero Garc’a",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202761": {
    "id": "item_22732",
    "Last Name": "Hilliard",
    "First Name": "Bridget",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202787": {
    "id": "item_34889",
    "Last Name": "Law",
    "First Name": "Sonya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202810": {
    "id": "item_37256",
    "Last Name": "Gill",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202814": {
    "id": "item_24240",
    "Last Name": "Katoa",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202827": {
    "id": "item_22731",
    "Last Name": "Payne",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202866": {
    "id": "item_37252",
    "Last Name": "Nnko",
    "First Name": "Martha Phineas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202889": {
    "id": "item_11581",
    "Last Name": "Chapman",
    "First Name": "Louisa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202917": {
    "id": "item_22729",
    "Last Name": "Culla",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202933": {
    "id": "item_22726",
    "Last Name": "Fill",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202949": {
    "id": "item_37247",
    "Last Name": "Salvador",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202950": {
    "id": "item_9814",
    "Last Name": "Marshall",
    "First Name": "Iain",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37202962": {
    "id": "item_37249",
    "Last Name": "mcmullan",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203018": {
    "id": "item_22712",
    "Last Name": "Zhang",
    "First Name": "Lingxiao",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203025": {
    "id": "item_24235",
    "Last Name": "McNamara",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203028": {
    "id": "item_9808",
    "Last Name": "Northrop",
    "First Name": "Riley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203033": {
    "id": "item_37243",
    "Last Name": "Preston",
    "First Name": "Jules",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203036": {
    "id": "item_24236",
    "Last Name": "Devenney",
    "First Name": "Daryl",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203079": {
    "id": "item_22721",
    "Last Name": "Dinga",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203097": {
    "id": "item_11577",
    "Last Name": "Brasil",
    "First Name": "Sidney",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203107": {
    "id": "item_37240",
    "Last Name": "Horgan",
    "First Name": "Aisling",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203108": {
    "id": "item_24234",
    "Last Name": "Cahya Negara",
    "First Name": "Al Ridla",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203117": {
    "id": "item_37235",
    "Last Name": "PUTRA ALDAFI",
    "First Name": "MAHESA BINTANG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203141": {
    "id": "item_9806",
    "Last Name": "Haruki",
    "First Name": "Ogasawara",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203146": {
    "id": "item_11574",
    "Last Name": "Marchukov",
    "First Name": "Sergei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203192": {
    "id": "item_11573",
    "Last Name": "Shanahan",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203197": {
    "id": "item_9807",
    "Last Name": "Hawthorne",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203224": {
    "id": "item_22714",
    "Last Name": "Boyd",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203260": {
    "id": "item_24230",
    "Last Name": "Baker",
    "First Name": "Leah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203261": {
    "id": "item_9805",
    "Last Name": "Fletcher",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203272": {
    "id": "item_24229",
    "Last Name": "Downey",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203281": {
    "id": "item_22711",
    "Last Name": "Menzie",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203312": {
    "id": "item_34884",
    "Last Name": "Stallard",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203326": {
    "id": "item_22710",
    "Last Name": "Cheung",
    "First Name": "Man Kit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203331": {
    "id": "item_24226",
    "Last Name": "mcmonagle",
    "First Name": "noel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203340": {
    "id": "item_9802",
    "Last Name": "Hannaford",
    "First Name": "Monty",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203353": {
    "id": "item_24223",
    "Last Name": "Bourke",
    "First Name": "Stefanie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203389": {
    "id": "item_9797",
    "Last Name": "ALLOU",
    "First Name": "Rafik",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203413": {
    "id": "item_37221",
    "Last Name": "Mulia",
    "First Name": "Trisnadi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203425": {
    "id": "item_34883",
    "Last Name": "Vanitchpongphan",
    "First Name": "Chanakarn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203439": {
    "id": "item_37211",
    "Last Name": "FRIDAY",
    "First Name": "DAVID",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203470": {
    "id": "item_37219",
    "Last Name": "Stewart",
    "First Name": "Christie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203515": {
    "id": "item_37205",
    "Last Name": "Armigos",
    "First Name": "Mayeath",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203530": {
    "id": "item_37214",
    "Last Name": "Van Wijngaarden",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203538": {
    "id": "item_37208",
    "Last Name": "chan",
    "First Name": "siu kwan kris anthony",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203539": {
    "id": "item_9799",
    "Last Name": "Fujita",
    "First Name": "Fumiaki",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203544": {
    "id": "item_9800",
    "Last Name": "Boardman",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203562": {
    "id": "item_37213",
    "Last Name": "Waters",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203568": {
    "id": "item_11567",
    "Last Name": "Nelson",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203575": {
    "id": "item_34880",
    "Last Name": "Herdina",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203592": {
    "id": "item_37209",
    "Last Name": "McCaffrey",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203635": {
    "id": "item_11563",
    "Last Name": "McRae",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203658": {
    "id": "item_37199",
    "Last Name": "Bayram",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203684": {
    "id": "item_22699",
    "Last Name": "Gu",
    "First Name": "Haiyan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203716": {
    "id": "item_37194",
    "Last Name": "Engleder",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203741": {
    "id": "item_37137",
    "Last Name": "Fletcher",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203748": {
    "id": "item_37193",
    "Last Name": "O'Mahoney",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203751": {
    "id": "item_37192",
    "Last Name": "Rees",
    "First Name": "Sion",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203755": {
    "id": "item_11561",
    "Last Name": "Hughes",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203778": {
    "id": "item_22697",
    "Last Name": "Chan",
    "First Name": "Yee Sum",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203783": {
    "id": "item_37189",
    "Last Name": "Stone",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203790": {
    "id": "item_24904",
    "Last Name": "Donovan",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203795": {
    "id": "item_9787",
    "Last Name": "Vincent",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203830": {
    "id": "item_37158",
    "Last Name": "Pham",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203858": {
    "id": "item_11555",
    "Last Name": "Day",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203868": {
    "id": "item_22696",
    "Last Name": "Joyce",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203870": {
    "id": "item_24209",
    "Last Name": "Ardern",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203889": {
    "id": "item_24208",
    "Last Name": "Still",
    "First Name": "Jacinda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203966": {
    "id": "item_37176",
    "Last Name": "Bolderoff",
    "First Name": "Micheal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37203995": {
    "id": "item_22694",
    "Last Name": "Brooks",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204026": {
    "id": "item_24207",
    "Last Name": "Aparecida Pereira Martins",
    "First Name": "Wandressa Mara",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204029": {
    "id": "item_37170",
    "Last Name": "Katombo",
    "First Name": "Meriam Wahyuni",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204052": {
    "id": "item_37169",
    "Last Name": "Luo",
    "First Name": "Jiachen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204111": {
    "id": "item_22689",
    "Last Name": "Rivett",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204119": {
    "id": "item_37164",
    "Last Name": "Pringle",
    "First Name": "Jazmyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204128": {
    "id": "item_37165",
    "Last Name": "Bolderoff",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204198": {
    "id": "item_9780",
    "Last Name": "Donegan",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204218": {
    "id": "item_35624",
    "Last Name": "MacLeod",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204223": {
    "id": "item_37156",
    "Last Name": "Taylorova",
    "First Name": "Vera",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204234": {
    "id": "item_37155",
    "Last Name": "LIM",
    "First Name": "HUI CHIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204283": {
    "id": "item_37152",
    "Last Name": "Bauer",
    "First Name": "Aleisha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204286": {
    "id": "item_11543",
    "Last Name": "RIFKY",
    "First Name": "Sami",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204334": {
    "id": "item_35623",
    "Last Name": "Beddoe",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204342": {
    "id": "item_12211",
    "Last Name": "Brennan",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204346": {
    "id": "item_12210",
    "Last Name": "Van der Veken",
    "First Name": "Youssef",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204419": {
    "id": "item_12209",
    "Last Name": "Congedo",
    "First Name": "Matteo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204452": {
    "id": "item_24696",
    "Last Name": "Thorne",
    "First Name": "Maxwell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204499": {
    "id": "item_35621",
    "Last Name": "Fuentes",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204515": {
    "id": "item_12368",
    "Last Name": "Bracken",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204518": {
    "id": "item_10421",
    "Last Name": "McKinlay",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204519": {
    "id": "item_12208",
    "Last Name": "Arak",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204529": {
    "id": "item_10559",
    "Last Name": "Stroh",
    "First Name": "Dominik Julian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204548": {
    "id": "item_24694",
    "Last Name": "Murphy",
    "First Name": "Aoife",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204574": {
    "id": "item_10420",
    "Last Name": "Marks",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204607": {
    "id": "item_10419",
    "Last Name": "Dalby",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204628": {
    "id": "item_35619",
    "Last Name": "Christmann",
    "First Name": "Petra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204631": {
    "id": "item_24691",
    "Last Name": "Kljajic",
    "First Name": "Smiljana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204749": {
    "id": "item_24903",
    "Last Name": "XU",
    "First Name": "XINHUA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204757": {
    "id": "item_10415",
    "Last Name": "Goesmann",
    "First Name": "Marvin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204785": {
    "id": "item_24690",
    "Last Name": "Edlington",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204816": {
    "id": "item_35615",
    "Last Name": "Castellanos",
    "First Name": "Myriam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204819": {
    "id": "item_35613",
    "Last Name": "Thibodeau",
    "First Name": "Kristy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204851": {
    "id": "item_24689",
    "Last Name": "Ha",
    "First Name": "Trang",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204983": {
    "id": "item_12204",
    "Last Name": "Braithwaite",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37204997": {
    "id": "item_10520",
    "Last Name": "Maluf junior",
    "First Name": "Otavio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205009": {
    "id": "item_12202",
    "Last Name": "Fingleson",
    "First Name": "Larry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205068": {
    "id": "item_35607",
    "Last Name": "Hughes",
    "First Name": "Hilary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205082": {
    "id": "item_24682",
    "Last Name": "Brown",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205083": {
    "id": "item_24681",
    "Last Name": "Jones",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205098": {
    "id": "item_35602",
    "Last Name": "Maher",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205134": {
    "id": "item_10409",
    "Last Name": "Bond",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205150": {
    "id": "item_35741",
    "Last Name": "Lynch",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205161": {
    "id": "item_10408",
    "Last Name": "Plant",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205173": {
    "id": "item_35600",
    "Last Name": "Robinson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205205": {
    "id": "item_12366",
    "Last Name": "WILSON",
    "First Name": "ASHLEY",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205213": {
    "id": "item_12367",
    "Last Name": "Nagib",
    "First Name": "Mazen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205235": {
    "id": "item_12199",
    "Last Name": "Choi",
    "First Name": "Youngho",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205274": {
    "id": "item_35597",
    "Last Name": "Fairbrother",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205287": {
    "id": "item_12195",
    "Last Name": "Exadaktylos",
    "First Name": "Kyriakos",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205335": {
    "id": "item_35595",
    "Last Name": "Taufik",
    "First Name": "Inayat",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205358": {
    "id": "item_10406",
    "Last Name": "Stackhouse",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205461": {
    "id": "item_12193",
    "Last Name": "Pezzini",
    "First Name": "Marco",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205481": {
    "id": "item_24672",
    "Last Name": "van Noort",
    "First Name": "Marcel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205538": {
    "id": "item_23483",
    "Last Name": "Everingham",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205647": {
    "id": "item_10402",
    "Last Name": "Doran",
    "First Name": "Noah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205708": {
    "id": "item_24667",
    "Last Name": "Lente",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205754": {
    "id": "item_35587",
    "Last Name": "Montiel",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205755": {
    "id": "item_24666",
    "Last Name": "Leskovec",
    "First Name": "Cael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205803": {
    "id": "item_24664",
    "Last Name": "Mayers",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205902": {
    "id": "item_24658",
    "Last Name": "Zhaowen",
    "First Name": "Yang",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205916": {
    "id": "item_10399",
    "Last Name": "Kolasinski",
    "First Name": "Larissa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37205961": {
    "id": "item_12184",
    "Last Name": "Labr�che",
    "First Name": "Beno”t",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206000": {
    "id": "item_12183",
    "Last Name": "Dirjayanto",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206003": {
    "id": "item_12180",
    "Last Name": "Moscarda",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206020": {
    "id": "item_12181",
    "Last Name": "Wei",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206074": {
    "id": "item_35789",
    "Last Name": "Azarcon",
    "First Name": "Clarina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206093": {
    "id": "item_10396",
    "Last Name": "Pereira",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206106": {
    "id": "item_10395",
    "Last Name": "Webber",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206161": {
    "id": "item_10394",
    "Last Name": "Green",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206166": {
    "id": "item_10393",
    "Last Name": "Doyon",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206181": {
    "id": "item_35581",
    "Last Name": "Stayt",
    "First Name": "Roland",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206213": {
    "id": "item_24653",
    "Last Name": "Kaye",
    "First Name": "Joey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206222": {
    "id": "item_35579",
    "Last Name": "Underwood",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206238": {
    "id": "item_10391",
    "Last Name": "versace",
    "First Name": "daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206255": {
    "id": "item_24650",
    "Last Name": "Oliveira",
    "First Name": "Luiz Gustavo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206287": {
    "id": "item_35576",
    "Last Name": "ZHAO",
    "First Name": "HUANLAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206319": {
    "id": "item_12176",
    "Last Name": "Campos",
    "First Name": "Raul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206325": {
    "id": "item_10388",
    "Last Name": "Wolfe",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206333": {
    "id": "item_12175",
    "Last Name": "Hodges",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206347": {
    "id": "item_12174",
    "Last Name": "Augello",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206365": {
    "id": "item_10386",
    "Last Name": "Da Silva Lima",
    "First Name": "Alexsandro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206381": {
    "id": "item_35575",
    "Last Name": "Mathew",
    "First Name": "Bob",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206382": {
    "id": "item_12171",
    "Last Name": "Pacios Fern‡ndez",
    "First Name": "îscar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206491": {
    "id": "item_35573",
    "Last Name": "Chronister",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206567": {
    "id": "item_10383",
    "Last Name": "Reimer",
    "First Name": "Lennart",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206571": {
    "id": "item_10382",
    "Last Name": "Boriskin",
    "First Name": "Aleksandr",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206577": {
    "id": "item_35572",
    "Last Name": "Manolias",
    "First Name": "Annamarie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206584": {
    "id": "item_35571",
    "Last Name": "Fice",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206637": {
    "id": "item_10381",
    "Last Name": "Liu",
    "First Name": "Chun Wah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206661": {
    "id": "item_24638",
    "Last Name": "Flint",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206666": {
    "id": "item_35788",
    "Last Name": "Patel",
    "First Name": "Nitin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206690": {
    "id": "item_10380",
    "Last Name": "Tostmann",
    "First Name": "Benedikt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206777": {
    "id": "item_10378",
    "Last Name": "Tran",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206808": {
    "id": "item_23478",
    "Last Name": "Batrashkin",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206816": {
    "id": "item_12325",
    "Last Name": "Hirano",
    "First Name": "Masashi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37206885": {
    "id": "item_24631",
    "Last Name": "Ho",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207018": {
    "id": "item_12161",
    "Last Name": "Doi",
    "First Name": "Takashi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207022": {
    "id": "item_24627",
    "Last Name": "Toomey",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207023": {
    "id": "item_24629",
    "Last Name": "Chan",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207120": {
    "id": "item_35562",
    "Last Name": "POLANCO-BOYD",
    "First Name": "NORMA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207191": {
    "id": "item_35558",
    "Last Name": "Ocepek",
    "First Name": "Simona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207338": {
    "id": "item_35556",
    "Last Name": "Cross",
    "First Name": "Nena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207386": {
    "id": "item_24620",
    "Last Name": "Becca",
    "First Name": "Rosalia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207399": {
    "id": "item_24623",
    "Last Name": "Un",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207400": {
    "id": "item_24624",
    "Last Name": "McLoughlin",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207411": {
    "id": "item_24622",
    "Last Name": "BinHafiz",
    "First Name": "Mohamed",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207427": {
    "id": "item_24621",
    "Last Name": "Schreurs",
    "First Name": "Amalie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207430": {
    "id": "item_12159",
    "Last Name": "Dakin",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207445": {
    "id": "item_23477",
    "Last Name": "Moroney",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207479": {
    "id": "item_12158",
    "Last Name": "Douglas",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207497": {
    "id": "item_24902",
    "Last Name": "MAUCH",
    "First Name": "PABLO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207536": {
    "id": "item_35740",
    "Last Name": "Gonzalez",
    "First Name": "Brummell",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207604": {
    "id": "item_35553",
    "Last Name": "Twyford",
    "First Name": "Clare",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207647": {
    "id": "item_12157",
    "Last Name": "Hong",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207658": {
    "id": "item_24901",
    "Last Name": "CHIANG",
    "First Name": "YEN TE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207666": {
    "id": "item_24615",
    "Last Name": "Marathon",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207713": {
    "id": "item_10372",
    "Last Name": "Talleri",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207782": {
    "id": "item_12155",
    "Last Name": "Lewinski",
    "First Name": "Michal",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207795": {
    "id": "item_10370",
    "Last Name": "Han",
    "First Name": "Bing",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207809": {
    "id": "item_35550",
    "Last Name": "Ramsbotham",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207867": {
    "id": "item_35546",
    "Last Name": "Peters",
    "First Name": "Daphne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37207939": {
    "id": "item_24614",
    "Last Name": "Stone",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208006": {
    "id": "item_24613",
    "Last Name": "Pelczarska",
    "First Name": "Anya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208009": {
    "id": "item_12153",
    "Last Name": "Dikikj",
    "First Name": "Nebojsha",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208032": {
    "id": "item_35543",
    "Last Name": "Ng",
    "First Name": "Po Hing Patrick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208125": {
    "id": "item_24611",
    "Last Name": "Trigg",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208181": {
    "id": "item_24610",
    "Last Name": "Mundy",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208261": {
    "id": "item_24609",
    "Last Name": "Ong",
    "First Name": "Delson",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208361": {
    "id": "item_23476",
    "Last Name": "Reis",
    "First Name": "Monique",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208365": {
    "id": "item_24900",
    "Last Name": "Lang",
    "First Name": "Robin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208368": {
    "id": "item_24899",
    "Last Name": "Kim",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208548": {
    "id": "item_10363",
    "Last Name": "Choy",
    "First Name": "Jeffrey Yan Tsun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208632": {
    "id": "item_24605",
    "Last Name": "Redman",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208644": {
    "id": "item_12149",
    "Last Name": "Shang",
    "First Name": "Chun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208709": {
    "id": "item_35539",
    "Last Name": "Rouen",
    "First Name": "Mary Amber",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208768": {
    "id": "item_35538",
    "Last Name": "Espinosa",
    "First Name": "Erika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208855": {
    "id": "item_35535",
    "Last Name": "Leslie",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37208907": {
    "id": "item_12147",
    "Last Name": "tao",
    "First Name": "xingxing",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209076": {
    "id": "item_12146",
    "Last Name": "Mao",
    "First Name": "Haidong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209084": {
    "id": "item_24597",
    "Last Name": "Santos",
    "First Name": "Albert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209139": {
    "id": "item_35787",
    "Last Name": "Branley",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209186": {
    "id": "item_24594",
    "Last Name": "Clark",
    "First Name": "Brodie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209192": {
    "id": "item_12145",
    "Last Name": "Alblooshi",
    "First Name": "Saeed",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209252": {
    "id": "item_35532",
    "Last Name": "Becquet",
    "First Name": "Stephane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209283": {
    "id": "item_35531",
    "Last Name": "Anderson",
    "First Name": "Heidi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209454": {
    "id": "item_10358",
    "Last Name": "Ormond",
    "First Name": "Ross",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209572": {
    "id": "item_12144",
    "Last Name": "Wilson",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209750": {
    "id": "item_23505",
    "Last Name": "Sokol",
    "First Name": "Agnieszka",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209751": {
    "id": "item_12143",
    "Last Name": "Chow",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209938": {
    "id": "item_12142",
    "Last Name": "CHEN",
    "First Name": "KUOCHUNG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37209992": {
    "id": "item_12141",
    "Last Name": "Oliver",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210008": {
    "id": "item_24579",
    "Last Name": "Le",
    "First Name": "Tuan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210035": {
    "id": "item_24830",
    "Last Name": "Smith",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210103": {
    "id": "item_12139",
    "Last Name": "Smith",
    "First Name": "Shelley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210176": {
    "id": "item_10351",
    "Last Name": "PARK",
    "First Name": "YONGJUN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210185": {
    "id": "item_12138",
    "Last Name": "Li",
    "First Name": "Tianran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210233": {
    "id": "item_24576",
    "Last Name": "INOUE",
    "First Name": "KOICHI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210254": {
    "id": "item_24898",
    "Last Name": "AHN",
    "First Name": "MINCHUNG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210307": {
    "id": "item_24575",
    "Last Name": "Carter",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210372": {
    "id": "item_35523",
    "Last Name": "mehou",
    "First Name": "Ghislain",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210504": {
    "id": "item_12134",
    "Last Name": "Zhao",
    "First Name": "Shize",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210539": {
    "id": "item_10350",
    "Last Name": "Gonzalez",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210587": {
    "id": "item_12365",
    "Last Name": "Deitemeyer",
    "First Name": "Philip",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210640": {
    "id": "item_24574",
    "Last Name": "Kashpur",
    "First Name": "Olha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210698": {
    "id": "item_24572",
    "Last Name": "Khabuktanova",
    "First Name": "Olga",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210736": {
    "id": "item_23473",
    "Last Name": "Roderick",
    "First Name": "Rupert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210879": {
    "id": "item_12132",
    "Last Name": "Jimenez",
    "First Name": "Avelino",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210914": {
    "id": "item_10349",
    "Last Name": "DEL POZO",
    "First Name": "JOSE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210964": {
    "id": "item_10348",
    "Last Name": "Ng",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37210977": {
    "id": "item_10347",
    "Last Name": "Eisner",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211150": {
    "id": "item_12363",
    "Last Name": "KAM",
    "First Name": "Daniel Ka-On",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211156": {
    "id": "item_12364",
    "Last Name": "Jongschaap",
    "First Name": "Ramon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211228": {
    "id": "item_24567",
    "Last Name": "Chow",
    "First Name": "Hung Kwan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211236": {
    "id": "item_12131",
    "Last Name": "Brewster",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211260": {
    "id": "item_10345",
    "Last Name": "Mannix",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211316": {
    "id": "item_24566",
    "Last Name": "Marlow",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211329": {
    "id": "item_35519",
    "Last Name": "Lee",
    "First Name": "Hector Oi Tak",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211375": {
    "id": "item_12130",
    "Last Name": "O'Neil",
    "First Name": "Bryce",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211485": {
    "id": "item_10344",
    "Last Name": "French",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211535": {
    "id": "item_24561",
    "Last Name": "clarke",
    "First Name": "emily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211541": {
    "id": "item_24563",
    "Last Name": "shi",
    "First Name": "dongdong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211660": {
    "id": "item_24560",
    "Last Name": "smith",
    "First Name": "david",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211730": {
    "id": "item_24558",
    "Last Name": "ZHU",
    "First Name": "WENJIA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211741": {
    "id": "item_24556",
    "Last Name": "Gonzalez",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211754": {
    "id": "item_24557",
    "Last Name": "Sanz de Alba",
    "First Name": "Fleur",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211839": {
    "id": "item_12129",
    "Last Name": "Alexander",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211915": {
    "id": "item_35515",
    "Last Name": "Doniphan",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37211929": {
    "id": "item_12127",
    "Last Name": "cho",
    "First Name": "jennifer",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212012": {
    "id": "item_12125",
    "Last Name": "Petrilli",
    "First Name": "Gustavo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212021": {
    "id": "item_24554",
    "Last Name": "Wu",
    "First Name": "Edson",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212045": {
    "id": "item_24555",
    "Last Name": "Ladson",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212075": {
    "id": "item_35513",
    "Last Name": "Campbell",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212158": {
    "id": "item_10341",
    "Last Name": "Starsia",
    "First Name": "Katie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212188": {
    "id": "item_35511",
    "Last Name": "Nikolaeva",
    "First Name": "Malika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212204": {
    "id": "item_24552",
    "Last Name": "Molina",
    "First Name": "Andres",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212459": {
    "id": "item_12123",
    "Last Name": "Saccardi",
    "First Name": "Lorenzo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212486": {
    "id": "item_24551",
    "Last Name": "Alc‡ntara Noguez",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212717": {
    "id": "item_12119",
    "Last Name": "Latanik",
    "First Name": "Grzegorz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212721": {
    "id": "item_12120",
    "Last Name": "Li",
    "First Name": "Hao",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212750": {
    "id": "item_24897",
    "Last Name": "Mui",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212794": {
    "id": "item_10338",
    "Last Name": "Quach",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212870": {
    "id": "item_10337",
    "Last Name": "Osipov",
    "First Name": "Valentin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212883": {
    "id": "item_12117",
    "Last Name": "Weiler",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37212956": {
    "id": "item_12116",
    "Last Name": "Garrido Lecca",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213005": {
    "id": "item_10558",
    "Last Name": "Maitland-Jones",
    "First Name": "Ania",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213038": {
    "id": "item_12115",
    "Last Name": "Lopez",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213204": {
    "id": "item_12114",
    "Last Name": "Barnes Jr",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213352": {
    "id": "item_10334",
    "Last Name": "Unfried",
    "First Name": "Stanley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213433": {
    "id": "item_12362",
    "Last Name": "Kwong",
    "First Name": "Chun Ho Howard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213453": {
    "id": "item_10333",
    "Last Name": "Brotherton",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213506": {
    "id": "item_12113",
    "Last Name": "Clarke",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37213733": {
    "id": "item_23469",
    "Last Name": "Eeckhaut",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214026": {
    "id": "item_12112",
    "Last Name": "Mackenzie",
    "First Name": "Jak",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214070": {
    "id": "item_12111",
    "Last Name": "Gopaldas",
    "First Name": "Priya",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214141": {
    "id": "item_24829",
    "Last Name": "Maynez Acosta",
    "First Name": "Laura Elisa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214154": {
    "id": "item_35499",
    "Last Name": "LING",
    "First Name": "Chunfeng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214275": {
    "id": "item_10328",
    "Last Name": "Abularach",
    "First Name": "Maria Andrea",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214637": {
    "id": "item_12104",
    "Last Name": "Reyna",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214730": {
    "id": "item_10327",
    "Last Name": "Wallis",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214792": {
    "id": "item_35489",
    "Last Name": "Quick",
    "First Name": "Shona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214914": {
    "id": "item_12102",
    "Last Name": "Jones",
    "First Name": "Kassidi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37214990": {
    "id": "item_35486",
    "Last Name": "Vijay",
    "First Name": "PJ",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215023": {
    "id": "item_35485",
    "Last Name": "Pinto",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215069": {
    "id": "item_35484",
    "Last Name": "Fulton-Hines",
    "First Name": "Jarell",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215078": {
    "id": "item_24896",
    "Last Name": "Ewing",
    "First Name": "Kelsey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215107": {
    "id": "item_12099",
    "Last Name": "Bezzam",
    "First Name": "Anirudh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215381": {
    "id": "item_10557",
    "Last Name": "Jacob",
    "First Name": "Simeon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215383": {
    "id": "item_12098",
    "Last Name": "Robertson",
    "First Name": "Watene",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215437": {
    "id": "item_10556",
    "Last Name": "MULHOLLAND",
    "First Name": "ELLEN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215733": {
    "id": "item_24525",
    "Last Name": "James",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215746": {
    "id": "item_37138",
    "Last Name": "Siao",
    "First Name": "Maria Lourdes Racquel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215819": {
    "id": "item_24524",
    "Last Name": "Wang",
    "First Name": "Qinghua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215853": {
    "id": "item_10325",
    "Last Name": "Nyhart",
    "First Name": "Noah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215910": {
    "id": "item_12096",
    "Last Name": "White",
    "First Name": "Rizal",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37215967": {
    "id": "item_10324",
    "Last Name": "Gray",
    "First Name": "Ellis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216078": {
    "id": "item_24523",
    "Last Name": "Hamilton",
    "First Name": "Tegan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216247": {
    "id": "item_35479",
    "Last Name": "Lam",
    "First Name": "Adrienne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216257": {
    "id": "item_12093",
    "Last Name": "James",
    "First Name": "Lawson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216383": {
    "id": "item_10321",
    "Last Name": "Dejesus",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216409": {
    "id": "item_35478",
    "Last Name": "Martinez",
    "First Name": "Rosa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216434": {
    "id": "item_24520",
    "Last Name": "Samayoa",
    "First Name": "Cristina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216658": {
    "id": "item_12091",
    "Last Name": "Stroud",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216662": {
    "id": "item_12324",
    "Last Name": "Blankenship",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216680": {
    "id": "item_35475",
    "Last Name": "Perrin",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216819": {
    "id": "item_24517",
    "Last Name": "Gal",
    "First Name": "Roi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37216827": {
    "id": "item_24514",
    "Last Name": "McRae",
    "First Name": "Sara",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217019": {
    "id": "item_12089",
    "Last Name": "Makarowski",
    "First Name": "Pawel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217237": {
    "id": "item_24511",
    "Last Name": "Moraveji",
    "First Name": "Alireza",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217250": {
    "id": "item_23466",
    "Last Name": "Mullins",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217388": {
    "id": "item_10316",
    "Last Name": "Bussab Fonseca",
    "First Name": "Marcelo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217465": {
    "id": "item_12087",
    "Last Name": "Schofield",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217554": {
    "id": "item_23465",
    "Last Name": "Perea",
    "First Name": "Estefania",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217585": {
    "id": "item_12086",
    "Last Name": "Carmont",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217684": {
    "id": "item_24509",
    "Last Name": "Neria",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217686": {
    "id": "item_12085",
    "Last Name": "Egan",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217690": {
    "id": "item_24508",
    "Last Name": "Kuenen",
    "First Name": "Tommy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217809": {
    "id": "item_24895",
    "Last Name": "Jukes",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217886": {
    "id": "item_10311",
    "Last Name": "Peterson",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37217915": {
    "id": "item_24507",
    "Last Name": "Aitken",
    "First Name": "Donny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218054": {
    "id": "item_24504",
    "Last Name": "Yates",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218135": {
    "id": "item_35467",
    "Last Name": "Westphal",
    "First Name": "Klaus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218148": {
    "id": "item_24503",
    "Last Name": "Alstowe",
    "First Name": "Ciaran",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218150": {
    "id": "item_35465",
    "Last Name": "Price",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218156": {
    "id": "item_35466",
    "Last Name": "Lochhead",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218235": {
    "id": "item_12079",
    "Last Name": "Saleh",
    "First Name": "Fouad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218261": {
    "id": "item_35461",
    "Last Name": "Polonis",
    "First Name": "Roberta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218358": {
    "id": "item_12078",
    "Last Name": "Katsanevakis",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218421": {
    "id": "item_35459",
    "Last Name": "Rebbeck",
    "First Name": "Farran",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218487": {
    "id": "item_35458",
    "Last Name": "Keagbine",
    "First Name": "Jenni",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218574": {
    "id": "item_24497",
    "Last Name": "Munro",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218577": {
    "id": "item_24496",
    "Last Name": "Barrett",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218733": {
    "id": "item_37139",
    "Last Name": "Kerin",
    "First Name": "Amelie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218767": {
    "id": "item_24492",
    "Last Name": "Liston",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218781": {
    "id": "item_35453",
    "Last Name": "Adegoke",
    "First Name": "Toyin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218846": {
    "id": "item_24200",
    "Last Name": "Robb",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37218937": {
    "id": "item_35452",
    "Last Name": "Farrell",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219027": {
    "id": "item_10300",
    "Last Name": "Lisnik",
    "First Name": "Igor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219050": {
    "id": "item_10299",
    "Last Name": "SAFE",
    "First Name": "NATHAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219055": {
    "id": "item_12361",
    "Last Name": "Mora Benitez",
    "First Name": "Diana Pamela",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219059": {
    "id": "item_12072",
    "Last Name": "Hixon",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219107": {
    "id": "item_12069",
    "Last Name": "Stavnitskiy",
    "First Name": "Vasily",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219109": {
    "id": "item_12070",
    "Last Name": "pettem",
    "First Name": "ashok",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219157": {
    "id": "item_24828",
    "Last Name": "Singh",
    "First Name": "Khamini",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219197": {
    "id": "item_24487",
    "Last Name": "Said",
    "First Name": "Ibrahim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219222": {
    "id": "item_23496",
    "Last Name": "Homan",
    "First Name": "Colm",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219280": {
    "id": "item_24485",
    "Last Name": "Feng",
    "First Name": "Xiujuan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219310": {
    "id": "item_12066",
    "Last Name": "Buyck",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219441": {
    "id": "item_10297",
    "Last Name": "Taulle de Andrade",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219528": {
    "id": "item_35446",
    "Last Name": "Bennett",
    "First Name": "Alisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219600": {
    "id": "item_23455",
    "Last Name": "Prados",
    "First Name": "Kristian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219624": {
    "id": "item_23454",
    "Last Name": "Cobb",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219680": {
    "id": "item_24484",
    "Last Name": "D'Andrea",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219683": {
    "id": "item_23452",
    "Last Name": "Hodgson",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219763": {
    "id": "item_12060",
    "Last Name": "Conway",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219786": {
    "id": "item_23451",
    "Last Name": "Pokorski",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219823": {
    "id": "item_23450",
    "Last Name": "Stillman",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219848": {
    "id": "item_23447",
    "Last Name": "Francisco",
    "First Name": "Gianni",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37219914": {
    "id": "item_35786",
    "Last Name": "Murphy",
    "First Name": "Constance",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220011": {
    "id": "item_12057",
    "Last Name": "Sherriff",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220028": {
    "id": "item_23443",
    "Last Name": "Bhargava",
    "First Name": "Nishant",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220050": {
    "id": "item_10555",
    "Last Name": "Romero Kalifa",
    "First Name": "Diego Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220069": {
    "id": "item_12056",
    "Last Name": "Iordanou",
    "First Name": "Krystina",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220258": {
    "id": "item_10290",
    "Last Name": "Lewis",
    "First Name": "Baz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220265": {
    "id": "item_12053",
    "Last Name": "Meng",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220318": {
    "id": "item_12052",
    "Last Name": "Kieliszek",
    "First Name": "Dariusz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220387": {
    "id": "item_12051",
    "Last Name": "Matijevic",
    "First Name": "Darko",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220443": {
    "id": "item_23437",
    "Last Name": "Castellanos Ria–o",
    "First Name": "M—nica Viviana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220446": {
    "id": "item_23440",
    "Last Name": "Ke",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220458": {
    "id": "item_35436",
    "Last Name": "Rogers",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220490": {
    "id": "item_23435",
    "Last Name": "Bain",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220614": {
    "id": "item_23433",
    "Last Name": "Bonifant",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220652": {
    "id": "item_10286",
    "Last Name": "Rose",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220654": {
    "id": "item_23432",
    "Last Name": "Lysiuk",
    "First Name": "Alia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220845": {
    "id": "item_35430",
    "Last Name": "Giles",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220894": {
    "id": "item_12042",
    "Last Name": "Escobar Estrada",
    "First Name": "Rosa Angel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220908": {
    "id": "item_10279",
    "Last Name": "Barker",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37220981": {
    "id": "item_12041",
    "Last Name": "Steidler",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221066": {
    "id": "item_23425",
    "Last Name": "Smith",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221082": {
    "id": "item_35425",
    "Last Name": "Wang",
    "First Name": "Zitian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221083": {
    "id": "item_23423",
    "Last Name": "Robinson",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221100": {
    "id": "item_10276",
    "Last Name": "Osborne",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221141": {
    "id": "item_10275",
    "Last Name": "Reynolds",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221345": {
    "id": "item_10272",
    "Last Name": "Kuvin",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221352": {
    "id": "item_23419",
    "Last Name": "BELLOMI",
    "First Name": "Bernardo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221372": {
    "id": "item_12037",
    "Last Name": "Srivastava",
    "First Name": "Amit",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221582": {
    "id": "item_10269",
    "Last Name": "Simpson",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221606": {
    "id": "item_12035",
    "Last Name": "YAU",
    "First Name": "MAN CHING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221698": {
    "id": "item_10519",
    "Last Name": "Maya",
    "First Name": "Alvaro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221876": {
    "id": "item_10266",
    "Last Name": "MEINERS ZAMORA",
    "First Name": "HANS EMILIANO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221937": {
    "id": "item_10265",
    "Last Name": "Yamabe",
    "First Name": "Eiko",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37221943": {
    "id": "item_9774",
    "Last Name": "Bate",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222005": {
    "id": "item_35785",
    "Last Name": "Childers",
    "First Name": "Jay",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222020": {
    "id": "item_35419",
    "Last Name": "Rigby",
    "First Name": "Millie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222123": {
    "id": "item_35418",
    "Last Name": "Chang",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222157": {
    "id": "item_10264",
    "Last Name": "Cervantes Ilagor",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222170": {
    "id": "item_23411",
    "Last Name": "McDonald",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222217": {
    "id": "item_23407",
    "Last Name": "dobson",
    "First Name": "robin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222344": {
    "id": "item_10262",
    "Last Name": "Bailey",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222345": {
    "id": "item_12027",
    "Last Name": "Kim",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222352": {
    "id": "item_10261",
    "Last Name": "Russell",
    "First Name": "Julian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222398": {
    "id": "item_23404",
    "Last Name": "Scholer",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222496": {
    "id": "item_10259",
    "Last Name": "Johnson",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222683": {
    "id": "item_23395",
    "Last Name": "Rasmussen",
    "First Name": "Ed",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222684": {
    "id": "item_12023",
    "Last Name": "Boundy",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222719": {
    "id": "item_23393",
    "Last Name": "Hernandez Espinosa",
    "First Name": "Ofrey Etienne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222723": {
    "id": "item_23390",
    "Last Name": "Thinius",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222747": {
    "id": "item_10255",
    "Last Name": "Merdi",
    "First Name": "Teddy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222830": {
    "id": "item_35409",
    "Last Name": "Looney",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222859": {
    "id": "item_35407",
    "Last Name": "Wu",
    "First Name": "Kuang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222898": {
    "id": "item_23384",
    "Last Name": "Northey",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37222919": {
    "id": "item_23386",
    "Last Name": "Argaman",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223071": {
    "id": "item_23383",
    "Last Name": "Slattery",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223156": {
    "id": "item_23380",
    "Last Name": "Macklin",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223457": {
    "id": "item_23377",
    "Last Name": "WU",
    "First Name": "CHUN KIT CHRIS",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223466": {
    "id": "item_23376",
    "Last Name": "Cortes",
    "First Name": "Paulina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223573": {
    "id": "item_35398",
    "Last Name": "Walker",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223580": {
    "id": "item_10248",
    "Last Name": "Chan",
    "First Name": "Garrett",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223911": {
    "id": "item_10246",
    "Last Name": "Bornhoft",
    "First Name": "Glen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37223988": {
    "id": "item_12010",
    "Last Name": "Castagnaro",
    "First Name": "Hernan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224177": {
    "id": "item_12360",
    "Last Name": "Cossart",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224207": {
    "id": "item_35396",
    "Last Name": "Garcia Belmonte",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224522": {
    "id": "item_35394",
    "Last Name": "Petchalee",
    "First Name": "Anchalika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224647": {
    "id": "item_12007",
    "Last Name": "Clifton",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224690": {
    "id": "item_35392",
    "Last Name": "Linh",
    "First Name": "Doan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224699": {
    "id": "item_23367",
    "Last Name": "Parker",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224868": {
    "id": "item_23363",
    "Last Name": "Jain",
    "First Name": "Pulkit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224969": {
    "id": "item_23362",
    "Last Name": "Lundahl",
    "First Name": "Colette",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37224975": {
    "id": "item_35391",
    "Last Name": "Garg",
    "First Name": "Puja",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225153": {
    "id": "item_12359",
    "Last Name": "Sandoval",
    "First Name": "Jesus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225314": {
    "id": "item_12000",
    "Last Name": "Broome",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225319": {
    "id": "item_35388",
    "Last Name": "Yumul",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225752": {
    "id": "item_23355",
    "Last Name": "Williams",
    "First Name": "Derrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225783": {
    "id": "item_11997",
    "Last Name": "La-ab",
    "First Name": "Gloanne",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225891": {
    "id": "item_24894",
    "Last Name": "Fisher",
    "First Name": "Lukas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37225991": {
    "id": "item_23352",
    "Last Name": "Rodriguez",
    "First Name": "Juan Pablo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226220": {
    "id": "item_35377",
    "Last Name": "Johnson",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226356": {
    "id": "item_35376",
    "Last Name": "Douglas",
    "First Name": "Annabel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226746": {
    "id": "item_35374",
    "Last Name": "Tocharoen",
    "First Name": "Pannathorn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226762": {
    "id": "item_23349",
    "Last Name": "Schramm",
    "First Name": "Fabiana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37226780": {
    "id": "item_23348",
    "Last Name": "Horvat",
    "First Name": "Chandler",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227039": {
    "id": "item_23346",
    "Last Name": "Au",
    "First Name": "Jacky",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227062": {
    "id": "item_10230",
    "Last Name": "Uruchima",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227094": {
    "id": "item_35365",
    "Last Name": "Pribadi",
    "First Name": "Aldy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227288": {
    "id": "item_10228",
    "Last Name": "Serrano",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227384": {
    "id": "item_11989",
    "Last Name": "Chivas",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227388": {
    "id": "item_35358",
    "Last Name": "Rabaud",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227402": {
    "id": "item_35357",
    "Last Name": "KANE",
    "First Name": "SUZANNA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227553": {
    "id": "item_24474",
    "Last Name": "Gillett",
    "First Name": "Eva",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227580": {
    "id": "item_11986",
    "Last Name": "Dunster",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227616": {
    "id": "item_35354",
    "Last Name": "Kanagavelu",
    "First Name": "Gowrimanohar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227647": {
    "id": "item_11984",
    "Last Name": "Murphy",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37227733": {
    "id": "item_35352",
    "Last Name": "Reynolds",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228078": {
    "id": "item_11981",
    "Last Name": "Browne",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228347": {
    "id": "item_38257",
    "Last Name": "huang",
    "First Name": "siyuan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228349": {
    "id": "item_38261",
    "Last Name": "Robert",
    "First Name": "ELYAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228367": {
    "id": "item_38259",
    "Last Name": "Venugopalan",
    "First Name": "Shreevaishnavi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228391": {
    "id": "item_38256",
    "Last Name": "yan",
    "First Name": "dong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228563": {
    "id": "item_35345",
    "Last Name": "Islam",
    "First Name": "Abdul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228584": {
    "id": "item_23331",
    "Last Name": "McClelland",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228653": {
    "id": "item_10220",
    "Last Name": "Quesada Vargas",
    "First Name": "Victor Hugo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228674": {
    "id": "item_10219",
    "Last Name": "Cores",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228814": {
    "id": "item_9775",
    "Last Name": "Benson",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228834": {
    "id": "item_35341",
    "Last Name": "Scales",
    "First Name": "Kendall",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228855": {
    "id": "item_10218",
    "Last Name": "Boehme",
    "First Name": "Walter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228876": {
    "id": "item_11974",
    "Last Name": "Allan",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228893": {
    "id": "item_11971",
    "Last Name": "Abakumov",
    "First Name": "Stanislav",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37228972": {
    "id": "item_11969",
    "Last Name": "Schoeman",
    "First Name": "Riaan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229080": {
    "id": "item_38250",
    "Last Name": "Parker",
    "First Name": "Scarlett",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229099": {
    "id": "item_38249",
    "Last Name": "Leung",
    "First Name": "Wing Cheong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229167": {
    "id": "item_38247",
    "Last Name": "Yulianto",
    "First Name": "Eko",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229175": {
    "id": "item_35333",
    "Last Name": "Lowry",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229232": {
    "id": "item_37140",
    "Last Name": "Huet",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229418": {
    "id": "item_35331",
    "Last Name": "Sangsangatrakul",
    "First Name": "Nichapa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229421": {
    "id": "item_38245",
    "Last Name": "Senra",
    "First Name": "Miryam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229734": {
    "id": "item_10213",
    "Last Name": "Kays",
    "First Name": "Camblar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37229848": {
    "id": "item_23323",
    "Last Name": "Alexander Tardif",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230110": {
    "id": "item_10212",
    "Last Name": "McConnel",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230296": {
    "id": "item_24471",
    "Last Name": "Spencer",
    "First Name": "Rachaey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230309": {
    "id": "item_38237",
    "Last Name": "Stanley",
    "First Name": "Alec",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230500": {
    "id": "item_35328",
    "Last Name": "Pointon",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230513": {
    "id": "item_38235",
    "Last Name": "Hall",
    "First Name": "Damien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37230550": {
    "id": "item_38236",
    "Last Name": "Cunningham",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231027": {
    "id": "item_23320",
    "Last Name": "Jones",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231181": {
    "id": "item_11963",
    "Last Name": "Shoniker",
    "First Name": "Angela",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231200": {
    "id": "item_24470",
    "Last Name": "Sanchez ramirez",
    "First Name": "Enrique",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231248": {
    "id": "item_38232",
    "Last Name": "Kean Yau",
    "First Name": "Koh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231329": {
    "id": "item_35325",
    "Last Name": "Smith",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231399": {
    "id": "item_23318",
    "Last Name": "Foster",
    "First Name": "Graham",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231455": {
    "id": "item_38227",
    "Last Name": "Lim",
    "First Name": "Jarn Han",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231485": {
    "id": "item_35322",
    "Last Name": "SHIMONISHI",
    "First Name": "Masaru",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231559": {
    "id": "item_37141",
    "Last Name": "Jonovski",
    "First Name": "Jade-Lily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231577": {
    "id": "item_11958",
    "Last Name": "Wing Kit",
    "First Name": "Lam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231689": {
    "id": "item_10208",
    "Last Name": "Bailey",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231706": {
    "id": "item_23313",
    "Last Name": "Chee",
    "First Name": "Soo Siong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231843": {
    "id": "item_10206",
    "Last Name": "Murdoch",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37231900": {
    "id": "item_38221",
    "Last Name": "Chantriaux",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232020": {
    "id": "item_23311",
    "Last Name": "Blore",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232086": {
    "id": "item_38214",
    "Last Name": "Diaz",
    "First Name": "Don",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232216": {
    "id": "item_10200",
    "Last Name": "TONG",
    "First Name": "NINGPING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232239": {
    "id": "item_35314",
    "Last Name": "Ward",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232258": {
    "id": "item_35313",
    "Last Name": "Tylu_",
    "First Name": "Sylwia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232348": {
    "id": "item_23307",
    "Last Name": "O'Neill",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232386": {
    "id": "item_35311",
    "Last Name": "Harris",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232411": {
    "id": "item_38205",
    "Last Name": "LAMINATO",
    "First Name": "MARIDES",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232432": {
    "id": "item_38206",
    "Last Name": "Wills",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232469": {
    "id": "item_11947",
    "Last Name": "Hillman",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232489": {
    "id": "item_10199",
    "Last Name": "Yapp",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232629": {
    "id": "item_38201",
    "Last Name": "Chamnongkijphanich",
    "First Name": "Tanawat",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232688": {
    "id": "item_38198",
    "Last Name": "Manalo",
    "First Name": "Carla",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232707": {
    "id": "item_23298",
    "Last Name": "Berghofer",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232765": {
    "id": "item_23297",
    "Last Name": "Bell",
    "First Name": "Philippa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232797": {
    "id": "item_35303",
    "Last Name": "Barr",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232866": {
    "id": "item_11938",
    "Last Name": "Hauber",
    "First Name": "Toby",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37232977": {
    "id": "item_38187",
    "Last Name": "Young",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233051": {
    "id": "item_35298",
    "Last Name": "Cable",
    "First Name": "Navaal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233091": {
    "id": "item_38185",
    "Last Name": "Tasdemir",
    "First Name": "Fionna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233166": {
    "id": "item_11933",
    "Last Name": "Son",
    "First Name": "Wonmin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233278": {
    "id": "item_38177",
    "Last Name": "Farha",
    "First Name": "Mustapha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233330": {
    "id": "item_23292",
    "Last Name": "Moularadellis",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233416": {
    "id": "item_38171",
    "Last Name": "Hatten",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233441": {
    "id": "item_35784",
    "Last Name": "GREGORY",
    "First Name": "BURNICHON",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233450": {
    "id": "item_10189",
    "Last Name": "Martinez",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233454": {
    "id": "item_35292",
    "Last Name": "Piper",
    "First Name": "Sammy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233520": {
    "id": "item_10188",
    "Last Name": "Gray",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233571": {
    "id": "item_35289",
    "Last Name": "Chua",
    "First Name": "Hui Lin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233581": {
    "id": "item_38164",
    "Last Name": "Gee",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233592": {
    "id": "item_35290",
    "Last Name": "Osijo",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233642": {
    "id": "item_10187",
    "Last Name": "Tyndall",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233668": {
    "id": "item_38160",
    "Last Name": "Adlington",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233680": {
    "id": "item_23285",
    "Last Name": "Coulthard",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233691": {
    "id": "item_23284",
    "Last Name": "Sandrina",
    "First Name": "Ressy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233760": {
    "id": "item_10185",
    "Last Name": "Snowball",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233778": {
    "id": "item_23282",
    "Last Name": "Gentner",
    "First Name": "Constance",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233780": {
    "id": "item_23279",
    "Last Name": "Low",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233802": {
    "id": "item_23280",
    "Last Name": "Raisin",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233828": {
    "id": "item_11923",
    "Last Name": "Colbran",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233862": {
    "id": "item_38154",
    "Last Name": "Lee",
    "First Name": "Heeyoung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233869": {
    "id": "item_38151",
    "Last Name": "Sagade",
    "First Name": "Nitesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233874": {
    "id": "item_35283",
    "Last Name": "Wallace",
    "First Name": "Harry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233896": {
    "id": "item_23276",
    "Last Name": "Davies",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233922": {
    "id": "item_10182",
    "Last Name": "Winkelmolen",
    "First Name": "Remo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233933": {
    "id": "item_23274",
    "Last Name": "Lubbe",
    "First Name": "Sue",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233954": {
    "id": "item_35280",
    "Last Name": "Capra",
    "First Name": "Jess",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233961": {
    "id": "item_10181",
    "Last Name": "Hackney",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37233991": {
    "id": "item_38148",
    "Last Name": "ospina matiz",
    "First Name": "vanessa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234002": {
    "id": "item_23273",
    "Last Name": "Handley",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234012": {
    "id": "item_11919",
    "Last Name": "Pountney",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234045": {
    "id": "item_38144",
    "Last Name": "Gerea",
    "First Name": "Carmen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234061": {
    "id": "item_38143",
    "Last Name": "Tsang",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234064": {
    "id": "item_24893",
    "Last Name": "Jones",
    "First Name": "Kenrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234068": {
    "id": "item_23271",
    "Last Name": "Feltrin",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234105": {
    "id": "item_38140",
    "Last Name": "Ibarra Ballesteros",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234133": {
    "id": "item_38138",
    "Last Name": "Howlett",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234172": {
    "id": "item_11915",
    "Last Name": "Hillerby",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234225": {
    "id": "item_23268",
    "Last Name": "Thompson",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234230": {
    "id": "item_35273",
    "Last Name": "Garcia",
    "First Name": "Jo‹o",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234240": {
    "id": "item_11914",
    "Last Name": "Bulacz",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234250": {
    "id": "item_38135",
    "Last Name": "Sudharta",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234275": {
    "id": "item_10176",
    "Last Name": "Tuck",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234287": {
    "id": "item_10175",
    "Last Name": "Pizer",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234338": {
    "id": "item_38131",
    "Last Name": "Robinson",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234374": {
    "id": "item_11913",
    "Last Name": "Park",
    "First Name": "Inho",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234420": {
    "id": "item_23262",
    "Last Name": "O'Donnell",
    "First Name": "Arianna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234460": {
    "id": "item_38124",
    "Last Name": "Galvin",
    "First Name": "Kristian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234489": {
    "id": "item_38122",
    "Last Name": "Chee",
    "First Name": "Ronan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234598": {
    "id": "item_35269",
    "Last Name": "Kenny",
    "First Name": "Kieron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234620": {
    "id": "item_9776",
    "Last Name": "Mountford",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234630": {
    "id": "item_10172",
    "Last Name": "Ryan",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234645": {
    "id": "item_11911",
    "Last Name": "Villeza",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234655": {
    "id": "item_38117",
    "Last Name": "Ross",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234708": {
    "id": "item_34873",
    "Last Name": "White",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234776": {
    "id": "item_23260",
    "Last Name": "shan",
    "First Name": "daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234791": {
    "id": "item_35267",
    "Last Name": "Ackland",
    "First Name": "Raychele",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234808": {
    "id": "item_10170",
    "Last Name": "Wright",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37234886": {
    "id": "item_23254",
    "Last Name": "Gilbert",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235147": {
    "id": "item_38104",
    "Last Name": "Goh",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235170": {
    "id": "item_35263",
    "Last Name": "Hixson",
    "First Name": "Casey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235345": {
    "id": "item_38101",
    "Last Name": "Lorian",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235352": {
    "id": "item_10168",
    "Last Name": "WANG",
    "First Name": "XIAO LI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235419": {
    "id": "item_11907",
    "Last Name": "Peirano",
    "First Name": "Marcelo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235420": {
    "id": "item_38099",
    "Last Name": "Penales",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235445": {
    "id": "item_35259",
    "Last Name": "Ranford",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235485": {
    "id": "item_38095",
    "Last Name": "Lenkel",
    "First Name": "Laurie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235590": {
    "id": "item_38094",
    "Last Name": "Cho",
    "First Name": "Junga",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37235888": {
    "id": "item_23242",
    "Last Name": "Churchill",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236143": {
    "id": "item_10165",
    "Last Name": "Hern‡ndez",
    "First Name": "FŽlix",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236159": {
    "id": "item_35252",
    "Last Name": "Tjandra",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236182": {
    "id": "item_10163",
    "Last Name": "Aarland",
    "First Name": "Nikolas Jon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236193": {
    "id": "item_23239",
    "Last Name": "Naniko",
    "First Name": "Erryn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236201": {
    "id": "item_38086",
    "Last Name": "Cheng",
    "First Name": "Kin Chung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236214": {
    "id": "item_38087",
    "Last Name": "Onorato",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236308": {
    "id": "item_38083",
    "Last Name": "Berryman",
    "First Name": "Bryeanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236449": {
    "id": "item_23234",
    "Last Name": "Pritchard",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236493": {
    "id": "item_37144",
    "Last Name": "Fukase",
    "First Name": "Emiko",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236504": {
    "id": "item_10161",
    "Last Name": "Roache",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236512": {
    "id": "item_38080",
    "Last Name": "Yamanoi",
    "First Name": "Tamiko",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236526": {
    "id": "item_23233",
    "Last Name": "Thomas",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236585": {
    "id": "item_23232",
    "Last Name": "Rhee",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236637": {
    "id": "item_35247",
    "Last Name": "Barron",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236641": {
    "id": "item_35246",
    "Last Name": "Froese",
    "First Name": "Tawnya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236701": {
    "id": "item_35245",
    "Last Name": "Lau",
    "First Name": "Chi Kwong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236790": {
    "id": "item_10158",
    "Last Name": "Colon",
    "First Name": "Jean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236847": {
    "id": "item_35244",
    "Last Name": "MOHD NOOR",
    "First Name": "MUHAMMAD ZARQALI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236853": {
    "id": "item_38079",
    "Last Name": "Rivers",
    "First Name": "Tommi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37236926": {
    "id": "item_35243",
    "Last Name": "Amezcua",
    "First Name": "Esteban",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37237062": {
    "id": "item_10157",
    "Last Name": "rosenberg",
    "First Name": "drew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239365": {
    "id": "item_10155",
    "Last Name": "Straker",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239388": {
    "id": "item_23225",
    "Last Name": "Kocourek Rodriguez",
    "First Name": "Marina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239393": {
    "id": "item_23226",
    "Last Name": "Davies",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239478": {
    "id": "item_38068",
    "Last Name": "Ko",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239513": {
    "id": "item_35235",
    "Last Name": "Dupont",
    "First Name": "Shane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239853": {
    "id": "item_38067",
    "Last Name": "Mas Gaslac",
    "First Name": "Herberth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37239925": {
    "id": "item_10154",
    "Last Name": "Videbaek",
    "First Name": "Mikkel Dreyer",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240181": {
    "id": "item_24460",
    "Last Name": "Kaur",
    "First Name": "Gurpreet",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240215": {
    "id": "item_35232",
    "Last Name": "Wingate",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240511": {
    "id": "item_38064",
    "Last Name": "ER",
    "First Name": "YAN XIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240534": {
    "id": "item_23219",
    "Last Name": "Law",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240634": {
    "id": "item_38062",
    "Last Name": "Espiritu",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37240834": {
    "id": "item_35230",
    "Last Name": "Lin",
    "First Name": "Yutang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241291": {
    "id": "item_10151",
    "Last Name": "Pinder",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241718": {
    "id": "item_10147",
    "Last Name": "Corona De La Cruz",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241758": {
    "id": "item_10146",
    "Last Name": "Espinoza",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37241872": {
    "id": "item_11894",
    "Last Name": "Pilih",
    "First Name": "Tomaz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242025": {
    "id": "item_38054",
    "Last Name": "Doyna",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242332": {
    "id": "item_35227",
    "Last Name": "Dawson",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242466": {
    "id": "item_11892",
    "Last Name": "Isles",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242499": {
    "id": "item_38047",
    "Last Name": "Jenkins",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242540": {
    "id": "item_38046",
    "Last Name": "Abad",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242615": {
    "id": "item_10143",
    "Last Name": "Niewoudt",
    "First Name": "Whaddon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242760": {
    "id": "item_38044",
    "Last Name": "Sutedja",
    "First Name": "Steve",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242884": {
    "id": "item_24892",
    "Last Name": "Contreras",
    "First Name": "Augusto",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37242975": {
    "id": "item_10142",
    "Last Name": "Canavan",
    "First Name": "Eamon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243380": {
    "id": "item_35225",
    "Last Name": "Sochacka",
    "First Name": "Zuzanna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243542": {
    "id": "item_24827",
    "Last Name": "Claereboudt",
    "First Name": "Jan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243642": {
    "id": "item_35224",
    "Last Name": "Montero",
    "First Name": "Gerardo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243681": {
    "id": "item_23209",
    "Last Name": "Britter",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243914": {
    "id": "item_23206",
    "Last Name": "Margenberg",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37243975": {
    "id": "item_38040",
    "Last Name": "Doyle",
    "First Name": "Elena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244057": {
    "id": "item_23204",
    "Last Name": "Popiel",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244069": {
    "id": "item_38036",
    "Last Name": "McNamara",
    "First Name": "Dave",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244136": {
    "id": "item_11888",
    "Last Name": "Labudda",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244275": {
    "id": "item_11889",
    "Last Name": "Milverton",
    "First Name": "Zac",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244747": {
    "id": "item_23200",
    "Last Name": "Fedorchuk",
    "First Name": "Vera",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37244879": {
    "id": "item_38028",
    "Last Name": "Bateman",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245021": {
    "id": "item_38027",
    "Last Name": "Fackenthal",
    "First Name": "Ayako",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245032": {
    "id": "item_23198",
    "Last Name": "Joe",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245149": {
    "id": "item_9777",
    "Last Name": "Caughlan",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245158": {
    "id": "item_23194",
    "Last Name": "Keis",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245255": {
    "id": "item_35215",
    "Last Name": "Noble",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245637": {
    "id": "item_38020",
    "Last Name": "Due–as Zu–iga",
    "First Name": "Ana Lidia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245647": {
    "id": "item_38019",
    "Last Name": "Knott",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245769": {
    "id": "item_38016",
    "Last Name": "McLaws",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245831": {
    "id": "item_35209",
    "Last Name": "Petzer",
    "First Name": "Septimus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245881": {
    "id": "item_12358",
    "Last Name": "Gomez Noyola",
    "First Name": "Jesus Adan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245956": {
    "id": "item_38014",
    "Last Name": "Smith",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37245976": {
    "id": "item_35206",
    "Last Name": "Ramagaga",
    "First Name": "Max",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246056": {
    "id": "item_10132",
    "Last Name": "Trutwin",
    "First Name": "Paddy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246111": {
    "id": "item_23504",
    "Last Name": "MORALES",
    "First Name": "NANCY",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246271": {
    "id": "item_35205",
    "Last Name": "Dhakal",
    "First Name": "Lalit",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246439": {
    "id": "item_38010",
    "Last Name": "Lane",
    "First Name": "Vicki",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246534": {
    "id": "item_23183",
    "Last Name": "O'Neill",
    "First Name": "Ronan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246568": {
    "id": "item_38006",
    "Last Name": "Sutcliffe",
    "First Name": "Neil",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246631": {
    "id": "item_38005",
    "Last Name": "Wilkins",
    "First Name": "Michele",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246674": {
    "id": "item_35200",
    "Last Name": "Davis",
    "First Name": "Shalisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246694": {
    "id": "item_11876",
    "Last Name": "Guzzi",
    "First Name": "Francesco",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246759": {
    "id": "item_24456",
    "Last Name": "Pellascini",
    "First Name": "Yaneyra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246774": {
    "id": "item_23180",
    "Last Name": "Carberry",
    "First Name": "Hae",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37246871": {
    "id": "item_37997",
    "Last Name": "Callahan",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247074": {
    "id": "item_10126",
    "Last Name": "Gerrard",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247405": {
    "id": "item_10125",
    "Last Name": "Seit",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247409": {
    "id": "item_37989",
    "Last Name": "Clarke",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247718": {
    "id": "item_23173",
    "Last Name": "Kostadinovski",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247797": {
    "id": "item_11868",
    "Last Name": "Christie",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247842": {
    "id": "item_35196",
    "Last Name": "Borg",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37247866": {
    "id": "item_35194",
    "Last Name": "Cook",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248071": {
    "id": "item_11865",
    "Last Name": "Lancaster",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248422": {
    "id": "item_11863",
    "Last Name": "stavrevski",
    "First Name": "jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248669": {
    "id": "item_37981",
    "Last Name": "Erlandsen",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248924": {
    "id": "item_23164",
    "Last Name": "Tong",
    "First Name": "Ho kai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37248949": {
    "id": "item_11859",
    "Last Name": "Graham",
    "First Name": "Jacqui",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251042": {
    "id": "item_11858",
    "Last Name": "Laparidis",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251144": {
    "id": "item_35185",
    "Last Name": "Dmytrenko",
    "First Name": "Russell",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251224": {
    "id": "item_35783",
    "Last Name": "Utama",
    "First Name": "Abdi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251268": {
    "id": "item_11857",
    "Last Name": "Bernstein",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251492": {
    "id": "item_35182",
    "Last Name": "Gomez",
    "First Name": "Julian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251509": {
    "id": "item_10114",
    "Last Name": "Garcia",
    "First Name": "Misael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251570": {
    "id": "item_11856",
    "Last Name": "Mergen",
    "First Name": "Bayanjargal",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251644": {
    "id": "item_10112",
    "Last Name": "Courgenay",
    "First Name": "Adele",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251857": {
    "id": "item_10111",
    "Last Name": "Nelson",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37251978": {
    "id": "item_23157",
    "Last Name": "Dunbar",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252417": {
    "id": "item_10106",
    "Last Name": "Wang",
    "First Name": "Cong Ci",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252475": {
    "id": "item_37949",
    "Last Name": "Siganto",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252540": {
    "id": "item_37951",
    "Last Name": "Mathersul",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252552": {
    "id": "item_35174",
    "Last Name": "Au",
    "First Name": "Hin Ching Cherry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252700": {
    "id": "item_23151",
    "Last Name": "Brooks",
    "First Name": "Lance",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252828": {
    "id": "item_10104",
    "Last Name": "Zepeda Sotomora",
    "First Name": "Alvaro Enrique",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37252990": {
    "id": "item_10102",
    "Last Name": "Collins",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253002": {
    "id": "item_35171",
    "Last Name": "Cunningham",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253058": {
    "id": "item_35170",
    "Last Name": "Graham",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253149": {
    "id": "item_37944",
    "Last Name": "Wong",
    "First Name": "Yi Tak Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253184": {
    "id": "item_37941",
    "Last Name": "Chan",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253340": {
    "id": "item_37939",
    "Last Name": "Sims",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253371": {
    "id": "item_37940",
    "Last Name": "Bhagwat",
    "First Name": "Kunal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253640": {
    "id": "item_23145",
    "Last Name": "Clifford",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253668": {
    "id": "item_11845",
    "Last Name": "Evans",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253851": {
    "id": "item_37932",
    "Last Name": "Martin",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253897": {
    "id": "item_10096",
    "Last Name": "Natoli",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37253924": {
    "id": "item_23143",
    "Last Name": "Angus",
    "First Name": "Elise",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254006": {
    "id": "item_35164",
    "Last Name": "Cazanis",
    "First Name": "Aly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254095": {
    "id": "item_10094",
    "Last Name": "Li",
    "First Name": "Wai Cheong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254096": {
    "id": "item_37929",
    "Last Name": "Tantra Maulana",
    "First Name": "Mohamad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254173": {
    "id": "item_10093",
    "Last Name": "Anderson",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254212": {
    "id": "item_10091",
    "Last Name": "Casey",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254282": {
    "id": "item_11840",
    "Last Name": "HARDWICKE",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254677": {
    "id": "item_23141",
    "Last Name": "McLean",
    "First Name": "Joe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254720": {
    "id": "item_37923",
    "Last Name": "Roberts",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254723": {
    "id": "item_37922",
    "Last Name": "Saluja",
    "First Name": "Raj-Rani",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254776": {
    "id": "item_10089",
    "Last Name": "Solovyev",
    "First Name": "Yury",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254779": {
    "id": "item_12323",
    "Last Name": "kim",
    "First Name": "younghwan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37254976": {
    "id": "item_37916",
    "Last Name": "Hennessy",
    "First Name": "Meghan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255060": {
    "id": "item_23132",
    "Last Name": "Toh",
    "First Name": "Eric Tze Chung",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255066": {
    "id": "item_37913",
    "Last Name": "Rane",
    "First Name": "Shreya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255131": {
    "id": "item_10086",
    "Last Name": "Vowles",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255137": {
    "id": "item_11837",
    "Last Name": "Zygadlo",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255165": {
    "id": "item_37909",
    "Last Name": "Ma",
    "First Name": "Wenjing",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255496": {
    "id": "item_23130",
    "Last Name": "Sahingoez",
    "First Name": "Murat",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255527": {
    "id": "item_37907",
    "Last Name": "Vu",
    "First Name": "Gia-Anh-Minh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255831": {
    "id": "item_35142",
    "Last Name": "Smith",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255898": {
    "id": "item_37905",
    "Last Name": "Jardine",
    "First Name": "Darrell",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37255987": {
    "id": "item_37904",
    "Last Name": "Burbridge",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256032": {
    "id": "item_35140",
    "Last Name": "Ton",
    "First Name": "Vandol",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256360": {
    "id": "item_35136",
    "Last Name": "Palma Jr",
    "First Name": "Danilo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256397": {
    "id": "item_11830",
    "Last Name": "KIM",
    "First Name": "YOOJIN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256418": {
    "id": "item_23123",
    "Last Name": "TEH",
    "First Name": "RONG KANG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256603": {
    "id": "item_37897",
    "Last Name": "Noonan",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256606": {
    "id": "item_35134",
    "Last Name": "Scarce",
    "First Name": "Libby",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256829": {
    "id": "item_37895",
    "Last Name": "Sarenac",
    "First Name": "Jelena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37256857": {
    "id": "item_37896",
    "Last Name": "Pal",
    "First Name": "Auvik",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257087": {
    "id": "item_37891",
    "Last Name": "Krenk",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257100": {
    "id": "item_23119",
    "Last Name": "Buckley",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257163": {
    "id": "item_37887",
    "Last Name": "Concepcion",
    "First Name": "Sofia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257187": {
    "id": "item_23116",
    "Last Name": "Pitek",
    "First Name": "Tomasz",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257198": {
    "id": "item_37885",
    "Last Name": "Barns",
    "First Name": "Susie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257231": {
    "id": "item_35782",
    "Last Name": "Denner",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257236": {
    "id": "item_37882",
    "Last Name": "Boekema",
    "First Name": "Berber",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257247": {
    "id": "item_35129",
    "Last Name": "O'Shaughnessy",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257271": {
    "id": "item_23115",
    "Last Name": "Delemer",
    "First Name": "Anne-Sophie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257307": {
    "id": "item_37880",
    "Last Name": "Liu",
    "First Name": "Melinda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257332": {
    "id": "item_10074",
    "Last Name": "Davis",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257374": {
    "id": "item_23112",
    "Last Name": "Zbyshko",
    "First Name": "Igor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257439": {
    "id": "item_23110",
    "Last Name": "Ladrido",
    "First Name": "Ernesto Lorenzo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257496": {
    "id": "item_37877",
    "Last Name": "Penson",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257531": {
    "id": "item_23107",
    "Last Name": "Robertson",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257605": {
    "id": "item_37876",
    "Last Name": "Kendall",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257814": {
    "id": "item_11822",
    "Last Name": "Chen",
    "First Name": "Xu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257866": {
    "id": "item_23104",
    "Last Name": "Pitek",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37257959": {
    "id": "item_37872",
    "Last Name": "Thomas",
    "First Name": "Micheal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258008": {
    "id": "item_37869",
    "Last Name": "Thompson",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258038": {
    "id": "item_11820",
    "Last Name": "Creak",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258107": {
    "id": "item_37868",
    "Last Name": "Waddington",
    "First Name": "Gordon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258111": {
    "id": "item_10068",
    "Last Name": "Kwong",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258134": {
    "id": "item_35124",
    "Last Name": "Case",
    "First Name": "Miriam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258163": {
    "id": "item_37866",
    "Last Name": "Leong",
    "First Name": "Ivy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258185": {
    "id": "item_35121",
    "Last Name": "Woods",
    "First Name": "Sal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258225": {
    "id": "item_37864",
    "Last Name": "Sehgal",
    "First Name": "Anchal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258276": {
    "id": "item_35119",
    "Last Name": "Arnott",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258289": {
    "id": "item_11814",
    "Last Name": "Lange",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258316": {
    "id": "item_11813",
    "Last Name": "Zhao",
    "First Name": "Wenbo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258340": {
    "id": "item_35117",
    "Last Name": "Sudol",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258403": {
    "id": "item_24201",
    "Last Name": "Samuelsson",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258432": {
    "id": "item_23098",
    "Last Name": "Connor",
    "First Name": "Georgie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258433": {
    "id": "item_37862",
    "Last Name": "Murphy",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258454": {
    "id": "item_23096",
    "Last Name": "Fiaschi",
    "First Name": "Elodie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258548": {
    "id": "item_37861",
    "Last Name": "Nguyen",
    "First Name": "Van Loc",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258549": {
    "id": "item_23095",
    "Last Name": "Blackmore",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258580": {
    "id": "item_11812",
    "Last Name": "lam",
    "First Name": "ken",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258709": {
    "id": "item_37854",
    "Last Name": "Santos",
    "First Name": "Angelica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258755": {
    "id": "item_23094",
    "Last Name": "Tafur",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37258987": {
    "id": "item_37849",
    "Last Name": "Rienecker",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259480": {
    "id": "item_35105",
    "Last Name": "Bird",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259560": {
    "id": "item_10060",
    "Last Name": "Zharov",
    "First Name": "Dmitrii",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37259682": {
    "id": "item_11809",
    "Last Name": "Borges Merheb",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260032": {
    "id": "item_37842",
    "Last Name": "Perez-Castillo",
    "First Name": "Billy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260157": {
    "id": "item_10053",
    "Last Name": "Lee",
    "First Name": "Jung Hyub",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260372": {
    "id": "item_23084",
    "Last Name": "CHENG",
    "First Name": "Michael Godwin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260513": {
    "id": "item_37838",
    "Last Name": "Ballantyne",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260830": {
    "id": "item_12322",
    "Last Name": "Ley",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37260886": {
    "id": "item_11807",
    "Last Name": "Vargas",
    "First Name": "Johan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261203": {
    "id": "item_23081",
    "Last Name": "Gohar",
    "First Name": "Jazib",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37261714": {
    "id": "item_23075",
    "Last Name": "Rising",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37267903": {
    "id": "item_10046",
    "Last Name": "Padusinski",
    "First Name": "Pawel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37268852": {
    "id": "item_37830",
    "Last Name": "Ji",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37268954": {
    "id": "item_11801",
    "Last Name": "Sanchez Rosales",
    "First Name": "Miranda",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37269758": {
    "id": "item_35093",
    "Last Name": "Begum",
    "First Name": "Syeda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37273415": {
    "id": "item_37828",
    "Last Name": "Nguyen",
    "First Name": "Ba Tuyen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37273884": {
    "id": "item_23072",
    "Last Name": "Gallon",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37274855": {
    "id": "item_37825",
    "Last Name": "Jones",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37275373": {
    "id": "item_23071",
    "Last Name": "Suazo",
    "First Name": "Manny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37275390": {
    "id": "item_35781",
    "Last Name": "Crews",
    "First Name": "Kathy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37278245": {
    "id": "item_35089",
    "Last Name": "Lee",
    "First Name": "Karla",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37281005": {
    "id": "item_35088",
    "Last Name": "HO",
    "First Name": "LEE HONG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37284997": {
    "id": "item_10044",
    "Last Name": "Kostyuk",
    "First Name": "Oleg",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37285018": {
    "id": "item_35087",
    "Last Name": "Williams",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287117": {
    "id": "item_35086",
    "Last Name": "Taylor",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287231": {
    "id": "item_35085",
    "Last Name": "Morrell",
    "First Name": "Amber",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287236": {
    "id": "item_12357",
    "Last Name": "Stierankova",
    "First Name": "Terezia",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287433": {
    "id": "item_11797",
    "Last Name": "Morales Elizondo",
    "First Name": "Jose Adrian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287441": {
    "id": "item_11798",
    "Last Name": "Wu",
    "First Name": "Austin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287522": {
    "id": "item_23062",
    "Last Name": "Nevill",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287864": {
    "id": "item_24444",
    "Last Name": "venkataramanappa",
    "First Name": "lokesh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287877": {
    "id": "item_23059",
    "Last Name": "espoz",
    "First Name": "mario",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287890": {
    "id": "item_11794",
    "Last Name": "Corner",
    "First Name": "Harvey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287939": {
    "id": "item_37819",
    "Last Name": "Famularo",
    "First Name": "Teona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37287982": {
    "id": "item_10042",
    "Last Name": "Salazar Rodr’guez",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288149": {
    "id": "item_23057",
    "Last Name": "Teter",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288195": {
    "id": "item_23058",
    "Last Name": "Heiner",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288342": {
    "id": "item_35082",
    "Last Name": "Evans",
    "First Name": "Clark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288362": {
    "id": "item_37814",
    "Last Name": "Fisher",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288549": {
    "id": "item_23054",
    "Last Name": "Maitland",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288552": {
    "id": "item_23052",
    "Last Name": "Morris",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288553": {
    "id": "item_35080",
    "Last Name": "Hu",
    "First Name": "Jun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288654": {
    "id": "item_37811",
    "Last Name": "Hong",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288658": {
    "id": "item_37810",
    "Last Name": "Morozumi",
    "First Name": "Yuka",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288673": {
    "id": "item_23050",
    "Last Name": "Kondritz",
    "First Name": "Madeline",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288821": {
    "id": "item_11789",
    "Last Name": "Hicken",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37288926": {
    "id": "item_24443",
    "Last Name": "Mesinas",
    "First Name": "Mariana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289132": {
    "id": "item_37801",
    "Last Name": "Yepez",
    "First Name": "Jose",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289256": {
    "id": "item_23047",
    "Last Name": "Livingston",
    "First Name": "Lenore",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289424": {
    "id": "item_24442",
    "Last Name": "Inns",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289512": {
    "id": "item_10038",
    "Last Name": "Rayward-Smith",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289607": {
    "id": "item_23046",
    "Last Name": "Usendiah",
    "First Name": "Ewelina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289677": {
    "id": "item_37795",
    "Last Name": "Mejia",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289725": {
    "id": "item_35071",
    "Last Name": "Kohakura",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289749": {
    "id": "item_23044",
    "Last Name": "Criswell",
    "First Name": "Liza",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289760": {
    "id": "item_35070",
    "Last Name": "Hendrix",
    "First Name": "Eline",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289826": {
    "id": "item_35069",
    "Last Name": "Palacios",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289833": {
    "id": "item_35739",
    "Last Name": "Klein",
    "First Name": "Desmond",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37289933": {
    "id": "item_35068",
    "Last Name": "Wickenden",
    "First Name": "Kerri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290136": {
    "id": "item_35067",
    "Last Name": "Sweeney",
    "First Name": "Mary-Kate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290195": {
    "id": "item_37790",
    "Last Name": "Sissel",
    "First Name": "Abigail",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290202": {
    "id": "item_23040",
    "Last Name": "Joyce",
    "First Name": "Milly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290299": {
    "id": "item_10554",
    "Last Name": "Louden",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290301": {
    "id": "item_24440",
    "Last Name": "Marin Garcia",
    "First Name": "Mario Eduardo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290329": {
    "id": "item_11781",
    "Last Name": "Gamble",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290337": {
    "id": "item_24891",
    "Last Name": "Lam",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290339": {
    "id": "item_10034",
    "Last Name": "Lee",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290470": {
    "id": "item_23038",
    "Last Name": "Lobosco",
    "First Name": "Justine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290550": {
    "id": "item_10032",
    "Last Name": "YODER",
    "First Name": "JOHN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290589": {
    "id": "item_37785",
    "Last Name": "Mahon",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290655": {
    "id": "item_37783",
    "Last Name": "Silva",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290754": {
    "id": "item_11779",
    "Last Name": "Stewart",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290808": {
    "id": "item_23036",
    "Last Name": "Gellert",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290859": {
    "id": "item_35061",
    "Last Name": "Umana",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37290883": {
    "id": "item_37781",
    "Last Name": "Choy",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291013": {
    "id": "item_23034",
    "Last Name": "Hua",
    "First Name": "Linh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291055": {
    "id": "item_37780",
    "Last Name": "Kovvuri",
    "First Name": "Sahiti",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291156": {
    "id": "item_12356",
    "Last Name": "Seet",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291198": {
    "id": "item_10030",
    "Last Name": "VELAZQUEZ",
    "First Name": "AXEL",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291253": {
    "id": "item_24890",
    "Last Name": "O'Hare",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291427": {
    "id": "item_23030",
    "Last Name": "Guido",
    "First Name": "Johanna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291444": {
    "id": "item_35056",
    "Last Name": "Whiteman",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291669": {
    "id": "item_35054",
    "Last Name": "Perkins",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291682": {
    "id": "item_23503",
    "Last Name": "Moretti",
    "First Name": "Marco",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291705": {
    "id": "item_10026",
    "Last Name": "Prushynskyy",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291846": {
    "id": "item_37776",
    "Last Name": "Gonnet",
    "First Name": "Julien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291850": {
    "id": "item_10024",
    "Last Name": "LaCoursiere",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291894": {
    "id": "item_11778",
    "Last Name": "Symotiuk",
    "First Name": "Viktor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291913": {
    "id": "item_23027",
    "Last Name": "Chan",
    "First Name": "Hing Yuet Joe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37291943": {
    "id": "item_35050",
    "Last Name": "Redgment",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292019": {
    "id": "item_11777",
    "Last Name": "Benkevych",
    "First Name": "Yuriy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292032": {
    "id": "item_23024",
    "Last Name": "Ni",
    "First Name": "Ruicong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292126": {
    "id": "item_23023",
    "Last Name": "Johnson",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292163": {
    "id": "item_23021",
    "Last Name": "clift",
    "First Name": "ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292226": {
    "id": "item_35049",
    "Last Name": "Axt Conaghan",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292422": {
    "id": "item_37769",
    "Last Name": "Jaros",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292466": {
    "id": "item_37765",
    "Last Name": "Perez",
    "First Name": "Maria Michaelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292473": {
    "id": "item_10022",
    "Last Name": "Melville",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292513": {
    "id": "item_23018",
    "Last Name": "Hoet",
    "First Name": "Greet",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292563": {
    "id": "item_37764",
    "Last Name": "Xi",
    "First Name": "Yeafan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292576": {
    "id": "item_37145",
    "Last Name": "Ahn",
    "First Name": "Harry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292614": {
    "id": "item_9778",
    "Last Name": "Meireles",
    "First Name": "Marcio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292645": {
    "id": "item_11776",
    "Last Name": "Nykke",
    "First Name": "Austin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292734": {
    "id": "item_11775",
    "Last Name": "Ellis",
    "First Name": "Kane",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292748": {
    "id": "item_24826",
    "Last Name": "Kim",
    "First Name": "Insik",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292786": {
    "id": "item_35042",
    "Last Name": "Wahyuni",
    "First Name": "Eny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292867": {
    "id": "item_11774",
    "Last Name": "Maya",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37292982": {
    "id": "item_37758",
    "Last Name": "Zhao",
    "First Name": "Shengli",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293013": {
    "id": "item_35041",
    "Last Name": "Sexton",
    "First Name": "Shelby",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293063": {
    "id": "item_37757",
    "Last Name": "jiao",
    "First Name": "Fuxing",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293107": {
    "id": "item_24889",
    "Last Name": "BORROS",
    "First Name": "YANIV",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293269": {
    "id": "item_35039",
    "Last Name": "Martinez",
    "First Name": "Juana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293543": {
    "id": "item_35037",
    "Last Name": "Ratz",
    "First Name": "Shelsea",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293594": {
    "id": "item_37753",
    "Last Name": "Lyle",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293623": {
    "id": "item_24887",
    "Last Name": "Jose",
    "First Name": "Ania",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293773": {
    "id": "item_35035",
    "Last Name": "Brennan",
    "First Name": "Magdalena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293809": {
    "id": "item_37750",
    "Last Name": "Bacon",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293903": {
    "id": "item_24888",
    "Last Name": "Zia",
    "First Name": "Ammar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293910": {
    "id": "item_37749",
    "Last Name": "Da Rui",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37293921": {
    "id": "item_37748",
    "Last Name": "Schubert",
    "First Name": "Joerg",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294038": {
    "id": "item_10017",
    "Last Name": "Carn",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294043": {
    "id": "item_37746",
    "Last Name": "Carroll",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294048": {
    "id": "item_35033",
    "Last Name": "Patton",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294078": {
    "id": "item_35031",
    "Last Name": "Redden",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294083": {
    "id": "item_37744",
    "Last Name": "Pelzer",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294282": {
    "id": "item_35030",
    "Last Name": "Ugaz",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294334": {
    "id": "item_10014",
    "Last Name": "Koike",
    "First Name": "Soshi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294343": {
    "id": "item_35029",
    "Last Name": "Beaton",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294399": {
    "id": "item_11771",
    "Last Name": "DeSoto",
    "First Name": "Jared",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294553": {
    "id": "item_37739",
    "Last Name": "Puarr",
    "First Name": "Harneet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294660": {
    "id": "item_10010",
    "Last Name": "Borja",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37294870": {
    "id": "item_37733",
    "Last Name": "Kitsanayothin",
    "First Name": "Pongpat",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295216": {
    "id": "item_35025",
    "Last Name": "LI",
    "First Name": "CHAO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295256": {
    "id": "item_10007",
    "Last Name": "Lu",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295378": {
    "id": "item_10006",
    "Last Name": "Moore",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295443": {
    "id": "item_11766",
    "Last Name": "Sikma",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295452": {
    "id": "item_35021",
    "Last Name": "Takacs",
    "First Name": "Keira",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295464": {
    "id": "item_37727",
    "Last Name": "CHEN",
    "First Name": "SHIAWTIAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295510": {
    "id": "item_10005",
    "Last Name": "LEE",
    "First Name": "SOONSIL",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295558": {
    "id": "item_37726",
    "Last Name": "Trend",
    "First Name": "Kaija",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295639": {
    "id": "item_10553",
    "Last Name": "Brown",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295652": {
    "id": "item_10004",
    "Last Name": "Achatz",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295953": {
    "id": "item_37719",
    "Last Name": "Rivera",
    "First Name": "Ramon III",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37295974": {
    "id": "item_35017",
    "Last Name": "Mitchell",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296118": {
    "id": "item_37715",
    "Last Name": "KUMAR",
    "First Name": "BRIJESH NAVENDRA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296130": {
    "id": "item_37716",
    "Last Name": "Buist",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296221": {
    "id": "item_10003",
    "Last Name": "Woods",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296288": {
    "id": "item_11761",
    "Last Name": "Lee",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296303": {
    "id": "item_35014",
    "Last Name": "Rellata",
    "First Name": "Russ",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296332": {
    "id": "item_37713",
    "Last Name": "SU",
    "First Name": "YEN HAO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296428": {
    "id": "item_37712",
    "Last Name": "Burrell",
    "First Name": "Alan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296554": {
    "id": "item_35011",
    "Last Name": "Mitchell",
    "First Name": "Kerry-Ann",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296775": {
    "id": "item_37710",
    "Last Name": "Yim",
    "First Name": "Eunha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296786": {
    "id": "item_11757",
    "Last Name": "park",
    "First Name": "myeonghee",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37296796": {
    "id": "item_11758",
    "Last Name": "Hung",
    "First Name": "Ching-Hung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297053": {
    "id": "item_23000",
    "Last Name": "Foster",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297502": {
    "id": "item_37702",
    "Last Name": "Chong",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297554": {
    "id": "item_35006",
    "Last Name": "Kim",
    "First Name": "Hyun Jong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297588": {
    "id": "item_37697",
    "Last Name": "Wells",
    "First Name": "Teri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297844": {
    "id": "item_24430",
    "Last Name": "Careri",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297854": {
    "id": "item_37691",
    "Last Name": "HUANG",
    "First Name": "BINGQIANG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37297926": {
    "id": "item_35004",
    "Last Name": "Scarff",
    "First Name": "Alistair",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298096": {
    "id": "item_37692",
    "Last Name": "Birnie",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298221": {
    "id": "item_37688",
    "Last Name": "MONCATAR",
    "First Name": "TJ ROBINSON",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298450": {
    "id": "item_24425",
    "Last Name": "Holmes",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298472": {
    "id": "item_10000",
    "Last Name": "Hopewell",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298591": {
    "id": "item_34998",
    "Last Name": "GUO",
    "First Name": "ZHANGLIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298612": {
    "id": "item_37683",
    "Last Name": "Johnson",
    "First Name": "Brett",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298633": {
    "id": "item_22991",
    "Last Name": "Bowen",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298690": {
    "id": "item_37679",
    "Last Name": "Cantu",
    "First Name": "Rene",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298692": {
    "id": "item_22990",
    "Last Name": "Lam",
    "First Name": "Hoi Leong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298753": {
    "id": "item_24424",
    "Last Name": "Holmes",
    "First Name": "Tamami",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298863": {
    "id": "item_37673",
    "Last Name": "Posselt",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37298945": {
    "id": "item_22989",
    "Last Name": "Muensakultep",
    "First Name": "Thanin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299123": {
    "id": "item_9998",
    "Last Name": "Gazziero",
    "First Name": "Riccardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299183": {
    "id": "item_37670",
    "Last Name": "Morris",
    "First Name": "Brydon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299284": {
    "id": "item_24421",
    "Last Name": "Forster",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299378": {
    "id": "item_24419",
    "Last Name": "Angell",
    "First Name": "Cowan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299400": {
    "id": "item_37669",
    "Last Name": "Kelso",
    "First Name": "Lina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299411": {
    "id": "item_9996",
    "Last Name": "Burns",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299500": {
    "id": "item_37667",
    "Last Name": "Morgan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299613": {
    "id": "item_9993",
    "Last Name": "zhang",
    "First Name": "Rui",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299622": {
    "id": "item_37666",
    "Last Name": "Lennartz",
    "First Name": "Lotte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299656": {
    "id": "item_9994",
    "Last Name": "Anderson",
    "First Name": "Izac",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299848": {
    "id": "item_9991",
    "Last Name": "Signoriello",
    "First Name": "Aurelio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37299853": {
    "id": "item_37662",
    "Last Name": "Lynch",
    "First Name": "Keely",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300049": {
    "id": "item_24412",
    "Last Name": "Johnson",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300117": {
    "id": "item_37656",
    "Last Name": "Emms",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300137": {
    "id": "item_9987",
    "Last Name": "Edwards",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300265": {
    "id": "item_34991",
    "Last Name": "Seaton",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300292": {
    "id": "item_22977",
    "Last Name": "Swannock",
    "First Name": "Paula",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300365": {
    "id": "item_22975",
    "Last Name": "Yuro",
    "First Name": "Barry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300397": {
    "id": "item_22973",
    "Last Name": "Suhendro",
    "First Name": "Henky",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300414": {
    "id": "item_24405",
    "Last Name": "Peasland",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300415": {
    "id": "item_37650",
    "Last Name": "Thongcharoen",
    "First Name": "Ratana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300428": {
    "id": "item_37648",
    "Last Name": "Spencer",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300555": {
    "id": "item_11740",
    "Last Name": "Tennant",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300574": {
    "id": "item_34990",
    "Last Name": "Rutter",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300583": {
    "id": "item_37642",
    "Last Name": "Huynh",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300611": {
    "id": "item_24401",
    "Last Name": "Tabotta",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300639": {
    "id": "item_37640",
    "Last Name": "Garcia",
    "First Name": "Adriana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300782": {
    "id": "item_22970",
    "Last Name": "Beaulac",
    "First Name": "Spencer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300816": {
    "id": "item_11739",
    "Last Name": "Pepperell",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300956": {
    "id": "item_37629",
    "Last Name": "Heysen-Smith",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37300973": {
    "id": "item_11737",
    "Last Name": "Cao",
    "First Name": "Mingda",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301083": {
    "id": "item_37146",
    "Last Name": "Huet",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301175": {
    "id": "item_24397",
    "Last Name": "Huynh",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301355": {
    "id": "item_9981",
    "Last Name": "Donald",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301412": {
    "id": "item_11733",
    "Last Name": "Arnold",
    "First Name": "Angie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301464": {
    "id": "item_37624",
    "Last Name": "Zhou",
    "First Name": "Kaiping",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301482": {
    "id": "item_37621",
    "Last Name": "Boyd",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301602": {
    "id": "item_37616",
    "Last Name": "Frost",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301636": {
    "id": "item_34983",
    "Last Name": "Nator",
    "First Name": "Jomar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301702": {
    "id": "item_11730",
    "Last Name": "CHIU",
    "First Name": "HOI SHUEN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301725": {
    "id": "item_9980",
    "Last Name": "Jervis-Bardy",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301777": {
    "id": "item_37610",
    "Last Name": "Hoang",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301784": {
    "id": "item_37609",
    "Last Name": "Tan",
    "First Name": "Weicong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301798": {
    "id": "item_24391",
    "Last Name": "Iglesias",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301899": {
    "id": "item_22956",
    "Last Name": "Neill",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301931": {
    "id": "item_11728",
    "Last Name": "Murray",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37301962": {
    "id": "item_34980",
    "Last Name": "Chiew",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302011": {
    "id": "item_12355",
    "Last Name": "Statev",
    "First Name": "Stanimir",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302065": {
    "id": "item_22953",
    "Last Name": "templar",
    "First Name": "matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302066": {
    "id": "item_9973",
    "Last Name": "CHEUNG",
    "First Name": "CHI FAI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302103": {
    "id": "item_11727",
    "Last Name": "Daly",
    "First Name": "Odhran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302169": {
    "id": "item_37598",
    "Last Name": "Houtzer",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302183": {
    "id": "item_24389",
    "Last Name": "Littleford",
    "First Name": "Harry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302205": {
    "id": "item_11726",
    "Last Name": "Bisaga",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302256": {
    "id": "item_22947",
    "Last Name": "Neilson",
    "First Name": "Callum",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302262": {
    "id": "item_34977",
    "Last Name": "Pacey",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302290": {
    "id": "item_37594",
    "Last Name": "Jones",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302318": {
    "id": "item_37593",
    "Last Name": "Du",
    "First Name": "Allen (Chunfeng)",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302363": {
    "id": "item_22945",
    "Last Name": "PETSUNGHAN",
    "First Name": "JAKARIN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302387": {
    "id": "item_37590",
    "Last Name": "Du",
    "First Name": "Andrea (Mengyao)",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302443": {
    "id": "item_11725",
    "Last Name": "Marteddu",
    "First Name": "Francesco",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302467": {
    "id": "item_22944",
    "Last Name": "Hoe",
    "First Name": "Wesley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302482": {
    "id": "item_22943",
    "Last Name": "Walker",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302555": {
    "id": "item_9969",
    "Last Name": "Doggett",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302609": {
    "id": "item_11721",
    "Last Name": "Jubb",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302620": {
    "id": "item_9968",
    "Last Name": "Malone",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302623": {
    "id": "item_37587",
    "Last Name": "Moore",
    "First Name": "Jacinta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302646": {
    "id": "item_37586",
    "Last Name": "Jiang",
    "First Name": "Lumin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302669": {
    "id": "item_11718",
    "Last Name": "Egan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302688": {
    "id": "item_37584",
    "Last Name": "Antunes",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302702": {
    "id": "item_37583",
    "Last Name": "Kuper",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302712": {
    "id": "item_9965",
    "Last Name": "ZHOU",
    "First Name": "SHENGZHENG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302782": {
    "id": "item_11717",
    "Last Name": "Yea",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302854": {
    "id": "item_37578",
    "Last Name": "Peacock",
    "First Name": "Celeste",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302882": {
    "id": "item_37577",
    "Last Name": "TANZER",
    "First Name": "DEBORAH",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302953": {
    "id": "item_9961",
    "Last Name": "Kihara",
    "First Name": "Takumi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37302986": {
    "id": "item_11712",
    "Last Name": "Edelsten",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303071": {
    "id": "item_22934",
    "Last Name": "Heinze",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303109": {
    "id": "item_37572",
    "Last Name": "Smith",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303255": {
    "id": "item_24376",
    "Last Name": "Manrique",
    "First Name": "Roman",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303299": {
    "id": "item_37565",
    "Last Name": "Jonas",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303365": {
    "id": "item_9952",
    "Last Name": "Bowley",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303380": {
    "id": "item_22928",
    "Last Name": "Mak",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303536": {
    "id": "item_22927",
    "Last Name": "Lotz",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303587": {
    "id": "item_37561",
    "Last Name": "Grundy",
    "First Name": "Kim-Louise",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303621": {
    "id": "item_9947",
    "Last Name": "Martin",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303719": {
    "id": "item_11707",
    "Last Name": "Stacey",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303769": {
    "id": "item_37559",
    "Last Name": "Oman",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303824": {
    "id": "item_37558",
    "Last Name": "Rodset",
    "First Name": "Karina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37303882": {
    "id": "item_24369",
    "Last Name": "Lestono",
    "First Name": "Hengki jaya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304024": {
    "id": "item_22926",
    "Last Name": "Lam",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304064": {
    "id": "item_22925",
    "Last Name": "Lopez",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304085": {
    "id": "item_11702",
    "Last Name": "Lopez",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304303": {
    "id": "item_24365",
    "Last Name": "Ferrier",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304423": {
    "id": "item_34966",
    "Last Name": "Otton",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304448": {
    "id": "item_11697",
    "Last Name": "Salmon",
    "First Name": "Becca",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37304576": {
    "id": "item_37542",
    "Last Name": "Dowdakin",
    "First Name": "Jared",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37306725": {
    "id": "item_37539",
    "Last Name": "Devia",
    "First Name": "Risca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37306781": {
    "id": "item_22923",
    "Last Name": "CHO",
    "First Name": "BOSUNG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37307796": {
    "id": "item_11694",
    "Last Name": "Ancheta",
    "First Name": "Raphael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37308954": {
    "id": "item_37533",
    "Last Name": "Kukay",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37310920": {
    "id": "item_37532",
    "Last Name": "Ebrahimi",
    "First Name": "Shelir",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37331268": {
    "id": "item_9941",
    "Last Name": "Kahlefeldt",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37331340": {
    "id": "item_22915",
    "Last Name": "Patel",
    "First Name": "Anish",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37332095": {
    "id": "item_24358",
    "Last Name": "LOK",
    "First Name": "TSZ LOK",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37333323": {
    "id": "item_37529",
    "Last Name": "Atizado",
    "First Name": "Joaquin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37333952": {
    "id": "item_37528",
    "Last Name": "Corpuz",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37336956": {
    "id": "item_24357",
    "Last Name": "Soga",
    "First Name": "Yonke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37344583": {
    "id": "item_37525",
    "Last Name": "Billano",
    "First Name": "Janin Lou",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37347914": {
    "id": "item_34963",
    "Last Name": "AQUINO",
    "First Name": "JOSƒ",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37348259": {
    "id": "item_37523",
    "Last Name": "CAYUPE ARCELA",
    "First Name": "JULISSA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37350482": {
    "id": "item_37521",
    "Last Name": "Huang",
    "First Name": "Jingyuan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37351905": {
    "id": "item_37520",
    "Last Name": "Shin",
    "First Name": "Charles",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37351939": {
    "id": "item_22910",
    "Last Name": "Gavan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37354006": {
    "id": "item_22909",
    "Last Name": "TIAN",
    "First Name": "WENDY",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365075": {
    "id": "item_22908",
    "Last Name": "Manalastas",
    "First Name": "Ma Lourdes",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365122": {
    "id": "item_24886",
    "Last Name": "Lemme",
    "First Name": "Seth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365465": {
    "id": "item_9936",
    "Last Name": "Turner",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365498": {
    "id": "item_34962",
    "Last Name": "Mastej",
    "First Name": "Izabela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365646": {
    "id": "item_24353",
    "Last Name": "Olivier",
    "First Name": "Liza-Lie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365757": {
    "id": "item_12354",
    "Last Name": "Li",
    "First Name": "Jing",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365797": {
    "id": "item_37511",
    "Last Name": "Skovberg",
    "First Name": "Marc",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37365810": {
    "id": "item_9931",
    "Last Name": "Manuel",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366002": {
    "id": "item_24351",
    "Last Name": "Navarro Lepe",
    "First Name": "Arianne Lisset",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366065": {
    "id": "item_34960",
    "Last Name": "Toy",
    "First Name": "Kay",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366116": {
    "id": "item_22902",
    "Last Name": "Hopkins",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366490": {
    "id": "item_9928",
    "Last Name": "Markwell",
    "First Name": "Bomber",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366505": {
    "id": "item_22900",
    "Last Name": "Dribbus",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366635": {
    "id": "item_37504",
    "Last Name": "Taranto",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366676": {
    "id": "item_37503",
    "Last Name": "Wildy",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366781": {
    "id": "item_22898",
    "Last Name": "Ilott",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366816": {
    "id": "item_22896",
    "Last Name": "Johansson",
    "First Name": "Freddie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366878": {
    "id": "item_11685",
    "Last Name": "M.Macedo",
    "First Name": "Marcio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37366917": {
    "id": "item_37497",
    "Last Name": "Lawson",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367051": {
    "id": "item_9924",
    "Last Name": "Xu",
    "First Name": "Zhenchao",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367094": {
    "id": "item_9922",
    "Last Name": "Hulley",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367158": {
    "id": "item_37493",
    "Last Name": "Keesmaat",
    "First Name": "Lloyd",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367327": {
    "id": "item_11684",
    "Last Name": "Bradley",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367552": {
    "id": "item_37491",
    "Last Name": "Simpson",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37367980": {
    "id": "item_24340",
    "Last Name": "Daniels",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368069": {
    "id": "item_34953",
    "Last Name": "Diletti",
    "First Name": "Jorja",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368172": {
    "id": "item_37486",
    "Last Name": "Bruning",
    "First Name": "Karla",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368253": {
    "id": "item_37485",
    "Last Name": "Haysman",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368305": {
    "id": "item_24885",
    "Last Name": "Pena",
    "First Name": "Juan Ignacio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368340": {
    "id": "item_12321",
    "Last Name": "Ng",
    "First Name": "Darwin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368502": {
    "id": "item_34951",
    "Last Name": "Sanchez",
    "First Name": "Averegine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368561": {
    "id": "item_24333",
    "Last Name": "Vukov",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368566": {
    "id": "item_22888",
    "Last Name": "Sheaff",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37368938": {
    "id": "item_9916",
    "Last Name": "de Zylva",
    "First Name": "Jye",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369002": {
    "id": "item_9915",
    "Last Name": "Weinholtz",
    "First Name": "Garrett",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369027": {
    "id": "item_37477",
    "Last Name": "Marr",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369065": {
    "id": "item_22885",
    "Last Name": "Moase",
    "First Name": "Clare",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369075": {
    "id": "item_35780",
    "Last Name": "Searcy",
    "First Name": "Erica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369477": {
    "id": "item_9913",
    "Last Name": "Czech",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369518": {
    "id": "item_22880",
    "Last Name": "Vass",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369601": {
    "id": "item_24326",
    "Last Name": "Kerkham",
    "First Name": "Telena",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369620": {
    "id": "item_37473",
    "Last Name": "Sloan",
    "First Name": "Isobel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369671": {
    "id": "item_24325",
    "Last Name": "ROLNIK",
    "First Name": "BARTOSZ",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369708": {
    "id": "item_34948",
    "Last Name": "Rice",
    "First Name": "Jacinta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369711": {
    "id": "item_9911",
    "Last Name": "Johnston",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369769": {
    "id": "item_9910",
    "Last Name": "Pattison",
    "First Name": "Wesley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369839": {
    "id": "item_34947",
    "Last Name": "Evens",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369858": {
    "id": "item_11673",
    "Last Name": "McTrusty",
    "First Name": "Rocco",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37369874": {
    "id": "item_22876",
    "Last Name": "Tobin",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370203": {
    "id": "item_24323",
    "Last Name": "Roland",
    "First Name": "Ana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370208": {
    "id": "item_37465",
    "Last Name": "Gu",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370403": {
    "id": "item_37464",
    "Last Name": "Wang",
    "First Name": "Derrick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370425": {
    "id": "item_22871",
    "Last Name": "Nguyen",
    "First Name": "Van Nguyen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370459": {
    "id": "item_22869",
    "Last Name": "Lucas",
    "First Name": "Ashlee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370492": {
    "id": "item_22868",
    "Last Name": "Tsiavlis",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370642": {
    "id": "item_37461",
    "Last Name": "Ferro",
    "First Name": "Edgar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370731": {
    "id": "item_22867",
    "Last Name": "Steyn",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370744": {
    "id": "item_37459",
    "Last Name": "Toogood",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37370782": {
    "id": "item_9903",
    "Last Name": "Nobuzawa",
    "First Name": "Miki",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371020": {
    "id": "item_37457",
    "Last Name": "Sachdev",
    "First Name": "Saurav",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371139": {
    "id": "item_24825",
    "Last Name": "Luk",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371432": {
    "id": "item_22862",
    "Last Name": "Marqueses",
    "First Name": "Francene",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371489": {
    "id": "item_9901",
    "Last Name": "Godwin",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371576": {
    "id": "item_37453",
    "Last Name": "Padilla",
    "First Name": "Delmy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371599": {
    "id": "item_24317",
    "Last Name": "Scott",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371642": {
    "id": "item_34945",
    "Last Name": "Chen",
    "First Name": "Li",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371748": {
    "id": "item_37450",
    "Last Name": "Padilla",
    "First Name": "Herberth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371910": {
    "id": "item_37456",
    "Last Name": "Villalobos",
    "First Name": "Alejandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37371945": {
    "id": "item_37447",
    "Last Name": "Pudney",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372009": {
    "id": "item_24314",
    "Last Name": "Grady",
    "First Name": "Marie-Claire",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372078": {
    "id": "item_24313",
    "Last Name": "Terlick",
    "First Name": "Ross",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372101": {
    "id": "item_37445",
    "Last Name": "Tardiff",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372108": {
    "id": "item_22856",
    "Last Name": "YANG",
    "First Name": "YUEQI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372111": {
    "id": "item_10518",
    "Last Name": "Tisera",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372149": {
    "id": "item_24312",
    "Last Name": "Grady",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372216": {
    "id": "item_37444",
    "Last Name": "Kauffman",
    "First Name": "Maren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372244": {
    "id": "item_37443",
    "Last Name": "Lee",
    "First Name": "Ngai Ming",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372363": {
    "id": "item_37440",
    "Last Name": "Priore",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372835": {
    "id": "item_22853",
    "Last Name": "Jorcino",
    "First Name": "Raul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37372887": {
    "id": "item_37437",
    "Last Name": "Govorko",
    "First Name": "Steve",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373281": {
    "id": "item_34942",
    "Last Name": "Balachanthiran",
    "First Name": "Sinduja",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373340": {
    "id": "item_24307",
    "Last Name": "Contreras Vargas",
    "First Name": "Christian Gibran",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373376": {
    "id": "item_35779",
    "Last Name": "TSENG CHIH",
    "First Name": "CHIU",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373461": {
    "id": "item_37430",
    "Last Name": "Spurr-Ospina",
    "First Name": "Robyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373603": {
    "id": "item_22849",
    "Last Name": "Chew",
    "First Name": "Kah Wei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373655": {
    "id": "item_35778",
    "Last Name": "Minandi",
    "First Name": "Britania",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373661": {
    "id": "item_22846",
    "Last Name": "Rutkevich",
    "First Name": "Alla",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373744": {
    "id": "item_37428",
    "Last Name": "Pozzi",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373746": {
    "id": "item_37427",
    "Last Name": "Vary",
    "First Name": "Frantisek",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373763": {
    "id": "item_37424",
    "Last Name": "Perelson",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373798": {
    "id": "item_37422",
    "Last Name": "O Sullivan",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373841": {
    "id": "item_37421",
    "Last Name": "Crawford",
    "First Name": "Mary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373853": {
    "id": "item_11663",
    "Last Name": "Steer",
    "First Name": "Eloise",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373910": {
    "id": "item_37420",
    "Last Name": "Morris",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37373938": {
    "id": "item_11662",
    "Last Name": "Drakeford",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374093": {
    "id": "item_11661",
    "Last Name": "Howell",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374097": {
    "id": "item_9887",
    "Last Name": "Bordenave",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374102": {
    "id": "item_22839",
    "Last Name": "Robertson",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374327": {
    "id": "item_37415",
    "Last Name": "Gough",
    "First Name": "Carol-Ann",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374336": {
    "id": "item_11659",
    "Last Name": "Ferreira",
    "First Name": "Jan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374493": {
    "id": "item_37414",
    "Last Name": "Torres",
    "First Name": "Manuel Khelvin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374496": {
    "id": "item_24303",
    "Last Name": "Principato",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374554": {
    "id": "item_11657",
    "Last Name": "Mummery",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374595": {
    "id": "item_37413",
    "Last Name": "Sorbanelli",
    "First Name": "Joe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374617": {
    "id": "item_37412",
    "Last Name": "Gill",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374667": {
    "id": "item_24302",
    "Last Name": "Uzair",
    "First Name": "Ahmed",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374683": {
    "id": "item_11655",
    "Last Name": "Franich",
    "First Name": "Cody",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374735": {
    "id": "item_22832",
    "Last Name": "Hoette",
    "First Name": "Stephan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374768": {
    "id": "item_37410",
    "Last Name": "Tam",
    "First Name": "Wen Tsing",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374787": {
    "id": "item_9885",
    "Last Name": "Costner",
    "First Name": "Rochelle",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374791": {
    "id": "item_22831",
    "Last Name": "Wiszniewski",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37374999": {
    "id": "item_10552",
    "Last Name": "Olson",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375003": {
    "id": "item_22829",
    "Last Name": "Mavrov",
    "First Name": "Jovan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375005": {
    "id": "item_37408",
    "Last Name": "Taylor",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375070": {
    "id": "item_37404",
    "Last Name": "Jennings",
    "First Name": "Damon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375118": {
    "id": "item_37400",
    "Last Name": "Robbins",
    "First Name": "Glen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375122": {
    "id": "item_37401",
    "Last Name": "Tan",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375137": {
    "id": "item_22827",
    "Last Name": "Imeri",
    "First Name": "Adem",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375188": {
    "id": "item_9880",
    "Last Name": "Treloar",
    "First Name": "Curtis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375201": {
    "id": "item_37398",
    "Last Name": "Guyomard",
    "First Name": "Florian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375367": {
    "id": "item_12353",
    "Last Name": "Yuchen",
    "First Name": "Rong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375382": {
    "id": "item_11649",
    "Last Name": "Waco",
    "First Name": "Shawn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375406": {
    "id": "item_9878",
    "Last Name": "Jobin",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375420": {
    "id": "item_11648",
    "Last Name": "Rose",
    "First Name": "Flynn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375563": {
    "id": "item_9877",
    "Last Name": "Wang",
    "First Name": "Shengxian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375637": {
    "id": "item_37389",
    "Last Name": "Farina",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375639": {
    "id": "item_37390",
    "Last Name": "Hollis-Sando",
    "First Name": "Lily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375643": {
    "id": "item_24296",
    "Last Name": "Kempler",
    "First Name": "Lise",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375684": {
    "id": "item_9876",
    "Last Name": "Deeley",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375719": {
    "id": "item_24295",
    "Last Name": "Zheng",
    "First Name": "Kaiyang",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375801": {
    "id": "item_37384",
    "Last Name": "Urie",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375866": {
    "id": "item_37382",
    "Last Name": "Chew",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375897": {
    "id": "item_22820",
    "Last Name": "Eid",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37375959": {
    "id": "item_35777",
    "Last Name": "Dahuja",
    "First Name": "Rohit",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376079": {
    "id": "item_11642",
    "Last Name": "Mountney",
    "First Name": "Reid",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376086": {
    "id": "item_37381",
    "Last Name": "Trew",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376104": {
    "id": "item_11640",
    "Last Name": "Schaup",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376163": {
    "id": "item_37147",
    "Last Name": "Beynon",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376235": {
    "id": "item_22815",
    "Last Name": "ILIADIS",
    "First Name": "MICHAIL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376256": {
    "id": "item_34926",
    "Last Name": "Panamthanath Murali",
    "First Name": "Sinesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376264": {
    "id": "item_37375",
    "Last Name": "Shaw",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376290": {
    "id": "item_22813",
    "Last Name": "Pan",
    "First Name": "Hsiao Hsuan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376348": {
    "id": "item_11635",
    "Last Name": "Palmieri",
    "First Name": "Lydia",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376349": {
    "id": "item_11636",
    "Last Name": "Roe",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376383": {
    "id": "item_11634",
    "Last Name": "QuŽrŽ",
    "First Name": "Ronan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376437": {
    "id": "item_24290",
    "Last Name": "Whitlam",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376473": {
    "id": "item_37372",
    "Last Name": "Harrison",
    "First Name": "Jess",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376486": {
    "id": "item_37370",
    "Last Name": "Ho",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376543": {
    "id": "item_9864",
    "Last Name": "Virgin",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376560": {
    "id": "item_37369",
    "Last Name": "Tan",
    "First Name": "Xiahui",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376570": {
    "id": "item_24288",
    "Last Name": "Gorat",
    "First Name": "Anny janty",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376589": {
    "id": "item_34923",
    "Last Name": "KO",
    "First Name": "Chi Yuen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376603": {
    "id": "item_34922",
    "Last Name": "Chen",
    "First Name": "Kay",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376759": {
    "id": "item_37361",
    "Last Name": "Billett",
    "First Name": "Anthea",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376876": {
    "id": "item_11542",
    "Last Name": "Teng",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376879": {
    "id": "item_24286",
    "Last Name": "Dunning",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37376974": {
    "id": "item_11624",
    "Last Name": "Boosey",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377056": {
    "id": "item_24284",
    "Last Name": "Wark",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377082": {
    "id": "item_24282",
    "Last Name": "Jonhera",
    "First Name": "Admire",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377185": {
    "id": "item_11623",
    "Last Name": "Chung",
    "First Name": "Chi ho",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377407": {
    "id": "item_22803",
    "Last Name": "Rodriguez",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377444": {
    "id": "item_37357",
    "Last Name": "Bell",
    "First Name": "Corey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377480": {
    "id": "item_11622",
    "Last Name": "syme",
    "First Name": "matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377880": {
    "id": "item_22801",
    "Last Name": "MCPETERS",
    "First Name": "JULIA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377906": {
    "id": "item_9857",
    "Last Name": "HSU",
    "First Name": "MINGYUAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37377966": {
    "id": "item_9856",
    "Last Name": "Jordan",
    "First Name": "Jeramey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378461": {
    "id": "item_11620",
    "Last Name": "Chow",
    "First Name": "Tze Chun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378536": {
    "id": "item_10551",
    "Last Name": "Alaniz",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378644": {
    "id": "item_22799",
    "Last Name": "Hawkins",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378830": {
    "id": "item_35738",
    "Last Name": "Kubokawa",
    "First Name": "Yasushi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378896": {
    "id": "item_37343",
    "Last Name": "Fanning",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37378979": {
    "id": "item_11615",
    "Last Name": "GRADDEN",
    "First Name": "JORDAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37379586": {
    "id": "item_37341",
    "Last Name": "Keller",
    "First Name": "Clarissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37379704": {
    "id": "item_22798",
    "Last Name": "Westbrook",
    "First Name": "Kaelin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37381023": {
    "id": "item_24274",
    "Last Name": "Michalak",
    "First Name": "Agnieszka",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37381834": {
    "id": "item_22795",
    "Last Name": "Peng",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37382674": {
    "id": "item_9851",
    "Last Name": "Carvallo",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37382776": {
    "id": "item_11610",
    "Last Name": "Pearce",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37382961": {
    "id": "item_34916",
    "Last Name": "Battaglio",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37383028": {
    "id": "item_24273",
    "Last Name": "Anderson",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37383772": {
    "id": "item_9849",
    "Last Name": "o'sullivan",
    "First Name": "robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37383859": {
    "id": "item_24884",
    "Last Name": "Scholberg",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385287": {
    "id": "item_34912",
    "Last Name": "So",
    "First Name": "Eddy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385322": {
    "id": "item_37329",
    "Last Name": "Callinan",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385391": {
    "id": "item_22787",
    "Last Name": "LEE",
    "First Name": "Chiu Ming",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385405": {
    "id": "item_37328",
    "Last Name": "McLeod",
    "First Name": "Jodie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385458": {
    "id": "item_37325",
    "Last Name": "Bakopoulos",
    "First Name": "Petros",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385489": {
    "id": "item_24269",
    "Last Name": "Nguyen",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385709": {
    "id": "item_9845",
    "Last Name": "Alford",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385726": {
    "id": "item_37321",
    "Last Name": "Brett",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385801": {
    "id": "item_37320",
    "Last Name": "Brett",
    "First Name": "Shane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385950": {
    "id": "item_24824",
    "Last Name": "Bonano",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385973": {
    "id": "item_34910",
    "Last Name": "Robinson",
    "First Name": "Tarin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37385997": {
    "id": "item_24268",
    "Last Name": "Carrascoza",
    "First Name": "Bruna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37386203": {
    "id": "item_22778",
    "Last Name": "Badro",
    "First Name": "Michel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387143": {
    "id": "item_37310",
    "Last Name": "Kennedy",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387577": {
    "id": "item_9840",
    "Last Name": "Rios Ma–ay",
    "First Name": "Facundo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37387648": {
    "id": "item_11601",
    "Last Name": "Abbott",
    "First Name": "Dane",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388209": {
    "id": "item_37302",
    "Last Name": "Elmes",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388343": {
    "id": "item_37300",
    "Last Name": "Ekawati",
    "First Name": "Nilam Tri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388575": {
    "id": "item_22769",
    "Last Name": "Carlisle",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37388927": {
    "id": "item_22767",
    "Last Name": "Bernaus",
    "First Name": "Joaquin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389019": {
    "id": "item_34901",
    "Last Name": "Mitchell",
    "First Name": "Elysia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389126": {
    "id": "item_11599",
    "Last Name": "Lambert",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389394": {
    "id": "item_37292",
    "Last Name": "Blaikie",
    "First Name": "Felix",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389395": {
    "id": "item_22763",
    "Last Name": "Ferreira Cortez",
    "First Name": "Guilherme",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389695": {
    "id": "item_34900",
    "Last Name": "Poblete",
    "First Name": "Arvin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389876": {
    "id": "item_9829",
    "Last Name": "McCormack",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37389986": {
    "id": "item_11597",
    "Last Name": "Van Zetten",
    "First Name": "Brady",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390001": {
    "id": "item_22758",
    "Last Name": "Naude",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390079": {
    "id": "item_10550",
    "Last Name": "Jacobson",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390207": {
    "id": "item_37283",
    "Last Name": "Siva Das",
    "First Name": "Sooraj",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390369": {
    "id": "item_9828",
    "Last Name": "McPherson",
    "First Name": "Brent",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390459": {
    "id": "item_24256",
    "Last Name": "Horton",
    "First Name": "India",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390502": {
    "id": "item_9827",
    "Last Name": "Partel",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390572": {
    "id": "item_37277",
    "Last Name": "Trinh",
    "First Name": "Christiana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390965": {
    "id": "item_9826",
    "Last Name": "Merigan",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37390967": {
    "id": "item_22746",
    "Last Name": "Devitt",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391078": {
    "id": "item_9823",
    "Last Name": "SINN",
    "First Name": "SIRAVUTH",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391362": {
    "id": "item_37273",
    "Last Name": "Wallis",
    "First Name": "Caylee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391386": {
    "id": "item_22745",
    "Last Name": "Border",
    "First Name": "Jay",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391394": {
    "id": "item_9821",
    "Last Name": "Cacciola",
    "First Name": "Zachery",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391412": {
    "id": "item_37271",
    "Last Name": "Komninos",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391754": {
    "id": "item_11588",
    "Last Name": "Kim",
    "First Name": "Sukmo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391805": {
    "id": "item_24883",
    "Last Name": "White",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37391815": {
    "id": "item_37269",
    "Last Name": "Castellano",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392070": {
    "id": "item_24882",
    "Last Name": "Gunther",
    "First Name": "Mackenzie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392193": {
    "id": "item_22740",
    "Last Name": "Dickson",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392314": {
    "id": "item_34891",
    "Last Name": "Andersen",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392387": {
    "id": "item_34890",
    "Last Name": "Chileshe",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392474": {
    "id": "item_37265",
    "Last Name": "Leelapisuth",
    "First Name": "Chonlada",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392534": {
    "id": "item_37263",
    "Last Name": "Gauci",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392763": {
    "id": "item_37262",
    "Last Name": "moller",
    "First Name": "jessie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392837": {
    "id": "item_11585",
    "Last Name": "Yee",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392869": {
    "id": "item_37260",
    "Last Name": "Knezevic-Kovac",
    "First Name": "Erika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37392949": {
    "id": "item_24244",
    "Last Name": "Ceferino Olarte",
    "First Name": "Margarita",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393016": {
    "id": "item_24242",
    "Last Name": "Aneja",
    "First Name": "Arvind",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393066": {
    "id": "item_11582",
    "Last Name": "Simkins",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393188": {
    "id": "item_9818",
    "Last Name": "Reid",
    "First Name": "Cecily",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393308": {
    "id": "item_37255",
    "Last Name": "Branfield",
    "First Name": "Greg",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393378": {
    "id": "item_37254",
    "Last Name": "Cattermole",
    "First Name": "Rosalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393454": {
    "id": "item_37253",
    "Last Name": "Radyanti",
    "First Name": "Shabrina Pritta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393459": {
    "id": "item_22728",
    "Last Name": "Schaxmann",
    "First Name": "Linus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393467": {
    "id": "item_22727",
    "Last Name": "Gelis",
    "First Name": "Shay",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393509": {
    "id": "item_24238",
    "Last Name": "Chen",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393538": {
    "id": "item_37246",
    "Last Name": "SHIMOBAYASHI",
    "First Name": "HISASHI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393652": {
    "id": "item_9812",
    "Last Name": "Duffy",
    "First Name": "Declan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393709": {
    "id": "item_37241",
    "Last Name": "Laisathit",
    "First Name": "Karun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393748": {
    "id": "item_34886",
    "Last Name": "Yoon",
    "First Name": "Junseok",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393822": {
    "id": "item_11575",
    "Last Name": "Kiefel-Johnson",
    "First Name": "Clara",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393936": {
    "id": "item_37238",
    "Last Name": "Oxley",
    "First Name": "Allisha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37393945": {
    "id": "item_9809",
    "Last Name": "Ršnty",
    "First Name": "Veli-Pekka",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394024": {
    "id": "item_37236",
    "Last Name": "Williams",
    "First Name": "Sara-Louise",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394048": {
    "id": "item_37233",
    "Last Name": "Byrd",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394079": {
    "id": "item_37232",
    "Last Name": "Hollis",
    "First Name": "Troy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394167": {
    "id": "item_24231",
    "Last Name": "Vines",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394188": {
    "id": "item_34885",
    "Last Name": "Piccolo",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394263": {
    "id": "item_9804",
    "Last Name": "Edwards",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394298": {
    "id": "item_37228",
    "Last Name": "Junianto",
    "First Name": "Junianto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394311": {
    "id": "item_37227",
    "Last Name": "Prakoso",
    "First Name": "Rangga Satya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394341": {
    "id": "item_11571",
    "Last Name": "Kirkland",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394411": {
    "id": "item_22709",
    "Last Name": "Clemson",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394430": {
    "id": "item_24227",
    "Last Name": "McLachlan",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394461": {
    "id": "item_22707",
    "Last Name": "Hall",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394588": {
    "id": "item_37222",
    "Last Name": "Bandini",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394610": {
    "id": "item_24224",
    "Last Name": "Gonzalez",
    "First Name": "Camille",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394626": {
    "id": "item_11569",
    "Last Name": "Barker",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394634": {
    "id": "item_37220",
    "Last Name": "Hughes",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394786": {
    "id": "item_24220",
    "Last Name": "Millard",
    "First Name": "Alecia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394799": {
    "id": "item_37215",
    "Last Name": "Guiney",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394817": {
    "id": "item_37212",
    "Last Name": "Ross",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394862": {
    "id": "item_22706",
    "Last Name": "Dickinson",
    "First Name": "Deanna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37394905": {
    "id": "item_34881",
    "Last Name": "Foo",
    "First Name": "Lyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395022": {
    "id": "item_9798",
    "Last Name": "Murphy",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395046": {
    "id": "item_22704",
    "Last Name": "Faragi",
    "First Name": "Rayan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395201": {
    "id": "item_11566",
    "Last Name": "KIM",
    "First Name": "SANGHO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395232": {
    "id": "item_22701",
    "Last Name": "White",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395275": {
    "id": "item_34879",
    "Last Name": "Zubova",
    "First Name": "Valentina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395290": {
    "id": "item_11564",
    "Last Name": "Angst-Baumgartner",
    "First Name": "Martin Andreas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395298": {
    "id": "item_37200",
    "Last Name": "McGee",
    "First Name": "Blake",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395305": {
    "id": "item_24217",
    "Last Name": "Lui",
    "First Name": "Kwong Hing",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395318": {
    "id": "item_34878",
    "Last Name": "Xu",
    "First Name": "Baoqiang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395332": {
    "id": "item_9793",
    "Last Name": "Hinrichsen",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395421": {
    "id": "item_24215",
    "Last Name": "Wen",
    "First Name": "Xueli",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37395652": {
    "id": "item_9792",
    "Last Name": "Little",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37396054": {
    "id": "item_11562",
    "Last Name": "Farmer",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37396111": {
    "id": "item_9791",
    "Last Name": "KIM",
    "First Name": "ARAMYI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37397114": {
    "id": "item_11559",
    "Last Name": "Leon Romero",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37397165": {
    "id": "item_37187",
    "Last Name": "PARK",
    "First Name": "JUN SEOP",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37397516": {
    "id": "item_24881",
    "Last Name": "Valenzuela",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37397839": {
    "id": "item_37184",
    "Last Name": "Houtz",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37398158": {
    "id": "item_37181",
    "Last Name": "SUNAGARE",
    "First Name": "YUJI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37398524": {
    "id": "item_37180",
    "Last Name": "Garcia",
    "First Name": "Christell Jill",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37399531": {
    "id": "item_11551",
    "Last Name": "Chapman",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37399766": {
    "id": "item_11550",
    "Last Name": "Augsburger",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37400384": {
    "id": "item_37174",
    "Last Name": "king",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37400509": {
    "id": "item_37173",
    "Last Name": "Tang",
    "First Name": "Chi Lung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37401094": {
    "id": "item_22692",
    "Last Name": "Gregory",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37401199": {
    "id": "item_9784",
    "Last Name": "Wildes",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37401474": {
    "id": "item_37168",
    "Last Name": "Cheso",
    "First Name": "Jarryd",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402074": {
    "id": "item_10549",
    "Last Name": "Dybvad",
    "First Name": "John Gunnar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402113": {
    "id": "item_37166",
    "Last Name": "Vanneste",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402484": {
    "id": "item_37162",
    "Last Name": "Harrison",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37402839": {
    "id": "item_37160",
    "Last Name": "Markland",
    "First Name": "Hadley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37403019": {
    "id": "item_37159",
    "Last Name": "Knight",
    "First Name": "Paulina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37403336": {
    "id": "item_24205",
    "Last Name": "Buwalda",
    "First Name": "Jeroen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37403408": {
    "id": "item_9779",
    "Last Name": "Degan",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37403606": {
    "id": "item_22686",
    "Last Name": "Mallon",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404112": {
    "id": "item_11544",
    "Last Name": "Jarrad",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404435": {
    "id": "item_37150",
    "Last Name": "Smith",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404528": {
    "id": "item_37149",
    "Last Name": "Smith",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404600": {
    "id": "item_34874",
    "Last Name": "Spraggins",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404773": {
    "id": "item_24704",
    "Last Name": "Lynch",
    "First Name": "Anita",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404923": {
    "id": "item_35631",
    "Last Name": "Meikle",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37404955": {
    "id": "item_35630",
    "Last Name": "Rowland",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405158": {
    "id": "item_35629",
    "Last Name": "Ang",
    "First Name": "Rinto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405186": {
    "id": "item_24702",
    "Last Name": "McQualter",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405192": {
    "id": "item_10426",
    "Last Name": "Harburg",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405359": {
    "id": "item_24701",
    "Last Name": "Johnson",
    "First Name": "Terry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405835": {
    "id": "item_12212",
    "Last Name": "Hopkins",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405866": {
    "id": "item_24698",
    "Last Name": "Webb",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405969": {
    "id": "item_10423",
    "Last Name": "Cuevas",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405982": {
    "id": "item_24697",
    "Last Name": "Vierneza",
    "First Name": "Jemerson",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37405996": {
    "id": "item_35622",
    "Last Name": "Pears",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406389": {
    "id": "item_35620",
    "Last Name": "Flynn",
    "First Name": "Terri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37406405": {
    "id": "item_24693",
    "Last Name": "Russell",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407093": {
    "id": "item_12206",
    "Last Name": "Ueda",
    "First Name": "Sawako",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407115": {
    "id": "item_10417",
    "Last Name": "Kelly",
    "First Name": "Ewan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407214": {
    "id": "item_35618",
    "Last Name": "Owen",
    "First Name": "Katharine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407251": {
    "id": "item_10416",
    "Last Name": "Heffernan",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407600": {
    "id": "item_35616",
    "Last Name": "Silvers",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37407798": {
    "id": "item_10413",
    "Last Name": "Cawley",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37408129": {
    "id": "item_10517",
    "Last Name": "Choi",
    "First Name": "Man Ho",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37408199": {
    "id": "item_10412",
    "Last Name": "Beadle",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37408378": {
    "id": "item_35611",
    "Last Name": "Sudbedi",
    "First Name": "Lila Nath",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37408676": {
    "id": "item_35610",
    "Last Name": "Houghton",
    "First Name": "Tania",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409364": {
    "id": "item_23484",
    "Last Name": "Veblen",
    "First Name": "Lynn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409711": {
    "id": "item_10410",
    "Last Name": "Jambor",
    "First Name": "Maxwell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37409948": {
    "id": "item_35606",
    "Last Name": "Brichacek",
    "First Name": "Gina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410002": {
    "id": "item_24685",
    "Last Name": "Alexopoulos",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410454": {
    "id": "item_35604",
    "Last Name": "Constable",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410501": {
    "id": "item_12201",
    "Last Name": "Love",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410573": {
    "id": "item_35601",
    "Last Name": "Ingledew",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410861": {
    "id": "item_12200",
    "Last Name": "Deane",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37410949": {
    "id": "item_24679",
    "Last Name": "Souto",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37412036": {
    "id": "item_24675",
    "Last Name": "Gosbell",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37412369": {
    "id": "item_12197",
    "Last Name": "Treloar",
    "First Name": "Julie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37412472": {
    "id": "item_12196",
    "Last Name": "Wang",
    "First Name": "Shicheng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37412539": {
    "id": "item_35596",
    "Last Name": "Fu",
    "First Name": "Chunjiang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37412732": {
    "id": "item_35594",
    "Last Name": "Campbell",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413618": {
    "id": "item_10405",
    "Last Name": "Overstall",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413781": {
    "id": "item_10404",
    "Last Name": "Holowaty",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413817": {
    "id": "item_35592",
    "Last Name": "Crouch",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413842": {
    "id": "item_24674",
    "Last Name": "Larcombe",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37413883": {
    "id": "item_24673",
    "Last Name": "M",
    "First Name": "Francis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414537": {
    "id": "item_24671",
    "Last Name": "ennals",
    "First Name": "sam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414775": {
    "id": "item_35776",
    "Last Name": "De Guzman",
    "First Name": "Leo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37414923": {
    "id": "item_23482",
    "Last Name": "Hynds",
    "First Name": "Brody",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415148": {
    "id": "item_24669",
    "Last Name": "Pitter",
    "First Name": "Theresa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415385": {
    "id": "item_12188",
    "Last Name": "Robbins",
    "First Name": "Fergus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415501": {
    "id": "item_24668",
    "Last Name": "Sardeson",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415768": {
    "id": "item_24665",
    "Last Name": "Lee",
    "First Name": "On Yi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415851": {
    "id": "item_23481",
    "Last Name": "Campbell",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415869": {
    "id": "item_35588",
    "Last Name": "Constantino",
    "First Name": "Arnel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415908": {
    "id": "item_24662",
    "Last Name": "Neil",
    "First Name": "Cathrine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415955": {
    "id": "item_12186",
    "Last Name": "Chhibber",
    "First Name": "Karan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37415972": {
    "id": "item_38264",
    "Last Name": "Rand",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416074": {
    "id": "item_35586",
    "Last Name": "He",
    "First Name": "Shenghui",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416305": {
    "id": "item_12185",
    "Last Name": "Perryman",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416317": {
    "id": "item_24660",
    "Last Name": "Lardizabal",
    "First Name": "Rodgee Gwen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416351": {
    "id": "item_35585",
    "Last Name": "Ross",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416546": {
    "id": "item_35583",
    "Last Name": "Ingram",
    "First Name": "Karin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416813": {
    "id": "item_24654",
    "Last Name": "Dowding",
    "First Name": "Perrine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416824": {
    "id": "item_23480",
    "Last Name": "Williams",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416885": {
    "id": "item_12179",
    "Last Name": "PHUPICHAYAPHAN",
    "First Name": "CHINDANAI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37416987": {
    "id": "item_10392",
    "Last Name": "Le Brocque",
    "First Name": "Todd",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417135": {
    "id": "item_12177",
    "Last Name": "Fleming",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417148": {
    "id": "item_24651",
    "Last Name": "Lordan",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417218": {
    "id": "item_10390",
    "Last Name": "Pyne",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417228": {
    "id": "item_35577",
    "Last Name": "Graham",
    "First Name": "Amie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417280": {
    "id": "item_10389",
    "Last Name": "Bell",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417350": {
    "id": "item_10387",
    "Last Name": "Luk",
    "First Name": "Cheuk Ting Plato",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417389": {
    "id": "item_24648",
    "Last Name": "Ryan",
    "First Name": "Nate",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417393": {
    "id": "item_12173",
    "Last Name": "Shu Pui",
    "First Name": "Cheung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417509": {
    "id": "item_35574",
    "Last Name": "Murphy",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417522": {
    "id": "item_12172",
    "Last Name": "Wills",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417556": {
    "id": "item_24646",
    "Last Name": "Strum",
    "First Name": "Orly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417703": {
    "id": "item_24645",
    "Last Name": "Sari",
    "First Name": "Uci Kartika",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417732": {
    "id": "item_12170",
    "Last Name": "Ploteau",
    "First Name": "Romain",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417764": {
    "id": "item_12168",
    "Last Name": "Clarke",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417838": {
    "id": "item_12167",
    "Last Name": "Taborsky",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417889": {
    "id": "item_24641",
    "Last Name": "Hughes",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37417969": {
    "id": "item_23479",
    "Last Name": "Silva",
    "First Name": "Gomes da",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418037": {
    "id": "item_24639",
    "Last Name": "Schiewe",
    "First Name": "Andrzej",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418093": {
    "id": "item_35570",
    "Last Name": "Dowling",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418171": {
    "id": "item_35569",
    "Last Name": "PAUNIL",
    "First Name": "LYLE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418300": {
    "id": "item_24636",
    "Last Name": "XU",
    "First Name": "XING",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418340": {
    "id": "item_35568",
    "Last Name": "Holland",
    "First Name": "Dutch",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418353": {
    "id": "item_35567",
    "Last Name": "OU",
    "First Name": "JIE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418403": {
    "id": "item_12165",
    "Last Name": "WU",
    "First Name": "SONGYANG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418853": {
    "id": "item_24633",
    "Last Name": "Rojko",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418859": {
    "id": "item_35566",
    "Last Name": "Rados",
    "First Name": "Janet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37418988": {
    "id": "item_35565",
    "Last Name": "Wang",
    "First Name": "Hungyu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37419028": {
    "id": "item_35564",
    "Last Name": "Santos Silva",
    "First Name": "Hellen Mayara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37419030": {
    "id": "item_12164",
    "Last Name": "Ivanov",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37430481": {
    "id": "item_10377",
    "Last Name": "Kaffka",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37446430": {
    "id": "item_10376",
    "Last Name": "Mason",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37448918": {
    "id": "item_24880",
    "Last Name": "Jackiewicz",
    "First Name": "Agnieszka",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37450015": {
    "id": "item_12162",
    "Last Name": "Larkins",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37459947": {
    "id": "item_12352",
    "Last Name": "FERNANDEZ SANZ",
    "First Name": "MIGUEL",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37470744": {
    "id": "item_10375",
    "Last Name": "Villarce",
    "First Name": "Itzu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37471757": {
    "id": "item_10374",
    "Last Name": "Appleton",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37480033": {
    "id": "item_35775",
    "Last Name": "WEST",
    "First Name": "JAMES",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37480099": {
    "id": "item_35560",
    "Last Name": "Fritz",
    "First Name": "Nini",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37480291": {
    "id": "item_24628",
    "Last Name": "Lambert",
    "First Name": "Izaiah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37481378": {
    "id": "item_24626",
    "Last Name": "Radik",
    "First Name": "Lara",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37481390": {
    "id": "item_35557",
    "Last Name": "Ramirez",
    "First Name": "Jose",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37481601": {
    "id": "item_24625",
    "Last Name": "Curtis",
    "First Name": "Shontelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37482341": {
    "id": "item_35555",
    "Last Name": "Fowler",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37482463": {
    "id": "item_24619",
    "Last Name": "Horvat",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37483153": {
    "id": "item_24616",
    "Last Name": "Weir",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37483503": {
    "id": "item_10373",
    "Last Name": "Jambor",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484098": {
    "id": "item_35551",
    "Last Name": "Buhler",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484191": {
    "id": "item_35549",
    "Last Name": "Gurry",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484237": {
    "id": "item_12154",
    "Last Name": "McDonald",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484266": {
    "id": "item_35547",
    "Last Name": "Giraud",
    "First Name": "Cyril",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484436": {
    "id": "item_35545",
    "Last Name": "Lish",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37484619": {
    "id": "item_35544",
    "Last Name": "Jun",
    "First Name": "Yeonjae",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37485028": {
    "id": "item_10369",
    "Last Name": "Michalek",
    "First Name": "Lukas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37485437": {
    "id": "item_10368",
    "Last Name": "Hayes",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37485573": {
    "id": "item_10367",
    "Last Name": "Ream",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486251": {
    "id": "item_10365",
    "Last Name": "Bos",
    "First Name": "Lance",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486530": {
    "id": "item_10364",
    "Last Name": "English",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486602": {
    "id": "item_24607",
    "Last Name": "Jootoo",
    "First Name": "Swaraj",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486620": {
    "id": "item_12151",
    "Last Name": "Garth",
    "First Name": "Warwick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37486992": {
    "id": "item_24606",
    "Last Name": "Perry",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37487232": {
    "id": "item_35540",
    "Last Name": "Davis",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37487308": {
    "id": "item_24604",
    "Last Name": "Taylor",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37487694": {
    "id": "item_35537",
    "Last Name": "Wood",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37487965": {
    "id": "item_24601",
    "Last Name": "Kincaid",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488405": {
    "id": "item_24599",
    "Last Name": "Boyd",
    "First Name": "Adrienne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488439": {
    "id": "item_35533",
    "Last Name": "WU",
    "First Name": "SHANHAO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488628": {
    "id": "item_24595",
    "Last Name": "Perry",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37488924": {
    "id": "item_24592",
    "Last Name": "Carberry",
    "First Name": "Ciaran",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489053": {
    "id": "item_10361",
    "Last Name": "OH",
    "First Name": "WOOJIN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489234": {
    "id": "item_24589",
    "Last Name": "Lim",
    "First Name": "Jungmoon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489270": {
    "id": "item_10359",
    "Last Name": "Hunt",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489507": {
    "id": "item_24588",
    "Last Name": "Dodd",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489939": {
    "id": "item_35530",
    "Last Name": "Gowrie",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37489985": {
    "id": "item_24586",
    "Last Name": "Mutinda",
    "First Name": "Benny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490025": {
    "id": "item_35529",
    "Last Name": "Wong",
    "First Name": "Justina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490102": {
    "id": "item_24585",
    "Last Name": "Peters",
    "First Name": "Angelique",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490216": {
    "id": "item_10356",
    "Last Name": "Cameron",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490373": {
    "id": "item_24583",
    "Last Name": "O'Brien",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490441": {
    "id": "item_23475",
    "Last Name": "KivelŠ",
    "First Name": "Krista",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490535": {
    "id": "item_10354",
    "Last Name": "Nguyen",
    "First Name": "Tuan minh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490536": {
    "id": "item_24580",
    "Last Name": "Yu",
    "First Name": "Xiang",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490554": {
    "id": "item_24581",
    "Last Name": "Zammit",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490819": {
    "id": "item_12140",
    "Last Name": "McLean",
    "First Name": "Chad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37490968": {
    "id": "item_35526",
    "Last Name": "Permpreedanan",
    "First Name": "Voramet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491023": {
    "id": "item_35525",
    "Last Name": "Zhu",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491074": {
    "id": "item_23502",
    "Last Name": "Zhukhin",
    "First Name": "Bakhytbek",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491180": {
    "id": "item_35524",
    "Last Name": "Maher",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491255": {
    "id": "item_35774",
    "Last Name": "Malarie Bender",
    "First Name": "Malarie Bender",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491285": {
    "id": "item_35522",
    "Last Name": "Reynolds",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491469": {
    "id": "item_24571",
    "Last Name": "Elio",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491528": {
    "id": "item_23472",
    "Last Name": "Eckermann",
    "First Name": "Miklos Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491793": {
    "id": "item_10346",
    "Last Name": "Plaice",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491800": {
    "id": "item_24569",
    "Last Name": "Lembo",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37491889": {
    "id": "item_23471",
    "Last Name": "Gray",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492224": {
    "id": "item_24564",
    "Last Name": "Loo",
    "First Name": "Ching Ee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492441": {
    "id": "item_35517",
    "Last Name": null,
    "First Name": "Shamshad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492679": {
    "id": "item_24559",
    "Last Name": "Kong",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37492732": {
    "id": "item_12351",
    "Last Name": "Farizuan",
    "First Name": "Radin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37493692": {
    "id": "item_35773",
    "Last Name": "Mazza",
    "First Name": "Lori",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37494549": {
    "id": "item_12128",
    "Last Name": "Cairns",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495240": {
    "id": "item_35514",
    "Last Name": "Pham",
    "First Name": "Kara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495278": {
    "id": "item_24553",
    "Last Name": "LI",
    "First Name": "YADONG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37495886": {
    "id": "item_10340",
    "Last Name": "Losty",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37496109": {
    "id": "item_12124",
    "Last Name": "Hoyle",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37496231": {
    "id": "item_12350",
    "Last Name": "Tong",
    "First Name": "Ka chun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37496581": {
    "id": "item_12122",
    "Last Name": "Russell",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37496617": {
    "id": "item_12121",
    "Last Name": "mccutcheon",
    "First Name": "brett",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37496841": {
    "id": "item_24879",
    "Last Name": "Cruz",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37497142": {
    "id": "item_35510",
    "Last Name": "Menheere",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37497282": {
    "id": "item_24549",
    "Last Name": "Twycross",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37497409": {
    "id": "item_35508",
    "Last Name": "Stafford",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37497660": {
    "id": "item_10336",
    "Last Name": "Carbonell Alberti",
    "First Name": "Joan Pere",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37497954": {
    "id": "item_10335",
    "Last Name": "Metcalf",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37503119": {
    "id": "item_24548",
    "Last Name": "Fatah",
    "First Name": "Abderahim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37509080": {
    "id": "item_24547",
    "Last Name": "Thompson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37509522": {
    "id": "item_24546",
    "Last Name": "Reid",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37509789": {
    "id": "item_35506",
    "Last Name": "Berry",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37510109": {
    "id": "item_24544",
    "Last Name": "Ellis",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37510219": {
    "id": "item_24543",
    "Last Name": "Seaton",
    "First Name": "Eilidh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37510359": {
    "id": "item_24542",
    "Last Name": "Sagar",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37511365": {
    "id": "item_10331",
    "Last Name": "Ramirez",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37511455": {
    "id": "item_35502",
    "Last Name": "feeney",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37511465": {
    "id": "item_12110",
    "Last Name": "Duncan",
    "First Name": "Josiah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37512847": {
    "id": "item_35501",
    "Last Name": "Stoker",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37513711": {
    "id": "item_23468",
    "Last Name": "Tsai",
    "First Name": "Tsung-Yu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37513730": {
    "id": "item_10329",
    "Last Name": "Unsworth",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514133": {
    "id": "item_24540",
    "Last Name": "Wong",
    "First Name": "Wesley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514208": {
    "id": "item_12109",
    "Last Name": "Sheng",
    "First Name": "Erbang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514217": {
    "id": "item_35496",
    "Last Name": "Yoo",
    "First Name": "Daeseok",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514273": {
    "id": "item_24538",
    "Last Name": "Czak",
    "First Name": "Bozena",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514476": {
    "id": "item_35495",
    "Last Name": "Watt",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514477": {
    "id": "item_35494",
    "Last Name": "Foster",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37514642": {
    "id": "item_35490",
    "Last Name": "Gibbons",
    "First Name": "Alan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515095": {
    "id": "item_35488",
    "Last Name": "Paraoan",
    "First Name": "Dianne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515100": {
    "id": "item_12103",
    "Last Name": "Zhai",
    "First Name": "Yi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515146": {
    "id": "item_35487",
    "Last Name": "Barlow",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515550": {
    "id": "item_35483",
    "Last Name": "Breen",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37515934": {
    "id": "item_35772",
    "Last Name": "Taggart",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37516008": {
    "id": "item_24530",
    "Last Name": "Napier",
    "First Name": "Libby",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37516265": {
    "id": "item_35481",
    "Last Name": "Zhang",
    "First Name": "Becky",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518083": {
    "id": "item_24521",
    "Last Name": "Huddle",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37518181": {
    "id": "item_24878",
    "Last Name": "Kergastel",
    "First Name": "Regis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519118": {
    "id": "item_24823",
    "Last Name": "CONSTANT",
    "First Name": "CARLOTTA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519251": {
    "id": "item_24515",
    "Last Name": "Zepina",
    "First Name": "Luka",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519302": {
    "id": "item_10318",
    "Last Name": "Wells",
    "First Name": "Leshay",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519560": {
    "id": "item_23467",
    "Last Name": "Zhenghong",
    "First Name": "Wu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519781": {
    "id": "item_35473",
    "Last Name": "Aguilor",
    "First Name": "Manny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519864": {
    "id": "item_12088",
    "Last Name": "LIANG",
    "First Name": "JHERUEI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519884": {
    "id": "item_35472",
    "Last Name": "Shanahan",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37519975": {
    "id": "item_35471",
    "Last Name": "Hawker",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520041": {
    "id": "item_10314",
    "Last Name": "Oliveira",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520293": {
    "id": "item_24510",
    "Last Name": "Izteleuova",
    "First Name": "Indira",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520759": {
    "id": "item_10312",
    "Last Name": "Li",
    "First Name": "Zhe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37520992": {
    "id": "item_35469",
    "Last Name": "CHIU",
    "First Name": "SHUHUA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521008": {
    "id": "item_10310",
    "Last Name": "CHEN",
    "First Name": "CHINGWEI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521592": {
    "id": "item_12083",
    "Last Name": "Boyes",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37521836": {
    "id": "item_24877",
    "Last Name": "Chou",
    "First Name": "Chih-Hung",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37522207": {
    "id": "item_35468",
    "Last Name": "Isoldi",
    "First Name": "Keith",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37522423": {
    "id": "item_10308",
    "Last Name": "Huang",
    "First Name": "Lei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37523624": {
    "id": "item_35462",
    "Last Name": "Rice",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37525195": {
    "id": "item_35460",
    "Last Name": "GIL DE OLIVEIRA",
    "First Name": "ALEXANDRE LUIS",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37536903": {
    "id": "item_10304",
    "Last Name": "Pritchard",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556577": {
    "id": "item_35457",
    "Last Name": "Panangian",
    "First Name": "Andriano Hosny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556706": {
    "id": "item_35455",
    "Last Name": "Duffy",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37556866": {
    "id": "item_24494",
    "Last Name": "Brohier",
    "First Name": "Gladstone",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37557104": {
    "id": "item_12075",
    "Last Name": "McConnell",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37557164": {
    "id": "item_35454",
    "Last Name": "Jena",
    "First Name": "Santosh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558529": {
    "id": "item_35451",
    "Last Name": "Shepherd",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37558799": {
    "id": "item_12071",
    "Last Name": "Gu",
    "First Name": "Binxiong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37560467": {
    "id": "item_12068",
    "Last Name": "MacFarlane",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37560939": {
    "id": "item_23459",
    "Last Name": "CHO",
    "First Name": "YUK LING YOLANDA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37561159": {
    "id": "item_35448",
    "Last Name": "Mills",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37561508": {
    "id": "item_12065",
    "Last Name": "Nielsen",
    "First Name": "Jed",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37561764": {
    "id": "item_35771",
    "Last Name": "Cunanan",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562186": {
    "id": "item_23457",
    "Last Name": "Archbold",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562226": {
    "id": "item_10296",
    "Last Name": "hou",
    "First Name": "jie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562562": {
    "id": "item_10295",
    "Last Name": "LIU",
    "First Name": "YI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562618": {
    "id": "item_23453",
    "Last Name": "Qualskul",
    "First Name": "Pichet",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37562735": {
    "id": "item_12062",
    "Last Name": "hardie",
    "First Name": "sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37563430": {
    "id": "item_35442",
    "Last Name": "Lan",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37565819": {
    "id": "item_35440",
    "Last Name": "Gascard",
    "First Name": "Jack",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37565908": {
    "id": "item_10294",
    "Last Name": "Hunter",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566328": {
    "id": "item_12058",
    "Last Name": "LIN",
    "First Name": "YEHHSIN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566514": {
    "id": "item_35439",
    "Last Name": "van Besien",
    "First Name": "Maaike",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566567": {
    "id": "item_12055",
    "Last Name": "Bei",
    "First Name": "Chen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566699": {
    "id": "item_38262",
    "Last Name": "Whoang",
    "First Name": "Intae",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37566817": {
    "id": "item_35438",
    "Last Name": "Paee",
    "First Name": "Khairul Faizal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567022": {
    "id": "item_35437",
    "Last Name": "Storey",
    "First Name": "Lyndon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567157": {
    "id": "item_23436",
    "Last Name": "Sammut",
    "First Name": "Keegan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567263": {
    "id": "item_12349",
    "Last Name": "YEH",
    "First Name": "POCHI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567330": {
    "id": "item_10287",
    "Last Name": "Yong",
    "First Name": "Jiang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567448": {
    "id": "item_10285",
    "Last Name": "Lennon",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567497": {
    "id": "item_10284",
    "Last Name": "Sicard",
    "First Name": "Tanguy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567559": {
    "id": "item_35433",
    "Last Name": "SAENGKITTIPAIBUL",
    "First Name": "CHANKIT",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567811": {
    "id": "item_10548",
    "Last Name": "Murphy",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567850": {
    "id": "item_10281",
    "Last Name": "Kuchinad",
    "First Name": "Amar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37567868": {
    "id": "item_10280",
    "Last Name": "Ghamgosar",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37568230": {
    "id": "item_23429",
    "Last Name": "Tang",
    "First Name": "Joe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37573580": {
    "id": "item_23422",
    "Last Name": "frantz",
    "First Name": "patrice",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37585132": {
    "id": "item_35770",
    "Last Name": "Somchanakit",
    "First Name": "Yosaphon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37587958": {
    "id": "item_35424",
    "Last Name": "Sutticheun",
    "First Name": "Kritiya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37600190": {
    "id": "item_35423",
    "Last Name": "Sweet",
    "First Name": "April",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37610052": {
    "id": "item_23420",
    "Last Name": "Zheng",
    "First Name": "Hao",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37631622": {
    "id": "item_35422",
    "Last Name": "Fary_ski",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37632386": {
    "id": "item_10270",
    "Last Name": "ARAI",
    "First Name": "RYO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37634022": {
    "id": "item_12034",
    "Last Name": "Hammoudi",
    "First Name": "Khaled",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37645117": {
    "id": "item_12032",
    "Last Name": "Tyrus",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37645194": {
    "id": "item_23415",
    "Last Name": "O'Connor",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646284": {
    "id": "item_23410",
    "Last Name": "Madeira",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646470": {
    "id": "item_23406",
    "Last Name": "OÕBrien",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37646990": {
    "id": "item_12026",
    "Last Name": "Tebbey",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647210": {
    "id": "item_12025",
    "Last Name": "Ng",
    "First Name": "Iong Pan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647217": {
    "id": "item_23400",
    "Last Name": "Davies",
    "First Name": "Ashlynn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647357": {
    "id": "item_23399",
    "Last Name": "Hardy",
    "First Name": "Jose",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647642": {
    "id": "item_35414",
    "Last Name": "Bell",
    "First Name": "Peta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37647776": {
    "id": "item_12024",
    "Last Name": "Rabdanov",
    "First Name": "Bator",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37648274": {
    "id": "item_35737",
    "Last Name": "Martinez",
    "First Name": "Edgar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37648333": {
    "id": "item_23394",
    "Last Name": "Chantarawirod",
    "First Name": "Husai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37648617": {
    "id": "item_23389",
    "Last Name": "Nguyen",
    "First Name": "Keane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37649718": {
    "id": "item_35408",
    "Last Name": "Mazzarella",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37649899": {
    "id": "item_23387",
    "Last Name": "Ferguson",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37649912": {
    "id": "item_23385",
    "Last Name": "Nugent",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37649958": {
    "id": "item_35406",
    "Last Name": "Heath",
    "First Name": "Susie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650210": {
    "id": "item_35405",
    "Last Name": "Gochnour",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650216": {
    "id": "item_35404",
    "Last Name": "Rothwell",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650513": {
    "id": "item_10252",
    "Last Name": "Lotin",
    "First Name": "FrŽderique",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650529": {
    "id": "item_10251",
    "Last Name": "Chan",
    "First Name": "Kai Pan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37650949": {
    "id": "item_35401",
    "Last Name": "Rodriguez",
    "First Name": "Edgar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651295": {
    "id": "item_35400",
    "Last Name": "Vandenberg",
    "First Name": "Will",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651534": {
    "id": "item_10249",
    "Last Name": "Paroz",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651596": {
    "id": "item_23375",
    "Last Name": "Haynes",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37651914": {
    "id": "item_12012",
    "Last Name": "Warburton",
    "First Name": "Trevor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652142": {
    "id": "item_23372",
    "Last Name": "Stanley",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652201": {
    "id": "item_10245",
    "Last Name": "Rutherford",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652291": {
    "id": "item_23370",
    "Last Name": "Bulman",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652632": {
    "id": "item_23369",
    "Last Name": "Serrano",
    "First Name": "Julian Sebar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652735": {
    "id": "item_35393",
    "Last Name": "Hearnden",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652799": {
    "id": "item_10243",
    "Last Name": "Silva",
    "First Name": "Gildo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652873": {
    "id": "item_10241",
    "Last Name": "Cawthra",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37652983": {
    "id": "item_24480",
    "Last Name": "Soetardjo",
    "First Name": "Robert Donald",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37653984": {
    "id": "item_23360",
    "Last Name": "Yiu",
    "First Name": "Melva",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37654629": {
    "id": "item_23358",
    "Last Name": "Gatto",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37654694": {
    "id": "item_23357",
    "Last Name": "Han",
    "First Name": "jihoon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37665553": {
    "id": "item_12001",
    "Last Name": "De Azevedo Niero",
    "First Name": "Reinor Estevam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37675359": {
    "id": "item_10236",
    "Last Name": "Deshommes",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37680117": {
    "id": "item_12348",
    "Last Name": "berce",
    "First Name": "andrej",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37681058": {
    "id": "item_24479",
    "Last Name": "Alvarez",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37693870": {
    "id": "item_24876",
    "Last Name": "Sy Quimsiam",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37694236": {
    "id": "item_35385",
    "Last Name": "Croguennec",
    "First Name": "Talia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37694832": {
    "id": "item_12347",
    "Last Name": "Witter",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37697114": {
    "id": "item_35383",
    "Last Name": "Landis",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37699060": {
    "id": "item_11996",
    "Last Name": "MARUN",
    "First Name": "ANDRES",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37699072": {
    "id": "item_23353",
    "Last Name": "James",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37699232": {
    "id": "item_35380",
    "Last Name": "Horscroft",
    "First Name": "Virginia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37699616": {
    "id": "item_10233",
    "Last Name": "Schemel",
    "First Name": "Straten",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37700321": {
    "id": "item_11994",
    "Last Name": "Salkeld",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37700348": {
    "id": "item_35375",
    "Last Name": "McKinnon",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37700355": {
    "id": "item_11993",
    "Last Name": "Furrer",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37701412": {
    "id": "item_11992",
    "Last Name": "Kirley",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37701757": {
    "id": "item_35373",
    "Last Name": "Robinson",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37701885": {
    "id": "item_35372",
    "Last Name": "Pelayo",
    "First Name": "Juan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702129": {
    "id": "item_35369",
    "Last Name": "Claunch",
    "First Name": "Zina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702369": {
    "id": "item_10547",
    "Last Name": "Baker",
    "First Name": "Cade",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702428": {
    "id": "item_35367",
    "Last Name": "Potter",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702590": {
    "id": "item_23345",
    "Last Name": "McCabe",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702632": {
    "id": "item_35366",
    "Last Name": "Howarth",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702797": {
    "id": "item_23344",
    "Last Name": "D'Ettorre",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37702993": {
    "id": "item_35364",
    "Last Name": "Kapla",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703039": {
    "id": "item_24476",
    "Last Name": "Lin",
    "First Name": "Yuan Tan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703390": {
    "id": "item_23343",
    "Last Name": "Arias",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37703399": {
    "id": "item_35362",
    "Last Name": "Sertori",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704170": {
    "id": "item_11985",
    "Last Name": "Auger",
    "First Name": "Pascal-Andre",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37704295": {
    "id": "item_35353",
    "Last Name": "Garcia",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705192": {
    "id": "item_23337",
    "Last Name": "Olives",
    "First Name": "Javier",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705226": {
    "id": "item_35350",
    "Last Name": "Carro Garcia",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705374": {
    "id": "item_23335",
    "Last Name": "Harwood",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37705813": {
    "id": "item_38260",
    "Last Name": "Kaur",
    "First Name": "Jaskiran",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706047": {
    "id": "item_23330",
    "Last Name": "Lam",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706170": {
    "id": "item_11976",
    "Last Name": "Bergamin",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706202": {
    "id": "item_11975",
    "Last Name": "Nturubika",
    "First Name": "Bukuru",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706263": {
    "id": "item_24875",
    "Last Name": "Wolsky",
    "First Name": "Sascha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706400": {
    "id": "item_38255",
    "Last Name": "Ko",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706409": {
    "id": "item_23328",
    "Last Name": "Mendoza",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37706448": {
    "id": "item_35340",
    "Last Name": "Woodward",
    "First Name": "Jess",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37707097": {
    "id": "item_11973",
    "Last Name": "Chang",
    "First Name": "Wei Min",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37707615": {
    "id": "item_35338",
    "Last Name": "Yung",
    "First Name": "Cheuk Hei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37707727": {
    "id": "item_11970",
    "Last Name": "McDermott",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37707750": {
    "id": "item_35336",
    "Last Name": "JORDAN",
    "First Name": "MICHAEL",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37710024": {
    "id": "item_10216",
    "Last Name": "Narasimhan",
    "First Name": "Prashanth",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37711998": {
    "id": "item_10215",
    "Last Name": "Richardson",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712564": {
    "id": "item_38243",
    "Last Name": "McDonald",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712632": {
    "id": "item_38241",
    "Last Name": "Lama",
    "First Name": "Casey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712696": {
    "id": "item_38238",
    "Last Name": "Gamio",
    "First Name": "Rosario",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37712767": {
    "id": "item_38239",
    "Last Name": "Truong",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37713497": {
    "id": "item_10210",
    "Last Name": "Graham",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714584": {
    "id": "item_23319",
    "Last Name": "Wilden",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37714658": {
    "id": "item_24469",
    "Last Name": "Kraizelburd",
    "First Name": "Nataniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715023": {
    "id": "item_23317",
    "Last Name": "Smithson-Tomas",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715374": {
    "id": "item_23316",
    "Last Name": "Ma",
    "First Name": "Boris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715471": {
    "id": "item_38226",
    "Last Name": "Cepeda",
    "First Name": "Hector",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715590": {
    "id": "item_35318",
    "Last Name": "Lo",
    "First Name": "Alfred",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715599": {
    "id": "item_11956",
    "Last Name": "Smith",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715816": {
    "id": "item_10207",
    "Last Name": "Beer",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37715891": {
    "id": "item_11954",
    "Last Name": "Petersen",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716079": {
    "id": "item_10546",
    "Last Name": "Doubell",
    "First Name": "Logan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716262": {
    "id": "item_38219",
    "Last Name": "Moran",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716291": {
    "id": "item_38218",
    "Last Name": "Miels",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716387": {
    "id": "item_10203",
    "Last Name": "koltermann",
    "First Name": "scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716398": {
    "id": "item_38215",
    "Last Name": "Tsalko",
    "First Name": "Artsiom",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716410": {
    "id": "item_11952",
    "Last Name": "Maher",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716490": {
    "id": "item_10545",
    "Last Name": "RANQUE",
    "First Name": "SAMUEL RANULLO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716492": {
    "id": "item_24874",
    "Last Name": "Wong",
    "First Name": "Ho Yi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716547": {
    "id": "item_10201",
    "Last Name": "Lynch",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716631": {
    "id": "item_35769",
    "Last Name": "Boonkong",
    "First Name": "Kulisara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716665": {
    "id": "item_11951",
    "Last Name": "Madsen",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716671": {
    "id": "item_11950",
    "Last Name": "Takada",
    "First Name": "Akihiro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716674": {
    "id": "item_38209",
    "Last Name": "stacey",
    "First Name": "dale",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716843": {
    "id": "item_38207",
    "Last Name": "Huggins",
    "First Name": "Faryn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716895": {
    "id": "item_23304",
    "Last Name": "Kincaid",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37716986": {
    "id": "item_23303",
    "Last Name": "Cook",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717189": {
    "id": "item_11946",
    "Last Name": "CHU",
    "First Name": "YUANFENG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717235": {
    "id": "item_35309",
    "Last Name": "Wood",
    "First Name": "Freddie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717271": {
    "id": "item_11945",
    "Last Name": "England",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717274": {
    "id": "item_11944",
    "Last Name": "Morel",
    "First Name": "Olivier",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717388": {
    "id": "item_23300",
    "Last Name": "Roberts",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717400": {
    "id": "item_35307",
    "Last Name": "Wong",
    "First Name": "Chi Man",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717442": {
    "id": "item_35306",
    "Last Name": "Sharma",
    "First Name": "Ritwik",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717519": {
    "id": "item_11941",
    "Last Name": "Mckean",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717574": {
    "id": "item_35305",
    "Last Name": "Graham",
    "First Name": "Zac",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717579": {
    "id": "item_38197",
    "Last Name": "eun chan",
    "First Name": "ju",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717757": {
    "id": "item_38195",
    "Last Name": "Miller",
    "First Name": "Anne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717794": {
    "id": "item_38194",
    "Last Name": "Cai",
    "First Name": "Jacky",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37717999": {
    "id": "item_11940",
    "Last Name": "Law",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718188": {
    "id": "item_11939",
    "Last Name": "Yang",
    "First Name": "Cally",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718414": {
    "id": "item_10196",
    "Last Name": "Velipasalar",
    "First Name": "Oztan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37718656": {
    "id": "item_38189",
    "Last Name": "Nilam",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37719378": {
    "id": "item_35297",
    "Last Name": "Ng",
    "First Name": "Oliver HL",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37719811": {
    "id": "item_23294",
    "Last Name": "Lau",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37720083": {
    "id": "item_10195",
    "Last Name": "Bowes",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37720297": {
    "id": "item_11934",
    "Last Name": "Teng",
    "First Name": "Junn Wei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37721027": {
    "id": "item_11932",
    "Last Name": "Heinrich",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37721252": {
    "id": "item_23293",
    "Last Name": "Dos Santos",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37721402": {
    "id": "item_38182",
    "Last Name": "Zhang",
    "First Name": "Shumin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37721415": {
    "id": "item_38179",
    "Last Name": "BERNY",
    "First Name": "IVANA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37721535": {
    "id": "item_38180",
    "Last Name": "Treanor",
    "First Name": "Maeve",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37721645": {
    "id": "item_35294",
    "Last Name": "Lonie",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37721933": {
    "id": "item_38176",
    "Last Name": "Hewitt",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37722289": {
    "id": "item_10193",
    "Last Name": "Heffernan",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37722681": {
    "id": "item_10191",
    "Last Name": "Giggins",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37722740": {
    "id": "item_10190",
    "Last Name": "Shearer",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37722789": {
    "id": "item_38172",
    "Last Name": "Mansfield",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37723070": {
    "id": "item_38170",
    "Last Name": "Ligertwood",
    "First Name": "Alan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37723405": {
    "id": "item_11930",
    "Last Name": "Schreuder",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724451": {
    "id": "item_35288",
    "Last Name": "Chung",
    "First Name": "Lamuel Chi Hay",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37724750": {
    "id": "item_35287",
    "Last Name": "Warner",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37725479": {
    "id": "item_10184",
    "Last Name": "NAGARAJ",
    "First Name": "PRATHEEK",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726098": {
    "id": "item_11922",
    "Last Name": "Schaverien",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726109": {
    "id": "item_38152",
    "Last Name": "Dickey",
    "First Name": "Colm",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726190": {
    "id": "item_11921",
    "Last Name": "Quinn",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726304": {
    "id": "item_35281",
    "Last Name": "Rawlinson",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726368": {
    "id": "item_38150",
    "Last Name": "Shapiro",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726539": {
    "id": "item_11920",
    "Last Name": "FitzGerald",
    "First Name": "Molly",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726886": {
    "id": "item_38147",
    "Last Name": "Giffin",
    "First Name": "Janice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37726901": {
    "id": "item_23272",
    "Last Name": "Casey",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727137": {
    "id": "item_38145",
    "Last Name": "Ding",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727415": {
    "id": "item_35277",
    "Last Name": "Follett",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727541": {
    "id": "item_35276",
    "Last Name": "Pai",
    "First Name": "Chunyi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727777": {
    "id": "item_38139",
    "Last Name": "Morsley",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727925": {
    "id": "item_35275",
    "Last Name": "Gieselmann",
    "First Name": "Lukas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37727961": {
    "id": "item_10178",
    "Last Name": "Vnuk",
    "First Name": "Lu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728131": {
    "id": "item_35274",
    "Last Name": "West",
    "First Name": "Genevieve",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728167": {
    "id": "item_23266",
    "Last Name": "Finn",
    "First Name": "Calvin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728238": {
    "id": "item_38133",
    "Last Name": "Wong",
    "First Name": "Chak Ming",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728581": {
    "id": "item_10173",
    "Last Name": "LAI",
    "First Name": "CHI YIN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728770": {
    "id": "item_38127",
    "Last Name": "roberts",
    "First Name": "dafydd",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728788": {
    "id": "item_38125",
    "Last Name": "carreon",
    "First Name": "nino",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728891": {
    "id": "item_38121",
    "Last Name": "Wiechula",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728916": {
    "id": "item_35270",
    "Last Name": "Humphreys",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37728978": {
    "id": "item_38118",
    "Last Name": "LEE",
    "First Name": "SONG YEON",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729164": {
    "id": "item_38116",
    "Last Name": "Wang",
    "First Name": "MuLei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729351": {
    "id": "item_23259",
    "Last Name": "Wong",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729822": {
    "id": "item_35266",
    "Last Name": "Achilike",
    "First Name": "Immaculeta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37729965": {
    "id": "item_38113",
    "Last Name": "JUNMIN",
    "First Name": "HAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37730056": {
    "id": "item_23256",
    "Last Name": "Kelly",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37730561": {
    "id": "item_24873",
    "Last Name": "Prieto",
    "First Name": "Matias",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37730714": {
    "id": "item_38110",
    "Last Name": "li",
    "First Name": "zhixian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37730785": {
    "id": "item_35265",
    "Last Name": "Kuzmin",
    "First Name": "Dima",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37731398": {
    "id": "item_23253",
    "Last Name": "Bromley",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37731715": {
    "id": "item_38107",
    "Last Name": "Chen",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37731773": {
    "id": "item_38106",
    "Last Name": "Talbi",
    "First Name": "Sachiko",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37732203": {
    "id": "item_38103",
    "Last Name": "Sanchez",
    "First Name": "Paola",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37733949": {
    "id": "item_23247",
    "Last Name": "Mukhopadhyay",
    "First Name": "Dibya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37733968": {
    "id": "item_35260",
    "Last Name": "Dominguez",
    "First Name": "Emilio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734116": {
    "id": "item_23245",
    "Last Name": "Shepherd",
    "First Name": "Jase",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734184": {
    "id": "item_35258",
    "Last Name": "Lam",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734584": {
    "id": "item_24462",
    "Last Name": "Borghesi",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734875": {
    "id": "item_24461",
    "Last Name": "Watters",
    "First Name": "Donal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734914": {
    "id": "item_10167",
    "Last Name": "Lopez Ramirez",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37734992": {
    "id": "item_35256",
    "Last Name": "Trapp",
    "First Name": "Ronnie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735109": {
    "id": "item_35255",
    "Last Name": "Hsieh",
    "First Name": "Dong-Yeong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735224": {
    "id": "item_38093",
    "Last Name": "Dutney",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735370": {
    "id": "item_38091",
    "Last Name": "Murray",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735554": {
    "id": "item_35253",
    "Last Name": "Maandig",
    "First Name": "Jillian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735567": {
    "id": "item_10166",
    "Last Name": "Allday",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735620": {
    "id": "item_38089",
    "Last Name": "Roughan",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735810": {
    "id": "item_23241",
    "Last Name": "Whiteley",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735823": {
    "id": "item_38088",
    "Last Name": "Keen",
    "First Name": "Nathaniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735852": {
    "id": "item_38085",
    "Last Name": "Li",
    "First Name": "Baoxiang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37735961": {
    "id": "item_23240",
    "Last Name": "Whiteley",
    "First Name": "Montana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37736129": {
    "id": "item_38084",
    "Last Name": "LIN",
    "First Name": "CHIN YU",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37736360": {
    "id": "item_38082",
    "Last Name": "Zhang",
    "First Name": "Weikun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37736507": {
    "id": "item_23235",
    "Last Name": "CHAN",
    "First Name": "CHI FUNG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37736510": {
    "id": "item_10162",
    "Last Name": "Mikus",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37736576": {
    "id": "item_38081",
    "Last Name": "Vega",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37737964": {
    "id": "item_11904",
    "Last Name": "Bloom",
    "First Name": "Maxwell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738081": {
    "id": "item_10160",
    "Last Name": "Clements",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738298": {
    "id": "item_35248",
    "Last Name": "Peck",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738794": {
    "id": "item_35242",
    "Last Name": "Hayes",
    "First Name": "Jerim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738805": {
    "id": "item_35240",
    "Last Name": "Hart",
    "First Name": "Josephine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37738839": {
    "id": "item_35241",
    "Last Name": "Palermo",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739162": {
    "id": "item_10156",
    "Last Name": "Allen",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739163": {
    "id": "item_38076",
    "Last Name": "Warr",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739191": {
    "id": "item_38072",
    "Last Name": "son",
    "First Name": "jeongdai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739208": {
    "id": "item_35237",
    "Last Name": "Setyawan",
    "First Name": "Harwin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739219": {
    "id": "item_23227",
    "Last Name": "Longland",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739380": {
    "id": "item_38071",
    "Last Name": "Kilborn",
    "First Name": "Roderick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37739671": {
    "id": "item_35234",
    "Last Name": "Lenzner",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740128": {
    "id": "item_23222",
    "Last Name": "Kemp",
    "First Name": "Rohan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740292": {
    "id": "item_23221",
    "Last Name": "fongjoyo",
    "First Name": "welly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740350": {
    "id": "item_24459",
    "Last Name": "upton",
    "First Name": "david",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740463": {
    "id": "item_38063",
    "Last Name": "YEUNG",
    "First Name": "JASON",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740615": {
    "id": "item_11897",
    "Last Name": "Halupka",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740800": {
    "id": "item_10150",
    "Last Name": "Copeland",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740819": {
    "id": "item_23215",
    "Last Name": "OÕNeill",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37740849": {
    "id": "item_38058",
    "Last Name": "PEREZ",
    "First Name": "ELADIO JR",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741069": {
    "id": "item_38051",
    "Last Name": "Arba",
    "First Name": "Rendra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741143": {
    "id": "item_38050",
    "Last Name": "FitzGerald",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741213": {
    "id": "item_10144",
    "Last Name": "Chamley",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741250": {
    "id": "item_38048",
    "Last Name": "Santos",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741552": {
    "id": "item_38042",
    "Last Name": "Christensen",
    "First Name": "Juliana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741609": {
    "id": "item_35223",
    "Last Name": "Monks",
    "First Name": "Holly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741853": {
    "id": "item_11890",
    "Last Name": "Foye",
    "First Name": "Rory",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741882": {
    "id": "item_35222",
    "Last Name": "LANG",
    "First Name": "YING",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37741925": {
    "id": "item_23207",
    "Last Name": "LI",
    "First Name": "HAIYAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37742477": {
    "id": "item_10139",
    "Last Name": "zhong",
    "First Name": "hua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37742572": {
    "id": "item_38037",
    "Last Name": "McQueen",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37742601": {
    "id": "item_10138",
    "Last Name": "Malcolm",
    "First Name": "Cory",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37742898": {
    "id": "item_38032",
    "Last Name": "Belot",
    "First Name": "Titouan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37743312": {
    "id": "item_38030",
    "Last Name": "Veerappan",
    "First Name": "Vimalkumar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37744225": {
    "id": "item_38029",
    "Last Name": "Smoker",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37744292": {
    "id": "item_10136",
    "Last Name": "Massafra",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37744820": {
    "id": "item_23199",
    "Last Name": "Goldberg",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37744919": {
    "id": "item_11886",
    "Last Name": "Leaney",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745086": {
    "id": "item_38025",
    "Last Name": "Acot Acot",
    "First Name": "Maricel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745188": {
    "id": "item_38024",
    "Last Name": "Mc Sorley",
    "First Name": "Catriona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745334": {
    "id": "item_38022",
    "Last Name": "DAVIES",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745845": {
    "id": "item_11883",
    "Last Name": "Wallace",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745865": {
    "id": "item_23193",
    "Last Name": "Stevens",
    "First Name": "Eddie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745942": {
    "id": "item_35212",
    "Last Name": "Chan",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745948": {
    "id": "item_23192",
    "Last Name": "Scialdone",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37745966": {
    "id": "item_23191",
    "Last Name": "Ewing-Sykes",
    "First Name": "Aedan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746146": {
    "id": "item_11882",
    "Last Name": "Francis",
    "First Name": "Byron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746246": {
    "id": "item_35210",
    "Last Name": "Veis",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746659": {
    "id": "item_38015",
    "Last Name": "Peralta",
    "First Name": "Elena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746677": {
    "id": "item_35208",
    "Last Name": "Kartika",
    "First Name": "Ira Purwani",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37746991": {
    "id": "item_38013",
    "Last Name": "White",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747131": {
    "id": "item_23185",
    "Last Name": "Cheng",
    "First Name": "Kei Yip",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747684": {
    "id": "item_35204",
    "Last Name": "YEO",
    "First Name": "POR CHING",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747907": {
    "id": "item_11880",
    "Last Name": "Cantelo",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37747964": {
    "id": "item_38012",
    "Last Name": "Liddell",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748027": {
    "id": "item_23184",
    "Last Name": "Conaty",
    "First Name": "Muireann",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748168": {
    "id": "item_38009",
    "Last Name": "Romero",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748431": {
    "id": "item_38008",
    "Last Name": "Lukic",
    "First Name": "Nick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748470": {
    "id": "item_35201",
    "Last Name": "Avery",
    "First Name": "Trent",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748521": {
    "id": "item_23501",
    "Last Name": "Lim",
    "First Name": "Celeste",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748531": {
    "id": "item_38004",
    "Last Name": "Chu",
    "First Name": "Victor Breckow",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748852": {
    "id": "item_38000",
    "Last Name": "Ongkowijaya",
    "First Name": "Mario Christofel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37748970": {
    "id": "item_37999",
    "Last Name": "Morettin",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749290": {
    "id": "item_23179",
    "Last Name": "Chiappazzo",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749340": {
    "id": "item_10128",
    "Last Name": "Ku",
    "First Name": "Yao Hsuan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749349": {
    "id": "item_10127",
    "Last Name": "Hodges",
    "First Name": "Rupert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749481": {
    "id": "item_37994",
    "Last Name": "Kang",
    "First Name": "HoJung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749493": {
    "id": "item_37993",
    "Last Name": "Bingham",
    "First Name": "Ardialo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749554": {
    "id": "item_37992",
    "Last Name": "MENG",
    "First Name": "ZHAOJIAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749793": {
    "id": "item_10124",
    "Last Name": "Nguyen",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37749918": {
    "id": "item_35768",
    "Last Name": "Campbell",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37750349": {
    "id": "item_11869",
    "Last Name": "Takaoka",
    "First Name": "Masahiro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37750826": {
    "id": "item_37983",
    "Last Name": "Fisher",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37751462": {
    "id": "item_11864",
    "Last Name": "Pember",
    "First Name": "Rhett",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37751606": {
    "id": "item_35192",
    "Last Name": "Floyd",
    "First Name": "Tyrel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37751942": {
    "id": "item_24872",
    "Last Name": "Zhu",
    "First Name": "Qiuye",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37751948": {
    "id": "item_23168",
    "Last Name": "Bollman",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37752075": {
    "id": "item_10119",
    "Last Name": "Hayda",
    "First Name": "Yuriy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37752150": {
    "id": "item_11862",
    "Last Name": "Yu",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37752496": {
    "id": "item_37982",
    "Last Name": "Sanchez",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37752827": {
    "id": "item_11861",
    "Last Name": "CUENCA",
    "First Name": "ANDRES",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37752938": {
    "id": "item_37979",
    "Last Name": "belarbi",
    "First Name": "amin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37752986": {
    "id": "item_37978",
    "Last Name": "Tang",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37753471": {
    "id": "item_10118",
    "Last Name": "Anderson",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37753701": {
    "id": "item_24870",
    "Last Name": "Plain",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37753846": {
    "id": "item_35189",
    "Last Name": "Da Rin",
    "First Name": "Federica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37753854": {
    "id": "item_37975",
    "Last Name": "Prasad",
    "First Name": "Vivek",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37753865": {
    "id": "item_37974",
    "Last Name": "Stewart",
    "First Name": "Lindsey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37753882": {
    "id": "item_37972",
    "Last Name": "Stewart",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37753970": {
    "id": "item_35188",
    "Last Name": "Dermott",
    "First Name": "Cassidy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754036": {
    "id": "item_24871",
    "Last Name": "Wood",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754094": {
    "id": "item_23165",
    "Last Name": "Deng",
    "First Name": "Haoyu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754100": {
    "id": "item_11860",
    "Last Name": "MU„OZ SANTANA",
    "First Name": "SINDY",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754653": {
    "id": "item_23163",
    "Last Name": "May",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37754983": {
    "id": "item_23162",
    "Last Name": "Smith",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755103": {
    "id": "item_37968",
    "Last Name": "Reid",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755151": {
    "id": "item_23161",
    "Last Name": "Planella",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755299": {
    "id": "item_37965",
    "Last Name": "Prota",
    "First Name": "Lorenzo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755479": {
    "id": "item_37964",
    "Last Name": "Cash",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755594": {
    "id": "item_37963",
    "Last Name": "Cox",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755768": {
    "id": "item_37961",
    "Last Name": "Kurniawan",
    "First Name": "Ongki",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37755784": {
    "id": "item_23158",
    "Last Name": "Paterson",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37756210": {
    "id": "item_37959",
    "Last Name": "Steyn",
    "First Name": "Lambrie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37756262": {
    "id": "item_37956",
    "Last Name": "Malan",
    "First Name": "Dawie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37756307": {
    "id": "item_35179",
    "Last Name": "Strikwerda-Brown",
    "First Name": "Cherie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37756475": {
    "id": "item_35767",
    "Last Name": "CHENG",
    "First Name": "JENHAO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37756746": {
    "id": "item_23154",
    "Last Name": "Johnstone",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37757019": {
    "id": "item_35177",
    "Last Name": "Yun",
    "First Name": "Sohui",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37757103": {
    "id": "item_10108",
    "Last Name": "Cooper",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37760228": {
    "id": "item_10105",
    "Last Name": "Mitchell",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37760284": {
    "id": "item_23152",
    "Last Name": "Jenvey",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37760291": {
    "id": "item_37950",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37760403": {
    "id": "item_37946",
    "Last Name": "Langham",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37760442": {
    "id": "item_11852",
    "Last Name": "Allen",
    "First Name": "Triegue",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37761946": {
    "id": "item_23149",
    "Last Name": "Nelson",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37763086": {
    "id": "item_37945",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37763099": {
    "id": "item_10100",
    "Last Name": "Holland",
    "First Name": "Rayne",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37763125": {
    "id": "item_37942",
    "Last Name": "Paglomutan",
    "First Name": "Zandrix",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37763126": {
    "id": "item_37943",
    "Last Name": "Schwedhelm",
    "First Name": "Diana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37769125": {
    "id": "item_10099",
    "Last Name": "Quin",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37769625": {
    "id": "item_23148",
    "Last Name": "Ford",
    "First Name": "Owen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37774085": {
    "id": "item_11846",
    "Last Name": "Fouhy",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37774533": {
    "id": "item_23147",
    "Last Name": "Bae",
    "First Name": "Hyeonji",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37774655": {
    "id": "item_35167",
    "Last Name": "LIN",
    "First Name": "MEIHUI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37774805": {
    "id": "item_24452",
    "Last Name": "Ameer",
    "First Name": "Muhammad Yusuf",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37774956": {
    "id": "item_11844",
    "Last Name": "Sneddon",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775020": {
    "id": "item_24869",
    "Last Name": "Wawczak",
    "First Name": "Yves",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775107": {
    "id": "item_35166",
    "Last Name": "Holmes",
    "First Name": "Nia-Lydia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775133": {
    "id": "item_35165",
    "Last Name": "Churchill",
    "First Name": "Keegan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775159": {
    "id": "item_11843",
    "Last Name": "Bartlett",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775266": {
    "id": "item_37930",
    "Last Name": "Andes",
    "First Name": "Suzeth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775312": {
    "id": "item_10095",
    "Last Name": "Fazzalari",
    "First Name": "Angelo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775495": {
    "id": "item_35162",
    "Last Name": "Revington",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775565": {
    "id": "item_11842",
    "Last Name": "Ryan",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775586": {
    "id": "item_35161",
    "Last Name": "Wilson",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775690": {
    "id": "item_37928",
    "Last Name": "Randall",
    "First Name": "Anne-Marie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775726": {
    "id": "item_35159",
    "Last Name": "Halasinski",
    "First Name": "Erinn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775736": {
    "id": "item_10090",
    "Last Name": "Tokoro",
    "First Name": "Saki",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775840": {
    "id": "item_23142",
    "Last Name": "Denk",
    "First Name": "Ron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775847": {
    "id": "item_35156",
    "Last Name": "Schmidt",
    "First Name": "Madelyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775879": {
    "id": "item_37925",
    "Last Name": "Good",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37775940": {
    "id": "item_35155",
    "Last Name": "Rushbrooke",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776165": {
    "id": "item_23138",
    "Last Name": "Podgorski",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776220": {
    "id": "item_37921",
    "Last Name": "Punusingon",
    "First Name": "Blessy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776269": {
    "id": "item_37920",
    "Last Name": "Mountford",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37776460": {
    "id": "item_11839",
    "Last Name": "Iwakabe",
    "First Name": "Shigeru",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37777311": {
    "id": "item_23136",
    "Last Name": "Liwlompaisan",
    "First Name": "Wisit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37777484": {
    "id": "item_23134",
    "Last Name": "Collazo",
    "First Name": "Irina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37778775": {
    "id": "item_37911",
    "Last Name": "Steffey",
    "First Name": "Rita",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37780079": {
    "id": "item_10544",
    "Last Name": "Biglands",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37781512": {
    "id": "item_35146",
    "Last Name": "Bui",
    "First Name": "Johnny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782076": {
    "id": "item_35144",
    "Last Name": "Lewis",
    "First Name": "Juliane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782246": {
    "id": "item_35143",
    "Last Name": "Cattadori",
    "First Name": "Chiara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782257": {
    "id": "item_10085",
    "Last Name": "Jones",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37782644": {
    "id": "item_11832",
    "Last Name": "serrano",
    "First Name": "miguel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783030": {
    "id": "item_37903",
    "Last Name": "Morrissey",
    "First Name": "Tahlia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783565": {
    "id": "item_37901",
    "Last Name": "Bowers",
    "First Name": "Cheyenne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783622": {
    "id": "item_37900",
    "Last Name": "Nguyen",
    "First Name": "My Anh (Julie)",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37783703": {
    "id": "item_23124",
    "Last Name": "Barrett",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784021": {
    "id": "item_35135",
    "Last Name": "Rolph",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784074": {
    "id": "item_35133",
    "Last Name": "Knight",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784253": {
    "id": "item_10080",
    "Last Name": "Hancox",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784322": {
    "id": "item_37894",
    "Last Name": "MacPherson",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784374": {
    "id": "item_35132",
    "Last Name": "Bletsoe-Brown",
    "First Name": "Anneli",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784499": {
    "id": "item_35130",
    "Last Name": "Shambler",
    "First Name": "Anni",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784640": {
    "id": "item_37890",
    "Last Name": "Rankin",
    "First Name": "Mollie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37784830": {
    "id": "item_37889",
    "Last Name": "Patterson",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785379": {
    "id": "item_11826",
    "Last Name": "Bulla",
    "First Name": "Henrique Augusto",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785499": {
    "id": "item_23114",
    "Last Name": "Roker",
    "First Name": "Harry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785602": {
    "id": "item_35128",
    "Last Name": "Donkin",
    "First Name": "Alana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785829": {
    "id": "item_37879",
    "Last Name": "Alava",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785846": {
    "id": "item_11823",
    "Last Name": "SHIMADA",
    "First Name": "SHINJI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785965": {
    "id": "item_23111",
    "Last Name": "Hird",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37785966": {
    "id": "item_37878",
    "Last Name": "Glynn",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37786311": {
    "id": "item_35127",
    "Last Name": "Henry",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37786772": {
    "id": "item_10071",
    "Last Name": "Lindsay",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787112": {
    "id": "item_37875",
    "Last Name": "Duggan",
    "First Name": "Todd",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787208": {
    "id": "item_37870",
    "Last Name": "Yeap",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787231": {
    "id": "item_37871",
    "Last Name": "To",
    "First Name": "Wing Sheung Carrie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787532": {
    "id": "item_35125",
    "Last Name": "Roberts",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787534": {
    "id": "item_23102",
    "Last Name": "Chojenta",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787541": {
    "id": "item_35123",
    "Last Name": "Sechet",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787567": {
    "id": "item_23101",
    "Last Name": "Toughhill",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787606": {
    "id": "item_10067",
    "Last Name": "Crawford",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37787923": {
    "id": "item_35122",
    "Last Name": "Yeark",
    "First Name": "Terry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37788258": {
    "id": "item_11816",
    "Last Name": "Seaton",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37788339": {
    "id": "item_37863",
    "Last Name": "Morgan",
    "First Name": "Redvers",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37788509": {
    "id": "item_23099",
    "Last Name": "Malone",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37788897": {
    "id": "item_35115",
    "Last Name": "Hodgkinson",
    "First Name": "Eleesa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789113": {
    "id": "item_37860",
    "Last Name": "Mail",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789263": {
    "id": "item_37856",
    "Last Name": "Lazzaro",
    "First Name": "Rene",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789316": {
    "id": "item_35109",
    "Last Name": "Allan",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789476": {
    "id": "item_35108",
    "Last Name": "Kim",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789507": {
    "id": "item_11810",
    "Last Name": "Gurung",
    "First Name": "Pradeep",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789512": {
    "id": "item_37851",
    "Last Name": "SEKIGUCHI",
    "First Name": "KEI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789558": {
    "id": "item_10065",
    "Last Name": "Payne",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789690": {
    "id": "item_37850",
    "Last Name": "Lai",
    "First Name": "Ivy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789822": {
    "id": "item_37848",
    "Last Name": "Bugler",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789847": {
    "id": "item_24448",
    "Last Name": "Riley",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37789930": {
    "id": "item_37845",
    "Last Name": "Davidson",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790019": {
    "id": "item_37844",
    "Last Name": "Lynch",
    "First Name": "Eimear",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790211": {
    "id": "item_23088",
    "Last Name": "O'Farrell",
    "First Name": "Connor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790224": {
    "id": "item_24447",
    "Last Name": "Gregory",
    "First Name": "Boahdan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790256": {
    "id": "item_23087",
    "Last Name": "JIN",
    "First Name": "YAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790375": {
    "id": "item_11808",
    "Last Name": "Gregory",
    "First Name": "Kasimir",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790426": {
    "id": "item_10058",
    "Last Name": "Goto",
    "First Name": "Wataru",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790441": {
    "id": "item_10056",
    "Last Name": "Wong",
    "First Name": "Chik Kui",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790578": {
    "id": "item_23086",
    "Last Name": "Fitzgerald",
    "First Name": "Phil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790627": {
    "id": "item_10054",
    "Last Name": "Millard",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790650": {
    "id": "item_37839",
    "Last Name": "Plant",
    "First Name": "Graham",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790755": {
    "id": "item_10052",
    "Last Name": "Barkmeyer",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790836": {
    "id": "item_37837",
    "Last Name": "Dark",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37790997": {
    "id": "item_23083",
    "Last Name": "Earley",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791032": {
    "id": "item_35099",
    "Last Name": "Dolton",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37791208": {
    "id": "item_35098",
    "Last Name": "Calzado Catala",
    "First Name": "Andres",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37792048": {
    "id": "item_11806",
    "Last Name": "Zhao",
    "First Name": "JunYing",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37792568": {
    "id": "item_12320",
    "Last Name": "CHAN",
    "First Name": "Kwan Kit",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37793275": {
    "id": "item_37832",
    "Last Name": "Gould",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37809143": {
    "id": "item_23074",
    "Last Name": "Halliday",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37812301": {
    "id": "item_23073",
    "Last Name": "Hampton",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37815014": {
    "id": "item_10048",
    "Last Name": "Galdamez",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37818080": {
    "id": "item_11804",
    "Last Name": "McCarthy",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37819320": {
    "id": "item_10047",
    "Last Name": "Kelly",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37830122": {
    "id": "item_24445",
    "Last Name": "Hasson",
    "First Name": "Laurence",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37837458": {
    "id": "item_24868",
    "Last Name": "Jeffrey",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37838799": {
    "id": "item_11800",
    "Last Name": "Swadling",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37838831": {
    "id": "item_37829",
    "Last Name": "Cuales",
    "First Name": "Benjarde",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37838884": {
    "id": "item_35092",
    "Last Name": "Boyle",
    "First Name": "Valentina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839379": {
    "id": "item_24867",
    "Last Name": "Yao",
    "First Name": "Chenglin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839472": {
    "id": "item_23068",
    "Last Name": "Mercado",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839482": {
    "id": "item_23067",
    "Last Name": "Guin",
    "First Name": "Russ",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839515": {
    "id": "item_37824",
    "Last Name": "Hardiman",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839521": {
    "id": "item_23064",
    "Last Name": "Stone",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839560": {
    "id": "item_37823",
    "Last Name": "Tormey",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839620": {
    "id": "item_23061",
    "Last Name": "Shankland",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839630": {
    "id": "item_37821",
    "Last Name": "Mayer",
    "First Name": "Chad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839636": {
    "id": "item_11795",
    "Last Name": "Tran",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839677": {
    "id": "item_35766",
    "Last Name": "AOYAMA",
    "First Name": "KIYO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839684": {
    "id": "item_37817",
    "Last Name": "Broad",
    "First Name": "Lucinda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839745": {
    "id": "item_11792",
    "Last Name": "Woolley",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839776": {
    "id": "item_37812",
    "Last Name": "Murinda",
    "First Name": "Farai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839856": {
    "id": "item_37808",
    "Last Name": "Quinn",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839859": {
    "id": "item_37809",
    "Last Name": "Morrison",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839871": {
    "id": "item_23049",
    "Last Name": "Williams",
    "First Name": "Renee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37839909": {
    "id": "item_10039",
    "Last Name": "McDonald",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840005": {
    "id": "item_11788",
    "Last Name": "Castillo",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840018": {
    "id": "item_12346",
    "Last Name": "Wu",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840037": {
    "id": "item_37802",
    "Last Name": "Byrnes",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840048": {
    "id": "item_11786",
    "Last Name": "Ferraro",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840114": {
    "id": "item_37799",
    "Last Name": "Nierras-Lee",
    "First Name": "Melani",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840167": {
    "id": "item_37797",
    "Last Name": "Lafontaine",
    "First Name": "Julien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840175": {
    "id": "item_11784",
    "Last Name": "Pigott",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840177": {
    "id": "item_37798",
    "Last Name": "Southcote-Want",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840240": {
    "id": "item_35072",
    "Last Name": "Dannenberg",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840247": {
    "id": "item_37793",
    "Last Name": "Kimes",
    "First Name": "Leona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840251": {
    "id": "item_37794",
    "Last Name": "Murphy",
    "First Name": "Berny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840286": {
    "id": "item_37792",
    "Last Name": "WILLIAMS",
    "First Name": "KRISTIAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840398": {
    "id": "item_23041",
    "Last Name": "Graham",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840405": {
    "id": "item_24441",
    "Last Name": "Mruskovic",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840444": {
    "id": "item_35065",
    "Last Name": "Ramos",
    "First Name": "Patricio Francisco",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840495": {
    "id": "item_37787",
    "Last Name": "Barry",
    "First Name": "Lise",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840554": {
    "id": "item_23037",
    "Last Name": "Vollmerhause",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840578": {
    "id": "item_35063",
    "Last Name": "Clark",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840635": {
    "id": "item_37782",
    "Last Name": "Beitner",
    "First Name": "Sasha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840700": {
    "id": "item_23035",
    "Last Name": "Kuswadi",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840749": {
    "id": "item_35059",
    "Last Name": "Shanks",
    "First Name": "Pippi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840826": {
    "id": "item_35057",
    "Last Name": "Yee",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840863": {
    "id": "item_23031",
    "Last Name": "Restrepo",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840922": {
    "id": "item_37778",
    "Last Name": "Hunt",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37840999": {
    "id": "item_23029",
    "Last Name": "Reuss",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841129": {
    "id": "item_23028",
    "Last Name": "D'Rose",
    "First Name": "Carl",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841146": {
    "id": "item_35051",
    "Last Name": "RAMOS VERGES",
    "First Name": "NORMA LOURDES XITLALI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841164": {
    "id": "item_23026",
    "Last Name": "Edwards",
    "First Name": "Nadine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841202": {
    "id": "item_23025",
    "Last Name": "Trebbin",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841245": {
    "id": "item_24437",
    "Last Name": "Collinson",
    "First Name": "Chrissie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841302": {
    "id": "item_23020",
    "Last Name": "Mackay",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841361": {
    "id": "item_10023",
    "Last Name": "Edwards",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841392": {
    "id": "item_37771",
    "Last Name": "Pineda Sagastume",
    "First Name": "Mauro Antonio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841446": {
    "id": "item_37767",
    "Last Name": "Lowe",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841522": {
    "id": "item_10021",
    "Last Name": "Bradford",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841582": {
    "id": "item_37761",
    "Last Name": "Hollands",
    "First Name": "Faye",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841611": {
    "id": "item_37760",
    "Last Name": "Shin",
    "First Name": "Eui sung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841809": {
    "id": "item_24435",
    "Last Name": "Gardiner",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841855": {
    "id": "item_37756",
    "Last Name": "Tea",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841875": {
    "id": "item_35040",
    "Last Name": "Ingman-Jones",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37841984": {
    "id": "item_35038",
    "Last Name": "Moran",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842006": {
    "id": "item_37752",
    "Last Name": "Dunlop",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842057": {
    "id": "item_37751",
    "Last Name": "Ho",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842139": {
    "id": "item_37747",
    "Last Name": "Nash",
    "First Name": "Clare",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842174": {
    "id": "item_37743",
    "Last Name": "Norrish",
    "First Name": "Rose",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842248": {
    "id": "item_10016",
    "Last Name": "Evans",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842320": {
    "id": "item_37742",
    "Last Name": "Singh",
    "First Name": "Ritika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842398": {
    "id": "item_10013",
    "Last Name": "Lewis",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842458": {
    "id": "item_10012",
    "Last Name": "Thomas",
    "First Name": "Alec",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842495": {
    "id": "item_11770",
    "Last Name": "Obaydin",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842527": {
    "id": "item_37740",
    "Last Name": "Fewster",
    "First Name": "Annie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842644": {
    "id": "item_11769",
    "Last Name": "Olver",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842719": {
    "id": "item_37737",
    "Last Name": "McCormack",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842759": {
    "id": "item_10009",
    "Last Name": "Grey",
    "First Name": "stuart",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842761": {
    "id": "item_37736",
    "Last Name": "Wall",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842762": {
    "id": "item_37735",
    "Last Name": "Del Rosario",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842867": {
    "id": "item_11768",
    "Last Name": "Ogden",
    "First Name": "Llion",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37842985": {
    "id": "item_37730",
    "Last Name": "Akers",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843075": {
    "id": "item_11767",
    "Last Name": "Kippen",
    "First Name": "Elliot",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843092": {
    "id": "item_35026",
    "Last Name": "Mchutchon",
    "First Name": "Steve",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843097": {
    "id": "item_35023",
    "Last Name": "Miller",
    "First Name": "Ash",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843177": {
    "id": "item_37728",
    "Last Name": "Levy",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843306": {
    "id": "item_35020",
    "Last Name": "Munetsi",
    "First Name": "Pasca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843584": {
    "id": "item_37724",
    "Last Name": "Custerson",
    "First Name": "Suzie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843593": {
    "id": "item_37723",
    "Last Name": "Elavarthi",
    "First Name": "Raajesh Varma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843597": {
    "id": "item_35019",
    "Last Name": "Murphy",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843662": {
    "id": "item_23003",
    "Last Name": "Dore",
    "First Name": "Fabio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843731": {
    "id": "item_37721",
    "Last Name": "Eats",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843736": {
    "id": "item_37720",
    "Last Name": "Gabe",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843743": {
    "id": "item_37722",
    "Last Name": "Rooney",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843836": {
    "id": "item_11764",
    "Last Name": "Erami",
    "First Name": "Akira",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843873": {
    "id": "item_37717",
    "Last Name": "Fisher",
    "First Name": "Ginny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37843980": {
    "id": "item_11763",
    "Last Name": "Miller",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844340": {
    "id": "item_37709",
    "Last Name": "Kelly",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844464": {
    "id": "item_37707",
    "Last Name": "Angelozzi",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844514": {
    "id": "item_37706",
    "Last Name": "Conheady",
    "First Name": "Harriet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844579": {
    "id": "item_37704",
    "Last Name": "Cohen",
    "First Name": "Bronwyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844605": {
    "id": "item_11754",
    "Last Name": "Brewer",
    "First Name": "Caleb",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844742": {
    "id": "item_22997",
    "Last Name": "Murray",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844782": {
    "id": "item_37703",
    "Last Name": "Chilcott",
    "First Name": "Edwina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844870": {
    "id": "item_37701",
    "Last Name": "Hsu",
    "First Name": "Ching Yang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37844877": {
    "id": "item_37700",
    "Last Name": "Coren",
    "First Name": "Tonya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845051": {
    "id": "item_11752",
    "Last Name": "Palmer",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845055": {
    "id": "item_24431",
    "Last Name": "Hicks",
    "First Name": "Russell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845090": {
    "id": "item_37696",
    "Last Name": "Weller",
    "First Name": "Garion",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845097": {
    "id": "item_35003",
    "Last Name": "paz",
    "First Name": "sharon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845134": {
    "id": "item_22994",
    "Last Name": "Knox",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845214": {
    "id": "item_37689",
    "Last Name": "Phillipson",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845226": {
    "id": "item_24428",
    "Last Name": "Duncan",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845309": {
    "id": "item_37687",
    "Last Name": "zhang",
    "First Name": "xiaoxue",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845368": {
    "id": "item_24866",
    "Last Name": "Gillon",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845439": {
    "id": "item_35001",
    "Last Name": "Butler",
    "First Name": "Kellie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845441": {
    "id": "item_11750",
    "Last Name": "OMahony",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845445": {
    "id": "item_24426",
    "Last Name": "Longstreet",
    "First Name": "Debra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845467": {
    "id": "item_22992",
    "Last Name": "Ngo",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845513": {
    "id": "item_9999",
    "Last Name": "van Gangelen",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845530": {
    "id": "item_37680",
    "Last Name": "Yellala",
    "First Name": "Naveen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845725": {
    "id": "item_34997",
    "Last Name": "Davidson",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845856": {
    "id": "item_37671",
    "Last Name": "Meers",
    "First Name": "Bob",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845860": {
    "id": "item_37672",
    "Last Name": "Yu",
    "First Name": "Derek",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37845959": {
    "id": "item_34996",
    "Last Name": "Day",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846136": {
    "id": "item_34995",
    "Last Name": "Myles",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846245": {
    "id": "item_24415",
    "Last Name": "Duncan",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846303": {
    "id": "item_9995",
    "Last Name": "Hurford",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846356": {
    "id": "item_34994",
    "Last Name": "Navales",
    "First Name": "Lou Patrick Joseph",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846379": {
    "id": "item_34993",
    "Last Name": "Banaczek",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846422": {
    "id": "item_24414",
    "Last Name": "Tonkin",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846523": {
    "id": "item_37663",
    "Last Name": "Millhouse",
    "First Name": "Elissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846792": {
    "id": "item_22981",
    "Last Name": "Santiago",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846794": {
    "id": "item_9989",
    "Last Name": "Lambert",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846804": {
    "id": "item_37660",
    "Last Name": "Reeves",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846886": {
    "id": "item_22980",
    "Last Name": "Whyte",
    "First Name": "Conor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37846930": {
    "id": "item_34992",
    "Last Name": "Rodriguez",
    "First Name": "Ashly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847022": {
    "id": "item_24409",
    "Last Name": "Quinn",
    "First Name": "Sunee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847044": {
    "id": "item_22979",
    "Last Name": "Martin",
    "First Name": "Celine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847197": {
    "id": "item_11743",
    "Last Name": "Zhao",
    "First Name": "Shunnai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847204": {
    "id": "item_24407",
    "Last Name": "PANDEY",
    "First Name": "GAUTAM",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847229": {
    "id": "item_37651",
    "Last Name": "Lawrie",
    "First Name": "Jay",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847303": {
    "id": "item_9985",
    "Last Name": "Ohashi",
    "First Name": "Ryota",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847307": {
    "id": "item_37647",
    "Last Name": "Huckson",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847485": {
    "id": "item_34989",
    "Last Name": "Scott",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847493": {
    "id": "item_37643",
    "Last Name": "Miller",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847551": {
    "id": "item_34988",
    "Last Name": "Chen",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847618": {
    "id": "item_37639",
    "Last Name": "Mulinti",
    "First Name": "Praveen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847625": {
    "id": "item_37637",
    "Last Name": "Zhang",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847656": {
    "id": "item_9984",
    "Last Name": "Hooper",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847679": {
    "id": "item_37634",
    "Last Name": "Elson",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847734": {
    "id": "item_37633",
    "Last Name": "Rey",
    "First Name": "Dom",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847787": {
    "id": "item_10543",
    "Last Name": "LAM",
    "First Name": "KA YAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847798": {
    "id": "item_22967",
    "Last Name": "Brodovcky",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847807": {
    "id": "item_22966",
    "Last Name": "Cleveland",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847866": {
    "id": "item_22965",
    "Last Name": "Chew",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847878": {
    "id": "item_37627",
    "Last Name": "Kristiansen",
    "First Name": "Kasper",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37847985": {
    "id": "item_24398",
    "Last Name": "Abdul Halim",
    "First Name": "Mohamad Zahf",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848104": {
    "id": "item_9982",
    "Last Name": "Williams",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848138": {
    "id": "item_34984",
    "Last Name": "Marcus",
    "First Name": "Callum",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848151": {
    "id": "item_22962",
    "Last Name": "Saguin",
    "First Name": "Alyssa Faith",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848197": {
    "id": "item_11734",
    "Last Name": "Berghofer",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848232": {
    "id": "item_37622",
    "Last Name": "Bonser",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848254": {
    "id": "item_11731",
    "Last Name": "Grove",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848257": {
    "id": "item_22960",
    "Last Name": "Xu",
    "First Name": "Guangchao",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848262": {
    "id": "item_24394",
    "Last Name": "Fitzgibbon",
    "First Name": "Rhiannon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848278": {
    "id": "item_37617",
    "Last Name": "Power",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848299": {
    "id": "item_37613",
    "Last Name": "Cappetta",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848399": {
    "id": "item_37612",
    "Last Name": "Boylan",
    "First Name": "Jenyne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848446": {
    "id": "item_24393",
    "Last Name": "Guymer",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848462": {
    "id": "item_37611",
    "Last Name": "Boskovic",
    "First Name": "Shae",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848508": {
    "id": "item_37608",
    "Last Name": "McDonnell",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848590": {
    "id": "item_37607",
    "Last Name": "Mcgoldrick",
    "First Name": "Ciara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848660": {
    "id": "item_37604",
    "Last Name": "McIntosh",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848722": {
    "id": "item_37603",
    "Last Name": "Rendall Day",
    "First Name": "Julian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848795": {
    "id": "item_9972",
    "Last Name": "Ketelbey",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848842": {
    "id": "item_22952",
    "Last Name": "Smith",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848848": {
    "id": "item_22950",
    "Last Name": "Doran",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848896": {
    "id": "item_34979",
    "Last Name": "Ton",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848901": {
    "id": "item_24388",
    "Last Name": "Malone",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848907": {
    "id": "item_37596",
    "Last Name": "Johnston",
    "First Name": "Stevie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848923": {
    "id": "item_34978",
    "Last Name": "Anderson",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848958": {
    "id": "item_37595",
    "Last Name": "Hasan",
    "First Name": "Ruman",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37848991": {
    "id": "item_34976",
    "Last Name": "Kent",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849110": {
    "id": "item_37592",
    "Last Name": "Longbottom",
    "First Name": "Dwayne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849203": {
    "id": "item_9970",
    "Last Name": "Siwek",
    "First Name": "Zbigniew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849291": {
    "id": "item_24385",
    "Last Name": "Barker",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849323": {
    "id": "item_24384",
    "Last Name": "De Torres",
    "First Name": "Weslyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849343": {
    "id": "item_22940",
    "Last Name": "Chiu",
    "First Name": "Hung-Pin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849414": {
    "id": "item_37588",
    "Last Name": "Santa Maria",
    "First Name": "Sonja",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849485": {
    "id": "item_9967",
    "Last Name": "Gordon",
    "First Name": "Flynn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849491": {
    "id": "item_22939",
    "Last Name": "Denton",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849518": {
    "id": "item_37582",
    "Last Name": "Gunn",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849529": {
    "id": "item_24381",
    "Last Name": "wong",
    "First Name": "Shun",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849605": {
    "id": "item_37581",
    "Last Name": "Sheils",
    "First Name": "Evan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849960": {
    "id": "item_34973",
    "Last Name": "Ashton",
    "First Name": "Lise",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37849990": {
    "id": "item_24380",
    "Last Name": "Escritt",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850106": {
    "id": "item_34972",
    "Last Name": "Marcozzi",
    "First Name": "Peyton",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850183": {
    "id": "item_34971",
    "Last Name": "Takahashi",
    "First Name": "Kosei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850218": {
    "id": "item_9963",
    "Last Name": "White",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850418": {
    "id": "item_37575",
    "Last Name": "O Toole",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850591": {
    "id": "item_22935",
    "Last Name": "Noel",
    "First Name": "Maxime",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850627": {
    "id": "item_11714",
    "Last Name": "Tam",
    "First Name": "Chun Tung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850644": {
    "id": "item_9960",
    "Last Name": "Barrow",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850765": {
    "id": "item_37573",
    "Last Name": "Fabiona",
    "First Name": "Fadia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37850799": {
    "id": "item_9958",
    "Last Name": "Mere",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851089": {
    "id": "item_35765",
    "Last Name": "Phillips",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851156": {
    "id": "item_22933",
    "Last Name": "Jones",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851341": {
    "id": "item_37570",
    "Last Name": "Rayner",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37851942": {
    "id": "item_35764",
    "Last Name": "Kleinjan",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37852896": {
    "id": "item_22930",
    "Last Name": "VARGAS TAMAYO",
    "First Name": "GUILLERMO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853233": {
    "id": "item_11709",
    "Last Name": "Cotugno Morrison",
    "First Name": "Luca",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853660": {
    "id": "item_37564",
    "Last Name": "Francis",
    "First Name": "Jen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853893": {
    "id": "item_34969",
    "Last Name": "McGee",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853939": {
    "id": "item_37562",
    "Last Name": "Hunter",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37853964": {
    "id": "item_9948",
    "Last Name": "Maughan",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854312": {
    "id": "item_24374",
    "Last Name": "Klaus",
    "First Name": "Katrin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854441": {
    "id": "item_24372",
    "Last Name": "Weckbecker",
    "First Name": "Gerhard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854662": {
    "id": "item_11706",
    "Last Name": "Rosser",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854697": {
    "id": "item_34968",
    "Last Name": "Bautista",
    "First Name": "Louie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854949": {
    "id": "item_37556",
    "Last Name": "Cadman",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37854950": {
    "id": "item_37555",
    "Last Name": "Cadman",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855055": {
    "id": "item_37553",
    "Last Name": "Clarke",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855065": {
    "id": "item_11703",
    "Last Name": "Watson",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855107": {
    "id": "item_37549",
    "Last Name": "Patel",
    "First Name": "Monika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855241": {
    "id": "item_22924",
    "Last Name": "Ford",
    "First Name": "Carina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855252": {
    "id": "item_24366",
    "Last Name": "Lee",
    "First Name": "Madison",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855325": {
    "id": "item_37545",
    "Last Name": "Schliwa",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855328": {
    "id": "item_37546",
    "Last Name": "Cindric",
    "First Name": "Monika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855402": {
    "id": "item_34967",
    "Last Name": "Rodgers",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855647": {
    "id": "item_24363",
    "Last Name": "Mitchell",
    "First Name": "Sue",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855648": {
    "id": "item_11700",
    "Last Name": "Brown",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855710": {
    "id": "item_37544",
    "Last Name": "Willsmore",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855788": {
    "id": "item_24362",
    "Last Name": "Key",
    "First Name": "Dillon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37855856": {
    "id": "item_37543",
    "Last Name": "Edwards",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856066": {
    "id": "item_11696",
    "Last Name": "Sparkes",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856121": {
    "id": "item_37540",
    "Last Name": "Swider",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856127": {
    "id": "item_9942",
    "Last Name": "Essex",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856160": {
    "id": "item_22921",
    "Last Name": "Chappell",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856173": {
    "id": "item_37538",
    "Last Name": "Salmon",
    "First Name": "Lorien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856193": {
    "id": "item_37537",
    "Last Name": "Wilson",
    "First Name": "Jack",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856291": {
    "id": "item_37536",
    "Last Name": "Robison",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856304": {
    "id": "item_37534",
    "Last Name": "Barringer",
    "First Name": "Georgie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856631": {
    "id": "item_22917",
    "Last Name": "Wilkes",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856650": {
    "id": "item_22916",
    "Last Name": "Hill",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37856731": {
    "id": "item_9940",
    "Last Name": "Campbell",
    "First Name": "Greg",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857115": {
    "id": "item_10542",
    "Last Name": "Sridhar",
    "First Name": "Arjun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857541": {
    "id": "item_37519",
    "Last Name": "Zlatkovic",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857569": {
    "id": "item_22906",
    "Last Name": "Carter",
    "First Name": "Reniece",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857579": {
    "id": "item_22904",
    "Last Name": "Lloyd",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857590": {
    "id": "item_37518",
    "Last Name": "Kirk",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857595": {
    "id": "item_9937",
    "Last Name": "Russell-Gibson",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857620": {
    "id": "item_37517",
    "Last Name": "JUNG",
    "First Name": "SUKJIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857646": {
    "id": "item_37515",
    "Last Name": "Maher Allan",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857685": {
    "id": "item_11691",
    "Last Name": "Aitken",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857748": {
    "id": "item_37513",
    "Last Name": "West",
    "First Name": "Steph",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857814": {
    "id": "item_37510",
    "Last Name": "Broad",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857825": {
    "id": "item_24352",
    "Last Name": "Whitwam",
    "First Name": "Ella",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857844": {
    "id": "item_11689",
    "Last Name": "McDonagh",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857854": {
    "id": "item_24350",
    "Last Name": "Pilkington",
    "First Name": "Lara",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857876": {
    "id": "item_37508",
    "Last Name": "Rooney",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857909": {
    "id": "item_24822",
    "Last Name": "Purnama",
    "First Name": "Eko Hadi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857914": {
    "id": "item_24349",
    "Last Name": "Regan",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37857932": {
    "id": "item_22901",
    "Last Name": "Tseng",
    "First Name": "Wen-chung",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858184": {
    "id": "item_37502",
    "Last Name": "Reyes",
    "First Name": "Jennifer Frances",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858231": {
    "id": "item_22899",
    "Last Name": "Basaglia",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858297": {
    "id": "item_34957",
    "Last Name": "Freyja-Mead",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858366": {
    "id": "item_22897",
    "Last Name": "Zollo Semmler",
    "First Name": "Tiani",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858384": {
    "id": "item_11687",
    "Last Name": "Fauls",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858439": {
    "id": "item_11686",
    "Last Name": "High",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858499": {
    "id": "item_37495",
    "Last Name": "atreya",
    "First Name": "kishore",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858648": {
    "id": "item_9923",
    "Last Name": "Smith",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858854": {
    "id": "item_24343",
    "Last Name": "Campbell",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37858999": {
    "id": "item_22894",
    "Last Name": "Cranney",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859170": {
    "id": "item_9919",
    "Last Name": "Handscombe",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859242": {
    "id": "item_24338",
    "Last Name": "Bengoechea",
    "First Name": "Alberto",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859365": {
    "id": "item_37484",
    "Last Name": "Muller",
    "First Name": "Heid",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859432": {
    "id": "item_24336",
    "Last Name": "Khaiitbaev",
    "First Name": "Roustam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859922": {
    "id": "item_24332",
    "Last Name": "Pennings",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859942": {
    "id": "item_11678",
    "Last Name": "Banks",
    "First Name": "Fergal",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37859972": {
    "id": "item_24330",
    "Last Name": "Berndt",
    "First Name": "Anica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860051": {
    "id": "item_9917",
    "Last Name": "Browne",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860452": {
    "id": "item_37474",
    "Last Name": "Gangasandra",
    "First Name": "Vishaak",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860454": {
    "id": "item_37475",
    "Last Name": "Lambert",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860486": {
    "id": "item_22883",
    "Last Name": "Tebbs",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860629": {
    "id": "item_34950",
    "Last Name": "Hartnett",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860797": {
    "id": "item_22879",
    "Last Name": "Giblin",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860948": {
    "id": "item_22878",
    "Last Name": "Beale",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37860996": {
    "id": "item_22877",
    "Last Name": "Carter",
    "First Name": "Trent",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861012": {
    "id": "item_37468",
    "Last Name": "Horne",
    "First Name": "Sally",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861169": {
    "id": "item_37466",
    "Last Name": "Rea",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861192": {
    "id": "item_9909",
    "Last Name": "Anderson",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861199": {
    "id": "item_22875",
    "Last Name": "Keong",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861292": {
    "id": "item_24322",
    "Last Name": "Brion",
    "First Name": "Laurence",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861302": {
    "id": "item_22874",
    "Last Name": "Jordan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861344": {
    "id": "item_24321",
    "Last Name": "Mckelvey",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861376": {
    "id": "item_22872",
    "Last Name": "Williams",
    "First Name": "Casey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861447": {
    "id": "item_22870",
    "Last Name": "Vasquez",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861691": {
    "id": "item_9907",
    "Last Name": "Macleay",
    "First Name": "Trent",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861706": {
    "id": "item_11671",
    "Last Name": "Henkel",
    "First Name": "Bert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861711": {
    "id": "item_24320",
    "Last Name": "Bridge",
    "First Name": "Kiely",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861840": {
    "id": "item_9905",
    "Last Name": "Baird",
    "First Name": "Skyler",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37861943": {
    "id": "item_24318",
    "Last Name": "Moore",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862071": {
    "id": "item_22863",
    "Last Name": "Zhdaneev",
    "First Name": "Oleg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862092": {
    "id": "item_37551",
    "Last Name": "Dodd",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862143": {
    "id": "item_37455",
    "Last Name": "Morzone",
    "First Name": "Juliette",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862249": {
    "id": "item_22860",
    "Last Name": "Newberry",
    "First Name": "Eddy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862273": {
    "id": "item_22859",
    "Last Name": "Rose",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862299": {
    "id": "item_37451",
    "Last Name": "Guthrie",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862357": {
    "id": "item_37449",
    "Last Name": "Bilboe",
    "First Name": "Sian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862398": {
    "id": "item_37446",
    "Last Name": "Landhed",
    "First Name": "Elin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862533": {
    "id": "item_11669",
    "Last Name": "Griffiths",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862718": {
    "id": "item_37441",
    "Last Name": "Dullard",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862732": {
    "id": "item_37439",
    "Last Name": "DRECQ",
    "First Name": "LŽa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862778": {
    "id": "item_9896",
    "Last Name": "Ward",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862861": {
    "id": "item_24309",
    "Last Name": "Doyle",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862952": {
    "id": "item_37435",
    "Last Name": "Coss",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862959": {
    "id": "item_37436",
    "Last Name": "Tang",
    "First Name": "Tsai-Ping",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37862993": {
    "id": "item_24308",
    "Last Name": "Andrews",
    "First Name": "Robbie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863072": {
    "id": "item_34944",
    "Last Name": "Child",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863085": {
    "id": "item_11666",
    "Last Name": "Maiz",
    "First Name": "Gregg Alexis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863318": {
    "id": "item_34939",
    "Last Name": "Lorimer",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863338": {
    "id": "item_22842",
    "Last Name": "Chappell",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863349": {
    "id": "item_22845",
    "Last Name": "Pearl",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863384": {
    "id": "item_37425",
    "Last Name": "Graves",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863463": {
    "id": "item_9891",
    "Last Name": "Frasha",
    "First Name": "Osman Arturo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863517": {
    "id": "item_9888",
    "Last Name": "Alcock",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863602": {
    "id": "item_37418",
    "Last Name": "Owen",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863614": {
    "id": "item_22837",
    "Last Name": "Salahuddin",
    "First Name": "Mohammad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863639": {
    "id": "item_37417",
    "Last Name": "Neylan",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863699": {
    "id": "item_22836",
    "Last Name": "SHU",
    "First Name": "KUO JEN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863743": {
    "id": "item_22835",
    "Last Name": "Thompson",
    "First Name": "Keisha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863751": {
    "id": "item_24304",
    "Last Name": "Bartolo",
    "First Name": "Eden",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863811": {
    "id": "item_22834",
    "Last Name": "Denyer",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37863911": {
    "id": "item_24301",
    "Last Name": "Snow",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864110": {
    "id": "item_37409",
    "Last Name": "Cruz",
    "First Name": "Ailynn Danielle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864120": {
    "id": "item_22828",
    "Last Name": "Abeysuriya",
    "First Name": "Kapila",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864211": {
    "id": "item_24299",
    "Last Name": "Heffernan",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864222": {
    "id": "item_9882",
    "Last Name": "Muletta",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864326": {
    "id": "item_11651",
    "Last Name": "McConachie",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864389": {
    "id": "item_37395",
    "Last Name": "Khoury",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864434": {
    "id": "item_34931",
    "Last Name": "Chan",
    "First Name": "Yuk Chor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864613": {
    "id": "item_34930",
    "Last Name": "Glick",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864638": {
    "id": "item_24294",
    "Last Name": "Handscombe",
    "First Name": "Lily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864655": {
    "id": "item_11646",
    "Last Name": "De Andrade",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864661": {
    "id": "item_35763",
    "Last Name": "Devi",
    "First Name": "Vania",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864734": {
    "id": "item_37383",
    "Last Name": "Mooney",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864773": {
    "id": "item_9871",
    "Last Name": "Kenzie",
    "First Name": "Deon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864879": {
    "id": "item_22818",
    "Last Name": "O'Connor",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864881": {
    "id": "item_22817",
    "Last Name": "CHEN",
    "First Name": "LI WEN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37864903": {
    "id": "item_37380",
    "Last Name": "Lewis",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865012": {
    "id": "item_9869",
    "Last Name": "Hammond",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865017": {
    "id": "item_37376",
    "Last Name": "Warner",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865055": {
    "id": "item_34927",
    "Last Name": "Lester",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865189": {
    "id": "item_9866",
    "Last Name": "Hong",
    "First Name": "SungBoo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865249": {
    "id": "item_22812",
    "Last Name": "Barton",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865267": {
    "id": "item_9865",
    "Last Name": "Tsui",
    "First Name": "Ka Leung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865379": {
    "id": "item_37368",
    "Last Name": "Chandrasegaran",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865478": {
    "id": "item_9863",
    "Last Name": "Wilson",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865608": {
    "id": "item_37365",
    "Last Name": "KANJANAPAYONT",
    "First Name": "PITSANUPONG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865614": {
    "id": "item_11632",
    "Last Name": "Barker",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865632": {
    "id": "item_22808",
    "Last Name": "Miels",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865728": {
    "id": "item_37364",
    "Last Name": "Christopher",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865885": {
    "id": "item_11630",
    "Last Name": "Deane",
    "First Name": "Alison",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37865980": {
    "id": "item_22806",
    "Last Name": "Sura",
    "First Name": "Parvin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866025": {
    "id": "item_22805",
    "Last Name": "Tsang",
    "First Name": "Johnny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866090": {
    "id": "item_11629",
    "Last Name": "KUO",
    "First Name": "ZIH HAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866093": {
    "id": "item_9860",
    "Last Name": "CHIANG",
    "First Name": "CHENG-LUN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866197": {
    "id": "item_24285",
    "Last Name": "Block",
    "First Name": "Fang",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866252": {
    "id": "item_37360",
    "Last Name": "choi",
    "First Name": "sunwoo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866310": {
    "id": "item_24283",
    "Last Name": "Lee",
    "First Name": "Seunghee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866360": {
    "id": "item_9859",
    "Last Name": "OÕBrien",
    "First Name": "Declan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866478": {
    "id": "item_34919",
    "Last Name": "Moyes",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866529": {
    "id": "item_37359",
    "Last Name": "Chong",
    "First Name": "Yi Herng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866725": {
    "id": "item_34918",
    "Last Name": "Quartermaine",
    "First Name": "Wade",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37866891": {
    "id": "item_37355",
    "Last Name": "Chen",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867088": {
    "id": "item_22802",
    "Last Name": "Alfaro Rodriguez",
    "First Name": "Gustavo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867488": {
    "id": "item_11621",
    "Last Name": "jiang",
    "First Name": "lizhi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867524": {
    "id": "item_24281",
    "Last Name": "Kuntanarumitkul",
    "First Name": "Taweesilp",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37867940": {
    "id": "item_37348",
    "Last Name": "Saranas",
    "First Name": "Vincentas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37868002": {
    "id": "item_24278",
    "Last Name": "Lucas",
    "First Name": "Bened",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37868201": {
    "id": "item_24277",
    "Last Name": "sutton",
    "First Name": "william",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37868657": {
    "id": "item_11616",
    "Last Name": "Smith",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37869083": {
    "id": "item_11614",
    "Last Name": "Crespo Pe–alosa",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37869964": {
    "id": "item_37339",
    "Last Name": "Saxon",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37870249": {
    "id": "item_37338",
    "Last Name": "Dinh",
    "First Name": "Theresa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37870304": {
    "id": "item_24276",
    "Last Name": "Ulrich",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37870329": {
    "id": "item_11612",
    "Last Name": "Melgaard",
    "First Name": "Kennet",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37870377": {
    "id": "item_24275",
    "Last Name": "Jovinski",
    "First Name": "Leticia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871076": {
    "id": "item_24272",
    "Last Name": "Chavez Cruz",
    "First Name": "Angie Ivonne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871087": {
    "id": "item_34914",
    "Last Name": "Rouse",
    "First Name": "Martina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871107": {
    "id": "item_37333",
    "Last Name": "Geldenhuys",
    "First Name": "Leonora",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871143": {
    "id": "item_22792",
    "Last Name": "Reddy",
    "First Name": "Madhusudhan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871423": {
    "id": "item_9847",
    "Last Name": "Upton",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871450": {
    "id": "item_11608",
    "Last Name": "Yeo",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871614": {
    "id": "item_37330",
    "Last Name": "Kiely",
    "First Name": "Fang Fang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871669": {
    "id": "item_22788",
    "Last Name": "Mummery",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871714": {
    "id": "item_24271",
    "Last Name": "Denyer",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37871751": {
    "id": "item_37327",
    "Last Name": "Lin",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872337": {
    "id": "item_37322",
    "Last Name": "Woo",
    "First Name": "Joe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872394": {
    "id": "item_22784",
    "Last Name": "Grech",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872462": {
    "id": "item_37319",
    "Last Name": "Ho",
    "First Name": "Chuong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872464": {
    "id": "item_10541",
    "Last Name": "Kachach",
    "First Name": "Mohammed",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872480": {
    "id": "item_34911",
    "Last Name": "Oxley",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872656": {
    "id": "item_11606",
    "Last Name": "Tuntivate",
    "First Name": "Maeve",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872700": {
    "id": "item_37316",
    "Last Name": "Cusack",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37872858": {
    "id": "item_34906",
    "Last Name": "Poynton",
    "First Name": "Damien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873130": {
    "id": "item_37312",
    "Last Name": "Laub-Thomas",
    "First Name": "Anastasia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873192": {
    "id": "item_11604",
    "Last Name": "Snowdon",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873257": {
    "id": "item_9842",
    "Last Name": "Porter",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873299": {
    "id": "item_22775",
    "Last Name": "Emmett",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873472": {
    "id": "item_37307",
    "Last Name": "Marett",
    "First Name": "Aiden",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873600": {
    "id": "item_22773",
    "Last Name": "Cooley",
    "First Name": "Robin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873750": {
    "id": "item_9838",
    "Last Name": "Proctor",
    "First Name": "Baz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873754": {
    "id": "item_37305",
    "Last Name": "Johnson",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37873974": {
    "id": "item_37303",
    "Last Name": "Lawrence",
    "First Name": "Will",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874020": {
    "id": "item_37301",
    "Last Name": "Golding",
    "First Name": "Kirby",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874039": {
    "id": "item_10516",
    "Last Name": "Garcia",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874374": {
    "id": "item_22768",
    "Last Name": "Julien",
    "First Name": "Marc",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37874651": {
    "id": "item_9834",
    "Last Name": "Seymour",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875090": {
    "id": "item_24261",
    "Last Name": "Stoey",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875269": {
    "id": "item_22766",
    "Last Name": "Cabita",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875356": {
    "id": "item_22765",
    "Last Name": "Oliver",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875566": {
    "id": "item_37295",
    "Last Name": "Mulcair",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875770": {
    "id": "item_22762",
    "Last Name": "Abela",
    "First Name": "Amante",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875778": {
    "id": "item_37294",
    "Last Name": "Quagliotto",
    "First Name": "Massimo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875794": {
    "id": "item_24260",
    "Last Name": "Laemle",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875814": {
    "id": "item_24259",
    "Last Name": "Connolly",
    "First Name": "Ed",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37875967": {
    "id": "item_24258",
    "Last Name": "Thompson",
    "First Name": "Kieren",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876445": {
    "id": "item_34898",
    "Last Name": "Daniels",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876571": {
    "id": "item_37281",
    "Last Name": "Crawley",
    "First Name": "Bronte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876762": {
    "id": "item_22756",
    "Last Name": "Guest",
    "First Name": "Anne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37876845": {
    "id": "item_37280",
    "Last Name": "TAMADADDI",
    "First Name": "KIRAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877069": {
    "id": "item_22753",
    "Last Name": "Zampogna",
    "First Name": "Damien",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877079": {
    "id": "item_22751",
    "Last Name": "MARUYAMA",
    "First Name": "TAKASHI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877549": {
    "id": "item_22748",
    "Last Name": "Iriarte",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877574": {
    "id": "item_11595",
    "Last Name": "Gantner",
    "First Name": "Dashiell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877758": {
    "id": "item_9824",
    "Last Name": "Benson",
    "First Name": "Gus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877822": {
    "id": "item_11594",
    "Last Name": "Smith",
    "First Name": "Brittni",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37877982": {
    "id": "item_11593",
    "Last Name": "Contreras",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878252": {
    "id": "item_24253",
    "Last Name": "Cely",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878525": {
    "id": "item_9820",
    "Last Name": "Lee",
    "First Name": "Yuk Lam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878690": {
    "id": "item_11589",
    "Last Name": "Armstrong",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37878842": {
    "id": "item_22742",
    "Last Name": "Li",
    "First Name": "Lizzie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879200": {
    "id": "item_11587",
    "Last Name": "Phillips",
    "First Name": "Alaric",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879220": {
    "id": "item_37266",
    "Last Name": "Zhou",
    "First Name": "Jiarun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879221": {
    "id": "item_37267",
    "Last Name": "Smith",
    "First Name": "Michael Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879594": {
    "id": "item_9819",
    "Last Name": "Perez Racancoj",
    "First Name": "Carlos Enrique",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879607": {
    "id": "item_37264",
    "Last Name": "Reyes",
    "First Name": "Jemima Riq",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879697": {
    "id": "item_22737",
    "Last Name": "Weidner",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37879865": {
    "id": "item_22735",
    "Last Name": "Kyle",
    "First Name": "Logan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880050": {
    "id": "item_37259",
    "Last Name": "Gathercole",
    "First Name": "Siobhan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880167": {
    "id": "item_37258",
    "Last Name": "Eddie",
    "First Name": "Justinn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880320": {
    "id": "item_37257",
    "Last Name": "Kefford",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880411": {
    "id": "item_9817",
    "Last Name": "Spence",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880468": {
    "id": "item_24239",
    "Last Name": "Vardy",
    "First Name": "Trevor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880504": {
    "id": "item_34888",
    "Last Name": "Tang",
    "First Name": "Lee Hong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880627": {
    "id": "item_9815",
    "Last Name": "Kelly",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880715": {
    "id": "item_11579",
    "Last Name": "Wills",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880717": {
    "id": "item_11580",
    "Last Name": "Sammut",
    "First Name": "Julian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880776": {
    "id": "item_37250",
    "Last Name": "Zhou",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880964": {
    "id": "item_37248",
    "Last Name": "Warda",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37880975": {
    "id": "item_22725",
    "Last Name": "Kelly",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881026": {
    "id": "item_22724",
    "Last Name": "Wendt",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881027": {
    "id": "item_22723",
    "Last Name": "Etherington",
    "First Name": "Lloyd",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881136": {
    "id": "item_9813",
    "Last Name": "PIRAO",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881383": {
    "id": "item_24237",
    "Last Name": "Booth",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881436": {
    "id": "item_37244",
    "Last Name": "Chen",
    "First Name": "Yan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881467": {
    "id": "item_9811",
    "Last Name": "WANG",
    "First Name": "WENMING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881616": {
    "id": "item_22719",
    "Last Name": "Sprogis",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881783": {
    "id": "item_37239",
    "Last Name": "Kelly",
    "First Name": "Judy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37881913": {
    "id": "item_22716",
    "Last Name": "HSU",
    "First Name": "TZU HAO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882112": {
    "id": "item_24233",
    "Last Name": "Clifford",
    "First Name": "Joe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882207": {
    "id": "item_22715",
    "Last Name": "Miller",
    "First Name": "Tina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882237": {
    "id": "item_24232",
    "Last Name": "Mahenthirarajah",
    "First Name": "Daran",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882327": {
    "id": "item_37231",
    "Last Name": "Evans",
    "First Name": "Zac",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882366": {
    "id": "item_37230",
    "Last Name": "Selby",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882442": {
    "id": "item_22713",
    "Last Name": "Birch",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882456": {
    "id": "item_37229",
    "Last Name": "gao",
    "First Name": "neng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882528": {
    "id": "item_37226",
    "Last Name": "Lai",
    "First Name": "Audrey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882535": {
    "id": "item_24228",
    "Last Name": "Myhre",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882581": {
    "id": "item_37225",
    "Last Name": "Keyt",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882616": {
    "id": "item_37224",
    "Last Name": "JIN",
    "First Name": "TAO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882622": {
    "id": "item_11570",
    "Last Name": "Pitts",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882649": {
    "id": "item_37223",
    "Last Name": "Hungerford",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882763": {
    "id": "item_24222",
    "Last Name": "Thevarajah",
    "First Name": "Prakash",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882808": {
    "id": "item_37218",
    "Last Name": "Hayes",
    "First Name": "Lara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37882817": {
    "id": "item_37216",
    "Last Name": "Paunil",
    "First Name": "Rico",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883016": {
    "id": "item_34882",
    "Last Name": "Greenwell",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883069": {
    "id": "item_22705",
    "Last Name": "Welbourne",
    "First Name": "Damian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883077": {
    "id": "item_37210",
    "Last Name": "Watkin",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883106": {
    "id": "item_22703",
    "Last Name": "Murphy",
    "First Name": "Cal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883154": {
    "id": "item_22702",
    "Last Name": "Scheffers",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883239": {
    "id": "item_37203",
    "Last Name": "Joyce",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883240": {
    "id": "item_9795",
    "Last Name": "Mooney",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883270": {
    "id": "item_9794",
    "Last Name": "Everest",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883280": {
    "id": "item_37201",
    "Last Name": "Davidson",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883321": {
    "id": "item_22700",
    "Last Name": "Moscos",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883358": {
    "id": "item_37195",
    "Last Name": "Strom",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883396": {
    "id": "item_9789",
    "Last Name": "Ogden",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883428": {
    "id": "item_9788",
    "Last Name": "Kilbride",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883453": {
    "id": "item_37191",
    "Last Name": "TANG",
    "First Name": "Wentao",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883454": {
    "id": "item_22698",
    "Last Name": "Ojha",
    "First Name": "Govind P",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883496": {
    "id": "item_37190",
    "Last Name": "Hickson",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883538": {
    "id": "item_11560",
    "Last Name": "Denny",
    "First Name": "Lancelot",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883558": {
    "id": "item_24211",
    "Last Name": "Woodbridge",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883559": {
    "id": "item_11556",
    "Last Name": "Bailey",
    "First Name": "Jo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883563": {
    "id": "item_11557",
    "Last Name": "Khan",
    "First Name": "Aamir",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883652": {
    "id": "item_37186",
    "Last Name": "LEE",
    "First Name": "HeeRang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883677": {
    "id": "item_9786",
    "Last Name": "Gray",
    "First Name": "AJ",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883714": {
    "id": "item_22695",
    "Last Name": "DJAMBAR",
    "First Name": "DJAMBAR",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883739": {
    "id": "item_37179",
    "Last Name": "Formosa",
    "First Name": "Jade",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883793": {
    "id": "item_37177",
    "Last Name": "Thom",
    "First Name": "Jen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883829": {
    "id": "item_11548",
    "Last Name": "Jeavons",
    "First Name": "Lawrie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883866": {
    "id": "item_37172",
    "Last Name": "Goulden-Buckley",
    "First Name": "Annabelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37883889": {
    "id": "item_37171",
    "Last Name": "Chak",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884009": {
    "id": "item_37167",
    "Last Name": "Parikh",
    "First Name": "Mehul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884082": {
    "id": "item_37163",
    "Last Name": "Dang",
    "First Name": "Vinh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884252": {
    "id": "item_10540",
    "Last Name": "Zinman",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884332": {
    "id": "item_11546",
    "Last Name": "Sideris",
    "First Name": "Timon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884384": {
    "id": "item_22685",
    "Last Name": "Gotting",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884393": {
    "id": "item_37154",
    "Last Name": "Gunn O'Connor",
    "First Name": "Harriet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884401": {
    "id": "item_11545",
    "Last Name": "Sideris",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884433": {
    "id": "item_24204",
    "Last Name": "Bailey",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884444": {
    "id": "item_24202",
    "Last Name": "Irwin",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "37884493": {
    "id": "item_37148",
    "Last Name": "mak",
    "First Name": "PUI YIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38210342": {
    "id": "item_24714",
    "Last Name": "Watson",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211331": {
    "id": "item_35637",
    "Last Name": "Donovan",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211570": {
    "id": "item_12215",
    "Last Name": "Pryor",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211574": {
    "id": "item_12217",
    "Last Name": "Viney",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211579": {
    "id": "item_35638",
    "Last Name": "Penafiel",
    "First Name": "Jasmin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211582": {
    "id": "item_12216",
    "Last Name": "Azlin",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211587": {
    "id": "item_35641",
    "Last Name": "Kosseris",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211589": {
    "id": "item_24715",
    "Last Name": "Adama",
    "First Name": "Thando",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211594": {
    "id": "item_35639",
    "Last Name": "Lau Shi Ang",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211608": {
    "id": "item_10432",
    "Last Name": "Barton - Callaghan",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211613": {
    "id": "item_12218",
    "Last Name": "Mattos Gomez Seixas Oliveira",
    "First Name": "Guilherme",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211614": {
    "id": "item_35640",
    "Last Name": "Juwono",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211621": {
    "id": "item_12219",
    "Last Name": "Lynch",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211625": {
    "id": "item_24716",
    "Last Name": "Faulkner",
    "First Name": "Matty",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211640": {
    "id": "item_35642",
    "Last Name": "Bayaraa",
    "First Name": "Sarangerel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211646": {
    "id": "item_24717",
    "Last Name": "Charles",
    "First Name": "Madeline",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211650": {
    "id": "item_10434",
    "Last Name": "Parsana",
    "First Name": "Ruchi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211660": {
    "id": "item_12220",
    "Last Name": "Spies",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211671": {
    "id": "item_35643",
    "Last Name": "Firth",
    "First Name": "Kirstie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211683": {
    "id": "item_10433",
    "Last Name": "Berardi",
    "First Name": "Frankie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211684": {
    "id": "item_24718",
    "Last Name": "Griffin",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211693": {
    "id": "item_35644",
    "Last Name": "Yang",
    "First Name": "Bon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211709": {
    "id": "item_10445",
    "Last Name": "Eades",
    "First Name": "Anna",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211722": {
    "id": "item_12223",
    "Last Name": "Tankovic",
    "First Name": "Damir",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211723": {
    "id": "item_24722",
    "Last Name": "Stanton",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211724": {
    "id": "item_10435",
    "Last Name": "Cunningham",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211725": {
    "id": "item_35645",
    "Last Name": "McKenna",
    "First Name": "Maeve McKenna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211726": {
    "id": "item_12221",
    "Last Name": "Laird",
    "First Name": "Gary",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211742": {
    "id": "item_12222",
    "Last Name": "Craft",
    "First Name": "Miles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211749": {
    "id": "item_35647",
    "Last Name": "McCallion",
    "First Name": "Aoife",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211750": {
    "id": "item_10436",
    "Last Name": "Morrow",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211757": {
    "id": "item_10438",
    "Last Name": "Forbes",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211766": {
    "id": "item_10437",
    "Last Name": "Hulbert",
    "First Name": "Riley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211781": {
    "id": "item_24719",
    "Last Name": "Lam",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211783": {
    "id": "item_24723",
    "Last Name": "Ioppolo",
    "First Name": "Renee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211786": {
    "id": "item_10441",
    "Last Name": "Nosti",
    "First Name": "Jose Manuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211802": {
    "id": "item_10442",
    "Last Name": "Peat",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211809": {
    "id": "item_24720",
    "Last Name": "King",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211819": {
    "id": "item_10439",
    "Last Name": "MCDERMOTT",
    "First Name": "MILES",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211820": {
    "id": "item_24721",
    "Last Name": "Theurel",
    "First Name": "Lois",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211830": {
    "id": "item_10440",
    "Last Name": "Ball",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211852": {
    "id": "item_35646",
    "Last Name": "Dahal",
    "First Name": "Shreejan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211853": {
    "id": "item_24724",
    "Last Name": "Morgan",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211859": {
    "id": "item_24725",
    "Last Name": "Vera Wood",
    "First Name": "Hector",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211872": {
    "id": "item_35648",
    "Last Name": "Giangualano",
    "First Name": "Dave",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211898": {
    "id": "item_24727",
    "Last Name": "Rojas Bohorquez",
    "First Name": "Dairo David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211923": {
    "id": "item_35649",
    "Last Name": "Lack",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211953": {
    "id": "item_35650",
    "Last Name": "Theodore",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211954": {
    "id": "item_10443",
    "Last Name": "Dack",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211957": {
    "id": "item_24726",
    "Last Name": "Brooks",
    "First Name": "Alyssa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211979": {
    "id": "item_10444",
    "Last Name": "WANG",
    "First Name": "MAOSONG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211984": {
    "id": "item_12224",
    "Last Name": "Fuessel",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211989": {
    "id": "item_35655",
    "Last Name": "Halfon",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38211992": {
    "id": "item_35651",
    "Last Name": "Lowe",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212037": {
    "id": "item_12225",
    "Last Name": "Hooper",
    "First Name": "Jono",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212040": {
    "id": "item_24728",
    "Last Name": "Mullins",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212042": {
    "id": "item_10446",
    "Last Name": "Kim",
    "First Name": "Byeonghwa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212051": {
    "id": "item_35652",
    "Last Name": "Ogden",
    "First Name": "Kimberley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212060": {
    "id": "item_35653",
    "Last Name": "Osborne",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212075": {
    "id": "item_24729",
    "Last Name": "Callan",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212084": {
    "id": "item_35654",
    "Last Name": "Du Randt",
    "First Name": "Ilze",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212090": {
    "id": "item_24730",
    "Last Name": "Doman",
    "First Name": "Billie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212101": {
    "id": "item_10457",
    "Last Name": "Leonov",
    "First Name": "Aleksei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212141": {
    "id": "item_24731",
    "Last Name": "Tien",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212156": {
    "id": "item_35656",
    "Last Name": "Bato",
    "First Name": "Winifred",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212158": {
    "id": "item_24732",
    "Last Name": "Pope",
    "First Name": "Jill",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212162": {
    "id": "item_10447",
    "Last Name": "Collier",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212165": {
    "id": "item_12227",
    "Last Name": "Delves",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212182": {
    "id": "item_24734",
    "Last Name": "Adams",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212188": {
    "id": "item_12226",
    "Last Name": "Huang",
    "First Name": "Yunda",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212197": {
    "id": "item_35657",
    "Last Name": "Andrews",
    "First Name": "Dale",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212201": {
    "id": "item_12228",
    "Last Name": "Press",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212211": {
    "id": "item_24733",
    "Last Name": "Noble",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212222": {
    "id": "item_35658",
    "Last Name": "Poole",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212227": {
    "id": "item_12231",
    "Last Name": "Paugam",
    "First Name": "Honore",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212243": {
    "id": "item_10448",
    "Last Name": "Murphy",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212244": {
    "id": "item_10450",
    "Last Name": "archer",
    "First Name": "matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212245": {
    "id": "item_24735",
    "Last Name": "eastham",
    "First Name": "brodie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212274": {
    "id": "item_23488",
    "Last Name": "Trontz",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212281": {
    "id": "item_10449",
    "Last Name": "Shakespeare",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212330": {
    "id": "item_23489",
    "Last Name": "Tischendorf",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212331": {
    "id": "item_24736",
    "Last Name": "Craig",
    "First Name": "Archibald",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212337": {
    "id": "item_12229",
    "Last Name": "Preeo",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212339": {
    "id": "item_24737",
    "Last Name": "Catterall",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212358": {
    "id": "item_12230",
    "Last Name": "Quartara",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212372": {
    "id": "item_10452",
    "Last Name": "Garcia",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212381": {
    "id": "item_35659",
    "Last Name": "Di Vito",
    "First Name": "Emverwell",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212395": {
    "id": "item_10451",
    "Last Name": "Tam",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212404": {
    "id": "item_24738",
    "Last Name": "WANG",
    "First Name": "KAIMIN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212427": {
    "id": "item_10453",
    "Last Name": "Ar‡mburu",
    "First Name": "Mariano",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212439": {
    "id": "item_35660",
    "Last Name": "Moraga Masson",
    "First Name": "Catalina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212458": {
    "id": "item_35661",
    "Last Name": "Richards",
    "First Name": "Keahna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212461": {
    "id": "item_12232",
    "Last Name": "Tatarek",
    "First Name": "_ukasz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212473": {
    "id": "item_24739",
    "Last Name": "Younger",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212483": {
    "id": "item_10454",
    "Last Name": "Mooney",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212518": {
    "id": "item_12233",
    "Last Name": "Haberley",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212537": {
    "id": "item_10455",
    "Last Name": "Whitty",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212570": {
    "id": "item_35662",
    "Last Name": "Jayapaul",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212589": {
    "id": "item_35663",
    "Last Name": "Trakarnwijitr",
    "First Name": "Issada",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212611": {
    "id": "item_10456",
    "Last Name": "Oliphant",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212639": {
    "id": "item_10458",
    "Last Name": "Hurley",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212665": {
    "id": "item_10459",
    "Last Name": "Sharman",
    "First Name": "Cody",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212718": {
    "id": "item_12234",
    "Last Name": "DONGSEOK",
    "First Name": "CHOI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212737": {
    "id": "item_12237",
    "Last Name": "Cowell",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212752": {
    "id": "item_12235",
    "Last Name": "Donaldson",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212763": {
    "id": "item_24740",
    "Last Name": "Luckhurst",
    "First Name": "Archie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212779": {
    "id": "item_12238",
    "Last Name": "Naranjo Diaz",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212798": {
    "id": "item_12236",
    "Last Name": "Zwickert",
    "First Name": "Kristy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212818": {
    "id": "item_10460",
    "Last Name": "Alanis",
    "First Name": "Jose Diego",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212893": {
    "id": "item_35665",
    "Last Name": "SAGITA",
    "First Name": "TIFANNY",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212915": {
    "id": "item_35664",
    "Last Name": "Houden",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38212967": {
    "id": "item_24741",
    "Last Name": "Dubadi",
    "First Name": "Durlav",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213017": {
    "id": "item_10462",
    "Last Name": "O'Flynn",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213041": {
    "id": "item_10461",
    "Last Name": "Sheers",
    "First Name": "Brent",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213081": {
    "id": "item_35666",
    "Last Name": "Bilyk",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213099": {
    "id": "item_24742",
    "Last Name": "Sanders",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213124": {
    "id": "item_24743",
    "Last Name": "Villegas Moreno",
    "First Name": "Nancy Jeniffer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213158": {
    "id": "item_24744",
    "Last Name": "Andrews",
    "First Name": "Brent",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213189": {
    "id": "item_12239",
    "Last Name": "Joel",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213198": {
    "id": "item_35667",
    "Last Name": "Carden",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213221": {
    "id": "item_35668",
    "Last Name": "Lambe",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213250": {
    "id": "item_12240",
    "Last Name": "Miranda",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213256": {
    "id": "item_35669",
    "Last Name": "Hunter",
    "First Name": "Netty",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213264": {
    "id": "item_24745",
    "Last Name": "Clapton",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213294": {
    "id": "item_10463",
    "Last Name": "Williams",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213300": {
    "id": "item_23490",
    "Last Name": "Licata",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213303": {
    "id": "item_24746",
    "Last Name": "Jelfs",
    "First Name": "Georgie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213328": {
    "id": "item_12241",
    "Last Name": "Milosavljevic",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213517": {
    "id": "item_24747",
    "Last Name": "Lawrence",
    "First Name": "Jo-Ann",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213519": {
    "id": "item_12243",
    "Last Name": "Denhere",
    "First Name": "Charity",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213522": {
    "id": "item_10464",
    "Last Name": "LI",
    "First Name": "PO-YI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213530": {
    "id": "item_12244",
    "Last Name": "Gregg",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213532": {
    "id": "item_10465",
    "Last Name": "Kellie",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213563": {
    "id": "item_24748",
    "Last Name": "Power",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213566": {
    "id": "item_10466",
    "Last Name": "McMahon",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213607": {
    "id": "item_12242",
    "Last Name": "Gorman",
    "First Name": "Donal",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213610": {
    "id": "item_10467",
    "Last Name": "Ladds",
    "First Name": "Ronan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213650": {
    "id": "item_10468",
    "Last Name": "Lorder",
    "First Name": "Zack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213694": {
    "id": "item_10469",
    "Last Name": "HUANG",
    "First Name": "CHIH-JUNG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213696": {
    "id": "item_24749",
    "Last Name": "CHONG",
    "First Name": "TESSA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213712": {
    "id": "item_35670",
    "Last Name": "Oliver",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213728": {
    "id": "item_12245",
    "Last Name": "Webber",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213746": {
    "id": "item_12248",
    "Last Name": "flynn-troy",
    "First Name": "cassidy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213759": {
    "id": "item_12246",
    "Last Name": "Kearney",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213783": {
    "id": "item_35672",
    "Last Name": "Barrett",
    "First Name": "Harriet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213795": {
    "id": "item_35674",
    "Last Name": "Bielons",
    "First Name": "Paola",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213804": {
    "id": "item_24750",
    "Last Name": "Croker",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213827": {
    "id": "item_10470",
    "Last Name": "Allan",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213906": {
    "id": "item_35671",
    "Last Name": "Lin",
    "First Name": "Veronica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213914": {
    "id": "item_12247",
    "Last Name": "Lieschke",
    "First Name": "April",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38213952": {
    "id": "item_10471",
    "Last Name": "Wilson",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214005": {
    "id": "item_12250",
    "Last Name": "Tay",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214069": {
    "id": "item_10472",
    "Last Name": "Smith",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214075": {
    "id": "item_35673",
    "Last Name": "Roth",
    "First Name": "Abbi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214109": {
    "id": "item_24751",
    "Last Name": "Pollard",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214113": {
    "id": "item_38265",
    "Last Name": "Zhdanko",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214125": {
    "id": "item_10473",
    "Last Name": "Anstis",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214146": {
    "id": "item_12249",
    "Last Name": "Ravi",
    "First Name": "Shobegen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214153": {
    "id": "item_35675",
    "Last Name": "Agorilla",
    "First Name": "Francis Arvy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214181": {
    "id": "item_35678",
    "Last Name": "Joshuang",
    "First Name": "Leonardus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214209": {
    "id": "item_12251",
    "Last Name": "Pacovski",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214212": {
    "id": "item_10474",
    "Last Name": "JINWOO",
    "First Name": "BAE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214236": {
    "id": "item_12252",
    "Last Name": "Small",
    "First Name": "Kirsty",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214240": {
    "id": "item_35676",
    "Last Name": "Nguyen",
    "First Name": "Van Anh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214241": {
    "id": "item_35677",
    "Last Name": "Harvey",
    "First Name": "Cait",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214249": {
    "id": "item_12253",
    "Last Name": "Thorpe",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214299": {
    "id": "item_35679",
    "Last Name": "Tedjasaputra",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214304": {
    "id": "item_35680",
    "Last Name": "Charitopoulos",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214320": {
    "id": "item_24752",
    "Last Name": "Pierpoint",
    "First Name": "Bryce",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214347": {
    "id": "item_24753",
    "Last Name": "Johnston",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214383": {
    "id": "item_12254",
    "Last Name": "Price",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214388": {
    "id": "item_23491",
    "Last Name": "Zimmerman",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214455": {
    "id": "item_12260",
    "Last Name": "Mora",
    "First Name": "Carol",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214492": {
    "id": "item_10475",
    "Last Name": "Bakker",
    "First Name": "Malachi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214511": {
    "id": "item_24754",
    "Last Name": "Betard",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214529": {
    "id": "item_35681",
    "Last Name": "Chow",
    "First Name": "Suet Yan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214536": {
    "id": "item_35682",
    "Last Name": "Yao",
    "First Name": "Aka",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214595": {
    "id": "item_12256",
    "Last Name": "Szlachetko",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214628": {
    "id": "item_12255",
    "Last Name": "Nguyen",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214639": {
    "id": "item_10476",
    "Last Name": "Potter",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214720": {
    "id": "item_24755",
    "Last Name": "Whitaker",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214721": {
    "id": "item_12257",
    "Last Name": "lee",
    "First Name": "jaewon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214742": {
    "id": "item_12258",
    "Last Name": "Schmidt",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214751": {
    "id": "item_12259",
    "Last Name": "Raiz",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214772": {
    "id": "item_35683",
    "Last Name": "Sheth",
    "First Name": "Rajiv",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214799": {
    "id": "item_35684",
    "Last Name": "Padmanabhan",
    "First Name": "Karthik",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214804": {
    "id": "item_24756",
    "Last Name": "Brookes",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214870": {
    "id": "item_10477",
    "Last Name": "Jennings",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214899": {
    "id": "item_10478",
    "Last Name": "Cox",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214954": {
    "id": "item_12261",
    "Last Name": "Pearce",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38214973": {
    "id": "item_24757",
    "Last Name": "Dermott",
    "First Name": "Mia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215017": {
    "id": "item_24758",
    "Last Name": "Jiang",
    "First Name": "Hai Dong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215046": {
    "id": "item_10479",
    "Last Name": "Nicholls",
    "First Name": "Pat",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215145": {
    "id": "item_12262",
    "Last Name": "Steding",
    "First Name": "Riley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215198": {
    "id": "item_12263",
    "Last Name": "Harris",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215203": {
    "id": "item_24759",
    "Last Name": "Sheed",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215210": {
    "id": "item_12264",
    "Last Name": "Pantling",
    "First Name": "Braeden",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215316": {
    "id": "item_24760",
    "Last Name": "Arlow",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215335": {
    "id": "item_35685",
    "Last Name": "Brodholt",
    "First Name": "Scarlett",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215356": {
    "id": "item_35686",
    "Last Name": "piccio",
    "First Name": "maria imelda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215379": {
    "id": "item_12265",
    "Last Name": "Fitzgerald",
    "First Name": "Nathaniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215386": {
    "id": "item_24761",
    "Last Name": "Thomann",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215412": {
    "id": "item_23492",
    "Last Name": "Liu",
    "First Name": "Chak Wo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215463": {
    "id": "item_12266",
    "Last Name": "Wray",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215524": {
    "id": "item_12267",
    "Last Name": "Nguyen Minh",
    "First Name": "Phung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215541": {
    "id": "item_24762",
    "Last Name": "Yuan",
    "First Name": "Krista",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38215890": {
    "id": "item_24763",
    "Last Name": "Sas",
    "First Name": "Nikolai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216011": {
    "id": "item_12268",
    "Last Name": "Murphy",
    "First Name": "Julia",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216076": {
    "id": "item_12269",
    "Last Name": "Sasaran",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216232": {
    "id": "item_35687",
    "Last Name": "Sumner",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216329": {
    "id": "item_24764",
    "Last Name": "borda",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216902": {
    "id": "item_35688",
    "Last Name": "Wilson",
    "First Name": "Frances",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38216988": {
    "id": "item_24765",
    "Last Name": "Smith",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217004": {
    "id": "item_35689",
    "Last Name": "Reid",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217143": {
    "id": "item_23493",
    "Last Name": "Patman",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217336": {
    "id": "item_10480",
    "Last Name": "Garner",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217422": {
    "id": "item_24766",
    "Last Name": "Larsen",
    "First Name": "Kalieb",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217540": {
    "id": "item_24767",
    "Last Name": "Hewitt",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217644": {
    "id": "item_12270",
    "Last Name": "Nazarizadeh",
    "First Name": "Ali",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217726": {
    "id": "item_12271",
    "Last Name": "Nowicki",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217770": {
    "id": "item_24768",
    "Last Name": "Gossage",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217869": {
    "id": "item_35690",
    "Last Name": "Ramesh",
    "First Name": "Nikhil",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217916": {
    "id": "item_10481",
    "Last Name": "Sandoval Rojo",
    "First Name": "Mario",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38217953": {
    "id": "item_35691",
    "Last Name": "Gonz‡lez Lozano",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218025": {
    "id": "item_24770",
    "Last Name": "Danaatmadja",
    "First Name": "Anandita",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218037": {
    "id": "item_35692",
    "Last Name": "Bell",
    "First Name": "Jocelyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218299": {
    "id": "item_12272",
    "Last Name": "YUN",
    "First Name": "YONGMAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218310": {
    "id": "item_24769",
    "Last Name": "Hennessy",
    "First Name": "Daragh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218334": {
    "id": "item_24772",
    "Last Name": "Norledge",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218401": {
    "id": "item_12273",
    "Last Name": "Noble",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218434": {
    "id": "item_12274",
    "Last Name": "Savu",
    "First Name": "Andrei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218441": {
    "id": "item_24771",
    "Last Name": "Hulston",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218446": {
    "id": "item_10482",
    "Last Name": "Oakley",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218561": {
    "id": "item_12275",
    "Last Name": "ELWORTHY",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218678": {
    "id": "item_12277",
    "Last Name": "Wilson",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218748": {
    "id": "item_12276",
    "Last Name": "Tarplah",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218886": {
    "id": "item_12278",
    "Last Name": "RIMMER",
    "First Name": "MARISSA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218904": {
    "id": "item_35693",
    "Last Name": "Parekh",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38218968": {
    "id": "item_10483",
    "Last Name": "Czwarno",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219069": {
    "id": "item_24773",
    "Last Name": "Foo",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219071": {
    "id": "item_35694",
    "Last Name": "Carpio",
    "First Name": "Senen Bradley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219125": {
    "id": "item_24774",
    "Last Name": "Thomson",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219242": {
    "id": "item_10484",
    "Last Name": "Morales",
    "First Name": "Hector",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219278": {
    "id": "item_35695",
    "Last Name": "Hunter",
    "First Name": "Nova",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219333": {
    "id": "item_10485",
    "Last Name": "UISSO",
    "First Name": "EMILY",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219342": {
    "id": "item_24775",
    "Last Name": "Cannon",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219459": {
    "id": "item_24776",
    "Last Name": "Vas",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219499": {
    "id": "item_12279",
    "Last Name": "Muddle",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219623": {
    "id": "item_24777",
    "Last Name": "Galvan Pastor",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219626": {
    "id": "item_24778",
    "Last Name": "Neville",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219635": {
    "id": "item_12280",
    "Last Name": "Shaw",
    "First Name": "Colin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219637": {
    "id": "item_10486",
    "Last Name": "Neofitou",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219752": {
    "id": "item_10487",
    "Last Name": "Hebblethwaite",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219800": {
    "id": "item_35696",
    "Last Name": "Gedye",
    "First Name": "Carlen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219820": {
    "id": "item_24779",
    "Last Name": "Phelps",
    "First Name": "Allen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219851": {
    "id": "item_24780",
    "Last Name": "Montgomerie",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219899": {
    "id": "item_12281",
    "Last Name": "Tull",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219933": {
    "id": "item_12282",
    "Last Name": "Way-Nee",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219959": {
    "id": "item_12283",
    "Last Name": "Brooker",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219967": {
    "id": "item_24782",
    "Last Name": "CHEN",
    "First Name": "YONG LIN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38219991": {
    "id": "item_24781",
    "Last Name": "Congedo",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220115": {
    "id": "item_10488",
    "Last Name": "Eun",
    "First Name": "Huiyu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220167": {
    "id": "item_10489",
    "Last Name": "Williams",
    "First Name": "Corie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220182": {
    "id": "item_35697",
    "Last Name": "Morton",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220183": {
    "id": "item_24784",
    "Last Name": "Stokes",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220191": {
    "id": "item_24783",
    "Last Name": "Wright",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220244": {
    "id": "item_24786",
    "Last Name": "KUMAR",
    "First Name": "PANKAJ",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220264": {
    "id": "item_24785",
    "Last Name": "Cooper",
    "First Name": "Curtis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220317": {
    "id": "item_24787",
    "Last Name": "Magart",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220333": {
    "id": "item_24788",
    "Last Name": "TORRES",
    "First Name": "SHARON ROSE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220476": {
    "id": "item_12284",
    "Last Name": "Polak",
    "First Name": "Dusan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220541": {
    "id": "item_24789",
    "Last Name": "Burton",
    "First Name": "Jock",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220640": {
    "id": "item_12285",
    "Last Name": "Fresneda Genovard",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220780": {
    "id": "item_24790",
    "Last Name": "Ghidella",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220804": {
    "id": "item_10490",
    "Last Name": "Samatuly",
    "First Name": "Zharas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220907": {
    "id": "item_10491",
    "Last Name": "Martinez Romero",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220955": {
    "id": "item_24791",
    "Last Name": "Kartsounis",
    "First Name": "Viviene",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220964": {
    "id": "item_35698",
    "Last Name": "Delgao Alcayde",
    "First Name": "Nazarena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220975": {
    "id": "item_23494",
    "Last Name": "Di Bartolomeo",
    "First Name": "Florian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38220983": {
    "id": "item_12286",
    "Last Name": "Carter",
    "First Name": "Chase",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221028": {
    "id": "item_12287",
    "Last Name": "Matthewman",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221055": {
    "id": "item_35699",
    "Last Name": "Ashton",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221096": {
    "id": "item_24792",
    "Last Name": "Roel",
    "First Name": "Georgie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221308": {
    "id": "item_12288",
    "Last Name": "Smith",
    "First Name": "Fletcher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221311": {
    "id": "item_35700",
    "Last Name": "Duckworth",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221397": {
    "id": "item_35701",
    "Last Name": "Brann",
    "First Name": "Taneille",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221420": {
    "id": "item_10492",
    "Last Name": "Price",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221496": {
    "id": "item_24793",
    "Last Name": "Marks",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221576": {
    "id": "item_12289",
    "Last Name": "Wood",
    "First Name": "Flynn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221730": {
    "id": "item_12290",
    "Last Name": "Meng",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221774": {
    "id": "item_10493",
    "Last Name": "Maximov",
    "First Name": "Maxim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221775": {
    "id": "item_10494",
    "Last Name": "Donnik",
    "First Name": "Roman",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38221974": {
    "id": "item_35702",
    "Last Name": "Stoddard",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222005": {
    "id": "item_35703",
    "Last Name": "Wu",
    "First Name": "Yiqing",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222023": {
    "id": "item_12291",
    "Last Name": "Morsanuto",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222106": {
    "id": "item_12292",
    "Last Name": "Thorn",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222127": {
    "id": "item_10495",
    "Last Name": "Potts",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222139": {
    "id": "item_10497",
    "Last Name": "Nistrian",
    "First Name": "Issachar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222151": {
    "id": "item_10496",
    "Last Name": "Andrewartha",
    "First Name": "Zach",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222180": {
    "id": "item_12293",
    "Last Name": "Alderton",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222223": {
    "id": "item_12294",
    "Last Name": "Stezhkin",
    "First Name": "Aleksandr",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222272": {
    "id": "item_35704",
    "Last Name": "Dalak-Ozog",
    "First Name": "Gra_yna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222325": {
    "id": "item_10498",
    "Last Name": "Parker",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222387": {
    "id": "item_35705",
    "Last Name": "Montes",
    "First Name": "James Kenneth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222400": {
    "id": "item_12295",
    "Last Name": "Chapman",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222413": {
    "id": "item_10499",
    "Last Name": "Ion",
    "First Name": "Alexandru",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222583": {
    "id": "item_12296",
    "Last Name": "Ingram",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222678": {
    "id": "item_24794",
    "Last Name": "Leask",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222728": {
    "id": "item_24795",
    "Last Name": "Carvalho Meira de Araujo",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222744": {
    "id": "item_24796",
    "Last Name": "Real Piguillem",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222760": {
    "id": "item_35706",
    "Last Name": "Lahinta",
    "First Name": "Agus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222784": {
    "id": "item_10500",
    "Last Name": "Castro",
    "First Name": "Abel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222891": {
    "id": "item_10501",
    "Last Name": "Snell",
    "First Name": "Alastair",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38222983": {
    "id": "item_10502",
    "Last Name": "Kingdon",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223054": {
    "id": "item_24797",
    "Last Name": "Zee",
    "First Name": "Warren",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223063": {
    "id": "item_35707",
    "Last Name": "Claassen",
    "First Name": "Keren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223154": {
    "id": "item_35708",
    "Last Name": "Karvinkop",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223172": {
    "id": "item_35709",
    "Last Name": "Bimantara",
    "First Name": "Afif",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223237": {
    "id": "item_35710",
    "Last Name": "Garriga",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223280": {
    "id": "item_35711",
    "Last Name": "Gardeniers",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223324": {
    "id": "item_12297",
    "Last Name": "Aulia",
    "First Name": "Ovy Magda",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223340": {
    "id": "item_24798",
    "Last Name": "Hanna",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223360": {
    "id": "item_10503",
    "Last Name": "Johns",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223376": {
    "id": "item_35712",
    "Last Name": "Puntuyakorn",
    "First Name": "Burin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223410": {
    "id": "item_10504",
    "Last Name": "Nhengeze",
    "First Name": "Innocent Tichaona",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223619": {
    "id": "item_35713",
    "Last Name": "Mockler",
    "First Name": "Mags",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223651": {
    "id": "item_35714",
    "Last Name": "Permana",
    "First Name": "Yudiya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223686": {
    "id": "item_12298",
    "Last Name": "Beckett",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223690": {
    "id": "item_12299",
    "Last Name": "Cade",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223787": {
    "id": "item_24799",
    "Last Name": "Nanayakkara",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223903": {
    "id": "item_24800",
    "Last Name": "Hincksman",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38223953": {
    "id": "item_35715",
    "Last Name": "Tregear",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224008": {
    "id": "item_35716",
    "Last Name": "Leong",
    "First Name": "Immanuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224040": {
    "id": "item_24801",
    "Last Name": "De Luca",
    "First Name": "Guido",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224047": {
    "id": "item_12300",
    "Last Name": "Tinio",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224147": {
    "id": "item_12301",
    "Last Name": "Praes Menezes",
    "First Name": "Guilherme",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224169": {
    "id": "item_35717",
    "Last Name": "Sherlini",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224393": {
    "id": "item_10505",
    "Last Name": "Igros",
    "First Name": "John Ivan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224464": {
    "id": "item_24802",
    "Last Name": "Srivastava",
    "First Name": "Manisha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224538": {
    "id": "item_35718",
    "Last Name": "Varfolomeeva",
    "First Name": "Ekaterina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224635": {
    "id": "item_24803",
    "Last Name": "Martins",
    "First Name": "Danny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224715": {
    "id": "item_12302",
    "Last Name": "Kashangaki",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224760": {
    "id": "item_35719",
    "Last Name": "Rundle",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38224789": {
    "id": "item_35720",
    "Last Name": "Yin",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225023": {
    "id": "item_35721",
    "Last Name": "Sinha",
    "First Name": "Prashant",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225460": {
    "id": "item_12303",
    "Last Name": "Ivory",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225503": {
    "id": "item_24804",
    "Last Name": "Roche",
    "First Name": "Kate Anne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225598": {
    "id": "item_24805",
    "Last Name": "Trost",
    "First Name": "Dominique",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225706": {
    "id": "item_10506",
    "Last Name": "Amaral",
    "First Name": "Carl",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225712": {
    "id": "item_35722",
    "Last Name": "Hector",
    "First Name": "Rebekah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225764": {
    "id": "item_12304",
    "Last Name": "Andrian",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38225958": {
    "id": "item_35723",
    "Last Name": "Rocha",
    "First Name": "Camila",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38226133": {
    "id": "item_35724",
    "Last Name": "Nagarajan",
    "First Name": "Thamyliniane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38226401": {
    "id": "item_12305",
    "Last Name": "Raimundo",
    "First Name": "Jo‹o Tiago",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38227981": {
    "id": "item_24806",
    "Last Name": "Sharp",
    "First Name": "Graham",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38229059": {
    "id": "item_10507",
    "Last Name": "GWAK",
    "First Name": "SEONGJONG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38232008": {
    "id": "item_12306",
    "Last Name": "Vargas Zu–iga",
    "First Name": "Gustavo Adolfo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38232675": {
    "id": "item_35725",
    "Last Name": "Hartman",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38233198": {
    "id": "item_12307",
    "Last Name": "Hart",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38234216": {
    "id": "item_24807",
    "Last Name": "May",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38235874": {
    "id": "item_24808",
    "Last Name": "Stewart",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38241113": {
    "id": "item_12308",
    "Last Name": "Woolfe",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38243545": {
    "id": "item_24809",
    "Last Name": "Ng",
    "First Name": "Jing Wen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38248136": {
    "id": "item_12309",
    "Last Name": "SOTO GOMEZ",
    "First Name": "CUAUHTEMOC",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38248162": {
    "id": "item_10508",
    "Last Name": "Ventura",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38248759": {
    "id": "item_10509",
    "Last Name": "Homburg",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38248815": {
    "id": "item_12310",
    "Last Name": "Maldonado",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38248874": {
    "id": "item_24810",
    "Last Name": "Bakin",
    "First Name": "Maya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38249095": {
    "id": "item_12311",
    "Last Name": "Flannery",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38249149": {
    "id": "item_24811",
    "Last Name": "Coster",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38249619": {
    "id": "item_24812",
    "Last Name": "Ng",
    "First Name": "Wein",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38249975": {
    "id": "item_12312",
    "Last Name": "Haynes",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38250237": {
    "id": "item_35726",
    "Last Name": "Langoulant",
    "First Name": "Racquel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38250323": {
    "id": "item_23495",
    "Last Name": "MALEY",
    "First Name": "TANJA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38250392": {
    "id": "item_12313",
    "Last Name": "Walker",
    "First Name": "Benn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38253614": {
    "id": "item_35727",
    "Last Name": "Chenney",
    "First Name": "Taylah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38253798": {
    "id": "item_24813",
    "Last Name": "Suda",
    "First Name": "Meg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38254298": {
    "id": "item_12314",
    "Last Name": "Ozimek",
    "First Name": "Wojciech",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38254554": {
    "id": "item_24814",
    "Last Name": "Turner",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38255278": {
    "id": "item_35728",
    "Last Name": "Salazar",
    "First Name": "Ana Cecilia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38255737": {
    "id": "item_24815",
    "Last Name": "Pulyadath",
    "First Name": "Vivek Thilakan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38255745": {
    "id": "item_12315",
    "Last Name": "Perez",
    "First Name": "Jheisson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256056": {
    "id": "item_35729",
    "Last Name": "Vo",
    "First Name": "Mai-Anh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256074": {
    "id": "item_24816",
    "Last Name": "Hadjinicolaou",
    "First Name": "Kane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256242": {
    "id": "item_24817",
    "Last Name": "Trenerry",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256251": {
    "id": "item_12316",
    "Last Name": "Kanaiya",
    "First Name": "Shamik Pramod",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256490": {
    "id": "item_10510",
    "Last Name": "Snooks",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38256691": {
    "id": "item_24818",
    "Last Name": "Charman",
    "First Name": "Declan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38257407": {
    "id": "item_12317",
    "Last Name": "Kling",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38257841": {
    "id": "item_10511",
    "Last Name": "Stedman",
    "First Name": "Elliott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38257853": {
    "id": "item_35730",
    "Last Name": "Berisha",
    "First Name": "Artur",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258072": {
    "id": "item_10512",
    "Last Name": "Agarwal",
    "First Name": "Sanchit",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258351": {
    "id": "item_24819",
    "Last Name": "Byrnes",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258397": {
    "id": "item_35731",
    "Last Name": "Still",
    "First Name": "Rod",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258424": {
    "id": "item_24820",
    "Last Name": "Draper",
    "First Name": "Tabatha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258591": {
    "id": "item_12318",
    "Last Name": "Crisostomo",
    "First Name": "Mathew Louis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38258664": {
    "id": "item_10513",
    "Last Name": "Butler",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38259547": {
    "id": "item_35732",
    "Last Name": "Craigie",
    "First Name": "Bonnie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38259662": {
    "id": "item_35733",
    "Last Name": "Turner",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38261316": {
    "id": "item_10514",
    "Last Name": "Gravener",
    "First Name": "Nat",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38262838": {
    "id": "item_12319",
    "Last Name": "Lund",
    "First Name": "Peran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38262904": {
    "id": "item_24821",
    "Last Name": "Schadow",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38263599": {
    "id": "item_35734",
    "Last Name": "Soewanto",
    "First Name": "Sunny K.",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38264058": {
    "id": "item_35735",
    "Last Name": "Alfiana",
    "First Name": "Moudy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38265000": {
    "id": "item_35736",
    "Last Name": "Nguyen",
    "First Name": "Vivienne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38265705": {
    "id": "item_10515",
    "Last Name": "Tuck",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38270420": {
    "id": "item_24834",
    "Last Name": "Newton",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38270556": {
    "id": "item_24835",
    "Last Name": "Tutkaj",
    "First Name": "Grzegorz",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38270797": {
    "id": "item_12328",
    "Last Name": "Lodge",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38281189": {
    "id": "item_24836",
    "Last Name": "Hernandez Hernandez",
    "First Name": "Rocio Talina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38289589": {
    "id": "item_23497",
    "Last Name": "Adlesic Barba",
    "First Name": "Natasa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38294500": {
    "id": "item_23498",
    "Last Name": "Bundu",
    "First Name": "Andronikus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38295022": {
    "id": "item_12329",
    "Last Name": "younes",
    "First Name": "lincoln",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38295547": {
    "id": "item_35748",
    "Last Name": "de Roany",
    "First Name": "Penelope",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38295588": {
    "id": "item_10522",
    "Last Name": "Dolby",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38295870": {
    "id": "item_12330",
    "Last Name": "Ewens",
    "First Name": "Eli",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38296506": {
    "id": "item_24837",
    "Last Name": "Phiri",
    "First Name": "Derrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38296974": {
    "id": "item_35749",
    "Last Name": "English",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38297270": {
    "id": "item_35750",
    "Last Name": "Blakey",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38297979": {
    "id": "item_10523",
    "Last Name": "Ramirez",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38298689": {
    "id": "item_12331",
    "Last Name": "Cruz Gutierrez",
    "First Name": "Maria Teresa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38299071": {
    "id": "item_12332",
    "Last Name": "Lee",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38299122": {
    "id": "item_10524",
    "Last Name": "Tellez",
    "First Name": "Juan Ram—n",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38299670": {
    "id": "item_10525",
    "Last Name": "Pan",
    "First Name": "Elfred",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38300157": {
    "id": "item_10526",
    "Last Name": "Sosa",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38300231": {
    "id": "item_24838",
    "Last Name": "Balakrishna",
    "First Name": "Yashas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38300958": {
    "id": "item_35751",
    "Last Name": "Alfasya",
    "First Name": "Tengku Rizal",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38301065": {
    "id": "item_24839",
    "Last Name": "Ielejs",
    "First Name": "Karlis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38301930": {
    "id": "item_35752",
    "Last Name": "Li",
    "First Name": "Wan Tsun",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302007": {
    "id": "item_24840",
    "Last Name": "Bray",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302106": {
    "id": "item_35753",
    "Last Name": "Grunau",
    "First Name": "Adrienne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302348": {
    "id": "item_23499",
    "Last Name": "Zhangaliyev",
    "First Name": "Rauan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302448": {
    "id": "item_24841",
    "Last Name": "O'Donnell",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302451": {
    "id": "item_35754",
    "Last Name": "Webber",
    "First Name": "Jacquelyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302462": {
    "id": "item_10527",
    "Last Name": "Webster",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302478": {
    "id": "item_12333",
    "Last Name": "Williams",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302509": {
    "id": "item_24842",
    "Last Name": "Press",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302577": {
    "id": "item_10528",
    "Last Name": "Bissacco",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302776": {
    "id": "item_35755",
    "Last Name": "robinson",
    "First Name": "scarlett",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302870": {
    "id": "item_24843",
    "Last Name": "Estrada",
    "First Name": "Mateo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302880": {
    "id": "item_24844",
    "Last Name": "Trevino",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302916": {
    "id": "item_24845",
    "Last Name": "Suwandi",
    "First Name": "Suwandi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302967": {
    "id": "item_12334",
    "Last Name": "PARK",
    "First Name": "JUNYOUNG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38302969": {
    "id": "item_24846",
    "Last Name": "Barzilay",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303068": {
    "id": "item_24847",
    "Last Name": "Edwards",
    "First Name": "Christopher Rhyss",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303107": {
    "id": "item_35756",
    "Last Name": "Beven",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303131": {
    "id": "item_10529",
    "Last Name": "Grant",
    "First Name": "Jun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303310": {
    "id": "item_12335",
    "Last Name": "Vozzo",
    "First Name": "Jonah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303685": {
    "id": "item_38266",
    "Last Name": "Yussof",
    "First Name": "Wan Haziq",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303701": {
    "id": "item_35757",
    "Last Name": "Reed",
    "First Name": "India",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38303924": {
    "id": "item_24848",
    "Last Name": "Wong",
    "First Name": "Cynthea",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304080": {
    "id": "item_35758",
    "Last Name": "Alhambra",
    "First Name": "Raphael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304188": {
    "id": "item_12336",
    "Last Name": "Rachman",
    "First Name": "Aditya Nur",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304280": {
    "id": "item_10530",
    "Last Name": "OÕDea",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304330": {
    "id": "item_10531",
    "Last Name": "Gruber",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304437": {
    "id": "item_24849",
    "Last Name": "Creighton",
    "First Name": "Kylee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304459": {
    "id": "item_24850",
    "Last Name": "Creighton",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304558": {
    "id": "item_24851",
    "Last Name": "Mackay",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304595": {
    "id": "item_12337",
    "Last Name": "Syzdykov",
    "First Name": "Teymur",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304724": {
    "id": "item_10532",
    "Last Name": "Schuman",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304742": {
    "id": "item_12338",
    "Last Name": "Lanzoni",
    "First Name": "Bruna",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38304891": {
    "id": "item_12339",
    "Last Name": "Gallagher",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305067": {
    "id": "item_10533",
    "Last Name": "Carmichael",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305128": {
    "id": "item_10534",
    "Last Name": "Monkhouse",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305205": {
    "id": "item_10535",
    "Last Name": "Tozer",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305305": {
    "id": "item_24852",
    "Last Name": "Guerra",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305354": {
    "id": "item_10536",
    "Last Name": "Wasley",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38305522": {
    "id": "item_24853",
    "Last Name": "Chin",
    "First Name": "Chienteng",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38306233": {
    "id": "item_10537",
    "Last Name": "Korovina",
    "First Name": "Liubov",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38306460": {
    "id": "item_35759",
    "Last Name": "Xu",
    "First Name": "Cathy Caoping",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38307901": {
    "id": "item_24854",
    "Last Name": "Murillo Morales",
    "First Name": "Sergio Manuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38308532": {
    "id": "item_24855",
    "Last Name": "KUBIAK",
    "First Name": "PIOTR",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38312894": {
    "id": "item_35760",
    "Last Name": "Valdes Lozano",
    "First Name": "Luis Alberto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38314664": {
    "id": "item_24856",
    "Last Name": "Rankin",
    "First Name": "Alistair",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38323958": {
    "id": "item_24857",
    "Last Name": "Jones",
    "First Name": "Toby",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38326357": {
    "id": "item_24858",
    "Last Name": "LaForgia",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38326525": {
    "id": "item_35761",
    "Last Name": "Wharakura",
    "First Name": "Brad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38329244": {
    "id": "item_12340",
    "Last Name": "JUNG",
    "First Name": "YONGJIN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38330870": {
    "id": "item_24859",
    "Last Name": "Clark",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38337819": {
    "id": "item_12341",
    "Last Name": "Cheaterfield",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38338061": {
    "id": "item_10538",
    "Last Name": "Rhodes",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38338183": {
    "id": "item_12342",
    "Last Name": "Brime",
    "First Name": "Leonel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38339854": {
    "id": "item_24860",
    "Last Name": "Chaudhry",
    "First Name": "Ujjwal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38340095": {
    "id": "item_10539",
    "Last Name": "Boland",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38340484": {
    "id": "item_24861",
    "Last Name": "Dawson",
    "First Name": "Todd",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38340688": {
    "id": "item_23500",
    "Last Name": "Joshi",
    "First Name": "Ashish",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38340767": {
    "id": "item_24862",
    "Last Name": "Cafra",
    "First Name": "Eleanor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38341140": {
    "id": "item_12343",
    "Last Name": "Baxter-Holland",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38371838": {
    "id": "item_24863",
    "Last Name": "Alimbekov",
    "First Name": "Aidar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38406212": {
    "id": "item_35762",
    "Last Name": "Scott",
    "First Name": "Barry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38406778": {
    "id": "item_12344",
    "Last Name": "Frew",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38450493": {
    "id": "item_24864",
    "Last Name": "Whyte",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38462255": {
    "id": "item_24865",
    "Last Name": "Oldham",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38465666": {
    "id": "item_12345",
    "Last Name": "LEE",
    "First Name": "SENG HOOI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38512997": {
    "id": "item_24920",
    "Last Name": "Nikitaras",
    "First Name": "Reece",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38527647": {
    "id": "item_10570",
    "Last Name": "Alforque",
    "First Name": "Moiselle Angelo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38530055": {
    "id": "item_35799",
    "Last Name": "Gallagher",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38531133": {
    "id": "item_24921",
    "Last Name": "Naylor",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38531651": {
    "id": "item_12381",
    "Last Name": "stepanov",
    "First Name": "julian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38532305": {
    "id": "item_35800",
    "Last Name": "Hayward",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38532487": {
    "id": "item_12382",
    "Last Name": "O'Donovan",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38533004": {
    "id": "item_35801",
    "Last Name": "Phillips",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38533363": {
    "id": "item_35802",
    "Last Name": "Roach",
    "First Name": "Damien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38533589": {
    "id": "item_12383",
    "Last Name": "Hughes",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38534691": {
    "id": "item_10571",
    "Last Name": "Hoyset",
    "First Name": "Mats",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38534986": {
    "id": "item_12384",
    "Last Name": "Kennedy",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38535034": {
    "id": "item_10572",
    "Last Name": "Desentis Calleja",
    "First Name": "Diego Roberto",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38536940": {
    "id": "item_10573",
    "Last Name": "Anderson",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38536955": {
    "id": "item_10574",
    "Last Name": "Holmes",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38537041": {
    "id": "item_35803",
    "Last Name": "Chiang",
    "First Name": "Yu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38537236": {
    "id": "item_12385",
    "Last Name": "Jerez",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38537488": {
    "id": "item_24922",
    "Last Name": "YANG",
    "First Name": "KAI-CHUN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38537490": {
    "id": "item_10575",
    "Last Name": "Golovitsyn",
    "First Name": "Nikita",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38537980": {
    "id": "item_35804",
    "Last Name": "Loh",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38538857": {
    "id": "item_10576",
    "Last Name": "Labate",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38538931": {
    "id": "item_35805",
    "Last Name": "Sard",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38539010": {
    "id": "item_35806",
    "Last Name": "cho",
    "First Name": "sooyeon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38540388": {
    "id": "item_12386",
    "Last Name": "Gonzalez Echenique",
    "First Name": "Eliana",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38544642": {
    "id": "item_35807",
    "Last Name": "NORWOOD",
    "First Name": "DANIEL",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38559976": {
    "id": "item_35808",
    "Last Name": "Saldumbides",
    "First Name": "ƒrika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38566497": {
    "id": "item_12387",
    "Last Name": "Banasaz",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38566940": {
    "id": "item_12388",
    "Last Name": "Fulgencio",
    "First Name": "Ruben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38586847": {
    "id": "item_24923",
    "Last Name": "Rudd",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38588853": {
    "id": "item_10577",
    "Last Name": "Lynch",
    "First Name": "Malachy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38596331": {
    "id": "item_24924",
    "Last Name": "Crosson",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38596968": {
    "id": "item_12389",
    "Last Name": "Junaedi",
    "First Name": "Ferry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38617406": {
    "id": "item_23507",
    "Last Name": "Anez de Daboin",
    "First Name": "Eva Maria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38634259": {
    "id": "item_23508",
    "Last Name": "neville",
    "First Name": "skye",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38659216": {
    "id": "item_24925",
    "Last Name": "Hugh-Jones",
    "First Name": "Theo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38659911": {
    "id": "item_24926",
    "Last Name": "Harricks",
    "First Name": "Finn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38660608": {
    "id": "item_10578",
    "Last Name": "DÕAntonio",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38660890": {
    "id": "item_12390",
    "Last Name": "Hampson",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38674298": {
    "id": "item_35809",
    "Last Name": "Arya",
    "First Name": "Gavrilla",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38675831": {
    "id": "item_35810",
    "Last Name": "Beer",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38678694": {
    "id": "item_35811",
    "Last Name": "Ho",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38680500": {
    "id": "item_12391",
    "Last Name": "Hewer",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38680513": {
    "id": "item_35812",
    "Last Name": "Farrell",
    "First Name": "JP",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38680706": {
    "id": "item_12392",
    "Last Name": "Stansfield",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38681207": {
    "id": "item_24927",
    "Last Name": "Dunphy",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "38682844": {
    "id": "item_10579",
    "Last Name": "Carniglia",
    "First Name": "Simone",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39035820": {
    "id": "item_12393",
    "Last Name": "Zurbruegg",
    "First Name": "Hans-Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39073452": {
    "id": "item_35813",
    "Last Name": "Holmes",
    "First Name": "Lara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39095345": {
    "id": "item_10580",
    "Last Name": "Blankenship",
    "First Name": "Cody",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39096179": {
    "id": "item_35814",
    "Last Name": "Majka",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39096305": {
    "id": "item_24928",
    "Last Name": "Morgan",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39096864": {
    "id": "item_10581",
    "Last Name": "Al-Rashid",
    "First Name": "Salman",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39097348": {
    "id": "item_24929",
    "Last Name": "Marchel",
    "First Name": "Spencer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39132351": {
    "id": "item_10582",
    "Last Name": "Coombes",
    "First Name": "Rich",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39133401": {
    "id": "item_24930",
    "Last Name": "Unterrheiner",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39133756": {
    "id": "item_35815",
    "Last Name": "HOSONO",
    "First Name": "TAKAO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39135429": {
    "id": "item_35816",
    "Last Name": "Takahashi Abe",
    "First Name": "Esther Hissae",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39135590": {
    "id": "item_35817",
    "Last Name": "Jaramillo-Saa",
    "First Name": "Karina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39136528": {
    "id": "item_24931",
    "Last Name": "Saxon",
    "First Name": "Meg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39148737": {
    "id": "item_35818",
    "Last Name": "Loft",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39153772": {
    "id": "item_23509",
    "Last Name": "da Silva Godinho",
    "First Name": "Evandro Roberto",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39173093": {
    "id": "item_35819",
    "Last Name": "Hardy",
    "First Name": "Lina Arto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39252098": {
    "id": "item_12394",
    "Last Name": "Torrisi",
    "First Name": "Carl",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39259647": {
    "id": "item_35820",
    "Last Name": "Reece",
    "First Name": "Lindsey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39265363": {
    "id": "item_12395",
    "Last Name": "Power",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39300687": {
    "id": "item_24932",
    "Last Name": "New",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39398937": {
    "id": "item_12396",
    "Last Name": "Madigan",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39399129": {
    "id": "item_24933",
    "Last Name": "Pinto",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39405900": {
    "id": "item_12397",
    "Last Name": "Bittar",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39408961": {
    "id": "item_12398",
    "Last Name": "Neel",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39482929": {
    "id": "item_35821",
    "Last Name": "Hansen",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39482997": {
    "id": "item_24934",
    "Last Name": "Sweeney",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39483062": {
    "id": "item_10583",
    "Last Name": "XU",
    "First Name": "HUI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39483124": {
    "id": "item_24935",
    "Last Name": "Thomson",
    "First Name": "Damien",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39483212": {
    "id": "item_35822",
    "Last Name": "Miller",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39483496": {
    "id": "item_12399",
    "Last Name": "Vorias",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39483755": {
    "id": "item_24936",
    "Last Name": "Huynh",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39520390": {
    "id": "item_12400",
    "Last Name": "Shear",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39566737": {
    "id": "item_35823",
    "Last Name": "Isaacson",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39636102": {
    "id": "item_35824",
    "Last Name": "Leva Pelaez",
    "First Name": "Daniela Alejandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39665719": {
    "id": "item_35825",
    "Last Name": "Lloyd",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39667912": {
    "id": "item_24937",
    "Last Name": "Choudhury",
    "First Name": "Misbah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39668014": {
    "id": "item_24938",
    "Last Name": "Laturia",
    "First Name": "Shreeraj",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39682230": {
    "id": "item_24939",
    "Last Name": "Berry",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39688034": {
    "id": "item_12401",
    "Last Name": "Panta",
    "First Name": "Narayan Babu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39688898": {
    "id": "item_10584",
    "Last Name": "Rai",
    "First Name": "Biru",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39688956": {
    "id": "item_10585",
    "Last Name": "Kunwor",
    "First Name": "Padam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39690003": {
    "id": "item_24940",
    "Last Name": "Aryal",
    "First Name": "Kishor Raj",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39690053": {
    "id": "item_38267",
    "Last Name": "Dahal",
    "First Name": "Atmaram",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39693794": {
    "id": "item_24941",
    "Last Name": "Pandey",
    "First Name": "Dinesh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39705737": {
    "id": "item_35826",
    "Last Name": "Grigg",
    "First Name": "Brad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39707927": {
    "id": "item_10586",
    "Last Name": "Graeve",
    "First Name": "Kerran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39719733": {
    "id": "item_35827",
    "Last Name": "ABUKARAM",
    "First Name": "ZIAD",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39721334": {
    "id": "item_23510",
    "Last Name": "Khan",
    "First Name": "Zawar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39729739": {
    "id": "item_12402",
    "Last Name": "Lambat",
    "First Name": "Ebrahim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39744246": {
    "id": "item_24942",
    "Last Name": "Sood",
    "First Name": "Alfona",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39750833": {
    "id": "item_24943",
    "Last Name": "Afzal",
    "First Name": "Abu-Bakr Mohammad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39786399": {
    "id": "item_10587",
    "Last Name": "Moran",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39788086": {
    "id": "item_12403",
    "Last Name": "Mota",
    "First Name": "Haroon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39795935": {
    "id": "item_24944",
    "Last Name": "Khan",
    "First Name": "Asjad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39892805": {
    "id": "item_12404",
    "Last Name": "Al-Hussain",
    "First Name": "Khadija",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39918366": {
    "id": "item_35828",
    "Last Name": "Fehily",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39919608": {
    "id": "item_35829",
    "Last Name": "McNamara",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "39973106": {
    "id": "item_10588",
    "Last Name": "de la Cruz",
    "First Name": "Rio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40001493": {
    "id": "item_35830",
    "Last Name": "Egerton-Warburton",
    "First Name": "Jude",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40005416": {
    "id": "item_35831",
    "Last Name": "Chesson",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40011333": {
    "id": "item_35832",
    "Last Name": "Kilic",
    "First Name": "Samet",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40062918": {
    "id": "item_24945",
    "Last Name": "Algie",
    "First Name": "Nic",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40075019": {
    "id": "item_24946",
    "Last Name": "Bernal",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40110212": {
    "id": "item_35833",
    "Last Name": "Chamtie",
    "First Name": "Hayat",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40116766": {
    "id": "item_24947",
    "Last Name": "Kaiser",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40121200": {
    "id": "item_12405",
    "Last Name": "Kavanagh",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40123178": {
    "id": "item_12406",
    "Last Name": "Leah",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40126723": {
    "id": "item_24948",
    "Last Name": "Sherwood",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40146946": {
    "id": "item_24949",
    "Last Name": "Javam",
    "First Name": "Ali",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40147559": {
    "id": "item_24950",
    "Last Name": "Lanham",
    "First Name": "Eve",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40177869": {
    "id": "item_35834",
    "Last Name": "Boyd",
    "First Name": "Fran",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40199440": {
    "id": "item_12407",
    "Last Name": "Gilchrist",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40209681": {
    "id": "item_12408",
    "Last Name": "Robinson",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40427387": {
    "id": "item_12409",
    "Last Name": "Govender",
    "First Name": "Willy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40496024": {
    "id": "item_24951",
    "Last Name": "Duffy",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40528495": {
    "id": "item_24952",
    "Last Name": "Schaaf",
    "First Name": "Molly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40542963": {
    "id": "item_35835",
    "Last Name": "FREEMAN",
    "First Name": "NICOLE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40648074": {
    "id": "item_12410",
    "Last Name": "Caristo",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40649277": {
    "id": "item_35836",
    "Last Name": "Carter",
    "First Name": "Jill",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40649567": {
    "id": "item_35837",
    "Last Name": "Carter",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40686220": {
    "id": "item_12411",
    "Last Name": "Winney",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40724460": {
    "id": "item_35838",
    "Last Name": "Dowd",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40726338": {
    "id": "item_35839",
    "Last Name": "Scenna",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40820435": {
    "id": "item_23511",
    "Last Name": "Huerta Peregrina",
    "First Name": "Renata",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40869383": {
    "id": "item_35840",
    "Last Name": "Norris",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40909514": {
    "id": "item_35841",
    "Last Name": "Pulley",
    "First Name": "Rafe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40909839": {
    "id": "item_10589",
    "Last Name": "Atici",
    "First Name": "Mustafa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40910643": {
    "id": "item_10590",
    "Last Name": "Hirczy",
    "First Name": "Andreas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40913006": {
    "id": "item_35842",
    "Last Name": "egilmezer",
    "First Name": "Ece",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40913504": {
    "id": "item_10591",
    "Last Name": "Whelehan",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40915450": {
    "id": "item_10592",
    "Last Name": "McMullan",
    "First Name": "Talen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40923292": {
    "id": "item_10593",
    "Last Name": "Cianca",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40923540": {
    "id": "item_35843",
    "Last Name": "Daniels",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40923888": {
    "id": "item_10594",
    "Last Name": "Spooner",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40924829": {
    "id": "item_35844",
    "Last Name": "Ehrlich",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40947742": {
    "id": "item_35845",
    "Last Name": "Neto",
    "First Name": "Pedro",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40951200": {
    "id": "item_12412",
    "Last Name": "Kaczmarek",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40951867": {
    "id": "item_35846",
    "Last Name": "McMillan",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40951967": {
    "id": "item_24953",
    "Last Name": "Simpson",
    "First Name": "Philip",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40953933": {
    "id": "item_10595",
    "Last Name": "gao",
    "First Name": "jie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40954753": {
    "id": "item_10596",
    "Last Name": "li",
    "First Name": "hui",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40955758": {
    "id": "item_12413",
    "Last Name": "Schierbeek",
    "First Name": "Catijn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40956238": {
    "id": "item_12414",
    "Last Name": "Smith",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40956358": {
    "id": "item_12415",
    "Last Name": "Zhou",
    "First Name": "Qinnian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40956891": {
    "id": "item_12416",
    "Last Name": "Kirwan",
    "First Name": "Ruairi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40957702": {
    "id": "item_10597",
    "Last Name": "ZHOU",
    "First Name": "QIONG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40957874": {
    "id": "item_24954",
    "Last Name": "Ryan",
    "First Name": "Lorna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40961010": {
    "id": "item_23512",
    "Last Name": "Cooper",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40986527": {
    "id": "item_24955",
    "Last Name": "Travis",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "40986852": {
    "id": "item_24956",
    "Last Name": "Rao",
    "First Name": "Satya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41000397": {
    "id": "item_24957",
    "Last Name": "Bertram",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41000784": {
    "id": "item_10598",
    "Last Name": "Tchaplyguine",
    "First Name": "Brice",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41049818": {
    "id": "item_35847",
    "Last Name": "Smith",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41053937": {
    "id": "item_24958",
    "Last Name": "Kopp-Vaughan",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41073003": {
    "id": "item_35848",
    "Last Name": "Daniels",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41092622": {
    "id": "item_10599",
    "Last Name": "Tjarnberg",
    "First Name": "Mikael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41094392": {
    "id": "item_35849",
    "Last Name": "Inglessis",
    "First Name": "Ignacio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41105026": {
    "id": "item_12417",
    "Last Name": "Molino",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41111069": {
    "id": "item_24959",
    "Last Name": "Cahill",
    "First Name": "Orlaith",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41163596": {
    "id": "item_35850",
    "Last Name": "Allert",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41164967": {
    "id": "item_12418",
    "Last Name": "Britton",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41166934": {
    "id": "item_10600",
    "Last Name": "McGovern",
    "First Name": "Brodee",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41172141": {
    "id": "item_35851",
    "Last Name": "Kowalchek",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41174813": {
    "id": "item_12419",
    "Last Name": "Jansen van Rensburg",
    "First Name": "Mauritz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41179756": {
    "id": "item_24960",
    "Last Name": "Lopez",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41205926": {
    "id": "item_24961",
    "Last Name": "Troya",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41206080": {
    "id": "item_10601",
    "Last Name": "Rubio",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41211530": {
    "id": "item_24962",
    "Last Name": "Elliott",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41214622": {
    "id": "item_24963",
    "Last Name": "Hogan",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41215204": {
    "id": "item_12420",
    "Last Name": "Nael",
    "First Name": "Ehrabi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41215754": {
    "id": "item_10602",
    "Last Name": "Konnykh",
    "First Name": "Andrey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41287732": {
    "id": "item_24964",
    "Last Name": "Gonzalez",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41290849": {
    "id": "item_35852",
    "Last Name": "Grove",
    "First Name": "Jerry",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41301375": {
    "id": "item_35853",
    "Last Name": "Iqbal",
    "First Name": "Ahhad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41318847": {
    "id": "item_12421",
    "Last Name": "Cooper Brennan",
    "First Name": "MADELEINE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41319995": {
    "id": "item_10603",
    "Last Name": "Daniel",
    "First Name": "Alice",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41337197": {
    "id": "item_24965",
    "Last Name": "Ronzan",
    "First Name": "Andrae",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41373820": {
    "id": "item_12422",
    "Last Name": "Moustakas",
    "First Name": "Yianni",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41394574": {
    "id": "item_24966",
    "Last Name": "Burdzy",
    "First Name": "Milena",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41415040": {
    "id": "item_24967",
    "Last Name": "Melgarejo",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41416791": {
    "id": "item_24968",
    "Last Name": "Mettam",
    "First Name": "Toby",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41425546": {
    "id": "item_23513",
    "Last Name": "Lecoq",
    "First Name": "Ariane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41474697": {
    "id": "item_10604",
    "Last Name": "Hennessy",
    "First Name": "Darcy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41503590": {
    "id": "item_35854",
    "Last Name": "Richardson",
    "First Name": "Brett",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41504468": {
    "id": "item_12423",
    "Last Name": "Katris",
    "First Name": "Terry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41504986": {
    "id": "item_24969",
    "Last Name": "Schaefer",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41514537": {
    "id": "item_35855",
    "Last Name": "Wong",
    "First Name": "Kenny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41516380": {
    "id": "item_23514",
    "Last Name": "Gaugg",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41583908": {
    "id": "item_35856",
    "Last Name": "Dyson",
    "First Name": "Neil",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41587600": {
    "id": "item_35857",
    "Last Name": "Fagbemiro",
    "First Name": "Oluwabusola",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41613795": {
    "id": "item_24970",
    "Last Name": "Coombes",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41638604": {
    "id": "item_35858",
    "Last Name": "Hrudka",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41642873": {
    "id": "item_10605",
    "Last Name": "EO",
    "First Name": "SUHA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41672526": {
    "id": "item_12424",
    "Last Name": "Grollman",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41680420": {
    "id": "item_12425",
    "Last Name": "brown",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41749356": {
    "id": "item_35859",
    "Last Name": "Allen",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41794558": {
    "id": "item_35860",
    "Last Name": "Porter",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41802744": {
    "id": "item_35861",
    "Last Name": "Hart",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41842414": {
    "id": "item_24971",
    "Last Name": "Smart",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41880140": {
    "id": "item_35862",
    "Last Name": "Bennett",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41894809": {
    "id": "item_10606",
    "Last Name": "COSTA",
    "First Name": "SERGIO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41916736": {
    "id": "item_35863",
    "Last Name": "Manning",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41922761": {
    "id": "item_24972",
    "Last Name": "Taylor",
    "First Name": "Max",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41971879": {
    "id": "item_12426",
    "Last Name": "Mutti",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41972935": {
    "id": "item_24973",
    "Last Name": "Murray",
    "First Name": "Gary",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41973986": {
    "id": "item_10607",
    "Last Name": "Prayogo",
    "First Name": "Agus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41974899": {
    "id": "item_10608",
    "Last Name": "Heneghan",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41975262": {
    "id": "item_10609",
    "Last Name": "Thornton",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41982334": {
    "id": "item_12427",
    "Last Name": "MacPhail",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41983847": {
    "id": "item_12428",
    "Last Name": "Wollman",
    "First Name": "Ross",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "41996565": {
    "id": "item_23515",
    "Last Name": "Mota",
    "First Name": "Mario",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42017128": {
    "id": "item_35864",
    "Last Name": "Rubin",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42030928": {
    "id": "item_10610",
    "Last Name": "Maaliki",
    "First Name": "Walid",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42031258": {
    "id": "item_12429",
    "Last Name": "Remmani",
    "First Name": "Mohamed Bilal",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42044193": {
    "id": "item_12430",
    "Last Name": "GU",
    "First Name": "YIWEN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42044329": {
    "id": "item_12431",
    "Last Name": "ding",
    "First Name": "zuyu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42050252": {
    "id": "item_10611",
    "Last Name": "Xin",
    "First Name": "Yan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42051024": {
    "id": "item_10612",
    "Last Name": "Bouzoumita",
    "First Name": "Ilyes",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42054045": {
    "id": "item_10613",
    "Last Name": "Liu",
    "First Name": "Ran",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42055537": {
    "id": "item_35865",
    "Last Name": "Chepiha",
    "First Name": "Yuliia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42072885": {
    "id": "item_35866",
    "Last Name": "O'Donnell",
    "First Name": "Sue",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42074790": {
    "id": "item_24974",
    "Last Name": "ELAKIL",
    "First Name": "Yacine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42079527": {
    "id": "item_12432",
    "Last Name": "James",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42079714": {
    "id": "item_12433",
    "Last Name": "Sarfare",
    "First Name": "Manish",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42084079": {
    "id": "item_12434",
    "Last Name": "Sim",
    "First Name": "Moonshine",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42084335": {
    "id": "item_10614",
    "Last Name": "Stoff",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42085042": {
    "id": "item_12435",
    "Last Name": "Constantinou",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42086040": {
    "id": "item_24975",
    "Last Name": "Nott",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42087370": {
    "id": "item_23516",
    "Last Name": "McCully",
    "First Name": "Jacenta",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42101859": {
    "id": "item_10615",
    "Last Name": "De Noune",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42113103": {
    "id": "item_10616",
    "Last Name": "Goesmann",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42117845": {
    "id": "item_12436",
    "Last Name": "Newbury",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42128652": {
    "id": "item_10617",
    "Last Name": "Moyle",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42136622": {
    "id": "item_10618",
    "Last Name": "Mcnab",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42137677": {
    "id": "item_10619",
    "Last Name": "Heyden",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42138202": {
    "id": "item_10620",
    "Last Name": "Harris",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42139499": {
    "id": "item_24976",
    "Last Name": "Roberts",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42139768": {
    "id": "item_35867",
    "Last Name": "Heintze",
    "First Name": "Ava",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42141957": {
    "id": "item_12437",
    "Last Name": "Kerry",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42159617": {
    "id": "item_35868",
    "Last Name": "Versluys",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42161644": {
    "id": "item_12438",
    "Last Name": "Blacket",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181501": {
    "id": "item_12439",
    "Last Name": "Farrah-Seaton",
    "First Name": "Montana",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181516": {
    "id": "item_12440",
    "Last Name": "Young",
    "First Name": "Jotham",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181526": {
    "id": "item_10621",
    "Last Name": "Poulin",
    "First Name": "Charles-Emile",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42181545": {
    "id": "item_12441",
    "Last Name": "Clarke",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42205274": {
    "id": "item_24977",
    "Last Name": "Priest",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42211025": {
    "id": "item_10622",
    "Last Name": "Cargill",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42259903": {
    "id": "item_12442",
    "Last Name": "Mullins",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42261114": {
    "id": "item_24978",
    "Last Name": "Young",
    "First Name": "Esther",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42265214": {
    "id": "item_12443",
    "Last Name": "Chen",
    "First Name": "Yen-tin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42266533": {
    "id": "item_12444",
    "Last Name": "HUANG",
    "First Name": "YUCHI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42284074": {
    "id": "item_12445",
    "Last Name": "Pham",
    "First Name": "Kiarne",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42285557": {
    "id": "item_24979",
    "Last Name": "Izzo",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42286545": {
    "id": "item_10623",
    "Last Name": "Marchon",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42286722": {
    "id": "item_24980",
    "Last Name": "Creagh",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42288098": {
    "id": "item_10624",
    "Last Name": "Marcus Hogue",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42289226": {
    "id": "item_12446",
    "Last Name": "Kemshell",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42305465": {
    "id": "item_10625",
    "Last Name": "Byrne",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42309908": {
    "id": "item_23517",
    "Last Name": "Sik",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42309925": {
    "id": "item_35869",
    "Last Name": "Rigney",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42313024": {
    "id": "item_24981",
    "Last Name": "Berry",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42319092": {
    "id": "item_24982",
    "Last Name": "Pierobon",
    "First Name": "Carlo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42319911": {
    "id": "item_12447",
    "Last Name": "Cheung",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42335314": {
    "id": "item_10626",
    "Last Name": "Aldas",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42343219": {
    "id": "item_24983",
    "Last Name": "Spaan",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42347018": {
    "id": "item_10627",
    "Last Name": "Li",
    "First Name": "Yuanmou",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42352020": {
    "id": "item_10628",
    "Last Name": "Cocchiararo",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42353383": {
    "id": "item_10629",
    "Last Name": "Kratzer",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42365279": {
    "id": "item_12448",
    "Last Name": "Block",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42378303": {
    "id": "item_10630",
    "Last Name": "O'Donnell",
    "First Name": "Lydia",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42391731": {
    "id": "item_35870",
    "Last Name": "Crabtree",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42394535": {
    "id": "item_24984",
    "Last Name": "Trinh",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42398567": {
    "id": "item_12449",
    "Last Name": "Martin",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42400569": {
    "id": "item_24985",
    "Last Name": "Jones",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42403348": {
    "id": "item_35871",
    "Last Name": "Verbeke",
    "First Name": "Judy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42403756": {
    "id": "item_10631",
    "Last Name": "Bartolotto Sr.",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42404570": {
    "id": "item_24986",
    "Last Name": "Karki",
    "First Name": "Deepak",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42415859": {
    "id": "item_12450",
    "Last Name": "SANTA ANA",
    "First Name": "DANIEL",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42420638": {
    "id": "item_24987",
    "Last Name": "Medina",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42427360": {
    "id": "item_12451",
    "Last Name": "Yoo",
    "First Name": "Seungwoo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42433721": {
    "id": "item_24988",
    "Last Name": "Chen",
    "First Name": "Hsu Min",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42433860": {
    "id": "item_24989",
    "Last Name": "Kong",
    "First Name": "Wan Sing",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42434314": {
    "id": "item_24990",
    "Last Name": "YANG",
    "First Name": "ZHIRONG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42435251": {
    "id": "item_10632",
    "Last Name": "Leiva Martinez",
    "First Name": "Juan Pablo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42435502": {
    "id": "item_10633",
    "Last Name": "Del Valle Stevens",
    "First Name": "Maricarmen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42437429": {
    "id": "item_12452",
    "Last Name": "Targett",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42437502": {
    "id": "item_24991",
    "Last Name": "Jones",
    "First Name": "Rich",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42438374": {
    "id": "item_24993",
    "Last Name": "Banga",
    "First Name": "Gagan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42438423": {
    "id": "item_24992",
    "Last Name": "Mc Quaide",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42438809": {
    "id": "item_10634",
    "Last Name": "Acevedo",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439132": {
    "id": "item_12453",
    "Last Name": "Quinn",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439516": {
    "id": "item_10635",
    "Last Name": "Li",
    "First Name": "Weina",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439558": {
    "id": "item_10636",
    "Last Name": "Holmberg",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42439643": {
    "id": "item_35872",
    "Last Name": "Sia",
    "First Name": "Kar Soon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42440246": {
    "id": "item_35873",
    "Last Name": "Carlson",
    "First Name": "Ebony",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42440566": {
    "id": "item_35874",
    "Last Name": "Christanto",
    "First Name": "Hadiwinarto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42440753": {
    "id": "item_24994",
    "Last Name": "Bernad",
    "First Name": "Jerry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42441269": {
    "id": "item_24995",
    "Last Name": "Sekar",
    "First Name": "Lavanya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42441927": {
    "id": "item_35875",
    "Last Name": "Ayuni",
    "First Name": "Dwi putri",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42442055": {
    "id": "item_35876",
    "Last Name": "Prasetyo",
    "First Name": "Deasy Srishantika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42442660": {
    "id": "item_35877",
    "Last Name": "Lai",
    "First Name": "Roselyn Pek Har",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42443014": {
    "id": "item_35878",
    "Last Name": "Tan",
    "First Name": "Puay leng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42447531": {
    "id": "item_24996",
    "Last Name": "Sukawati",
    "First Name": "Tjokorda Gde Dharma Putra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42448634": {
    "id": "item_35879",
    "Last Name": "Sirisantana",
    "First Name": "Natchanit",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42449151": {
    "id": "item_10637",
    "Last Name": "Cherem Mizrahi",
    "First Name": "Allan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42451642": {
    "id": "item_10638",
    "Last Name": "Rozada Perez de Salazar",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42453428": {
    "id": "item_10639",
    "Last Name": "Sastoque",
    "First Name": "FELIX",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42453564": {
    "id": "item_12454",
    "Last Name": "Hurtado",
    "First Name": "Marco",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42460427": {
    "id": "item_24997",
    "Last Name": "Mej’a Madrid",
    "First Name": "Miguel çngel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42461075": {
    "id": "item_24998",
    "Last Name": "MŽrida",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42462501": {
    "id": "item_10640",
    "Last Name": "Luan",
    "First Name": "Yushuai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42463204": {
    "id": "item_12455",
    "Last Name": "Shen",
    "First Name": "Changchun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42466076": {
    "id": "item_35880",
    "Last Name": "Lim",
    "First Name": "Swee Peng",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42482700": {
    "id": "item_24999",
    "Last Name": "Williamson",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42486119": {
    "id": "item_35881",
    "Last Name": "Chaisuparakul",
    "First Name": "Atichat",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42486164": {
    "id": "item_12456",
    "Last Name": "Haryadi",
    "First Name": "Yusa Pridasa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42486660": {
    "id": "item_12457",
    "Last Name": "LU",
    "First Name": "DONGMEI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42487043": {
    "id": "item_25000",
    "Last Name": "Zhang",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42487696": {
    "id": "item_35882",
    "Last Name": "Fong",
    "First Name": "Jany Chui Nee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42489520": {
    "id": "item_35883",
    "Last Name": "Ahmed",
    "First Name": "Adeel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42490143": {
    "id": "item_10641",
    "Last Name": "Lim",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42493576": {
    "id": "item_25001",
    "Last Name": "Morataya",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42493643": {
    "id": "item_25002",
    "Last Name": "Galvez",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42495556": {
    "id": "item_12458",
    "Last Name": "Soprano",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42498678": {
    "id": "item_35884",
    "Last Name": "Suryawan",
    "First Name": "I Gusti Agung Agus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42499552": {
    "id": "item_12459",
    "Last Name": "Amado",
    "First Name": "Anahi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42501975": {
    "id": "item_35885",
    "Last Name": "AVILA",
    "First Name": "FRANCISCO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42506155": {
    "id": "item_12460",
    "Last Name": "Riedel",
    "First Name": "Jannis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42512521": {
    "id": "item_35886",
    "Last Name": "Bota",
    "First Name": "Duda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42517276": {
    "id": "item_10642",
    "Last Name": "Anuntarumporn",
    "First Name": "Nuttanai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518002": {
    "id": "item_25003",
    "Last Name": "Suter",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518618": {
    "id": "item_35888",
    "Last Name": "Sosrohamidjojo",
    "First Name": "Heru Prakoso",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518646": {
    "id": "item_35887",
    "Last Name": "Manurung",
    "First Name": "Darwin Fernandes",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42518888": {
    "id": "item_25004",
    "Last Name": "Utomo",
    "First Name": "Mufti",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42519199": {
    "id": "item_12461",
    "Last Name": "Vanpoeyer",
    "First Name": "Jochen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42519628": {
    "id": "item_25005",
    "Last Name": "Tengku Alaudin",
    "First Name": "Tengku Iestarabie Putra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42520018": {
    "id": "item_12462",
    "Last Name": "Apriel",
    "First Name": "Imanuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42522283": {
    "id": "item_35889",
    "Last Name": "Adikta",
    "First Name": "Zaky",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42522690": {
    "id": "item_10643",
    "Last Name": "Yanagisawa",
    "First Name": "Kanta",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42524149": {
    "id": "item_35890",
    "Last Name": "Torrendell",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42524159": {
    "id": "item_10644",
    "Last Name": "OWADA",
    "First Name": "TAKUJI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42525358": {
    "id": "item_10645",
    "Last Name": "WANG",
    "First Name": "BING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42525943": {
    "id": "item_12463",
    "Last Name": "YOSHIDA",
    "First Name": "YOSHIHIRO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42527013": {
    "id": "item_25006",
    "Last Name": "SABANDAR",
    "First Name": "ALFONS OCTAVIAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42528270": {
    "id": "item_35891",
    "Last Name": "leowardi",
    "First Name": "agostina Yuti",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42535554": {
    "id": "item_12464",
    "Last Name": "Hannard",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42536982": {
    "id": "item_25007",
    "Last Name": "Zapletal",
    "First Name": "Jutta",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42537356": {
    "id": "item_10646",
    "Last Name": "Moriarty",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42538162": {
    "id": "item_12465",
    "Last Name": "Bell",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42538996": {
    "id": "item_25008",
    "Last Name": "Anguita",
    "First Name": "Eliana Dafne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42539652": {
    "id": "item_35892",
    "Last Name": "Herlin",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42541534": {
    "id": "item_25009",
    "Last Name": "BLANCO BUENAFE",
    "First Name": "ISMAEL DAVID",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42542289": {
    "id": "item_35893",
    "Last Name": "Smith",
    "First Name": "Marty",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42542439": {
    "id": "item_10647",
    "Last Name": "WATANABE",
    "First Name": "YUTA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42543300": {
    "id": "item_25010",
    "Last Name": "Gagnon",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42546895": {
    "id": "item_12466",
    "Last Name": "Weissberg",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42548230": {
    "id": "item_25011",
    "Last Name": "Pollack",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42548594": {
    "id": "item_35894",
    "Last Name": "Yeo",
    "First Name": "Darren Wee Chin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42548654": {
    "id": "item_12467",
    "Last Name": "Hicks",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42550553": {
    "id": "item_12468",
    "Last Name": "Sakolvipas",
    "First Name": "Samart",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552096": {
    "id": "item_12469",
    "Last Name": "Antonissen",
    "First Name": "Dimitri",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552228": {
    "id": "item_12470",
    "Last Name": "Huynh",
    "First Name": "Terry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552266": {
    "id": "item_25012",
    "Last Name": "Schoenegger",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552663": {
    "id": "item_25013",
    "Last Name": "Davis",
    "First Name": "Mayumi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42552841": {
    "id": "item_35895",
    "Last Name": "Luk",
    "First Name": "Lai Yung Martina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553133": {
    "id": "item_10648",
    "Last Name": "LI",
    "First Name": "RUI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553167": {
    "id": "item_35896",
    "Last Name": "CHAN",
    "First Name": "TSZ KIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553404": {
    "id": "item_25014",
    "Last Name": "Ho",
    "First Name": "Kwok Wai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553501": {
    "id": "item_35897",
    "Last Name": "Zhao",
    "First Name": "Yang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553551": {
    "id": "item_25015",
    "Last Name": "ZHANG",
    "First Name": "YI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553689": {
    "id": "item_12471",
    "Last Name": "Xu",
    "First Name": "Hua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553722": {
    "id": "item_12473",
    "Last Name": "Hsu",
    "First Name": "Hao Hsiang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553790": {
    "id": "item_12472",
    "Last Name": "LIN",
    "First Name": "CHIEN CHIH",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553794": {
    "id": "item_10649",
    "Last Name": "Han",
    "First Name": "Kankan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553918": {
    "id": "item_25016",
    "Last Name": "Brearley",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553946": {
    "id": "item_10650",
    "Last Name": "Law",
    "First Name": "Wai Yip",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42553965": {
    "id": "item_25017",
    "Last Name": "Urquhart",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554427": {
    "id": "item_12474",
    "Last Name": "Gallagher",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554540": {
    "id": "item_25018",
    "Last Name": "Tripathi",
    "First Name": "Upendra Narayan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554661": {
    "id": "item_23518",
    "Last Name": "Bhagavan",
    "First Name": "Gautham",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554704": {
    "id": "item_23519",
    "Last Name": "Cassidy",
    "First Name": "Glyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554754": {
    "id": "item_25019",
    "Last Name": "PIMSAREE",
    "First Name": "THUNYANEE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42554974": {
    "id": "item_35898",
    "Last Name": "GUNAPATI",
    "First Name": "VENKATA SANJAY REDDY",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42555133": {
    "id": "item_23520",
    "Last Name": "Steinmetz",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42562769": {
    "id": "item_12475",
    "Last Name": "Nawroth",
    "First Name": "Sonja",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42563321": {
    "id": "item_25020",
    "Last Name": "Cimenti Neto",
    "First Name": "Alberto",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42565138": {
    "id": "item_25021",
    "Last Name": "Horth",
    "First Name": "Carl",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572121": {
    "id": "item_35899",
    "Last Name": "Passos",
    "First Name": "Marco Antonio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572314": {
    "id": "item_25022",
    "Last Name": "SAITO",
    "First Name": "CHIKASHI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42572382": {
    "id": "item_25023",
    "Last Name": "Bair",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42573731": {
    "id": "item_25024",
    "Last Name": "TAKIDA",
    "First Name": "MIWANO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42574949": {
    "id": "item_35900",
    "Last Name": "Jaiswal",
    "First Name": "Saraswati",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42578730": {
    "id": "item_25025",
    "Last Name": "Omote",
    "First Name": "Hiroko",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42582674": {
    "id": "item_25026",
    "Last Name": "de Albino",
    "First Name": "Mariana cristina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42587951": {
    "id": "item_35901",
    "Last Name": "wu",
    "First Name": "xiaoyuan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42588086": {
    "id": "item_25027",
    "Last Name": "Keng",
    "First Name": "Tee Keong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42590827": {
    "id": "item_25028",
    "Last Name": "Vasquez Del Carpio",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42594507": {
    "id": "item_35902",
    "Last Name": "Reyes",
    "First Name": "Luciano",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42594642": {
    "id": "item_25029",
    "Last Name": "Machida",
    "First Name": "Wataru",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42594738": {
    "id": "item_10651",
    "Last Name": "Peng",
    "First Name": "Cheng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42595599": {
    "id": "item_23521",
    "Last Name": "Hung",
    "First Name": "Chui Yee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42595625": {
    "id": "item_23522",
    "Last Name": "Aguirre",
    "First Name": "Ligia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42596735": {
    "id": "item_25030",
    "Last Name": "Toiviainen",
    "First Name": "Antti",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42597030": {
    "id": "item_10652",
    "Last Name": "Becerra Torres",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42597473": {
    "id": "item_12476",
    "Last Name": "SIERRA",
    "First Name": "BORJA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42598120": {
    "id": "item_23523",
    "Last Name": "Patton",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42598768": {
    "id": "item_25031",
    "Last Name": "PRESOTTO GOMES",
    "First Name": "DANIEL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42598925": {
    "id": "item_23524",
    "Last Name": "PUENTE VEGA",
    "First Name": "JUAN JOSE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42599804": {
    "id": "item_25032",
    "Last Name": "MEDINA MONINO",
    "First Name": "ESTHER",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42599807": {
    "id": "item_12477",
    "Last Name": "Kl‡sek",
    "First Name": "Jan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42602663": {
    "id": "item_23525",
    "Last Name": "Lograno",
    "First Name": "Giuseppe Maria Antonio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42602690": {
    "id": "item_25033",
    "Last Name": "Madjid",
    "First Name": "Ade Mutiara",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42605256": {
    "id": "item_10653",
    "Last Name": "Qian",
    "First Name": "Xinping",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42606753": {
    "id": "item_12478",
    "Last Name": "Cassells",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42607656": {
    "id": "item_25034",
    "Last Name": "Pinol",
    "First Name": "Denise Yurie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42609926": {
    "id": "item_12479",
    "Last Name": "Oliveira",
    "First Name": "Werika",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42612387": {
    "id": "item_35903",
    "Last Name": "YIP",
    "First Name": "TIMOTHY SIN YEUNG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42613519": {
    "id": "item_35904",
    "Last Name": "Russell",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42613875": {
    "id": "item_25035",
    "Last Name": "Moreton",
    "First Name": "Koorinya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42614433": {
    "id": "item_12480",
    "Last Name": "Ngai",
    "First Name": "Tak Cheung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42615160": {
    "id": "item_25036",
    "Last Name": "FAN",
    "First Name": "AIDAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42615161": {
    "id": "item_25037",
    "Last Name": "TAKAGI",
    "First Name": "AKIKO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42615215": {
    "id": "item_25038",
    "Last Name": "Laopraneechon",
    "First Name": "Piriya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42615281": {
    "id": "item_12481",
    "Last Name": "Herrera Vega",
    "First Name": "Salvador",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42615497": {
    "id": "item_10654",
    "Last Name": "CHEN",
    "First Name": "PIN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42616017": {
    "id": "item_12482",
    "Last Name": "Macklin",
    "First Name": "Billy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42616423": {
    "id": "item_10655",
    "Last Name": "INOUE",
    "First Name": "KEISUKE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42616693": {
    "id": "item_12483",
    "Last Name": "almu arrif",
    "First Name": "Rachmat",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42617118": {
    "id": "item_25039",
    "Last Name": "WATTHANASIRIPHUWADECH",
    "First Name": "NATTHAPHATR",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42617201": {
    "id": "item_10656",
    "Last Name": "Nakpradit",
    "First Name": "Eakachai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42617363": {
    "id": "item_35905",
    "Last Name": "Takamizawa",
    "First Name": "Akihiro",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42617478": {
    "id": "item_25040",
    "Last Name": "CHEN",
    "First Name": "WEIJIAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42617565": {
    "id": "item_35906",
    "Last Name": "SWADSRI",
    "First Name": "KEVIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42617593": {
    "id": "item_10657",
    "Last Name": "CHEN",
    "First Name": "CHUNMING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618365": {
    "id": "item_12484",
    "Last Name": "RAWEKCHOM",
    "First Name": "CHAIYOT",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42618629": {
    "id": "item_35907",
    "Last Name": "Rouvray",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42621049": {
    "id": "item_23526",
    "Last Name": "Kapadia",
    "First Name": "Kiran",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42621289": {
    "id": "item_35908",
    "Last Name": "Goriparthy",
    "First Name": "Suresh Kumar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42623190": {
    "id": "item_25041",
    "Last Name": "Ramdhan",
    "First Name": "Asep",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42625733": {
    "id": "item_23527",
    "Last Name": "Gracia",
    "First Name": "Gede Abi Govinda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42627599": {
    "id": "item_35909",
    "Last Name": "Modi",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631372": {
    "id": "item_10658",
    "Last Name": "Tjahyadikarta",
    "First Name": "Donny",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631439": {
    "id": "item_35910",
    "Last Name": "ZHAO",
    "First Name": "QIBO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631553": {
    "id": "item_35911",
    "Last Name": "LIU",
    "First Name": "XUANYUN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631567": {
    "id": "item_25042",
    "Last Name": "PAN",
    "First Name": "YOFANG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631679": {
    "id": "item_25043",
    "Last Name": "zhao",
    "First Name": "shan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631683": {
    "id": "item_10659",
    "Last Name": "Aleida",
    "First Name": "Salem",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631711": {
    "id": "item_23528",
    "Last Name": "LIAO",
    "First Name": "CHIEN-MING",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631752": {
    "id": "item_35912",
    "Last Name": "REN",
    "First Name": "SHAOFENG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631864": {
    "id": "item_23529",
    "Last Name": "KUNCORO",
    "First Name": "DIDIT WAHYU",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631975": {
    "id": "item_10660",
    "Last Name": "yan",
    "First Name": "shaoyong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42631997": {
    "id": "item_23530",
    "Last Name": "Karnani",
    "First Name": "Ashish",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42632040": {
    "id": "item_23531",
    "Last Name": "Maia",
    "First Name": "Gustavo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42632086": {
    "id": "item_23532",
    "Last Name": "Burmeister",
    "First Name": "Mathias",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42632147": {
    "id": "item_25044",
    "Last Name": "HUANG",
    "First Name": "CHAN TAI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42632297": {
    "id": "item_23533",
    "Last Name": "Janssen",
    "First Name": "Hendrik",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42632339": {
    "id": "item_10661",
    "Last Name": "Dai",
    "First Name": "Chaoguang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42636834": {
    "id": "item_35913",
    "Last Name": "Jain",
    "First Name": "Kalpesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42638747": {
    "id": "item_25045",
    "Last Name": "CHEN",
    "First Name": "MIN-HUI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645406": {
    "id": "item_35914",
    "Last Name": "JIANG",
    "First Name": "JING",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645452": {
    "id": "item_25046",
    "Last Name": "Kho",
    "First Name": "Teck Ho",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645539": {
    "id": "item_23534",
    "Last Name": "GALLARDO",
    "First Name": "CELINE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645570": {
    "id": "item_10662",
    "Last Name": "Setiabudi",
    "First Name": "Rahmad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645624": {
    "id": "item_10663",
    "Last Name": "KODAMA",
    "First Name": "RYO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645626": {
    "id": "item_25047",
    "Last Name": "Garrett",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645852": {
    "id": "item_25048",
    "Last Name": "Agrawal",
    "First Name": "Alok",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42645916": {
    "id": "item_35915",
    "Last Name": "Nugroho",
    "First Name": "Wimbuh Nawa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646063": {
    "id": "item_23535",
    "Last Name": "MEZHUKANAL",
    "First Name": "MANUVEL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646294": {
    "id": "item_10664",
    "Last Name": "anand",
    "First Name": "Karthik",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646361": {
    "id": "item_12485",
    "Last Name": "Steeves",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646391": {
    "id": "item_10665",
    "Last Name": "Ma",
    "First Name": "Jianqiong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646682": {
    "id": "item_25049",
    "Last Name": "Kumalo",
    "First Name": "Romeo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646727": {
    "id": "item_23536",
    "Last Name": "ZHOU",
    "First Name": "LEFENG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646883": {
    "id": "item_23537",
    "Last Name": "BLAZQUEZ CAPILLA",
    "First Name": "CARLOS ALBERTO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42646909": {
    "id": "item_10666",
    "Last Name": "Marlin",
    "First Name": "Frederic",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42647027": {
    "id": "item_23538",
    "Last Name": "LOO",
    "First Name": "FOOK KEONG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42647110": {
    "id": "item_12486",
    "Last Name": "PARTIDA CASADO",
    "First Name": "DAVID",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42647545": {
    "id": "item_35916",
    "Last Name": "zhang",
    "First Name": "liwei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42648065": {
    "id": "item_12487",
    "Last Name": "Pao",
    "First Name": "Chi Kin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42649110": {
    "id": "item_10667",
    "Last Name": "Pechsricha",
    "First Name": "Patikarn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42649260": {
    "id": "item_25050",
    "Last Name": "LI",
    "First Name": "YIN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42649340": {
    "id": "item_35917",
    "Last Name": "EUGENIO",
    "First Name": "MARCOS",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42650496": {
    "id": "item_12488",
    "Last Name": "Yee",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42651928": {
    "id": "item_10668",
    "Last Name": "Ng",
    "First Name": "Ki Wai, Eric",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42651976": {
    "id": "item_25051",
    "Last Name": "Bishop",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42656820": {
    "id": "item_25052",
    "Last Name": "Tenllado diez",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42657935": {
    "id": "item_35918",
    "Last Name": "Thomas",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42660251": {
    "id": "item_35919",
    "Last Name": "Garcia Hidalgo",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42661239": {
    "id": "item_35920",
    "Last Name": "Arias Garcia",
    "First Name": "Jose Alexandro",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42661317": {
    "id": "item_25053",
    "Last Name": "Delgado",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42661765": {
    "id": "item_23539",
    "Last Name": "DU",
    "First Name": "WENHUI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42663240": {
    "id": "item_10669",
    "Last Name": "Takeuchi",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42663373": {
    "id": "item_23540",
    "Last Name": "Wiederspahn Franke",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42665782": {
    "id": "item_25054",
    "Last Name": "Shinta",
    "First Name": "Shirley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42666670": {
    "id": "item_23541",
    "Last Name": "HE",
    "First Name": "WEI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42667401": {
    "id": "item_12489",
    "Last Name": "Yokoyama",
    "First Name": "Haruna",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42667404": {
    "id": "item_23542",
    "Last Name": "LIU",
    "First Name": "YAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42667602": {
    "id": "item_35921",
    "Last Name": "Smith",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42668033": {
    "id": "item_23543",
    "Last Name": "gudavalli",
    "First Name": "shanthi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42668719": {
    "id": "item_10670",
    "Last Name": "Mone",
    "First Name": "Alexander Cancerio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42668922": {
    "id": "item_25055",
    "Last Name": "Maddren",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42670734": {
    "id": "item_10671",
    "Last Name": "Friend",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42671389": {
    "id": "item_25056",
    "Last Name": "POOMKAEWKRA",
    "First Name": "PIPOAUH",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42672460": {
    "id": "item_12490",
    "Last Name": "Venis",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42672543": {
    "id": "item_35922",
    "Last Name": "Jumico",
    "First Name": "Kenny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42672747": {
    "id": "item_10672",
    "Last Name": "Reed",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42672888": {
    "id": "item_35923",
    "Last Name": "CHONG",
    "First Name": "WEN YAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42672996": {
    "id": "item_12491",
    "Last Name": "Bec",
    "First Name": "Gregor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673113": {
    "id": "item_10673",
    "Last Name": "Vikram",
    "First Name": "B J",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673126": {
    "id": "item_25057",
    "Last Name": "Yong",
    "First Name": "Sock Fong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673256": {
    "id": "item_23544",
    "Last Name": "Atyanto",
    "First Name": "Genio Yudha Wibowo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673604": {
    "id": "item_35924",
    "Last Name": "Noviyanti",
    "First Name": "Herni",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673615": {
    "id": "item_12492",
    "Last Name": "JIN",
    "First Name": "HUI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673766": {
    "id": "item_23545",
    "Last Name": "Liu",
    "First Name": "Dongli",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42673905": {
    "id": "item_23546",
    "Last Name": "WAN",
    "First Name": "MENGYING",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674054": {
    "id": "item_35925",
    "Last Name": "ZHANG",
    "First Name": "JINGWEI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674175": {
    "id": "item_25058",
    "Last Name": "Krishna",
    "First Name": "Sri",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674644": {
    "id": "item_35926",
    "Last Name": "Aryal",
    "First Name": "Sanjeev",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674673": {
    "id": "item_25059",
    "Last Name": "Lee",
    "First Name": "Koon Wong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42674869": {
    "id": "item_12493",
    "Last Name": "ZHAO",
    "First Name": "LEI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675043": {
    "id": "item_25060",
    "Last Name": "Kothai Nayagam",
    "First Name": "Ramji",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675127": {
    "id": "item_25061",
    "Last Name": "Atkins",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675171": {
    "id": "item_23547",
    "Last Name": "Ramupillai",
    "First Name": "Muruganandam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675445": {
    "id": "item_35927",
    "Last Name": "Low",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42675829": {
    "id": "item_23548",
    "Last Name": "GUO",
    "First Name": "DONGMEI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42676325": {
    "id": "item_25062",
    "Last Name": "GAL",
    "First Name": "ZIPORAH",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42676361": {
    "id": "item_35928",
    "Last Name": "Bajaj",
    "First Name": "Aneeta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42676624": {
    "id": "item_25063",
    "Last Name": "HUANG",
    "First Name": "KUAN-WEI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42676666": {
    "id": "item_35929",
    "Last Name": "Singh",
    "First Name": "Hemant",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42676864": {
    "id": "item_35930",
    "Last Name": "Caleon",
    "First Name": "Khristian Norland",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42676943": {
    "id": "item_25064",
    "Last Name": "Patel",
    "First Name": "Pinky",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42677111": {
    "id": "item_25065",
    "Last Name": "Patel",
    "First Name": "Vijay",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42677413": {
    "id": "item_10674",
    "Last Name": "Ortiz",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42677838": {
    "id": "item_10675",
    "Last Name": "Syed ali",
    "First Name": "Seynul Abdeen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42680242": {
    "id": "item_35931",
    "Last Name": "Shivashankar",
    "First Name": "Bhadresh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42680684": {
    "id": "item_25066",
    "Last Name": "Mushi",
    "First Name": "Fredrick Isaac Kamili",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42682112": {
    "id": "item_25067",
    "Last Name": "Vinekar",
    "First Name": "Anand Sudhir",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42682270": {
    "id": "item_35932",
    "Last Name": "Dewi",
    "First Name": "Risliana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42684487": {
    "id": "item_35933",
    "Last Name": "Co",
    "First Name": "John Alexander",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42685172": {
    "id": "item_35934",
    "Last Name": "Canelo Paredes",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42691676": {
    "id": "item_10676",
    "Last Name": "Oliveira",
    "First Name": "Herbert",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42692345": {
    "id": "item_35935",
    "Last Name": "Iannacone",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42692503": {
    "id": "item_35936",
    "Last Name": "DE ARAUJO",
    "First Name": "JOSE ROBERTO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42692793": {
    "id": "item_25068",
    "Last Name": "da Silva Rodrigues",
    "First Name": "Henrique Rangel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42693827": {
    "id": "item_35937",
    "Last Name": "Ardan",
    "First Name": "Andi Mohammad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42693835": {
    "id": "item_35938",
    "Last Name": "Detenbeck",
    "First Name": "Alana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42694050": {
    "id": "item_25069",
    "Last Name": "Francisley Camargo Hoffman",
    "First Name": "Costa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42694633": {
    "id": "item_35939",
    "Last Name": "Van de Velde",
    "First Name": "Charles",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42694809": {
    "id": "item_23549",
    "Last Name": "Hornung",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42695115": {
    "id": "item_25070",
    "Last Name": "Penaco",
    "First Name": "Marilyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42695319": {
    "id": "item_25071",
    "Last Name": "Medina Ramos",
    "First Name": "Jose Ramon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42695368": {
    "id": "item_12494",
    "Last Name": "Maharjan",
    "First Name": "Hari Krishna",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42695401": {
    "id": "item_25072",
    "Last Name": "Erkulvrawatr",
    "First Name": "Edson",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42696533": {
    "id": "item_10677",
    "Last Name": "Tavares",
    "First Name": "Paulo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42697501": {
    "id": "item_35940",
    "Last Name": "Romanovski",
    "First Name": "Irineu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42698130": {
    "id": "item_23550",
    "Last Name": "Geddes",
    "First Name": "Felix",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42698211": {
    "id": "item_23551",
    "Last Name": "Hernandez",
    "First Name": "Jose Andres",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42699184": {
    "id": "item_23552",
    "Last Name": "Lara",
    "First Name": "Yaneth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42699540": {
    "id": "item_25073",
    "Last Name": "Parra Diaz",
    "First Name": "Luis Gabriel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42702136": {
    "id": "item_25074",
    "Last Name": "Ayala",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42702619": {
    "id": "item_12495",
    "Last Name": "Marquez",
    "First Name": "Luis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42703067": {
    "id": "item_25075",
    "Last Name": "Singh",
    "First Name": "Jyotsna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42703567": {
    "id": "item_35941",
    "Last Name": "JENKINS",
    "First Name": "TAMMY",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42704434": {
    "id": "item_10678",
    "Last Name": "OROZCO",
    "First Name": "FROILAN SALVADOR",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42705579": {
    "id": "item_25076",
    "Last Name": "Satija",
    "First Name": "Kalyani",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42705879": {
    "id": "item_12496",
    "Last Name": "Azevedo junior",
    "First Name": "Vagner",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42706421": {
    "id": "item_35942",
    "Last Name": "Tang",
    "First Name": "Engelbert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42706632": {
    "id": "item_35943",
    "Last Name": "Kwan",
    "First Name": "Victor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42707249": {
    "id": "item_25077",
    "Last Name": "Guglielmi",
    "First Name": "Jose",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42707465": {
    "id": "item_25078",
    "Last Name": "Ibarra Rabadan",
    "First Name": "Mario Ruben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42708254": {
    "id": "item_23553",
    "Last Name": "Leung",
    "First Name": "Siu Kee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42708544": {
    "id": "item_23554",
    "Last Name": "Rajaraman",
    "First Name": "Arun",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42708717": {
    "id": "item_35944",
    "Last Name": "ALLENDE",
    "First Name": "Mar’a Lucrecia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42709139": {
    "id": "item_35945",
    "Last Name": "CAMALIG",
    "First Name": "CLIFFORD JAYSON",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42709150": {
    "id": "item_25079",
    "Last Name": "Han",
    "First Name": "Xu Dong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42709154": {
    "id": "item_12497",
    "Last Name": "Carvalho",
    "First Name": "Luis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42709650": {
    "id": "item_35946",
    "Last Name": "Choudhary",
    "First Name": "Anurag",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42709681": {
    "id": "item_10679",
    "Last Name": "WU",
    "First Name": "CHING-TAI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42709731": {
    "id": "item_35947",
    "Last Name": "Nugent",
    "First Name": "Jill",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42709922": {
    "id": "item_10680",
    "Last Name": "Dean",
    "First Name": "Jye",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710239": {
    "id": "item_23555",
    "Last Name": "Wylie",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710505": {
    "id": "item_35948",
    "Last Name": "Kotimukalur Subramania Raja",
    "First Name": "Sivaperumal Sudhakar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710678": {
    "id": "item_25080",
    "Last Name": "Suana",
    "First Name": "Enrique",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710872": {
    "id": "item_10681",
    "Last Name": "Andrew",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42710901": {
    "id": "item_25081",
    "Last Name": "Borges",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42711215": {
    "id": "item_25082",
    "Last Name": "Koh",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42714329": {
    "id": "item_10682",
    "Last Name": "Wan",
    "First Name": "Qian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42714641": {
    "id": "item_23556",
    "Last Name": "Hines",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42715055": {
    "id": "item_23557",
    "Last Name": "Zhang",
    "First Name": "Huirong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42715799": {
    "id": "item_25083",
    "Last Name": "Rampa",
    "First Name": "Raju",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42716074": {
    "id": "item_12498",
    "Last Name": "Zhang",
    "First Name": "Hanyi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42716507": {
    "id": "item_23558",
    "Last Name": "CAO",
    "First Name": "NING",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42716512": {
    "id": "item_12499",
    "Last Name": "Yu",
    "First Name": "Zhen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42716584": {
    "id": "item_25084",
    "Last Name": "Vovk",
    "First Name": "Vincenc",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42716914": {
    "id": "item_23559",
    "Last Name": "Joksimovic",
    "First Name": "Nevena",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42717194": {
    "id": "item_10683",
    "Last Name": "Franco",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42717253": {
    "id": "item_25085",
    "Last Name": "Andersson",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42717367": {
    "id": "item_12500",
    "Last Name": "YANG",
    "First Name": "MINGZHE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42717557": {
    "id": "item_35949",
    "Last Name": "Kraljevic",
    "First Name": "Ivica",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42720550": {
    "id": "item_12501",
    "Last Name": "MOURA",
    "First Name": "EVERSON",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42720613": {
    "id": "item_23560",
    "Last Name": "Mendoza",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42720625": {
    "id": "item_12502",
    "Last Name": "Tillman",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42721220": {
    "id": "item_25086",
    "Last Name": "Nguyen",
    "First Name": "Lena",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42721344": {
    "id": "item_25087",
    "Last Name": "Moreira Oliveira",
    "First Name": "Adelia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42722308": {
    "id": "item_25088",
    "Last Name": "Bussieres",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42722892": {
    "id": "item_23561",
    "Last Name": "Dhesi",
    "First Name": "Surjit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42723293": {
    "id": "item_25089",
    "Last Name": "Salas Salazar",
    "First Name": "Carlos Alberto",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42724778": {
    "id": "item_35950",
    "Last Name": "Lapadula",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42724835": {
    "id": "item_12503",
    "Last Name": "Patel",
    "First Name": "Neal",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42725497": {
    "id": "item_10684",
    "Last Name": "Sasaki",
    "First Name": "Kota",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42728662": {
    "id": "item_35951",
    "Last Name": "Warren",
    "First Name": "Shelley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42729199": {
    "id": "item_10685",
    "Last Name": "PAN",
    "First Name": "YING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42729445": {
    "id": "item_35952",
    "Last Name": "Judge",
    "First Name": "Dermot",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42729447": {
    "id": "item_25090",
    "Last Name": "Godfrey",
    "First Name": "Mike",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42729529": {
    "id": "item_25091",
    "Last Name": "Bennett",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42729992": {
    "id": "item_25092",
    "Last Name": "Rodriguez Higuerey",
    "First Name": "Andres Jose",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42730535": {
    "id": "item_25093",
    "Last Name": "Sultani",
    "First Name": "Zahra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42731529": {
    "id": "item_25094",
    "Last Name": "Hinojosa Sandoval",
    "First Name": "Fabian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42732156": {
    "id": "item_35953",
    "Last Name": "Daniels",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42732389": {
    "id": "item_25095",
    "Last Name": "Dong",
    "First Name": "Jiesi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42733510": {
    "id": "item_35954",
    "Last Name": "Ramos",
    "First Name": "Rosalyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42733696": {
    "id": "item_35955",
    "Last Name": "Lim",
    "First Name": "Chin Ni",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42734932": {
    "id": "item_35956",
    "Last Name": "Chen",
    "First Name": "Tianshui",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42735099": {
    "id": "item_35957",
    "Last Name": "Bacot",
    "First Name": "Roy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42735959": {
    "id": "item_35958",
    "Last Name": "DONG",
    "First Name": "XIAOWAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42736476": {
    "id": "item_12504",
    "Last Name": "ZHANG",
    "First Name": "GUANGYA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42736577": {
    "id": "item_23562",
    "Last Name": "Bridge",
    "First Name": "Vicki",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42736702": {
    "id": "item_10686",
    "Last Name": "GAO",
    "First Name": "CHAO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737167": {
    "id": "item_35959",
    "Last Name": "MUSTIKASARI",
    "First Name": "LACRIMA CRISTI ARIANI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737258": {
    "id": "item_12505",
    "Last Name": "Ngai",
    "First Name": "Cheuk Him William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737348": {
    "id": "item_10687",
    "Last Name": "zhang",
    "First Name": "yuan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737727": {
    "id": "item_25096",
    "Last Name": "Cheng",
    "First Name": "Samson Tsz Kit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42737928": {
    "id": "item_10688",
    "Last Name": "SHAO",
    "First Name": "PENG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42738066": {
    "id": "item_25097",
    "Last Name": "Lee",
    "First Name": "Meng Yeow",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42738085": {
    "id": "item_23563",
    "Last Name": "Dias",
    "First Name": "Vinay",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42738256": {
    "id": "item_35960",
    "Last Name": "Lay Tin",
    "First Name": "Teo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42738333": {
    "id": "item_23564",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42738609": {
    "id": "item_25098",
    "Last Name": "Duggan",
    "First Name": "Share",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42739013": {
    "id": "item_12506",
    "Last Name": "GU",
    "First Name": "QIZHEN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42740045": {
    "id": "item_12507",
    "Last Name": "liang",
    "First Name": "feng",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42742106": {
    "id": "item_25099",
    "Last Name": "Fabris",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42742889": {
    "id": "item_12508",
    "Last Name": "Darovskikh",
    "First Name": "Sergei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42746424": {
    "id": "item_25100",
    "Last Name": "Schumann",
    "First Name": "Joerg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42751136": {
    "id": "item_10689",
    "Last Name": "CHEN",
    "First Name": "PING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42753034": {
    "id": "item_23565",
    "Last Name": "Khangura",
    "First Name": "Karamjit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42757045": {
    "id": "item_10690",
    "Last Name": "Matsubara",
    "First Name": "Manato",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42757444": {
    "id": "item_25101",
    "Last Name": "Ganeriwalla",
    "First Name": "Amit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42757689": {
    "id": "item_23566",
    "Last Name": "MITTAL",
    "First Name": "SHIVANI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758014": {
    "id": "item_12509",
    "Last Name": "ZHONG",
    "First Name": "ZHIPING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758073": {
    "id": "item_35961",
    "Last Name": "Lopez Martin",
    "First Name": "Celestino",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758184": {
    "id": "item_25102",
    "Last Name": "LEE",
    "First Name": "HON WAI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758302": {
    "id": "item_10691",
    "Last Name": "WU",
    "First Name": "CHING-CHENG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42758727": {
    "id": "item_23567",
    "Last Name": "FAN",
    "First Name": "CHIA-FU",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42759109": {
    "id": "item_12510",
    "Last Name": "TSAI",
    "First Name": "KUO-CHUN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42759194": {
    "id": "item_12511",
    "Last Name": "MATSUI",
    "First Name": "TOMOKA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42759199": {
    "id": "item_25103",
    "Last Name": "Chaudhari",
    "First Name": "Nishant",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42759926": {
    "id": "item_35962",
    "Last Name": "YEH",
    "First Name": "CHIA-WEN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42760787": {
    "id": "item_35963",
    "Last Name": "wowor",
    "First Name": "Roland",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42760823": {
    "id": "item_35964",
    "Last Name": "zhao",
    "First Name": "HongLing",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42762800": {
    "id": "item_10692",
    "Last Name": "Velazquez Valentin",
    "First Name": "Josue",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42763257": {
    "id": "item_35965",
    "Last Name": "Roy",
    "First Name": "Latika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42764206": {
    "id": "item_35966",
    "Last Name": "Prieto",
    "First Name": "Cecilia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42764476": {
    "id": "item_10693",
    "Last Name": "Sharipov",
    "First Name": "Dmitrii",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42764501": {
    "id": "item_35967",
    "Last Name": "WONG",
    "First Name": "CHI HO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42765447": {
    "id": "item_25104",
    "Last Name": "SKRINJAR",
    "First Name": "Vladimir",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42765542": {
    "id": "item_10694",
    "Last Name": "Densa",
    "First Name": "Domen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42766332": {
    "id": "item_12512",
    "Last Name": "Reicher",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42766334": {
    "id": "item_25105",
    "Last Name": "Smith",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42767118": {
    "id": "item_10695",
    "Last Name": "Raeymaekers",
    "First Name": "Kirsten",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42767353": {
    "id": "item_23568",
    "Last Name": "BHARATH",
    "First Name": "A L",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42767509": {
    "id": "item_25106",
    "Last Name": "Bolka",
    "First Name": "Anka",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42768082": {
    "id": "item_35968",
    "Last Name": "Lopez Gol",
    "First Name": "Sergi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42770286": {
    "id": "item_23569",
    "Last Name": "Costa",
    "First Name": "Ivana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42770580": {
    "id": "item_35969",
    "Last Name": "Chong",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42770650": {
    "id": "item_35970",
    "Last Name": "Tham",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42771711": {
    "id": "item_23570",
    "Last Name": "SILMAN",
    "First Name": "ISIS",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42773501": {
    "id": "item_25107",
    "Last Name": "Chakrabarty",
    "First Name": "Tapantosh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42775041": {
    "id": "item_25108",
    "Last Name": "REN",
    "First Name": "RUIHUA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42775952": {
    "id": "item_25109",
    "Last Name": "LOI",
    "First Name": "SI WENG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42776686": {
    "id": "item_10696",
    "Last Name": "Mcintyre",
    "First Name": "Klarie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42777900": {
    "id": "item_10697",
    "Last Name": "Salazar Echavarria",
    "First Name": "Carlos Andres",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42777958": {
    "id": "item_12513",
    "Last Name": "LI",
    "First Name": "GANG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42779454": {
    "id": "item_10698",
    "Last Name": "LI",
    "First Name": "BO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42780634": {
    "id": "item_12514",
    "Last Name": "Venkatramaiah",
    "First Name": "Satisha",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42780808": {
    "id": "item_35971",
    "Last Name": "UMEDA",
    "First Name": "FUMIFUTO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42780892": {
    "id": "item_25110",
    "Last Name": "Singh",
    "First Name": "Shashi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42780955": {
    "id": "item_25111",
    "Last Name": "Ballerini",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781182": {
    "id": "item_35972",
    "Last Name": "Prain",
    "First Name": "Glynnis",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781247": {
    "id": "item_10699",
    "Last Name": "Mircea",
    "First Name": "Alexandru",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781376": {
    "id": "item_23571",
    "Last Name": "SHI",
    "First Name": "XIAOQIAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781408": {
    "id": "item_25112",
    "Last Name": "van wezel",
    "First Name": "Lambertus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42781728": {
    "id": "item_25113",
    "Last Name": "GHADAGE",
    "First Name": "DILIP",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782023": {
    "id": "item_10700",
    "Last Name": "van der Meer",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782061": {
    "id": "item_10701",
    "Last Name": "KENNIS",
    "First Name": "ROEL",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782214": {
    "id": "item_25114",
    "Last Name": "du Clou",
    "First Name": "Aschwin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782591": {
    "id": "item_25115",
    "Last Name": "Li",
    "First Name": "Zhihua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782687": {
    "id": "item_10702",
    "Last Name": "Tester",
    "First Name": "Wyatt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42782906": {
    "id": "item_10703",
    "Last Name": "Blom",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42783092": {
    "id": "item_25116",
    "Last Name": "Bin As'at",
    "First Name": "Mohammad Zaki",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42783120": {
    "id": "item_25117",
    "Last Name": "Dhlamini",
    "First Name": "Daniel Tshepo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42784437": {
    "id": "item_25118",
    "Last Name": "Meyvaert",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42784484": {
    "id": "item_25119",
    "Last Name": "VAN EIJKELENBURG",
    "First Name": "Lars",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42784689": {
    "id": "item_12515",
    "Last Name": "Couvreur",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42784833": {
    "id": "item_25120",
    "Last Name": "Van Beeck",
    "First Name": "Guido GPM",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42785670": {
    "id": "item_25121",
    "Last Name": "Van Eijkelenburg",
    "First Name": "Marcus Anthonius",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42785800": {
    "id": "item_25122",
    "Last Name": "Luechinger",
    "First Name": "Sascha Markus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42789487": {
    "id": "item_12516",
    "Last Name": "Petrut",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42789911": {
    "id": "item_10704",
    "Last Name": "HINESTROSA",
    "First Name": "SANTIAGO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42790513": {
    "id": "item_35973",
    "Last Name": "Mercer",
    "First Name": "Meagan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42791453": {
    "id": "item_35974",
    "Last Name": "van Tol",
    "First Name": "Maurits",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42792182": {
    "id": "item_12517",
    "Last Name": "Baird",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42792758": {
    "id": "item_25123",
    "Last Name": "Mortier",
    "First Name": "Kay",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42793507": {
    "id": "item_23572",
    "Last Name": "Magoro",
    "First Name": "Tshifhiwa Bernard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42793559": {
    "id": "item_12518",
    "Last Name": "Zdanavicius",
    "First Name": "Tomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42794427": {
    "id": "item_25124",
    "Last Name": "GOMEZ LOPEZ",
    "First Name": "JOSE ENRIQUE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42794873": {
    "id": "item_23573",
    "Last Name": "Timmermann",
    "First Name": "Kristian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42794881": {
    "id": "item_12519",
    "Last Name": "Greensides",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42794944": {
    "id": "item_23574",
    "Last Name": "SUNG",
    "First Name": "JACKIE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42795208": {
    "id": "item_35975",
    "Last Name": "Colt",
    "First Name": "Lera",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42795320": {
    "id": "item_35976",
    "Last Name": "Colt",
    "First Name": "Max",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42795689": {
    "id": "item_23575",
    "Last Name": "Lee",
    "First Name": "June",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42796076": {
    "id": "item_35977",
    "Last Name": "Isaac",
    "First Name": "Cristian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42796322": {
    "id": "item_10705",
    "Last Name": "Etienne",
    "First Name": "Sandy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42796713": {
    "id": "item_35978",
    "Last Name": "George",
    "First Name": "Sanchez",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42796989": {
    "id": "item_23576",
    "Last Name": "Marte de Tiburcio",
    "First Name": "Ninoska Francina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42797567": {
    "id": "item_35979",
    "Last Name": "Opazo",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42797579": {
    "id": "item_25125",
    "Last Name": "Riley",
    "First Name": "Lavelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42803132": {
    "id": "item_35980",
    "Last Name": "Huang",
    "First Name": "Hsing Yu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42803471": {
    "id": "item_10706",
    "Last Name": "Kong",
    "First Name": "Qiang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42804026": {
    "id": "item_12520",
    "Last Name": "Hopson",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42804690": {
    "id": "item_12521",
    "Last Name": "LIANG",
    "First Name": "BO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805078": {
    "id": "item_25126",
    "Last Name": "song",
    "First Name": "peiyao",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805360": {
    "id": "item_25127",
    "Last Name": "Haddock",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805791": {
    "id": "item_25128",
    "Last Name": "Gao",
    "First Name": "Huihua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42805909": {
    "id": "item_23577",
    "Last Name": "li",
    "First Name": "ling",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806223": {
    "id": "item_25129",
    "Last Name": "O'Boyle",
    "First Name": "Shauna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806236": {
    "id": "item_10707",
    "Last Name": "flores vides",
    "First Name": "luis miguel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806450": {
    "id": "item_35981",
    "Last Name": "Mwiche",
    "First Name": "Kafula",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806475": {
    "id": "item_10708",
    "Last Name": "Oldenhof",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806744": {
    "id": "item_25130",
    "Last Name": "Mwanawasa",
    "First Name": "Mayamba",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806970": {
    "id": "item_25131",
    "Last Name": "OBrien",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42806989": {
    "id": "item_25132",
    "Last Name": "Ruitenberg",
    "First Name": "Ewout",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42807176": {
    "id": "item_25133",
    "Last Name": "GOMEZ DE CASTRO",
    "First Name": "PABLO ENRIQUE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42807236": {
    "id": "item_12522",
    "Last Name": "WEI",
    "First Name": "TZU HSIANG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42807337": {
    "id": "item_12523",
    "Last Name": "horman",
    "First Name": "erik steven",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42807372": {
    "id": "item_25134",
    "Last Name": "Khoza",
    "First Name": "Siyabonga",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42807497": {
    "id": "item_35982",
    "Last Name": "Brodard",
    "First Name": "Monique",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42807789": {
    "id": "item_35983",
    "Last Name": "WEI",
    "First Name": "WEI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42808049": {
    "id": "item_10709",
    "Last Name": "Dr. Becker",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42808524": {
    "id": "item_12524",
    "Last Name": "Ayyappanthody",
    "First Name": "Abdul nassar peringodan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42808645": {
    "id": "item_25135",
    "Last Name": "Sullivan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42809078": {
    "id": "item_10710",
    "Last Name": "MLOTSHWA",
    "First Name": "THEMBOKWAKHE GIFT",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42809849": {
    "id": "item_35984",
    "Last Name": "urriza",
    "First Name": "beatriz",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42809878": {
    "id": "item_25136",
    "Last Name": "Hauck",
    "First Name": "Karl-Heinz Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42810084": {
    "id": "item_25137",
    "Last Name": "Muthuswamy",
    "First Name": "Narayanan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42811859": {
    "id": "item_35985",
    "Last Name": "Ammerlaan",
    "First Name": "Adriana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42812197": {
    "id": "item_35986",
    "Last Name": "van Zeijl",
    "First Name": "Hendrika",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42813732": {
    "id": "item_23578",
    "Last Name": "Pancirolli",
    "First Name": "Luca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42814032": {
    "id": "item_10711",
    "Last Name": "Sbalchiero",
    "First Name": "Enrico",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42815225": {
    "id": "item_23579",
    "Last Name": "Desentis",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42817485": {
    "id": "item_23580",
    "Last Name": "mizrahi cohen",
    "First Name": "salomon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42817710": {
    "id": "item_25138",
    "Last Name": "Ots",
    "First Name": "Yves Alfons L",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42825049": {
    "id": "item_25139",
    "Last Name": "Brinkmann",
    "First Name": "Heiner",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42827567": {
    "id": "item_12525",
    "Last Name": "Garcia",
    "First Name": "Santiago Ezequiel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42827736": {
    "id": "item_10712",
    "Last Name": "Das",
    "First Name": "Aniket",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42827789": {
    "id": "item_23581",
    "Last Name": "nadal",
    "First Name": "carlo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42827947": {
    "id": "item_25140",
    "Last Name": "Murelli",
    "First Name": "Maria Cristina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42830046": {
    "id": "item_23582",
    "Last Name": "Iturrieta Monroe",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42831350": {
    "id": "item_25141",
    "Last Name": "Romo",
    "First Name": "Luis Enrique",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42833240": {
    "id": "item_23583",
    "Last Name": "O'Brien",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42833270": {
    "id": "item_12526",
    "Last Name": "Qu",
    "First Name": "Qing",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42833327": {
    "id": "item_35987",
    "Last Name": "Santos",
    "First Name": "Romer Ariel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42833969": {
    "id": "item_10713",
    "Last Name": "Parker",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834011": {
    "id": "item_23584",
    "Last Name": "Sager",
    "First Name": "Carmen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834017": {
    "id": "item_25142",
    "Last Name": "Yip",
    "First Name": "Kam Suen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834228": {
    "id": "item_35988",
    "Last Name": "Varani",
    "First Name": "Claudio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834252": {
    "id": "item_10714",
    "Last Name": "HSU",
    "First Name": "JEN HAO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42834692": {
    "id": "item_25143",
    "Last Name": "Sierra Martinez",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42835282": {
    "id": "item_10715",
    "Last Name": "Rodriguez",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42835364": {
    "id": "item_25144",
    "Last Name": "AVILA PEREZ",
    "First Name": "JOSE EDUARDO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42835481": {
    "id": "item_23585",
    "Last Name": "Yuen",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836161": {
    "id": "item_10716",
    "Last Name": "Lee",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836299": {
    "id": "item_25145",
    "Last Name": "Liu",
    "First Name": "Yiwei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836439": {
    "id": "item_35989",
    "Last Name": "GONZALES",
    "First Name": "TEDDY",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42836988": {
    "id": "item_23586",
    "Last Name": "suksamrit",
    "First Name": "sinlapakorn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837166": {
    "id": "item_35990",
    "Last Name": "Lacambra",
    "First Name": "Leidee January",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42837214": {
    "id": "item_10717",
    "Last Name": "Szeto",
    "First Name": "Yat Sing John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838384": {
    "id": "item_12527",
    "Last Name": "Rahman",
    "First Name": "Taseen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838446": {
    "id": "item_12528",
    "Last Name": "HO",
    "First Name": "Ka Chun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838450": {
    "id": "item_23587",
    "Last Name": "Habraken",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838484": {
    "id": "item_10718",
    "Last Name": "Mulcahy",
    "First Name": "Teri",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838488": {
    "id": "item_10719",
    "Last Name": "Laenen",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838599": {
    "id": "item_35991",
    "Last Name": "Hickin",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838720": {
    "id": "item_10720",
    "Last Name": "Richardson",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838756": {
    "id": "item_25146",
    "Last Name": "Papanikolaou",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838864": {
    "id": "item_35992",
    "Last Name": "Kearns",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42838923": {
    "id": "item_12529",
    "Last Name": "Taylor",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839113": {
    "id": "item_25147",
    "Last Name": "Po",
    "First Name": "Hung Chang",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839182": {
    "id": "item_25148",
    "Last Name": "Zhang",
    "First Name": "Chao",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839468": {
    "id": "item_25149",
    "Last Name": "Lau",
    "First Name": "Shuk Fan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839564": {
    "id": "item_25150",
    "Last Name": "Hsieh",
    "First Name": "Tsang Tang",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839610": {
    "id": "item_25151",
    "Last Name": "Chang",
    "First Name": "Chih Hao",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839675": {
    "id": "item_25152",
    "Last Name": "Liu",
    "First Name": "Hua Cheng",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839765": {
    "id": "item_12530",
    "Last Name": "kristensen",
    "First Name": "mikael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839834": {
    "id": "item_25153",
    "Last Name": "Chiou",
    "First Name": "Deng Song",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839902": {
    "id": "item_25154",
    "Last Name": "LIAO",
    "First Name": "YU LI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839950": {
    "id": "item_25155",
    "Last Name": "Chang",
    "First Name": "Hung Chi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839982": {
    "id": "item_25156",
    "Last Name": "HO",
    "First Name": "CHING YI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42839997": {
    "id": "item_10721",
    "Last Name": "McCall",
    "First Name": "Rory",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840005": {
    "id": "item_25157",
    "Last Name": "CHO",
    "First Name": "YUN JEN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840054": {
    "id": "item_25158",
    "Last Name": "Suteja Putra",
    "First Name": "I Wayan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840131": {
    "id": "item_25159",
    "Last Name": "Heilesen",
    "First Name": "Jonas Bjoern",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840137": {
    "id": "item_35993",
    "Last Name": "Siu",
    "First Name": "Yuet Chung Axel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840329": {
    "id": "item_25160",
    "Last Name": "Arriola",
    "First Name": "Ariel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840458": {
    "id": "item_23588",
    "Last Name": "Bus",
    "First Name": "Dave",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840503": {
    "id": "item_25161",
    "Last Name": "Surovtsev",
    "First Name": "Valentin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840597": {
    "id": "item_23589",
    "Last Name": "chiang",
    "First Name": "chaowei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840813": {
    "id": "item_35994",
    "Last Name": "Balzini",
    "First Name": "Andrea Luigi Guido",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42840875": {
    "id": "item_35995",
    "Last Name": "Sofra",
    "First Name": "Clotilde",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841181": {
    "id": "item_12531",
    "Last Name": "Gentile",
    "First Name": "Federico Emanuele",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841337": {
    "id": "item_23590",
    "Last Name": "Fabiani",
    "First Name": "Fabio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841478": {
    "id": "item_25162",
    "Last Name": "Usman",
    "First Name": "James Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841536": {
    "id": "item_25163",
    "Last Name": "Nisyrios",
    "First Name": "Voula",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841666": {
    "id": "item_25164",
    "Last Name": "Axford",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841812": {
    "id": "item_35996",
    "Last Name": "Moreno",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841838": {
    "id": "item_10722",
    "Last Name": "Richardson",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841852": {
    "id": "item_25165",
    "Last Name": "Moskovkina",
    "First Name": "Irina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841887": {
    "id": "item_35997",
    "Last Name": "Greig",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841912": {
    "id": "item_10723",
    "Last Name": "Sprigings",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42841940": {
    "id": "item_25166",
    "Last Name": "Corr�a",
    "First Name": "Luciana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42842146": {
    "id": "item_35998",
    "Last Name": "Bourke",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42842404": {
    "id": "item_10724",
    "Last Name": "Tilse",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42842969": {
    "id": "item_25167",
    "Last Name": "Peacock",
    "First Name": "Aimee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843259": {
    "id": "item_25168",
    "Last Name": "mesa gutierrez",
    "First Name": "fernando",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843261": {
    "id": "item_12532",
    "Last Name": "Leoncini",
    "First Name": "Dario",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843281": {
    "id": "item_35999",
    "Last Name": "MORENO ROMERO",
    "First Name": "NILSA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843327": {
    "id": "item_10725",
    "Last Name": "Nielsen",
    "First Name": "Peter Andreas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843486": {
    "id": "item_25169",
    "Last Name": "Seah",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843488": {
    "id": "item_25170",
    "Last Name": "WIRYADHANA",
    "First Name": "MADE GITHA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42843873": {
    "id": "item_23591",
    "Last Name": "Beshtawy",
    "First Name": "Bakheet",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42844042": {
    "id": "item_36000",
    "Last Name": "Cios",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42844871": {
    "id": "item_25171",
    "Last Name": "Linares Garcia",
    "First Name": "Arturo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42845229": {
    "id": "item_10726",
    "Last Name": "Yantchook",
    "First Name": "Niles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42845233": {
    "id": "item_12533",
    "Last Name": "QUARTANA",
    "First Name": "CLAUDIO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42845260": {
    "id": "item_12534",
    "Last Name": "Jaramillo",
    "First Name": "Mar’a",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42847183": {
    "id": "item_25172",
    "Last Name": "MŽndez",
    "First Name": "Marcelo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42847203": {
    "id": "item_12535",
    "Last Name": "Yanney",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42847554": {
    "id": "item_36001",
    "Last Name": "Bignotti",
    "First Name": "Massimo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42847673": {
    "id": "item_36002",
    "Last Name": "Gragnaniello",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42847798": {
    "id": "item_23592",
    "Last Name": "Sch¿n",
    "First Name": "Katja Adelheid",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42848312": {
    "id": "item_10727",
    "Last Name": "Espinoza Gastelum",
    "First Name": "Guadalupe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42848357": {
    "id": "item_25173",
    "Last Name": "Goodwin",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42848899": {
    "id": "item_12536",
    "Last Name": "Kurihara",
    "First Name": "Takehiro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42849196": {
    "id": "item_36003",
    "Last Name": "Grandonico",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42849300": {
    "id": "item_10728",
    "Last Name": "Surrey",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42849554": {
    "id": "item_10729",
    "Last Name": "Czyzewski",
    "First Name": "Jaroslaw",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42850069": {
    "id": "item_10730",
    "Last Name": "Cage",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42850256": {
    "id": "item_36004",
    "Last Name": "Cabiati",
    "First Name": "Valentina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42850356": {
    "id": "item_12537",
    "Last Name": "Seethoff",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42850393": {
    "id": "item_36005",
    "Last Name": "Schiatti",
    "First Name": "Carlo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42851881": {
    "id": "item_25174",
    "Last Name": "GARCIA",
    "First Name": "JORGE ENRIQUE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42852128": {
    "id": "item_36006",
    "Last Name": "Br¿chner-Mortensen",
    "First Name": "Marius",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42852129": {
    "id": "item_36007",
    "Last Name": "Lundsteen",
    "First Name": "Anne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42852182": {
    "id": "item_36008",
    "Last Name": "Burgett",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42852449": {
    "id": "item_36009",
    "Last Name": "Miller",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42852585": {
    "id": "item_10731",
    "Last Name": "becerra",
    "First Name": "joaquin hector eleazar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42852697": {
    "id": "item_25175",
    "Last Name": "Piazza",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42853291": {
    "id": "item_10732",
    "Last Name": "ZHANG",
    "First Name": "LILI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42853675": {
    "id": "item_36010",
    "Last Name": "Manana",
    "First Name": "Bongani James",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42858326": {
    "id": "item_10733",
    "Last Name": "Rodenghi",
    "First Name": "Enrico",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42860104": {
    "id": "item_23593",
    "Last Name": "Postoaca",
    "First Name": "Anana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42860139": {
    "id": "item_23594",
    "Last Name": "Cabrera",
    "First Name": "Wilkin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42865035": {
    "id": "item_23595",
    "Last Name": "Borri",
    "First Name": "Giorgio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42875679": {
    "id": "item_23596",
    "Last Name": "Urquidez",
    "First Name": "Ginger",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42875784": {
    "id": "item_36011",
    "Last Name": "Sun",
    "First Name": "Michele",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42875927": {
    "id": "item_36012",
    "Last Name": "Krewer",
    "First Name": "Mary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876216": {
    "id": "item_25176",
    "Last Name": "Zhurilo",
    "First Name": "Maxim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876596": {
    "id": "item_36013",
    "Last Name": "Lee",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876597": {
    "id": "item_25177",
    "Last Name": "Lindeman",
    "First Name": "Alexandria",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876653": {
    "id": "item_25178",
    "Last Name": "Gilmore",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42876848": {
    "id": "item_12538",
    "Last Name": "Cabrera C‡rdenas",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42877475": {
    "id": "item_12539",
    "Last Name": "Vassilakos",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42877968": {
    "id": "item_25179",
    "Last Name": "AGUIAR",
    "First Name": "LOURDES",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42878247": {
    "id": "item_12540",
    "Last Name": "Lubbers",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42878856": {
    "id": "item_36014",
    "Last Name": "Butler",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42879505": {
    "id": "item_36015",
    "Last Name": "Zwern",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42879883": {
    "id": "item_36016",
    "Last Name": "sommers",
    "First Name": "camille",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42880083": {
    "id": "item_25180",
    "Last Name": "Lopez",
    "First Name": "Yohany",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42882341": {
    "id": "item_36017",
    "Last Name": "FEBRIANTO",
    "First Name": "RIZKI ANANDA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42882568": {
    "id": "item_12541",
    "Last Name": "Cropp",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42882633": {
    "id": "item_10734",
    "Last Name": "Ward",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42882953": {
    "id": "item_12542",
    "Last Name": "WAI KIN",
    "First Name": "LOK",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42882989": {
    "id": "item_10735",
    "Last Name": "Halim",
    "First Name": "Andry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42883282": {
    "id": "item_36018",
    "Last Name": "Russell",
    "First Name": "Viv",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42884474": {
    "id": "item_23597",
    "Last Name": "ASSEGAF",
    "First Name": "AHMAD FIKRI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42884734": {
    "id": "item_23598",
    "Last Name": "SONG",
    "First Name": "XIAOSHA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42885063": {
    "id": "item_23599",
    "Last Name": "OH",
    "First Name": "SEUNGWON",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42885136": {
    "id": "item_36019",
    "Last Name": "KIM",
    "First Name": "YOONSEOB",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42886344": {
    "id": "item_23600",
    "Last Name": "Wright",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42886374": {
    "id": "item_10736",
    "Last Name": "Yadernaya",
    "First Name": "Daria",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42886420": {
    "id": "item_23601",
    "Last Name": "chen",
    "First Name": "wenzhi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42886985": {
    "id": "item_10737",
    "Last Name": "Sever",
    "First Name": "Sandi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42886991": {
    "id": "item_36020",
    "Last Name": "RUOSS",
    "First Name": "PETER ALOIS",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42887468": {
    "id": "item_36021",
    "Last Name": "Restantio",
    "First Name": "Jencien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42887512": {
    "id": "item_25181",
    "Last Name": "Sutter",
    "First Name": "Mirco",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42887554": {
    "id": "item_36022",
    "Last Name": "Masuda",
    "First Name": "Mariko",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42887608": {
    "id": "item_12543",
    "Last Name": "Faulkner",
    "First Name": "Wade",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42887690": {
    "id": "item_23602",
    "Last Name": "sposato",
    "First Name": "rossella",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42887705": {
    "id": "item_25182",
    "Last Name": "Fulton",
    "First Name": "Abby",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42887786": {
    "id": "item_12544",
    "Last Name": "de Vries",
    "First Name": "Machteld",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42887986": {
    "id": "item_25183",
    "Last Name": "Rohr",
    "First Name": "Teruko",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888132": {
    "id": "item_10738",
    "Last Name": "Kobberoe",
    "First Name": "Bjarke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888240": {
    "id": "item_10739",
    "Last Name": "LEROUX",
    "First Name": "ELVIN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888440": {
    "id": "item_36023",
    "Last Name": "Nielsen",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42888793": {
    "id": "item_23603",
    "Last Name": "Suttie",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889025": {
    "id": "item_36024",
    "Last Name": "Nielsen",
    "First Name": "Frederik",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889184": {
    "id": "item_36025",
    "Last Name": "Tanoyo",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889275": {
    "id": "item_25184",
    "Last Name": "Ederveen",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889282": {
    "id": "item_25185",
    "Last Name": "Connell",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889456": {
    "id": "item_25186",
    "Last Name": "Tjeng",
    "First Name": "Endrix edison",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889487": {
    "id": "item_12545",
    "Last Name": "Kamya",
    "First Name": "Godfrey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42889561": {
    "id": "item_10740",
    "Last Name": "Swanepoel",
    "First Name": "Wihan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42890125": {
    "id": "item_36026",
    "Last Name": "Ahmed",
    "First Name": "Rabab",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42890185": {
    "id": "item_12546",
    "Last Name": "Serras",
    "First Name": "Jœlio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42890636": {
    "id": "item_23604",
    "Last Name": "Arora",
    "First Name": "Randeep singh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42890918": {
    "id": "item_25187",
    "Last Name": "Andriani",
    "First Name": "Mona Monica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42891356": {
    "id": "item_36027",
    "Last Name": "Carusone",
    "First Name": "Gianni",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42891622": {
    "id": "item_25188",
    "Last Name": "Zhang",
    "First Name": "Sugianto",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42892179": {
    "id": "item_36028",
    "Last Name": "Joshi",
    "First Name": "Meghna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42892547": {
    "id": "item_10741",
    "Last Name": "Cheng",
    "First Name": "Hon Lam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42892741": {
    "id": "item_25189",
    "Last Name": "Cuengco",
    "First Name": "Hazel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42892836": {
    "id": "item_12547",
    "Last Name": "RODRIGUEZ",
    "First Name": "WALTER",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42892844": {
    "id": "item_25190",
    "Last Name": "Rak",
    "First Name": "Pavol",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42894561": {
    "id": "item_36029",
    "Last Name": "Hernandez",
    "First Name": "Maritza",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42897786": {
    "id": "item_36030",
    "Last Name": "Meswantori",
    "First Name": "Dikki",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42905069": {
    "id": "item_12548",
    "Last Name": "Quiros Alpizar",
    "First Name": "Nelson Gerardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42907963": {
    "id": "item_36031",
    "Last Name": "Fisafarani",
    "First Name": "Hanani",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42910513": {
    "id": "item_36032",
    "Last Name": "Holland",
    "First Name": "Austin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42911023": {
    "id": "item_25191",
    "Last Name": "Segura",
    "First Name": "Javier",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42913055": {
    "id": "item_36033",
    "Last Name": "Sanchez",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42913804": {
    "id": "item_36034",
    "Last Name": "Kowalczyk",
    "First Name": "Camilla",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42935637": {
    "id": "item_25192",
    "Last Name": "Dries",
    "First Name": "Hendrik",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42935659": {
    "id": "item_25193",
    "Last Name": "Brown",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42935706": {
    "id": "item_23605",
    "Last Name": "Cavatorti",
    "First Name": "Shaila",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42935821": {
    "id": "item_25194",
    "Last Name": "Cornelis",
    "First Name": "Rudiger",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42935829": {
    "id": "item_25195",
    "Last Name": "Dhaen",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42936556": {
    "id": "item_12549",
    "Last Name": "Steele",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42936673": {
    "id": "item_36035",
    "Last Name": "Velez",
    "First Name": "Juan Esteban",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42936868": {
    "id": "item_36036",
    "Last Name": "Archey",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42940054": {
    "id": "item_25196",
    "Last Name": "RAMIREZ ZUNIGA",
    "First Name": "AARON",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42940462": {
    "id": "item_36037",
    "Last Name": "Cleary",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42942441": {
    "id": "item_36038",
    "Last Name": "Suzu Zerry",
    "First Name": "Yoma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42942517": {
    "id": "item_23606",
    "Last Name": "Miyachi",
    "First Name": "Hiroshi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42944310": {
    "id": "item_36039",
    "Last Name": "Adiningtyas",
    "First Name": "Wahyu Dwi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42944531": {
    "id": "item_25197",
    "Last Name": "Si",
    "First Name": "Indra Sumanjaya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42945014": {
    "id": "item_25198",
    "Last Name": "Lawrence",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42946666": {
    "id": "item_25199",
    "Last Name": "Lam",
    "First Name": "Chi Cheung",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42948202": {
    "id": "item_36040",
    "Last Name": "Chu",
    "First Name": "ChorYing",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42948223": {
    "id": "item_10742",
    "Last Name": "KIM",
    "First Name": "KI-HOON",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42948534": {
    "id": "item_36041",
    "Last Name": "Lee",
    "First Name": "Nolan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42948741": {
    "id": "item_10743",
    "Last Name": "Hansen",
    "First Name": "Hauke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42949075": {
    "id": "item_36042",
    "Last Name": "Chan",
    "First Name": "Shu King Elsa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42949507": {
    "id": "item_23607",
    "Last Name": "IMAYA",
    "First Name": "KENICHI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950047": {
    "id": "item_25200",
    "Last Name": "Derikx",
    "First Name": "Chantal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950049": {
    "id": "item_25201",
    "Last Name": "Hohenstein",
    "First Name": "Wanda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950068": {
    "id": "item_25202",
    "Last Name": "Hohenstein",
    "First Name": "Helgo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950120": {
    "id": "item_23608",
    "Last Name": "FRANCIOSI",
    "First Name": "ANDREA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950560": {
    "id": "item_23609",
    "Last Name": "Maggi",
    "First Name": "Sebastiano",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950671": {
    "id": "item_25203",
    "Last Name": "Mulaudzi",
    "First Name": "Masha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950690": {
    "id": "item_36043",
    "Last Name": "Nefale",
    "First Name": "Nyambeni Ntsundeni",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950720": {
    "id": "item_12550",
    "Last Name": "Bulgarelli",
    "First Name": "Anna",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950802": {
    "id": "item_25204",
    "Last Name": "DELOGU",
    "First Name": "SEBASTIANO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42950975": {
    "id": "item_36044",
    "Last Name": "Hung",
    "First Name": "Wan Yan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42951075": {
    "id": "item_36045",
    "Last Name": "WAI",
    "First Name": "MEI LAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42951185": {
    "id": "item_36046",
    "Last Name": "Zhao",
    "First Name": "Anyu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42952063": {
    "id": "item_25205",
    "Last Name": "Alagia",
    "First Name": "Giuseppe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42952221": {
    "id": "item_10744",
    "Last Name": "Stieranka",
    "First Name": "Rastislav",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42952232": {
    "id": "item_25206",
    "Last Name": "Weigand",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42952234": {
    "id": "item_36047",
    "Last Name": "Leung",
    "First Name": "Eddie Chin Pang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42952496": {
    "id": "item_25207",
    "Last Name": "Chang",
    "First Name": "Tan Wei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42953184": {
    "id": "item_36048",
    "Last Name": "Chung",
    "First Name": "Chin Hung",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42953710": {
    "id": "item_25208",
    "Last Name": "De Winde",
    "First Name": "Laure",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42954229": {
    "id": "item_12551",
    "Last Name": "Borgognoni",
    "First Name": "Marco",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42954282": {
    "id": "item_25209",
    "Last Name": "Fava",
    "First Name": "Assunta",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42954557": {
    "id": "item_25210",
    "Last Name": "Burley",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42954839": {
    "id": "item_36049",
    "Last Name": "Foddai",
    "First Name": "Graziella",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42954886": {
    "id": "item_23610",
    "Last Name": "Mildenberger",
    "First Name": "Luciane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42955134": {
    "id": "item_12552",
    "Last Name": "Grewal",
    "First Name": "Gurpreet S",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42957023": {
    "id": "item_36050",
    "Last Name": "Tsui",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42958728": {
    "id": "item_12553",
    "Last Name": "ORTIZ DE PINEDO FERNANDEZ",
    "First Name": "JOSE MARIA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42958840": {
    "id": "item_12554",
    "Last Name": "Appleton",
    "First Name": "Darryn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42959432": {
    "id": "item_25211",
    "Last Name": "Chapman",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42960473": {
    "id": "item_36051",
    "Last Name": "Powell",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42960998": {
    "id": "item_25212",
    "Last Name": "Neil",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42961178": {
    "id": "item_36052",
    "Last Name": "BUISE",
    "First Name": "Pierre Jean Marie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42961335": {
    "id": "item_25213",
    "Last Name": "FABRIS",
    "First Name": "EMANUELE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42961754": {
    "id": "item_23611",
    "Last Name": "Contreras",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42962586": {
    "id": "item_25214",
    "Last Name": "ROSSI SERRES LOUCAO",
    "First Name": "DANIELA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42963506": {
    "id": "item_36053",
    "Last Name": "Carranza Zenteno",
    "First Name": "Zarina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42963587": {
    "id": "item_25215",
    "Last Name": "Gray",
    "First Name": "Franklin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42965969": {
    "id": "item_10745",
    "Last Name": "Hack",
    "First Name": "Maurice",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42966031": {
    "id": "item_36054",
    "Last Name": "ALVAREZ ROCHA",
    "First Name": "JOSE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42966190": {
    "id": "item_25216",
    "Last Name": "Wang",
    "First Name": "Xiaoyuan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42972421": {
    "id": "item_23612",
    "Last Name": "Gayst",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42972497": {
    "id": "item_36055",
    "Last Name": "Vora",
    "First Name": "Jill",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42972898": {
    "id": "item_36056",
    "Last Name": "Gupta",
    "First Name": "Chirag",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42973764": {
    "id": "item_25217",
    "Last Name": "van der Grift",
    "First Name": "AndrŽ",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42974264": {
    "id": "item_12555",
    "Last Name": "KONG",
    "First Name": "Cheuk Ho",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42974340": {
    "id": "item_10746",
    "Last Name": "Schmidt",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42974403": {
    "id": "item_10747",
    "Last Name": "Pfaller",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42974799": {
    "id": "item_36057",
    "Last Name": "Beni",
    "First Name": "Maurizio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42974800": {
    "id": "item_36058",
    "Last Name": "Modenese",
    "First Name": "Valentina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42975808": {
    "id": "item_12556",
    "Last Name": "Berrahou",
    "First Name": "Reda",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42975841": {
    "id": "item_12557",
    "Last Name": "Berrahou",
    "First Name": "Mourad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42976028": {
    "id": "item_12558",
    "Last Name": "Bishop",
    "First Name": "Matty",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42976566": {
    "id": "item_10748",
    "Last Name": "Selling",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42977297": {
    "id": "item_25218",
    "Last Name": "Pellicelli",
    "First Name": "Nunzio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42978645": {
    "id": "item_25219",
    "Last Name": "Temesio",
    "First Name": "Raul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42978761": {
    "id": "item_36059",
    "Last Name": "KIRCHNER",
    "First Name": "RALF",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42980875": {
    "id": "item_36060",
    "Last Name": "Kusters",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42987275": {
    "id": "item_25220",
    "Last Name": "Doinikov",
    "First Name": "Igor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42989424": {
    "id": "item_23613",
    "Last Name": "Daradjatun",
    "First Name": "Andra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42993308": {
    "id": "item_36061",
    "Last Name": "Yasin",
    "First Name": "Muhamad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42993502": {
    "id": "item_25221",
    "Last Name": "Blake",
    "First Name": "Keith",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42993704": {
    "id": "item_36062",
    "Last Name": "Botma",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42994268": {
    "id": "item_25222",
    "Last Name": "Emslie",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42994827": {
    "id": "item_12559",
    "Last Name": "masaracchia",
    "First Name": "giuseppe salvatore",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42995204": {
    "id": "item_10749",
    "Last Name": "Caspersz-Loney",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42995296": {
    "id": "item_10750",
    "Last Name": "Carson",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42995389": {
    "id": "item_12560",
    "Last Name": "Sanjaya",
    "First Name": "Sintra",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42995439": {
    "id": "item_23614",
    "Last Name": "Daafous Villamar",
    "First Name": "Nadir",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42996040": {
    "id": "item_12561",
    "Last Name": "Heringer",
    "First Name": "Sandro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42996251": {
    "id": "item_23615",
    "Last Name": "Yang",
    "First Name": "Junqi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42998386": {
    "id": "item_36063",
    "Last Name": "Madrigal",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42999143": {
    "id": "item_10751",
    "Last Name": "Rodriguez",
    "First Name": "Jeffry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42999323": {
    "id": "item_25223",
    "Last Name": "Amadori",
    "First Name": "Marco",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42999324": {
    "id": "item_10752",
    "Last Name": "Richter",
    "First Name": "Anton",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "42999514": {
    "id": "item_12562",
    "Last Name": "Junior",
    "First Name": "Alvaro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43000353": {
    "id": "item_23616",
    "Last Name": "Wongso",
    "First Name": "Sutedio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43000830": {
    "id": "item_12563",
    "Last Name": "Pileggi",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43000835": {
    "id": "item_25224",
    "Last Name": "Fell",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43001084": {
    "id": "item_12564",
    "Last Name": "Mace",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43003456": {
    "id": "item_36064",
    "Last Name": "aquino de lacerda",
    "First Name": "janewmar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43005550": {
    "id": "item_12565",
    "Last Name": "Damian Flores",
    "First Name": "Neftali",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43005636": {
    "id": "item_12566",
    "Last Name": "Choksi",
    "First Name": "Harsh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43006308": {
    "id": "item_36065",
    "Last Name": "Moffett",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43006469": {
    "id": "item_36066",
    "Last Name": "IHARA",
    "First Name": "EMIKO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43006644": {
    "id": "item_36067",
    "Last Name": "IHARA",
    "First Name": "KAZUYOSHI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43006923": {
    "id": "item_23617",
    "Last Name": "Connolly",
    "First Name": "Antonia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43006939": {
    "id": "item_25225",
    "Last Name": "Gruwez",
    "First Name": "Milo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43007926": {
    "id": "item_25226",
    "Last Name": "Orozco",
    "First Name": "Cuauhtemoc",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43008009": {
    "id": "item_12567",
    "Last Name": "cassaniti",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43009295": {
    "id": "item_25227",
    "Last Name": "Watkins",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43010703": {
    "id": "item_25228",
    "Last Name": "KWOK",
    "First Name": "SUI SAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43010777": {
    "id": "item_12568",
    "Last Name": "Noonan",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43011608": {
    "id": "item_38268",
    "Last Name": "Wat",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43011926": {
    "id": "item_23618",
    "Last Name": "Kurniawan",
    "First Name": "Kurniawan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43013492": {
    "id": "item_23619",
    "Last Name": "LAU",
    "First Name": "HO TAK",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014200": {
    "id": "item_25229",
    "Last Name": "Porto de Almeida",
    "First Name": "Mateus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014251": {
    "id": "item_36068",
    "Last Name": "SCALICI",
    "First Name": "DANIELA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014407": {
    "id": "item_36069",
    "Last Name": "Focquet",
    "First Name": "Annie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014686": {
    "id": "item_36070",
    "Last Name": "NTULI",
    "First Name": "ITEBOGENG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43014801": {
    "id": "item_36071",
    "Last Name": "MASANABO",
    "First Name": "GEORGE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43015267": {
    "id": "item_25230",
    "Last Name": "Bang",
    "First Name": "Birgitte",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43015686": {
    "id": "item_36072",
    "Last Name": "Ling",
    "First Name": "Ai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43015711": {
    "id": "item_25231",
    "Last Name": "TRUSSARDI",
    "First Name": "RICCARDO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43015795": {
    "id": "item_36073",
    "Last Name": "Leung",
    "First Name": "Sze Hang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43015989": {
    "id": "item_10753",
    "Last Name": "Udol",
    "First Name": "Alexandre",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016123": {
    "id": "item_36074",
    "Last Name": "van Schaik",
    "First Name": "Bernardus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016180": {
    "id": "item_25232",
    "Last Name": "Kruaykitanon",
    "First Name": "Parichart",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016413": {
    "id": "item_12569",
    "Last Name": "PARADISO",
    "First Name": "MICHELE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016457": {
    "id": "item_25233",
    "Last Name": "DRUAIS",
    "First Name": "JEAN PAUL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016532": {
    "id": "item_12570",
    "Last Name": "DETTOLE",
    "First Name": "ANDREA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016635": {
    "id": "item_25234",
    "Last Name": "Garbarino",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016642": {
    "id": "item_36075",
    "Last Name": "YAMADA",
    "First Name": "HITOSHI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016776": {
    "id": "item_25235",
    "Last Name": "Zaharik",
    "First Name": "Chad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016871": {
    "id": "item_23620",
    "Last Name": "Harmon",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43016932": {
    "id": "item_12571",
    "Last Name": "van Hoeij",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43018147": {
    "id": "item_36076",
    "Last Name": "Flanagan",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43018570": {
    "id": "item_23621",
    "Last Name": "Mistretta",
    "First Name": "Vincenzo Daniele",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43018871": {
    "id": "item_36077",
    "Last Name": "CHARBONNIER",
    "First Name": "Jean-Marie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43019660": {
    "id": "item_36078",
    "Last Name": "Wilson",
    "First Name": "Lee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43020129": {
    "id": "item_25236",
    "Last Name": "Goh",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43020708": {
    "id": "item_25237",
    "Last Name": "Strauch",
    "First Name": "Joachim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43020799": {
    "id": "item_36079",
    "Last Name": "LOPEZ MORENO",
    "First Name": "YAGO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43021657": {
    "id": "item_10754",
    "Last Name": "AUGY",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43023204": {
    "id": "item_10755",
    "Last Name": "Knops",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43023567": {
    "id": "item_36080",
    "Last Name": "van der Lienden",
    "First Name": "Gerardus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43023941": {
    "id": "item_36081",
    "Last Name": "Genova",
    "First Name": "Silvia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43024991": {
    "id": "item_12572",
    "Last Name": "Davis",
    "First Name": "Keeson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43027022": {
    "id": "item_25238",
    "Last Name": "Smith",
    "First Name": "Spencer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43027720": {
    "id": "item_25239",
    "Last Name": "Pereira",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43029287": {
    "id": "item_25240",
    "Last Name": "Perral",
    "First Name": "Gifford John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43030618": {
    "id": "item_23622",
    "Last Name": "Andersen",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43030986": {
    "id": "item_36082",
    "Last Name": "Hanna",
    "First Name": "Justine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43031254": {
    "id": "item_25241",
    "Last Name": "Mustari",
    "First Name": "Mohamad",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43031460": {
    "id": "item_10756",
    "Last Name": "MO",
    "First Name": "YINGHUI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43031655": {
    "id": "item_36083",
    "Last Name": "CHIN",
    "First Name": "PEK WAN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43031785": {
    "id": "item_36084",
    "Last Name": "Rudnianyn",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43032391": {
    "id": "item_12573",
    "Last Name": "Ventosa",
    "First Name": "Joao",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43033493": {
    "id": "item_12574",
    "Last Name": "Octara",
    "First Name": "Ade",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43034807": {
    "id": "item_25243",
    "Last Name": "Widjaja",
    "First Name": "Nini",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43034815": {
    "id": "item_25242",
    "Last Name": "Ruiz",
    "First Name": "Gilberto",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43035921": {
    "id": "item_25244",
    "Last Name": "Lee",
    "First Name": "Diana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43036020": {
    "id": "item_10757",
    "Last Name": "ZHAO",
    "First Name": "YAWEN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43036268": {
    "id": "item_12575",
    "Last Name": "Wang",
    "First Name": "Fenghao",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43036636": {
    "id": "item_23623",
    "Last Name": "West",
    "First Name": "Marc",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43037134": {
    "id": "item_12576",
    "Last Name": "Bronstein",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43037474": {
    "id": "item_25245",
    "Last Name": "Merkelbach",
    "First Name": "Bart",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43037481": {
    "id": "item_23624",
    "Last Name": "WANG",
    "First Name": "CHING LUNG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43037979": {
    "id": "item_23625",
    "Last Name": "Ziola",
    "First Name": "Rebekah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43037993": {
    "id": "item_23626",
    "Last Name": "Rigby",
    "First Name": "Jaime-Lee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43038222": {
    "id": "item_12577",
    "Last Name": "Dabrazzi",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43038476": {
    "id": "item_25246",
    "Last Name": "Li",
    "First Name": "Qixiu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43039038": {
    "id": "item_12578",
    "Last Name": "le Roux",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43039242": {
    "id": "item_23627",
    "Last Name": "BRAVO QUIROZ",
    "First Name": "CARMEN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43039279": {
    "id": "item_10758",
    "Last Name": "ARANDA CANO",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43039384": {
    "id": "item_25247",
    "Last Name": "Despreaux",
    "First Name": "Florent",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43040280": {
    "id": "item_12579",
    "Last Name": "Cools",
    "First Name": "Jan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43040370": {
    "id": "item_10759",
    "Last Name": "Li",
    "First Name": "Shirong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43041254": {
    "id": "item_25248",
    "Last Name": "Kwun",
    "First Name": "Junil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43042063": {
    "id": "item_36085",
    "Last Name": "Firme",
    "First Name": "Marco",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43043399": {
    "id": "item_23628",
    "Last Name": "Wood",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43043439": {
    "id": "item_36086",
    "Last Name": "Myers",
    "First Name": "Casey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43043966": {
    "id": "item_36087",
    "Last Name": "Janssens",
    "First Name": "StŽphanie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43046361": {
    "id": "item_36088",
    "Last Name": "Farjoni",
    "First Name": "Paulo Henrique",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43046481": {
    "id": "item_23629",
    "Last Name": "Leutwiler",
    "First Name": "Roger",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43046581": {
    "id": "item_36089",
    "Last Name": "Biddulph-Wall",
    "First Name": "Madeline",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048185": {
    "id": "item_10760",
    "Last Name": "PARAGE",
    "First Name": "Fran�oise",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048229": {
    "id": "item_23630",
    "Last Name": "Benzaken",
    "First Name": "Alain",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048361": {
    "id": "item_23631",
    "Last Name": "Laur",
    "First Name": "Patrice",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048416": {
    "id": "item_25249",
    "Last Name": "Seifert",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048421": {
    "id": "item_36090",
    "Last Name": "Broster",
    "First Name": "Tegan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048425": {
    "id": "item_25250",
    "Last Name": "Martinez",
    "First Name": "Neil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048450": {
    "id": "item_10761",
    "Last Name": "Liegghio",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048539": {
    "id": "item_36091",
    "Last Name": "McGuire",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048567": {
    "id": "item_23632",
    "Last Name": "Kolyadenko",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048572": {
    "id": "item_36092",
    "Last Name": "Baumgarten Velen",
    "First Name": "Cynthia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048577": {
    "id": "item_12580",
    "Last Name": "Preti",
    "First Name": "Alessio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048687": {
    "id": "item_23633",
    "Last Name": "Smith",
    "First Name": "Autumn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048703": {
    "id": "item_36093",
    "Last Name": "Gannamraju",
    "First Name": "Ashwin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048758": {
    "id": "item_10762",
    "Last Name": "Helmer",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048834": {
    "id": "item_36094",
    "Last Name": "Zayas Ramos",
    "First Name": "Eileen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43048841": {
    "id": "item_25251",
    "Last Name": "Lawson",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049002": {
    "id": "item_36095",
    "Last Name": "Al-Ghanim",
    "First Name": "Margie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049119": {
    "id": "item_25252",
    "Last Name": "Lawson",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049148": {
    "id": "item_10763",
    "Last Name": "Malone",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049423": {
    "id": "item_36096",
    "Last Name": "GLAZE",
    "First Name": "THENESHIA",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049426": {
    "id": "item_10764",
    "Last Name": "Pattee",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049443": {
    "id": "item_36097",
    "Last Name": "Pham",
    "First Name": "Chinh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049560": {
    "id": "item_36098",
    "Last Name": "Tamayo-Hutchinson",
    "First Name": "Elizabeth Jill",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049645": {
    "id": "item_10765",
    "Last Name": "Singsaas",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049652": {
    "id": "item_36099",
    "Last Name": "Wendel",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049831": {
    "id": "item_36100",
    "Last Name": "Mason",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43049848": {
    "id": "item_25253",
    "Last Name": "Ravindranath",
    "First Name": "Abhilash",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43050216": {
    "id": "item_36101",
    "Last Name": "Riley",
    "First Name": "Keomany Julie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43050409": {
    "id": "item_23634",
    "Last Name": "Hill",
    "First Name": "Amanda Elyse",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051056": {
    "id": "item_12581",
    "Last Name": "Wong",
    "First Name": "Kin Man",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051422": {
    "id": "item_23635",
    "Last Name": "Rosen",
    "First Name": "Diane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051500": {
    "id": "item_36102",
    "Last Name": "BARREDA VAZQUEZ",
    "First Name": "RICARDO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051556": {
    "id": "item_25254",
    "Last Name": "Satti",
    "First Name": "Chakrapani",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051613": {
    "id": "item_36103",
    "Last Name": "Seigle",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051662": {
    "id": "item_25255",
    "Last Name": "Stephens",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43051893": {
    "id": "item_25256",
    "Last Name": "LaCroix",
    "First Name": "Allison",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052127": {
    "id": "item_12582",
    "Last Name": "Kokta",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052189": {
    "id": "item_12583",
    "Last Name": "Onistrat",
    "First Name": "Andrii",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052361": {
    "id": "item_12584",
    "Last Name": "Adamson",
    "First Name": "Stewart",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052515": {
    "id": "item_25257",
    "Last Name": "Brown",
    "First Name": "Alanna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43052560": {
    "id": "item_36104",
    "Last Name": "Leland",
    "First Name": "Shelby",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43053672": {
    "id": "item_12585",
    "Last Name": "Duarte Ambriz",
    "First Name": "Mauricio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43053782": {
    "id": "item_25258",
    "Last Name": "Duarte Rodr’guez",
    "First Name": "Mauricio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43054149": {
    "id": "item_36105",
    "Last Name": "Willets",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43054586": {
    "id": "item_36106",
    "Last Name": "Leland",
    "First Name": "Gail Cynthia Giovannetti",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43055105": {
    "id": "item_36107",
    "Last Name": "Dei",
    "First Name": "Dimas Aditya Shannon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43055289": {
    "id": "item_36108",
    "Last Name": "Berry",
    "First Name": "Jennette",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43055379": {
    "id": "item_36109",
    "Last Name": "Psyche",
    "First Name": "Fok",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43055566": {
    "id": "item_10766",
    "Last Name": "Reed",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43056056": {
    "id": "item_25259",
    "Last Name": "Fasola",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43056214": {
    "id": "item_25260",
    "Last Name": "Liao",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43056373": {
    "id": "item_25261",
    "Last Name": "Eusey",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43056564": {
    "id": "item_10767",
    "Last Name": "Shiga",
    "First Name": "Suguru",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43056607": {
    "id": "item_23636",
    "Last Name": "Nevin",
    "First Name": "Heidi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43057171": {
    "id": "item_36110",
    "Last Name": "Armstrong",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43057448": {
    "id": "item_36111",
    "Last Name": "Maree",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43057910": {
    "id": "item_10768",
    "Last Name": "Syafril Sayuti",
    "First Name": "Hamdan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058059": {
    "id": "item_36112",
    "Last Name": "MELCHERS",
    "First Name": "ALEXANDER",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058071": {
    "id": "item_36113",
    "Last Name": "BODET",
    "First Name": "Francois",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058836": {
    "id": "item_23637",
    "Last Name": "TUNG",
    "First Name": "YU-JU",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058945": {
    "id": "item_25262",
    "Last Name": "Heath",
    "First Name": "Nat",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43058993": {
    "id": "item_10769",
    "Last Name": "JOUN",
    "First Name": "NAMSOK",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059204": {
    "id": "item_12586",
    "Last Name": "ZHENG",
    "First Name": "SONGBO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059279": {
    "id": "item_25263",
    "Last Name": "YU",
    "First Name": "Xiaoming",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059423": {
    "id": "item_12587",
    "Last Name": "JE",
    "First Name": "BYEONGJIK",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059641": {
    "id": "item_10770",
    "Last Name": "Ho",
    "First Name": "Chun Wing",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059790": {
    "id": "item_25264",
    "Last Name": "Dahal",
    "First Name": "Shambhu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43059956": {
    "id": "item_23638",
    "Last Name": "MARTINEZ LOPEZ",
    "First Name": "RAFAEL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060072": {
    "id": "item_12588",
    "Last Name": "Pfeiffer",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060284": {
    "id": "item_12589",
    "Last Name": "Barros Cordero",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060473": {
    "id": "item_23639",
    "Last Name": "Osma S‡nchez",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060585": {
    "id": "item_23640",
    "Last Name": "CHENG",
    "First Name": "SHU HUA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060638": {
    "id": "item_25265",
    "Last Name": "GARCêA RUIZ",
    "First Name": "ANGEL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43060674": {
    "id": "item_25266",
    "Last Name": "DELEPINE",
    "First Name": "JEROME",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061022": {
    "id": "item_23641",
    "Last Name": "Howard",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061236": {
    "id": "item_23642",
    "Last Name": "HAMON",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061318": {
    "id": "item_25267",
    "Last Name": "Mehroke",
    "First Name": "Tansa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061637": {
    "id": "item_25268",
    "Last Name": "ODonnell",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061988": {
    "id": "item_25269",
    "Last Name": "LO",
    "First Name": "CHIA CHENG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43061990": {
    "id": "item_36114",
    "Last Name": "Nimmo",
    "First Name": "Zara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43062014": {
    "id": "item_12590",
    "Last Name": "Larson",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43062057": {
    "id": "item_36115",
    "Last Name": "Heker Rozmaryn",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43062068": {
    "id": "item_10771",
    "Last Name": "Rutgers",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43062094": {
    "id": "item_36116",
    "Last Name": "Humbel",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43062311": {
    "id": "item_36117",
    "Last Name": "Cosola",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43063633": {
    "id": "item_25270",
    "Last Name": "nasoetion",
    "First Name": "nadia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43063791": {
    "id": "item_23643",
    "Last Name": "Nieva",
    "First Name": "Concepcion",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43064094": {
    "id": "item_36118",
    "Last Name": "Sickel",
    "First Name": "Marcelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43064491": {
    "id": "item_23644",
    "Last Name": "Maxwell",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43064532": {
    "id": "item_36119",
    "Last Name": "Booysen",
    "First Name": "Jacques",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43064698": {
    "id": "item_25271",
    "Last Name": "Mathys-Borali",
    "First Name": "Odilia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43065003": {
    "id": "item_36121",
    "Last Name": "Wilson",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43065004": {
    "id": "item_36120",
    "Last Name": "DLAMINI",
    "First Name": "NOMCEBO SICELINHLANHLA THABISILE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43065609": {
    "id": "item_25272",
    "Last Name": "Loukola",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43065664": {
    "id": "item_10772",
    "Last Name": "Stampa",
    "First Name": "Gian Lorenzo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43065842": {
    "id": "item_10773",
    "Last Name": "Matos celemin",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43065992": {
    "id": "item_10774",
    "Last Name": "Medvene",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066097": {
    "id": "item_36122",
    "Last Name": "Khoh",
    "First Name": "Allan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066222": {
    "id": "item_12591",
    "Last Name": "Campia",
    "First Name": "Paolo Enrico Giovanni",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066470": {
    "id": "item_36123",
    "Last Name": "BOUKHOBZA",
    "First Name": "FLORINE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066532": {
    "id": "item_25273",
    "Last Name": "THEVENY",
    "First Name": "STEPHANE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066619": {
    "id": "item_23645",
    "Last Name": "Robison",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066836": {
    "id": "item_25274",
    "Last Name": "Pettit",
    "First Name": "Jodi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43066840": {
    "id": "item_23646",
    "Last Name": "Moose",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43067364": {
    "id": "item_36124",
    "Last Name": "Delfosse",
    "First Name": "Luc",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43067490": {
    "id": "item_36125",
    "Last Name": "Lee",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43067494": {
    "id": "item_25275",
    "Last Name": "Rogers",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43067744": {
    "id": "item_25276",
    "Last Name": "Thompson",
    "First Name": "leonor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43067779": {
    "id": "item_36126",
    "Last Name": "van de Weem",
    "First Name": "Branko",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43067926": {
    "id": "item_36127",
    "Last Name": "van den Heuvel",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43067968": {
    "id": "item_36128",
    "Last Name": "Blum",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43068068": {
    "id": "item_36129",
    "Last Name": "FONDRILLON",
    "First Name": "Jean-Claude",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43068316": {
    "id": "item_36130",
    "Last Name": "Cobb",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43068374": {
    "id": "item_10775",
    "Last Name": "Nurmagambetov",
    "First Name": "Sunkar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43068436": {
    "id": "item_10776",
    "Last Name": "Chabot",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43068478": {
    "id": "item_23647",
    "Last Name": "Eiler",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43069135": {
    "id": "item_25277",
    "Last Name": "Bruno",
    "First Name": "Damian Jorge",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43069224": {
    "id": "item_23648",
    "Last Name": "Fox",
    "First Name": "Alaric",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43069436": {
    "id": "item_12592",
    "Last Name": "Procopio",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43070364": {
    "id": "item_23649",
    "Last Name": "goedegebuure",
    "First Name": "erica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43070882": {
    "id": "item_25278",
    "Last Name": "Bulus",
    "First Name": "Patrick Afonso",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43070919": {
    "id": "item_25279",
    "Last Name": "Brown",
    "First Name": "Nichole",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071207": {
    "id": "item_36131",
    "Last Name": "Nielsen",
    "First Name": "Christian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071463": {
    "id": "item_25280",
    "Last Name": "Buitendag",
    "First Name": "Gerdus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071572": {
    "id": "item_25281",
    "Last Name": "Raymond",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071587": {
    "id": "item_25282",
    "Last Name": "O'Keefe",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071723": {
    "id": "item_36132",
    "Last Name": "Lawless",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071800": {
    "id": "item_36133",
    "Last Name": "Lax",
    "First Name": "Montgomery",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071864": {
    "id": "item_23650",
    "Last Name": "Rougas",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071866": {
    "id": "item_36134",
    "Last Name": "Nielsen",
    "First Name": "Astrid",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43071925": {
    "id": "item_25283",
    "Last Name": "surratt",
    "First Name": "thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43072016": {
    "id": "item_36135",
    "Last Name": "Araujo Rodriguez",
    "First Name": "Maribel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43072453": {
    "id": "item_25284",
    "Last Name": "CORONEL LEON",
    "First Name": "MARIA DEL CARMEN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43072498": {
    "id": "item_25285",
    "Last Name": "Sanschagrin",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43072617": {
    "id": "item_23651",
    "Last Name": "MacMahon",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43072855": {
    "id": "item_12593",
    "Last Name": "Araujo",
    "First Name": "Vitor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43072856": {
    "id": "item_12594",
    "Last Name": "Vevers",
    "First Name": "Rory",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43073100": {
    "id": "item_25286",
    "Last Name": "Dhaliwal",
    "First Name": "Lovedip",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43073252": {
    "id": "item_36136",
    "Last Name": "Gilliam",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43074964": {
    "id": "item_12595",
    "Last Name": "GOMEZ ALVAREZ MORENO",
    "First Name": "FERNANDO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43075178": {
    "id": "item_10777",
    "Last Name": "ALFARO",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43075277": {
    "id": "item_25287",
    "Last Name": "Moustafa",
    "First Name": "Yacoob",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43075556": {
    "id": "item_12596",
    "Last Name": "Tapp",
    "First Name": "Jerry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43076609": {
    "id": "item_36137",
    "Last Name": "Wells Schroeder",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43077270": {
    "id": "item_12597",
    "Last Name": "Conejo",
    "First Name": "Mauricio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43077392": {
    "id": "item_25288",
    "Last Name": "Tharachai",
    "First Name": "Theerathon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43080801": {
    "id": "item_25289",
    "Last Name": "Inouye",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43081179": {
    "id": "item_12598",
    "Last Name": "FUJIMURA",
    "First Name": "MASAHIRO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43081611": {
    "id": "item_10778",
    "Last Name": "Tebeck",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43082974": {
    "id": "item_10779",
    "Last Name": "Chapple",
    "First Name": "Megan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43082995": {
    "id": "item_12599",
    "Last Name": "Singh",
    "First Name": "Sukhveer",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084045": {
    "id": "item_36138",
    "Last Name": "Tanzilli",
    "First Name": "Gaetano",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43084429": {
    "id": "item_23652",
    "Last Name": "OLLER BELLMUNT",
    "First Name": "ROSA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43085153": {
    "id": "item_10780",
    "Last Name": "Boonprasitpol",
    "First Name": "Tanakorn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43085293": {
    "id": "item_25290",
    "Last Name": "liang",
    "First Name": "yibin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43086874": {
    "id": "item_25291",
    "Last Name": "Tsiambouris",
    "First Name": "Evelyn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43088161": {
    "id": "item_12600",
    "Last Name": "Jolly",
    "First Name": "Geo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43088419": {
    "id": "item_12601",
    "Last Name": "LIANG",
    "First Name": "SHIHKUN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43092648": {
    "id": "item_25292",
    "Last Name": "M Luke",
    "First Name": "Larry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43093721": {
    "id": "item_36139",
    "Last Name": "Rodriguez",
    "First Name": "Darresa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43093904": {
    "id": "item_12602",
    "Last Name": "Passetti",
    "First Name": "Alberto",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43094100": {
    "id": "item_36140",
    "Last Name": "Loozen",
    "First Name": "Heidi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43094280": {
    "id": "item_12603",
    "Last Name": "Franze",
    "First Name": "Giuseppe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43094582": {
    "id": "item_10781",
    "Last Name": "Germanos",
    "First Name": "Tarek",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43094746": {
    "id": "item_36141",
    "Last Name": "Belic",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43094976": {
    "id": "item_25293",
    "Last Name": "MACCIO'",
    "First Name": "Luigi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43095365": {
    "id": "item_25294",
    "Last Name": "Ferrari",
    "First Name": "Massimo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43095720": {
    "id": "item_36142",
    "Last Name": "Roberts",
    "First Name": "Mary Ellen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43095723": {
    "id": "item_36143",
    "Last Name": "Peters",
    "First Name": "Janice Louise",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43095804": {
    "id": "item_25295",
    "Last Name": "Marola",
    "First Name": "Enzo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43098359": {
    "id": "item_12604",
    "Last Name": "Fonseca",
    "First Name": "Erik",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43098689": {
    "id": "item_36144",
    "Last Name": "Torres",
    "First Name": "Eugenio",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43098740": {
    "id": "item_36145",
    "Last Name": "Lopez",
    "First Name": "Angerick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43098741": {
    "id": "item_12605",
    "Last Name": "GAUCI",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43099828": {
    "id": "item_25296",
    "Last Name": "Dehaney",
    "First Name": "Armand",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43100136": {
    "id": "item_12606",
    "Last Name": "Pisegna Orlando",
    "First Name": "Francesco",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43100892": {
    "id": "item_36146",
    "Last Name": "Lee",
    "First Name": "Kang Won",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43101018": {
    "id": "item_25297",
    "Last Name": "King",
    "First Name": "Heather",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43101997": {
    "id": "item_12607",
    "Last Name": "Apuzzo",
    "First Name": "Ferdinando",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43102728": {
    "id": "item_36147",
    "Last Name": "Lee",
    "First Name": "Kang Yong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43102898": {
    "id": "item_36148",
    "Last Name": "Metivier",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43103872": {
    "id": "item_23653",
    "Last Name": "Wilson",
    "First Name": "Neville",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43103984": {
    "id": "item_25298",
    "Last Name": "Brennan",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43104491": {
    "id": "item_36149",
    "Last Name": "Tsigros",
    "First Name": "Niki",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43104710": {
    "id": "item_25299",
    "Last Name": "TIYASSIH",
    "First Name": "ESTIRA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43108983": {
    "id": "item_12608",
    "Last Name": "Lee",
    "First Name": "Chi Man",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43110154": {
    "id": "item_12609",
    "Last Name": "Liu",
    "First Name": "Ricky",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43110255": {
    "id": "item_25300",
    "Last Name": "Fickling",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43110682": {
    "id": "item_23654",
    "Last Name": "FAVA",
    "First Name": "STEFANO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43111369": {
    "id": "item_12610",
    "Last Name": "Moreno Eurresta",
    "First Name": "Ana Raquel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43112451": {
    "id": "item_23655",
    "Last Name": "Visentin",
    "First Name": "Irene",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43113045": {
    "id": "item_36150",
    "Last Name": "Lightner",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43113597": {
    "id": "item_12611",
    "Last Name": "Junge",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43115586": {
    "id": "item_10782",
    "Last Name": "Kusano",
    "First Name": "Hiroki",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43116099": {
    "id": "item_10783",
    "Last Name": "van der Goes",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43116145": {
    "id": "item_10784",
    "Last Name": "Lip",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43118408": {
    "id": "item_12612",
    "Last Name": "PIETRA",
    "First Name": "GIANLUCA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43120152": {
    "id": "item_25302",
    "Last Name": "Hook",
    "First Name": "Theodore",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43120154": {
    "id": "item_25301",
    "Last Name": "DeFabritiis",
    "First Name": "Sabrina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43120265": {
    "id": "item_36151",
    "Last Name": "Clarke",
    "First Name": "Aiden",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43120307": {
    "id": "item_23656",
    "Last Name": "RODRIGUEZ CHAVARRIA",
    "First Name": "AMANDA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43125953": {
    "id": "item_36152",
    "Last Name": "Cunningham",
    "First Name": "Kassi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43127298": {
    "id": "item_10785",
    "Last Name": "Ndungu",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43128345": {
    "id": "item_25303",
    "Last Name": "Simek",
    "First Name": "Janice",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43128483": {
    "id": "item_36153",
    "Last Name": "Shaak",
    "First Name": "George William",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43129517": {
    "id": "item_12613",
    "Last Name": "Mercier",
    "First Name": "Matthieu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43130628": {
    "id": "item_12614",
    "Last Name": "Coria",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43134011": {
    "id": "item_12615",
    "Last Name": "Trujillo Ausces",
    "First Name": "Marco Antonio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43134502": {
    "id": "item_25304",
    "Last Name": "Orozco Alonzo",
    "First Name": "Gerardo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43134695": {
    "id": "item_25305",
    "Last Name": "PARRENO",
    "First Name": "VAL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43136733": {
    "id": "item_25306",
    "Last Name": "Cohen",
    "First Name": "Meghan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43138930": {
    "id": "item_23657",
    "Last Name": "Patricio",
    "First Name": "Maria Lailani",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43139310": {
    "id": "item_25307",
    "Last Name": "Walpole",
    "First Name": "Franck",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43139344": {
    "id": "item_12616",
    "Last Name": "Wong",
    "First Name": "Chun Bong Joseph",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43139465": {
    "id": "item_36154",
    "Last Name": "zhu",
    "First Name": "yufei",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43140806": {
    "id": "item_36155",
    "Last Name": "Bell˜",
    "First Name": "Francesco",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43141011": {
    "id": "item_12617",
    "Last Name": "El yahyaoui",
    "First Name": "Samir",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43142130": {
    "id": "item_25308",
    "Last Name": "MŸller",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43143055": {
    "id": "item_36156",
    "Last Name": "Hoefling",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43145868": {
    "id": "item_25309",
    "Last Name": "GARCIA LOPEZ",
    "First Name": "ELIZABETH",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43146600": {
    "id": "item_36157",
    "Last Name": "Boylan",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43146998": {
    "id": "item_36158",
    "Last Name": "Newsom",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43147511": {
    "id": "item_36159",
    "Last Name": "Kumar",
    "First Name": "Atul",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43151152": {
    "id": "item_36160",
    "Last Name": "Taylor",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43151196": {
    "id": "item_36161",
    "Last Name": "Virani",
    "First Name": "Kanubhai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43153226": {
    "id": "item_12618",
    "Last Name": "Soward",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43157671": {
    "id": "item_23658",
    "Last Name": "Haude",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43158261": {
    "id": "item_25310",
    "Last Name": "Adamski",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43158642": {
    "id": "item_36162",
    "Last Name": "ribaute",
    "First Name": "etienne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43158841": {
    "id": "item_12619",
    "Last Name": "Miklic",
    "First Name": "Mirko Bogomir",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43161028": {
    "id": "item_36163",
    "Last Name": "Clarke",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43163448": {
    "id": "item_36164",
    "Last Name": "Y",
    "First Name": "Esteban",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43163547": {
    "id": "item_25311",
    "Last Name": "Yi",
    "First Name": "Lihuai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43163870": {
    "id": "item_25312",
    "Last Name": "Quinlan",
    "First Name": "Clodagh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43164327": {
    "id": "item_36165",
    "Last Name": "Herndon Lee",
    "First Name": "Bridget Ann",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43164387": {
    "id": "item_38269",
    "Last Name": "Enrera",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43165156": {
    "id": "item_36166",
    "Last Name": "Chite",
    "First Name": "Stewart",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43165650": {
    "id": "item_36167",
    "Last Name": "Henry",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43174073": {
    "id": "item_10786",
    "Last Name": "Moncada",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43175313": {
    "id": "item_36168",
    "Last Name": "YU",
    "First Name": "SHANGYU",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43175803": {
    "id": "item_10787",
    "Last Name": "Wilson",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43175851": {
    "id": "item_23659",
    "Last Name": "Taufik",
    "First Name": "Ricki",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43176272": {
    "id": "item_23660",
    "Last Name": "Sitanggang",
    "First Name": "Reynold Susilo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43177132": {
    "id": "item_10788",
    "Last Name": "Hogan",
    "First Name": "Billy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43177683": {
    "id": "item_23661",
    "Last Name": "Azarfane",
    "First Name": "Mohamed",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43177892": {
    "id": "item_10789",
    "Last Name": "Smith",
    "First Name": "Campbell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43178177": {
    "id": "item_25313",
    "Last Name": "Alj",
    "First Name": "Myriam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43178582": {
    "id": "item_25314",
    "Last Name": "Uteulin",
    "First Name": "Daniyar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179038": {
    "id": "item_25315",
    "Last Name": "van der Linden",
    "First Name": "Roger",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179095": {
    "id": "item_10790",
    "Last Name": "LEE",
    "First Name": "KA BO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179353": {
    "id": "item_36169",
    "Last Name": "Lee",
    "First Name": "Chiachien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43179631": {
    "id": "item_12620",
    "Last Name": "Nayak",
    "First Name": "Deepa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180239": {
    "id": "item_10791",
    "Last Name": "McNamara",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180324": {
    "id": "item_10792",
    "Last Name": "MOGIO PALAU",
    "First Name": "GERVASIO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180576": {
    "id": "item_25316",
    "Last Name": "Fr¿lund Olsen",
    "First Name": "Betina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180598": {
    "id": "item_25317",
    "Last Name": "Olsen",
    "First Name": "Kenni",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180601": {
    "id": "item_25318",
    "Last Name": "Symes",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43180617": {
    "id": "item_23662",
    "Last Name": "Khieochaum",
    "First Name": "Jatuwit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43181158": {
    "id": "item_25319",
    "Last Name": "Larragan",
    "First Name": "Berta",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43181238": {
    "id": "item_23663",
    "Last Name": "Landache",
    "First Name": "Cristina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43182287": {
    "id": "item_10793",
    "Last Name": "Cebotari",
    "First Name": "Andrei",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43182347": {
    "id": "item_36170",
    "Last Name": "Lissau",
    "First Name": "Anders",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43183854": {
    "id": "item_12621",
    "Last Name": "Warchol",
    "First Name": "Marcin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43184258": {
    "id": "item_23664",
    "Last Name": "MOK",
    "First Name": "WAI HANG",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43184392": {
    "id": "item_12622",
    "Last Name": "Zielinski",
    "First Name": "Grzegorz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43184702": {
    "id": "item_12623",
    "Last Name": "Stryczek",
    "First Name": "Katarzyna",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43185215": {
    "id": "item_12624",
    "Last Name": "CELIC",
    "First Name": "ALEXIS",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43185286": {
    "id": "item_23665",
    "Last Name": "BERIOS",
    "First Name": "NIKOLAOS",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43185486": {
    "id": "item_23666",
    "Last Name": "KUNG",
    "First Name": "LING JU",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43185728": {
    "id": "item_36171",
    "Last Name": "Clark",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43188550": {
    "id": "item_23667",
    "Last Name": "Jones",
    "First Name": "Nadine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43189307": {
    "id": "item_25320",
    "Last Name": "Baxter",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43189352": {
    "id": "item_10794",
    "Last Name": "Graves",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43191677": {
    "id": "item_10795",
    "Last Name": "Vonk",
    "First Name": "Laurens",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43191703": {
    "id": "item_10796",
    "Last Name": "Wong",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43192047": {
    "id": "item_25321",
    "Last Name": "Rogers",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43192573": {
    "id": "item_25322",
    "Last Name": "Rogers",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43193126": {
    "id": "item_25323",
    "Last Name": "Granado Justo",
    "First Name": "Alvaro JosŽ",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43193330": {
    "id": "item_10797",
    "Last Name": "Trust",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43194324": {
    "id": "item_10798",
    "Last Name": "Rendon S",
    "First Name": "Manuel G",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43198164": {
    "id": "item_23668",
    "Last Name": "Smith",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43200000": {
    "id": "item_36172",
    "Last Name": "Sirithanachai",
    "First Name": "Thanapol",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43200098": {
    "id": "item_36173",
    "Last Name": "Chu",
    "First Name": "Dan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43200461": {
    "id": "item_10799",
    "Last Name": "Lewis",
    "First Name": "Darryl",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43200846": {
    "id": "item_36174",
    "Last Name": "Sutanto",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43203093": {
    "id": "item_12625",
    "Last Name": "Gordon",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43203240": {
    "id": "item_25324",
    "Last Name": "PENTHEROUDAKIS",
    "First Name": "NIKOLAOS",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43203291": {
    "id": "item_25325",
    "Last Name": "Thomson",
    "First Name": "Brodan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43203687": {
    "id": "item_25326",
    "Last Name": "Whelan",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43203862": {
    "id": "item_10800",
    "Last Name": "Poole",
    "First Name": "Cayman",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43204534": {
    "id": "item_25327",
    "Last Name": "Cobarro",
    "First Name": "Joaquin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43204751": {
    "id": "item_25328",
    "Last Name": "Brailean",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43204942": {
    "id": "item_36175",
    "Last Name": "Belgen",
    "First Name": "Stian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43204980": {
    "id": "item_12626",
    "Last Name": "Akinci",
    "First Name": "Lutfiye",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43205393": {
    "id": "item_10801",
    "Last Name": "NIKITCHENKO",
    "First Name": "ANDREY",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43205463": {
    "id": "item_23669",
    "Last Name": "Larsen",
    "First Name": "Anne-Lill",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43205672": {
    "id": "item_36176",
    "Last Name": "Smith",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43206318": {
    "id": "item_23670",
    "Last Name": "Knapp",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43206497": {
    "id": "item_36177",
    "Last Name": "Pallotta",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43206650": {
    "id": "item_25329",
    "Last Name": "Rachitoff",
    "First Name": "Javier",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43206849": {
    "id": "item_36178",
    "Last Name": "Lokkevik",
    "First Name": "Inger Johanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43206914": {
    "id": "item_36179",
    "Last Name": "Fedyaev",
    "First Name": "Artem",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43208211": {
    "id": "item_10802",
    "Last Name": "Cheng",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43208714": {
    "id": "item_23671",
    "Last Name": "bedier",
    "First Name": "yohann",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43208760": {
    "id": "item_12627",
    "Last Name": "Rose",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43209459": {
    "id": "item_25330",
    "Last Name": "Sutton",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43209608": {
    "id": "item_25331",
    "Last Name": "Carboni",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43209679": {
    "id": "item_10803",
    "Last Name": "Diz Mendez",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43210590": {
    "id": "item_36180",
    "Last Name": "Rubio",
    "First Name": "Samanta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43211769": {
    "id": "item_25332",
    "Last Name": "Ravuri",
    "First Name": "Vikash",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43213071": {
    "id": "item_36181",
    "Last Name": "Tobo Barrera",
    "First Name": "Pedro Guillermo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43214756": {
    "id": "item_12628",
    "Last Name": "Jimenez",
    "First Name": "Fabian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43218483": {
    "id": "item_23672",
    "Last Name": "Ocampo Trejo",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43221500": {
    "id": "item_23673",
    "Last Name": "AIVALIOTIS",
    "First Name": "ELEFTHERIOS-MATTHAIOS",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43221566": {
    "id": "item_36182",
    "Last Name": "Dalmau",
    "First Name": "Karlina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43221644": {
    "id": "item_10804",
    "Last Name": "Olmos",
    "First Name": "Rolando",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43221876": {
    "id": "item_12629",
    "Last Name": "MAGNUSSEN",
    "First Name": "JON MICHAEL",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43222365": {
    "id": "item_10805",
    "Last Name": "Herrera",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43222393": {
    "id": "item_36183",
    "Last Name": "Rodriguez Vicens",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43222679": {
    "id": "item_12630",
    "Last Name": "SECO",
    "First Name": "JAVIER ADRIAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43222977": {
    "id": "item_25333",
    "Last Name": "Jones",
    "First Name": "Keith",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43223064": {
    "id": "item_10806",
    "Last Name": "Berelowitz",
    "First Name": "Gary",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43223865": {
    "id": "item_12631",
    "Last Name": "NOLI",
    "First Name": "PAOLA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43225268": {
    "id": "item_23674",
    "Last Name": "Ikeda",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43225676": {
    "id": "item_25334",
    "Last Name": "Haase",
    "First Name": "Ismene",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43226098": {
    "id": "item_10807",
    "Last Name": "Cortes Guzman",
    "First Name": "Carlos Israel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43226552": {
    "id": "item_25335",
    "Last Name": "zucca",
    "First Name": "paolo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43226869": {
    "id": "item_25336",
    "Last Name": "Oudrhiri",
    "First Name": "Mustapha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43226876": {
    "id": "item_36184",
    "Last Name": "George",
    "First Name": "Edgard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43227303": {
    "id": "item_12632",
    "Last Name": "Reyes Chavez",
    "First Name": "Marco Antonio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43227622": {
    "id": "item_25337",
    "Last Name": "bhandal",
    "First Name": "charan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43228150": {
    "id": "item_36185",
    "Last Name": "Guthrie",
    "First Name": "Damian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43228355": {
    "id": "item_36186",
    "Last Name": "Guthrie",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43229074": {
    "id": "item_25338",
    "Last Name": "Lozano Branger",
    "First Name": "Pedro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43229078": {
    "id": "item_23675",
    "Last Name": "Lee",
    "First Name": "Chiachen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43229280": {
    "id": "item_36187",
    "Last Name": "Hellman",
    "First Name": "MŒrten",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43229690": {
    "id": "item_25339",
    "Last Name": "Kuvin",
    "First Name": "Kaitlin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43230907": {
    "id": "item_10808",
    "Last Name": "Wight",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43230918": {
    "id": "item_23676",
    "Last Name": "Colunga Fraga",
    "First Name": "Victor Samuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43233230": {
    "id": "item_25340",
    "Last Name": "Ruiz",
    "First Name": "Joaquin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43234165": {
    "id": "item_10809",
    "Last Name": "Bustamante",
    "First Name": "Exequiel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43234350": {
    "id": "item_25341",
    "Last Name": "Quidlat",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43234390": {
    "id": "item_10810",
    "Last Name": "PEI",
    "First Name": "YI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43236259": {
    "id": "item_25342",
    "Last Name": "Villa",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43236603": {
    "id": "item_25343",
    "Last Name": "Dosdos",
    "First Name": "Aquillo Jr,",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43236806": {
    "id": "item_36188",
    "Last Name": "RIOS FLORES",
    "First Name": "JESUS",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43238931": {
    "id": "item_10811",
    "Last Name": "Saputra",
    "First Name": "Iqbal",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43239295": {
    "id": "item_12633",
    "Last Name": "Wehbe",
    "First Name": "Elias",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43240263": {
    "id": "item_12634",
    "Last Name": "Goodrick",
    "First Name": "Byron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43240285": {
    "id": "item_12635",
    "Last Name": "LIN",
    "First Name": "TSENG TING",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43240337": {
    "id": "item_36189",
    "Last Name": "Sparks",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43240533": {
    "id": "item_23677",
    "Last Name": "LU",
    "First Name": "KUO HUA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43240953": {
    "id": "item_25344",
    "Last Name": "MA",
    "First Name": "CHI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43241027": {
    "id": "item_25345",
    "Last Name": "ROMAN ROMAN",
    "First Name": "JOSE ANTONIO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43241722": {
    "id": "item_25346",
    "Last Name": "Ahmad",
    "First Name": "Sulastri",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43241859": {
    "id": "item_36190",
    "Last Name": "Moloney",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43242306": {
    "id": "item_25347",
    "Last Name": "Bharani",
    "First Name": "Narendra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43242699": {
    "id": "item_10812",
    "Last Name": "Geeraets",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43244373": {
    "id": "item_36191",
    "Last Name": "CHANG",
    "First Name": "TZYY NENG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43244489": {
    "id": "item_25348",
    "Last Name": "Polii",
    "First Name": "Joessy Kelly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43244982": {
    "id": "item_36192",
    "Last Name": "S¾ther",
    "First Name": "Dagfinn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43245370": {
    "id": "item_36193",
    "Last Name": "Diez",
    "First Name": "Maria Cristina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43245632": {
    "id": "item_12636",
    "Last Name": "Trinidad",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43245643": {
    "id": "item_12637",
    "Last Name": "Paxton",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43248854": {
    "id": "item_36194",
    "Last Name": "Nicklin",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43249127": {
    "id": "item_12638",
    "Last Name": "Pilli",
    "First Name": "Moonika",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43251787": {
    "id": "item_23678",
    "Last Name": "Bandini",
    "First Name": "Filippo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43252269": {
    "id": "item_10813",
    "Last Name": "Paolucci",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43252301": {
    "id": "item_36195",
    "Last Name": "Otero",
    "First Name": "Juan Enrique",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43252862": {
    "id": "item_23679",
    "Last Name": "Carrera",
    "First Name": "Marcos",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43252956": {
    "id": "item_25349",
    "Last Name": "Aramburu Gonzalez",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43253151": {
    "id": "item_12639",
    "Last Name": "Charlebois",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43253788": {
    "id": "item_25350",
    "Last Name": "Rodriguez Marizcurrena",
    "First Name": "Alejandro Jose",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43253794": {
    "id": "item_23680",
    "Last Name": "Bautista",
    "First Name": "Isagani Ramon Jr",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43253870": {
    "id": "item_23681",
    "Last Name": "Esteva",
    "First Name": "Cristian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43254418": {
    "id": "item_36196",
    "Last Name": "Vaskinn",
    "First Name": "Anja",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43254466": {
    "id": "item_25351",
    "Last Name": "Lavoie",
    "First Name": "Marc",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43254574": {
    "id": "item_25352",
    "Last Name": "Germano",
    "First Name": "M‡rio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43254796": {
    "id": "item_12640",
    "Last Name": "Van Hautte",
    "First Name": "Jeroen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43254951": {
    "id": "item_23682",
    "Last Name": "Boudjack",
    "First Name": "Yann",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43256810": {
    "id": "item_12641",
    "Last Name": "Mokhtar",
    "First Name": "Hany",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43256844": {
    "id": "item_36197",
    "Last Name": "steven jomides",
    "First Name": "steven jomides",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43256845": {
    "id": "item_23683",
    "Last Name": "Madrid",
    "First Name": "Elias",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257015": {
    "id": "item_36198",
    "Last Name": "DiRosato",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257152": {
    "id": "item_12642",
    "Last Name": "Almoayyed",
    "First Name": "Saud",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257198": {
    "id": "item_36199",
    "Last Name": "Weidmann",
    "First Name": "Shawn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257207": {
    "id": "item_25353",
    "Last Name": "ROCHA HOURCADE",
    "First Name": "RICARDO DANIEL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257719": {
    "id": "item_36200",
    "Last Name": "Rivero Vda de Aguilera",
    "First Name": "Olga Olimpia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257921": {
    "id": "item_25354",
    "Last Name": "Vera-Sommers",
    "First Name": "Naima",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257971": {
    "id": "item_25355",
    "Last Name": "Vogele",
    "First Name": "Sasha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43257974": {
    "id": "item_23684",
    "Last Name": "Dyer",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43258066": {
    "id": "item_10814",
    "Last Name": "Horn",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43258102": {
    "id": "item_36201",
    "Last Name": "Dhlomo",
    "First Name": "Deon",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43258209": {
    "id": "item_12643",
    "Last Name": "Montero Le—n",
    "First Name": "Raœl",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43258335": {
    "id": "item_23685",
    "Last Name": "McKeon",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43258430": {
    "id": "item_10815",
    "Last Name": "Salvatore",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43258835": {
    "id": "item_25356",
    "Last Name": "Acosta Gelos",
    "First Name": "Washington Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43258837": {
    "id": "item_36202",
    "Last Name": "Fredes",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43259081": {
    "id": "item_36203",
    "Last Name": "Pantig",
    "First Name": "Yoly",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43259794": {
    "id": "item_23686",
    "Last Name": "McCullough",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43260005": {
    "id": "item_36204",
    "Last Name": "Mai",
    "First Name": "Huy (TONY)",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43260201": {
    "id": "item_36205",
    "Last Name": "Mezaki",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43260247": {
    "id": "item_25357",
    "Last Name": "Higashihara",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43260934": {
    "id": "item_36206",
    "Last Name": "Rodarte",
    "First Name": "Rene",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43261032": {
    "id": "item_23687",
    "Last Name": "SUNG",
    "First Name": "SANG HYUN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43262063": {
    "id": "item_36207",
    "Last Name": "Dougherty",
    "First Name": "Suzanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43262673": {
    "id": "item_36208",
    "Last Name": "Pestillos-Ocat",
    "First Name": "Liza",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43263017": {
    "id": "item_36209",
    "Last Name": "Sands",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43263254": {
    "id": "item_36210",
    "Last Name": "Sangueza",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43263340": {
    "id": "item_36211",
    "Last Name": "Manikkam",
    "First Name": "Indu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43265050": {
    "id": "item_36212",
    "Last Name": "NIE",
    "First Name": "XUEZHEN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43265131": {
    "id": "item_25358",
    "Last Name": "Flowers",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43265917": {
    "id": "item_25359",
    "Last Name": "Zakerski",
    "First Name": "Debora",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43265930": {
    "id": "item_23688",
    "Last Name": "Haysman",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43266091": {
    "id": "item_25360",
    "Last Name": "Kunz",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43266930": {
    "id": "item_25361",
    "Last Name": "Chaiwichian",
    "First Name": "Pitcha",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43267380": {
    "id": "item_10816",
    "Last Name": "Larkin",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43267441": {
    "id": "item_25362",
    "Last Name": "Carr",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43268777": {
    "id": "item_36213",
    "Last Name": "Patthanathamrongkasem",
    "First Name": "Soontorn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43268935": {
    "id": "item_12644",
    "Last Name": "Raya",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43269815": {
    "id": "item_25363",
    "Last Name": "XI",
    "First Name": "YIMING",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43269889": {
    "id": "item_36214",
    "Last Name": "Boyle",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270326": {
    "id": "item_36215",
    "Last Name": "Fisher",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270332": {
    "id": "item_10817",
    "Last Name": "RYU",
    "First Name": "HO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270493": {
    "id": "item_10819",
    "Last Name": "Pappalardo",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270497": {
    "id": "item_10818",
    "Last Name": "Martin",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43270767": {
    "id": "item_12645",
    "Last Name": "PARK",
    "First Name": "JINGIL",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43271003": {
    "id": "item_10820",
    "Last Name": "KANG",
    "First Name": "MINKEON",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43271146": {
    "id": "item_36216",
    "Last Name": "Kocinski",
    "First Name": "Laurent",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43271518": {
    "id": "item_25364",
    "Last Name": "Downs",
    "First Name": "Jo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43271836": {
    "id": "item_36217",
    "Last Name": "Paterson",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43272774": {
    "id": "item_23689",
    "Last Name": "J›gi",
    "First Name": "Agur",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43272802": {
    "id": "item_10821",
    "Last Name": "Stankard",
    "First Name": "Enda",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43274764": {
    "id": "item_23690",
    "Last Name": "Hobday",
    "First Name": "Barry",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43275111": {
    "id": "item_10822",
    "Last Name": "Cicma",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43275170": {
    "id": "item_25365",
    "Last Name": "Roth",
    "First Name": "Zdenek",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43275242": {
    "id": "item_36218",
    "Last Name": "Cowles",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43276134": {
    "id": "item_10823",
    "Last Name": "Tedesco",
    "First Name": "Luigi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43276875": {
    "id": "item_12646",
    "Last Name": "Branco Santos",
    "First Name": "Filipe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43277083": {
    "id": "item_12647",
    "Last Name": "To",
    "First Name": "Ming Hin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43277392": {
    "id": "item_25366",
    "Last Name": "Temesio",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43277604": {
    "id": "item_36219",
    "Last Name": "Galvin",
    "First Name": "Sadie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43277725": {
    "id": "item_36220",
    "Last Name": "Mouttet",
    "First Name": "Marc",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43277758": {
    "id": "item_36221",
    "Last Name": "kalle",
    "First Name": "Anti",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43278597": {
    "id": "item_10824",
    "Last Name": "Wat",
    "First Name": "King Long",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43278787": {
    "id": "item_36222",
    "Last Name": "Schade",
    "First Name": "Jesper",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43279212": {
    "id": "item_12648",
    "Last Name": "Cascarina",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43279233": {
    "id": "item_10825",
    "Last Name": "Caiado",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43279574": {
    "id": "item_36223",
    "Last Name": "Gonzalez",
    "First Name": "Joey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43280232": {
    "id": "item_25367",
    "Last Name": "Love",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43280378": {
    "id": "item_25368",
    "Last Name": "TZIGKOS",
    "First Name": "FOTIOS",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43280420": {
    "id": "item_36224",
    "Last Name": "Svenningsen",
    "First Name": "Bill Liberty",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43280995": {
    "id": "item_36225",
    "Last Name": "Suarez",
    "First Name": "Mary Tawney",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43281212": {
    "id": "item_12649",
    "Last Name": "Padhi",
    "First Name": "Hrushikesh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43281251": {
    "id": "item_25369",
    "Last Name": "HUANG",
    "First Name": "SHINJIE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43281691": {
    "id": "item_25370",
    "Last Name": "A–ez Marcano",
    "First Name": "Maria Eugenia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43283039": {
    "id": "item_12650",
    "Last Name": "Koo",
    "First Name": "Wai Lun",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43283215": {
    "id": "item_36226",
    "Last Name": "Dukats",
    "First Name": "Martins",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43283305": {
    "id": "item_36227",
    "Last Name": "GLOVASA",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43283397": {
    "id": "item_10826",
    "Last Name": "Mackay",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43283949": {
    "id": "item_36228",
    "Last Name": "Barrezueta",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43284117": {
    "id": "item_25371",
    "Last Name": "Farley",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43284144": {
    "id": "item_10827",
    "Last Name": "White",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43284527": {
    "id": "item_12651",
    "Last Name": "Riestra Rivero",
    "First Name": "Emilio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43284791": {
    "id": "item_23691",
    "Last Name": "Itkin",
    "First Name": "Ilya",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43284874": {
    "id": "item_25372",
    "Last Name": "Goyal",
    "First Name": "Rita",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43285225": {
    "id": "item_36229",
    "Last Name": "Dal Busco",
    "First Name": "Serge",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43285380": {
    "id": "item_23692",
    "Last Name": "Fennah",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43285649": {
    "id": "item_10828",
    "Last Name": "Hanson",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43286170": {
    "id": "item_25373",
    "Last Name": "PALUCHOWSKI",
    "First Name": "JAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43287352": {
    "id": "item_25374",
    "Last Name": "Gallardo Gonzalez",
    "First Name": "Jorge Raul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43287974": {
    "id": "item_12652",
    "Last Name": "Vom",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43289162": {
    "id": "item_12653",
    "Last Name": "Dietz",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43289732": {
    "id": "item_25375",
    "Last Name": "Gomez",
    "First Name": "Johann",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43291146": {
    "id": "item_36230",
    "Last Name": "HOI",
    "First Name": "CHAO LONG",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43291841": {
    "id": "item_36231",
    "Last Name": "Lee",
    "First Name": "Sze Man",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43292728": {
    "id": "item_10829",
    "Last Name": "Jackson",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43293445": {
    "id": "item_36232",
    "Last Name": "Kusare",
    "First Name": "Sumit",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43293989": {
    "id": "item_10830",
    "Last Name": "Monti",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43294421": {
    "id": "item_25376",
    "Last Name": "Papanikolaou",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43295203": {
    "id": "item_25377",
    "Last Name": "Schluter",
    "First Name": "Calvin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43295385": {
    "id": "item_10831",
    "Last Name": "PARK",
    "First Name": "SUNGBAE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43295797": {
    "id": "item_23693",
    "Last Name": "Kindle",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43296822": {
    "id": "item_36233",
    "Last Name": "Fridiaz",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43296863": {
    "id": "item_10832",
    "Last Name": "Lloyd",
    "First Name": "Jaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43297291": {
    "id": "item_36234",
    "Last Name": "Bernaciak",
    "First Name": "Slawomir",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43297297": {
    "id": "item_25378",
    "Last Name": "Enger",
    "First Name": "Anne Gro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43297330": {
    "id": "item_25379",
    "Last Name": "TUNG",
    "First Name": "wai ming",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43297927": {
    "id": "item_12654",
    "Last Name": "Bonnafoux",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43298089": {
    "id": "item_23694",
    "Last Name": "Emett",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43298133": {
    "id": "item_10833",
    "Last Name": "Aquino",
    "First Name": "Pedro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43298353": {
    "id": "item_12655",
    "Last Name": "Bšrjesson",
    "First Name": "Mikael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43298698": {
    "id": "item_36235",
    "Last Name": "Pattnayak",
    "First Name": "Santosh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43300847": {
    "id": "item_25380",
    "Last Name": "Van Noten",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43301054": {
    "id": "item_36236",
    "Last Name": "Lee",
    "First Name": "Maurice",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43302311": {
    "id": "item_36237",
    "Last Name": "Paradis",
    "First Name": "RŽjean",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43302478": {
    "id": "item_36238",
    "Last Name": "Lawless",
    "First Name": "Brenden",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43303782": {
    "id": "item_25381",
    "Last Name": "Beltran noriega",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43305754": {
    "id": "item_25382",
    "Last Name": "VARGAS RENDON",
    "First Name": "ROBERTO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43307381": {
    "id": "item_25383",
    "Last Name": "Vu",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43308633": {
    "id": "item_36239",
    "Last Name": "Rubin",
    "First Name": "Maxwell",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43309636": {
    "id": "item_12656",
    "Last Name": "Mayorga",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43309993": {
    "id": "item_12657",
    "Last Name": "Shpokiavichius",
    "First Name": "Arnas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43310061": {
    "id": "item_23695",
    "Last Name": "Desaulniers",
    "First Name": "Jean-Franc_ois",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43311831": {
    "id": "item_36240",
    "Last Name": "Van Daele",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43312912": {
    "id": "item_25384",
    "Last Name": "Norambuena",
    "First Name": "Hector",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43313721": {
    "id": "item_25385",
    "Last Name": "mackenzie-heyboer",
    "First Name": "mariska",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43316388": {
    "id": "item_10834",
    "Last Name": "Ortiz Lopez",
    "First Name": "Luis Angel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43319671": {
    "id": "item_36241",
    "Last Name": "Andren",
    "First Name": "Lars Thomas Robert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43321587": {
    "id": "item_25386",
    "Last Name": "Tindall",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43321936": {
    "id": "item_36242",
    "Last Name": "Hespel",
    "First Name": "Damien",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43322476": {
    "id": "item_25387",
    "Last Name": "Benjakul",
    "First Name": "Pinyo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43322485": {
    "id": "item_23696",
    "Last Name": "Lenicky",
    "First Name": "Dalibor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43323191": {
    "id": "item_25388",
    "Last Name": "King",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43323207": {
    "id": "item_25389",
    "Last Name": "Gjerde Ong",
    "First Name": "Jennie Jing",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43323632": {
    "id": "item_12658",
    "Last Name": "Moretti",
    "First Name": "Filippo Andrea",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43324169": {
    "id": "item_36243",
    "Last Name": "Gimenez",
    "First Name": "Juan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43324207": {
    "id": "item_25390",
    "Last Name": "Novales",
    "First Name": "Ariane Odessy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43325230": {
    "id": "item_23697",
    "Last Name": "Rotem",
    "First Name": "Sagi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43326503": {
    "id": "item_25391",
    "Last Name": "MORANDI",
    "First Name": "william",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43326651": {
    "id": "item_23698",
    "Last Name": "Thomerson",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43326782": {
    "id": "item_36244",
    "Last Name": "Baldock",
    "First Name": "Clair",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43336248": {
    "id": "item_36245",
    "Last Name": "Joergensen",
    "First Name": "Trude katrin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43337427": {
    "id": "item_25392",
    "Last Name": "TREMBLAY",
    "First Name": "DOMINIQUE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43342222": {
    "id": "item_12659",
    "Last Name": "Schroeder-Lam",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43342247": {
    "id": "item_12660",
    "Last Name": "Lam",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43349594": {
    "id": "item_23699",
    "Last Name": "BETARIA",
    "First Name": "JELITA NOVALENTINA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43352016": {
    "id": "item_25393",
    "Last Name": "Pacaleu",
    "First Name": "Oleg",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43353400": {
    "id": "item_36246",
    "Last Name": "Johannesen",
    "First Name": "Ruth",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43356165": {
    "id": "item_23700",
    "Last Name": "Chan",
    "First Name": "Tsz Kin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43357838": {
    "id": "item_25394",
    "Last Name": "Olsson",
    "First Name": "Lars",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43358050": {
    "id": "item_12661",
    "Last Name": "Opris",
    "First Name": "Alexandru",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43359257": {
    "id": "item_10835",
    "Last Name": "Mashita",
    "First Name": "Sammy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43362229": {
    "id": "item_23701",
    "Last Name": "Lopez",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43364008": {
    "id": "item_25395",
    "Last Name": "HALACOGLU",
    "First Name": "TOLGA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43364400": {
    "id": "item_25396",
    "Last Name": "Galo",
    "First Name": "Harold",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43368582": {
    "id": "item_12662",
    "Last Name": "Cranfield",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43369198": {
    "id": "item_10836",
    "Last Name": "Gibson",
    "First Name": "Travis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43370118": {
    "id": "item_36247",
    "Last Name": "Hart",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43370142": {
    "id": "item_36248",
    "Last Name": "Owodunni",
    "First Name": "Oluwafemi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43370377": {
    "id": "item_36249",
    "Last Name": "Blackbourn",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43370553": {
    "id": "item_23702",
    "Last Name": "McIntyre",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43370627": {
    "id": "item_10837",
    "Last Name": "Gordon",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43371003": {
    "id": "item_25397",
    "Last Name": "Mallia",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43371174": {
    "id": "item_10838",
    "Last Name": "Smith",
    "First Name": "Justin Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43371787": {
    "id": "item_10839",
    "Last Name": "Punpanichgul",
    "First Name": "Kamalinphol",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43372797": {
    "id": "item_12663",
    "Last Name": "Hoban (nee Edmondson)",
    "First Name": "Tracie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43373118": {
    "id": "item_36250",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43373679": {
    "id": "item_10840",
    "Last Name": "Kuataiuly",
    "First Name": "Yerengaiyp",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374204": {
    "id": "item_12664",
    "Last Name": "Telemachou",
    "First Name": "Pericles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374305": {
    "id": "item_10841",
    "Last Name": "Friend",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374430": {
    "id": "item_25398",
    "Last Name": "TAKAO",
    "First Name": "SHUN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374612": {
    "id": "item_36251",
    "Last Name": "Lim",
    "First Name": "Cindy Halim",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374680": {
    "id": "item_23703",
    "Last Name": "HERRERO MATEO",
    "First Name": "CATALINA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374851": {
    "id": "item_10842",
    "Last Name": "Hundt",
    "First Name": "Matthias",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374901": {
    "id": "item_23704",
    "Last Name": "Quanz",
    "First Name": "Manfred",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43374942": {
    "id": "item_25399",
    "Last Name": "Franiatte",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375034": {
    "id": "item_36252",
    "Last Name": "Krueger",
    "First Name": "Heike",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375087": {
    "id": "item_36253",
    "Last Name": "Jacob",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375088": {
    "id": "item_25400",
    "Last Name": "Hoefler",
    "First Name": "Fritz",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375113": {
    "id": "item_10843",
    "Last Name": "Heritage",
    "First Name": "Ewan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375200": {
    "id": "item_12665",
    "Last Name": "Hetzel",
    "First Name": "Soeren",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375279": {
    "id": "item_23705",
    "Last Name": "Baer",
    "First Name": "Romulus",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375341": {
    "id": "item_25401",
    "Last Name": "Becker",
    "First Name": "Heinrich",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375370": {
    "id": "item_36254",
    "Last Name": "Staubach",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375383": {
    "id": "item_36255",
    "Last Name": "Bernhard",
    "First Name": "Sonja",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375442": {
    "id": "item_36256",
    "Last Name": "Seehofner",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375762": {
    "id": "item_36257",
    "Last Name": "Poll",
    "First Name": "Simon Andreas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375767": {
    "id": "item_23706",
    "Last Name": "Cortes Estevez",
    "First Name": "Jonny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375893": {
    "id": "item_10844",
    "Last Name": "Nishimura",
    "First Name": "Akira",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43375913": {
    "id": "item_12666",
    "Last Name": "O'Bryan",
    "First Name": "Eamon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43376239": {
    "id": "item_12667",
    "Last Name": "kita",
    "First Name": "tomohiko",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43376567": {
    "id": "item_25402",
    "Last Name": "DŸrr",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43376723": {
    "id": "item_10845",
    "Last Name": "Digges",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43377203": {
    "id": "item_36258",
    "Last Name": "Carrera",
    "First Name": "Bruna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43377346": {
    "id": "item_10846",
    "Last Name": "Newman",
    "First Name": "J",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43380302": {
    "id": "item_12668",
    "Last Name": "Wright",
    "First Name": "Harriet",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43380412": {
    "id": "item_25403",
    "Last Name": "Ammer",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43381702": {
    "id": "item_12669",
    "Last Name": "Astigarraga",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43381714": {
    "id": "item_10847",
    "Last Name": "Rock",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43382050": {
    "id": "item_12670",
    "Last Name": "MŸller",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43382144": {
    "id": "item_10848",
    "Last Name": "Geerdes",
    "First Name": "Dominik",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43382198": {
    "id": "item_36259",
    "Last Name": "Martin",
    "First Name": "Antje",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43382607": {
    "id": "item_23707",
    "Last Name": "Dubois",
    "First Name": "Anick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43383646": {
    "id": "item_10849",
    "Last Name": "Nogotkov",
    "First Name": "Vladislav",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43384459": {
    "id": "item_36260",
    "Last Name": "Minne",
    "First Name": "Myriam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43386308": {
    "id": "item_36261",
    "Last Name": "Langendorf",
    "First Name": "Steffen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43386439": {
    "id": "item_23708",
    "Last Name": "Huynh",
    "First Name": "Tiffanie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43386548": {
    "id": "item_10850",
    "Last Name": "Wojcik",
    "First Name": "Slawomir",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43386843": {
    "id": "item_12671",
    "Last Name": "Wa_niewska",
    "First Name": "Karolina",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43387010": {
    "id": "item_12672",
    "Last Name": "Kurtyka",
    "First Name": "Andrzej",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43387017": {
    "id": "item_25404",
    "Last Name": "Maslanka",
    "First Name": "Tomasz",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43387042": {
    "id": "item_12673",
    "Last Name": "Janta",
    "First Name": "Marek",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43387433": {
    "id": "item_25405",
    "Last Name": "Staubach",
    "First Name": "Jochen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43387816": {
    "id": "item_25406",
    "Last Name": "Moisson",
    "First Name": "SalomŽ",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43388179": {
    "id": "item_23709",
    "Last Name": "Steele",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43388185": {
    "id": "item_12674",
    "Last Name": "Zmuda",
    "First Name": "Krzysztof",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43388536": {
    "id": "item_23710",
    "Last Name": "Zinkiewicz",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43388573": {
    "id": "item_36262",
    "Last Name": "Larsen",
    "First Name": "Vera",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43389932": {
    "id": "item_25407",
    "Last Name": "Faria",
    "First Name": "Marcielle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43391050": {
    "id": "item_36263",
    "Last Name": "Hazell",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43395914": {
    "id": "item_25408",
    "Last Name": "J—_wik",
    "First Name": "Grzegorz",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43397044": {
    "id": "item_25409",
    "Last Name": "Rodrigues",
    "First Name": "Gustavo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43397158": {
    "id": "item_10851",
    "Last Name": "Heaney",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43397587": {
    "id": "item_23711",
    "Last Name": "Hong",
    "First Name": "Camila",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43398295": {
    "id": "item_25410",
    "Last Name": "Coltman",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43398315": {
    "id": "item_25411",
    "Last Name": "Buchan",
    "First Name": "Judith",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43398449": {
    "id": "item_12675",
    "Last Name": "Aristizabal",
    "First Name": "Julio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43424025": {
    "id": "item_12676",
    "Last Name": "Chidlow",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43427299": {
    "id": "item_12677",
    "Last Name": "Chan",
    "First Name": "Sik Ning",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43430178": {
    "id": "item_12678",
    "Last Name": "Wu",
    "First Name": "Tik Ki Dicky",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43430445": {
    "id": "item_25412",
    "Last Name": "Orts",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43430916": {
    "id": "item_25413",
    "Last Name": "Haese",
    "First Name": "Royce",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43430967": {
    "id": "item_25414",
    "Last Name": "Lawrence",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43432133": {
    "id": "item_12679",
    "Last Name": "Flecker",
    "First Name": "Bobby",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43432198": {
    "id": "item_12680",
    "Last Name": "YOO",
    "First Name": "SUNG WON",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43432444": {
    "id": "item_10852",
    "Last Name": "Wehbe",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43432605": {
    "id": "item_12681",
    "Last Name": "Couvalias",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43432767": {
    "id": "item_36264",
    "Last Name": "Armitage",
    "First Name": "Kari",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43433538": {
    "id": "item_25415",
    "Last Name": "Gorzel",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43433595": {
    "id": "item_25416",
    "Last Name": "Sherwood-Berndt",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43434978": {
    "id": "item_23712",
    "Last Name": "Weickinger",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435178": {
    "id": "item_10853",
    "Last Name": "Salyubayev",
    "First Name": "Marat",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435323": {
    "id": "item_12682",
    "Last Name": "TSUJI",
    "First Name": "MAYUKO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435332": {
    "id": "item_25417",
    "Last Name": "Praewpraowong",
    "First Name": "Nathanont",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43435581": {
    "id": "item_10854",
    "Last Name": "CHIANG",
    "First Name": "YEN-LUN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436016": {
    "id": "item_23713",
    "Last Name": "NAGANO",
    "First Name": "MASASHI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436409": {
    "id": "item_36265",
    "Last Name": "PACLAWSKI",
    "First Name": "PAWEL",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436703": {
    "id": "item_23714",
    "Last Name": "Fucile",
    "First Name": "Fabrizio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43436886": {
    "id": "item_25418",
    "Last Name": "medeiros",
    "First Name": "mario jose",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437312": {
    "id": "item_23715",
    "Last Name": "Kalikov",
    "First Name": "Serik",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437420": {
    "id": "item_23716",
    "Last Name": "Rossi",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437425": {
    "id": "item_10855",
    "Last Name": "Piazza",
    "First Name": "Tommaso",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437501": {
    "id": "item_12683",
    "Last Name": "Doi",
    "First Name": "Yasuhiko",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437504": {
    "id": "item_25419",
    "Last Name": "Del Prete",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437745": {
    "id": "item_36266",
    "Last Name": "Mvula",
    "First Name": "Aubrey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437921": {
    "id": "item_25420",
    "Last Name": "Juras",
    "First Name": "Juraj",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437930": {
    "id": "item_12684",
    "Last Name": "Bishop",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437933": {
    "id": "item_36267",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43437942": {
    "id": "item_23717",
    "Last Name": "CECCHINI",
    "First Name": "GABRIELE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43438216": {
    "id": "item_25421",
    "Last Name": "Crow",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43438538": {
    "id": "item_23718",
    "Last Name": "vitri",
    "First Name": "roberta",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43438712": {
    "id": "item_36268",
    "Last Name": "Zeschky",
    "First Name": "Walter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43439170": {
    "id": "item_12685",
    "Last Name": "Teuscher",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43439275": {
    "id": "item_23719",
    "Last Name": "Ratto Ferreira Leite",
    "First Name": "Gustavo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43440267": {
    "id": "item_23720",
    "Last Name": "Del Quondam",
    "First Name": "Mauro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43440268": {
    "id": "item_23721",
    "Last Name": "D'Oria",
    "First Name": "Martina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43440526": {
    "id": "item_23722",
    "Last Name": "PALOMBARO",
    "First Name": "ELENA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43441155": {
    "id": "item_10856",
    "Last Name": "Louvet",
    "First Name": "Dorian",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43441324": {
    "id": "item_25422",
    "Last Name": "Favale",
    "First Name": "Antonella",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43441442": {
    "id": "item_10857",
    "Last Name": "Amieva",
    "First Name": "Esteban",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43442499": {
    "id": "item_10858",
    "Last Name": "VEE",
    "First Name": "JEAN DANIEL",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43442735": {
    "id": "item_10859",
    "Last Name": "VEE",
    "First Name": "MICHEL JEAN PIERRE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43443637": {
    "id": "item_36269",
    "Last Name": "Hillmer",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43444834": {
    "id": "item_23723",
    "Last Name": "Keith",
    "First Name": "Randall",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43444951": {
    "id": "item_12686",
    "Last Name": "Miranda Ojeda",
    "First Name": "Felipe Alberto",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43445048": {
    "id": "item_36270",
    "Last Name": "Bronisefski",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43445407": {
    "id": "item_12687",
    "Last Name": "Gro§",
    "First Name": "Markus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43446022": {
    "id": "item_36271",
    "Last Name": "Minetto",
    "First Name": "Graziella",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43447047": {
    "id": "item_23724",
    "Last Name": "Angelini",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43447833": {
    "id": "item_23725",
    "Last Name": "Ricci",
    "First Name": "Cristina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43448064": {
    "id": "item_12688",
    "Last Name": "Barrio",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43448154": {
    "id": "item_10860",
    "Last Name": "TAKANO",
    "First Name": "WALTER",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43448876": {
    "id": "item_36272",
    "Last Name": "Jus",
    "First Name": "Romano",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43448988": {
    "id": "item_25423",
    "Last Name": "Keidaish",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43449072": {
    "id": "item_25424",
    "Last Name": "Froncillo",
    "First Name": "Myrian Adriana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43449380": {
    "id": "item_12689",
    "Last Name": "Paolotti",
    "First Name": "Simone",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43449721": {
    "id": "item_36273",
    "Last Name": "Johnston",
    "First Name": "Jeffrey Singleton",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43453701": {
    "id": "item_25425",
    "Last Name": "Carneri",
    "First Name": "Giorgio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43458365": {
    "id": "item_10861",
    "Last Name": "Arantes",
    "First Name": "Fabiano CŽsar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43481642": {
    "id": "item_12690",
    "Last Name": "Tallis",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43482024": {
    "id": "item_25426",
    "Last Name": "Klashovski",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43482214": {
    "id": "item_25427",
    "Last Name": "Garces",
    "First Name": "Darwin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43482386": {
    "id": "item_25428",
    "Last Name": "Keat",
    "First Name": "Jemma",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43485086": {
    "id": "item_12691",
    "Last Name": "MANGEON",
    "First Name": "MATHIEU",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43489398": {
    "id": "item_12692",
    "Last Name": "Trethowan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43489404": {
    "id": "item_36274",
    "Last Name": "KHOUMA",
    "First Name": "Cheikh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43489730": {
    "id": "item_23726",
    "Last Name": "Standish",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43489782": {
    "id": "item_10862",
    "Last Name": "PASSAMONTI",
    "First Name": "SIMONE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43489964": {
    "id": "item_36275",
    "Last Name": "Calla",
    "First Name": "Mats",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490238": {
    "id": "item_10863",
    "Last Name": "Taccaliti",
    "First Name": "Fabio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490436": {
    "id": "item_25429",
    "Last Name": "Rangachary",
    "First Name": "Vasu",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490513": {
    "id": "item_36276",
    "Last Name": "Cremona",
    "First Name": "Giulia",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490754": {
    "id": "item_25430",
    "Last Name": "Nakajima",
    "First Name": "Masaki",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490946": {
    "id": "item_23727",
    "Last Name": "Gavin",
    "First Name": "Mary",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43490975": {
    "id": "item_10864",
    "Last Name": "Dillon",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43491185": {
    "id": "item_10865",
    "Last Name": "Pahlman",
    "First Name": "Martti",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43491446": {
    "id": "item_10866",
    "Last Name": "DEMOULIN",
    "First Name": "VINCENT",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43491604": {
    "id": "item_23728",
    "Last Name": "Elliott",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43492208": {
    "id": "item_10867",
    "Last Name": "Morisi",
    "First Name": "Enrico",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43492658": {
    "id": "item_25431",
    "Last Name": "Seck",
    "First Name": "Yannick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43493975": {
    "id": "item_12693",
    "Last Name": "gomez fraire",
    "First Name": "cristiano javier",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43494121": {
    "id": "item_23729",
    "Last Name": "CECCHINI",
    "First Name": "GIUSEPPE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43494372": {
    "id": "item_25432",
    "Last Name": "Kennedy",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43494405": {
    "id": "item_36277",
    "Last Name": "BROWN",
    "First Name": "KEVIN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43494607": {
    "id": "item_12694",
    "Last Name": "Klever",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43495760": {
    "id": "item_25433",
    "Last Name": "NITARSKA",
    "First Name": "Katarzyna",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43496042": {
    "id": "item_12695",
    "Last Name": "Marc",
    "First Name": "Chong Chun Ming",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43496375": {
    "id": "item_23730",
    "Last Name": "ROBERT",
    "First Name": "KATHERINE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43496561": {
    "id": "item_25434",
    "Last Name": "Doctor",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43497029": {
    "id": "item_25435",
    "Last Name": "Bououghroum",
    "First Name": "Ali",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43499617": {
    "id": "item_25436",
    "Last Name": "Watson",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43500023": {
    "id": "item_12696",
    "Last Name": "McCutcheon",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43500108": {
    "id": "item_12697",
    "Last Name": "Letonnelier",
    "First Name": "Julien",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43500403": {
    "id": "item_23731",
    "Last Name": "Taylor",
    "First Name": "Vinnett",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43501401": {
    "id": "item_36278",
    "Last Name": "Gallegos",
    "First Name": "Josue",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43502048": {
    "id": "item_12698",
    "Last Name": "Coggins",
    "First Name": "Andre",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43502179": {
    "id": "item_10868",
    "Last Name": "Redmond",
    "First Name": "Iain",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43502787": {
    "id": "item_10869",
    "Last Name": "Verleih",
    "First Name": "Gerrit",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43503679": {
    "id": "item_12699",
    "Last Name": "Parsay Ganjavar",
    "First Name": "Mahdi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43507280": {
    "id": "item_12700",
    "Last Name": "Dalle",
    "First Name": "Mathieu",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43507832": {
    "id": "item_36279",
    "Last Name": "Corrigan",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43508499": {
    "id": "item_23732",
    "Last Name": "Chi",
    "First Name": "Janet",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43508632": {
    "id": "item_12701",
    "Last Name": "CANSECO ROMERO",
    "First Name": "GERARDO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43508914": {
    "id": "item_12702",
    "Last Name": "Rivera",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43509109": {
    "id": "item_12703",
    "Last Name": "Vidal",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43509781": {
    "id": "item_36280",
    "Last Name": "Kelly",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43511180": {
    "id": "item_36281",
    "Last Name": "Surahman",
    "First Name": "Candra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43512405": {
    "id": "item_36282",
    "Last Name": "Vucetic",
    "First Name": "Renee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43513478": {
    "id": "item_23733",
    "Last Name": "Matthews",
    "First Name": "Russell",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43514411": {
    "id": "item_25437",
    "Last Name": "Nowrin",
    "First Name": "Iffath",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43515212": {
    "id": "item_12704",
    "Last Name": "Fuller",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43516679": {
    "id": "item_36283",
    "Last Name": "Lam",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43516767": {
    "id": "item_25438",
    "Last Name": "Salmon",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43516910": {
    "id": "item_25439",
    "Last Name": "Air",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43517179": {
    "id": "item_23734",
    "Last Name": "NUGRAHA",
    "First Name": "ADITYA YOGA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43519440": {
    "id": "item_10870",
    "Last Name": "WENJIE",
    "First Name": "XIA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43519646": {
    "id": "item_10871",
    "Last Name": "Martyan",
    "First Name": "Teguh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43519874": {
    "id": "item_36284",
    "Last Name": "Trillana",
    "First Name": "Diosdado",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43520440": {
    "id": "item_12705",
    "Last Name": "TZOULIOS",
    "First Name": "CHRISTODOULOS",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43520782": {
    "id": "item_10872",
    "Last Name": "Schwarz",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43521034": {
    "id": "item_23735",
    "Last Name": "Lesmana",
    "First Name": "Dolly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43521881": {
    "id": "item_25440",
    "Last Name": "zanini",
    "First Name": "tommaso",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43522199": {
    "id": "item_12706",
    "Last Name": "Miller",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43522273": {
    "id": "item_23736",
    "Last Name": "Choi",
    "First Name": "Chi Wai",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43522374": {
    "id": "item_25441",
    "Last Name": "Streletzki",
    "First Name": "Christoph",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43522814": {
    "id": "item_36285",
    "Last Name": "She",
    "First Name": "Jian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523177": {
    "id": "item_10873",
    "Last Name": "UBERTAZZI",
    "First Name": "TOMMASO MARIA GIOVANNI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523253": {
    "id": "item_23737",
    "Last Name": "SPADA",
    "First Name": "LAURA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523307": {
    "id": "item_25442",
    "Last Name": "Charaklias",
    "First Name": "Napoleon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523331": {
    "id": "item_25443",
    "Last Name": "SHIINO",
    "First Name": "KEIKO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523409": {
    "id": "item_23738",
    "Last Name": "Lumbroso",
    "First Name": "Flynn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523748": {
    "id": "item_12707",
    "Last Name": "Brooke",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523847": {
    "id": "item_25444",
    "Last Name": "Kadji Kalabang",
    "First Name": "Roger",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523912": {
    "id": "item_10874",
    "Last Name": "Kostulas",
    "First Name": "Nikolaos",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43523955": {
    "id": "item_10875",
    "Last Name": "Dexter",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43524576": {
    "id": "item_10876",
    "Last Name": "Augutis",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43524917": {
    "id": "item_10877",
    "Last Name": "Sacre",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43524948": {
    "id": "item_25445",
    "Last Name": "O'Connor",
    "First Name": "Delia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43525167": {
    "id": "item_10878",
    "Last Name": "Pegorari",
    "First Name": "Lorenzo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43525840": {
    "id": "item_36286",
    "Last Name": "Zhang",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43526016": {
    "id": "item_36287",
    "Last Name": "Lattasch",
    "First Name": "Klaus",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43527030": {
    "id": "item_36288",
    "Last Name": "Jones",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43527534": {
    "id": "item_25446",
    "Last Name": "Ferguson",
    "First Name": "Jonny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43527610": {
    "id": "item_10879",
    "Last Name": "Osmond",
    "First Name": "Danai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43529879": {
    "id": "item_36289",
    "Last Name": "Brown",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43530240": {
    "id": "item_12708",
    "Last Name": "Argyrou",
    "First Name": "Kyriacos",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43530696": {
    "id": "item_23739",
    "Last Name": "Belleville",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43530785": {
    "id": "item_36290",
    "Last Name": "Vernersdottir",
    "First Name": "Herdis",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43530957": {
    "id": "item_36291",
    "Last Name": "Petersen",
    "First Name": "Tanja",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43532006": {
    "id": "item_36292",
    "Last Name": "Round",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43534262": {
    "id": "item_25447",
    "Last Name": "Plummer",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43534895": {
    "id": "item_23740",
    "Last Name": "Cowie",
    "First Name": "Graham",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43534992": {
    "id": "item_23741",
    "Last Name": "Cowie",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535512": {
    "id": "item_10880",
    "Last Name": "Cruz",
    "First Name": "Maccartney",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535576": {
    "id": "item_23742",
    "Last Name": "Moritz",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535739": {
    "id": "item_12709",
    "Last Name": "Meneghini",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43535879": {
    "id": "item_10881",
    "Last Name": "Wesemann",
    "First Name": "Duane",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43536072": {
    "id": "item_36293",
    "Last Name": "Schneider",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43536766": {
    "id": "item_36294",
    "Last Name": "Hodgkinson",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43537322": {
    "id": "item_25448",
    "Last Name": "Monteiro",
    "First Name": "Scotty",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43537457": {
    "id": "item_23743",
    "Last Name": "Ramirez",
    "First Name": "Ruben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43538171": {
    "id": "item_12710",
    "Last Name": "Vilar Llantada",
    "First Name": "Juan Pablo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43538273": {
    "id": "item_25449",
    "Last Name": "Harada",
    "First Name": "Norihito",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43539289": {
    "id": "item_10882",
    "Last Name": "Park",
    "First Name": "Min Jung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43539476": {
    "id": "item_23744",
    "Last Name": "O'Neill",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43540670": {
    "id": "item_10883",
    "Last Name": "Neilson",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43540690": {
    "id": "item_12711",
    "Last Name": "Craig",
    "First Name": "Kernow",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43541677": {
    "id": "item_23745",
    "Last Name": "Perry",
    "First Name": "Mary Margaret",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43544239": {
    "id": "item_10884",
    "Last Name": "Huang",
    "First Name": "YU-HSUAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43544583": {
    "id": "item_23746",
    "Last Name": "Mayson",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43544611": {
    "id": "item_23747",
    "Last Name": "Mayson",
    "First Name": "Cheryl Teresa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43544881": {
    "id": "item_12712",
    "Last Name": "Hayden",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545002": {
    "id": "item_10885",
    "Last Name": "Phelan",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545114": {
    "id": "item_25450",
    "Last Name": "Choi",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43545167": {
    "id": "item_10886",
    "Last Name": "Hodgson",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43546163": {
    "id": "item_10887",
    "Last Name": "McCarthy",
    "First Name": "Mary",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43546201": {
    "id": "item_36295",
    "Last Name": "Oudet",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43546371": {
    "id": "item_23748",
    "Last Name": "Hayward",
    "First Name": "Kurt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43546752": {
    "id": "item_25451",
    "Last Name": "Tindall",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43546897": {
    "id": "item_36296",
    "Last Name": "Gilg",
    "First Name": "Susanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43546948": {
    "id": "item_25452",
    "Last Name": "Oyama",
    "First Name": "Chiyuki",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43547150": {
    "id": "item_10888",
    "Last Name": "Arthur",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43547346": {
    "id": "item_23749",
    "Last Name": "Omanio",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43547355": {
    "id": "item_36297",
    "Last Name": "Szendey",
    "First Name": "Maura",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43547382": {
    "id": "item_25453",
    "Last Name": "Lewis",
    "First Name": "Rashida",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43548741": {
    "id": "item_25454",
    "Last Name": "DeVellis",
    "First Name": "Denise",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43552106": {
    "id": "item_12713",
    "Last Name": "NGUYEN VAN LANG",
    "First Name": "Michel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43552221": {
    "id": "item_23750",
    "Last Name": "Gonzalez Cabrera",
    "First Name": "Wilfredo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43554753": {
    "id": "item_36298",
    "Last Name": "Akula",
    "First Name": "Pavan Kumar",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43555899": {
    "id": "item_25455",
    "Last Name": "Thomas",
    "First Name": "Reginald",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43556486": {
    "id": "item_36299",
    "Last Name": "Lombard",
    "First Name": "Annabel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43557338": {
    "id": "item_36300",
    "Last Name": "Pillamari",
    "First Name": "Rajesh",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43557489": {
    "id": "item_36301",
    "Last Name": "Hofmann",
    "First Name": "Anke",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43557600": {
    "id": "item_23751",
    "Last Name": "Buettner",
    "First Name": "Timo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43557637": {
    "id": "item_36302",
    "Last Name": "Robinson",
    "First Name": "Clare",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43558042": {
    "id": "item_36303",
    "Last Name": "Hanson",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43559276": {
    "id": "item_10889",
    "Last Name": "Cortinas Vidal",
    "First Name": "Jesus Armando",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43559614": {
    "id": "item_25456",
    "Last Name": "Garza",
    "First Name": "Edgar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43559641": {
    "id": "item_23752",
    "Last Name": "Dell'Anno",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43559648": {
    "id": "item_36304",
    "Last Name": "Hewitt",
    "First Name": "Josalyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43559701": {
    "id": "item_25457",
    "Last Name": "Villarreal",
    "First Name": "Martin Eduardo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43560706": {
    "id": "item_12714",
    "Last Name": "Haik",
    "First Name": "Romina",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43561485": {
    "id": "item_36305",
    "Last Name": "Herdoiza Morales",
    "First Name": "Danny Yelena",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43564033": {
    "id": "item_23753",
    "Last Name": "Huston",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43564585": {
    "id": "item_12715",
    "Last Name": "Kwok",
    "First Name": "Fuk Ping",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43565048": {
    "id": "item_25458",
    "Last Name": "Tam",
    "First Name": "YukFong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43566008": {
    "id": "item_12716",
    "Last Name": "Davies",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43566414": {
    "id": "item_10890",
    "Last Name": "Garza",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43566876": {
    "id": "item_25459",
    "Last Name": "Haire",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43566948": {
    "id": "item_25460",
    "Last Name": "WANG",
    "First Name": "YONGXU",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43567649": {
    "id": "item_12717",
    "Last Name": "__",
    "First Name": "___",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43567792": {
    "id": "item_36306",
    "Last Name": "George",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43568699": {
    "id": "item_36307",
    "Last Name": "Wee",
    "First Name": "Hui Kan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43569945": {
    "id": "item_36308",
    "Last Name": "Hutchinson",
    "First Name": "Niall",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43570855": {
    "id": "item_36309",
    "Last Name": "Schreiber",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43571354": {
    "id": "item_10891",
    "Last Name": "MEZIERE",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43571423": {
    "id": "item_23754",
    "Last Name": "Pettman",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43574055": {
    "id": "item_25461",
    "Last Name": "ramon",
    "First Name": "miguel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43574596": {
    "id": "item_25462",
    "Last Name": "Carty",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43577384": {
    "id": "item_36310",
    "Last Name": "Daley",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43577818": {
    "id": "item_12718",
    "Last Name": "Stuart",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43580195": {
    "id": "item_36311",
    "Last Name": "Forrest",
    "First Name": "Graeme",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43582025": {
    "id": "item_25463",
    "Last Name": "Powell",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43585146": {
    "id": "item_25464",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43586001": {
    "id": "item_36312",
    "Last Name": "Hiyama",
    "First Name": "Tamaki",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43586689": {
    "id": "item_36313",
    "Last Name": "Schwarzfischer",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43588079": {
    "id": "item_25465",
    "Last Name": "Nadjmi",
    "First Name": "Nasser",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43592067": {
    "id": "item_12719",
    "Last Name": "Novakovskyi",
    "First Name": "Dmytro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43593480": {
    "id": "item_36314",
    "Last Name": "PATRON MUKUL",
    "First Name": "RUSSEL ANTONIO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43598690": {
    "id": "item_23755",
    "Last Name": "McKinnon",
    "First Name": "Brent",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43598770": {
    "id": "item_12720",
    "Last Name": "Fasih ul Saleh",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43599442": {
    "id": "item_12721",
    "Last Name": "Alassmi",
    "First Name": "Rami",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43599842": {
    "id": "item_25466",
    "Last Name": "Tyler-Whiteman",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600420": {
    "id": "item_36315",
    "Last Name": "Brodie",
    "First Name": "Suzanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600425": {
    "id": "item_36316",
    "Last Name": "Greensitt",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600569": {
    "id": "item_25467",
    "Last Name": "Yazbek",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600685": {
    "id": "item_36317",
    "Last Name": "Waalkens",
    "First Name": "Vangana",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43600817": {
    "id": "item_36318",
    "Last Name": "Amyes",
    "First Name": "Errol Victor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43602336": {
    "id": "item_12722",
    "Last Name": "Dosovic",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43602485": {
    "id": "item_12723",
    "Last Name": "Faria",
    "First Name": "Jonas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43604291": {
    "id": "item_12724",
    "Last Name": "Sarabia Aragon",
    "First Name": "Marco Antonio",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43605292": {
    "id": "item_23756",
    "Last Name": "Veblen",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43607085": {
    "id": "item_36319",
    "Last Name": "Hutchinson",
    "First Name": "Ruari",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43610963": {
    "id": "item_10892",
    "Last Name": "Fernandez",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43611299": {
    "id": "item_10893",
    "Last Name": "Meakin",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43611758": {
    "id": "item_36320",
    "Last Name": "Campbell",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43612205": {
    "id": "item_25468",
    "Last Name": "Bry",
    "First Name": "Romain",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43612380": {
    "id": "item_36321",
    "Last Name": "Carter",
    "First Name": "M Nancy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43613848": {
    "id": "item_25469",
    "Last Name": "Tse",
    "First Name": "Tin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43613870": {
    "id": "item_10894",
    "Last Name": "Holdsworth",
    "First Name": "Kenny",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43614266": {
    "id": "item_12725",
    "Last Name": "Fulton",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43614494": {
    "id": "item_10895",
    "Last Name": "DONIS",
    "First Name": "FERNANDO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43614884": {
    "id": "item_10896",
    "Last Name": "Tokunaga",
    "First Name": "Yasuhiro",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43615193": {
    "id": "item_36322",
    "Last Name": "Rodeka",
    "First Name": "Chanelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43616249": {
    "id": "item_36323",
    "Last Name": "KITAGAWA",
    "First Name": "NORIKAZU",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43617095": {
    "id": "item_25470",
    "Last Name": "Jones",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43617505": {
    "id": "item_12726",
    "Last Name": "Carrizalez Escobedo",
    "First Name": "Omar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43618420": {
    "id": "item_23757",
    "Last Name": "Hemmerdinger",
    "First Name": "Jean Philippe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43620159": {
    "id": "item_25471",
    "Last Name": "Walsh",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43620264": {
    "id": "item_36324",
    "Last Name": "Watson",
    "First Name": "Gilbert",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43623442": {
    "id": "item_12727",
    "Last Name": "Janzen",
    "First Name": "Gerhard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43624025": {
    "id": "item_10897",
    "Last Name": "Roocke",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43624143": {
    "id": "item_25472",
    "Last Name": "Kerr",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43624677": {
    "id": "item_25473",
    "Last Name": "Evans",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43625135": {
    "id": "item_23758",
    "Last Name": "PE„A",
    "First Name": "MANUEL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43625585": {
    "id": "item_23759",
    "Last Name": "RODRIGUEZ PEREZ",
    "First Name": "ANTONIO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43627125": {
    "id": "item_36325",
    "Last Name": "Kohl Junior",
    "First Name": "Enio Nelson",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43629062": {
    "id": "item_25474",
    "Last Name": "Wright",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43629073": {
    "id": "item_36326",
    "Last Name": "Da Costa",
    "First Name": "Izenir",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43629082": {
    "id": "item_36327",
    "Last Name": "Dumaual",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43630827": {
    "id": "item_12728",
    "Last Name": "Matos",
    "First Name": "Angelo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43633520": {
    "id": "item_10898",
    "Last Name": "ruggieri",
    "First Name": "carlo alberto",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43635326": {
    "id": "item_36328",
    "Last Name": "Somerville",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43636836": {
    "id": "item_12729",
    "Last Name": "GUTIERREZ MONTERO",
    "First Name": "MIGUEL ANGEL",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43637707": {
    "id": "item_25475",
    "Last Name": "Kanda",
    "First Name": "Masashi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43639477": {
    "id": "item_25476",
    "Last Name": "Mathews",
    "First Name": "Kiki",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43642465": {
    "id": "item_36329",
    "Last Name": "Fox",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43643784": {
    "id": "item_10899",
    "Last Name": "KONISHI",
    "First Name": "TAKAHIRO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43644678": {
    "id": "item_25477",
    "Last Name": "Ngan",
    "First Name": "Chiu Ming Ronald",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645764": {
    "id": "item_12730",
    "Last Name": "Robinson",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645816": {
    "id": "item_12731",
    "Last Name": "Barwick",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645830": {
    "id": "item_10900",
    "Last Name": "Staehr",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645885": {
    "id": "item_25478",
    "Last Name": "Love",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645924": {
    "id": "item_23760",
    "Last Name": "Lynch",
    "First Name": "Damon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645974": {
    "id": "item_10901",
    "Last Name": "Taylor",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645991": {
    "id": "item_36330",
    "Last Name": "McNicol",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43645996": {
    "id": "item_25479",
    "Last Name": "Kiseloski",
    "First Name": "Luben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646039": {
    "id": "item_25480",
    "Last Name": "Simpson",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646067": {
    "id": "item_12732",
    "Last Name": "Wood",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646082": {
    "id": "item_38270",
    "Last Name": "Holland",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646090": {
    "id": "item_10902",
    "Last Name": "Criniti",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646158": {
    "id": "item_36331",
    "Last Name": "Arshad",
    "First Name": "Bjšrn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646292": {
    "id": "item_12733",
    "Last Name": "Keys",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646511": {
    "id": "item_25481",
    "Last Name": "Ortiz",
    "First Name": "Faith",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646789": {
    "id": "item_25482",
    "Last Name": "Burch",
    "First Name": "Emmy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646862": {
    "id": "item_23761",
    "Last Name": "Hwang",
    "First Name": "John White",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43646899": {
    "id": "item_25483",
    "Last Name": "Liao",
    "First Name": "Yanping",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43647752": {
    "id": "item_36332",
    "Last Name": "Blaesse",
    "First Name": "Detlef",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43647926": {
    "id": "item_38271",
    "Last Name": "Mannucci",
    "First Name": "Marco",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43648762": {
    "id": "item_36333",
    "Last Name": "Aguirre",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43649190": {
    "id": "item_23762",
    "Last Name": "Marlow",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43649344": {
    "id": "item_36334",
    "Last Name": "Strack",
    "First Name": "Sascha Carsten",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43649688": {
    "id": "item_25484",
    "Last Name": "Garnett",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43651395": {
    "id": "item_12734",
    "Last Name": "Hill",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43652395": {
    "id": "item_12735",
    "Last Name": "Volkova",
    "First Name": "Svetlana",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43652649": {
    "id": "item_23763",
    "Last Name": "Cook",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43653044": {
    "id": "item_23764",
    "Last Name": "Harris",
    "First Name": "Carl",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43655111": {
    "id": "item_12736",
    "Last Name": "CARVALHO",
    "First Name": "MARCUS",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43656779": {
    "id": "item_10903",
    "Last Name": "Barratt",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43656802": {
    "id": "item_12737",
    "Last Name": "Goodge",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43657141": {
    "id": "item_25485",
    "Last Name": "Ugarte",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43657204": {
    "id": "item_25486",
    "Last Name": "Ugarte",
    "First Name": "Hollie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43657213": {
    "id": "item_23765",
    "Last Name": "O Regan",
    "First Name": "Sinead",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43658587": {
    "id": "item_12738",
    "Last Name": "Egan",
    "First Name": "Richie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43659003": {
    "id": "item_10904",
    "Last Name": "Vitullo",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43659231": {
    "id": "item_10905",
    "Last Name": "Heggie",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43660074": {
    "id": "item_23766",
    "Last Name": "monjaraz ya–ez",
    "First Name": "luis fernando",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43660335": {
    "id": "item_12739",
    "Last Name": "Gatt",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43660812": {
    "id": "item_25487",
    "Last Name": "Rogan",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43663047": {
    "id": "item_25488",
    "Last Name": "Kawashima",
    "First Name": "Atsuhiro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43663460": {
    "id": "item_23767",
    "Last Name": "TANIZAWA",
    "First Name": "MASASHI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43663560": {
    "id": "item_23768",
    "Last Name": "Lee",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43663774": {
    "id": "item_38272",
    "Last Name": "DUCKWORTH",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute B",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43664074": {
    "id": "item_36335",
    "Last Name": "Seal",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43664615": {
    "id": "item_10906",
    "Last Name": "Petron",
    "First Name": "Romain",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43665841": {
    "id": "item_10907",
    "Last Name": "Chan",
    "First Name": "Wai Ming",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43670161": {
    "id": "item_12740",
    "Last Name": "Rickards",
    "First Name": "Field Antony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43670413": {
    "id": "item_12741",
    "Last Name": "Krasniewski",
    "First Name": "Rafal",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43670580": {
    "id": "item_23769",
    "Last Name": "GIUSTO",
    "First Name": "MASSIMO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43671519": {
    "id": "item_36336",
    "Last Name": "TAJIMA",
    "First Name": "KEIKO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43672611": {
    "id": "item_36337",
    "Last Name": "Tomany",
    "First Name": "Ray",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43673420": {
    "id": "item_23770",
    "Last Name": "Zhang",
    "First Name": "Xiaohua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43674011": {
    "id": "item_10908",
    "Last Name": "Bucher",
    "First Name": "Kate",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43674307": {
    "id": "item_25489",
    "Last Name": "Makar",
    "First Name": "Corinne",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43674531": {
    "id": "item_25490",
    "Last Name": "Korusiakova",
    "First Name": "Ivana",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43675045": {
    "id": "item_25491",
    "Last Name": "Holloway",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43679080": {
    "id": "item_23771",
    "Last Name": "Cancro",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43679360": {
    "id": "item_36338",
    "Last Name": "Wilson",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43681472": {
    "id": "item_25492",
    "Last Name": "Rudzki",
    "First Name": "Matou",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43683231": {
    "id": "item_23772",
    "Last Name": "Madrazo Baca",
    "First Name": "German",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43683796": {
    "id": "item_25493",
    "Last Name": "Gearhart",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43685415": {
    "id": "item_10909",
    "Last Name": "Silva",
    "First Name": "German",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43687227": {
    "id": "item_36339",
    "Last Name": "Adi Tirta",
    "First Name": "Budiwan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43688237": {
    "id": "item_36340",
    "Last Name": "Trefzger",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43688292": {
    "id": "item_23773",
    "Last Name": "Gehre",
    "First Name": "Lara-Irina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43688462": {
    "id": "item_25494",
    "Last Name": "Tju",
    "First Name": "Se Kim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43689508": {
    "id": "item_10910",
    "Last Name": "Costa",
    "First Name": "Raffaele",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43691140": {
    "id": "item_36341",
    "Last Name": "Morehen",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43694500": {
    "id": "item_36342",
    "Last Name": "Gex",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43695623": {
    "id": "item_23774",
    "Last Name": "BRUSTIA",
    "First Name": "LUCIANO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43697479": {
    "id": "item_10911",
    "Last Name": "Gutierrez",
    "First Name": "Romulo Santiago",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43699052": {
    "id": "item_10912",
    "Last Name": "Aparecida da Silva",
    "First Name": "Adriana",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43699239": {
    "id": "item_10913",
    "Last Name": "Prattes Bittencourt Pires",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43701452": {
    "id": "item_23775",
    "Last Name": "Barrera Meza",
    "First Name": "Silvia Patricia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43704728": {
    "id": "item_25495",
    "Last Name": "Nelson",
    "First Name": "Heather",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43707122": {
    "id": "item_36343",
    "Last Name": "TANAKA",
    "First Name": "MAYUMI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43708057": {
    "id": "item_25496",
    "Last Name": "SHAO",
    "First Name": "BIN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43709263": {
    "id": "item_10914",
    "Last Name": "Robinson",
    "First Name": "Forest",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43712224": {
    "id": "item_25497",
    "Last Name": "Cornish",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43714390": {
    "id": "item_36344",
    "Last Name": "Benedetti",
    "First Name": "Gery",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43714993": {
    "id": "item_10915",
    "Last Name": "YAMASAKI",
    "First Name": "TAKEMARU",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43716345": {
    "id": "item_36345",
    "Last Name": "ITO",
    "First Name": "NAO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43728011": {
    "id": "item_36346",
    "Last Name": "Kisworo",
    "First Name": "Dhanu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43728592": {
    "id": "item_10916",
    "Last Name": "Takemura",
    "First Name": "Katsumi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43730761": {
    "id": "item_10917",
    "Last Name": "Perkins",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43731340": {
    "id": "item_10918",
    "Last Name": "Appleby",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43736871": {
    "id": "item_25498",
    "Last Name": "Gosteva",
    "First Name": "Olga",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43739610": {
    "id": "item_10919",
    "Last Name": "Wasniewski",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43740883": {
    "id": "item_25499",
    "Last Name": "De Lazaro",
    "First Name": "Lazaro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43746023": {
    "id": "item_36347",
    "Last Name": "Linsangan",
    "First Name": "Linette Calalang",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43747798": {
    "id": "item_25500",
    "Last Name": "PROTO",
    "First Name": "MARK",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43747851": {
    "id": "item_25501",
    "Last Name": "PROTO",
    "First Name": "LOUISE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43749118": {
    "id": "item_10920",
    "Last Name": "Grubba",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43749790": {
    "id": "item_36348",
    "Last Name": "Khaw",
    "First Name": "Derek",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43750431": {
    "id": "item_36349",
    "Last Name": "Wang",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43750552": {
    "id": "item_36350",
    "Last Name": "philipse",
    "First Name": "charl",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43751522": {
    "id": "item_25502",
    "Last Name": "De Lazaro Nore–a",
    "First Name": "Gonzalo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43752567": {
    "id": "item_25503",
    "Last Name": "Kirby",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43756783": {
    "id": "item_36351",
    "Last Name": "MCGEE",
    "First Name": "EDWARD",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43757403": {
    "id": "item_25504",
    "Last Name": "Selderbeek",
    "First Name": "Ted",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43758408": {
    "id": "item_12742",
    "Last Name": "Robison",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43758848": {
    "id": "item_25505",
    "Last Name": "Appleby",
    "First Name": "Candice",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43761112": {
    "id": "item_25506",
    "Last Name": "Papierak",
    "First Name": "Wojciech",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43761239": {
    "id": "item_25507",
    "Last Name": "Papierak",
    "First Name": "Monika",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43763608": {
    "id": "item_25508",
    "Last Name": "Vazquez",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43765182": {
    "id": "item_25509",
    "Last Name": "Watt",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43767690": {
    "id": "item_23776",
    "Last Name": "Mattice",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43768308": {
    "id": "item_36352",
    "Last Name": "Petit",
    "First Name": "Clemence",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43770105": {
    "id": "item_36353",
    "Last Name": "mao",
    "First Name": "jie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43771007": {
    "id": "item_36354",
    "Last Name": "Lai",
    "First Name": "Yuet Yun Wylie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43772112": {
    "id": "item_23777",
    "Last Name": "WEATHERLY",
    "First Name": "DAVID",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43774633": {
    "id": "item_10921",
    "Last Name": "Park",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43774720": {
    "id": "item_23778",
    "Last Name": "Cotter",
    "First Name": "Daniel James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43775245": {
    "id": "item_36355",
    "Last Name": "Jonsson",
    "First Name": "Bogi",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43775897": {
    "id": "item_10922",
    "Last Name": "Hull",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43776503": {
    "id": "item_10923",
    "Last Name": "Okamoto",
    "First Name": "Koichi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43781531": {
    "id": "item_10924",
    "Last Name": "Wong",
    "First Name": "Hung Yung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43781693": {
    "id": "item_23779",
    "Last Name": "Flecha",
    "First Name": "Livia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43781847": {
    "id": "item_23780",
    "Last Name": "Fran�a",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43782336": {
    "id": "item_12743",
    "Last Name": "Cupertino",
    "First Name": "Aline",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43782930": {
    "id": "item_12744",
    "Last Name": "Sanchez Valderrama",
    "First Name": "Mauricio Guillermo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43783021": {
    "id": "item_25510",
    "Last Name": "Zagury",
    "First Name": "Lior",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43783071": {
    "id": "item_25511",
    "Last Name": "Binyamin",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43783172": {
    "id": "item_25512",
    "Last Name": "MUCHTAR",
    "First Name": "AYELET",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43783348": {
    "id": "item_25513",
    "Last Name": "Mines",
    "First Name": "Yuval",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43783566": {
    "id": "item_25514",
    "Last Name": "Goli",
    "First Name": "Surender",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43783851": {
    "id": "item_25515",
    "Last Name": "SZMULEWICZ",
    "First Name": "Mendy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43784139": {
    "id": "item_10925",
    "Last Name": "ZEHAVI",
    "First Name": "ARTUM",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43784505": {
    "id": "item_25516",
    "Last Name": "ben knaan",
    "First Name": "meital",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43784836": {
    "id": "item_25517",
    "Last Name": "Stepniewski",
    "First Name": "Michal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43785161": {
    "id": "item_25518",
    "Last Name": "Simon",
    "First Name": "Shay",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43785683": {
    "id": "item_23781",
    "Last Name": "Schwerbrock",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43785776": {
    "id": "item_23782",
    "Last Name": "Mair",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43785781": {
    "id": "item_12745",
    "Last Name": "Vasylkiv",
    "First Name": "Bohdan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43787451": {
    "id": "item_23783",
    "Last Name": "Rodriguez",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43789415": {
    "id": "item_12746",
    "Last Name": "Sorgiovanni",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43789523": {
    "id": "item_25519",
    "Last Name": "Gomes Hughes",
    "First Name": "Juliana Aparecida",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43791792": {
    "id": "item_12747",
    "Last Name": "JANG",
    "First Name": "EUNHYUK",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43791923": {
    "id": "item_25520",
    "Last Name": "Yordan",
    "First Name": "Dicky",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43792171": {
    "id": "item_12748",
    "Last Name": "Guitarte",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43792247": {
    "id": "item_12749",
    "Last Name": "Guitarte",
    "First Name": "Rizza",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43792779": {
    "id": "item_25521",
    "Last Name": "SHIN",
    "First Name": "DONGCHEOL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795158": {
    "id": "item_10926",
    "Last Name": "Lehmann",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795375": {
    "id": "item_23784",
    "Last Name": "Narvaez",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795553": {
    "id": "item_25522",
    "Last Name": "snapiri",
    "First Name": "oshrat",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795615": {
    "id": "item_36356",
    "Last Name": "Levy",
    "First Name": "Yoel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795629": {
    "id": "item_23785",
    "Last Name": "Golek",
    "First Name": "Seweryn",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795646": {
    "id": "item_25523",
    "Last Name": "Glinkewitz",
    "First Name": "Omer",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795829": {
    "id": "item_25524",
    "Last Name": "Barzilay",
    "First Name": "Yehoshua",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795833": {
    "id": "item_12750",
    "Last Name": "Sacarello",
    "First Name": "Giles",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43795977": {
    "id": "item_25525",
    "Last Name": "GAMLIEL",
    "First Name": "BARAK",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796032": {
    "id": "item_25526",
    "Last Name": "Oz",
    "First Name": "Noga",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796350": {
    "id": "item_12751",
    "Last Name": "Tay",
    "First Name": "Evelyn",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796407": {
    "id": "item_25527",
    "Last Name": "CHEN",
    "First Name": "LI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796487": {
    "id": "item_25528",
    "Last Name": "karp",
    "First Name": "reem ben zion",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796566": {
    "id": "item_25529",
    "Last Name": "PAKTER",
    "First Name": "ERAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796629": {
    "id": "item_25530",
    "Last Name": "ARNOLD",
    "First Name": "Yonina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43796635": {
    "id": "item_10927",
    "Last Name": "Eather",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43798782": {
    "id": "item_12752",
    "Last Name": "Langdown",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43801209": {
    "id": "item_25531",
    "Last Name": "Lozano Gracia",
    "First Name": "Fernando Antonio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43803339": {
    "id": "item_36357",
    "Last Name": "Roper",
    "First Name": "Justine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43804013": {
    "id": "item_10928",
    "Last Name": "Fleischmann",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43804518": {
    "id": "item_25532",
    "Last Name": "TALKER",
    "First Name": "YORAM",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43805782": {
    "id": "item_36358",
    "Last Name": "Coyne",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43808227": {
    "id": "item_25533",
    "Last Name": "Heidger",
    "First Name": "Benno",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43811422": {
    "id": "item_10929",
    "Last Name": "Garcia",
    "First Name": "Jose Eduardo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43812091": {
    "id": "item_10930",
    "Last Name": "Parker",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43813090": {
    "id": "item_23786",
    "Last Name": "Capones",
    "First Name": "Marline",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43813161": {
    "id": "item_36359",
    "Last Name": "PALERMO",
    "First Name": "CHARMAINE GRACE",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43813527": {
    "id": "item_12753",
    "Last Name": "KIM",
    "First Name": "YOUNGHU",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43813711": {
    "id": "item_23787",
    "Last Name": "LEE",
    "First Name": "KEONHEE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43814412": {
    "id": "item_10931",
    "Last Name": "Tiongson",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43815410": {
    "id": "item_12754",
    "Last Name": "PARK",
    "First Name": "MINKYU",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43815557": {
    "id": "item_10932",
    "Last Name": "KIM",
    "First Name": "JAEYOUNG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43816411": {
    "id": "item_10933",
    "Last Name": "Drabble",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43816894": {
    "id": "item_10934",
    "Last Name": "Bowles",
    "First Name": "Maxwell",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43817038": {
    "id": "item_12755",
    "Last Name": "Mullane",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43817179": {
    "id": "item_25534",
    "Last Name": "sescovich",
    "First Name": "yael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43817743": {
    "id": "item_36360",
    "Last Name": "HU",
    "First Name": "ZHAOHUI",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818110": {
    "id": "item_12756",
    "Last Name": "Zheng",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818359": {
    "id": "item_10935",
    "Last Name": "ZHANG",
    "First Name": "TINGXI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818438": {
    "id": "item_25535",
    "Last Name": "Samuels",
    "First Name": "Michall",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818556": {
    "id": "item_10936",
    "Last Name": "Sabag",
    "First Name": "Yosef",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43818962": {
    "id": "item_25536",
    "Last Name": "Wandel",
    "First Name": "Penina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43819011": {
    "id": "item_25537",
    "Last Name": "Shevach",
    "First Name": "Ithamar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43819103": {
    "id": "item_23788",
    "Last Name": "zohar",
    "First Name": "moran shiri",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43819403": {
    "id": "item_25538",
    "Last Name": "Hanna",
    "First Name": "Ella",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43819566": {
    "id": "item_12757",
    "Last Name": "Padusinski",
    "First Name": "Pawel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43821484": {
    "id": "item_23789",
    "Last Name": "KATOPI",
    "First Name": "AIKATERINI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43823653": {
    "id": "item_36361",
    "Last Name": "Bacchetta",
    "First Name": "Juan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43826236": {
    "id": "item_12758",
    "Last Name": "BIRNBAUM",
    "First Name": "ELISHA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43828046": {
    "id": "item_36362",
    "Last Name": "Fuentes Pineiro",
    "First Name": "Cecilia Violeta",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43829975": {
    "id": "item_36363",
    "Last Name": "FERNANDEZ PLASCENCIA",
    "First Name": "CARLOS ALEJANDRO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43832581": {
    "id": "item_10937",
    "Last Name": "Gagliardi",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43835031": {
    "id": "item_12759",
    "Last Name": "ZHANG",
    "First Name": "JINGYU",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43837417": {
    "id": "item_10938",
    "Last Name": "PARK",
    "First Name": "DONG JIN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43837891": {
    "id": "item_10939",
    "Last Name": "Wang",
    "First Name": "Shuang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43839290": {
    "id": "item_36364",
    "Last Name": "Marushima",
    "First Name": "Tadaharu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43839413": {
    "id": "item_10940",
    "Last Name": "Sakimoto",
    "First Name": "Koji",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43839490": {
    "id": "item_25539",
    "Last Name": "SHOLOM",
    "First Name": "AVI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43839491": {
    "id": "item_12760",
    "Last Name": "Iwayama",
    "First Name": "Shinya",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43840395": {
    "id": "item_12761",
    "Last Name": "Yager",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43840620": {
    "id": "item_12762",
    "Last Name": "YARITA",
    "First Name": "YUICHI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43843628": {
    "id": "item_25540",
    "Last Name": "Hufnagl",
    "First Name": "Irina",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43845701": {
    "id": "item_25541",
    "Last Name": "Sorbanelli",
    "First Name": "Ruth",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43848015": {
    "id": "item_36365",
    "Last Name": "Brown",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43850267": {
    "id": "item_25542",
    "Last Name": "Hallihan",
    "First Name": "Leo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43851577": {
    "id": "item_36366",
    "Last Name": "West",
    "First Name": "Abby",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43855336": {
    "id": "item_12763",
    "Last Name": "Alvarez",
    "First Name": "Noah",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43856585": {
    "id": "item_25543",
    "Last Name": "_kuta",
    "First Name": "Michal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43857280": {
    "id": "item_36367",
    "Last Name": "Patterson",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43857628": {
    "id": "item_25544",
    "Last Name": "Benvenisti",
    "First Name": "Nevo",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43857771": {
    "id": "item_12764",
    "Last Name": "Pam",
    "First Name": "Zhen shen",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43857973": {
    "id": "item_12765",
    "Last Name": "Turski",
    "First Name": "Mateusz",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43861170": {
    "id": "item_36368",
    "Last Name": "Dewanto",
    "First Name": "Adi Surya",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43862219": {
    "id": "item_36369",
    "Last Name": "Curley",
    "First Name": "Jaclyn",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43862910": {
    "id": "item_36370",
    "Last Name": "Coetzee",
    "First Name": "Dirkie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43863002": {
    "id": "item_36371",
    "Last Name": "Coetzee",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43866883": {
    "id": "item_25545",
    "Last Name": "Pantano",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43872388": {
    "id": "item_25546",
    "Last Name": "SHIMONI",
    "First Name": "ROZA TZOFIA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43872454": {
    "id": "item_36372",
    "Last Name": "Shochetman",
    "First Name": "Aviah meir",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43872626": {
    "id": "item_25547",
    "Last Name": "Al-Malliki",
    "First Name": "Nouralhouda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43872672": {
    "id": "item_25548",
    "Last Name": "Richani",
    "First Name": "Moshe",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43877867": {
    "id": "item_25549",
    "Last Name": "Silvester",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43882549": {
    "id": "item_25550",
    "Last Name": "Orr",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43882550": {
    "id": "item_12766",
    "Last Name": "Gibson",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43883192": {
    "id": "item_36373",
    "Last Name": "Borges",
    "First Name": "Nattai",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43886730": {
    "id": "item_25551",
    "Last Name": "Grunseit",
    "First Name": "Leah",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43886737": {
    "id": "item_10941",
    "Last Name": "Yang",
    "First Name": "ChungKai",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43886839": {
    "id": "item_36374",
    "Last Name": "GAO",
    "First Name": "JING",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43886865": {
    "id": "item_25552",
    "Last Name": "Taoui",
    "First Name": "Mehdi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43886926": {
    "id": "item_10942",
    "Last Name": "XIE",
    "First Name": "HONGCHENG",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43887113": {
    "id": "item_12767",
    "Last Name": "ZHONG",
    "First Name": "JUNYI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43888314": {
    "id": "item_25553",
    "Last Name": "NISSIM",
    "First Name": "MOSHE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43888350": {
    "id": "item_10943",
    "Last Name": "Luciani",
    "First Name": "Simone",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43888673": {
    "id": "item_12768",
    "Last Name": "TANG",
    "First Name": "WEICHUN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43889922": {
    "id": "item_25554",
    "Last Name": "EIKI",
    "First Name": "MASAHIRO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43890394": {
    "id": "item_25555",
    "Last Name": "Swanberg",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43895144": {
    "id": "item_10944",
    "Last Name": "Mbugua",
    "First Name": "Brian Ngunjiri",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43900070": {
    "id": "item_25556",
    "Last Name": "Nawi",
    "First Name": "Ronen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43904232": {
    "id": "item_36375",
    "Last Name": "Watson",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43904258": {
    "id": "item_10945",
    "Last Name": "NAMGOONG",
    "First Name": "YEONGJIN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43904460": {
    "id": "item_36376",
    "Last Name": "Pink",
    "First Name": "Ihaka",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43905417": {
    "id": "item_10946",
    "Last Name": "Miller",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43905964": {
    "id": "item_36377",
    "Last Name": "Beigel",
    "First Name": "Pamela",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43906205": {
    "id": "item_12769",
    "Last Name": "huang",
    "First Name": "shang",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43906446": {
    "id": "item_36378",
    "Last Name": "Horn",
    "First Name": "Tina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43906805": {
    "id": "item_12770",
    "Last Name": "Quijano",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43907355": {
    "id": "item_10947",
    "Last Name": "Robertson",
    "First Name": "Murray",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43907647": {
    "id": "item_25557",
    "Last Name": "Rothschild",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43907725": {
    "id": "item_25558",
    "Last Name": "Michel",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43907835": {
    "id": "item_36379",
    "Last Name": "Friedler",
    "First Name": "Rabbi Natti",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43908845": {
    "id": "item_25559",
    "Last Name": "Hartman Schwartz",
    "First Name": "Yael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43908887": {
    "id": "item_10948",
    "Last Name": "Oates",
    "First Name": "Felix",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43909354": {
    "id": "item_23790",
    "Last Name": "Chatley",
    "First Name": "Sumit",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43909702": {
    "id": "item_36380",
    "Last Name": "Jeet",
    "First Name": "Varinder",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43912186": {
    "id": "item_25560",
    "Last Name": "Gezels",
    "First Name": "Wim",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43912208": {
    "id": "item_25561",
    "Last Name": "Brophy",
    "First Name": "Randy",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43913154": {
    "id": "item_23791",
    "Last Name": "Longanecker",
    "First Name": "Haven",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43913654": {
    "id": "item_36381",
    "Last Name": "Evangelista",
    "First Name": "Ireen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43913983": {
    "id": "item_23792",
    "Last Name": "Alhulaibi",
    "First Name": "Noor",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43915092": {
    "id": "item_25562",
    "Last Name": "Bermo",
    "First Name": "Ramon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43915910": {
    "id": "item_10949",
    "Last Name": "Forehand",
    "First Name": "Rashaad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43915919": {
    "id": "item_25563",
    "Last Name": "Schuchart",
    "First Name": "Bennie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43917206": {
    "id": "item_12771",
    "Last Name": "Song",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43919706": {
    "id": "item_25564",
    "Last Name": "Jha",
    "First Name": "Ashok",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43922861": {
    "id": "item_10950",
    "Last Name": "Degortes",
    "First Name": "Vincenzo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43924062": {
    "id": "item_10951",
    "Last Name": "Gill",
    "First Name": "Ella",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43925009": {
    "id": "item_10952",
    "Last Name": "Warnock",
    "First Name": "Rory",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43926063": {
    "id": "item_23793",
    "Last Name": "GONG",
    "First Name": "FAN",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43927811": {
    "id": "item_12772",
    "Last Name": "ZHANG",
    "First Name": "CHONGJUN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43928535": {
    "id": "item_12773",
    "Last Name": "TIAN",
    "First Name": "CHUNHUA",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43928539": {
    "id": "item_36382",
    "Last Name": "Moreton",
    "First Name": "Charles",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43929542": {
    "id": "item_36383",
    "Last Name": "Zawistowska",
    "First Name": "Katarzyna",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43929769": {
    "id": "item_25565",
    "Last Name": "YOO",
    "First Name": "JAEHO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43931346": {
    "id": "item_23794",
    "Last Name": "Slusarski",
    "First Name": "Rafal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43931757": {
    "id": "item_25566",
    "Last Name": "Persaud",
    "First Name": "Rene",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43932257": {
    "id": "item_12774",
    "Last Name": "Shimko",
    "First Name": "Evgeniya",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43932899": {
    "id": "item_10953",
    "Last Name": "Orta ortiz",
    "First Name": "Jose manuel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43932915": {
    "id": "item_23795",
    "Last Name": "Radev",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43934195": {
    "id": "item_23796",
    "Last Name": "Y",
    "First Name": "Ying",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43934720": {
    "id": "item_10954",
    "Last Name": "Utetleuov",
    "First Name": "Batyrzhan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43935023": {
    "id": "item_23797",
    "Last Name": "Li",
    "First Name": "Yongwei",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43935044": {
    "id": "item_25567",
    "Last Name": "Richardson",
    "First Name": "Torian",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43936051": {
    "id": "item_23798",
    "Last Name": "Giudicatti",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43936233": {
    "id": "item_23799",
    "Last Name": "Asef",
    "First Name": "Griselda",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43938476": {
    "id": "item_25568",
    "Last Name": "De Cremer",
    "First Name": "Dirk",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43941955": {
    "id": "item_36384",
    "Last Name": "Gasparoli Muniz",
    "First Name": "Marissa C",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43942401": {
    "id": "item_36385",
    "Last Name": "Green",
    "First Name": "Ella",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43943813": {
    "id": "item_12775",
    "Last Name": "CAI",
    "First Name": "ZHIYUAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43943893": {
    "id": "item_25569",
    "Last Name": "Jenkins",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43943958": {
    "id": "item_36386",
    "Last Name": "LIU",
    "First Name": "JIAREN",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43944473": {
    "id": "item_12776",
    "Last Name": "CHEN",
    "First Name": "XUELI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43946113": {
    "id": "item_12777",
    "Last Name": "Bodkin",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43946132": {
    "id": "item_25570",
    "Last Name": "LIU",
    "First Name": "MENGDI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43946466": {
    "id": "item_25571",
    "Last Name": "MALPICA VALENCIA",
    "First Name": "JORGE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43946650": {
    "id": "item_25572",
    "Last Name": "BELHAOUANE",
    "First Name": "CATHY",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43946667": {
    "id": "item_23800",
    "Last Name": "van Ooijen",
    "First Name": "Andre",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43946692": {
    "id": "item_23801",
    "Last Name": "van Ooijen",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43946703": {
    "id": "item_23802",
    "Last Name": "Hermkens",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43946907": {
    "id": "item_25573",
    "Last Name": "JI",
    "First Name": "KALI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43946908": {
    "id": "item_10955",
    "Last Name": "Stelmach",
    "First Name": "Dominika",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43947332": {
    "id": "item_36387",
    "Last Name": "Dummer",
    "First Name": "Lillian",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43947364": {
    "id": "item_12778",
    "Last Name": "Hale",
    "First Name": "Todd",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43947567": {
    "id": "item_12779",
    "Last Name": "Watts",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43947896": {
    "id": "item_23803",
    "Last Name": "Pu",
    "First Name": "Jing",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43948304": {
    "id": "item_10956",
    "Last Name": "Lister",
    "First Name": "Lansana",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43948719": {
    "id": "item_25574",
    "Last Name": "Marszalik",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43949296": {
    "id": "item_10957",
    "Last Name": "Barchalk",
    "First Name": "Nate",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43951696": {
    "id": "item_12780",
    "Last Name": "Pastor",
    "First Name": "Tomas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43953924": {
    "id": "item_25575",
    "Last Name": "ZYSK",
    "First Name": "PAWEL",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43954901": {
    "id": "item_25576",
    "Last Name": "Zhou",
    "First Name": "Xiaorong",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43956511": {
    "id": "item_36388",
    "Last Name": "Marcozzi",
    "First Name": "Peyton",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43956699": {
    "id": "item_25577",
    "Last Name": "Ordog",
    "First Name": "Norbert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43956988": {
    "id": "item_12781",
    "Last Name": "Reed",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43957472": {
    "id": "item_36389",
    "Last Name": "Leonard",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43961414": {
    "id": "item_25578",
    "Last Name": "Sumers",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43962361": {
    "id": "item_10958",
    "Last Name": "LIN",
    "First Name": "SHAOHUI",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43962788": {
    "id": "item_36390",
    "Last Name": "Alanis Marcos",
    "First Name": "Maria Alejandra",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43966856": {
    "id": "item_25579",
    "Last Name": "Muhlmann",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43967152": {
    "id": "item_23804",
    "Last Name": "Gallagher",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43967177": {
    "id": "item_25580",
    "Last Name": "Torres",
    "First Name": "Mar’a del Socorro",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43967552": {
    "id": "item_25581",
    "Last Name": "Islam-Medeaux",
    "First Name": "Sonwara",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43970716": {
    "id": "item_36391",
    "Last Name": "Raz",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43973322": {
    "id": "item_23805",
    "Last Name": "Gallagher",
    "First Name": "Ellie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43974809": {
    "id": "item_23806",
    "Last Name": "Ngetu",
    "First Name": "Thandeka",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43987399": {
    "id": "item_25582",
    "Last Name": "NIPPARD",
    "First Name": "KAYE",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "43998803": {
    "id": "item_12782",
    "Last Name": "Khan",
    "First Name": "Salman",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44003891": {
    "id": "item_12783",
    "Last Name": "Connolly",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44010794": {
    "id": "item_25583",
    "Last Name": "Koczessa-Drš§ler",
    "First Name": "Kathrin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44015442": {
    "id": "item_36392",
    "Last Name": "Yan",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44017776": {
    "id": "item_36393",
    "Last Name": "Donaldson",
    "First Name": "Jade",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44021419": {
    "id": "item_36394",
    "Last Name": "Smith",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44022157": {
    "id": "item_25584",
    "Last Name": "Manni",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44022166": {
    "id": "item_36395",
    "Last Name": "Murray",
    "First Name": "Neil",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44022233": {
    "id": "item_25585",
    "Last Name": "Dahill",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44024819": {
    "id": "item_10959",
    "Last Name": "Hwawoon",
    "First Name": "Kwon",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44025570": {
    "id": "item_36396",
    "Last Name": "Sze",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44026029": {
    "id": "item_36397",
    "Last Name": "Koczessa",
    "First Name": "GŸnter Wilhelm",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44027801": {
    "id": "item_25586",
    "Last Name": "Lombardo",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44030992": {
    "id": "item_36398",
    "Last Name": "Pradhana",
    "First Name": "Mohammad",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44031216": {
    "id": "item_25587",
    "Last Name": "Latif",
    "First Name": "Moh Anher",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44035841": {
    "id": "item_25588",
    "Last Name": "ANNENKO",
    "First Name": "MARINA",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44037814": {
    "id": "item_25589",
    "Last Name": "Pham",
    "First Name": "Cam Yen",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44038490": {
    "id": "item_36399",
    "Last Name": "Law",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44044076": {
    "id": "item_25590",
    "Last Name": "Keeping Sullivan",
    "First Name": "Harriet",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44045396": {
    "id": "item_10960",
    "Last Name": "Larkin",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44046187": {
    "id": "item_25591",
    "Last Name": "Getty",
    "First Name": "Jaimee",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44049644": {
    "id": "item_25592",
    "Last Name": "RUIZ",
    "First Name": "LINO",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44053268": {
    "id": "item_36400",
    "Last Name": "HONGWEI",
    "First Name": "SHAO",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44053590": {
    "id": "item_25593",
    "Last Name": "Dickinson",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44053923": {
    "id": "item_23807",
    "Last Name": "Fanshawe",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44055213": {
    "id": "item_36401",
    "Last Name": "Dang",
    "First Name": "Phong",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44059262": {
    "id": "item_23808",
    "Last Name": "Harden",
    "First Name": "Janet",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44060222": {
    "id": "item_10961",
    "Last Name": "Asai",
    "First Name": "Hiroshi",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44064948": {
    "id": "item_23809",
    "Last Name": "Escobar Jare",
    "First Name": "Gabriel Andres",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44071630": {
    "id": "item_25594",
    "Last Name": "Salazar",
    "First Name": "Lenin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44075022": {
    "id": "item_25595",
    "Last Name": "Wharton",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44075073": {
    "id": "item_25596",
    "Last Name": "Khoury",
    "First Name": "Dany",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44075402": {
    "id": "item_25597",
    "Last Name": "Akpojaro",
    "First Name": "Princeton",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44076025": {
    "id": "item_36402",
    "Last Name": "McGrath",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44076320": {
    "id": "item_25598",
    "Last Name": "Preedawiphat",
    "First Name": "Chatchawan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44078738": {
    "id": "item_10962",
    "Last Name": "Ivanchikhin",
    "First Name": "Andrey",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44082144": {
    "id": "item_23810",
    "Last Name": "Rayson",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44090376": {
    "id": "item_12784",
    "Last Name": "Towning",
    "First Name": "Louis",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44091827": {
    "id": "item_10963",
    "Last Name": "HERRERA AVILES",
    "First Name": "ALBERTO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44092094": {
    "id": "item_12785",
    "Last Name": "FUJII",
    "First Name": "YOSHIGO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44093572": {
    "id": "item_25599",
    "Last Name": "Rigby",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44094772": {
    "id": "item_36403",
    "Last Name": "Wiseman",
    "First Name": "Paige",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44095499": {
    "id": "item_10964",
    "Last Name": "Alhashmi",
    "First Name": "Salem",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44095973": {
    "id": "item_36404",
    "Last Name": "Paul",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44096277": {
    "id": "item_25600",
    "Last Name": "Taylor",
    "First Name": "Kerrie",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44097638": {
    "id": "item_10965",
    "Last Name": "Maxwell",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44100653": {
    "id": "item_10966",
    "Last Name": "Pehas",
    "First Name": "Stavros",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44100716": {
    "id": "item_12786",
    "Last Name": "Kalyvas",
    "First Name": "Lampros",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44101755": {
    "id": "item_10967",
    "Last Name": "van Duursen",
    "First Name": "Rick",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44105029": {
    "id": "item_23811",
    "Last Name": "Contreras",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44114571": {
    "id": "item_10968",
    "Last Name": "Keinath",
    "First Name": "Moritz Caspar",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44115419": {
    "id": "item_10969",
    "Last Name": "Waters",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44115461": {
    "id": "item_10970",
    "Last Name": "Axford",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44115480": {
    "id": "item_25601",
    "Last Name": "Linscott",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44119500": {
    "id": "item_10971",
    "Last Name": "Fernandez Burcet",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44120592": {
    "id": "item_36405",
    "Last Name": "De Caesemaeker",
    "First Name": "Dieter",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44123877": {
    "id": "item_36406",
    "Last Name": "Brook",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44125377": {
    "id": "item_10972",
    "Last Name": "Hoonhout",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44138390": {
    "id": "item_25602",
    "Last Name": "Comafay",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44142125": {
    "id": "item_36407",
    "Last Name": "Laundy",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44150964": {
    "id": "item_10973",
    "Last Name": "Hallasgo",
    "First Name": "Christine",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44151112": {
    "id": "item_10974",
    "Last Name": "Sala–o",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44154152": {
    "id": "item_10975",
    "Last Name": "Britz",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44165813": {
    "id": "item_25603",
    "Last Name": "Plant",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44181763": {
    "id": "item_25604",
    "Last Name": "Sharp",
    "First Name": "Jamari",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44192603": {
    "id": "item_25605",
    "Last Name": "Taglioretti",
    "First Name": "Luca",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44193391": {
    "id": "item_25606",
    "Last Name": "Rangel Sanchez",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44212677": {
    "id": "item_25607",
    "Last Name": "Abella Lago",
    "First Name": "Octavio",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44219164": {
    "id": "item_25608",
    "Last Name": "Higgins",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44271911": {
    "id": "item_23812",
    "Last Name": "Murphy",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44273860": {
    "id": "item_12787",
    "Last Name": "Altin",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44274177": {
    "id": "item_36408",
    "Last Name": "Bugge",
    "First Name": "Karli-Jane",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44275976": {
    "id": "item_36409",
    "Last Name": "Gabrio",
    "First Name": "Cassidy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44277342": {
    "id": "item_12788",
    "Last Name": "GUTIERREZ HIDALGO",
    "First Name": "JAVIER",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44277825": {
    "id": "item_36410",
    "Last Name": "Lay",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44277995": {
    "id": "item_12789",
    "Last Name": "Marsh",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44279089": {
    "id": "item_25609",
    "Last Name": "Bangs",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44283709": {
    "id": "item_12790",
    "Last Name": "GARCIA IRAUSQUIN",
    "First Name": "ALEJANDRO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44339445": {
    "id": "item_36411",
    "Last Name": "Goorts",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44341419": {
    "id": "item_10976",
    "Last Name": "Cham",
    "First Name": "Tyson",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44341860": {
    "id": "item_23813",
    "Last Name": "Du",
    "First Name": "Johnny",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44342056": {
    "id": "item_10977",
    "Last Name": "Mack",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44342178": {
    "id": "item_36412",
    "Last Name": "Chapman",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44345908": {
    "id": "item_23814",
    "Last Name": "Perkins",
    "First Name": "Vicky",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44346722": {
    "id": "item_23815",
    "Last Name": "Waterfield",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44346745": {
    "id": "item_25610",
    "Last Name": "Lim",
    "First Name": "Semi",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44368440": {
    "id": "item_36413",
    "Last Name": "Ognibene",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44397238": {
    "id": "item_36414",
    "Last Name": "Rodrigues",
    "First Name": "Dana Jean",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44428750": {
    "id": "item_12791",
    "Last Name": "Johnson",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44428841": {
    "id": "item_25611",
    "Last Name": "Opdam",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44429602": {
    "id": "item_25612",
    "Last Name": "Burke",
    "First Name": "Ross",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44432120": {
    "id": "item_23816",
    "Last Name": "Zhang",
    "First Name": "Xiaozhou",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44435826": {
    "id": "item_12792",
    "Last Name": "Dreyer",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44436736": {
    "id": "item_10978",
    "Last Name": "won",
    "First Name": "hyeongseok",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44437704": {
    "id": "item_36415",
    "Last Name": "Mol",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44437736": {
    "id": "item_10979",
    "Last Name": "Wauer",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44443525": {
    "id": "item_23817",
    "Last Name": "Jackson",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44452571": {
    "id": "item_10980",
    "Last Name": "AHN",
    "First Name": "EUNTAE",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44455715": {
    "id": "item_36416",
    "Last Name": "Ewert-Krzemieniewski",
    "First Name": "Mikolaj",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44459587": {
    "id": "item_25613",
    "Last Name": "Reyes",
    "First Name": "Jose Robert",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44459680": {
    "id": "item_25614",
    "Last Name": "Gatt",
    "First Name": "Tyrone",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44460250": {
    "id": "item_25615",
    "Last Name": "Dian",
    "First Name": "Dicky",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44460880": {
    "id": "item_36417",
    "Last Name": "Papp",
    "First Name": "Andr‡s P‡l",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44461502": {
    "id": "item_36418",
    "Last Name": "Matutina",
    "First Name": "Jehmer",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44461690": {
    "id": "item_12793",
    "Last Name": "Omarova",
    "First Name": "Diana",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44463002": {
    "id": "item_36419",
    "Last Name": "Kalikov",
    "First Name": "Aslan",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44467815": {
    "id": "item_36420",
    "Last Name": "Bignone",
    "First Name": "Paola",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44467831": {
    "id": "item_36421",
    "Last Name": "Winch",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44482500": {
    "id": "item_12794",
    "Last Name": "Parsons",
    "First Name": "Marie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44483388": {
    "id": "item_10981",
    "Last Name": "Merrick",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44483698": {
    "id": "item_25616",
    "Last Name": "Carvalho Neto",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44488752": {
    "id": "item_25617",
    "Last Name": "Koskorelos",
    "First Name": "Elly",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44495520": {
    "id": "item_36422",
    "Last Name": "Kittelson",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44505614": {
    "id": "item_12795",
    "Last Name": "ZHANG",
    "First Name": "QIAN",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44508935": {
    "id": "item_36423",
    "Last Name": "Skurnik",
    "First Name": "Leora",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44509121": {
    "id": "item_12796",
    "Last Name": "Chan",
    "First Name": "Fuk Keung",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44509656": {
    "id": "item_12797",
    "Last Name": "Rowlings",
    "First Name": "Clint",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44510294": {
    "id": "item_36424",
    "Last Name": "Carracher",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44510576": {
    "id": "item_12798",
    "Last Name": "Herkes",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44515432": {
    "id": "item_25618",
    "Last Name": "Adames",
    "First Name": "Elvin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44517559": {
    "id": "item_23818",
    "Last Name": "Esparza",
    "First Name": "Aidin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44519021": {
    "id": "item_36425",
    "Last Name": "Antus",
    "First Name": "Jeannine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44534787": {
    "id": "item_10982",
    "Last Name": "Fothergill",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44535260": {
    "id": "item_36426",
    "Last Name": "Olzomer",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44535965": {
    "id": "item_10983",
    "Last Name": "Jung",
    "First Name": "Won Cheol",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44536812": {
    "id": "item_12799",
    "Last Name": "Schindler",
    "First Name": "Lukas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44536860": {
    "id": "item_25619",
    "Last Name": "Lipp",
    "First Name": "Lorenz",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44538043": {
    "id": "item_12800",
    "Last Name": "Mandje",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44543563": {
    "id": "item_36427",
    "Last Name": "Frost",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44547164": {
    "id": "item_12801",
    "Last Name": "Gilbert",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44565497": {
    "id": "item_10984",
    "Last Name": "Chen",
    "First Name": "Yong",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44617864": {
    "id": "item_23819",
    "Last Name": "Gnanasegaram",
    "First Name": "Ashan",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44618351": {
    "id": "item_23820",
    "Last Name": "Deeb",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44646918": {
    "id": "item_12802",
    "Last Name": "Hennessy",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44647439": {
    "id": "item_12803",
    "Last Name": "Senior Guzman",
    "First Name": "Raquel",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44647913": {
    "id": "item_25620",
    "Last Name": "Wegdam",
    "First Name": "Hein",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44651369": {
    "id": "item_10985",
    "Last Name": "Low",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44652356": {
    "id": "item_36428",
    "Last Name": "Prasad",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44652744": {
    "id": "item_23821",
    "Last Name": "Davidson",
    "First Name": "Piers",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44653869": {
    "id": "item_36429",
    "Last Name": "Moran",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44654066": {
    "id": "item_36430",
    "Last Name": "Wilson",
    "First Name": "Lili",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44654173": {
    "id": "item_25621",
    "Last Name": "Blancpain",
    "First Name": "Marley",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44654744": {
    "id": "item_12804",
    "Last Name": "Aoukar",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44655351": {
    "id": "item_10986",
    "Last Name": "LEE",
    "First Name": "SEUNGHYO",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44656398": {
    "id": "item_36431",
    "Last Name": "You",
    "First Name": "Jun Je",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44688319": {
    "id": "item_10987",
    "Last Name": "Malton",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44692292": {
    "id": "item_36432",
    "Last Name": "White",
    "First Name": "Megan Chloe",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44693306": {
    "id": "item_36433",
    "Last Name": "Avshalom",
    "First Name": "Nadja",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44729713": {
    "id": "item_12805",
    "Last Name": "Hathaway",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44802523": {
    "id": "item_23822",
    "Last Name": "Garland",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44805031": {
    "id": "item_10988",
    "Last Name": "Kim",
    "First Name": "Minsuk",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44806827": {
    "id": "item_36434",
    "Last Name": "Purcell",
    "First Name": "April-Lee",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44807140": {
    "id": "item_10989",
    "Last Name": "Haines",
    "First Name": "Reece",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44807522": {
    "id": "item_25622",
    "Last Name": "Woo",
    "First Name": "Sunghoon",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44808203": {
    "id": "item_36435",
    "Last Name": "Nham",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44896079": {
    "id": "item_25623",
    "Last Name": "Kite",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44946944": {
    "id": "item_10990",
    "Last Name": "Bowen",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44950246": {
    "id": "item_12806",
    "Last Name": "Elliott",
    "First Name": "Carl",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44953578": {
    "id": "item_10991",
    "Last Name": "Wormald",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44967090": {
    "id": "item_25624",
    "Last Name": "Yu",
    "First Name": "Weilin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "44967423": {
    "id": "item_25625",
    "Last Name": "Quinn",
    "First Name": "Hayleigh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45120100": {
    "id": "item_36436",
    "Last Name": "Maly",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45124794": {
    "id": "item_12807",
    "Last Name": "Ng",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45125862": {
    "id": "item_10992",
    "Last Name": "Hallam",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45130863": {
    "id": "item_36437",
    "Last Name": "Cottle",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45130947": {
    "id": "item_10993",
    "Last Name": "Houghton",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45132593": {
    "id": "item_10994",
    "Last Name": "Richards",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45133070": {
    "id": "item_12808",
    "Last Name": "Stoneman",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45133401": {
    "id": "item_25626",
    "Last Name": "Doran",
    "First Name": "Merve",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45133489": {
    "id": "item_12809",
    "Last Name": "Zids",
    "First Name": "Aleks",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45134353": {
    "id": "item_36438",
    "Last Name": "French",
    "First Name": "Elaine",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45135659": {
    "id": "item_25627",
    "Last Name": "Ranocchiari",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45173780": {
    "id": "item_25628",
    "Last Name": "Kitchen",
    "First Name": "Neil",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45203852": {
    "id": "item_12810",
    "Last Name": "Aquilina",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45204394": {
    "id": "item_10995",
    "Last Name": "Musgrove",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45206560": {
    "id": "item_25629",
    "Last Name": "Green",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45207154": {
    "id": "item_25630",
    "Last Name": "Richardson",
    "First Name": "Anna-Lena",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45209830": {
    "id": "item_25631",
    "Last Name": "Brenner",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45211432": {
    "id": "item_23823",
    "Last Name": "Pearson",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45213610": {
    "id": "item_25632",
    "Last Name": "JAYARAMAN",
    "First Name": "MANI",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45213733": {
    "id": "item_25633",
    "Last Name": "Moore",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45217667": {
    "id": "item_36439",
    "Last Name": "Chapple",
    "First Name": "Kym",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45220489": {
    "id": "item_36440",
    "Last Name": "Marston",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45220974": {
    "id": "item_36441",
    "Last Name": "Martin",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45221029": {
    "id": "item_36442",
    "Last Name": "Lee",
    "First Name": "Russell",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45221924": {
    "id": "item_23824",
    "Last Name": "Bailey",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45250881": {
    "id": "item_12811",
    "Last Name": "Cerrillos",
    "First Name": "Letticcia",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45259307": {
    "id": "item_12812",
    "Last Name": "Cerrillos",
    "First Name": "Evaristo",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45259930": {
    "id": "item_36443",
    "Last Name": "Goli",
    "First Name": "Saisindhu",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45261374": {
    "id": "item_25634",
    "Last Name": "Stibbe",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45288537": {
    "id": "item_12813",
    "Last Name": "Edusei",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45291639": {
    "id": "item_10996",
    "Last Name": "Flynn",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45293638": {
    "id": "item_10997",
    "Last Name": "Threlfall",
    "First Name": "Brady",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45294323": {
    "id": "item_25635",
    "Last Name": "Cardona Henao",
    "First Name": "Federico",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45294791": {
    "id": "item_36444",
    "Last Name": "Altland",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45294818": {
    "id": "item_36445",
    "Last Name": "Slater",
    "First Name": "Martha",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45294974": {
    "id": "item_12814",
    "Last Name": "Tehan",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45295566": {
    "id": "item_25636",
    "Last Name": "dean",
    "First Name": "jason",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45296091": {
    "id": "item_36446",
    "Last Name": "Montoya Guerrero",
    "First Name": "Karina",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45296589": {
    "id": "item_10998",
    "Last Name": "Croker",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45296750": {
    "id": "item_36447",
    "Last Name": "Hsia",
    "First Name": "Li Ming",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45297727": {
    "id": "item_23825",
    "Last Name": "McDonald",
    "First Name": "Mal",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute A",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45299653": {
    "id": "item_36448",
    "Last Name": "Coleman",
    "First Name": "Ann Marie",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45303539": {
    "id": "item_36449",
    "Last Name": "Nishiguchi",
    "First Name": "Michele",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45361714": {
    "id": "item_36450",
    "Last Name": "Mullings",
    "First Name": "Cigale",
    "Marathon Waves": "Start group 3 - Red Assembly - Entry Chute A",
    "assemblyPoint": " Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "6:30 AM",
    "ENTRY CHUTE TIME": "7:05 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45373128": {
    "id": "item_12815",
    "Last Name": "Sison",
    "First Name": "Allan",
    "Marathon Waves": "Start group 1 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "5:45 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45395736": {
    "id": "item_25637",
    "Last Name": "Yi",
    "First Name": "Xiaxin",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45404005": {
    "id": "item_25638",
    "Last Name": "Ganu",
    "First Name": "Omkar",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  },
  "45405602": {
    "id": "item_25639",
    "Last Name": "Tarlinton",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Red Assembly - Entry Chute B",
    "assemblyPoint": "Red Assembly",
    "startingPoint": "Victoria Cross Station",
    "routeStartCoordinates": [
      -33.8358333,
      151.2077778
    ],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [
      -33.8402778,
      151.2072222
    ],
    "assemblyCoordinates": [
      -33.8311111,
      151.2102778
    ],
    "assemblyCoordinates_2": [
      -33.8302778,
      151.2105556
    ],
    "ARRIVAL Time": "5:40 AM",
    "ENTRY CHUTE TIME": "6:35 AM",
    "Ped Crossing 1": [
      -33.835,
      151.2075
    ],
    "Ped Crossing 2": [
      -33.8366667,
      151.2072222
    ],
    "Ped Crossing 3": [
      -33.8405556,
      151.2083333
    ],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    "closureTimeStart": "6:30 AM, 7:03 AM, 7:40 AM",
    "closureTimeEnd": "7:00 AM, 7:31 AM, 8:10 AM"
  }
};